//console.log("ranches");

 staples =  [
        {
            "name": "Brockhausen",
            "id": "10-000",
            "text": "Brockhausen in Münster (Nr.10-000)",
            "Street": "Böddingheideweg 48a",
            "ZIP": "48167",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hinske/Dunkelmann",
            "id": "11-000",
            "text": "Hinske/Dunkelmann in Münster (Nr.11-000)",
            "Street": "Angelsachsenweg 111",
            "ZIP": "48167",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Sendenhorst",
            "id": "12-000",
            "text": "RV Sendenhorst in Sendenhorst (Nr.12-000)",
            "Street": "Alter Postweg 3",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Amelsbüren",
            "id": "13-000",
            "text": "RV Amelsbüren in Münster (Nr.13-000)",
            "Street": "Thierstraße 291",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Hobeling",
            "id": "14-000",
            "text": "Schulze Hobeling in Telgte (Nr.14-000)",
            "Street": "Grevener Straße 161",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Averkamp",
            "id": "15-000",
            "text": "Averkamp in Münster (Nr.15-000)",
            "Street": "Gremmendorfer Weg 210",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Förster",
            "id": "16-000",
            "text": "Gestüt Förster in Lüdinghausen (Nr.16-000)",
            "Street": "Ermen 55",
            "ZIP": "59348",
            "City": "Lüdinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rusticus",
            "id": "17-000",
            "text": "Rusticus in Münster (Nr.17-000)",
            "Street": "Münsterstraße 128b",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyhof Georgenbruch",
            "id": "18-000",
            "text": "Ponyhof Georgenbruch in Everswinkel (Nr.18-000)",
            "Street": "Müssingen 25",
            "ZIP": "48351",
            "City": "Everswinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Holtkötter",
            "id": "19-000",
            "text": "Holtkötter in Münster (Nr.19-000)",
            "Street": "Kötterstr. 120",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Niehoff",
            "id": "20-000",
            "text": "Niehoff in Münster (Nr.20-000)",
            "Street": "Westfalenstr. 90",
            "ZIP": "48165",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "AR Trainingstable",
            "id": "21-000",
            "text": "AR Trainingstable in Sendenhorst (Nr.21-000)",
            "Street": "Rummler 32",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jostmeier ",
            "id": "22-000",
            "text": "Jostmeier  in Dülmen (Nr.22-000)",
            "Street": "Feldmark 18",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Haves",
            "id": "23-000",
            "text": "Reitstall Haves in Sendenhorst (Nr.23-000)",
            "Street": "Sunger 7",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Ludwig",
            "id": "24-000",
            "text": "Pferdehof Ludwig in Drensteinfurt (Nr.24-000)",
            "Street": "Eickendorf 36",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Schabhüser",
            "id": "25-000",
            "text": "Pferdehof Schabhüser in Warendorf (Nr.25-000)",
            "Street": "Neuwarendorf 3",
            "ZIP": "48231",
            "City": "Warendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Weidenhof",
            "id": "26-000",
            "text": "Weidenhof in Drensteinfurt (Nr.26-000)",
            "Street": "Göttendorfer Weg 94",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hengststation Holkenbrink",
            "id": "27-000",
            "text": "Hengststation Holkenbrink in Münster (Nr.27-000)",
            "Street": "Oberort 20",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "West I 12 (Privat) ",
            "id": "28-000",
            "text": "West I 12 (Privat)  in Sendenhorst (Nr.28-000)",
            "Street": "West I 12",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stegemann-Wibbelt",
            "id": "29-000",
            "text": "Stegemann-Wibbelt in Münster (Nr.29-000)",
            "Street": "Kanalstraße 258",
            "ZIP": "48159",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Albachten",
            "id": "30-000",
            "text": "RV Albachten in Münster (Nr.30-000)",
            "Street": "Oberort 105",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sekic",
            "id": "31-000",
            "text": "Sekic in Sendenhorst (Nr.31-000)",
            "Street": "Sudfeld 9",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Ascheberg",
            "id": "32-000",
            "text": "RV Ascheberg in Ascheberg (Nr.32-000)",
            "Street": "Windmühlenweg 10",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuF Greven",
            "id": "33-000",
            "text": "RuF Greven in Greven (Nr.33-000)",
            "Street": "Saerbeckerstrasse 190",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Westphalia Stables",
            "id": "34-000",
            "text": "Westphalia Stables in Hörstel (Nr.34-000)",
            "Street": "Ludwigswald 101",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kammler",
            "id": "35-000",
            "text": "Kammler in Emsdetten (Nr.35-000)",
            "Street": "Saerbecker Weg 32",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Enigger Vorhelm",
            "id": "36-000",
            "text": "RV Enigger Vorhelm in Ennigerloh (Nr.36-000)",
            "Street": "Balhorn 1",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Berkenheide",
            "id": "37-000",
            "text": "Berkenheide in Greven (Nr.37-000)",
            "Street": "Am Mühlenbach 46",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hase ",
            "id": "38-000",
            "text": "Reitanlage Hase  in Welver (Nr.38-000)",
            "Street": "Postweg 1-3",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Weringhof ",
            "id": "39-000",
            "text": "Weringhof  in Hamm (Nr.39-000)",
            "Street": "Am Weringhof 1",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hidding",
            "id": "40-000",
            "text": "Reitanlage Hidding in Greven (Nr.40-000)",
            "Street": "Wentruper Mark 45",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Möllenbeck ",
            "id": "41-000",
            "text": "Möllenbeck  in Münster (Nr.41-000)",
            "Street": "Kreuzbach 326",
            "ZIP": "48167",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Herrenstein (Kruckenbaum)",
            "id": "43-000",
            "text": "Herrenstein (Kruckenbaum) in Drensteinfurt (Nr.43-000)",
            "Street": "Kerkpatt 24",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Twent ",
            "id": "44-000",
            "text": "Reitstall Twent  in Nottuln (Nr.44-000)",
            "Street": "Gladbeck 10",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Landhof Große-Hellmann",
            "id": "45-000",
            "text": "Landhof Große-Hellmann in münster (Nr.45-000)",
            "Street": "Niederort 131",
            "ZIP": "48308",
            "City": "münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Beckmann ",
            "id": "46-000",
            "text": "Stall Beckmann  in Münster (Nr.46-000)",
            "Street": "Hofkamp 132",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Korte ",
            "id": "47-000",
            "text": "Korte  in Telgte (Nr.47-000)",
            "Street": "Lauheide 26",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuV Hiltrup ",
            "id": "48-000",
            "text": "RuV Hiltrup  in Münster (Nr.48-000)",
            "Street": "Hünenburg 22",
            "ZIP": "48165",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Albersloh",
            "id": "49-000",
            "text": "RV Albersloh in Sendenhorst (Nr.49-000)",
            "Street": "Hohe Ward 5",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Frankenhof",
            "id": "50-000",
            "text": "Frankenhof in Rehau (Nr.50-000)",
            "Street": "Degenreuth 2",
            "ZIP": "95111",
            "City": "Rehau",
            "Bundesland": "Bayern",
            "Land": "Deutschland"
        },
        {
            "name": "Triebus Fallenberg ",
            "id": "51-000",
            "text": "Triebus Fallenberg  in Ennigerloh (Nr.51-000)",
            "Street": "Wessenhorst 20",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Grumbach ",
            "id": "52-000",
            "text": "Grumbach  in Harsewinkel (Nr.52-000)",
            "Street": "Hallerstrasse 37",
            "ZIP": "33428",
            "City": "Harsewinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Rhynern ",
            "id": "53-000",
            "text": "RV Rhynern  in Hamm (Nr.53-000)",
            "Street": "Holthöfener Weg 1A",
            "ZIP": "59069",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Feddermann ",
            "id": "54-000",
            "text": "Feddermann  in Greven (Nr.54-000)",
            "Street": "Saerbeckerstr. 150",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Roxel ",
            "id": "55-000",
            "text": "RV Roxel  in Münster (Nr.55-000)",
            "Street": "Bösenseller Straße 6",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zur Rossheide ",
            "id": "56-000",
            "text": "Zur Rossheide  in Münster (Nr.56-000)",
            "Street": "Zur Rossheide 2",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Don A Rima Ranch",
            "id": "57-000",
            "text": "Don A Rima Ranch in Warendorf (Nr.57-000)",
            "Street": "Neuwarendorf 56A",
            "ZIP": "48231",
            "City": "Warendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuFWadelheim-Rheine ",
            "id": "58-000",
            "text": "RuFWadelheim-Rheine  in Rheine (Nr.58-000)",
            "Street": "Ohner Damm 9",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kögel",
            "id": "59-000",
            "text": "Kögel in Porta Westfalica (Nr.59-000)",
            "Street": "Am Rehm 10",
            "ZIP": "32457",
            "City": "Porta Westfalica",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Heimann",
            "id": "60-000",
            "text": "Heimann in Sendenhorst (Nr.60-000)",
            "Street": "Rummler 1",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Kellenberg",
            "id": "61-000",
            "text": "Pferdepension Kellenberg in Hemsloh (Nr.61-000)",
            "Street": "Wagenfelderstraße 28",
            "ZIP": "49453",
            "City": "Hemsloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Laumann",
            "id": "62-000",
            "text": "Laumann in Greven (Nr.62-000)",
            "Street": "Laumanns Damm 22",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuF Recklinghausen ",
            "id": "63-000",
            "text": "RuF Recklinghausen  in Recklinghausen (Nr.63-000)",
            "Street": "Lindenstr. 82",
            "ZIP": "45659",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Holtmann ",
            "id": "64-000",
            "text": "Gut Holtmann  in Billerbeck (Nr.64-000)",
            "Street": "Dörholt 14",
            "ZIP": "48727",
            "City": "Billerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jana Preissing ",
            "id": "65-000",
            "text": "Jana Preissing  in Senden (Nr.65-000)",
            "Street": "Gettrup 13",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meckmann-Dorsel",
            "id": "66-000",
            "text": "Meckmann-Dorsel in Münster (Nr.66-000)",
            "Street": "Markweg 100",
            "ZIP": "48147",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pfedehof Rohmann ",
            "id": "67-000",
            "text": "Pfedehof Rohmann  in Hörstel (Nr.67-000)",
            "Street": "Brachtesendeweg 215",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Ennigerloh-Neubeckum",
            "id": "68-000",
            "text": "RV Ennigerloh-Neubeckum in Ennigerloh (Nr.68-000)",
            "Street": "In der Hoest  22",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Ansgar Westrup ",
            "id": "69-000",
            "text": "Reitanlage Ansgar Westrup  in Havixbeck (Nr.69-000)",
            "Street": "Schonebeck 21",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mölllers ",
            "id": "70-000",
            "text": "Mölllers  in Münster (Nr.70-000)",
            "Street": "Lauheide 31",
            "ZIP": "48291",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall",
            "id": "72-000",
            "text": "Privater Offenstall in Bottrop (Nr.72-000)",
            "Street": "Im Spring 87",
            "ZIP": "46244",
            "City": "Bottrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Wadelheim Rheine",
            "id": "73-000",
            "text": "RV Wadelheim Rheine in Rheine (Nr.73-000)",
            "Street": "Ohner Damm 13",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Rohmann ",
            "id": "74-000",
            "text": "Reiterhof Rohmann  in Nordwalde (Nr.74-000)",
            "Street": "Westerode 41",
            "ZIP": "48356",
            "City": "Nordwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hinterberg ",
            "id": "75-000",
            "text": "Hof Hinterberg  in Westernkappeln (Nr.75-000)",
            "Street": "Hoppenliet 21",
            "ZIP": "49492",
            "City": "Westernkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hengsthaltung Becks",
            "id": "76-000",
            "text": "Hengsthaltung Becks in Senden (Nr.76-000)",
            "Street": "Dorfbauerschaft 39",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wernsmann ",
            "id": "77-000",
            "text": "Wernsmann  in Hörstel (Nr.77-000)",
            "Street": "Münsterdamm 16a",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof  Hillebrandt",
            "id": "78-000",
            "text": "Pferdehof  Hillebrandt in Coesfeld (Nr.78-000)",
            "Street": "Letter Berg 16",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kinnebrock",
            "id": "79-000",
            "text": "Kinnebrock in Münster (Nr.79-000)",
            "Street": "Erbdrostenweg 285",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Leusmann",
            "id": "81-000",
            "text": "Hof Leusmann in Rheine (Nr.81-000)",
            "Street": "Riesenbeckerstr. 180",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schmitz",
            "id": "82-000",
            "text": "Stall Schmitz in Ibbenbüren-Dickenberg (Nr.82-000)",
            "Street": "Am Mariannenschacht  85",
            "ZIP": "49479",
            "City": "Ibbenbüren-Dickenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Hackenesch",
            "id": "83-000",
            "text": "Pferdehof Hackenesch in Münster (Nr.83-000)",
            "Street": "Im Dahl 13a",
            "ZIP": "48165",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kammann",
            "id": "84-000",
            "text": "Kammann in Senden (Nr.84-000)",
            "Street": "Wierling 33",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Lohmann",
            "id": "85-000",
            "text": "Pferdehof Lohmann in Münster (Nr.85-000)",
            "Street": "Westfalen Strasse 48",
            "ZIP": "48165",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "id": "86-000",
            "text": " in Billerbeck (Nr.86-000)",
            "Street": "Bockelsdorf 22",
            "ZIP": "48727",
            "City": "Billerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Kost",
            "id": "87-000",
            "text": "Reitanlage Kost in Bochum (Nr.87-000)",
            "Street": "Havkenscheider Straße 243",
            "ZIP": "44803",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall",
            "id": "88-000",
            "text": "Privatstall in Viernheim (Nr.88-000)",
            "Street": "Am Alten Weinheimer Weg 13",
            "ZIP": "68589",
            "City": "Viernheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Burfeind",
            "id": "89-000",
            "text": "Burfeind in Sittensen (Nr.89-000)",
            "Street": "Alte Dorfstraße ",
            "ZIP": "27419",
            "City": "Sittensen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fam. Aupers",
            "id": "90-000",
            "text": "Fam. Aupers in Münster (Nr.90-000)",
            "Street": "Havixbecker Straße 101",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Ahlen",
            "id": "91-000",
            "text": "RV Ahlen in Ahlen (Nr.91-000)",
            "Street": "Walstedderstr. 176",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Beckmann",
            "id": "92-000",
            "text": "Hof Beckmann in Recklinghausen (Nr.92-000)",
            "Street": "Bockholterstraße 445",
            "ZIP": "45659",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hildesheim marienburg",
            "id": "93-000",
            "text": "Hildesheim marienburg in Hildesheim (Nr.93-000)",
            "Street": "Beusterstrasse 22",
            "ZIP": "31141",
            "City": "Hildesheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Engelke",
            "id": "94-000",
            "text": "Reitstall Engelke in Hülsede (Nr.94-000)",
            "Street": "Zur Bauernstelle 7",
            "ZIP": "31867",
            "City": "Hülsede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Loikum",
            "id": "95-000",
            "text": "RV Loikum in Hamminkeln (Nr.95-000)",
            "Street": "Mehrbruch 1",
            "ZIP": "46499",
            "City": "Hamminkeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Niehues",
            "id": "96-000",
            "text": "Niehues in Ledgen (Nr.96-000)",
            "Street": "Isingort 63",
            "ZIP": "48739",
            "City": "Ledgen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Peter Horstmann",
            "id": "97-000",
            "text": "Pferdepension Peter Horstmann in Sendenhorst (Nr.97-000)",
            "Street": "Alter Postweg 38",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Freisfeld",
            "id": "98-000",
            "text": "Hof Freisfeld in Ascheberg (Nr.98-000)",
            "Street": "Ostereckern 11",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vechtehof Pröbsting",
            "id": "99-000",
            "text": "Vechtehof Pröbsting in Wettringen (Nr.99-000)",
            "Street": "Vollenbrok 1",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Lüdinghausen",
            "id": "100-000",
            "text": "Reit- und Fahrverein Lüdinghausen in Lüdinghausen (Nr.100-000)",
            "Street": "Elvert 26",
            "ZIP": "53948",
            "City": "Lüdinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Engemann",
            "id": "101-000",
            "text": "Engemann in Rheda Wiedenbrück (Nr.101-000)",
            "Street": "Auf der Horst 29",
            "ZIP": "33378",
            "City": "Rheda Wiedenbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schütte",
            "id": "102-000",
            "text": "Hof Schütte in Spelle (Nr.102-000)",
            "Street": "An der Koppel 1",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV Neuenkirchen",
            "id": "103-000",
            "text": "ZRFV Neuenkirchen in Neuenkirchen (Nr.103-000)",
            "Street": "Haarweg 42",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulte Mesum",
            "id": "104-000",
            "text": "Schulte Mesum in Rheine (Nr.104-000)",
            "Street": "Feuerstiege 31",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Borgert",
            "id": "106-000",
            "text": "Gestüt Borgert in Coesfeld (Nr.106-000)",
            "Street": "Harle 51",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hollenhorst Stables",
            "id": "107-000",
            "text": "Hollenhorst Stables in Thuine (Nr.107-000)",
            "Street": "Hollenhorst 1",
            "ZIP": "49832",
            "City": "Thuine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Steinschulte",
            "id": "108-000",
            "text": "Steinschulte in Hamm (Nr.108-000)",
            "Street": "Frielick 6",
            "ZIP": "59073",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schulze Everding",
            "id": "109-000",
            "text": "Hof Schulze Everding in Münster (Nr.109-000)",
            "Street": "Brock 200",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Birkenhof Birgte / Riesenbeck",
            "id": "110-000",
            "text": "Birkenhof Birgte / Riesenbeck in Hörstel (Nr.110-000)",
            "Street": "Saerbecker Damm 261",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Reken",
            "id": "111-000",
            "text": "Reitverein Reken in Reken (Nr.111-000)",
            "Street": "Berge 12",
            "ZIP": "48734",
            "City": "Reken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Billerbeck",
            "id": "112-000",
            "text": "Reitverein Billerbeck in Billerbeck (Nr.112-000)",
            "Street": "Hamern 13",
            "ZIP": "48727",
            "City": "Billerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Kettlerholz",
            "id": "113-000",
            "text": "Reitanlage Kettlerholz in Welver (Nr.113-000)",
            "Street": "Kettlerholz 39",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Selbstabholer",
            "id": "115-000",
            "text": "Selbstabholer in Rheine (Nr.115-000)",
            "Street": "Max-Born-Straße 4",
            "ZIP": "48431",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Grothues-Homann",
            "id": "116-000",
            "text": "Grothues-Homann in Senden (Nr.116-000)",
            "Street": "Schölling 17",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hilbring",
            "id": "117-000",
            "text": "Reitanlage Hilbring in Recklinghausen (Nr.117-000)",
            "Street": "Rittbörden 48",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Westerfeld",
            "id": "118-000",
            "text": "Hof Westerfeld in Datteln (Nr.118-000)",
            "Street": "Hagemer Kirchweg 104",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Falkhof",
            "id": "119-000",
            "text": "Falkhof in Lienen (Nr.119-000)",
            "Street": "Im Siensfeld 1",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Teigeler Datteln",
            "id": "120-000",
            "text": "Teigeler Datteln in Datteln (Nr.120-000)",
            "Street": "Hagemer Kirchweg 82",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Stöppelmann",
            "id": "121-000",
            "text": "Pferdehof Stöppelmann in Hamm (Nr.121-000)",
            "Street": "Wambelner Straße 9",
            "ZIP": "59069",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Bawinkel",
            "id": "122-000",
            "text": "Reit- und Fahrverein Bawinkel in Bawinkel (Nr.122-000)",
            "Street": "Am Sportplatz ",
            "ZIP": "49844",
            "City": "Bawinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein St.Georg Heek-Nienborg e.V.",
            "id": "123-000",
            "text": "Reitverein St.Georg Heek-Nienborg e.V. in Heek (Nr.123-000)",
            "Street": "Averbeck 105",
            "ZIP": "48619",
            "City": "Heek",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Harde",
            "id": "124-000",
            "text": "Reitanlage Harde in Welver (Nr.124-000)",
            "Street": "Hillingsen 1",
            "ZIP": "59515",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Lippetal",
            "id": "125-000",
            "text": "Reitanlage Lippetal in Lippetal (Nr.125-000)",
            "Street": "Dolberger Str. 76",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fenner",
            "id": "126-000",
            "text": "Privatstall Fenner in Greven (Nr.126-000)",
            "Street": "Kroner Heide 33",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Alte Vogtei Schloss Vornholz",
            "id": "127-000",
            "text": "Alte Vogtei Schloss Vornholz in Ennigerloh (Nr.127-000)",
            "Street": "Zum Hohen Kreuz 16",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Small Hill Stable",
            "id": "128-000",
            "text": "Small Hill Stable in Hamm (Nr.128-000)",
            "Street": "Hölter 21",
            "ZIP": "59065",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Floer",
            "id": "129-000",
            "text": "Hof Floer in Nordwalde (Nr.129-000)",
            "Street": "Suttorf 11",
            "ZIP": "48356",
            "City": "Nordwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gisa de Angelis",
            "id": "130-000",
            "text": "Gisa de Angelis in Münster (Nr.130-000)",
            "Street": "Bredeheide 152",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hülskötter",
            "id": "131-000",
            "text": "Hülskötter in Greven (Nr.131-000)",
            "Street": "Hüttruper Str. 86",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hoogenhof",
            "id": "132-000",
            "text": "Hoogenhof in Kamp-Lintfort (Nr.132-000)",
            "Street": "Xantener Str. 80",
            "ZIP": "47475",
            "City": "Kamp-Lintfort",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuF Spelle",
            "id": "133-000",
            "text": "RuF Spelle in Spelle (Nr.133-000)",
            "Street": "In den Gärten 20",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hövelmann",
            "id": "134-000",
            "text": "Hövelmann in Sendenhorst (Nr.134-000)",
            "Street": "West II",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Thurau",
            "id": "137-000",
            "text": "Thurau in Haselünne (Nr.137-000)",
            "Street": "Kreuzweg 14",
            "ZIP": "49740",
            "City": "Haselünne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Raming-Freesen",
            "id": "138-000",
            "text": "Raming-Freesen in Oberlangen (Nr.138-000)",
            "Street": "Zur Marsch 15",
            "ZIP": "49779",
            "City": "Oberlangen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Therapiehof Welp",
            "id": "139-000",
            "text": "Therapiehof Welp in Wettringen (Nr.139-000)",
            "Street": "Bilk 57",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Burlage",
            "id": "140-000",
            "text": "Burlage in Telgte-Westbevern (Nr.140-000)",
            "Street": "Lütken Heide 32",
            "ZIP": "48291",
            "City": "Telgte-Westbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vinzenzwerk handorf e.V.",
            "id": "141-000",
            "text": "Vinzenzwerk handorf e.V. in Münster (Nr.141-000)",
            "Street": "Flugplatz 53",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Overbeck",
            "id": "142-000",
            "text": "Overbeck in Herten (Nr.142-000)",
            "Street": "Weiherstraße ",
            "ZIP": "45701",
            "City": "Herten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulte ",
            "id": "143-000",
            "text": "Schulte  in Spelle (Nr.143-000)",
            "Street": "Bönnestr. 8",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Weymanns Pony Ranch",
            "id": "144-000",
            "text": "Weymanns Pony Ranch in Neuenkirchen (Nr.144-000)",
            "Street": "Mühlendamm 97",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage am Rehrbach",
            "id": "146-000",
            "text": "Reitanlage am Rehrbach in Schermbeck (Nr.146-000)",
            "Street": "Am Rehrbach 98",
            "ZIP": "46514",
            "City": "Schermbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Zumkley",
            "id": "147-000",
            "text": "Hof Zumkley in Senden (Nr.147-000)",
            "Street": "Kley 14",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Horses in Flames Bleckum",
            "id": "148-000",
            "text": "Horses in Flames Bleckum in Beckum (Nr.148-000)",
            "Street": "Elker 16",
            "ZIP": "59269",
            "City": "Beckum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Felix Ponyhof",
            "id": "149-000",
            "text": "Felix Ponyhof in Rietberg (Nr.149-000)",
            "Street": "Schulstr. 130",
            "ZIP": "33397",
            "City": "Rietberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Hunsche",
            "id": "150-000",
            "text": "Reiterhof Hunsche in Lienen (Nr.150-000)",
            "Street": "Reiterweg 5",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Stimberg",
            "id": "152-000",
            "text": "Hof Stimberg in Datteln (Nr.152-000)",
            "Street": "Recklinghäuserstr. 140",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schmidt",
            "id": "153-000",
            "text": "Schmidt in Everswinkel (Nr.153-000)",
            "Street": "Müssingen 38",
            "ZIP": "48351",
            "City": "Everswinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wiermann",
            "id": "155-000",
            "text": "Privatstall Wiermann in Mettingen (Nr.155-000)",
            "Street": "Hagebröcker Weg 22",
            "ZIP": "49497",
            "City": "Mettingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lieningshof",
            "id": "156-000",
            "text": "Lieningshof in Neuenhaus (Nr.156-000)",
            "Street": "Lager Str. 110",
            "ZIP": "49828",
            "City": "Neuenhaus",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ostkotte",
            "id": "157-000",
            "text": "Ostkotte in Ochtrup (Nr.157-000)",
            "Street": "Winkelstraße 31",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Wilhelm Mönnich",
            "id": "158-000",
            "text": "Reitanlage Wilhelm Mönnich in Datteln (Nr.158-000)",
            "Street": "Klosterner Weg 2",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pach",
            "id": "159-000",
            "text": "Pach in Nordhorn (Nr.159-000)",
            "Street": "Am Nolland 18",
            "ZIP": "48529",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Veltmaat",
            "id": "160-000",
            "text": "Veltmaat in Wietmarschen (Nr.160-000)",
            "Street": "Pferdebahn 5",
            "ZIP": "49835",
            "City": "Wietmarschen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Berning",
            "id": "161-000",
            "text": "Berning in Rheine (Nr.161-000)",
            "Street": "Bredeweg 161",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vischedyk",
            "id": "162-000",
            "text": "Vischedyk in Gronau (Nr.162-000)",
            "Street": "Metelner Damm ",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gripshöver",
            "id": "163-000",
            "text": "Gripshöver in Werne (Nr.163-000)",
            "Street": "Martinsweg 4",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schlüter",
            "id": "164-000",
            "text": "Schlüter in Werne (Nr.164-000)",
            "Street": "Martinsweg 19",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "St. Georg Werne",
            "id": "165-000",
            "text": "St. Georg Werne in Werne (Nr.165-000)",
            "Street": "Kähte-Kollwitz Str. 103",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Thünemann",
            "id": "166-000",
            "text": "Thünemann in Andervenne (Nr.166-000)",
            "Street": "Toschlag 6",
            "ZIP": "49832",
            "City": "Andervenne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ross",
            "id": "167-000",
            "text": "Ross in Rheine (Nr.167-000)",
            "Street": "Kämpe 75",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Die Freigänger",
            "id": "168-000",
            "text": "Die Freigänger in Borken (Nr.168-000)",
            "Street": "Coesfelder Straße 69",
            "ZIP": "46325",
            "City": "Borken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Werpers",
            "id": "169-000",
            "text": "Werpers in Emsdetten (Nr.169-000)",
            "Street": "Ahlintel 45",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Brinker",
            "id": "170-000",
            "text": "Pensionsstall Brinker in Fürstenau (Nr.170-000)",
            "Street": "Kellinghausen 27",
            "ZIP": "49584",
            "City": "Fürstenau",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Frie",
            "id": "171-000",
            "text": "Frie in Greven (Nr.171-000)",
            "Street": "Aldruper Oberesch 26",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Neumann",
            "id": "172-000",
            "text": "Privatstall Neumann in Gütersloh (Nr.172-000)",
            "Street": "Luise-Henselstraße 129",
            "ZIP": "33335",
            "City": "Gütersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Münstermann",
            "id": "173-000",
            "text": "Reitanlage Münstermann in Werl-Holtum (Nr.173-000)",
            "Street": "Am Jahenbrink 10",
            "ZIP": "59457",
            "City": "Werl-Holtum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Muke",
            "id": "174-000",
            "text": "Privatstall Muke in Geeste (Nr.174-000)",
            "Street": "Zur Schleuse 25",
            "ZIP": "49744",
            "City": "Geeste",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Kohlmann",
            "id": "175-000",
            "text": "Reitanlage Kohlmann in Dortmund (Nr.175-000)",
            "Street": "Eichwaldstr. 103",
            "ZIP": "44419",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Nordwalde Reckenfeld",
            "id": "176-000",
            "text": "Offenstall Nordwalde Reckenfeld in Nordwalde (Nr.176-000)",
            "Street": "Suttorf 99",
            "ZIP": "48356",
            "City": "Nordwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Tankstelle Holtwick Öffentlich",
            "id": "177-000",
            "text": "Tankstelle Holtwick Öffentlich in Rosendahl (Nr.177-000)",
            "Street": "Coesfelder Straße 6",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Berghoff",
            "id": "178-000",
            "text": "Berghoff in Albersloh (Nr.178-000)",
            "Street": "Sunger 15",
            "ZIP": "48324",
            "City": "Albersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Blömker",
            "id": "179-000",
            "text": "Blömker in Lienen (Nr.179-000)",
            "Street": "Kattenvenner Str. 60",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Nordhoff",
            "id": "180-000",
            "text": "Reitanlage Nordhoff in Emsdetten (Nr.180-000)",
            "Street": "Reckenfelderstr. 92",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rawert",
            "id": "181-000",
            "text": "Rawert in Coesfeld-Lette (Nr.181-000)",
            "Street": "Herteler 74",
            "ZIP": "48653",
            "City": "Coesfeld-Lette",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schulte-Kellinghaus",
            "id": "182-000",
            "text": "Hof Schulte-Kellinghaus in Gladbeck (Nr.182-000)",
            "Street": "Feldhauserstraße 416",
            "ZIP": "45966",
            "City": "Gladbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Einfach Pferdisch",
            "id": "183-000",
            "text": "Einfach Pferdisch in Dorsten (Nr.183-000)",
            "Street": "Kippheide 60",
            "ZIP": "46286",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ruhmann",
            "id": "184-000",
            "text": "Ruhmann in Beckum (Nr.184-000)",
            "Street": "Holtmar 4",
            "ZIP": "59269",
            "City": "Beckum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Balzer",
            "id": "185-000",
            "text": "Hof Balzer in Herten  (Nr.185-000)",
            "Street": "Elper Straße 217",
            "ZIP": "45701",
            "City": "Herten ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RfV Rheine/Catenhorn",
            "id": "186-000",
            "text": "RfV Rheine/Catenhorn in Rheine (Nr.186-000)",
            "Street": "Bauernschaftsstrasse 153",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rv St. Georg Münster",
            "id": "187-000",
            "text": "Rv St. Georg Münster in Münster (Nr.187-000)",
            "Street": "Reiner-Klimke-Weg 1",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "JP - Reiten mit Verstand und Gefühl",
            "id": "188-000",
            "text": "JP - Reiten mit Verstand und Gefühl in Geeste (Nr.188-000)",
            "Street": "Süd-Nord-Straße 20",
            "ZIP": "49744",
            "City": "Geeste",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RuF Nordhorn e.V.",
            "id": "189-000",
            "text": "RuF Nordhorn e.V. in Nordhorn (Nr.189-000)",
            "Street": "Neuenhauser Str. 257",
            "ZIP": "48527",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Everding Amelsbüren",
            "id": "190-000",
            "text": "Schulze Everding Amelsbüren in Münster (Nr.190-000)",
            "Street": "Daverstr. 7",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gerd Niederschabbehard",
            "id": "191-000",
            "text": "Gerd Niederschabbehard in Steinhagen (Nr.191-000)",
            "Street": "In der Howe 1",
            "ZIP": "33803",
            "City": "Steinhagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Busmann",
            "id": "192-000",
            "text": "Busmann in Schüttorf (Nr.192-000)",
            "Street": "Alter Emsbürener Weg 21",
            "ZIP": "48465",
            "City": "Schüttorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wilhelmer",
            "id": "193-000",
            "text": "Hof Wilhelmer in Telgte (Nr.193-000)",
            "Street": "Verth 13",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Marl Hof Ostgathe",
            "id": "194-000",
            "text": "Reitverein Marl Hof Ostgathe in Marl (Nr.194-000)",
            "Street": "Rottmanskamp 23a",
            "ZIP": "45768",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Osterholt",
            "id": "195-000",
            "text": "Pferdehof Osterholt in Südlohn (Nr.195-000)",
            "Street": "Hessinghook 14",
            "ZIP": "46354",
            "City": "Südlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Wiegard",
            "id": "196-000",
            "text": "Pferdehof Wiegard in Ennigerloh (Nr.196-000)",
            "Street": "Hoest 19",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Private Stallgemeinschaft Banker",
            "id": "197-000",
            "text": "Private Stallgemeinschaft Banker in Rosendahl (Nr.197-000)",
            "Street": "Rockel 60",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Mennemann",
            "id": "198-000",
            "text": "Privatstall Mennemann in Lienen (Nr.198-000)",
            "Street": "Am Hagen 3",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Jungkamp",
            "id": "199-000",
            "text": "Reiterhof Jungkamp in Rhede (Nr.199-000)",
            "Street": "Zum Venn 34",
            "ZIP": "46414",
            "City": "Rhede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Equiva Münster",
            "id": "200-000",
            "text": "Equiva Münster in Münster (öffentlich) (Nr.200-000)",
            "Street": "Dieckstraße 71-75",
            "ZIP": "48145",
            "City": "Münster (öffentlich)",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fohlenhof Steins ",
            "id": "201-000",
            "text": "Fohlenhof Steins  in Waltrop (Nr.201-000)",
            "Street": "Unterlippe 26",
            "ZIP": "45731",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein St. Martin Stadtlohn",
            "id": "202-000",
            "text": "Reitverein St. Martin Stadtlohn in Stadtlohn (Nr.202-000)",
            "Street": "Losberg 1",
            "ZIP": "48703",
            "City": "Stadtlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Engelernerhof",
            "id": "203-000",
            "text": "Reitstall Engelernerhof in Merzen  (Nr.203-000)",
            "Street": "Fürstenauer Damm 22",
            "ZIP": "49586",
            "City": "Merzen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rennstall Pavel ",
            "id": "204-000",
            "text": "Rennstall Pavel  in Halle  (Nr.204-000)",
            "Street": "Gewerbestr. 4",
            "ZIP": "33790",
            "City": "Halle ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Quante ",
            "id": "205-000",
            "text": "Hof Quante  in Münster  (Nr.205-000)",
            "Street": "Am Mooresch 35",
            "ZIP": "48157",
            "City": "Münster ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Haverkamp ",
            "id": "206-000",
            "text": "Haverkamp  in Ostbevern  (Nr.206-000)",
            "Street": "Loburg 39",
            "ZIP": "48346",
            "City": "Ostbevern ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Harenburg ",
            "id": "207-000",
            "text": "Harenburg  in Hollage (Nr.207-000)",
            "Street": "Dörnter Weg 2",
            "ZIP": "49134",
            "City": "Hollage",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bussmann ",
            "id": "208-000",
            "text": "Bussmann  in Haltern am See  (Nr.208-000)",
            "Street": "Flaesheimerstraße 276",
            "ZIP": "45721",
            "City": "Haltern am See ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wienken ",
            "id": "209-000",
            "text": "Wienken  in Südlohn (Nr.209-000)",
            "Street": "Sickinghook 5",
            "ZIP": "46354",
            "City": "Südlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Strosi ",
            "id": "210-000",
            "text": "Strosi  in Salzbergen  (Nr.210-000)",
            "Street": "Brandeweg 2",
            "ZIP": "48499",
            "City": "Salzbergen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Helmert ",
            "id": "211-000",
            "text": "Pferdehof Helmert  in Marienfeld/Harsewinkel  (Nr.211-000)",
            "Street": "Lutterstrang 16",
            "ZIP": "33428",
            "City": "Marienfeld/Harsewinkel ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Grossmann/Brockmann ",
            "id": "212-000",
            "text": "Grossmann/Brockmann  in Rheine (Nr.212-000)",
            "Street": "Kloddenhook 23",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Laurenz ",
            "id": "213-000",
            "text": "Privatstall Laurenz  in Gronau  (Nr.213-000)",
            "Street": "Bergstraße 67",
            "ZIP": "48599",
            "City": "Gronau ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Bauer ",
            "id": "214-000",
            "text": "Pferdepension Bauer  in Greven  (Nr.214-000)",
            "Street": "Herberner Mersch 70",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kleinblei ",
            "id": "215-000",
            "text": "Kleinblei  in Nordkirchen  (Nr.215-000)",
            "Street": "Funneweg 2",
            "ZIP": "59394",
            "City": "Nordkirchen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Colrado-Ranch ",
            "id": "216-000",
            "text": "Colrado-Ranch  in Recklinghausen (Nr.216-000)",
            "Street": "Hestermannweg Ecke Heinrichstraße ",
            "ZIP": "45663",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Osthoff ",
            "id": "217-000",
            "text": "Osthoff  in Welver  (Nr.217-000)",
            "Street": "Recklingser Straße  1",
            "ZIP": "59514",
            "City": "Welver ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Gerling ",
            "id": "218-000",
            "text": "Pferdehof Gerling  in Greven  (Nr.218-000)",
            "Street": "Maestruper Brook 19",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit-und Pferdepension Bartling ",
            "id": "219-000",
            "text": "Reit-und Pferdepension Bartling  in Meppen  (Nr.219-000)",
            "Street": "Dorfstraße 1",
            "ZIP": "49716",
            "City": "Meppen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilde ",
            "id": "220-000",
            "text": "Wilde  in Rosendahl  (Nr.220-000)",
            "Street": "Schlee 4",
            "ZIP": "48720",
            "City": "Rosendahl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall FN Elberich ",
            "id": "221-000",
            "text": "Reitstall FN Elberich  in Münster  (Nr.221-000)",
            "Street": "Alter Mühlenweg 41",
            "ZIP": "48157",
            "City": "Münster ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ripperda ",
            "id": "222-000",
            "text": "Privatstall Ripperda  in Lingen  (Nr.222-000)",
            "Street": "Altenlingener Weg 85",
            "ZIP": "49808",
            "City": "Lingen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Suttrup ",
            "id": "223-000",
            "text": "Privatstall Suttrup  in Senden  (Nr.223-000)",
            "Street": "Dorfbauerschaft 122",
            "ZIP": "48308",
            "City": "Senden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bad Iburg ",
            "id": "224-000",
            "text": "Privatstall Bad Iburg  in Bad Iburg  (Nr.224-000)",
            "Street": "Alter Postdamm 2",
            "ZIP": "49186",
            "City": "Bad Iburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sportpferde Hüsken ",
            "id": "225-000",
            "text": "Sportpferde Hüsken  in Wietmarschen  (Nr.225-000)",
            "Street": "Auf der Haare 2",
            "ZIP": "49835",
            "City": "Wietmarschen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Christaller ",
            "id": "226-000",
            "text": "Privatstall Christaller  in Rosendahl  (Nr.226-000)",
            "Street": "Rockel 9",
            "ZIP": "48720",
            "City": "Rosendahl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rieskamp ",
            "id": "227-000",
            "text": "Rieskamp  in Recke  (Nr.227-000)",
            "Street": "Haarkamp 15",
            "ZIP": "49509",
            "City": "Recke ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Thier ",
            "id": "228-000",
            "text": "Reiterhof Thier  in Marl  (Nr.228-000)",
            "Street": "Johannesstraße 52",
            "ZIP": "45770",
            "City": "Marl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV St. Hubertus",
            "id": "229-000",
            "text": "ZRFV St. Hubertus in Dreierwalde (Nr.229-000)",
            "Street": "Venhäuser Weg  7",
            "ZIP": "48477",
            "City": "Dreierwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Decker ",
            "id": "230-000",
            "text": "Stall Decker  in Vreden  (Nr.230-000)",
            "Street": "Lünten Sand ",
            "ZIP": "48691",
            "City": "Vreden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Aschhoff ",
            "id": "231-000",
            "text": "Aschhoff  in Ennigerloh  (Nr.231-000)",
            "Street": "Pilatusberg 18",
            "ZIP": "59320",
            "City": "Ennigerloh ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Temminghoff ",
            "id": "232-000",
            "text": "Temminghoff  in Heiden  (Nr.232-000)",
            "Street": "Stegge 4",
            "ZIP": "46359",
            "City": "Heiden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RUF Nordbögge-Lerch ",
            "id": "233-000",
            "text": "RUF Nordbögge-Lerch  in Bönen (Nr.233-000)",
            "Street": "Schmerhöfeler Weg 5",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Paddocktrail ",
            "id": "234-000",
            "text": "Paddocktrail  in Melle  (Nr.234-000)",
            "Street": "Haseweg 11",
            "ZIP": "49326",
            "City": "Melle ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Repeler Hof ",
            "id": "235-000",
            "text": "Repeler Hof  in Bottrop  (Nr.235-000)",
            "Street": "Repeler Weg 25",
            "ZIP": "46244",
            "City": "Bottrop ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "DraBo Ranch ",
            "id": "236-000",
            "text": "DraBo Ranch  in Nottuln  (Nr.236-000)",
            "Street": "Kley 66",
            "ZIP": "48301",
            "City": "Nottuln ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bindernagel ",
            "id": "238-000",
            "text": "Privatstall Bindernagel  in Rheine  (Nr.238-000)",
            "Street": "Russenweg 16",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RC. St. Mauritz ",
            "id": "239-000",
            "text": "RC. St. Mauritz  in Münster (Nr.239-000)",
            "Street": "Pleistermühlenweg 144",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Brengenberg ",
            "id": "240-000",
            "text": "Hof Brengenberg  in Haltern am See (Nr.240-000)",
            "Street": "Dorstener Straße 950",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Wilmsberg ",
            "id": "241-000",
            "text": "Reiterhof Wilmsberg  in Steinfurt (Nr.241-000)",
            "Street": "Wilmsberg 35a",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Hesseler ",
            "id": "242-000",
            "text": "Stall Hesseler  in Bottrop  (Nr.242-000)",
            "Street": "Brabecker Feld  29A",
            "ZIP": "46244",
            "City": "Bottrop ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Mersmann ",
            "id": "243-000",
            "text": "Hof Mersmann  in Laer (Nr.243-000)",
            "Street": "Altenbergerstrasse 3",
            "ZIP": "48366",
            "City": "Laer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mein Offenstall",
            "id": "244-000",
            "text": "Mein Offenstall in Nordhorn (Nr.244-000)",
            "Street": "Harmsenweg 6",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Surmann",
            "id": "245-000",
            "text": "Privatstall Surmann in Lingen (Nr.245-000)",
            "Street": "Bawinkler Straße 5",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RuFV von Nagel Herbern",
            "id": "246-000",
            "text": "RuFV von Nagel Herbern in Ascheberg (Nr.246-000)",
            "Street": "Am Haselbüschken 5",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Tögemann",
            "id": "247-000",
            "text": "Reitanlage Tögemann in Marl (Nr.247-000)",
            "Street": "Obersinsener Str 172",
            "ZIP": "45770",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sennekamp",
            "id": "248-000",
            "text": "Sennekamp in Hamm (Nr.248-000)",
            "Street": "Baumstraße 47",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schulze Zumkley",
            "id": "249-000",
            "text": "Stall Schulze Zumkley in Olfen (Nr.249-000)",
            "Street": "Im Hagen 1",
            "ZIP": "59399",
            "City": "Olfen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Can Equi",
            "id": "250-000",
            "text": "Can Equi in Halle Westfalen (Nr.250-000)",
            "Street": "Haller Strasse 8",
            "ZIP": "33829",
            "City": "Halle Westfalen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See e.V.",
            "id": "251-000",
            "text": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See e.V. in Haltern am See (Nr.251-000)",
            "Street": "Münsterstraße 163",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vor dem Brocke",
            "id": "252-000",
            "text": "Vor dem Brocke in Lingen (Nr.252-000)",
            "Street": "Hohlweg 2",
            "ZIP": "49808",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Vorhelm Schäringer Feld",
            "id": "253-000",
            "text": "Reitverein Vorhelm Schäringer Feld in Ahlen (Nr.253-000)",
            "Street": "Enniger Str. 70",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Hohenkamp",
            "id": "254-000",
            "text": "Gut Hohenkamp in Dorsten (Nr.254-000)",
            "Street": "Hohenkamp 75",
            "ZIP": "46284",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Mühlenbeck",
            "id": "255-000",
            "text": "Pferdepension Mühlenbeck in Münster  (Nr.255-000)",
            "Street": "Roxeler Straße 447",
            "ZIP": "48161",
            "City": "Münster ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lackmanns Hof",
            "id": "256-000",
            "text": "Lackmanns Hof in Recklinghausen (Nr.256-000)",
            "Street": "Nonnenbuschweg 24",
            "ZIP": "45659",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Weeke",
            "id": "257-000",
            "text": "Weeke in Lienen (Nr.257-000)",
            "Street": "Glandorfer Damm 48",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dijital Santalar",
            "id": "258-000",
            "text": "Privatstall Dijital Santalar in Thuine (Nr.258-000)",
            "Street": "Messinger Straße 4",
            "ZIP": "49832",
            "City": "Thuine",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Bauernhof Albersloh",
            "id": "259-000",
            "text": "Privater Bauernhof Albersloh in Sendenhorst (Nr.259-000)",
            "Street": "Sunger 6a",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Behringhausen",
            "id": "260-000",
            "text": "Gut Behringhausen in Castrop-Rauxel (Nr.260-000)",
            "Street": "Westring 135",
            "ZIP": "44575",
            "City": "Castrop-Rauxel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kinderreitschule Gießler",
            "id": "261-000",
            "text": "Kinderreitschule Gießler in Münster (Nr.261-000)",
            "Street": "Buddenbrink 70",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schräder",
            "id": "262-000",
            "text": "Schräder in Ladbergen (Nr.262-000)",
            "Street": "Am Venn 26",
            "ZIP": "49549",
            "City": "Ladbergen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mindrup",
            "id": "263-000",
            "text": "Mindrup in Münster (Nr.263-000)",
            "Street": "Kreuzbach 40",
            "ZIP": "48167",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Otte",
            "id": "264-000",
            "text": "Otte in Gronau-Epe (Nr.264-000)",
            "Street": "Gerdingseite 13",
            "ZIP": "48599",
            "City": "Gronau-Epe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Perm",
            "id": "265-000",
            "text": "Pensionsstall Perm in Ibbenbbüren (Nr.265-000)",
            "Street": "Permer Straße 120",
            "ZIP": "49479",
            "City": "Ibbenbbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Schloss Wilbringen ",
            "id": "266-000",
            "text": "Reitanlage Schloss Wilbringen  in Waltrop (Nr.266-000)",
            "Street": "Wilbringen 1",
            "ZIP": "45371",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Familie Winzen ",
            "id": "267-000",
            "text": "Familie Winzen  in Reken (Nr.267-000)",
            "Street": "Vossplacke 4a",
            "ZIP": "48734",
            "City": "Reken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Am Dewesberg",
            "id": "268-000",
            "text": "Am Dewesberg in Hopsten (Nr.268-000)",
            "Street": "Am Dewesberg 1",
            "ZIP": "48496",
            "City": "Hopsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Bohlmann",
            "id": "269-000",
            "text": "Pferdehof Bohlmann in Bippen (Nr.269-000)",
            "Street": "Schockländer Straße 5",
            "ZIP": "49626",
            "City": "Bippen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Diekmanns Freigänger",
            "id": "270-000",
            "text": "Diekmanns Freigänger in Borken  (Nr.270-000)",
            "Street": "Boesweg 38",
            "ZIP": "46325",
            "City": "Borken ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Dahlkamp",
            "id": "271-000",
            "text": "Hof Dahlkamp in Selm - Cappenberg (Nr.271-000)",
            "Street": "Zum Birkenbaum 60",
            "ZIP": "59379",
            "City": "Selm - Cappenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Boedeker",
            "id": "272-000",
            "text": "Privatstall Boedeker in Vreden  (Nr.272-000)",
            "Street": "Theodor Heuss Str. 4",
            "ZIP": "48691",
            "City": "Vreden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kurk",
            "id": "273-000",
            "text": "Kurk in Greven  (Nr.273-000)",
            "Street": "Hüttruper Str. 193",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyrosa Ranch",
            "id": "274-000",
            "text": "Ponyrosa Ranch in Wadersloh (Nr.274-000)",
            "Street": "Herzebrockweg 3",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Deupmann",
            "id": "275-000",
            "text": "Privatstall Deupmann in Rheine  (Nr.275-000)",
            "Street": "Salzbergener Str. ",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Münch",
            "id": "276-000",
            "text": "Münch in Recklinghausen (Nr.276-000)",
            "Street": "Hoher Steinweg 33",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schwenken",
            "id": "277-000",
            "text": "Schwenken in Münster (Nr.277-000)",
            "Street": "Davertstrasse 137",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Middelhoff",
            "id": "278-000",
            "text": "Pferdepension Middelhoff in Steinfurt (Nr.278-000)",
            "Street": "Hollicher Straße 99",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Northoff ",
            "id": "279-000",
            "text": "Pferdepension Northoff  in Ahlen  (Nr.279-000)",
            "Street": "Borbeiner Straße 28",
            "ZIP": "59227",
            "City": "Ahlen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ehring",
            "id": "280-000",
            "text": "Privatstall Ehring in Hörstel (Nr.280-000)",
            "Street": "Emsdettener Str. 205",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schaffrinna",
            "id": "281-000",
            "text": "Privatstall Schaffrinna in Lünen (Nr.281-000)",
            "Street": "An der Wethmarheide 120",
            "ZIP": "44536",
            "City": "Lünen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Keßler's Landhaus",
            "id": "282-000",
            "text": "Keßler's Landhaus in Münster (Nr.282-000)",
            "Street": "Raringheide 226",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Beermann",
            "id": "283-000",
            "text": "Reiterhof Beermann in Senden (Nr.283-000)",
            "Street": "Leversum 13",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dove",
            "id": "284-000",
            "text": "Privatstall Dove in Schüttorf (Nr.284-000)",
            "Street": "Narzissenstraße 18",
            "ZIP": "48465",
            "City": "Schüttorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Gruber",
            "id": "285-000",
            "text": "Stall Gruber in Vreden  (Nr.285-000)",
            "Street": "Doemern ",
            "ZIP": "48691",
            "City": "Vreden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Riering",
            "id": "286-000",
            "text": "Privatstall Riering in Havixbeck (Nr.286-000)",
            "Street": "Sentrupskamp 14",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Koch",
            "id": "287-000",
            "text": "Hof Koch in Marl (Nr.287-000)",
            "Street": "Forststr. 78",
            "ZIP": "45768",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Burgmann",
            "id": "288-000",
            "text": "Privatstall Burgmann in Rheine  (Nr.288-000)",
            "Street": "Wadelheimer Chaussee 84",
            "ZIP": "48431",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bütergerds",
            "id": "289-000",
            "text": "Privatstall Bütergerds in Neuenkirchen (Nr.289-000)",
            "Street": "Pfarrer-Bette-Str. 5",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdezucht Brömmelland",
            "id": "290-000",
            "text": "Pferdezucht Brömmelland in Dorsten (Nr.290-000)",
            "Street": "Endelner Weg 201",
            "ZIP": "48286",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ütrecht",
            "id": "291-000",
            "text": "Ütrecht in Samern (Nr.291-000)",
            "Street": "Ohnerstr. 129 129",
            "ZIP": "48465",
            "City": "Samern",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Föcking",
            "id": "292-000",
            "text": "Föcking in Südlohn (Nr.292-000)",
            "Street": "Amselstrasse 29",
            "ZIP": "46354",
            "City": "Südlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferde Ems-Land",
            "id": "293-000",
            "text": "Islandpferde Ems-Land in Geeste (Nr.293-000)",
            "Street": "Erikastrasse 5",
            "ZIP": "49744",
            "City": "Geeste",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Winterhalder",
            "id": "294-000",
            "text": "Winterhalder in Gronau (Nr.294-000)",
            "Street": "Röntgenstr. 11",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Stukenborg",
            "id": "295-000",
            "text": "Hof Stukenborg in Haltern am See (Nr.295-000)",
            "Street": "Rekenerstraße 221",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Equiva Rheine",
            "id": "296-000",
            "text": "Equiva Rheine in Rheine  (Nr.296-000)",
            "Street": "Hansaallee 49-51",
            "ZIP": "48429",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Heemann - Pensionsstallbetrieb",
            "id": "297-000",
            "text": "Hof Heemann - Pensionsstallbetrieb in Lienen (Nr.297-000)",
            "Street": "Nigge Weg ",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kempkes",
            "id": "298-000",
            "text": "Privatstall Kempkes in Hörstel (Nr.298-000)",
            "Street": "Waldstr 17",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Janson",
            "id": "299-000",
            "text": "Privatstall Janson in Coesfeld (Nr.299-000)",
            "Street": "Herteler 32",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lüttecke",
            "id": "300-000",
            "text": "Lüttecke in Telgte (Nr.300-000)",
            "Street": "Sickerhook 9",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Wechter Mark",
            "id": "301-000",
            "text": "Gestüt Wechter Mark in Lengerich (Nr.301-000)",
            "Street": "Wechter Str. 108",
            "ZIP": "49525",
            "City": "Lengerich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Equiva Osnabrück",
            "id": "305-000",
            "text": "Equiva Osnabrück in Osnabrück (öffentlich) (Nr.305-000)",
            "Street": "Pagenstecherstraße 28",
            "ZIP": "49090",
            "City": "Osnabrück (öffentlich)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Bönen Hacheney",
            "id": "306-000",
            "text": "Bönen Hacheney in Bönen (Nr.306-000)",
            "Street": "Heidestrasse 2",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Brinkrolf",
            "id": "307-000",
            "text": "Pferdehof Brinkrolf in Rheda-Wiedenbrück (Nr.307-000)",
            "Street": "Moorweg 112",
            "ZIP": "33378",
            "City": "Rheda-Wiedenbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Brüning",
            "id": "308-000",
            "text": "Schulze Brüning in Münster (Nr.308-000)",
            "Street": "Kanalstraße 340",
            "ZIP": "48143",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Jäschke",
            "id": "309-000",
            "text": "Privatstall Jäschke in Coesfeld (Nr.309-000)",
            "Street": "Südring 10",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Funke",
            "id": "310-000",
            "text": "Funke in Hamm (Nr.310-000)",
            "Street": "Ahlenerstrasse 240",
            "ZIP": "59073",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ludger Zumvenne",
            "id": "311-000",
            "text": "Ludger Zumvenne in Senden (Nr.311-000)",
            "Street": "Gettrup 44",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Spreckelmeyer",
            "id": "312-000",
            "text": "Spreckelmeyer in Lienen (Nr.312-000)",
            "Street": "Am Hagen 2",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lennarz",
            "id": "313-000",
            "text": "Lennarz in Münster (Nr.313-000)",
            "Street": "Am Knapp ",
            "ZIP": "48159",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Niehoff",
            "id": "314-000",
            "text": "Reitanlage Niehoff in Havixbeck (Nr.314-000)",
            "Street": "Schonebeck 24",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Annuß",
            "id": "315-000",
            "text": "Privatstall Annuß in Recklinghausen (Nr.315-000)",
            "Street": "Marienstr. 36",
            "ZIP": "45663",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Köpper",
            "id": "316-000",
            "text": "Köpper in Schermbeck (Nr.316-000)",
            "Street": "Janbrucksfeld 92",
            "ZIP": "46514",
            "City": "Schermbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Brinkel",
            "id": "317-000",
            "text": "Brinkel in Spelle (Nr.317-000)",
            "Street": "Englandstraße 11",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Holz Ahmann",
            "id": "318-000",
            "text": "Holz Ahmann in Emsdetten (Nr.318-000)",
            "Street": "Dettener Straße 10a",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall Scholten",
            "id": "319-000",
            "text": "Privater Offenstall Scholten in Velen-Ramsdorf (Nr.319-000)",
            "Street": "Südlohner Diek ",
            "ZIP": "46342",
            "City": "Velen-Ramsdorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hölscher Pferde",
            "id": "320-000",
            "text": "Hölscher Pferde in Emsdetten (Nr.320-000)",
            "Street": "Grünring  74",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Doetkotte",
            "id": "321-000",
            "text": "Doetkotte in Gronau (Nr.321-000)",
            "Street": "Doetkottenweg  66",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hidding Schulte-Bockum",
            "id": "322-000",
            "text": "Hof Hidding Schulte-Bockum in Bottrop  (Nr.322-000)",
            "Street": "Kreienkampsweg  9",
            "ZIP": "46244",
            "City": "Bottrop ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Neumann",
            "id": "323-000",
            "text": "Reitstall Neumann in Haltern am See (Nr.323-000)",
            "Street": "Hellweg 230",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Meusel",
            "id": "324-000",
            "text": "Privatstall Meusel in Werne (Nr.324-000)",
            "Street": "Münsterstraße 42",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Forellenhof",
            "id": "325-000",
            "text": "Gestüt Forellenhof in Borken  (Nr.325-000)",
            "Street": "Zum Homborn 9",
            "ZIP": "46325",
            "City": "Borken ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Melanie Menzefricke",
            "id": "326-000",
            "text": "Reitsportanlage Melanie Menzefricke in Versmold (Nr.326-000)",
            "Street": "Friedrich-Menzefrickestr. 51",
            "ZIP": "33775",
            "City": "Versmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hemme",
            "id": "327-000",
            "text": "Hemme in Emsbüren (Nr.327-000)",
            "Street": "Zum Schultenhook 8",
            "ZIP": "48488",
            "City": "Emsbüren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Moorheide",
            "id": "328-000",
            "text": "Pferdehof Moorheide in Senden (Nr.328-000)",
            "Street": "Kley 32",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hollmann",
            "id": "329-000",
            "text": "Hollmann in Senden (Nr.329-000)",
            "Street": "Kley  14",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdeparadies Lögering",
            "id": "330-000",
            "text": "Pferdeparadies Lögering in Lingen-Bramsche (Nr.330-000)",
            "Street": "Wesel  4",
            "ZIP": "49811",
            "City": "Lingen-Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Storp",
            "id": "331-000",
            "text": "Privatstall Storp in Münster (Nr.331-000)",
            "Street": "Hartmannsbrook 92",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wimschulte",
            "id": "332-000",
            "text": "Hof Wimschulte in Drensteinfurt (Nr.332-000)",
            "Street": "Nordholt 3",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dasmann",
            "id": "333-000",
            "text": "Privatstall Dasmann in Tecklenburg (Nr.333-000)",
            "Street": "Dast 1",
            "ZIP": "49545",
            "City": "Tecklenburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Selbstversorger Niemand",
            "id": "335-000",
            "text": "Selbstversorger Niemand in Welver (Nr.335-000)",
            "Street": "Im Loh 7a",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ausbildungsstall Koeppel",
            "id": "336-000",
            "text": "Ausbildungsstall Koeppel in Glandorf (Nr.336-000)",
            "Street": "Laersche Straße  28",
            "ZIP": "49219",
            "City": "Glandorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Menke",
            "id": "337-000",
            "text": "Menke in Thuine (Nr.337-000)",
            "Street": "Mühlenstraße 4a",
            "ZIP": "49832",
            "City": "Thuine",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Topphoff",
            "id": "338-000",
            "text": "Schulze Topphoff in Telgte (Nr.338-000)",
            "Street": "Lütken Heide 45",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Helms",
            "id": "339-000",
            "text": "Privatstall Helms in Bergkamen (Nr.339-000)",
            "Street": "Kamer Heide  34",
            "ZIP": "59192",
            "City": "Bergkamen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zeirabenhof",
            "id": "340-000",
            "text": "Zeirabenhof in Sendenhorst (Nr.340-000)",
            "Street": "Jönsthövel  6",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Beckmann",
            "id": "341-000",
            "text": "Beckmann in Coesfeld (Nr.341-000)",
            "Street": "Flamschen 8",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Kuhlmann",
            "id": "342-000",
            "text": "Reitsportanlage Kuhlmann in Marl (Nr.342-000)",
            "Street": "Dahlbrede 5",
            "ZIP": "45772",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Jansen",
            "id": "343-000",
            "text": "Privatstall Jansen in Rheine  (Nr.343-000)",
            "Street": "Steinstr.  13b",
            "ZIP": "48429",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "SG Schröder Hardinghausen",
            "id": "344-000",
            "text": "SG Schröder Hardinghausen in Bottrop-Kirchhellen (Nr.344-000)",
            "Street": "An der Harre  2",
            "ZIP": "46244",
            "City": "Bottrop-Kirchhellen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Greven / Schmedehausen",
            "id": "345-000",
            "text": "Privatstall Greven / Schmedehausen in Greven  (Nr.345-000)",
            "Street": "Ostbevener Straße 26",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "FuRV Wettringen",
            "id": "346-000",
            "text": "FuRV Wettringen in Wettringen (Nr.346-000)",
            "Street": "Burgsteinfurter Straße  28",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bennie Kleijn",
            "id": "347-000",
            "text": "Bennie Kleijn in Havixbeck (Nr.347-000)",
            "Street": "Natrup  35",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jährlingsstation Deitermann",
            "id": "348-000",
            "text": "Jährlingsstation Deitermann in Horstmar, Leer (Nr.348-000)",
            "Street": "Haltern 30",
            "ZIP": "48612",
            "City": "Horstmar, Leer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Grave",
            "id": "349-000",
            "text": "Privatstall Grave in Lienen (Nr.349-000)",
            "Street": "Wulversump 5",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall",
            "id": "350-000",
            "text": "Pensionsstall in Warendorf (Nr.350-000)",
            "Street": "Neuwarendorf 64",
            "ZIP": "48231",
            "City": "Warendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Familie Beckersjürgen",
            "id": "351-000",
            "text": "Familie Beckersjürgen in Nottuln  (Nr.351-000)",
            "Street": "Leopoldshöhe 6",
            "ZIP": "48301",
            "City": "Nottuln ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wenzel",
            "id": "352-000",
            "text": "Privatstall Wenzel in Greven  (Nr.352-000)",
            "Street": "Anna-Badouin-Straße  55",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitgemeinschaft Bönen Hacheney",
            "id": "353-000",
            "text": "Reitgemeinschaft Bönen Hacheney in Bönen (Nr.353-000)",
            "Street": "Heidestraße 45",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Rottmann",
            "id": "354-000",
            "text": "Hof Rottmann in Münster (Nr.354-000)",
            "Street": "Gasselstiege 235",
            "ZIP": "48159",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fahrsportzentrum Ennigerloh",
            "id": "355-000",
            "text": "Fahrsportzentrum Ennigerloh in Ennigerloh  (Nr.355-000)",
            "Street": "Vossmar 10",
            "ZIP": "59320",
            "City": "Ennigerloh ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hofstelle Dennemann",
            "id": "356-000",
            "text": "Hofstelle Dennemann in Ohne (Nr.356-000)",
            "Street": "Möllenweg ",
            "ZIP": "48465",
            "City": "Ohne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Heidhügel",
            "id": "357-000",
            "text": "Gestüt Heidhügel in Emsdetten (Nr.357-000)",
            "Street": "Isendorfer Weg 34",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Vandreuke",
            "id": "358-000",
            "text": "Offenstall Vandreuke in Herten (Nr.358-000)",
            "Street": "Backumerstr. 416",
            "ZIP": "45699",
            "City": "Herten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Klostermann",
            "id": "359-000",
            "text": "Klostermann in Rheine  (Nr.359-000)",
            "Street": "Maiglöckchenweg  45",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kuper",
            "id": "360-000",
            "text": "Kuper in Spelle (Nr.360-000)",
            "Street": "Schlanestraße  17",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schürkamp",
            "id": "361-000",
            "text": "Schürkamp in Ahlen (Nr.361-000)",
            "Street": "Hagenbrede 70",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Beutnagel",
            "id": "362-000",
            "text": "Beutnagel in Spelle (Nr.362-000)",
            "Street": "Stubbendorfstraße 11",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Viefhues",
            "id": "363-000",
            "text": "Privatstall Viefhues in Riesenbeck (Nr.363-000)",
            "Street": "Kanalstraße 179",
            "ZIP": "48477",
            "City": "Riesenbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Franke",
            "id": "364-000",
            "text": "Franke in Lüdinghausen (Nr.364-000)",
            "Street": "Westrup  59",
            "ZIP": "59348",
            "City": "Lüdinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ulmker",
            "id": "365-000",
            "text": "Ulmker in Neuenkirchen (Nr.365-000)",
            "Street": "Mesumer Str.  75",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mersmann",
            "id": "366-000",
            "text": "Mersmann in Münster (Nr.366-000)",
            "Street": "Böckenhorst 18",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "FS Paradise",
            "id": "367-000",
            "text": "FS Paradise in Nordhorn (Nr.367-000)",
            "Street": "Emsbürener Str. 50",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Haus Küchen",
            "id": "368-000",
            "text": "Haus Küchen in Ahlen (Nr.368-000)",
            "Street": "Mallinckrodtweg 25",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gerlemann",
            "id": "369-000",
            "text": "Hof Gerlemann in Meppen (Nr.369-000)",
            "Street": "Dorfstraße 14",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schnarre",
            "id": "371-000",
            "text": "Schnarre in Lotte (Nr.371-000)",
            "Street": "Düter Str. 8",
            "ZIP": "49504",
            "City": "Lotte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Landhaus Schweckendieck",
            "id": "372-000",
            "text": "Gestüt Landhaus Schweckendieck in Wietmarschen  (Nr.372-000)",
            "Street": "Am Moersfeld 33",
            "ZIP": "49835",
            "City": "Wietmarschen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Große Wittler",
            "id": "373-000",
            "text": "Große Wittler in Münster (Nr.373-000)",
            "Street": "Davertstraße 198",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Diesen",
            "id": "374-000",
            "text": "Hof Diesen in Emsdetten (Nr.374-000)",
            "Street": "Aechterhoek 16",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Trainingszentrum Hoffrogge",
            "id": "375-000",
            "text": "Trainingszentrum Hoffrogge in Dorsten (Nr.375-000)",
            "Street": "Bestener Straße 145",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Stapelskotten",
            "id": "376-000",
            "text": "Reitanlage Stapelskotten in Münster (Nr.376-000)",
            "Street": "Am Mooresch  34",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV Borken e.V",
            "id": "377-000",
            "text": "ZRFV Borken e.V in Borken Weseken (Nr.377-000)",
            "Street": "Pröbstinger Allee 10",
            "ZIP": "46325",
            "City": "Borken Weseken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Von Kleinsorgen",
            "id": "378-000",
            "text": "Von Kleinsorgen in Coesfeld (Nr.378-000)",
            "Street": "Kalte 4",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zucht,-Reit und Fahrverein Rheine e.V.",
            "id": "379-000",
            "text": "Zucht,-Reit und Fahrverein Rheine e.V. in Rheine  (Nr.379-000)",
            "Street": "In der Lake 12",
            "ZIP": "48429",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Strotjohann",
            "id": "380-000",
            "text": "Strotjohann in Ostbevern (Nr.380-000)",
            "Street": "Reichard-Str.  9",
            "ZIP": "48346",
            "City": "Ostbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Temberge",
            "id": "381-000",
            "text": "Schulze Temberge in Gronau (Nr.381-000)",
            "Street": "Gerdingseite 3",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rehbaum",
            "id": "382-000",
            "text": "Privatstall Rehbaum in Sendenhorst (Nr.382-000)",
            "Street": "Sunger 18",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Elfringhof",
            "id": "383-000",
            "text": "Schulze Elfringhof in Ochtrup (Nr.383-000)",
            "Street": "Weiner 133",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Averhaus",
            "id": "384-000",
            "text": "Averhaus in Emsdetten (Nr.384-000)",
            "Street": "Saerbecker Weg 31",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ahlbrand Pferdefutter",
            "id": "385-000",
            "text": "Ahlbrand Pferdefutter in Münster (Nr.385-000)",
            "Street": "Dalkamp  14",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Peterka",
            "id": "386-000",
            "text": "Peterka in Legden (Nr.386-000)",
            "Street": "Wehr 159",
            "ZIP": "48739",
            "City": "Legden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Stein",
            "id": "387-000",
            "text": "Reitstall Stein in Wietmarschen  (Nr.387-000)",
            "Street": "Wietmarschener Straße 9",
            "ZIP": "49835",
            "City": "Wietmarschen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Hille",
            "id": "388-000",
            "text": "Reitstall Hille in Ladbergen (Nr.388-000)",
            "Street": "Brockwiesen 32",
            "ZIP": "49549",
            "City": "Ladbergen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Otten",
            "id": "389-000",
            "text": "Reitstall Otten in Lingen (Nr.389-000)",
            "Street": "Hüsinger Hook 2",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Strodt",
            "id": "390-000",
            "text": "Strodt in Lingen (Nr.390-000)",
            "Street": "Schulstraße  5",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichenhof",
            "id": "391-000",
            "text": "Eichenhof in Havixbeck (Nr.391-000)",
            "Street": "Masbeck 2",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Gottschald",
            "id": "392-000",
            "text": "Privatstall Gottschald in Stavern (Nr.392-000)",
            "Street": "Sögeler Straße 19",
            "ZIP": "49777",
            "City": "Stavern",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beckmann",
            "id": "393-000",
            "text": "Privatstall Beckmann in Lienen (Nr.393-000)",
            "Street": "Glandorfer Damm 5",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichenhof Beppen",
            "id": "394-000",
            "text": "Eichenhof Beppen in Thedinghausen (Nr.394-000)",
            "Street": "Neu-Morsumer-Weg  8",
            "ZIP": "27321",
            "City": "Thedinghausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Siedehof",
            "id": "395-000",
            "text": "Siedehof in Steyerberg (Nr.395-000)",
            "Street": "Voigtei 111",
            "ZIP": "31595",
            "City": "Steyerberg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Wilke",
            "id": "396-000",
            "text": "Pferdepension Wilke in Diepholz (Nr.396-000)",
            "Street": "Moorhäuser Str.  25",
            "ZIP": "49356",
            "City": "Diepholz",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Daubert",
            "id": "397-000",
            "text": "Stall Daubert in Sögel (Nr.397-000)",
            "Street": "Stavernerstrasse  1",
            "ZIP": "49751",
            "City": "Sögel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schnier",
            "id": "398-000",
            "text": "Schnier in Bad Oeynhausen/ Werste (Nr.398-000)",
            "Street": "Ringstraße 77",
            "ZIP": "32549",
            "City": "Bad Oeynhausen/ Werste",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sasse",
            "id": "399-000",
            "text": "Sasse in Recklinghausen (Nr.399-000)",
            "Street": "Franziskanerstr. 60",
            "ZIP": "45659",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Suntrup",
            "id": "400-000",
            "text": "Hof Suntrup in Warendorf (Nr.400-000)",
            "Street": "Gronhorst 14",
            "ZIP": "48231",
            "City": "Warendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hugerlandshof",
            "id": "401-000",
            "text": "Hugerlandshof in Münster-Handorf (Nr.401-000)",
            "Street": "Hugerlandshofweg 70",
            "ZIP": "48155",
            "City": "Münster-Handorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall von Abel",
            "id": "402-000",
            "text": "Privatstall von Abel in Elsfleth (Nr.402-000)",
            "Street": "Oberrege  49",
            "ZIP": "26931",
            "City": "Elsfleth",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Redder",
            "id": "403-000",
            "text": "Reiterhof Redder in Bad Driburg (Nr.403-000)",
            "Street": "An der Steinbrücke ",
            "ZIP": "33014",
            "City": "Bad Driburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Heuermann",
            "id": "404-000",
            "text": "Pensionsstall Heuermann in Vlotho (Nr.404-000)",
            "Street": "Hettenholter Weg  37",
            "ZIP": "32602",
            "City": "Vlotho",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gerusel",
            "id": "405-000",
            "text": "Gerusel in Dörentrup Wendlinghausen (Nr.405-000)",
            "Street": "Friedrichsfeld 2",
            "ZIP": "32694",
            "City": "Dörentrup Wendlinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Campingplatz Schöne Ausdicht",
            "id": "406-000",
            "text": "Campingplatz Schöne Ausdicht in Vlotho (Nr.406-000)",
            "Street": "Lehmhöhlenweg 5",
            "ZIP": "32602",
            "City": "Vlotho",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Wibbelmann",
            "id": "407-000",
            "text": "Pferdepension Wibbelmann in Bissendorf (Nr.407-000)",
            "Street": "Niederberger Mark  31",
            "ZIP": "49143",
            "City": "Bissendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Holtkamp",
            "id": "408-000",
            "text": "Stall Holtkamp in Kirchlegern (Nr.408-000)",
            "Street": "Brannecker Str. 56",
            "ZIP": "32278",
            "City": "Kirchlegern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Igelmann",
            "id": "409-000",
            "text": "Igelmann in Bissendorf (Nr.409-000)",
            "Street": "Bergstrasse  98a",
            "ZIP": "49153",
            "City": "Bissendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gockel",
            "id": "410-000",
            "text": "Hof Gockel in Paderborn (Nr.410-000)",
            "Street": "Dörener Holzweg 65",
            "ZIP": "33100",
            "City": "Paderborn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meiners",
            "id": "411-000",
            "text": "Meiners in Lorup (Nr.411-000)",
            "Street": "Kirchkamp 37",
            "ZIP": "26901",
            "City": "Lorup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Aldag",
            "id": "412-000",
            "text": "Stall Aldag in Minden (Nr.412-000)",
            "Street": "Mitteldamm 60",
            "ZIP": "32425",
            "City": "Minden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ewen",
            "id": "413-000",
            "text": "Privatstall Ewen in Hude (Nr.413-000)",
            "Street": "Erlenweg 1",
            "ZIP": "27798",
            "City": "Hude",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Blub",
            "id": "414-000",
            "text": "Blub in Colnrade (Nr.414-000)",
            "Street": "Holtesche 5",
            "ZIP": "27243",
            "City": "Colnrade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsport-Waldweg",
            "id": "415-000",
            "text": "Reitsport-Waldweg in Emtinghausen (Nr.415-000)",
            "Street": "Waldweg 8",
            "ZIP": "27321",
            "City": "Emtinghausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit-und Fahrverein Wagenfeld",
            "id": "416-000",
            "text": "Reit-und Fahrverein Wagenfeld in Wagenfeld (Nr.416-000)",
            "Street": "Fritz-Cording-Str. 1",
            "ZIP": "49419",
            "City": "Wagenfeld",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kröger",
            "id": "417-000",
            "text": "Privatstall Kröger in Löhne (Nr.417-000)",
            "Street": "Kirschenweg 5",
            "ZIP": "32584",
            "City": "Löhne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Goßling",
            "id": "418-000",
            "text": "Privatstall Goßling in Westoverledingen (Nr.418-000)",
            "Street": "Heerweg 6",
            "ZIP": "26810",
            "City": "Westoverledingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sonntag Bielefeld",
            "id": "419-000",
            "text": "Sonntag Bielefeld in Bielefeld (Nr.419-000)",
            "Street": "Hillegosser Str. 135",
            "ZIP": "33719",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lieschen's Ranch",
            "id": "420-000",
            "text": "Lieschen's Ranch in Kirchlengern (Nr.420-000)",
            "Street": "Horstfeld 37",
            "ZIP": "32278",
            "City": "Kirchlengern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Vinnen",
            "id": "421-000",
            "text": "Gut Vinnen in Bad Salzuflen (Nr.421-000)",
            "Street": "Vinnen 2",
            "ZIP": "32107",
            "City": "Bad Salzuflen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Radtke",
            "id": "422-000",
            "text": "Radtke in Bremen (Nr.422-000)",
            "Street": "Am Grenzknick 17a",
            "ZIP": "28755",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferdehof Lukka",
            "id": "423-000",
            "text": "Islandpferdehof Lukka in Lemgo (Nr.423-000)",
            "Street": "Am Tiefen Siek 65",
            "ZIP": "32657",
            "City": "Lemgo",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ratering",
            "id": "424-000",
            "text": "Ratering in Walchum (Nr.424-000)",
            "Street": "Westweg  61",
            "ZIP": "26907",
            "City": "Walchum",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kronenkamp Ranch",
            "id": "425-000",
            "text": "Kronenkamp Ranch in Bad Zwischenahn (Nr.425-000)",
            "Street": "Kronenkamp 2",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Petvitalshop",
            "id": "426-000",
            "text": "Petvitalshop in Bünde (Nr.426-000)",
            "Street": "Elsemühlenweg 85",
            "ZIP": "32257",
            "City": "Bünde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Overhagener Pferdehof",
            "id": "427-000",
            "text": "Overhagener Pferdehof in Bottrop (Nr.427-000)",
            "Street": "Hoheheideweg 4",
            "ZIP": "46244",
            "City": "Bottrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Claaßen",
            "id": "428-000",
            "text": "Claaßen in Bramsche (Nr.428-000)",
            "Street": "Schleptruper Strang 64",
            "ZIP": "49565",
            "City": "Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Junga",
            "id": "429-000",
            "text": "Privatstall Junga in Bramsche (Nr.429-000)",
            "Street": "Rote Riede  8",
            "ZIP": "49565",
            "City": "Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Halhof",
            "id": "430-000",
            "text": "Halhof in Bielefeld (Nr.430-000)",
            "Street": "Talbrückenstr. 142",
            "ZIP": "33609",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rippelbeck",
            "id": "431-000",
            "text": "Privatstall Rippelbeck in Bramsche (Nr.431-000)",
            "Street": "Wiechmanns Ecke 3",
            "ZIP": "49565",
            "City": "Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Semmler",
            "id": "432-000",
            "text": "Privatstall Semmler in Bramsche (Nr.432-000)",
            "Street": "Haferkamp 21",
            "ZIP": "49565",
            "City": "Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Landgut Papenhausen",
            "id": "433-000",
            "text": "Landgut Papenhausen in Bad Salzuflen (Nr.433-000)",
            "Street": "Papenhausen 2",
            "ZIP": "32108",
            "City": "Bad Salzuflen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Wessels",
            "id": "434-000",
            "text": "Stall Wessels in Rastede (Nr.434-000)",
            "Street": "Am Eichenwall 100",
            "ZIP": "26180",
            "City": "Rastede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Von Essen",
            "id": "435-000",
            "text": "Von Essen in Rastede (Nr.435-000)",
            "Street": "Heiddornweg  14",
            "ZIP": "26180",
            "City": "Rastede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Börger",
            "id": "436-000",
            "text": "Privatstall Börger in Delbrück (Nr.436-000)",
            "Street": "Ehlersweg 5",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Eicheneck",
            "id": "437-000",
            "text": "Hof Eicheneck in Menslage (Nr.437-000)",
            "Street": "Antener Str. 5",
            "ZIP": "49637",
            "City": "Menslage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Knemeyer",
            "id": "438-000",
            "text": "Knemeyer in Borgholzhausen (Nr.438-000)",
            "Street": "Illenbruch 3",
            "ZIP": "33829",
            "City": "Borgholzhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gnadenhof die Geretteten e.V.",
            "id": "439-000",
            "text": "Gnadenhof die Geretteten e.V. in Rahden (Nr.439-000)",
            "Street": "Örlingerhausen 4",
            "ZIP": "32369",
            "City": "Rahden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stallgemeinschaft",
            "id": "440-000",
            "text": "Stallgemeinschaft in Esterwegen (Nr.440-000)",
            "Street": "Mühlenberg 9",
            "ZIP": "26897",
            "City": "Esterwegen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Berg",
            "id": "441-000",
            "text": "Reitsportanlage Berg in Hiddenhausen (Nr.441-000)",
            "Street": "Lipinghauserstr. 101",
            "ZIP": "32120",
            "City": "Hiddenhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kinder Wald und Wiese Bremen e.V.",
            "id": "442-000",
            "text": "Kinder Wald und Wiese Bremen e.V. in Bremen (Nr.442-000)",
            "Street": "Papenkampsweg  12",
            "ZIP": "28213",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Harms",
            "id": "443-000",
            "text": "Harms in Wardenburg (Nr.443-000)",
            "Street": "Saarländer Weg 335",
            "ZIP": "26203",
            "City": "Wardenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Brunklaus",
            "id": "444-000",
            "text": "Brunklaus in Benstrup (Nr.444-000)",
            "Street": "Zuschläge 2",
            "ZIP": "49624",
            "City": "Benstrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Mehrhoff",
            "id": "445-000",
            "text": "Stall Mehrhoff in Hille (Nr.445-000)",
            "Street": "Burkampweg 21",
            "ZIP": "32479",
            "City": "Hille",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Freiberger Zucht Solenzki",
            "id": "446-000",
            "text": "Freiberger Zucht Solenzki in Bremen (Nr.446-000)",
            "Street": "Hospitalstr ",
            "ZIP": "28777",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Niederbäumer",
            "id": "447-000",
            "text": "Reitstall Niederbäumer in Hiddenhausen (Nr.447-000)",
            "Street": "Lippinghauser Str. 59",
            "ZIP": "32120",
            "City": "Hiddenhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Scharringhausen",
            "id": "448-000",
            "text": "Privatstall Scharringhausen in Harpstedt (Nr.448-000)",
            "Street": "Nordstr. 72",
            "ZIP": "27243",
            "City": "Harpstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Struckmann",
            "id": "449-000",
            "text": "Struckmann in Lähden (Nr.449-000)",
            "Street": "An der Riehe 15",
            "ZIP": "49774",
            "City": "Lähden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Cappeln e.V.",
            "id": "450-000",
            "text": "Reit- und Fahrverein Cappeln e.V. in Cappeln (Nr.450-000)",
            "Street": "Kösters Weg 3",
            "ZIP": "49692",
            "City": "Cappeln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "R.V Welver",
            "id": "451-000",
            "text": "R.V Welver in Welver (Nr.451-000)",
            "Street": "Werlerstr 32",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Leymann",
            "id": "452-000",
            "text": "Privatstall Leymann in Diepholz (Nr.452-000)",
            "Street": "An der Bahn 39",
            "ZIP": "49356",
            "City": "Diepholz",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Molenberg",
            "id": "453-000",
            "text": "Molenberg in Rhede/Neurhede (Nr.453-000)",
            "Street": "Hauptstraße  49",
            "ZIP": "26899",
            "City": "Rhede/Neurhede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Espelkamp",
            "id": "454-000",
            "text": "Reitverein Espelkamp in Vehlage (Nr.454-000)",
            "Street": "Levenerstraße 4",
            "ZIP": "32339",
            "City": "Vehlage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferdehof Frank Kasperczyk",
            "id": "455-000",
            "text": "Islandpferdehof Frank Kasperczyk in Stuhr (Nr.455-000)",
            "Street": "Kronsbruch 9",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Rath",
            "id": "456-000",
            "text": "Reitstall Rath in Borchen (Nr.456-000)",
            "Street": "Schmalzgrube  1",
            "ZIP": "33178",
            "City": "Borchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rosenberg",
            "id": "457-000",
            "text": "Rosenberg in Freren (Nr.457-000)",
            "Street": "Oststrasse 11",
            "ZIP": "49832",
            "City": "Freren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lübbe",
            "id": "458-000",
            "text": "Privatstall Lübbe in Höltinghausen (Nr.458-000)",
            "Street": "Eschstraße 18",
            "ZIP": "49685",
            "City": "Höltinghausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dehlwisch",
            "id": "459-000",
            "text": "Privatstall Dehlwisch in Bremen (Nr.459-000)",
            "Street": "Waller Heerstr. 61",
            "ZIP": "28217",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Eike Holfeld",
            "id": "460-000",
            "text": "Eike Holfeld in Wiefelstede (Nr.460-000)",
            "Street": "Hoher Kamp 5",
            "ZIP": "26215",
            "City": "Wiefelstede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Meyer zu Lösebeck",
            "id": "461-000",
            "text": "Meyer zu Lösebeck in Melle (Nr.461-000)",
            "Street": "Gerdenerstr. 20",
            "ZIP": "49326",
            "City": "Melle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Damrow",
            "id": "462-000",
            "text": "Privatstall Damrow in Hatten (Nr.462-000)",
            "Street": "Hatter Straße 8",
            "ZIP": "26209",
            "City": "Hatten",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Franzen",
            "id": "463-000",
            "text": "Hof Franzen in Marl (Nr.463-000)",
            "Street": "Linder Weg 1",
            "ZIP": "45770",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Beyer",
            "id": "464-000",
            "text": "Beyer in Melle (Nr.464-000)",
            "Street": "Hünenburgweg 52",
            "ZIP": "49328",
            "City": "Melle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Nehring/Maßmann",
            "id": "465-000",
            "text": "Nehring/Maßmann in Rhauderfehn (Nr.465-000)",
            "Street": "Buurnweg  5",
            "ZIP": "26817",
            "City": "Rhauderfehn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Köhler Dingstede",
            "id": "466-000",
            "text": "Offenstall Köhler Dingstede in Hatten (Nr.466-000)",
            "Street": "Nutteler Str. 1a",
            "ZIP": "26209",
            "City": "Hatten",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wöschenland",
            "id": "467-000",
            "text": "Hof Wöschenland in Hude (Nr.467-000)",
            "Street": "Holler Landstr. 74",
            "ZIP": "27798",
            "City": "Hude",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Lensmann",
            "id": "468-000",
            "text": "Lensmann in Oer-Erkenschwick (Nr.468-000)",
            "Street": "Sinsenerstr. 315",
            "ZIP": "45739",
            "City": "Oer-Erkenschwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Heidehof",
            "id": "469-000",
            "text": "Pensionsstall Heidehof in Wardenburg (Nr.469-000)",
            "Street": "Saarländer Weg 400",
            "ZIP": "26203",
            "City": "Wardenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Keuper",
            "id": "470-000",
            "text": "Reiterhof Keuper in Salzkotten (Nr.470-000)",
            "Street": "Hederbornstraße 11",
            "ZIP": "33154",
            "City": "Salzkotten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Müller-Klein",
            "id": "471-000",
            "text": "Privatstall Müller-Klein in Bruchhausen-Vilsen (Nr.471-000)",
            "Street": "Wöpser Berg 1",
            "ZIP": "27305",
            "City": "Bruchhausen-Vilsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ostholz",
            "id": "472-000",
            "text": "Ostholz in Hamm (Nr.472-000)",
            "Street": "Alter Uentroper Weg 263",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dauth",
            "id": "473-000",
            "text": "Privatstall Dauth in Ganderkesee (Nr.473-000)",
            "Street": "Müllerweg 11",
            "ZIP": "27777",
            "City": "Ganderkesee",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hrudzik",
            "id": "474-000",
            "text": "Privatstall Hrudzik in Mellinghausen (Nr.474-000)",
            "Street": "Hoyanerstrasse 21",
            "ZIP": "27349",
            "City": "Mellinghausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Sahlenbeck",
            "id": "475-000",
            "text": "Stall Sahlenbeck in Haren (Nr.475-000)",
            "Street": "Am Donnerberg 19",
            "ZIP": "49733",
            "City": "Haren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kral",
            "id": "476-000",
            "text": "Privatstall Kral in Groß Ippener (Nr.476-000)",
            "Street": "Dorfstr. 13",
            "ZIP": "27243",
            "City": "Groß Ippener",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hüting",
            "id": "477-000",
            "text": "Hüting in Paderborn (Nr.477-000)",
            "Street": "Fürstenallee 124",
            "ZIP": "33102",
            "City": "Paderborn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Holsterbrink",
            "id": "478-000",
            "text": "Reiterhof Holsterbrink in Dülmen (Nr.478-000)",
            "Street": "Holsterbrink 38",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Helming Drees",
            "id": "479-000",
            "text": "Helming Drees in Engden (Nr.479-000)",
            "Street": "Emsbürener Straße 9",
            "ZIP": "48465",
            "City": "Engden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Alte Heide",
            "id": "480-000",
            "text": "Alte Heide in Vrees (Nr.480-000)",
            "Street": "Alte Heide 2",
            "ZIP": "49757",
            "City": "Vrees",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Obermowe",
            "id": "481-000",
            "text": "Stall Obermowe in Vlotho (Nr.481-000)",
            "Street": "Zum Mergelbruch 1",
            "ZIP": "32602",
            "City": "Vlotho",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kampeter",
            "id": "482-000",
            "text": "Kampeter in Bielefeld (Nr.482-000)",
            "Street": "Buschkampstraße 1",
            "ZIP": "33659",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Howe",
            "id": "483-000",
            "text": "Reitstall Howe in Lengerich (Nr.483-000)",
            "Street": "Strohdamm 10",
            "ZIP": "49525",
            "City": "Lengerich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyhof Deipenbrock",
            "id": "484-000",
            "text": "Ponyhof Deipenbrock in Hamm (Nr.484-000)",
            "Street": "Holsen 9",
            "ZIP": "59075",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dengler",
            "id": "485-000",
            "text": "Dengler in Werne (Nr.485-000)",
            "Street": "Hagenrain 1",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kappel",
            "id": "486-000",
            "text": "Kappel in Rheda-Wiedenbrück (Nr.486-000)",
            "Street": "Emser Landstr 13",
            "ZIP": "33378",
            "City": "Rheda-Wiedenbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wacker",
            "id": "487-000",
            "text": "Wacker in Nordkirchen (Nr.487-000)",
            "Street": "Zum Brotacker 13",
            "ZIP": "59394",
            "City": "Nordkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "H.S. Reitsport",
            "id": "488-000",
            "text": "H.S. Reitsport in Hude (Nr.488-000)",
            "Street": "Knutzenweg 1",
            "ZIP": "27798",
            "City": "Hude",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Josephshof",
            "id": "489-000",
            "text": "Josephshof in Warendorf (Nr.489-000)",
            "Street": "Sassenberger Strasse  43",
            "ZIP": "48231",
            "City": "Warendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hermann",
            "id": "490-000",
            "text": "Privatstall Hermann in Gütersloh (Nr.490-000)",
            "Street": "Münsterlandstr. 110",
            "ZIP": "33334",
            "City": "Gütersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Meyer",
            "id": "491-000",
            "text": "Privatstall Meyer in Rastdorf (Nr.491-000)",
            "Street": "Wiesenweg 1",
            "ZIP": "26901",
            "City": "Rastdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Weetkorn",
            "id": "492-000",
            "text": "Weetkorn in Bad Zwischenahn (Nr.492-000)",
            "Street": "Mastenweg 67",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Sonntag",
            "id": "493-000",
            "text": "Reitsportanlage Sonntag in Jöllenbeck (Nr.493-000)",
            "Street": "Eckumer Straße 168",
            "ZIP": "33739",
            "City": "Jöllenbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Brinkmann",
            "id": "494-000",
            "text": "Reitstall Brinkmann in Lüdinghausen (Nr.494-000)",
            "Street": "Westrup  37",
            "ZIP": "59348",
            "City": "Lüdinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Huster-Klatte",
            "id": "495-000",
            "text": "Huster-Klatte in Lastrup (Nr.495-000)",
            "Street": "Molbergstr. 37",
            "ZIP": "49688",
            "City": "Lastrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Huder Pferdehof",
            "id": "496-000",
            "text": "Huder Pferdehof in Hude (Nr.496-000)",
            "Street": "Am Postweg 4",
            "ZIP": "27798",
            "City": "Hude",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bünde Holsen",
            "id": "497-000",
            "text": "Privatstall Bünde Holsen in Enger (Nr.497-000)",
            "Street": "Rödinghauserstrasse 190",
            "ZIP": "32257",
            "City": "Enger",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Trippel Trappel Hof",
            "id": "498-000",
            "text": "Trippel Trappel Hof in Goldenstedt (Nr.498-000)",
            "Street": "Brombeerhagen 11",
            "ZIP": "49424",
            "City": "Goldenstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportzentrum Brundiers",
            "id": "499-000",
            "text": "Reitsportzentrum Brundiers in Löningen Ehren (Nr.499-000)",
            "Street": "Ehrener Kirchweg 3",
            "ZIP": "49624",
            "City": "Löningen Ehren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Plate ",
            "id": "500-000",
            "text": "Hof Plate  in Syke  (Nr.500-000)",
            "Street": "Bremer Str.  45",
            "ZIP": "28857",
            "City": "Syke ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Vaske-Menke",
            "id": "501-000",
            "text": "Vaske-Menke in Halen  (Nr.501-000)",
            "Street": "Am Dorfplatz 16",
            "ZIP": "49685",
            "City": "Halen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Aktivstall Steinloge",
            "id": "502-000",
            "text": "Aktivstall Steinloge in Großkneten  (Nr.502-000)",
            "Street": "Im Glaner 10",
            "ZIP": "26197",
            "City": "Großkneten ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Uhlmann ",
            "id": "503-000",
            "text": "Hof Uhlmann  in Bad Essen  (Nr.503-000)",
            "Street": "Eichkamp 14",
            "ZIP": "49152",
            "City": "Bad Essen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wilmer in Coesfeld ",
            "id": "504-000",
            "text": "Hof Wilmer in Coesfeld  in Coesfeld  (Nr.504-000)",
            "Street": "Goxel  38",
            "ZIP": "48654",
            "City": "Coesfeld ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Lossau in Rheine ",
            "id": "505-000",
            "text": "Hof Lossau in Rheine  in Rheine  (Nr.505-000)",
            "Street": "Gottkenweg  57",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schwert",
            "id": "506-000",
            "text": "Hof Schwert in Werne (Nr.506-000)",
            "Street": "Südkirchener Straße 61",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schlüter",
            "id": "507-000",
            "text": "Hof Schlüter in Haltern am See (Nr.507-000)",
            "Street": "Hülstener Weg  26",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dörhoff",
            "id": "508-000",
            "text": "Dörhoff in Delbrück (Nr.508-000)",
            "Street": "Haselhorster Straße 57",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kloppenburg",
            "id": "510-000",
            "text": "Kloppenburg in Edewecht (Nr.510-000)",
            "Street": "Parkstraße 18e",
            "ZIP": "26188",
            "City": "Edewecht",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hilgen",
            "id": "511-000",
            "text": "Hilgen in Bad Zwischenahn (Nr.511-000)",
            "Street": "Mittellinie 149",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kochjohann",
            "id": "580-000",
            "text": "Kochjohann in Rietberg-Bokel (Nr.580-000)",
            "Street": "An der Mühle 11",
            "ZIP": "33397",
            "City": "Rietberg-Bokel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Landleben",
            "id": "513-000",
            "text": "Hof Landleben in Wettringen (Nr.513-000)",
            "Street": "Rothenberge  12",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jostwerner",
            "id": "514-000",
            "text": "Jostwerner in Delbrück (Nr.514-000)",
            "Street": "Heierweg 73",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Heinrich Buschmann",
            "id": "515-000",
            "text": "Reitstall Heinrich Buschmann in Stuhr (Nr.515-000)",
            "Street": "Siekstraße  150",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wienöbst",
            "id": "516-000",
            "text": "Privatstall Wienöbst in Essen Oldenburg (Nr.516-000)",
            "Street": "Postdamm 1",
            "ZIP": "49632",
            "City": "Essen Oldenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Berghausen",
            "id": "517-000",
            "text": "Gut Berghausen in Recklinghausen (Nr.517-000)",
            "Street": "Hoher Steinweg 40",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Tapken",
            "id": "518-000",
            "text": "Privatstall Tapken in Bad Zwischenahn (Nr.518-000)",
            "Street": "Ekenermoorstraße 4",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ramnitz",
            "id": "519-000",
            "text": "Privatstall Ramnitz in Rheine  (Nr.519-000)",
            "Street": "Emscherstraße  7",
            "ZIP": "48431",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sudowe",
            "id": "520-000",
            "text": "Sudowe in Wallenhorst (Nr.520-000)",
            "Street": "Haster Berg 2",
            "ZIP": "49134",
            "City": "Wallenhorst",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Ahlemeyer",
            "id": "521-000",
            "text": "Reiterhof Ahlemeyer in Melle (Nr.521-000)",
            "Street": "Brinker Str. 36",
            "ZIP": "49326",
            "City": "Melle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Keimeier",
            "id": "522-000",
            "text": "Privatstall Keimeier in Ennigerloh  (Nr.522-000)",
            "Street": "Zur Bunten Brücke 80",
            "ZIP": "59329",
            "City": "Ennigerloh ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vehlager Zucht-, Reit- und Fahrverein",
            "id": "523-000",
            "text": "Vehlager Zucht-, Reit- und Fahrverein in Vehlage (Nr.523-000)",
            "Street": "Siebenweg ",
            "ZIP": "32339",
            "City": "Vehlage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schäfer",
            "id": "525-000",
            "text": "Schäfer in Delbrück (Nr.525-000)",
            "Street": "Im Brinkort  15",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Wüllner",
            "id": "526-000",
            "text": "Reitstall Wüllner in Bünde (Nr.526-000)",
            "Street": "Lübbecker Str. 306",
            "ZIP": "32257",
            "City": "Bünde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RG Eichengrund Welver",
            "id": "527-000",
            "text": "RG Eichengrund Welver in Welver (Nr.527-000)",
            "Street": "Werler Strasse 34",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Spiegeler",
            "id": "528-000",
            "text": "Spiegeler in Gehrde (Nr.528-000)",
            "Street": "Holdorferstrasse 4",
            "ZIP": "49596",
            "City": "Gehrde",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Bruchwiesen",
            "id": "529-000",
            "text": "Bruchwiesen in Espelkamp (Nr.529-000)",
            "Street": "Bruchwiesen  10",
            "ZIP": "32339",
            "City": "Espelkamp",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zucht- und Pensionsstall Dirks",
            "id": "530-000",
            "text": "Zucht- und Pensionsstall Dirks in Isterberg (Nr.530-000)",
            "Street": "Bentheimer Straße  8",
            "ZIP": "48465",
            "City": "Isterberg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilken",
            "id": "531-000",
            "text": "Wilken in Bockhorn (Nr.531-000)",
            "Street": "Grabhorner Weg ",
            "ZIP": "26345",
            "City": "Bockhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schön",
            "id": "532-000",
            "text": "Schön in Barßel (Nr.532-000)",
            "Street": "Carolinenhofstr.  2",
            "ZIP": "26676",
            "City": "Barßel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hengstebeck",
            "id": "533-000",
            "text": "Hengstebeck in Heiden (Nr.533-000)",
            "Street": "Neuer Weg 6",
            "ZIP": "46359",
            "City": "Heiden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterverein St Georg Saerbeck",
            "id": "534-000",
            "text": "Reiterverein St Georg Saerbeck in Saerbeck (Nr.534-000)",
            "Street": "Ibbenbürener Straße  47",
            "ZIP": "48369",
            "City": "Saerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Börgel",
            "id": "535-000",
            "text": "Privatstall Börgel in Mettingen (Nr.535-000)",
            "Street": "Nieheweg 66",
            "ZIP": "49497",
            "City": "Mettingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Nolte",
            "id": "536-000",
            "text": "Pferdehof Nolte in Vlotho (Nr.536-000)",
            "Street": "Dornberger Heide 39",
            "ZIP": "32602",
            "City": "Vlotho",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ferienhof Junkern-Beel",
            "id": "537-000",
            "text": "Ferienhof Junkern-Beel in Lathen (Nr.537-000)",
            "Street": "Junkern-Beel 1",
            "ZIP": "49762",
            "City": "Lathen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Wehmeyer",
            "id": "538-000",
            "text": "Reitanlage Wehmeyer in Bielefed (Nr.538-000)",
            "Street": "Detmolder Str. 820",
            "ZIP": "33699",
            "City": "Bielefed",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "539000",
            "id": "539-000",
            "text": "539000 in Herten (Nr.539-000)",
            "Street": "Zufahrt Heukamp Backumer Straße 459",
            "ZIP": "45701",
            "City": "Herten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gerdes",
            "id": "540-000",
            "text": "Hof Gerdes in Bad Zwischenahn (Nr.540-000)",
            "Street": "Bloher Landstraße ",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Bottrop",
            "id": "541-000",
            "text": "Reit- und Fahrverein Bottrop in Bottrop (Nr.541-000)",
            "Street": "Beisenstrasse 18",
            "ZIP": "46242",
            "City": "Bottrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Arens",
            "id": "542-000",
            "text": "Arens in Meppen (Nr.542-000)",
            "Street": "Fullenerstr. 45",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Poggemann",
            "id": "543-000",
            "text": "Poggemann in Greven  (Nr.543-000)",
            "Street": "Emsdettener Damm 15",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Katharina Jürgens",
            "id": "544-000",
            "text": "Katharina Jürgens in Hamm (Nr.544-000)",
            "Street": "Lange Reihe 214",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall May-Rosen",
            "id": "545-000",
            "text": "Privatstall May-Rosen in Marl (Nr.545-000)",
            "Street": "Buerer Str.  65",
            "ZIP": "45768",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Haverkamp",
            "id": "546-000",
            "text": "Stall Haverkamp in Haltern am See (Nr.546-000)",
            "Street": "Kuhlenweg 64",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hötkemeier",
            "id": "547-000",
            "text": "Hötkemeier in Porta Westfalica (Nr.547-000)",
            "Street": "Möllbergerstr.  176",
            "ZIP": "32457",
            "City": "Porta Westfalica",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schimmelhof Bremen",
            "id": "548-000",
            "text": "Schimmelhof Bremen in Bremen (Nr.548-000)",
            "Street": "Osterholzer Dorfstraße 95",
            "ZIP": "28307",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Katenkamp",
            "id": "549-000",
            "text": "Reitstall Katenkamp in Stuhr Groß Mackenstedt (Nr.549-000)",
            "Street": "Bremer Weg  52",
            "ZIP": "28816",
            "City": "Stuhr Groß Mackenstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "FreeSpiritNaturalHorses",
            "id": "550-000",
            "text": "FreeSpiritNaturalHorses in Rahden (Nr.550-000)",
            "Street": "Wagenfelder Straße  66",
            "ZIP": "32369",
            "City": "Rahden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sentker",
            "id": "551-000",
            "text": "Sentker in Lemgo (Nr.551-000)",
            "Street": "Meinertsberg 11",
            "ZIP": "32657",
            "City": "Lemgo",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ziegenmichel",
            "id": "552-000",
            "text": "Ziegenmichel in Gelsenkirchen (Nr.552-000)",
            "Street": "Eggemannstr.  51",
            "ZIP": "45883",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reck",
            "id": "553-000",
            "text": "Reck in Jade (Nr.553-000)",
            "Street": "Lisztweg  15",
            "ZIP": "26349",
            "City": "Jade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Nau ",
            "id": "554-000",
            "text": "Nau  in Hopsten  (Nr.554-000)",
            "Street": " Napoleondamm  13",
            "ZIP": "48496",
            "City": "Hopsten ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Farwick ",
            "id": "555-000",
            "text": "Farwick  in Glandorf  (Nr.555-000)",
            "Street": "Auf der Wichelten  2",
            "ZIP": "49219",
            "City": "Glandorf ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferde Witthushof",
            "id": "556-000",
            "text": "Islandpferde Witthushof in Schwanenwede (Nr.556-000)",
            "Street": "Hinnebecker Furth  31",
            "ZIP": "28790",
            "City": "Schwanenwede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Pool ",
            "id": "557-000",
            "text": "Pferdehof Pool  in Lingen  (Nr.557-000)",
            "Street": "Kleekamp  1",
            "ZIP": "49811",
            "City": "Lingen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Held",
            "id": "558-000",
            "text": "Held in Ovelgönne (Nr.558-000)",
            "Street": "Kirchstraße  ",
            "ZIP": "26939",
            "City": "Ovelgönne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ollen River Ranch",
            "id": "559-000",
            "text": "Ollen River Ranch in Ganderkesee (Nr.559-000)",
            "Street": "Zur Ollen 2",
            "ZIP": "27777",
            "City": "Ganderkesee",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hermann",
            "id": "560-000",
            "text": "Hermann in Enger (Nr.560-000)",
            "Street": "Enger ",
            "ZIP": "32130",
            "City": "Enger",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Fitje",
            "id": "561-000",
            "text": "Reitstall Fitje in Bad Zwischenahn (Nr.561-000)",
            "Street": "Goldene Linie 23a",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "An der Engelbrücke",
            "id": "562-000",
            "text": "An der Engelbrücke in Borken (Nr.562-000)",
            "Street": "An der Eggelbrücke 25",
            "ZIP": "46325",
            "City": "Borken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raht",
            "id": "563-000",
            "text": "Raht in Büren (Nr.563-000)",
            "Street": "Sehrweg 1",
            "ZIP": "33142",
            "City": "Büren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beermann",
            "id": "564-000",
            "text": "Privatstall Beermann in Harsewinkel (Nr.564-000)",
            "Street": "Kortenhegge 10a",
            "ZIP": "33428",
            "City": "Harsewinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein St.Hülfe/Heede e.V.",
            "id": "565-000",
            "text": "Reit- und Fahrverein St.Hülfe/Heede e.V. in Diepholz (Nr.565-000)",
            "Street": "Am Turnierplatz 1",
            "ZIP": "49356",
            "City": "Diepholz",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Private Stallgemeinschaft Brinkmann",
            "id": "566-000",
            "text": "Private Stallgemeinschaft Brinkmann in Soest (Nr.566-000)",
            "Street": "Landwehr 12",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Boemer ",
            "id": "567-000",
            "text": "Boemer  in Ohne  (Nr.567-000)",
            "Street": "Feldhoek  6",
            "ZIP": "48465",
            "City": "Ohne ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Arndt ",
            "id": "568-000",
            "text": "Privatstall Arndt  in Landesbergen  (Nr.568-000)",
            "Street": "Birkenweg  7",
            "ZIP": "31628",
            "City": "Landesbergen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Vor dem Brocke Lingen ",
            "id": "569-000",
            "text": "Vor dem Brocke Lingen  in Lingen  (Nr.569-000)",
            "Street": "Hohlweg  2",
            "ZIP": "49811",
            "City": "Lingen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Eiling",
            "id": "570-000",
            "text": "Hof Eiling in Heiden (Nr.570-000)",
            "Street": "Drögen Bokelt 8",
            "ZIP": "46359",
            "City": "Heiden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Scheffler",
            "id": "571-000",
            "text": "Stall Scheffler in Westoverledingen (Nr.571-000)",
            "Street": "Birkenstraße 200",
            "ZIP": "26810",
            "City": "Westoverledingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hellmers Hof",
            "id": "572-000",
            "text": "Hellmers Hof in Brake (Nr.572-000)",
            "Street": "Sinaburger Straße 83",
            "ZIP": "26919",
            "City": "Brake",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Nordendorf",
            "id": "573-000",
            "text": "Hof Nordendorf in Reken  (Nr.573-000)",
            "Street": "Alter Landweg  2",
            "ZIP": "48734",
            "City": "Reken ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Geers ",
            "id": "574-000",
            "text": "Geers  in Goldenstedt  (Nr.574-000)",
            "Street": "Erikaweg  6",
            "ZIP": "49424",
            "City": "Goldenstedt ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilkens",
            "id": "575-000",
            "text": "Wilkens in Bremen (Nr.575-000)",
            "Street": "Waller Straße 300",
            "ZIP": "28719",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Velen",
            "id": "576-000",
            "text": "Reitverein Velen in Velen (Nr.576-000)",
            "Street": "Borkener Damm 12",
            "ZIP": "46342",
            "City": "Velen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Weetkornhof Klostermann",
            "id": "577-000",
            "text": "Weetkornhof Klostermann in Bad Zwischenahn (Nr.577-000)",
            "Street": "Weetkornstrasse  12",
            "ZIP": "46160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Völker",
            "id": "578-000",
            "text": "Pferdepension Völker in Spelle (Nr.578-000)",
            "Street": "Osterwiesenweg  6",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Cohausz",
            "id": "579-000",
            "text": "Stall Cohausz in Telgte (Nr.579-000)",
            "Street": "Voßhaar 15",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Konert",
            "id": "512-000",
            "text": "Konert in Wadersloh (Nr.512-000)",
            "Street": "Bredenweg 9",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RC St. Georg zu Bremen e.V.",
            "id": "581-000",
            "text": "RC St. Georg zu Bremen e.V. in Bremen (Nr.581-000)",
            "Street": "Wetterungsweg 1",
            "ZIP": "28359",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule Isadora Siekmann",
            "id": "582-000",
            "text": "Reitschule Isadora Siekmann in Detmold (Nr.582-000)",
            "Street": "Unternienhagen 21",
            "ZIP": "32758",
            "City": "Detmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Ochtrup",
            "id": "583-000",
            "text": "Raiffeisen Ochtrup in Ochtrup (öffentlich) (Nr.583-000)",
            "Street": "Gronauer Str. 52",
            "ZIP": "48607",
            "City": "Ochtrup (öffentlich)",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Gausepohl",
            "id": "584-000",
            "text": "Privatstall Gausepohl in Versmold (Nr.584-000)",
            "Street": "Stränger Str. 11",
            "ZIP": "33775",
            "City": "Versmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jana Dreckmann",
            "id": "585-000",
            "text": "Jana Dreckmann in Ostbevern (Nr.585-000)",
            "Street": "Ravel-Weg 6",
            "ZIP": "48346",
            "City": "Ostbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Woestmann",
            "id": "586-000",
            "text": "Privatstall Woestmann in Steinfurt (Nr.586-000)",
            "Street": "Hollich 46",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Horseman Ranch",
            "id": "587-000",
            "text": "Horseman Ranch in Bad Oeynhausen (Nr.587-000)",
            "Street": "Holzmark 35",
            "ZIP": "32549",
            "City": "Bad Oeynhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall Jenderzi",
            "id": "588-000",
            "text": "Privater Offenstall Jenderzi in Friesoythe (Nr.588-000)",
            "Street": "Röpkendamm 4",
            "ZIP": "26169",
            "City": "Friesoythe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schulze Schleithoff",
            "id": "589-000",
            "text": "Hof Schulze Schleithoff in Havixbeck (Nr.589-000)",
            "Street": "Herkentrup 4",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Averbeck",
            "id": "590-000",
            "text": "Averbeck in Ochtrup (Nr.590-000)",
            "Street": "Schweringhook 3",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Braun",
            "id": "591-000",
            "text": "Privatstall Braun in Schwanewede (Nr.591-000)",
            "Street": "Am Wald  1a",
            "ZIP": "28790",
            "City": "Schwanewede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Zurhove",
            "id": "592-000",
            "text": "Zurhove in Senden (Nr.592-000)",
            "Street": "Dorfbauerschaft 27",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sandhaus",
            "id": "594-000",
            "text": "Sandhaus in Menslage (Nr.594-000)",
            "Street": "Hahlener Straße 7",
            "ZIP": "49637",
            "City": "Menslage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Corina Carius",
            "id": "597-000",
            "text": "Corina Carius in Lippetal (Nr.597-000)",
            "Street": "Breite Str. 24",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Camping Simon",
            "id": "598-000",
            "text": "Camping Simon in Uelsen (Nr.598-000)",
            "Street": "Hesinger Str.  13",
            "ZIP": "49843",
            "City": "Uelsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Vethacke",
            "id": "599-000",
            "text": "Vethacke in Herne (Nr.599-000)",
            "Street": "Holsterhauser Straße  323",
            "ZIP": "44625",
            "City": "Herne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Heiner Kerkhof",
            "id": "600-000",
            "text": "Offenstall Heiner Kerkhof in Selm-Bork (Nr.600-000)",
            "Street": "Zum Wegebild 5",
            "ZIP": "59379",
            "City": "Selm-Bork",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Katrin Böker",
            "id": "601-000",
            "text": "Privatstall Katrin Böker in Willebadessen (Nr.601-000)",
            "Street": "Von- Ike- Str. 13",
            "ZIP": "34439",
            "City": "Willebadessen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bockschatz",
            "id": "602-000",
            "text": "Privatstall Bockschatz in Bielefeld (Nr.602-000)",
            "Street": "Lübbecker Str. 361",
            "ZIP": "33739",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Ochtrup e.V.",
            "id": "603-000",
            "text": "Reit- und Fahrverein Ochtrup e.V. in Ochtrup (Nr.603-000)",
            "Street": "Kreuzweg  77",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterverein Bayer Leverkusen",
            "id": "604-000",
            "text": "Reiterverein Bayer Leverkusen in Köln (Nr.604-000)",
            "Street": "Otto-Bayer-Str 1",
            "ZIP": "51061",
            "City": "Köln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Beelmann Stavern",
            "id": "605-000",
            "text": "Beelmann Stavern in Stavern (Nr.605-000)",
            "Street": "Hinterstr 7",
            "ZIP": "49777",
            "City": "Stavern",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule Füchtmann",
            "id": "606-000",
            "text": "Reitschule Füchtmann in Gronau (Nr.606-000)",
            "Street": "Gerdingseite 9",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Bianca",
            "id": "607-000",
            "text": "Reitstall Bianca in Büren (Nr.607-000)",
            "Street": "Niederburgstraße 1",
            "ZIP": "33142",
            "City": "Büren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Welslau",
            "id": "608-000",
            "text": "Reitstall Welslau in Bad Salzuflen (Nr.608-000)",
            "Street": "Im Wölkental /",
            "ZIP": "32107",
            "City": "Bad Salzuflen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Gräve",
            "id": "609-000",
            "text": "Reitanlage Gräve in Hamm (Nr.609-000)",
            "Street": "Ostwennemarstraße 125",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Wewel",
            "id": "610-000",
            "text": "Gut Wewel in Senden (Nr.610-000)",
            "Street": "Gettrup ",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Böckenholt",
            "id": "611-000",
            "text": "Böckenholt in Telgte (Nr.611-000)",
            "Street": "Kiebitzpohl 18",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bücker",
            "id": "612-000",
            "text": "Bücker in Emsdetten (Nr.612-000)",
            "Street": "Austum 36",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Geisthoff",
            "id": "613-000",
            "text": "Geisthoff in Ahlen (Nr.613-000)",
            "Street": "Westhusener Weg  5",
            "ZIP": "59229",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fam. Göcke, Eichenhof",
            "id": "614-000",
            "text": "Fam. Göcke, Eichenhof in Recke (Nr.614-000)",
            "Street": "Twenhusen 33",
            "ZIP": "49509",
            "City": "Recke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Bavendamm",
            "id": "615-000",
            "text": "Hof Bavendamm in Bremen (Nr.615-000)",
            "Street": "Wallerstraße  300",
            "ZIP": "28719",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Burghof",
            "id": "616-000",
            "text": "Burghof in Recklinghausen (Nr.616-000)",
            "Street": "Burgstr. 21",
            "ZIP": "45659",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Berg",
            "id": "617-000",
            "text": "Reitanlage Berg in Hiddenhausen (Nr.617-000)",
            "Street": "Lippinghauser Straße 101",
            "ZIP": "32120",
            "City": "Hiddenhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Vorsthove",
            "id": "618-000",
            "text": "Privatstall Vorsthove in Ibbenbüren (Nr.618-000)",
            "Street": "Fahlbachtal 12",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Temmen",
            "id": "619-000",
            "text": "Stall Temmen in Rheine  (Nr.619-000)",
            "Street": "Hohe Alle 101",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "CTH Sporthorses",
            "id": "620-000",
            "text": "CTH Sporthorses in Emsbüren (Nr.620-000)",
            "Street": "Moorlage 9",
            "ZIP": "48488",
            "City": "Emsbüren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Assel",
            "id": "621-000",
            "text": "Privatstall Assel in Bissendorf (Nr.621-000)",
            "Street": "Werscher Straße 2",
            "ZIP": "49143",
            "City": "Bissendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Jäger",
            "id": "622-000",
            "text": "Privatstall Jäger in Dülmen (Nr.622-000)",
            "Street": "Dernekamp 24a",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kollmer",
            "id": "623-000",
            "text": "Kollmer in Lastrup (Nr.623-000)",
            "Street": "Blaubusch 5",
            "ZIP": "49688",
            "City": "Lastrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Immer",
            "id": "624-000",
            "text": "Immer in Bremen (Nr.624-000)",
            "Street": "Stromer Landstraße 38L",
            "ZIP": "28197",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage an der Stever",
            "id": "625-000",
            "text": "Reitanlage an der Stever in Senden (Nr.625-000)",
            "Street": "Wierling 3b",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ulmenhof Albers",
            "id": "626-000",
            "text": "Ulmenhof Albers in Meppen (Nr.626-000)",
            "Street": "Ulmenhof 1",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Weilichmann",
            "id": "627-000",
            "text": "Weilichmann in Havixbeck (Nr.627-000)",
            "Street": "Herkentrup 7",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Döring",
            "id": "628-000",
            "text": "Reitanlage Döring in Espelkamp (Nr.628-000)",
            "Street": "Siebenweg 1",
            "ZIP": "32339",
            "City": "Espelkamp",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Achterhörner Reitstall",
            "id": "629-000",
            "text": "Achterhörner Reitstall in Friesoythe (Nr.629-000)",
            "Street": "Feddenbergsweg 2",
            "ZIP": "26169",
            "City": "Friesoythe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sportpferde Piotrowski",
            "id": "630-000",
            "text": "Sportpferde Piotrowski in Senden (Nr.630-000)",
            "Street": "Brock  8",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Höfener",
            "id": "631-000",
            "text": "Privatstall Höfener in Sendenhorst (Nr.631-000)",
            "Street": "Ahrenhorst 33",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Denker",
            "id": "632-000",
            "text": "Privatstall Denker in Wettringen (Nr.632-000)",
            "Street": "Vollenbrok 22",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ostermann",
            "id": "633-000",
            "text": "Privatstall Ostermann in Voltlage (Nr.633-000)",
            "Street": "Knappstr. 8",
            "ZIP": "49599",
            "City": "Voltlage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schmiemann",
            "id": "634-000",
            "text": "Schmiemann in Ibbenbüren (Nr.634-000)",
            "Street": "Brochterbecker Str. 8",
            "ZIP": "49477",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Steinfurt-Dumte e.V.",
            "id": "635-000",
            "text": "Reit- und Fahrverein Steinfurt-Dumte e.V. in Steinfurt (Nr.635-000)",
            "Street": "Dumte 20",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Molkembur",
            "id": "636-000",
            "text": "Reitstall Molkembur in Münster (Nr.636-000)",
            "Street": "Kasewinkel 94",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Fischer",
            "id": "637-000",
            "text": "Stall Fischer in Vechta (Nr.637-000)",
            "Street": "Holtruper Straße 36",
            "ZIP": "49377",
            "City": "Vechta",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Blank",
            "id": "638-000",
            "text": "Privathof Blank in Achim (Nr.638-000)",
            "Street": "Roedenbeckstraße 141d",
            "ZIP": "28832",
            "City": "Achim",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Robert",
            "id": "639-000",
            "text": "Robert in Vreden (Nr.639-000)",
            "Street": "Köckelwick 57",
            "ZIP": "48691",
            "City": "Vreden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Borggreve Dressage",
            "id": "640-000",
            "text": "Borggreve Dressage in Ahaus (Nr.640-000)",
            "Street": "Ammeln 99a",
            "ZIP": "48683",
            "City": "Ahaus",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Spieker",
            "id": "641-000",
            "text": "Spieker in Greven  (Nr.641-000)",
            "Street": "Ostbevenerstr. 64",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schlüter",
            "id": "642-000",
            "text": "Privatstall Schlüter in Stadtlohn (Nr.642-000)",
            "Street": "Boschstraße 30",
            "ZIP": "48703",
            "City": "Stadtlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Tenberge",
            "id": "643-000",
            "text": "Hof Tenberge in Lüdinghausen (Nr.643-000)",
            "Street": "Tetekum 9",
            "ZIP": "59348",
            "City": "Lüdinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hof Ebel",
            "id": "644-000",
            "text": "Reitanlage Hof Ebel in Arnsberg (Nr.644-000)",
            "Street": "Neheimer Str. 108",
            "ZIP": "59757",
            "City": "Arnsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Voß",
            "id": "645-000",
            "text": "Privatstall Voß in Rinkerode (Nr.645-000)",
            "Street": "Eickenbeck 25",
            "ZIP": "48317",
            "City": "Rinkerode",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zrg St.Sebastian Amelsbüren",
            "id": "646-000",
            "text": "Zrg St.Sebastian Amelsbüren in Münster (Nr.646-000)",
            "Street": "Von Renesseweg 20",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Recklinghausen",
            "id": "648-000",
            "text": "Loesdau Recklinghausen in Recklinghausen (Nr.648-000)",
            "Street": "Schmalkalder Str. 8",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Mülheim a.d. Ruhr",
            "id": "649-000",
            "text": "Loesdau Mülheim a.d. Ruhr in Mülheim an der Ruhr (Nr.649-000)",
            "Street": "Duisburger Str. 399",
            "ZIP": "45478",
            "City": "Mülheim an der Ruhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdestall Haarmann",
            "id": "650-000",
            "text": "Pferdestall Haarmann in Ahaus (Nr.650-000)",
            "Street": "Oberortwick  27a",
            "ZIP": "48683",
            "City": "Ahaus",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Hartz",
            "id": "651-000",
            "text": "Reitstall Hartz in Nottuln (Nr.651-000)",
            "Street": "Stevern 52",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hellenkamp",
            "id": "652-000",
            "text": "Hellenkamp in Ahaus (Nr.652-000)",
            "Street": "Ammeln  91",
            "ZIP": "48683",
            "City": "Ahaus",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stammkötter",
            "id": "653-000",
            "text": "Stammkötter in Steinhagen (Nr.653-000)",
            "Street": "Sandforther Straße 64",
            "ZIP": "33803",
            "City": "Steinhagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meine kleine Farm",
            "id": "654-000",
            "text": "Meine kleine Farm in Ostercappeln (Nr.654-000)",
            "Street": "Bremer Str.  42a",
            "ZIP": "49179",
            "City": "Ostercappeln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Mau",
            "id": "656-000",
            "text": "Mau in Sendenhorst (Nr.656-000)",
            "Street": "Sunger 27",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Geisterholz",
            "id": "657-000",
            "text": "RV Geisterholz in Oelde (Nr.657-000)",
            "Street": "Robert-Schumann-Ring  25",
            "ZIP": "59302",
            "City": "Oelde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rosenhof",
            "id": "658-000",
            "text": "Rosenhof in Horn Bad-Meinberg (Nr.658-000)",
            "Street": "Zum Rosenbusch 102",
            "ZIP": "32805",
            "City": "Horn Bad-Meinberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Knickenberg",
            "id": "659-000",
            "text": "Hof Knickenberg in Hamm (Nr.659-000)",
            "Street": "Im Nachtigallental 6",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schuckenberg",
            "id": "661-000",
            "text": "Hof Schuckenberg in Milte (Nr.661-000)",
            "Street": "Beverstrang 31a",
            "ZIP": "48231",
            "City": "Milte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Haak",
            "id": "662-000",
            "text": "Privatstall Haak in Borken (Nr.662-000)",
            "Street": "Neumühlenallee 114",
            "ZIP": "46325",
            "City": "Borken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kohlmannhof",
            "id": "663-000",
            "text": "Kohlmannhof in Westerkappeln (Nr.663-000)",
            "Street": "Kuhlmannstraße 5",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wischermann",
            "id": "664-000",
            "text": "Privatstall Wischermann in Rosendahl (Nr.664-000)",
            "Street": "Brockbauerschaft 30",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Albers Hof",
            "id": "665-000",
            "text": "Albers Hof in Oberlangen (Nr.665-000)",
            "Street": "Sandstraße 1",
            "ZIP": "49779",
            "City": "Oberlangen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Verstegge",
            "id": "666-000",
            "text": "Verstegge in Gronau (Nr.666-000)",
            "Street": "Windmühlenweg 1",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Döme",
            "id": "667-000",
            "text": "Privatstall Döme in Münster (Nr.667-000)",
            "Street": "Einigweg 11",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gövert",
            "id": "668-000",
            "text": "Hof Gövert in Havixbeck (Nr.668-000)",
            "Street": "Poppenbeck 17",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lödding",
            "id": "669-000",
            "text": "Lödding in Senden (Nr.669-000)",
            "Street": "Kreuzbauerschaft 6",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Göcking",
            "id": "670-000",
            "text": "Göcking in Rheine  (Nr.670-000)",
            "Street": "Osnabrücker Straße ",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Telljohann",
            "id": "671-000",
            "text": "Telljohann in Lienen (Nr.671-000)",
            "Street": "Ellerhooksweg 6",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Margaretenhof",
            "id": "672-000",
            "text": "Margaretenhof in Neuenkirchen (Nr.672-000)",
            "Street": "Rote Erde 12",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Engeler",
            "id": "674-000",
            "text": "Reiterhof Engeler in Saerbeck (Nr.674-000)",
            "Street": "Middendorf 31",
            "ZIP": "48369",
            "City": "Saerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lackenberg",
            "id": "675-000",
            "text": "Lackenberg in Drensteinfurt (Nr.675-000)",
            "Street": "Eickenbeck 33",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Familie Espelkott",
            "id": "676-000",
            "text": "Familie Espelkott in Rosendahl (Nr.676-000)",
            "Street": "Helenenweg 4",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Schierbaum",
            "id": "677-000",
            "text": "Reitstall Schierbaum in Osnabrück (Nr.677-000)",
            "Street": "Schierbaumsfeld ",
            "ZIP": "49086",
            "City": "Osnabrück",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Strotmeier",
            "id": "678-000",
            "text": "Privatstall Strotmeier in Ibbenbüren (Nr.678-000)",
            "Street": "Teutohang 83",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyhof Benning",
            "id": "679-000",
            "text": "Ponyhof Benning in Emsdetten (Nr.679-000)",
            "Street": "Up'mMersk 1",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bringemeier",
            "id": "680-000",
            "text": "Privatstall Bringemeier in Steinfurt (Nr.680-000)",
            "Street": "Emsdettener Straße 73",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pagliarini",
            "id": "681-000",
            "text": "Pagliarini in Havixbeck (Nr.681-000)",
            "Street": "Walingen 11",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dr. Ute Vaske",
            "id": "682-000",
            "text": "Dr. Ute Vaske in Lastrup (Nr.682-000)",
            "Street": "Bei der Groberei 4",
            "ZIP": "49688",
            "City": "Lastrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Jörns bei Zimmerei Stärke",
            "id": "683-000",
            "text": "Jörns bei Zimmerei Stärke in Riede (Nr.683-000)",
            "Street": "Wegstätte 25",
            "ZIP": "27339",
            "City": "Riede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension zu Stoltenberg",
            "id": "684-000",
            "text": "Pferdepension zu Stoltenberg in Lüdinghausen-Seppenrade (Nr.684-000)",
            "Street": "Leversum 38",
            "ZIP": "59348",
            "City": "Lüdinghausen-Seppenrade",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Böckmann",
            "id": "685-000",
            "text": "Böckmann in Ibbenbüren (Nr.685-000)",
            "Street": "Riesenbeckerstr. 45",
            "ZIP": "49477",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Sylvia Werft",
            "id": "686-000",
            "text": "Reitanlage Sylvia Werft in Bad Laer (Nr.686-000)",
            "Street": "Hagestrasse 5",
            "ZIP": "49196",
            "City": "Bad Laer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gilhaus",
            "id": "687-000",
            "text": "Gilhaus in Schermbeck (Nr.687-000)",
            "Street": "Vor der Burg 1",
            "ZIP": "46514",
            "City": "Schermbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Müller",
            "id": "688-000",
            "text": "Privatstall Müller in Werl (Nr.688-000)",
            "Street": "Am krummen Rücken 24",
            "ZIP": "59457",
            "City": "Werl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mareike Sanders",
            "id": "689-000",
            "text": "Mareike Sanders in Westbevern (Nr.689-000)",
            "Street": "Voßhaar 13",
            "ZIP": "48291",
            "City": "Westbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schulz",
            "id": "690-000",
            "text": "Privatstall Schulz in Westerkappeln (Nr.690-000)",
            "Street": "Telgte 12",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rusinek",
            "id": "691-000",
            "text": "Rusinek in Lengerich (Nr.691-000)",
            "Street": "Am Steinernen Kreuz 38",
            "ZIP": "49525",
            "City": "Lengerich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Starwood Stables (Hof Brumley)",
            "id": "692-000",
            "text": "Starwood Stables (Hof Brumley) in Emsdetten (Nr.692-000)",
            "Street": "Nordwalderstr. 197",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Leichhauer",
            "id": "693-000",
            "text": "Stall Leichhauer in Oer-Erkenschwick (Nr.693-000)",
            "Street": "Johannesstr. 248",
            "ZIP": "45739",
            "City": "Oer-Erkenschwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Matthaiwe",
            "id": "694-000",
            "text": "Matthaiwe in Xanten (Nr.694-000)",
            "Street": "Heesweg 25",
            "ZIP": "46509",
            "City": "Xanten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Südlohn",
            "id": "695-000",
            "text": "Reitverein Südlohn in Südlohn (Nr.695-000)",
            "Street": "Pingelerhook 26",
            "ZIP": "46354",
            "City": "Südlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wessling",
            "id": "696-000",
            "text": "Wessling in Ochtrup (Nr.696-000)",
            "Street": "Kreuzweg 77",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Marx",
            "id": "697-000",
            "text": "Stall Marx in Belm (Nr.697-000)",
            "Street": "An der Haarener Grenze 1",
            "ZIP": "49191",
            "City": "Belm",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Helleforth",
            "id": "698-000",
            "text": "RV Helleforth in Schloß Holte-Stukenbrock (Nr.698-000)",
            "Street": "Kaunitzer Str. 174",
            "ZIP": "33758",
            "City": "Schloß Holte-Stukenbrock",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Pothmann",
            "id": "699-000",
            "text": "Privatstall Pothmann in Metelen (Nr.699-000)",
            "Street": "Samberg 56",
            "ZIP": "48629",
            "City": "Metelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Köttermann",
            "id": "700-000",
            "text": "Privatstall Köttermann in Ahlen (Nr.700-000)",
            "Street": "Walstedderstraße 251",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Riesenbeck",
            "id": "701-000",
            "text": "RV Riesenbeck in Hörstel-Riesenbeck (Nr.701-000)",
            "Street": "Surenburg 20",
            "ZIP": "48477",
            "City": "Hörstel-Riesenbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ernsting",
            "id": "702-000",
            "text": "Privatstall Ernsting in Coesfeld  (Nr.702-000)",
            "Street": "Gaupel 32",
            "ZIP": "48653",
            "City": "Coesfeld ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulte-Schedding",
            "id": "703-000",
            "text": "Schulte-Schedding in Herten (Nr.703-000)",
            "Street": "Kampstr. 9",
            "ZIP": "45701",
            "City": "Herten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Binder",
            "id": "704-000",
            "text": "Reitstall Binder in Greven  (Nr.704-000)",
            "Street": "Saerbeckerstr. 144",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Wehdem-Oppendorf",
            "id": "705-000",
            "text": "RV Wehdem-Oppendorf in Stemwede (Nr.705-000)",
            "Street": "Am Birkenhain 4",
            "ZIP": "32351",
            "City": "Stemwede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rekers",
            "id": "706-000",
            "text": "Privatstall Rekers in Emsbüren (Nr.706-000)",
            "Street": "Zur Venhauser Schleuse  2",
            "ZIP": "48488",
            "City": "Emsbüren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "ebe Pferdegesundheitszentrum Münster GmbH",
            "id": "707-000",
            "text": "ebe Pferdegesundheitszentrum Münster GmbH in Münster (Nr.707-000)",
            "Street": "Tweehues 17",
            "ZIP": "48163",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beuker",
            "id": "708-000",
            "text": "Privatstall Beuker in Steinfurt (Nr.708-000)",
            "Street": "Hollich 120",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Keeve-Gerling",
            "id": "709-000",
            "text": "Privatstall Keeve-Gerling in Recke (Nr.709-000)",
            "Street": "Venneweg 13",
            "ZIP": "49509",
            "City": "Recke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rabe",
            "id": "710-000",
            "text": "Privatstall Rabe in Bohmte (Nr.710-000)",
            "Street": "Meyerhöfener Straße 5",
            "ZIP": "49163",
            "City": "Bohmte",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferde Oberkarthausen",
            "id": "711-000",
            "text": "Islandpferde Oberkarthausen in Radevormwald (Nr.711-000)",
            "Street": "Oberkarthausen 1",
            "ZIP": "42499",
            "City": "Radevormwald",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Boltrayhof",
            "id": "712-000",
            "text": "Boltrayhof in Voerde (Nr.712-000)",
            "Street": "Rheinstraße 183",
            "ZIP": "46562",
            "City": "Voerde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zumloh",
            "id": "713-000",
            "text": "Zumloh in Ahlen (Nr.713-000)",
            "Street": "In der Groeft 33",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hufbeschlag Hötte",
            "id": "714-000",
            "text": "Hufbeschlag Hötte in Ahlen (Nr.714-000)",
            "Street": "Westhusenerweg 1",
            "ZIP": "59229",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Pegasus",
            "id": "715-000",
            "text": "Reitstall Pegasus in Wülfrath (Nr.715-000)",
            "Street": "Nord-Erbach 25",
            "ZIP": "42489",
            "City": "Wülfrath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Korth",
            "id": "716-000",
            "text": "Korth in Gummersbach (Nr.716-000)",
            "Street": "Kerbelweg  15",
            "ZIP": "51647",
            "City": "Gummersbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Gessmann",
            "id": "717-000",
            "text": "Reitanlage Gessmann in Münster (Nr.717-000)",
            "Street": "Hunnebeckweg 97",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Pölling ",
            "id": "718-000",
            "text": "Stall Pölling  in Coesfeld  (Nr.718-000)",
            "Street": "Stevede  60",
            "ZIP": "48653",
            "City": "Coesfeld ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Haltergemeinschaft Dölling ",
            "id": "719-000",
            "text": "Haltergemeinschaft Dölling  in Rheine  (Nr.719-000)",
            "Street": "Zur Vogelstange  5",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Henscheshof ",
            "id": "720-000",
            "text": "Gut Henscheshof  in Erkrath  (Nr.720-000)",
            "Street": "Hubbelrather Weg 19",
            "ZIP": "40699",
            "City": "Erkrath ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Benger Hof ",
            "id": "721-000",
            "text": "Benger Hof  in Duisburg  (Nr.721-000)",
            "Street": "An der Bastei 118",
            "ZIP": "47529",
            "City": "Duisburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hüsing ",
            "id": "722-000",
            "text": "Hüsing  in Emsbüren  (Nr.722-000)",
            "Street": "Emsstraße  ",
            "ZIP": "48488",
            "City": "Emsbüren ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Te Heesen ",
            "id": "723-000",
            "text": "Te Heesen  in Voerde (Nr.723-000)",
            "Street": "Hindenburgstraße  160",
            "ZIP": "46562",
            "City": "Voerde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Centura Reitakademie ",
            "id": "724-000",
            "text": "Centura Reitakademie  in Schwanenwede (Nr.724-000)",
            "Street": "Hamfährer Weg  19",
            "ZIP": "28790",
            "City": "Schwanenwede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Nienberge",
            "id": "725-000",
            "text": "Reitverein Nienberge in Münster (Nr.725-000)",
            "Street": "Beerwiede 160A",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "DIPO - Hof Thier zum Berge",
            "id": "726-000",
            "text": "DIPO - Hof Thier zum Berge in Dülmen (Nr.726-000)",
            "Street": "Mitwick 32",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wessendorf",
            "id": "727-000",
            "text": "Wessendorf in Dülmen (Nr.727-000)",
            "Street": "Börnste  36",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kamps",
            "id": "729-000",
            "text": "Kamps in Bönen (Nr.729-000)",
            "Street": "Dorfstraße 11",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Tenbrok",
            "id": "730-000",
            "text": "Tenbrok in Bocholt (Nr.730-000)",
            "Street": "Franzstr 76",
            "ZIP": "46395",
            "City": "Bocholt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schettler",
            "id": "731-000",
            "text": "Hof Schettler in Haltern am See (Nr.731-000)",
            "Street": "Dorstener Str. 880",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Nordhues",
            "id": "732-000",
            "text": "Stall Nordhues in Saerbeck (Nr.732-000)",
            "Street": "Südhoek 15",
            "ZIP": "48369",
            "City": "Saerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Deipenwisch",
            "id": "733-000",
            "text": "Stall Deipenwisch in Everswinkel (Nr.733-000)",
            "Street": "Holling 17",
            "ZIP": "48351",
            "City": "Everswinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Elling",
            "id": "737-000",
            "text": "Reitstall Elling in Salzbergen (Nr.737-000)",
            "Street": "Devestr. 2",
            "ZIP": "48499",
            "City": "Salzbergen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Kottig",
            "id": "738-000",
            "text": "Reiterhof Kottig in Gronau-Epe (Nr.738-000)",
            "Street": "Gerdingseite 4",
            "ZIP": "48599",
            "City": "Gronau-Epe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meyer ",
            "id": "740-000",
            "text": "Meyer  in Saterland  (Nr.740-000)",
            "Street": "An der Wieke  7",
            "ZIP": "26683",
            "City": "Saterland ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raude Sudhoff ",
            "id": "741-000",
            "text": "Raude Sudhoff  in Osnabrück (Nr.741-000)",
            "Street": "DarumerStr.  ",
            "ZIP": "49090",
            "City": "Osnabrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meier ",
            "id": "742-000",
            "text": "Meier  in Vloth  (Nr.742-000)",
            "Street": "Im Nienhagen  3",
            "ZIP": "32602",
            "City": "Vloth ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Erlemeyer ",
            "id": "743-000",
            "text": "Erlemeyer  in Warendorf  (Nr.743-000)",
            "Street": "Westbezirk  82",
            "ZIP": "48231",
            "City": "Warendorf ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Minnerup ",
            "id": "744-000",
            "text": "Minnerup  in Ibbenbüren (Nr.744-000)",
            "Street": "Brumleyweg  8",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Figge ",
            "id": "745-000",
            "text": "Figge  in Welver  (Nr.745-000)",
            "Street": "Zur Binnekoh  13",
            "ZIP": "59514",
            "City": "Welver ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Brinkbäumer",
            "id": "746-000",
            "text": "Privatstall Brinkbäumer in Soest (Nr.746-000)",
            "Street": "Eichenweg 8b",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Döring Quarter Horses ",
            "id": "747-000",
            "text": "Döring Quarter Horses  in Marl  (Nr.747-000)",
            "Street": "Herner Weg  46",
            "ZIP": "45772",
            "City": "Marl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Weitkamp",
            "id": "748-000",
            "text": "Weitkamp in Billerbeck  (Nr.748-000)",
            "Street": "Hamern  36",
            "ZIP": "48727",
            "City": "Billerbeck ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hovestadt ",
            "id": "749-000",
            "text": "Hovestadt  in Warendorf  (Nr.749-000)",
            "Street": "Dr.-Rau-Allee 82",
            "ZIP": "48231",
            "City": "Warendorf ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Red Blaze Ranch",
            "id": "750-000",
            "text": "Red Blaze Ranch in Ascheberg (Nr.750-000)",
            "Street": "Davensbergerstraße 15",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Laurenz",
            "id": "751-000",
            "text": "Reitstall Laurenz in Gronau-Epe (Nr.751-000)",
            "Street": "Am Fürstenbusch 20",
            "ZIP": "48599",
            "City": "Gronau-Epe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RSC Norden Nordsee",
            "id": "752-000",
            "text": "RSC Norden Nordsee in Norden (Nr.752-000)",
            "Street": "Schwarzer Weg 32",
            "ZIP": "26506",
            "City": "Norden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Dornberg",
            "id": "753-000",
            "text": "Reit- und Fahrverein Dornberg in Bielefeld (Nr.753-000)",
            "Street": "Am Krebsbach 19",
            "ZIP": "33619",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Janning",
            "id": "754-000",
            "text": "Hof Janning in Rheine  (Nr.754-000)",
            "Street": "Brookstr. 45",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hackländer",
            "id": "755-000",
            "text": "Privatstall Hackländer in Rüthen (Nr.755-000)",
            "Street": "Königstraße 17",
            "ZIP": "59602",
            "City": "Rüthen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ratz",
            "id": "756-000",
            "text": "Privatstall Ratz in Beelen  (Nr.756-000)",
            "Street": "Pohlstadt 10",
            "ZIP": "48361",
            "City": "Beelen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Münsterland Stables & Curly Horses",
            "id": "757-000",
            "text": "Münsterland Stables & Curly Horses in Rosendahl (Nr.757-000)",
            "Street": "Midlicher Straße 7",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Drei Eichen ",
            "id": "758-000",
            "text": "Pferdepension Drei Eichen  in Welver  (Nr.758-000)",
            "Street": "Bergstrasser Weg  3",
            "ZIP": "59514",
            "City": "Welver ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Holling ",
            "id": "759-000",
            "text": "Holling  in Greven  (Nr.759-000)",
            "Street": "Gronenweg  1a ",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Feldmann ",
            "id": "760-000",
            "text": "Schulze Feldmann  in Hörstel-Riesenbeck (Nr.760-000)",
            "Street": "Pastorenkamp 20",
            "ZIP": "48477",
            "City": "Hörstel-Riesenbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Heessen ",
            "id": "761-000",
            "text": "RV Heessen  in Hamm  (Nr.761-000)",
            "Street": "Dasbeck  6",
            "ZIP": "59073",
            "City": "Hamm ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wickensack ",
            "id": "762-000",
            "text": "Wickensack  in Ostbevern  (Nr.762-000)",
            "Street": "Brock  29",
            "ZIP": "48346",
            "City": "Ostbevern ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wesling ",
            "id": "763-000",
            "text": "Wesling  in Ostbevern  (Nr.763-000)",
            "Street": "Deppengau  30",
            "ZIP": "48346",
            "City": "Ostbevern ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Becker",
            "id": "764-000",
            "text": "Hof Becker in Hamm (Nr.764-000)",
            "Street": "Lippestr 130",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Grünwald ",
            "id": "765-000",
            "text": "Hof Grünwald  in Tecklenburg  (Nr.765-000)",
            "Street": "Holthausen  25",
            "ZIP": "49545",
            "City": "Tecklenburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Stratmann",
            "id": "766-000",
            "text": "Hof Stratmann in Senden (Nr.766-000)",
            "Street": "Dorfbauerschaft 26",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Schulte-Walter",
            "id": "767-000",
            "text": "Offenstall Schulte-Walter in Münster (Nr.767-000)",
            "Street": "Wittoverstiege 68",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Nadine Nölle",
            "id": "768-000",
            "text": "Nadine Nölle in Hamm (Nr.768-000)",
            "Street": "Wambelner Berg 3",
            "ZIP": "59069",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wirth",
            "id": "769-000",
            "text": "Privatstall Wirth in Gütersloh (Nr.769-000)",
            "Street": "Erikenstraße ",
            "ZIP": "33335",
            "City": "Gütersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "EquiFit",
            "id": "770-000",
            "text": "EquiFit in Hüven (Nr.770-000)",
            "Street": "Berßener Str. 99",
            "ZIP": "49751",
            "City": "Hüven",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lüken",
            "id": "771-000",
            "text": "Privatstall Lüken in Rastdorf (Nr.771-000)",
            "Street": "Hauptstr.  19",
            "ZIP": "26901",
            "City": "Rastdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wiesenhof",
            "id": "772-000",
            "text": "Wiesenhof in Duisburg  (Nr.772-000)",
            "Street": "Straußplatz 3",
            "ZIP": "47057",
            "City": "Duisburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Harkotten",
            "id": "773-000",
            "text": "Hof Harkotten in Emsdetten (Nr.773-000)",
            "Street": "Hollingen 19",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Terheiden",
            "id": "774-000",
            "text": "Terheiden in Hopsten (Nr.774-000)",
            "Street": "Breischenerstr. 4",
            "ZIP": "48496",
            "City": "Hopsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Rieping",
            "id": "775-000",
            "text": "Reitstall Rieping in Ahlen (Nr.775-000)",
            "Street": "Dorffeld 25",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Constanze Möller",
            "id": "776-000",
            "text": "Constanze Möller in Ennigerloh (Nr.776-000)",
            "Street": "Im Sportpark 1",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Majewski",
            "id": "777-000",
            "text": "Majewski in Horstmar (Nr.777-000)",
            "Street": "Ostendorf 17",
            "ZIP": "48612",
            "City": "Horstmar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Neuß",
            "id": "778-000",
            "text": "Neuß in Bochum (Nr.778-000)",
            "Street": "Auf dem Kalwes 239",
            "ZIP": "44801",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Ostönnen",
            "id": "779-000",
            "text": "RV Ostönnen in Werl (Nr.779-000)",
            "Street": "Breite Straße 7",
            "ZIP": "59457",
            "City": "Werl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Busch",
            "id": "780-000",
            "text": "Busch in Melle (Nr.780-000)",
            "Street": "Westerheide 28",
            "ZIP": "49324",
            "City": "Melle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Tierpension Groll",
            "id": "781-000",
            "text": "Tierpension Groll in Hagen (Nr.781-000)",
            "Street": "Düinghauser Weg  33",
            "ZIP": "58091",
            "City": "Hagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ziegler",
            "id": "782-000",
            "text": "Ziegler in Menden (Nr.782-000)",
            "Street": "Neue Straße 26",
            "ZIP": "58708",
            "City": "Menden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Farwick",
            "id": "783-000",
            "text": "Privatstall Farwick in Wadersloh (Nr.783-000)",
            "Street": "Liesborner Str. 28",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Hoffmann",
            "id": "784-000",
            "text": "Reitstall Hoffmann in Düsseldorf (Nr.784-000)",
            "Street": "Edmund-Bertram-Straße  54",
            "ZIP": "40489",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Zur Verth",
            "id": "785-000",
            "text": "Schulze Zur Verth in Borken (Nr.785-000)",
            "Street": "Pröbstinger Allee 1",
            "ZIP": "46325",
            "City": "Borken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Niemeyer",
            "id": "786-000",
            "text": "Niemeyer in Westerkappeln (Nr.786-000)",
            "Street": "Bathmener Str. 28",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "J&A Ranch",
            "id": "787-000",
            "text": "J&A Ranch in Olsberg (Nr.787-000)",
            "Street": "Ibergstraße ",
            "ZIP": "59939",
            "City": "Olsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ramrath",
            "id": "788-000",
            "text": "Ramrath in Sendenhorst (Nr.788-000)",
            "Street": "Hohe Ward 4",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Lukat",
            "id": "789-000",
            "text": "Pensionsstall Lukat in Nordhorn (Nr.789-000)",
            "Street": "Karl-Braun-Straße  18",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyschule Sauerland",
            "id": "790-000",
            "text": "Ponyschule Sauerland in Meschede (Nr.790-000)",
            "Street": "Erflinghausen 13",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Anne Lauderbach",
            "id": "791-000",
            "text": "Anne Lauderbach in Lastrup (Nr.791-000)",
            "Street": "Blaubusch 1",
            "ZIP": "49688",
            "City": "Lastrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Klaas",
            "id": "792-000",
            "text": "Klaas in Meppen (Nr.792-000)",
            "Street": "In den Höften 11",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Frers",
            "id": "793-000",
            "text": "Privatstall Frers in Oelde (Nr.793-000)",
            "Street": "Katthagenstr. 25",
            "ZIP": "59302",
            "City": "Oelde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rönnebäumer",
            "id": "794-000",
            "text": "Rönnebäumer in Havixbeck (Nr.794-000)",
            "Street": "Brock 18",
            "ZIP": "48329",
            "City": "Havixbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "PferdeAktivStall",
            "id": "795-000",
            "text": "PferdeAktivStall in Stadthagen (Nr.795-000)",
            "Street": "Hauptstraße 23",
            "ZIP": "31655",
            "City": "Stadthagen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Vogel/Haar",
            "id": "796-000",
            "text": "Vogel/Haar in Nordhorn (Nr.796-000)",
            "Street": "Bentheimer Straße 405",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Tünte Cappenberg",
            "id": "797-000",
            "text": "Tünte Cappenberg in Telgte (Nr.797-000)",
            "Street": "Bockhorner Heide 27",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Emsdetten",
            "id": "798-000",
            "text": "Reit- und Fahrverein Emsdetten in Emsdetten (Nr.798-000)",
            "Street": "Am Teekotten 1",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sportpferde Premiumhorses",
            "id": "799-000",
            "text": "Sportpferde Premiumhorses in Emsdetten (Nr.799-000)",
            "Street": "Westumer Landstr.  68b",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Holzbau Fieke",
            "id": "800-000",
            "text": "Holzbau Fieke in Altenberge (Nr.800-000)",
            "Street": "Kümper 110b",
            "ZIP": "48341",
            "City": "Altenberge",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reckers",
            "id": "801-000",
            "text": "Reckers in Hörstel (Nr.801-000)",
            "Street": "Altenrheiner Weg 60",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Werning ",
            "id": "802-000",
            "text": "Werning  in Lage  (Nr.802-000)",
            "Street": "Eggeweg  21",
            "ZIP": "32791",
            "City": "Lage ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kamphorst ",
            "id": "803-000",
            "text": "Kamphorst  in Nordhorn-Hestrup (Nr.803-000)",
            "Street": "Katthorstweg  15",
            "ZIP": "48531",
            "City": "Nordhorn-Hestrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Vedder",
            "id": "804-000",
            "text": "Reitanlage Vedder in Waltrop (Nr.804-000)",
            "Street": "Im Abdinghof ",
            "ZIP": "45731",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schönberg",
            "id": "805-000",
            "text": "Privatstall Schönberg in Dreierwalde (Nr.805-000)",
            "Street": "Hopstener Straße 46",
            "ZIP": "48477",
            "City": "Dreierwalde",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dingwerth",
            "id": "806-000",
            "text": "Privatstall Dingwerth in Versmold (Nr.806-000)",
            "Street": "Hollmortstr 3",
            "ZIP": "33775",
            "City": "Versmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Pulte",
            "id": "807-000",
            "text": "Reitstall Pulte in Attendorn-Mecklinghausen (Nr.807-000)",
            "Street": "Talstrasse ",
            "ZIP": "57439",
            "City": "Attendorn-Mecklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sonnenhol",
            "id": "808-000",
            "text": "Sonnenhol in Lüdenscheid (Nr.808-000)",
            "Street": "Hottenbruch 24",
            "ZIP": "58515",
            "City": "Lüdenscheid",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Pöppelmann",
            "id": "809-000",
            "text": "Hof Pöppelmann in Münster (Nr.809-000)",
            "Street": "Ramertsweg 104",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zuchtgemeinschaft Espelkott",
            "id": "810-000",
            "text": "Zuchtgemeinschaft Espelkott in Rosendahl (Nr.810-000)",
            "Street": "Geitendorf 9",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lütke-Stratkötter",
            "id": "811-000",
            "text": "Privatstall Lütke-Stratkötter in Wadersloh (Nr.811-000)",
            "Street": "Herzebrockweg 8",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rose",
            "id": "812-000",
            "text": "Privatstall Rose in Büren (Nr.812-000)",
            "Street": "Burgwall 4",
            "ZIP": "33142",
            "City": "Büren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schmitz",
            "id": "813-000",
            "text": "Schmitz in Wadersloh (Nr.813-000)",
            "Street": "Soester Str. 14",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hill of the Moon",
            "id": "814-000",
            "text": "Hill of the Moon in Arnsberg (Nr.814-000)",
            "Street": "Echthauserstr. 55",
            "ZIP": "59757",
            "City": "Arnsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wittkemper",
            "id": "815-000",
            "text": "Wittkemper in Wadersloh (Nr.815-000)",
            "Street": "Buchenweg 5",
            "ZIP": "59320",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Osenberg",
            "id": "816-000",
            "text": "Osenberg in Radevormwald (Nr.816-000)",
            "Street": "Ispingrade 13",
            "ZIP": "42477",
            "City": "Radevormwald",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hovestadt ",
            "id": "817-000",
            "text": "Hovestadt  in Gronau (Nr.817-000)",
            "Street": "Am Berge 53",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ferienbauernhof Voß",
            "id": "818-000",
            "text": "Ferienbauernhof Voß in Schmallenberg (Nr.818-000)",
            "Street": "Uentropstr. 12",
            "ZIP": "57392",
            "City": "Schmallenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meierhof",
            "id": "819-000",
            "text": "Meierhof in Detmold (Nr.819-000)",
            "Street": "Barntruper Straße 44",
            "ZIP": "32758",
            "City": "Detmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fellnasen",
            "id": "820-000",
            "text": "Fellnasen in Dreierwalde (Nr.820-000)",
            "Street": "Uthuiserstraße 33",
            "ZIP": "48486",
            "City": "Dreierwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Keller",
            "id": "821-000",
            "text": "Privatstall Keller in Ibbenbüren (Nr.821-000)",
            "Street": "Adlerstiege  80",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Schultenhof",
            "id": "822-000",
            "text": "Gestüt Schultenhof in Bochum (Nr.822-000)",
            "Street": "Zum Schultenhof 34",
            "ZIP": "44807",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Buse",
            "id": "823-000",
            "text": "Buse in Holzwickede (Nr.823-000)",
            "Street": "Talstr. 12",
            "ZIP": "59439",
            "City": "Holzwickede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wewers",
            "id": "824-000",
            "text": "Privatstall Wewers in Belm (Nr.824-000)",
            "Street": "Nelkenweg 4",
            "ZIP": "49191",
            "City": "Belm",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Gelking",
            "id": "825-000",
            "text": "Privatstall Gelking in Nordwalde (Nr.825-000)",
            "Street": "Suttorf 5",
            "ZIP": "48356",
            "City": "Nordwalde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hüntemann",
            "id": "826-000",
            "text": "Privatstall Hüntemann in Wettringen (Nr.826-000)",
            "Street": "Wilhelm-Busch-Str.  17",
            "ZIP": "48493",
            "City": "Wettringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bracht",
            "id": "827-000",
            "text": "Privatstall Bracht in Kluse (Nr.827-000)",
            "Street": "Wippinger Str  7",
            "ZIP": "26892",
            "City": "Kluse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Große Hühnfeld",
            "id": "828-000",
            "text": "Große Hühnfeld in Münster (Nr.828-000)",
            "Street": "Lindberghweg 131",
            "ZIP": "48155",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Nienhaus",
            "id": "829-000",
            "text": "Nienhaus in Bocholt (Nr.829-000)",
            "Street": "Degelingsesch 5",
            "ZIP": "46395",
            "City": "Bocholt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Fockenberg",
            "id": "830-000",
            "text": "Reitanlage Fockenberg in Bottrop (Nr.830-000)",
            "Street": "In der Koppel 82",
            "ZIP": "46244",
            "City": "Bottrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schaafhausen",
            "id": "831-000",
            "text": "Schaafhausen in Mettmann (Nr.831-000)",
            "Street": "Diepensiepen 53",
            "ZIP": "40822",
            "City": "Mettmann",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Forsthof Haschert",
            "id": "832-000",
            "text": "Forsthof Haschert in Witten (Nr.832-000)",
            "Street": "Krünerstr. 52",
            "ZIP": "58456",
            "City": "Witten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Brockmann",
            "id": "833-000",
            "text": "Brockmann in Bergen (Nr.833-000)",
            "Street": "Peerborm 6",
            "ZIP": "29303",
            "City": "Bergen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Dortmund Kirchlinde",
            "id": "834-000",
            "text": "Dortmund Kirchlinde in Dortmund (Nr.834-000)",
            "Street": "Mosselde 150",
            "ZIP": "44357",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Schütte",
            "id": "835-000",
            "text": "Pferdehof Schütte in Schortens (Nr.835-000)",
            "Street": "Stummeldorf 1",
            "ZIP": "26419",
            "City": "Schortens",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Könemann",
            "id": "836-000",
            "text": "Reitsportanlage Könemann in Petershagen (Nr.836-000)",
            "Street": "Stehbrink 37",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Beringhof",
            "id": "837-000",
            "text": "Gut Beringhof in Wickede (Nr.837-000)",
            "Street": "Zum Beringhof 2",
            "ZIP": "58739",
            "City": "Wickede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Artmanns Hof",
            "id": "838-000",
            "text": "Artmanns Hof in  Horstmar (Nr.838-000)",
            "Street": "Ostendorf 38",
            "ZIP": "48565",
            "City": " Horstmar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Neitemeier",
            "id": "839-000",
            "text": "Neitemeier in Meschede (Nr.839-000)",
            "Street": "Stesse ",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Backhaus",
            "id": "840-000",
            "text": "Backhaus in Wetter (Nr.840-000)",
            "Street": "Limbeckerweg ",
            "ZIP": "58300",
            "City": "Wetter",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Werl",
            "id": "841-000",
            "text": "Reitverein Werl in Werl (Nr.841-000)",
            "Street": "Neheimer Str. 49",
            "ZIP": "59457",
            "City": "Werl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hasenhorst",
            "id": "842-000",
            "text": "Hasenhorst in Münster (Nr.842-000)",
            "Street": "Bremerfeld 4",
            "ZIP": "48147",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pension Tiemann",
            "id": "843-000",
            "text": "Pension Tiemann in Löhne (Nr.843-000)",
            "Street": "Börstelstraße 109",
            "ZIP": "32584",
            "City": "Löhne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jasper",
            "id": "844-000",
            "text": "Jasper in Hopsten (Nr.844-000)",
            "Street": "Stadener Straße  14",
            "ZIP": "48496",
            "City": "Hopsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Holtumer Landhof",
            "id": "845-000",
            "text": "Holtumer Landhof in Duisburg  (Nr.845-000)",
            "Street": "Holtumer Mühlenweg  1",
            "ZIP": "47259",
            "City": "Duisburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Steinbrückhof",
            "id": "846-000",
            "text": "Steinbrückhof in Müden (Aller) (Nr.846-000)",
            "Street": "Gilde 1a",
            "ZIP": "38539",
            "City": "Müden (Aller)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Güldner",
            "id": "847-000",
            "text": "Güldner in Hopsten (Nr.847-000)",
            "Street": "Zum Wurftaubenstand 1",
            "ZIP": "48496",
            "City": "Hopsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilde",
            "id": "848-000",
            "text": "Wilde in Nottuln (Nr.848-000)",
            "Street": "Mühlenweg  2",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kaspar",
            "id": "849-000",
            "text": "Kaspar in Korschenbroich (Nr.849-000)",
            "Street": "Glehner Str. 14a",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Nienhuis",
            "id": "850-000",
            "text": "Privatstall Nienhuis in Heede (Nr.850-000)",
            "Street": "Schuckenbrock 14",
            "ZIP": "26892",
            "City": "Heede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterverein Iserlohn",
            "id": "851-000",
            "text": "Reiterverein Iserlohn in Iserlohn (Nr.851-000)",
            "Street": "Reiterweg 16",
            "ZIP": "58636",
            "City": "Iserlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Niggemann Hunteburg",
            "id": "852-000",
            "text": "Privatstall Niggemann Hunteburg in Bohmte (Nr.852-000)",
            "Street": "Am Strohtkanal 3",
            "ZIP": "49163",
            "City": "Bohmte",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Hellerhof",
            "id": "853-000",
            "text": "Gut Hellerhof in Düsseldorf (Nr.853-000)",
            "Street": "Rudolf-Breitscheid-Strasse ",
            "ZIP": "40721",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage am Thabrauck",
            "id": "854-000",
            "text": "Reitanlage am Thabrauck in Frödenberg (Nr.854-000)",
            "Street": "Thabrauck 22",
            "ZIP": "58730",
            "City": "Frödenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Weller",
            "id": "855-000",
            "text": "Privatstall Weller in Goch (Nr.855-000)",
            "Street": "Kapellenhofstr. 13",
            "ZIP": "47574",
            "City": "Goch",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sonntagsfarm",
            "id": "856-000",
            "text": "Sonntagsfarm in Kaarst (Nr.856-000)",
            "Street": "Neersener Straße 38",
            "ZIP": "41564",
            "City": "Kaarst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Deimann/Sprankel",
            "id": "857-000",
            "text": "Stall Deimann/Sprankel in Schmallenberg-Oberkirchen (Nr.857-000)",
            "Street": "Hammerweg ",
            "ZIP": "57392",
            "City": "Schmallenberg-Oberkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hubertus",
            "id": "858-000",
            "text": "Reitanlage Hubertus in Gladbeck-Brauck (Nr.858-000)",
            "Street": "Brauckstr 10",
            "ZIP": "45968",
            "City": "Gladbeck-Brauck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Carranza Sport Horses",
            "id": "859-000",
            "text": "Carranza Sport Horses in Nordhorn (Nr.859-000)",
            "Street": "Buchenstraße 84",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Brautmeier",
            "id": "861-000",
            "text": "Privatstall Brautmeier in Delbrück (Nr.861-000)",
            "Street": "Lippstädter Str. 104",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Behle",
            "id": "862-000",
            "text": "Pferdehof Behle in Ense-Lüttringen (Nr.862-000)",
            "Street": "Auf den Weiden  6",
            "ZIP": "59469",
            "City": "Ense-Lüttringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Götten",
            "id": "863-000",
            "text": "Privatstall Götten in Ibbenbüren (Nr.863-000)",
            "Street": "Iltisweg  15e",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Harberg",
            "id": "864-000",
            "text": "Harberg in Beckum (Nr.864-000)",
            "Street": "Harberg 1",
            "ZIP": "59269",
            "City": "Beckum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Petershagen",
            "id": "865-000",
            "text": "Petershagen in Petershagen (Nr.865-000)",
            "Street": "Riehe Höfe 6",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Frickenstein",
            "id": "866-000",
            "text": "Frickenstein in Ibbenbüren (Nr.866-000)",
            "Street": "An der Umfluth 19a",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Steinberg",
            "id": "867-000",
            "text": "Privatstall Steinberg in Schwerte (Nr.867-000)",
            "Street": "Steinberg  31",
            "ZIP": "58239",
            "City": "Schwerte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Deuper",
            "id": "868-000",
            "text": "Privatstall Deuper in Bad Laer (Nr.868-000)",
            "Street": "Wechel  7",
            "ZIP": "49196",
            "City": "Bad Laer",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Engemann",
            "id": "869-000",
            "text": "Privatstall Engemann in Willebadessen (Nr.869-000)",
            "Street": "Klosterstr 5",
            "ZIP": "34439",
            "City": "Willebadessen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferdepension Haasenbau",
            "id": "870-000",
            "text": "Islandpferdepension Haasenbau in Dorsten (Nr.870-000)",
            "Street": "Nierleistr. 64",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hertenhof",
            "id": "871-000",
            "text": "Hertenhof in Meerbusch (Nr.871-000)",
            "Street": "Bovert  33",
            "ZIP": "40670",
            "City": "Meerbusch",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanl. am Kressenberg",
            "id": "872-000",
            "text": "Reitanl. am Kressenberg in Hattingen (Nr.872-000)",
            "Street": "Langes Feld 17",
            "ZIP": "45529",
            "City": "Hattingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof der Pferde",
            "id": "873-000",
            "text": "Hof der Pferde in Adelheidsdorf (Nr.873-000)",
            "Street": "Dasselsbrucher Str.  82",
            "ZIP": "29352",
            "City": "Adelheidsdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Zur Kummerwie",
            "id": "874-000",
            "text": "Zur Kummerwie in Bad Sassendorf (Nr.874-000)",
            "Street": "Weslarner Weg 2",
            "ZIP": "59505",
            "City": "Bad Sassendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Lengerich",
            "id": "875-000",
            "text": "RV Lengerich in Lengerich (Nr.875-000)",
            "Street": "Erlenweg  3",
            "ZIP": "49838",
            "City": "Lengerich",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Vogt  (kleiner Offenstall)",
            "id": "876-000",
            "text": "Privatstall Vogt  (kleiner Offenstall) in Marl  (Nr.876-000)",
            "Street": "Haßlinger Bogen 22",
            "ZIP": "49448",
            "City": "Marl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Adams",
            "id": "877-000",
            "text": "Privatstall Adams in Rheinberg (Nr.877-000)",
            "Street": "Rheinkamper Str.  71",
            "ZIP": "47495",
            "City": "Rheinberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Stappers",
            "id": "878-000",
            "text": "Privatstall Stappers in Spelle (Nr.878-000)",
            "Street": "Englandstr.  30",
            "ZIP": "48480",
            "City": "Spelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Krasenbrink",
            "id": "879-000",
            "text": "Privatstall Krasenbrink in Nordhorn (Nr.879-000)",
            "Street": "Feldflurweg  86",
            "ZIP": "48531",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Johst",
            "id": "880-000",
            "text": "Pensionsstall Johst in Grevenbroich (Nr.880-000)",
            "Street": "Am Blauen Stein 3",
            "ZIP": "41516",
            "City": "Grevenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lügan",
            "id": "881-000",
            "text": "Privatstall Lügan in Löningen (Nr.881-000)",
            "Street": "Weißer Damm 5",
            "ZIP": "49624",
            "City": "Löningen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Polo club Waseenaar",
            "id": "NL010-000",
            "text": "Polo club Waseenaar in Wassenaar (Nr.NL010-000)",
            "Street": "Wallsdorperlaan  29a",
            "ZIP": "2244 BN",
            "City": "Wassenaar",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Kleine Auszeit",
            "id": "882-000",
            "text": "Kleine Auszeit in Würselen (Nr.882-000)",
            "Street": "Broicher Str 130",
            "ZIP": "52146",
            "City": "Würselen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hunder",
            "id": "883-000",
            "text": "Hunder in Warmsen (Nr.883-000)",
            "Street": "Hauskämper Str.  6",
            "ZIP": "31606",
            "City": "Warmsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstsall Wiethoff",
            "id": "884-000",
            "text": "Privatstsall Wiethoff in Neukirchen-Vluyn (Nr.884-000)",
            "Street": "Geldernsche Str.  405",
            "ZIP": "47506",
            "City": "Neukirchen-Vluyn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Volkmer Meinhard",
            "id": "885-000",
            "text": "Stall Volkmer Meinhard in Ochtrup (Nr.885-000)",
            "Street": "Weiner  231",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pabsthof",
            "id": "886-000",
            "text": "Pabsthof in Düsseldorf (Nr.886-000)",
            "Street": "Pabsthofweg  2",
            "ZIP": "40629",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Birtes Ranch",
            "id": "887-000",
            "text": "Birtes Ranch in Ense Vollbringen (Nr.887-000)",
            "Street": "Lanner 9",
            "ZIP": "59469",
            "City": "Ense Vollbringen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Stegemann",
            "id": "888-000",
            "text": "Privatstall Stegemann in Neuenrade (Nr.888-000)",
            "Street": "Hofstr  5b",
            "ZIP": "58809",
            "City": "Neuenrade",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bacchiocchi",
            "id": "889-000",
            "text": "Privatstall Bacchiocchi in Ratingen (Nr.889-000)",
            "Street": "Lintorfer Weg 16",
            "ZIP": "40885",
            "City": "Ratingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Göppinger",
            "id": "890-000",
            "text": "Privatstall Göppinger in Grefrath (Nr.890-000)",
            "Street": "Auffeld  26",
            "ZIP": "47929",
            "City": "Grefrath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Joeressen",
            "id": "891-000",
            "text": "Joeressen in Mönchengladbach (Nr.891-000)",
            "Street": "Günhovener Str  49",
            "ZIP": "41179",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jürgensmeyerhof",
            "id": "892-000",
            "text": "Jürgensmeyerhof in Lage  (Nr.892-000)",
            "Street": "Billinghauser 167",
            "ZIP": "32791",
            "City": "Lage ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Landschapsstal Lenferink",
            "id": "NL011-000",
            "text": "Landschapsstal Lenferink in Mander (Nr.NL011-000)",
            "Street": "Oosteriksweg  25",
            "ZIP": "7663 TA",
            "City": "Mander",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Klein Düssel",
            "id": "893-000",
            "text": "Gut Klein Düssel in Düsseldorf (Nr.893-000)",
            "Street": "Gödinghover Weg 80",
            "ZIP": "40627",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Bahr",
            "id": "894-000",
            "text": "Stall Bahr in Schwanewede (Nr.894-000)",
            "Street": "Hamfährer Weg  34",
            "ZIP": "27890",
            "City": "Schwanewede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Entrup",
            "id": "895-000",
            "text": "Privatstall Entrup in Rheda-Wiedenbrück (Nr.895-000)",
            "Street": "Kleestr 44",
            "ZIP": "33378",
            "City": "Rheda-Wiedenbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Friedrich Dehmann",
            "id": "896-000",
            "text": "Friedrich Dehmann in Nordstemmen (Nr.896-000)",
            "Street": "Hallerstr 9",
            "ZIP": "31171",
            "City": "Nordstemmen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Göbel",
            "id": "897-000",
            "text": "Privatstall Göbel in Schmallenberg-Felbecke (Nr.897-000)",
            "Street": "Hawerlandstr 7",
            "ZIP": "57392",
            "City": "Schmallenberg-Felbecke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dyckers",
            "id": "898-000",
            "text": "Dyckers in Neuss Grefrath (Nr.898-000)",
            "Street": "Lüttenglehnerstrasse 116",
            "ZIP": "41472",
            "City": "Neuss Grefrath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Ressing",
            "id": "899-000",
            "text": "Reiterhof Ressing in Hünxe (Nr.899-000)",
            "Street": "Hoher Wardweg 12a",
            "ZIP": "46569",
            "City": "Hünxe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Watermann",
            "id": "900-000",
            "text": "Watermann in Witten (Nr.900-000)",
            "Street": "Am Katterloh  12",
            "ZIP": "58454",
            "City": "Witten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lampe",
            "id": "901-000",
            "text": "Privatstall Lampe in Friesoythe (Nr.901-000)",
            "Street": "Altenoyther Str. 66",
            "ZIP": "26169",
            "City": "Friesoythe",
            "Bundesland": "Niedersachsen",
            "Land": "Niederlande"
        },
        {
            "name": "Hof Eckey",
            "id": "902-000",
            "text": "Hof Eckey in Bönen (Nr.902-000)",
            "Street": "Auf dem hachenei 6",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fricke",
            "id": "903-000",
            "text": "Privatstall Fricke in Algermissen (Nr.903-000)",
            "Street": "Pfingstanger 5",
            "ZIP": "31191",
            "City": "Algermissen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Jennifer Wulf und Thorben Schulte",
            "id": "904-000",
            "text": "Jennifer Wulf und Thorben Schulte in Witten (Nr.904-000)",
            "Street": "Oberkrone 76",
            "ZIP": "58455",
            "City": "Witten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fahrstall",
            "id": "905-000",
            "text": "Fahrstall in Rheine  (Nr.905-000)",
            "Street": "Im Uhlenhook 11",
            "ZIP": "48432",
            "City": "Rheine ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Aumann",
            "id": "906-000",
            "text": "Privatstall Aumann in Hespe (Nr.906-000)",
            "Street": "Hauptstr 33",
            "ZIP": "31693",
            "City": "Hespe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Friedrich Döpke",
            "id": "907-000",
            "text": "Friedrich Döpke in Langenhagen (Nr.907-000)",
            "Street": "Dorfstraße 60",
            "ZIP": "30855",
            "City": "Langenhagen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Zuchtstall Schäfers",
            "id": "908-000",
            "text": "Zuchtstall Schäfers in Ense (Nr.908-000)",
            "Street": "Soester Straße  6",
            "ZIP": "59469",
            "City": "Ense",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Herbsthof",
            "id": "909-000",
            "text": "Herbsthof in Garbsen (Nr.909-000)",
            "Street": "Burgstraße 42",
            "ZIP": "30826",
            "City": "Garbsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Wolfsaap / Prange",
            "id": "910-000",
            "text": "Gut Wolfsaap / Prange in Düsseldorf (Nr.910-000)",
            "Street": "Bauernhäuser Weg  100",
            "ZIP": "40472",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vermittler Wesley Mulder",
            "id": "NL012-000",
            "text": "Vermittler Wesley Mulder in  (Nr.NL012-000)",
            "Street": "Hof NICHT einrichten! ",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Reinstall Stuhr",
            "id": "911-000",
            "text": "Reinstall Stuhr in Stuhr (Nr.911-000)",
            "Street": "Klardinger Straße 8",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Piepel",
            "id": "912-000",
            "text": "Piepel in Rheine (Nr.912-000)",
            "Street": "Devesburg 30",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Noeke",
            "id": "913-000",
            "text": "Noeke in Meschede (Nr.913-000)",
            "Street": "In der Giesmecke 3",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Resser RV",
            "id": "914-000",
            "text": "Resser RV in Gelsenkirchen (Nr.914-000)",
            "Street": "Brauckstraße  21",
            "ZIP": "45892",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Ziegelhof",
            "id": "915-000",
            "text": "Gestüt Ziegelhof in Rommerskirchen (Nr.915-000)",
            "Street": "Am Ziegelhof  2",
            "ZIP": "41569",
            "City": "Rommerskirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Meyers Pferdehof",
            "id": "916-000",
            "text": "Meyers Pferdehof in Stuhr (Nr.916-000)",
            "Street": "Zur Malsch 2",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RTG Gut Hellerhof",
            "id": "917-000",
            "text": "RTG Gut Hellerhof in Düsseldorf (Nr.917-000)",
            "Street": "Rudolf-Breitscheidstr.  71",
            "ZIP": "40595",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Holtmann/Schulze Isfort",
            "id": "918-000",
            "text": "Hof Holtmann/Schulze Isfort in Ascheberg (Nr.918-000)",
            "Street": "Davensbergerstraße 18",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Altlünen e.V.",
            "id": "919-000",
            "text": "Reit- und Fahrverein Altlünen e.V. in Lünen (Nr.919-000)",
            "Street": "Im Geistwinkel  62",
            "ZIP": "44534",
            "City": "Lünen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dieckmann",
            "id": "920-000",
            "text": "Dieckmann in Melle (Nr.920-000)",
            "Street": "Borgloher Str 65",
            "ZIP": "49326",
            "City": "Melle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Meißner",
            "id": "921-000",
            "text": "Privatstall Meißner in Nottuln (Nr.921-000)",
            "Street": "Appelhülsener Strasse 74",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Otte-Krone",
            "id": "922-000",
            "text": "Privatstall Otte-Krone in Stemwede (Nr.922-000)",
            "Street": "Oppenweher Str. 15",
            "ZIP": "32351",
            "City": "Stemwede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ulli Schröder",
            "id": "923-000",
            "text": "Ulli Schröder in Warstein (Nr.923-000)",
            "Street": "St Barbara str 42",
            "ZIP": "59581",
            "City": "Warstein",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilms",
            "id": "924-000",
            "text": "Wilms in Schwalmtal (Nr.924-000)",
            "Street": "Berg 36",
            "ZIP": "41366",
            "City": "Schwalmtal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Heidehof",
            "id": "925-000",
            "text": "Heidehof in Horstmar (Nr.925-000)",
            "Street": "Haltern 73",
            "ZIP": "48612",
            "City": "Horstmar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vereinigter Reit und Fahrverein Remscheid",
            "id": "926-000",
            "text": "Vereinigter Reit und Fahrverein Remscheid in Remscheid (Nr.926-000)",
            "Street": "Buscherhof  3",
            "ZIP": "42899",
            "City": "Remscheid",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Shamrock Stables",
            "id": "927-000",
            "text": "Shamrock Stables in Kierspe (Nr.927-000)",
            "Street": "Berkenbaum 1",
            "ZIP": "58566",
            "City": "Kierspe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "R.V. Stuhr",
            "id": "928-000",
            "text": "R.V. Stuhr in Stuhr (Nr.928-000)",
            "Street": "Stuhrer Landstraße 144",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Landgut Steeg",
            "id": "929-000",
            "text": "Landgut Steeg in Issum (Nr.929-000)",
            "Street": "Hamsfeld 24a",
            "ZIP": "47661",
            "City": "Issum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dzialdowski",
            "id": "930-000",
            "text": "Privatstall Dzialdowski in Gescher (Nr.930-000)",
            "Street": "Estern  4",
            "ZIP": "48712",
            "City": "Gescher",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beerens",
            "id": "931-000",
            "text": "Privatstall Beerens in Selm (Nr.931-000)",
            "Street": "Lüdinghausener Str 69",
            "ZIP": "59379",
            "City": "Selm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Deppe",
            "id": "932-000",
            "text": "Privatstall Deppe in Heiden (Nr.932-000)",
            "Street": "Deel 18",
            "ZIP": "46359",
            "City": "Heiden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Leimkühler KG",
            "id": "933-000",
            "text": "Leimkühler KG in Moers (Nr.933-000)",
            "Street": "Wefortstraße 99",
            "ZIP": "47445",
            "City": "Moers",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Roter stall",
            "id": "934-000",
            "text": "Roter stall in Bedburg (Nr.934-000)",
            "Street": "Hohenholzer Straße 32",
            "ZIP": "50181",
            "City": "Bedburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrverein Rinkerode e.V.",
            "id": "935-000",
            "text": "Reit- und Fahrverein Rinkerode e.V. in Drensteinfurt (Nr.935-000)",
            "Street": "Im Breul 35",
            "ZIP": "48317",
            "City": "Drensteinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Lübbehusen",
            "id": "936-000",
            "text": "Reitstall Lübbehusen in Visbeck (Nr.936-000)",
            "Street": "Norddöllen 1",
            "ZIP": "49429",
            "City": "Visbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hubert",
            "id": "937-000",
            "text": "Hubert in Haltern am See (Nr.937-000)",
            "Street": "Hennewigerweg 203",
            "ZIP": "45721",
            "City": "Haltern am See",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schuze Vels",
            "id": "938-000",
            "text": "Hof Schuze Vels in Kamen (Nr.938-000)",
            "Street": "Im Haferfeld 5",
            "ZIP": "59174",
            "City": "Kamen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "de Lutte NL",
            "id": "NL013-000",
            "text": "de Lutte NL in de Lutte NL (Nr.NL013-000)",
            "Street": "Bentheimerstraat 29",
            "ZIP": "7587 ND",
            "City": "de Lutte NL",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Rolf",
            "id": "939-000",
            "text": "Pferdepension Rolf in Herzebrock-Clarholz (Nr.939-000)",
            "Street": "Groppeler Straße 29",
            "ZIP": "33442",
            "City": "Herzebrock-Clarholz",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schulze Balhorn",
            "id": "940-000",
            "text": "Privatstall Schulze Balhorn in Sendenhorst (Nr.940-000)",
            "Street": "Blankenweg 2",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lindenbrink",
            "id": "941-000",
            "text": "Privatstall Lindenbrink in Ronnenberg (Nr.941-000)",
            "Street": "Reitverein Lindert 15",
            "ZIP": "30952",
            "City": "Ronnenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Bockumsfeld",
            "id": "942-000",
            "text": "Stall Bockumsfeld in Dorsten (Nr.942-000)",
            "Street": "Bockumsfeld 21",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Nienhausen",
            "id": "943-000",
            "text": "Gut Nienhausen in Gelsenkirchen (Nr.943-000)",
            "Street": "Laurentiusstr 38",
            "ZIP": "45899",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pension- en dressagestable \"De Oude Meerdijk\"",
            "id": "NL014-000",
            "text": "Pension- en dressagestable \"De Oude Meerdijk\" in Emmen (Nr.NL014-000)",
            "Street": "Oude Meerdijk 48",
            "ZIP": "7824 RW",
            "City": "Emmen",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Luela",
            "id": "944-000",
            "text": "Luela in Petershagen (Nr.944-000)",
            "Street": "Galgenheider Str ",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein vilsendorf",
            "id": "945-000",
            "text": "Reitverein vilsendorf in Bielefeld (Nr.945-000)",
            "Street": "Vilsendorfer Straße 210 210",
            "ZIP": "33739",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gehrendes",
            "id": "946-000",
            "text": "Hof Gehrendes in Willebadessen (Nr.946-000)",
            "Street": "Eissener Straße  5",
            "ZIP": "34439",
            "City": "Willebadessen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Süssmann",
            "id": "947-000",
            "text": "Süssmann in Sibbesse (Nr.947-000)",
            "Street": "Mittelweg  7",
            "ZIP": "31079",
            "City": "Sibbesse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Junker",
            "id": "948-000",
            "text": "Junker in Bad Sassendorf (Nr.948-000)",
            "Street": "Alter Soestweg 1",
            "ZIP": "59505",
            "City": "Bad Sassendorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Börgel",
            "id": "950-000",
            "text": "Börgel in Mettingen (Nr.950-000)",
            "Street": "Alte Bockradener Straße 13",
            "ZIP": "49497",
            "City": "Mettingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kappmeyer",
            "id": "951-000",
            "text": "Kappmeyer in Achim (Nr.951-000)",
            "Street": "Am Feldrain  16",
            "ZIP": "28832",
            "City": "Achim",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hansen",
            "id": "952-000",
            "text": "Hansen in Duisburg (Nr.952-000)",
            "Street": "Holtumer Mühlenweg 25",
            "ZIP": "47259",
            "City": "Duisburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Lengerich",
            "id": "953-000",
            "text": "Reitverein Lengerich in Lengerich (Nr.953-000)",
            "Street": "An der Reithalle 2",
            "ZIP": "49525",
            "City": "Lengerich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Breitenhaupt",
            "id": "954-000",
            "text": "Gut Breitenhaupt in Steinheim (Nr.954-000)",
            "Street": "Breitenhaupter Weg 1",
            "ZIP": "32839",
            "City": "Steinheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Stecklenberg",
            "id": "955-000",
            "text": "Stall Stecklenberg in Fröndenberg (Nr.955-000)",
            "Street": "Hauptstr 95",
            "ZIP": "58730",
            "City": "Fröndenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Averbeck",
            "id": "956-000",
            "text": "Hof Averbeck in Greven (Nr.956-000)",
            "Street": "Guntruper Str 44",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Caballos de la Luz",
            "id": "957-000",
            "text": "Caballos de la Luz in Mülheim (Nr.957-000)",
            "Street": "Stooter Strasse 100",
            "ZIP": "45481",
            "City": "Mülheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Nährmann",
            "id": "959-000",
            "text": "Privatstall Nährmann in Salzbergen (Nr.959-000)",
            "Street": "Wittenweg 2",
            "ZIP": "48499",
            "City": "Salzbergen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat Stall Storat",
            "id": "960-000",
            "text": "Privat Stall Storat in Reichshof (Nr.960-000)",
            "Street": "Im alten Garten 3",
            "ZIP": "51580",
            "City": "Reichshof",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stenmans",
            "id": "961-000",
            "text": "Stenmans in Kerken (Nr.961-000)",
            "Street": "Dorfstraße 1",
            "ZIP": "47647",
            "City": "Kerken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schuh",
            "id": "962-000",
            "text": "Stall Schuh in Mönchengladbach (Nr.962-000)",
            "Street": "Seidenweberstr 9",
            "ZIP": "41189",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Voltmer",
            "id": "963-000",
            "text": "Hof Voltmer in Isernhagen (Nr.963-000)",
            "Street": "Höfestraße 22",
            "ZIP": "30916",
            "City": "Isernhagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Westernranch Isterberg",
            "id": "964-000",
            "text": "Westernranch Isterberg in Isterberg (Nr.964-000)",
            "Street": "Am Wald 4",
            "ZIP": "48465",
            "City": "Isterberg",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall",
            "id": "965-000",
            "text": "Privater Offenstall in Hörstel (Nr.965-000)",
            "Street": "Horstesch 11",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Schulze-Oeing",
            "id": "966-000",
            "text": "Schulze-Oeing in Schöppingen (Nr.966-000)",
            "Street": "Heven 4",
            "ZIP": "48624",
            "City": "Schöppingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Volkardey",
            "id": "967-000",
            "text": "Gut Volkardey in Ratingen (Nr.967-000)",
            "Street": "Volkardeyer Str 51",
            "ZIP": "40880",
            "City": "Ratingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pielerhof",
            "id": "968-000",
            "text": "Pielerhof in Rheurdt (Nr.968-000)",
            "Street": "Moerserstraße 53",
            "ZIP": "47509",
            "City": "Rheurdt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kotten Leifeld",
            "id": "969-000",
            "text": "Kotten Leifeld in Oelde (Nr.969-000)",
            "Street": "Stromberger Schweiz 5",
            "ZIP": "59302",
            "City": "Oelde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat Averes",
            "id": "971-000",
            "text": "Privat Averes in Wilsum (Nr.971-000)",
            "Street": "Zur Hopfenbachquelle 2",
            "ZIP": "49849",
            "City": "Wilsum",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Funke",
            "id": "972-000",
            "text": "Privatstall Funke in Ramsdorf (Nr.972-000)",
            "Street": "Borkener Strasse 93",
            "ZIP": "46342",
            "City": "Ramsdorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall am Bückeberg",
            "id": "973-000",
            "text": "Reitstall am Bückeberg in Stadthagen (Nr.973-000)",
            "Street": "An der Bornau 9",
            "ZIP": "31655",
            "City": "Stadthagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Conradshof",
            "id": "974-000",
            "text": "Conradshof in Ratingen (Nr.974-000)",
            "Street": "Zu den Höfen 48",
            "ZIP": "40882",
            "City": "Ratingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Liethen",
            "id": "975-000",
            "text": "Liethen in Erkrath (Nr.975-000)",
            "Street": "Steinkaule  1",
            "ZIP": "40699",
            "City": "Erkrath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Götting",
            "id": "976-000",
            "text": "Götting in Bad Salzuflen (Nr.976-000)",
            "Street": "Am lockhauserbaum 19",
            "ZIP": "32107",
            "City": "Bad Salzuflen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Hellefeld",
            "id": "977-000",
            "text": "RV Hellefeld in Sundern-Hellefeld (Nr.977-000)",
            "Street": "Hellefelderstr. 1a",
            "ZIP": "59846",
            "City": "Sundern-Hellefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Löw Reitsport",
            "id": "978-000",
            "text": "Löw Reitsport in Bocholt (Nr.978-000)",
            "Street": "Westend 31-39",
            "ZIP": "46399 ",
            "City": "Bocholt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Familie Flunkert",
            "id": "979-000",
            "text": "Familie Flunkert in Iserlohn (Nr.979-000)",
            "Street": "Gerkendahler Weg 3",
            "ZIP": "58640",
            "City": "Iserlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsport Bippen e.V.",
            "id": "980-000",
            "text": "Reitsport Bippen e.V. in Bippen (Nr.980-000)",
            "Street": "Sunderhausstraße 1",
            "ZIP": "49626",
            "City": "Bippen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bottländer",
            "id": "981-000",
            "text": "Privatstall Bottländer in Issum (Nr.981-000)",
            "Street": "Mühlenstr. 41",
            "ZIP": "47661",
            "City": "Issum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Langenhof",
            "id": "982-000",
            "text": "Reitanlage Langenhof in Plettenberg (Nr.982-000)",
            "Street": "Bremcke 7",
            "ZIP": "58840",
            "City": "Plettenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Haus Giesking",
            "id": "983-000",
            "text": "Haus Giesking in Nottuln (Nr.983-000)",
            "Street": "Hangenau 25",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Warnders",
            "id": "984-000",
            "text": "Privatstall Warnders in Weener (Nr.984-000)",
            "Street": "Alt Möhlenwarf 27",
            "ZIP": "26826",
            "City": "Weener",
            "Bundesland": "NIedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Enschede BV",
            "id": "NL016-000",
            "text": "Divoza Horseworld Enschede BV in Enschede (Nr.NL016-000)",
            "Street": "Westerval  20",
            "ZIP": "7545 MZ",
            "City": "Enschede",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Nvt",
            "id": "NL015-000",
            "text": "Nvt in Zeddam (Nr.NL015-000)",
            "Street": "Papaverstraat 3",
            "ZIP": "BM7038",
            "City": "Zeddam",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Niessen",
            "id": "NL017-000",
            "text": "Privatstall Niessen in Stegeren (Nr.NL017-000)",
            "Street": "Stegerdijk 6",
            "ZIP": "7737 PT",
            "City": "Stegeren",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Oelschner",
            "id": "985-000",
            "text": "Privatstall Oelschner in Raesfeld (Nr.985-000)",
            "Street": "Hamborg  19",
            "ZIP": "46348",
            "City": "Raesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rennstall Jatzke",
            "id": "986-000",
            "text": "Rennstall Jatzke in Düsseldorf (Nr.986-000)",
            "Street": "Rennbahnstr 20",
            "ZIP": "40629",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "MW Dressage",
            "id": "NL018-000",
            "text": "MW Dressage in Doetinchem (Nr.NL018-000)",
            "Street": "Broekstraat 1",
            "ZIP": "7002 ZB",
            "City": "Doetinchem",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "RV Münster Sprakel",
            "id": "987-000",
            "text": "RV Münster Sprakel in Münster (Nr.987-000)",
            "Street": "Heidegrund 233",
            "ZIP": "48159",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Dudler Hof",
            "id": "988-000",
            "text": "Dudler Hof in Dinslaken (Nr.988-000)",
            "Street": "Dickerstraße  464",
            "ZIP": "46539",
            "City": "Dinslaken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schetters Busch",
            "id": "989-000",
            "text": "Schetters Busch in Essen (Nr.989-000)",
            "Street": "Schetters Busch 1",
            "ZIP": "45309",
            "City": "Essen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Küppers",
            "id": "990-000",
            "text": "Küppers in Solingen (Nr.990-000)",
            "Street": "Haumannst 22",
            "ZIP": "42651",
            "City": "Solingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reithof Remberg",
            "id": "991-000",
            "text": "Reithof Remberg in Dinslaken (Nr.991-000)",
            "Street": "Buschst 80",
            "ZIP": "46539",
            "City": "Dinslaken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Baldus",
            "id": "992-000",
            "text": "Privatstall Baldus in Ennepetal (Nr.992-000)",
            "Street": "Mönninghof 33",
            "ZIP": "58256",
            "City": "Ennepetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wilke",
            "id": "993-000",
            "text": "Privatstall Wilke in Neustadt Am Rübenberge (Nr.993-000)",
            "Street": "An Der Waldbühn 7",
            "ZIP": "31535",
            "City": "Neustadt Am Rübenberge",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kreutzerhof",
            "id": "994-000",
            "text": "Kreutzerhof in Krefeld (Nr.994-000)",
            "Street": "Vennikelstraße 44",
            "ZIP": "47802",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Leon",
            "id": "995-000",
            "text": "Privatstall Leon in Fürstenau (Nr.995-000)",
            "Street": "Große Haar 20",
            "ZIP": "49584",
            "City": "Fürstenau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Höfkes",
            "id": "996-000",
            "text": "Reitstall Höfkes in Kempen (Nr.996-000)",
            "Street": "Unterweidener Str 2",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Begemann",
            "id": "997-000",
            "text": "Hof Begemann in Dörentrup (Nr.997-000)",
            "Street": "Untere Dorfstrasse 17",
            "ZIP": "32694",
            "City": "Dörentrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Ulrich Schulte",
            "id": "998-000",
            "text": "Pferdepension Ulrich Schulte in Bad Sassenberg (Nr.998-000)",
            "Street": "Mühlenweg  33",
            "ZIP": "59505",
            "City": "Bad Sassenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Heinz",
            "id": "999-000",
            "text": "Privatstall Heinz in Geldern (Nr.999-000)",
            "Street": "Montessoristr 13",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Baumann",
            "id": "1000-000",
            "text": "Reitanlage Baumann in Bielefeld (Nr.1000-000)",
            "Street": "Heidsieker Heide 116",
            "ZIP": "33739",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ottensmeyer",
            "id": "1001-000",
            "text": "Privatstall Ottensmeyer in Hille (Nr.1001-000)",
            "Street": "Friedensweg 41",
            "ZIP": "32479",
            "City": "Hille",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kliedter Hof",
            "id": "1002-000",
            "text": "Kliedter Hof in Krefeld (Nr.1002-000)",
            "Street": "Papendyk 138",
            "ZIP": "47802",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fritzenhof",
            "id": "1003-000",
            "text": "Fritzenhof in Neumünster (Nr.1003-000)",
            "Street": "Kieler Straße 648a",
            "ZIP": "24536",
            "City": "Neumünster",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Niederlande"
        },
        {
            "name": "Stall Seemann",
            "id": "1004-000",
            "text": "Stall Seemann in Nienborstel (Nr.1004-000)",
            "Street": "Kluhs 4",
            "ZIP": "24819",
            "City": "Nienborstel",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Niederlande"
        },
        {
            "name": "Hof Rützenhagen",
            "id": "1005-000",
            "text": "Hof Rützenhagen in Negernbötel (Nr.1005-000)",
            "Street": "Rützenhagen 1",
            "ZIP": "23795",
            "City": "Negernbötel",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Niederlande"
        },
        {
            "name": "Gesenhues",
            "id": "1012-000",
            "text": "Gesenhues in Ahaus-Alstätte (Nr.1012-000)",
            "Street": "Öddingstraße 5",
            "ZIP": "48683",
            "City": "Ahaus-Alstätte",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Frölich",
            "id": "1006-000",
            "text": "Hof Frölich in Beckum (Nr.1006-000)",
            "Street": "Unterberg II nr 19",
            "ZIP": "59269",
            "City": "Beckum",
            "Land": "Deutschland"
        },
        {
            "name": "Lieningshof",
            "id": "1007-000",
            "text": "Lieningshof in Neuenhaus (Nr.1007-000)",
            "Street": "Lagerstr. 110",
            "ZIP": "49828",
            "City": "Neuenhaus",
            "Land": "Niederlande"
        },
        {
            "id": "1008-000",
            "text": " in Bassum (Nr.1008-000)",
            "Street": "Fuhrenkamp 25 25",
            "ZIP": "27211",
            "City": "Bassum",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Tellez",
            "id": "1009-000",
            "text": "Reitanlage Tellez in Fintel (Nr.1009-000)",
            "Street": "Himberg  80",
            "ZIP": "27389",
            "City": "Fintel",
            "Land": "Deutschland"
        },
        {
            "name": "Klüsener",
            "id": "1010-000",
            "text": "Klüsener in Herzebrock-Clarholz (Nr.1010-000)",
            "Street": "Udenbrink  15",
            "ZIP": "33442",
            "City": "Herzebrock-Clarholz",
            "Land": "Deutschland"
        },
        {
            "name": "Vogtes Erbe Reitanlage Thier",
            "id": "1013-000",
            "text": "Vogtes Erbe Reitanlage Thier in Lüdinghausen (Nr.1013-000)",
            "Street": "Ondrup 34",
            "ZIP": "59348",
            "City": "Lüdinghausen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Riedemann",
            "id": "1014-000",
            "text": "Hof Riedemann in Bramsche (Nr.1014-000)",
            "Street": "Schleptruper Strang 82",
            "ZIP": "49565",
            "City": "Bramsche",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Seibel",
            "id": "1015-000",
            "text": "Privatstall Seibel in Bockhorst (Nr.1015-000)",
            "Street": "Melmstraße 15",
            "ZIP": "26897",
            "City": "Bockhorst",
            "Land": "Deutschland"
        },
        {
            "name": "Am Ravenschlag",
            "id": "1016-000",
            "text": "Am Ravenschlag in Ennepetal (Nr.1016-000)",
            "Street": "Ravenschlag  82",
            "ZIP": "58256",
            "City": "Ennepetal",
            "Land": "Deutschland"
        },
        {
            "name": "Niki's Ponystall",
            "id": "1017-000",
            "text": "Niki's Ponystall in Hannover (Nr.1017-000)",
            "Street": "Varrelheide  25",
            "ZIP": "30657",
            "City": "Hannover",
            "Land": "Deutschland"
        },
        {
            "name": "Ruland",
            "id": "1018-000",
            "text": "Ruland in Emsdetten (Nr.1018-000)",
            "Street": "Lange water  10",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Land": "Deutschland"
        },
        {
            "name": "Lambardt",
            "id": "1019-000",
            "text": "Lambardt in Bergkamen (Nr.1019-000)",
            "Street": "Heinrichstrasse 41",
            "ZIP": "59192",
            "City": "Bergkamen",
            "Land": "Deutschland"
        },
        {
            "name": "Mewissen",
            "id": "1020-000",
            "text": "Mewissen in Schwalmtal (Nr.1020-000)",
            "Street": "Eschenrath  55-57",
            "ZIP": "41366",
            "City": "Schwalmtal",
            "Land": "Deutschland"
        },
        {
            "name": "Kingsland Superstore Groningen",
            "id": "NL019-000",
            "text": "Kingsland Superstore Groningen in Lageland (Groningen) (Nr.NL019-000)",
            "Street": "Eemskanaal Zuidzijde 15",
            "ZIP": "9622 PE",
            "City": "Lageland (Groningen)",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Homann Niehoff",
            "id": "1021-000",
            "text": "Homann Niehoff in Münster (Nr.1021-000)",
            "Street": "Homannstrasse 37",
            "ZIP": "48167",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pappelhof",
            "id": "1022-000",
            "text": "Pappelhof in Rheurdt (Nr.1022-000)",
            "Street": "Moerser Str 51",
            "ZIP": "47509",
            "City": "Rheurdt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Scheidtmann",
            "id": "1023-000",
            "text": "Scheidtmann in Hattingen (Nr.1023-000)",
            "Street": "Kohlenstrasse 183",
            "ZIP": "45529",
            "City": "Hattingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Grönings Hof",
            "id": "1024-000",
            "text": "Grönings Hof in Marl (Nr.1024-000)",
            "Street": "Wellerfeldweg 13",
            "ZIP": "45770",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bussmann",
            "id": "1025-000",
            "text": "Bussmann in  (Nr.1025-000)",
            "Street": " ",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Reipen",
            "id": "1026-000",
            "text": "Hof Reipen in Rhede (Nr.1026-000)",
            "Street": "Büngerner Allee 17",
            "ZIP": "46414",
            "City": "Rhede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Arndt",
            "id": "1027-000",
            "text": "Privatstall Arndt in Neuenkirchen (Nr.1027-000)",
            "Street": "Friedenstr. 57",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Vor den Moore - Privat",
            "id": "1028-000",
            "text": "Offenstall Vor den Moore - Privat in Neustadt (Nr.1028-000)",
            "Street": "Ahnser Weg 8",
            "ZIP": "31535",
            "City": "Neustadt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Lützow Schuckenbaum",
            "id": "1057-000",
            "text": "Lützow Schuckenbaum in Leopoldshöhe (Nr.1057-000)",
            "Street": "Eckendorferstr 74",
            "ZIP": "33818",
            "City": "Leopoldshöhe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstsall Prins",
            "id": "NL020-000",
            "text": "Privatstsall Prins in Almelo (Nr.NL020-000)",
            "Street": "Laan van Indië 89",
            "ZIP": "7602 DA",
            "City": "Almelo",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Leas Reitschule",
            "id": "1029-000",
            "text": "Leas Reitschule in Straelen (Nr.1029-000)",
            "Street": "Broekhuysener Str. 1",
            "ZIP": "47638",
            "City": "Straelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Luisenhof",
            "id": "1030-000",
            "text": "Luisenhof in Krefeld (Nr.1030-000)",
            "Street": "Flünnertzdyk 161",
            "ZIP": "47802",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "sportpferde Lohhof",
            "id": "1031-000",
            "text": "sportpferde Lohhof in Wedemark (Nr.1031-000)",
            "Street": "lange loh  15",
            "ZIP": "30900",
            "City": "Wedemark",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Rohleder",
            "id": "1032-000",
            "text": "Stall Rohleder in Dortmund (Nr.1032-000)",
            "Street": "Am Hausacker 5",
            "ZIP": "44339",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Scheibe",
            "id": "1033-000",
            "text": "Scheibe in Söhlde (Nr.1033-000)",
            "Street": "Lindenallee 10",
            "ZIP": "31185",
            "City": "Söhlde",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Boerger",
            "id": "1034-000",
            "text": "Reitstall Boerger in Lennestadt (Nr.1034-000)",
            "Street": "Seilmecke 17a",
            "ZIP": "57368",
            "City": "Lennestadt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Warneke",
            "id": "1035-000",
            "text": "Offenstall Warneke in Alveslohe (Nr.1035-000)",
            "Street": "Dieckskamp 23",
            "ZIP": "25486",
            "City": "Alveslohe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Topp",
            "id": "1036-000",
            "text": "Topp in Lippetal (Nr.1036-000)",
            "Street": "Hüttinghauserweg 3",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Kopp",
            "id": "1037-000",
            "text": "Offenstall Kopp in Dorsten (Nr.1037-000)",
            "Street": "Nelkenstr. 15",
            "ZIP": "46284",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kersebohm",
            "id": "1038-000",
            "text": "Kersebohm in Lünen (Nr.1038-000)",
            "Street": "Im Siepen 3",
            "ZIP": "44536",
            "City": "Lünen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zucht-&Pensionsstall Becker-lütke-Bexten",
            "id": "1039-000",
            "text": "Zucht-&Pensionsstall Becker-lütke-Bexten in Ostbevern (Nr.1039-000)",
            "Street": "Schirl  68",
            "ZIP": "48346",
            "City": "Ostbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Uesbeck",
            "id": "1040-000",
            "text": "Uesbeck in Gronau (Nr.1040-000)",
            "Street": "Schlamannweg 62a",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kriest",
            "id": "1041-000",
            "text": "Kriest in Recklinghausen (Nr.1041-000)",
            "Street": "Christine-Englerth-Str.  24",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit und Fahrverein e.V.",
            "id": "1042-000",
            "text": "Reit und Fahrverein e.V. in Dörentrup (Nr.1042-000)",
            "Street": "Untere Dorfstraße 36",
            "ZIP": "32694",
            "City": "Dörentrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Grabe",
            "id": "1043-000",
            "text": "Grabe in Lippetal (Nr.1043-000)",
            "Street": "Schachtruper weg  1",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Quitthoevelshof Tennagels",
            "id": "1044-000",
            "text": "Quitthoevelshof Tennagels in Geldern (Nr.1044-000)",
            "Street": "Am Mühlenwasser  56",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wiebke Felderhoff",
            "id": "1045-000",
            "text": "Wiebke Felderhoff in Bremen (Nr.1045-000)",
            "Street": "Oberneulander Landstraße 145c",
            "ZIP": "28355",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Spiekermann",
            "id": "1046-000",
            "text": "Spiekermann in Bönen (Nr.1046-000)",
            "Street": "Sinnerstraße 4",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gütges",
            "id": "1047-000",
            "text": "Gütges in Geldern (Nr.1047-000)",
            "Street": "Poststr. 6",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Malorny",
            "id": "1048-000",
            "text": "Malorny in Viersen (Nr.1048-000)",
            "Street": "Am Buschfeld 87",
            "ZIP": "41747",
            "City": "Viersen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Gilbers",
            "id": "1049-000",
            "text": "Gilbers in Rheurdt (Nr.1049-000)",
            "Street": "Kengen 66",
            "ZIP": "47509",
            "City": "Rheurdt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ruf Lohne",
            "id": "1050-000",
            "text": "Ruf Lohne in Lohne (Nr.1050-000)",
            "Street": "Reiterweg  10",
            "ZIP": "49393",
            "City": "Lohne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hilling",
            "id": "1051-000",
            "text": "Hilling in Lathen (Nr.1051-000)",
            "Street": "Emsweg 29b",
            "ZIP": "49762",
            "City": "Lathen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall",
            "id": "NL021-000",
            "text": "Privatstall in Sint Jansklooster (Nr.NL021-000)",
            "Street": "Halleweg 15",
            "ZIP": "8326 AN",
            "City": "Sint Jansklooster",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Boertje",
            "id": "NL023-000",
            "text": "Boertje in Vledderveen (Nr.NL023-000)",
            "Street": "Grensweg 8",
            "ZIP": "8385 GH",
            "City": "Vledderveen",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyfarm",
            "id": "1052-000",
            "text": "Ponyfarm in Rheine (Nr.1052-000)",
            "Street": "Bauerschaftsstraße 196",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Eulenkrug",
            "id": "1053-000",
            "text": "Hof Eulenkrug in Ahrensburg (Nr.1053-000)",
            "Street": "Hamburger Straße 248",
            "ZIP": "22926",
            "City": "Ahrensburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schröder",
            "id": "1054-000",
            "text": "Schröder in Hille-Hartum (Nr.1054-000)",
            "Street": "Holzhauser Straße 119",
            "ZIP": "32479",
            "City": "Hille-Hartum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahverein Wilhelminenhof e.V.",
            "id": "1055-000",
            "text": "Reit- und Fahverein Wilhelminenhof e.V. in Ladelund (Nr.1055-000)",
            "Street": "Wilhelmine Straße 3",
            "ZIP": "25926",
            "City": "Ladelund",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schumacher",
            "id": "1056-000",
            "text": "Privatstall Schumacher in Kappeln (Nr.1056-000)",
            "Street": "Heidesiedlung 50",
            "ZIP": "24376",
            "City": "Kappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdestall Pool",
            "id": "1059-000",
            "text": "Pferdestall Pool in Lingen (Nr.1059-000)",
            "Street": "Kleekamp 1",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sportpferdezucht Hof Charlottenlind",
            "id": "1060-000",
            "text": "Sportpferdezucht Hof Charlottenlind in Gudow (Nr.1060-000)",
            "Street": "Hauptstrasse 45",
            "ZIP": "23899",
            "City": "Gudow",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Mühlenhof",
            "id": "1061-000",
            "text": "Mühlenhof in Hürth (Nr.1061-000)",
            "Street": "Mühlenweg 11",
            "ZIP": "50354",
            "City": "Hürth",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Büsse",
            "id": "1062-000",
            "text": "Hof Büsse in Sibbesse (Nr.1062-000)",
            "Street": "Kirchstraße 28",
            "ZIP": "31079",
            "City": "Sibbesse",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit und Fahrverein Uetze und Umgebung e.V.",
            "id": "1064-000",
            "text": "Reit und Fahrverein Uetze und Umgebung e.V. in Uetze (Nr.1064-000)",
            "Street": "Am Wolfsbusch 2",
            "ZIP": "31311",
            "City": "Uetze",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat/Kirschbaum/Borgs",
            "id": "1065-000",
            "text": "Privat/Kirschbaum/Borgs in Rosendahl-Holtwick (Nr.1065-000)",
            "Street": "Bleck 8",
            "ZIP": "48720",
            "City": "Rosendahl-Holtwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bökhaus",
            "id": "1066-000",
            "text": "Bökhaus in Lage (Nr.1066-000)",
            "Street": "Lemgoer Str 154",
            "ZIP": "32791",
            "City": "Lage",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stonehouse Ranch",
            "id": "1067-000",
            "text": "Stonehouse Ranch in Herne (Nr.1067-000)",
            "Street": "Wiedehopfstrasse  200",
            "ZIP": "44653",
            "City": "Herne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Selker",
            "id": "1068-000",
            "text": "Selker in Horstmar-Leer (Nr.1068-000)",
            "Street": "Haltern  59",
            "ZIP": "48612",
            "City": "Horstmar-Leer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ohana",
            "id": "1069-000",
            "text": "Ohana in Bargtheide (Nr.1069-000)",
            "Street": "Alte Landstraße 111",
            "ZIP": "22941",
            "City": "Bargtheide",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hindersmann",
            "id": "1070-000",
            "text": "Privatstall Hindersmann in Mettingen (Nr.1070-000)",
            "Street": "Neuenkirchener Straße  128",
            "ZIP": "49497",
            "City": "Mettingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Janneby",
            "id": "1071-000",
            "text": "Reitstall Janneby in Janneby (Nr.1071-000)",
            "Street": "Ringstraße 8",
            "ZIP": "24992",
            "City": "Janneby",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Ohlemeyer",
            "id": "1072-000",
            "text": "Hof Ohlemeyer in Minden (Nr.1072-000)",
            "Street": "Barrlinge 4",
            "ZIP": "32425",
            "City": "Minden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Privater Stall in Nöpke",
            "id": "1073-000",
            "text": "Privater Stall in Nöpke in Neustadt (Nr.1073-000)",
            "Street": "Kleieweg 3a",
            "ZIP": "31535",
            "City": "Neustadt",
            "Bundesland": "Niedersachsen",
            "Land": "Niederlande"
        },
        {
            "name": "Stentenbach",
            "id": "1074-000",
            "text": "Stentenbach in Nordhorn (Nr.1074-000)",
            "Street": "Isterberger Weg 56",
            "ZIP": "48529",
            "City": "Nordhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Kruse",
            "id": "1075-000",
            "text": "Pferdehof Kruse in Neuenrade (Nr.1075-000)",
            "Street": "Oberer Beuler Weg 25",
            "ZIP": "58809",
            "City": "Neuenrade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Holtau",
            "id": "1076-000",
            "text": "Gut Holtau in Winsen (Aller) (Nr.1076-000)",
            "Street": "Gut Holtau 1",
            "ZIP": "29308",
            "City": "Winsen (Aller)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitgemeinschaft Schlagbaum",
            "id": "1077-000",
            "text": "Reitgemeinschaft Schlagbaum in Ennepetal (Nr.1077-000)",
            "Street": "Schlagbaum  17",
            "ZIP": "58256",
            "City": "Ennepetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Marie‘s Pony Paradies",
            "id": "1078-000",
            "text": "Marie‘s Pony Paradies in Kaarst (Nr.1078-000)",
            "Street": "Rottes 155",
            "ZIP": "41564",
            "City": "Kaarst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Haus Steprath",
            "id": "1079-000",
            "text": "Haus Steprath in Geldern (Nr.1079-000)",
            "Street": "Am Böckelken 35",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Tramm",
            "id": "1080-000",
            "text": "Reiterhof Tramm in Damp (Nr.1080-000)",
            "Street": "Dorotheental  1",
            "ZIP": "24351",
            "City": "Damp",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kaltenborner Offenstall",
            "id": "1081-000",
            "text": "Kaltenborner Offenstall in Overath (Nr.1081-000)",
            "Street": "Kaltenborn 15a",
            "ZIP": "51491",
            "City": "Overath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Pasternhof",
            "id": "1082-000",
            "text": "Reitstall Pasternhof in Krefeld (Nr.1082-000)",
            "Street": "Vorderorbroich 63",
            "ZIP": "47839 ",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Embsen",
            "id": "1083-000",
            "text": "Reitstall Embsen in Embsen (Nr.1083-000)",
            "Street": "Ringstr 1",
            "ZIP": "21409",
            "City": "Embsen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Seibel Ranch",
            "id": "1084-000",
            "text": "Seibel Ranch in Brekendorf (Nr.1084-000)",
            "Street": "Hammer 2",
            "ZIP": "24811",
            "City": "Brekendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Mühlenhof",
            "id": "1085-000",
            "text": "Mühlenhof in Westerkappeln (Nr.1085-000)",
            "Street": "Mühlenweg 13",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Helfgerdt",
            "id": "1086-000",
            "text": "Privatstall Helfgerdt in Delbrück (Nr.1086-000)",
            "Street": "Baumweg 21",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sport- und Freizeitstall Grefen",
            "id": "1087-000",
            "text": "Sport- und Freizeitstall Grefen in Meerbusch (Nr.1087-000)",
            "Street": "Am oberen Feld 94",
            "ZIP": "40668",
            "City": "Meerbusch",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "PSV Meeresreiter",
            "id": "1088-000",
            "text": "PSV Meeresreiter in Seelze (Nr.1088-000)",
            "Street": "Am Wall 4",
            "ZIP": "30926",
            "City": "Seelze",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Am Mühlenbach",
            "id": "1089-000",
            "text": "Am Mühlenbach in Bliestorf (Nr.1089-000)",
            "Street": "Am Mühlenbach  2",
            "ZIP": "23847",
            "City": "Bliestorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Niemann",
            "id": "1090-000",
            "text": "Niemann in Visbek (Nr.1090-000)",
            "Street": "Lohe 7",
            "ZIP": "49429",
            "City": "Visbek",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Platen",
            "id": "1092-000",
            "text": "Platen in Kempen (Nr.1092-000)",
            "Street": "Neuenweg 4",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Annika Mielke (privat)",
            "id": "1093-000",
            "text": "Annika Mielke (privat) in Ganderkesee (Nr.1093-000)",
            "Street": "Wildeshauser Landstraße ",
            "ZIP": "27777",
            "City": "Ganderkesee",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stallgemeinschaft Metelen",
            "id": "1094-000",
            "text": "Stallgemeinschaft Metelen in Metelen (Nr.1094-000)",
            "Street": "Schreiber Esch 8",
            "ZIP": "48629",
            "City": "Metelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Forstwald",
            "id": "1095-000",
            "text": "Gestüt Forstwald in Castrop Rauxel (Nr.1095-000)",
            "Street": "Westring 347",
            "ZIP": "44575",
            "City": "Castrop Rauxel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Franzen",
            "id": "1096-000",
            "text": "Reitanlage Franzen in Korschenbroich (Nr.1096-000)",
            "Street": "Krünsend 64",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Geisthoff",
            "id": "1097-000",
            "text": "Geisthoff in Ahlen (Nr.1097-000)",
            "Street": "Westhusener weg 5",
            "ZIP": "59229",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Störtal ",
            "id": "1098-000",
            "text": "Gestüt Störtal  in Ehndorf (Nr.1098-000)",
            "Street": "Heischredde 3",
            "ZIP": "24647",
            "City": "Ehndorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Bimberg",
            "id": "1099-000",
            "text": "Gut Bimberg in Unna (Nr.1099-000)",
            "Street": "Gut Bimberg ",
            "ZIP": "59427",
            "City": "Unna",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RFG Auetal e.V.",
            "id": "1101-000",
            "text": "RFG Auetal e.V. in Schwanewede (Nr.1101-000)",
            "Street": "Wiesenstraße 43",
            "ZIP": "28790",
            "City": "Schwanewede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall",
            "id": "1100-000",
            "text": "Privatstall in Berge (Nr.1100-000)",
            "Street": "Hekeser Str. 42",
            "ZIP": "49626",
            "City": "Berge",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schlungshof",
            "id": "1102-000",
            "text": "Schlungshof in Willich (Nr.1102-000)",
            "Street": "Stock 110",
            "ZIP": "47877",
            "City": "Willich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Eckhorst",
            "id": "1103-000",
            "text": "Hof Eckhorst in Güby (Nr.1103-000)",
            "Street": "Eckhorst 6",
            "ZIP": "24357",
            "City": "Güby",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Utta",
            "id": "1104-000",
            "text": "Privatstall Utta in Greven (Nr.1104-000)",
            "Street": "Herberner Mersch 22",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Steinburg Shires Fam. Hauschildt",
            "id": "1105-000",
            "text": "Steinburg Shires Fam. Hauschildt in Winseldorf (Nr.1105-000)",
            "Street": "Oberstr. 22",
            "ZIP": "25551",
            "City": "Winseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rinas-Tenberg",
            "id": "1106-000",
            "text": "Privatstall Rinas-Tenberg in Mettingen (Nr.1106-000)",
            "Street": "Woorteweg  9",
            "ZIP": "49497 ",
            "City": "Mettingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Katrin Kreihe",
            "id": "1107-000",
            "text": "Katrin Kreihe in Braunschweig (Nr.1107-000)",
            "Street": "Eutschenwinkel  1",
            "ZIP": "38124 ",
            "City": "Braunschweig",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schierenbeck",
            "id": "1108-000",
            "text": "Hof Schierenbeck in Weyhe (Nr.1108-000)",
            "Street": "Weyher Bruch 30",
            "ZIP": "28844",
            "City": "Weyhe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Kobbensen",
            "id": "1109-000",
            "text": "Gestüt Kobbensen in Heuerßen (Nr.1109-000)",
            "Street": "Im Krümmel 8",
            "ZIP": "31700",
            "City": "Heuerßen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Göfert",
            "id": "1110-000",
            "text": "Privatstall Göfert in Coesfeld (Nr.1110-000)",
            "Street": "Coesfelder Berg  17",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Tiemann",
            "id": "1111-000",
            "text": "Tiemann in Hamm (Nr.1111-000)",
            "Street": "Dasbeck  10",
            "ZIP": "59073",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Perlenhof",
            "id": "1117-000",
            "text": "Perlenhof in Winsen (Nr.1117-000)",
            "Street": "Ostenholzer Str 51",
            "ZIP": "29308",
            "City": "Winsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wichmann",
            "id": "1118-000",
            "text": "Hof Wichmann in Coesfeld (Nr.1118-000)",
            "Street": "Herteler  32",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gartz",
            "id": "1119-000",
            "text": "Gartz in Nettetal (Nr.1119-000)",
            "Street": "An Schönkes Krüz 2",
            "ZIP": "41334",
            "City": "Nettetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuFV Eiderstedt",
            "id": "1120-000",
            "text": "RuFV Eiderstedt in Garding (Nr.1120-000)",
            "Street": "Graureiherweg ",
            "ZIP": "25836",
            "City": "Garding",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gerding",
            "id": "1121-000",
            "text": "Gerding in Nottuln-Darup (Nr.1121-000)",
            "Street": "Hastehausen 9",
            "ZIP": "48301",
            "City": "Nottuln-Darup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Mahmens",
            "id": "1122-000",
            "text": "Privatstall Mahmens in Stapel (Nr.1122-000)",
            "Street": "Breite Str. 7",
            "ZIP": "25879",
            "City": "Stapel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Reuschenberg",
            "id": "1123-000",
            "text": "Gut Reuschenberg in Leverkusen (Nr.1123-000)",
            "Street": "Gut Reuschenberg 1",
            "ZIP": "51373",
            "City": "Leverkusen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rennstall Kleinbrahm",
            "id": "1124-000",
            "text": "Rennstall Kleinbrahm in Bottrop (Nr.1124-000)",
            "Street": "Brabecker Feld 27",
            "ZIP": "46244",
            "City": "Bottrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Postkunden",
            "id": "1125-000",
            "text": "Postkunden in  (Nr.1125-000)",
            "Street": "Postkunden ",
            "ZIP": "Postkunden",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ingwersen",
            "id": "1126-000",
            "text": "Privatstall Ingwersen in Ostenfeld (Nr.1126-000)",
            "Street": "Heidweg  13",
            "ZIP": "25872",
            "City": "Ostenfeld",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Engelking",
            "id": "1127-000",
            "text": "Engelking in Raddestorf (Nr.1127-000)",
            "Street": "Harrienstedt 60",
            "ZIP": "31604",
            "City": "Raddestorf",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Segbert",
            "id": "1128-000",
            "text": "Hof Segbert in Dülmen (Nr.1128-000)",
            "Street": "Bauerschaft  20",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kretschmann",
            "id": "1129-000",
            "text": "Kretschmann in Heidgraben (Nr.1129-000)",
            "Street": "Pipenblink 27",
            "ZIP": "25436",
            "City": "Heidgraben",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Finkenbrink",
            "id": "1130-000",
            "text": "Finkenbrink in Recklinghausen (Nr.1130-000)",
            "Street": "Dortmunderstr. 163",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raedgeshof Kempen",
            "id": "1131-000",
            "text": "Raedgeshof Kempen in Kempen (Nr.1131-000)",
            "Street": "An Haus Steinfunder 9",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage auf dem Ströhen",
            "id": "1132-000",
            "text": "Reitanlage auf dem Ströhen in Steinhagen (Nr.1132-000)",
            "Street": "Ströher Str. 46",
            "ZIP": "33803",
            "City": "Steinhagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Blome",
            "id": "1133-000",
            "text": "Pferdepension Blome in Arnsberg (Nr.1133-000)",
            "Street": "Westerholtstr. 2",
            "ZIP": "59757",
            "City": "Arnsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Nottuln (Wedding)",
            "id": "1134-000",
            "text": "Pferdehof Nottuln (Wedding) in Nottuln (Nr.1134-000)",
            "Street": "Horst 15",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pugge",
            "id": "1135-000",
            "text": "Pugge in Greven (Nr.1135-000)",
            "Street": "Pentruper Mersch 45",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kaiser",
            "id": "1136-000",
            "text": "Kaiser in Soest (Nr.1136-000)",
            "Street": "Eichenweg  4",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Holthäuser Hof",
            "id": "1137-000",
            "text": "Holthäuser Hof in Waltrop (Nr.1137-000)",
            "Street": "Im Eickel 42",
            "ZIP": "45731",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stallgemeinschaft Happy Hippos",
            "id": "1138-000",
            "text": "Stallgemeinschaft Happy Hippos in Castrop Rauxel (Nr.1138-000)",
            "Street": "Im Finkenbrink 34",
            "ZIP": "44581",
            "City": "Castrop Rauxel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bültel",
            "id": "1140-000",
            "text": "Bültel in Emsbüren (Nr.1140-000)",
            "Street": "Lingenerstraße 31",
            "ZIP": "48488",
            "City": "Emsbüren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kenzler",
            "id": "1141-000",
            "text": "Kenzler in Nideggen (Nr.1141-000)",
            "Street": "Neffeltalstrasse 24",
            "ZIP": "52385",
            "City": "Nideggen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Cassandra Tiehuis",
            "id": "NL022-000",
            "text": "Cassandra Tiehuis in Oldenzaal (Nr.NL022-000)",
            "Street": "Boterstraat  33",
            "ZIP": "7571EB",
            "City": "Oldenzaal",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Wonderland Ranch",
            "id": "1142-000",
            "text": "Wonderland Ranch in Wiehl (Nr.1142-000)",
            "Street": "Scheidter Straße ",
            "ZIP": "51674",
            "City": "Wiehl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Iron Horse Ranch",
            "id": "1143-000",
            "text": "Iron Horse Ranch in Hamminkeln (Nr.1143-000)",
            "Street": "Ißhorst 6",
            "ZIP": "46499",
            "City": "Hamminkeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat Kaiser",
            "id": "1144-000",
            "text": "Privat Kaiser in Ibbenbüren (Nr.1144-000)",
            "Street": "An der Blankenburg 99",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Krude",
            "id": "1145-000",
            "text": "Krude in Schwalmtal (Nr.1145-000)",
            "Street": "Renneperstr 32a",
            "ZIP": "41366",
            "City": "Schwalmtal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schönke",
            "id": "1146-000",
            "text": "Privatstall Schönke in Peine/Vöhrum (Nr.1146-000)",
            "Street": "Kirchvordenerstr 13A",
            "ZIP": "31228",
            "City": "Peine/Vöhrum",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension und Landwirtschaft Muckhof",
            "id": "1147-000",
            "text": "Pferdepension und Landwirtschaft Muckhof in Bochum (Nr.1147-000)",
            "Street": "Deimketal 44",
            "ZIP": "44879",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Weltring",
            "id": "1148-000",
            "text": "Privatstall Weltring in Lingen (Nr.1148-000)",
            "Street": "Hohlweg 7",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Möller",
            "id": "1149-000",
            "text": "Privatstall Möller in Dötlingen (Nr.1149-000)",
            "Street": "Zur Loh 23",
            "ZIP": "27801",
            "City": "Dötlingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule und Reiterhof Steinmeier-Beese",
            "id": "1150-000",
            "text": "Reitschule und Reiterhof Steinmeier-Beese in Everswinkel (Nr.1150-000)",
            "Street": "Evener  16",
            "ZIP": "48351",
            "City": "Everswinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bessmann",
            "id": "1151-000",
            "text": "Privatstall Bessmann in Harsewinkel (Nr.1151-000)",
            "Street": "Tüllheide 6",
            "ZIP": "33428",
            "City": "Harsewinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Leek BV",
            "id": "NL024-000",
            "text": "Divoza Horseworld Leek BV in Leek (Nr.NL024-000)",
            "Street": "Zernikelaan 16",
            "ZIP": "9351 VA",
            "City": "Leek",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Heteren BV",
            "id": "NL025-000",
            "text": "Divoza Horseworld Heteren BV in Heteren (Nr.NL025-000)",
            "Street": "Ressenerbroek 16",
            "ZIP": "6666 MR",
            "City": "Heteren",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Staphorst BV",
            "id": "NL026-000",
            "text": "Divoza Horseworld Staphorst BV in Staphorst (Nr.NL026-000)",
            "Street": "Wethouder Buitenhuisstraat 4a",
            "ZIP": "7951 SM",
            "City": "Staphorst",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Zoetermeer BV",
            "id": "NL027-000",
            "text": "Divoza Horseworld Zoetermeer BV in Zoetermeer (Nr.NL027-000)",
            "Street": "Edelgasstraat 45",
            "ZIP": "2718 SX",
            "City": "Zoetermeer",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Divoza Horseworld Harmelen BV",
            "id": "NL028-000",
            "text": "Divoza Horseworld Harmelen BV in Harmelen (Nr.NL028-000)",
            "Street": "Industrieweg 8",
            "ZIP": "3481 MD",
            "City": "Harmelen",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Thunhof",
            "id": "1152-000",
            "text": "Thunhof in Schloß Neuhaus (Nr.1152-000)",
            "Street": "Am Thunhof ",
            "ZIP": "33104",
            "City": "Schloß Neuhaus",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Heumann",
            "id": "1153-000",
            "text": "Heumann in Stuhr (Nr.1153-000)",
            "Street": "Kladdingerstr. 3",
            "ZIP": "28816",
            "City": "Stuhr",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wittenburg",
            "id": "1154-000",
            "text": "Privatstall Wittenburg in Hohenlockstedt (Nr.1154-000)",
            "Street": "Ridders 31",
            "ZIP": "25551",
            "City": "Hohenlockstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beiermann",
            "id": "1155-000",
            "text": "Privatstall Beiermann in Hörstel (Nr.1155-000)",
            "Street": "Nagels Damm 67",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eigener Offenstall",
            "id": "1156-000",
            "text": "Eigener Offenstall in Witten (Nr.1156-000)",
            "Street": "Oberkrone 36",
            "ZIP": "58455",
            "City": "Witten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rohloff",
            "id": "1157-000",
            "text": "Rohloff in Freienwill (Nr.1157-000)",
            "Street": "Alte Dorfstr. 13",
            "ZIP": "24991",
            "City": "Freienwill",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Mahner Berg",
            "id": "1158-000",
            "text": "Mahner Berg in Salzgitter Bad (Nr.1158-000)",
            "Street": "Mahner Berg 12",
            "ZIP": "38259",
            "City": "Salzgitter Bad",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Krallmann",
            "id": "1159-000",
            "text": "Privatstall Krallmann in Meppen (Nr.1159-000)",
            "Street": "Flutmulde 8",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RFV Bötenberg - Wietzen",
            "id": "1160-000",
            "text": "RFV Bötenberg - Wietzen in  Balge  (Nr.1160-000)",
            "Street": "Bötenberger Str. 82",
            "ZIP": "31609",
            "City": " Balge ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Höbek",
            "id": "1161-000",
            "text": "Gut Höbek in Haßmoor (Nr.1161-000)",
            "Street": "Gut Höbek 1",
            "ZIP": "24790",
            "City": "Haßmoor",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Waldhof Home of healthy horses",
            "id": "1162-000",
            "text": "Gut Waldhof Home of healthy horses in  Kisdorf (Nr.1162-000)",
            "Street": "Am Waldhof 6",
            "ZIP": "24629",
            "City": " Kisdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Lassen",
            "id": "1163-000",
            "text": "Lassen in Waabs (Nr.1163-000)",
            "Street": "Flintholm 1",
            "ZIP": "24369",
            "City": "Waabs",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Straube",
            "id": "1164-000",
            "text": "Privatstall Straube in Stadtlohn  (Nr.1164-000)",
            "Street": "Estern 78",
            "ZIP": "48703",
            "City": "Stadtlohn ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wenne Valley Ranch ",
            "id": "1165-000",
            "text": "Wenne Valley Ranch  in Schmallenberg (Nr.1165-000)",
            "Street": "Grimminghausen 2",
            "ZIP": "57392",
            "City": "Schmallenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mangelsen ",
            "id": "1166-000",
            "text": "Mangelsen  in Wees (Nr.1166-000)",
            "Street": "Blixberg 1",
            "ZIP": "24999",
            "City": "Wees",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Droste",
            "id": "1167-000",
            "text": "Privatstall Droste in Lingen (Nr.1167-000)",
            "Street": "Duisenburgerstraße 9",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Lengelshof",
            "id": "1168-000",
            "text": "Lengelshof in Ratingen  (Nr.1168-000)",
            "Street": "Lengelshof 1",
            "ZIP": "40883",
            "City": "Ratingen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Stegen",
            "id": "1169-000",
            "text": "Reitstall Stegen in Jersbek  (Nr.1169-000)",
            "Street": "Alte Landstraße 1H",
            "ZIP": "22941",
            "City": "Jersbek ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sandra",
            "id": "1170-000",
            "text": "Sandra in Velbert  (Nr.1170-000)",
            "Street": "Nierenhofer Straße 10",
            "ZIP": "45509",
            "City": "Velbert ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schmidt",
            "id": "1171-000",
            "text": "Privatstall Schmidt in Seelze  (Nr.1171-000)",
            "Street": "Im Busche 8",
            "ZIP": "30926",
            "City": "Seelze ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Lüerdissen",
            "id": "1172-000",
            "text": "Stall Lüerdissen in Lemgo (Nr.1172-000)",
            "Street": "Zur Behrensburg 19",
            "ZIP": "32657",
            "City": "Lemgo",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Neumann",
            "id": "1173-000",
            "text": "Privatstall Neumann in Niederkassel (Nr.1173-000)",
            "Street": "Sülzstr. 7",
            "ZIP": "53859",
            "City": "Niederkassel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wenzel",
            "id": "1174-000",
            "text": "Privatstall Wenzel in Niederkrüchten (Nr.1174-000)",
            "Street": "Dilborner Str. 5",
            "ZIP": "41372",
            "City": "Niederkrüchten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ekkehard Heuser ",
            "id": "1175-000",
            "text": "Ekkehard Heuser  in Ahnatal  (Nr.1175-000)",
            "Street": "Schulstr 17",
            "ZIP": "34292",
            "City": "Ahnatal ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Hans Lugge",
            "id": "1176-000",
            "text": "Reitstall Hans Lugge in Mülheim  (Nr.1176-000)",
            "Street": "Gänseweg 80",
            "ZIP": "45475",
            "City": "Mülheim ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hechmann",
            "id": "1177-000",
            "text": "Hechmann in Lennestadt (Nr.1177-000)",
            "Street": "Fredeburger Str 104",
            "ZIP": "57368",
            "City": "Lennestadt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vogt",
            "id": "1178-000",
            "text": "Vogt in Drensteinfurt  (Nr.1178-000)",
            "Street": "Herrenstein 26",
            "ZIP": "48317",
            "City": "Drensteinfurt ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wilde Banausen ",
            "id": "1179-000",
            "text": "Wilde Banausen  in Tostedt  (Nr.1179-000)",
            "Street": "Poststraße 34",
            "ZIP": "21255",
            "City": "Tostedt ",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Rayker Hof Matuszak",
            "id": "1180-000",
            "text": "Rayker Hof Matuszak in Lehe (Nr.1180-000)",
            "Street": "Bundesstraße 12",
            "ZIP": "26892",
            "City": "Lehe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Equus Dynamics Daria Böker / Gut Lödding",
            "id": "1181-000",
            "text": "Equus Dynamics Daria Böker / Gut Lödding in Hamm (Nr.1181-000)",
            "Street": "Holunderweg 11",
            "ZIP": "59063",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RSG Busche",
            "id": "1182-000",
            "text": "RSG Busche in Hückeswagen  (Nr.1182-000)",
            "Street": "Busche  3",
            "ZIP": "42499",
            "City": "Hückeswagen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wurth",
            "id": "1183-000",
            "text": "Wurth in Lindlar (Nr.1183-000)",
            "Street": "Stellberg 1",
            "ZIP": "51789",
            "City": "Lindlar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichstädt",
            "id": "1184-000",
            "text": "Eichstädt in Münster (Nr.1184-000)",
            "Street": "Westfalenstr. 88",
            "ZIP": "48165",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Berning",
            "id": "1185-000",
            "text": "Hof Berning in Emsdetten (Nr.1185-000)",
            "Street": "Isendorf 64",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Göbel",
            "id": "1186-000",
            "text": "Göbel in Bochum (Nr.1186-000)",
            "Street": "Bertastraße 8",
            "ZIP": "44793",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage kisters",
            "id": "1187-000",
            "text": "Reitsportanlage kisters in Oberhausen (Nr.1187-000)",
            "Street": "Waldhuckstraße 187",
            "ZIP": "46147",
            "City": "Oberhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Spaargaren",
            "id": "NL029-000",
            "text": "Spaargaren in Soest (Nr.NL029-000)",
            "Street": "Birkstraat 124 B",
            "ZIP": "3768 HM",
            "City": "Soest",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Islandpferde vom Torhaus",
            "id": "1188-000",
            "text": "Islandpferde vom Torhaus in Warnau (Nr.1188-000)",
            "Street": "Dorfstraße  24",
            "ZIP": "24250",
            "City": "Warnau",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Seehausen",
            "id": "1189-000",
            "text": "Reitstall Seehausen in Wunstorf (Nr.1189-000)",
            "Street": "Heidorner Str. 63",
            "ZIP": "31515",
            "City": "Wunstorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hepp",
            "id": "1190-000",
            "text": "Hepp in Schönbek (Nr.1190-000)",
            "Street": "Dorfstraße 21",
            "ZIP": "24582",
            "City": "Schönbek",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stegerhof",
            "id": "1191-000",
            "text": "Stegerhof in Voerde (Nr.1191-000)",
            "Street": "Stegerweg 19",
            "ZIP": "46562",
            "City": "Voerde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ristau",
            "id": "1192-000",
            "text": "Ristau in Fitzbek  (Nr.1192-000)",
            "Street": "Mühlenstraße 4",
            "ZIP": "25579",
            "City": "Fitzbek ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferderesort Wesling",
            "id": "1193-000",
            "text": "Pferderesort Wesling in Warmsen (Nr.1193-000)",
            "Street": "Brüninghorstedt 5",
            "ZIP": "31606",
            "City": "Warmsen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ma",
            "id": "1194-000",
            "text": "Privatstall Ma in Eschede (Nr.1194-000)",
            "Street": "Eichenstrasse 2",
            "ZIP": "29348",
            "City": "Eschede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Denkfein ",
            "id": "1195-000",
            "text": "Offenstall Denkfein  in Mettmann (Nr.1195-000)",
            "Street": "Laubach 26a",
            "ZIP": "40822",
            "City": "Mettmann",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wesche",
            "id": "1196-000",
            "text": "Wesche in Burgdorf  (Nr.1196-000)",
            "Street": "Am Vorwerk 18",
            "ZIP": "31303",
            "City": "Burgdorf ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof nedderby",
            "id": "1197-000",
            "text": "Hof nedderby in Husby  (Nr.1197-000)",
            "Street": "Nedderbyer str 11",
            "ZIP": "24975",
            "City": "Husby ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Psv Coldinne ",
            "id": "1198-000",
            "text": "Psv Coldinne  in Großheide (Nr.1198-000)",
            "Street": "Heerweg  11",
            "ZIP": "26532",
            "City": "Großheide",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hamminga",
            "id": "NL030-000",
            "text": "Hamminga in Mantgum (Nr.NL030-000)",
            "Street": "Swannedrift 19",
            "ZIP": "9022 AR",
            "City": "Mantgum",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Wiesendahl",
            "id": "1199-000",
            "text": "Wiesendahl in Hamm (Nr.1199-000)",
            "Street": "Auf dem Südfelde 5",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kulturhof Neuner",
            "id": "1200-000",
            "text": "Kulturhof Neuner in Wingst (Nr.1200-000)",
            "Street": "Altkehdinger Weg 50",
            "ZIP": "21789",
            "City": "Wingst",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Heineke",
            "id": "1201-000",
            "text": "Heineke in Syke  (Nr.1201-000)",
            "Street": "Specken 1",
            "ZIP": "28857",
            "City": "Syke ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hassel",
            "id": "1202-000",
            "text": "Reitanlage Hassel in Bergen (Nr.1202-000)",
            "Street": "Hassel 1a",
            "ZIP": "29303",
            "City": "Bergen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Erburt",
            "id": "1204-000",
            "text": "Erburt in Friesoythe (Nr.1204-000)",
            "Street": "Bundesstraße 87",
            "ZIP": "26169",
            "City": "Friesoythe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Loagshof",
            "id": "1205-000",
            "text": "Loagshof in Warstein (Nr.1205-000)",
            "Street": "Sauerlandstr 14",
            "ZIP": "59581",
            "City": "Warstein",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RFZV St. Hubertus Herne ",
            "id": "1206-000",
            "text": "RFZV St. Hubertus Herne  in Herne (Nr.1206-000)",
            "Street": "Holthauser Str. 91",
            "ZIP": "44627",
            "City": "Herne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichkamp",
            "id": "1207-000",
            "text": "Eichkamp in Ehndorf (Nr.1207-000)",
            "Street": "Heischredder 2",
            "ZIP": "24647",
            "City": "Ehndorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Busch",
            "id": "1208-000",
            "text": "Privatstall Busch in Bad Laasphe  (Nr.1208-000)",
            "Street": "Mittelstraße 21",
            "ZIP": "57334",
            "City": "Bad Laasphe ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "T spieker",
            "id": "NL031-000",
            "text": "T spieker in Vaassen  (Nr.NL031-000)",
            "Street": "Oude Sluisweg 10",
            "ZIP": "8171LH",
            "City": "Vaassen ",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Büttger Buscherhöfe",
            "id": "1209-000",
            "text": "Büttger Buscherhöfe in Kaarst (Nr.1209-000)",
            "Street": "Büttger Buscherhöfe 8a",
            "ZIP": "41564",
            "City": "Kaarst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ebkens",
            "id": "1210-000",
            "text": "Ebkens in Barßel (Nr.1210-000)",
            "Street": "Carolinenhofstraße 1",
            "ZIP": "26676",
            "City": "Barßel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Peters",
            "id": "1211-000",
            "text": "Reitstall Peters in Heinsberg- Randerath  (Nr.1211-000)",
            "Street": "Am Hellenkamp 38",
            "ZIP": "52525",
            "City": "Heinsberg- Randerath ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Eifler",
            "id": "1212-000",
            "text": "Privatstall Eifler in Hürth (Nr.1212-000)",
            "Street": "Burgstraße  66",
            "ZIP": "50354",
            "City": "Hürth",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Antje Kötters",
            "id": "1213-000",
            "text": "Antje Kötters in Rosendahl (Nr.1213-000)",
            "Street": "Rockel  31",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hesping",
            "id": "1214-000",
            "text": "Hesping in Hörstel (Nr.1214-000)",
            "Street": "Brandhakenweg 12",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Mohme ",
            "id": "1215-000",
            "text": "Pferdehof Mohme  in Porta Westfalica (Nr.1215-000)",
            "Street": "Albert-Schweitzer-Str. 21",
            "ZIP": "32457",
            "City": "Porta Westfalica",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fenner in Buseck",
            "id": "1216-000",
            "text": "Privatstall Fenner in Buseck in Buseck (Nr.1216-000)",
            "Street": "Grossen-Busecker Str.  41",
            "ZIP": "35418",
            "City": "Buseck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichkamp Ehndorf",
            "id": "1217-000",
            "text": "Eichkamp Ehndorf in Ehndorf (Nr.1217-000)",
            "Street": "Heischredder 2",
            "ZIP": "24647",
            "City": "Ehndorf",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lingens",
            "id": "1218-000",
            "text": "Privatstall Lingens in Bramsche (Nr.1218-000)",
            "Street": "Balkumer Str.  33",
            "ZIP": "49565",
            "City": "Bramsche",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Grose",
            "id": "1219-000",
            "text": "Privatstall Grose in Verden (Aller) (Nr.1219-000)",
            "Street": "Osterortstr. 20",
            "ZIP": "27283",
            "City": "Verden (Aller)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Leikop",
            "id": "1220-000",
            "text": "Leikop in Brilon (Nr.1220-000)",
            "Street": "Remstoß 7",
            "ZIP": "59929",
            "City": "Brilon",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Helmuth Schröder",
            "id": "1221-000",
            "text": "Helmuth Schröder in Dänischenhagen (Nr.1221-000)",
            "Street": "Kaltenhofer Allee 35",
            "ZIP": "24229",
            "City": "Dänischenhagen",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Tempel",
            "id": "1222-000",
            "text": "Reitstall Tempel in Kempen (Nr.1222-000)",
            "Street": "Pielmey 6",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdefreunde Filsum",
            "id": "1223-000",
            "text": "Pferdefreunde Filsum in Filsum (Nr.1223-000)",
            "Street": "Burgweg 9",
            "ZIP": "26849",
            "City": "Filsum",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Weigand",
            "id": "1224-000",
            "text": "Privatstall Weigand in Ilsede (Nr.1224-000)",
            "Street": "Dorfstraße 23",
            "ZIP": "31241",
            "City": "Ilsede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Everding",
            "id": "1225-000",
            "text": "Hof Everding in Harsewinkel (Nr.1225-000)",
            "Street": "Berkort 5",
            "ZIP": "33428",
            "City": "Harsewinkel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Linda Verwaal Dressage",
            "id": "NL032-000",
            "text": "Linda Verwaal Dressage in Enter (Nr.NL032-000)",
            "Street": "Achteresweg 11",
            "ZIP": "7468 PP",
            "City": "Enter",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Dunkel",
            "id": "1226-000",
            "text": "Privatstall Dunkel in Schalksmühle (Nr.1226-000)",
            "Street": "Resswinkeler Weg 49",
            "ZIP": "58579",
            "City": "Schalksmühle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Breforth",
            "id": "1227-000",
            "text": "Privatstall Breforth in Hamm (Nr.1227-000)",
            "Street": "Dennehauptweg 3a",
            "ZIP": "59073",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ganser",
            "id": "1228-000",
            "text": "Privatstall Ganser in Pulheim (Nr.1228-000)",
            "Street": "Johann-Hermanns-Weg  16",
            "ZIP": "50259",
            "City": "Pulheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Düren",
            "id": "1229-000",
            "text": "Hof Düren in Witten (Nr.1229-000)",
            "Street": "Dürener Str. 32",
            "ZIP": "58454",
            "City": "Witten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hippisch centrum Zwartewaterruiters",
            "id": "NL033-000",
            "text": "Hippisch centrum Zwartewaterruiters in Genemuiden (Nr.NL033-000)",
            "Street": "Kamperdijk 3",
            "ZIP": "8281 PB",
            "City": "Genemuiden",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Martin Düsterhöft",
            "id": "1230-000",
            "text": "Martin Düsterhöft in Melle (Nr.1230-000)",
            "Street": "Bruchmühlener Straße 61",
            "ZIP": "49328",
            "City": "Melle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule Sandkrug",
            "id": "1231-000",
            "text": "Reitschule Sandkrug in Hatten (Nr.1231-000)",
            "Street": "Bümmersteder Straße 57",
            "ZIP": "26209",
            "City": "Hatten",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Mannott",
            "id": "1232-000",
            "text": "Privatstall Mannott in Hohn (Nr.1232-000)",
            "Street": "Königsbach 10",
            "ZIP": "24806",
            "City": "Hohn",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hengststation Müller",
            "id": "1233-000",
            "text": "Hengststation Müller in Badbergen (Nr.1233-000)",
            "Street": "Burlagerweg 10a",
            "ZIP": "49635",
            "City": "Badbergen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrstall Lindenhof",
            "id": "1234-000",
            "text": "Reit- und Fahrstall Lindenhof in Lindlar (Nr.1234-000)",
            "Street": "Unterkotten 2",
            "ZIP": "51789",
            "City": "Lindlar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sperath",
            "id": "1235-000",
            "text": "Sperath in Nordenham (Nr.1235-000)",
            "Street": "Hansingstraße 62",
            "ZIP": "26954",
            "City": "Nordenham",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kampe",
            "id": "1236-000",
            "text": "Privatstall Kampe in Hürth (Nr.1236-000)",
            "Street": "Marktweg 31",
            "ZIP": "50354",
            "City": "Hürth",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "von Winterfell",
            "id": "1237-000",
            "text": "von Winterfell in Wedemark (Nr.1237-000)",
            "Street": "Auf Dem Kiel 10",
            "ZIP": "30900",
            "City": "Wedemark",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Luner Hof der Pferde",
            "id": "1238-000",
            "text": "Luner Hof der Pferde in Beverstedt (Nr.1238-000)",
            "Street": "Reithornsweg 32",
            "ZIP": "27616",
            "City": "Beverstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hemsing",
            "id": "1239-000",
            "text": "Privatstall Hemsing in Steinfurt (Nr.1239-000)",
            "Street": "Hollich 119",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lagemann",
            "id": "1240-000",
            "text": "Lagemann in Tecklenburg (Nr.1240-000)",
            "Street": "Horstmersch 41",
            "ZIP": "49545",
            "City": "Tecklenburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale Erftstadt",
            "id": "1241-000",
            "text": "Loesdau Filiale Erftstadt in Erftstadt-Lechenich (Nr.1241-000)",
            "Street": "Albert-Einstein-Ring 8",
            "ZIP": "59374",
            "City": "Erftstadt-Lechenich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hampsink Sporthorses",
            "id": "NL034-000",
            "text": "Hampsink Sporthorses in Gelselaar (Nr.NL034-000)",
            "Street": "Bollertweg 10",
            "ZIP": "7275 BH",
            "City": "Gelselaar",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Brandt",
            "id": "1242-000",
            "text": "Privatstall Brandt in Varel (Nr.1242-000)",
            "Street": "Im Winkel 7",
            "ZIP": "26316",
            "City": "Varel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Cleve",
            "id": "1243-000",
            "text": "Privatstall Cleve in Hessisch Oldendorf (Nr.1243-000)",
            "Street": "Rittergutstraße 47",
            "ZIP": "31840",
            "City": "Hessisch Oldendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit-Fahr-u. Zuchtverein Bochum-Nord",
            "id": "1244-000",
            "text": "Reit-Fahr-u. Zuchtverein Bochum-Nord in Bochum (Nr.1244-000)",
            "Street": "Zillertalstraße 89",
            "ZIP": "44807",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Stubbe",
            "id": "1245-000",
            "text": "Reiterhof Stubbe in Hamburg (Nr.1245-000)",
            "Street": "Billwerder Billdeich  272",
            "ZIP": "21033",
            "City": "Hamburg",
            "Bundesland": "Hamburg",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Beewen",
            "id": "1246-000",
            "text": "Privatstall Beewen in Döhlen (Nr.1246-000)",
            "Street": "Krumlander Straße 9",
            "ZIP": "26197",
            "City": "Döhlen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Zunasche Heide Logie",
            "id": "NL035-000",
            "text": "Zunasche Heide Logie in Zuna (Nr.NL035-000)",
            "Street": "Blokkendijk 4",
            "ZIP": "7466 PE",
            "City": "Zuna",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Jill Flocke",
            "id": "1247-000",
            "text": "Jill Flocke in Wuppertal (Nr.1247-000)",
            "Street": "Teschensudberger Straße 24a",
            "ZIP": "42349",
            "City": "Wuppertal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kowalski",
            "id": "1248-000",
            "text": "Privatstall Kowalski in Rheine (Nr.1248-000)",
            "Street": "Auf dem Brink 13",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Burchard",
            "id": "1249-000",
            "text": "Reitstall Burchard in Ronnenberg (Nr.1249-000)",
            "Street": "Holtenser Straße 4",
            "ZIP": "30952",
            "City": "Ronnenberg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Milte-Sassenberg",
            "id": "1250-000",
            "text": "Reitverein Milte-Sassenberg in Warendorf-Milte (Nr.1250-000)",
            "Street": "Velsen 20",
            "ZIP": "48231",
            "City": "Warendorf-Milte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyhof Doose",
            "id": "1251-000",
            "text": "Ponyhof Doose in Altenholz (Nr.1251-000)",
            "Street": "Achtstückenberg 6",
            "ZIP": "24161",
            "City": "Altenholz",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Köhler",
            "id": "1252-000",
            "text": "Hof Köhler in Mechtersen (Nr.1252-000)",
            "Street": "In der Marsch 1",
            "ZIP": "21358",
            "City": "Mechtersen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Jacobowsky",
            "id": "1253-000",
            "text": "Privatstall Jacobowsky in Bochum (Nr.1253-000)",
            "Street": "Steinring 30",
            "ZIP": "44789",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wessels",
            "id": "1254-000",
            "text": "Privatstall Wessels in Olfen (Nr.1254-000)",
            "Street": "Hahnenberg 15",
            "ZIP": "59399",
            "City": "Olfen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Brahmkamp",
            "id": "1255-000",
            "text": "Hof Brahmkamp in Kosel (Nr.1255-000)",
            "Street": "Lundshof 9",
            "ZIP": "24354",
            "City": "Kosel",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rochel",
            "id": "1256-000",
            "text": "Privatstall Rochel in Rahden (Nr.1256-000)",
            "Street": "Große Masch 12",
            "ZIP": "32369",
            "City": "Rahden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hundemühle",
            "id": "1257-000",
            "text": "Hof Hundemühle in Gronenberg (Nr.1257-000)",
            "Street": "Hundemühle 1",
            "ZIP": "23684",
            "City": "Gronenberg",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Rainbowranch",
            "id": "1258-000",
            "text": "Rainbowranch in Hannover (Nr.1258-000)",
            "Street": "Im Heidkampe 166",
            "ZIP": "30659",
            "City": "Hannover",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RFV Hermannsburg-Berge",
            "id": "1259-000",
            "text": "RFV Hermannsburg-Berge in Südheide / Hermannsburg (Nr.1259-000)",
            "Street": "Georgsstraße  19A",
            "ZIP": "29320",
            "City": "Südheide / Hermannsburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Heuer",
            "id": "1260-000",
            "text": "Heuer in Springe (Nr.1260-000)",
            "Street": "Steinhauserstraße 6",
            "ZIP": "31832",
            "City": "Springe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hancken",
            "id": "1261-000",
            "text": "Hancken in Loxstedt (Nr.1261-000)",
            "Street": "Eichenallee 72",
            "ZIP": "27612",
            "City": "Loxstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Nussbaum",
            "id": "1262-000",
            "text": "Nussbaum in Mettmann (Nr.1262-000)",
            "Street": "Wülfrather Str. 262",
            "ZIP": "40822",
            "City": "Mettmann",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal van de kadyk",
            "id": "NL036-000",
            "text": "Stal van de kadyk in Sintjohannesga (Nr.NL036-000)",
            "Street": "Kadijk 14",
            "ZIP": "8464 VK",
            "City": "Sintjohannesga",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Pferdesport Brand",
            "id": "1263-000",
            "text": "Pferdesport Brand in Steinfurt (Nr.1263-000)",
            "Street": "Hollich 132",
            "ZIP": "48565",
            "City": "Steinfurt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Peters",
            "id": "1264-000",
            "text": "Reitstall Peters in Marl (Nr.1264-000)",
            "Street": "Dämmerweg 101A",
            "ZIP": "45768",
            "City": "Marl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schmitz",
            "id": "1265-000",
            "text": "Privatstall Schmitz in Erftstadt (Nr.1265-000)",
            "Street": "Genner Str 30",
            "ZIP": "50374",
            "City": "Erftstadt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Frerking",
            "id": "1266-000",
            "text": "Frerking in Walsrode (Nr.1266-000)",
            "Street": "Ebbingen  2",
            "ZIP": "29664",
            "City": "Walsrode",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Voltigier und Reitzentrum im Sunderholze",
            "id": "1267-000",
            "text": "Voltigier und Reitzentrum im Sunderholze in Gevelsberg (Nr.1267-000)",
            "Street": "Sunderholzer Weg  24",
            "ZIP": "58285",
            "City": "Gevelsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Engstfeld",
            "id": "1268-000",
            "text": "Privatstall Engstfeld in Detmold (Nr.1268-000)",
            "Street": "Hornoldendorfer Str. 6",
            "ZIP": "32760",
            "City": "Detmold",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rolf Thiede",
            "id": "1269-000",
            "text": "Rolf Thiede in Lehe (Nr.1269-000)",
            "Street": "Schulstrasse 43",
            "ZIP": "25774",
            "City": "Lehe",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hippisch Centrum Emmen",
            "id": "NL037-000",
            "text": "Hippisch Centrum Emmen in Erica (Nr.NL037-000)",
            "Street": "Ericasestraat 109",
            "ZIP": "7887 GD",
            "City": "Erica",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Dapper",
            "id": "1270-000",
            "text": "Privatstall Dapper in Mucheln (Nr.1270-000)",
            "Street": "Dweerredder 10",
            "ZIP": "24238",
            "City": "Mucheln",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Riedel",
            "id": "1271-000",
            "text": "Privatstall Riedel in Essen (Nr.1271-000)",
            "Street": "Eststraße 33",
            "ZIP": "45149",
            "City": "Essen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kull-Bor",
            "id": "1272-000",
            "text": "Privatstall Kull-Bor in Brockel (Nr.1272-000)",
            "Street": "Bussardweg 15",
            "ZIP": "27386",
            "City": "Brockel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdezucht Steffens",
            "id": "1273-000",
            "text": "Pferdezucht Steffens in Vorwerk (Nr.1273-000)",
            "Street": "Mühlenhof 1",
            "ZIP": "27412",
            "City": "Vorwerk",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Oltmanns",
            "id": "1274-000",
            "text": "Pferdehof Oltmanns in Bad Zwischenahn (Nr.1274-000)",
            "Street": "Wildenlohslinie 22",
            "ZIP": "26160",
            "City": "Bad Zwischenahn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Remus-Petersen",
            "id": "1275-000",
            "text": "Remus-Petersen in Lindewitt OT Linnau (Nr.1275-000)",
            "Street": "Neue Str. 1",
            "ZIP": "24969",
            "City": "Lindewitt OT Linnau",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Groten Köß",
            "id": "1276-000",
            "text": "Hof Groten Köß in Walsrode (Nr.1276-000)",
            "Street": "Altenboitzen 13",
            "ZIP": "29664",
            "City": "Walsrode",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Paganetty",
            "id": "1277-000",
            "text": "Paganetty in Gronau (Nr.1277-000)",
            "Street": "Am Berge 47b",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Schmallenberg-Lennestadt e. V.",
            "id": "1278-000",
            "text": "Reitverein Schmallenberg-Lennestadt e. V. in Schmallenberg (Nr.1278-000)",
            "Street": "Berndorfer Straße 2",
            "ZIP": "57392",
            "City": "Schmallenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raetgeshof ",
            "id": "1279-000",
            "text": "Raetgeshof  in Kempen (Nr.1279-000)",
            "Street": "An Haus Steinfunder 9",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Müller",
            "id": "1280-000",
            "text": "Privatstall Müller in Soltau (Nr.1280-000)",
            "Street": "Reimerdingerstr  1",
            "ZIP": "29614",
            "City": "Soltau",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kamphausen",
            "id": "1281-000",
            "text": "Kamphausen in Mönchengladbach (Nr.1281-000)",
            "Street": "Am Chur  4",
            "ZIP": "41189",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Nowald",
            "id": "1282-000",
            "text": "Privatstall Nowald in Jade (Nr.1282-000)",
            "Street": "Harms Weg  6",
            "ZIP": "26349",
            "City": "Jade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reistall in Beelen",
            "id": "1283-000",
            "text": "Reistall in Beelen in Beelen (Nr.1283-000)",
            "Street": "Greffener Str 19",
            "ZIP": "48361",
            "City": "Beelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "van Esveld",
            "id": "NL038-000",
            "text": "van Esveld in Oldenzaal (Nr.NL038-000)",
            "Street": "Hunenborglaan 190",
            "ZIP": "8576 XE",
            "City": "Oldenzaal",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Stal Heineke",
            "id": "NL039-000",
            "text": "Stal Heineke in Erica (Nr.NL039-000)",
            "Street": "Ericasestraat 46",
            "ZIP": "7887 GB",
            "City": "Erica",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Bauer Krüsmann",
            "id": "1284-000",
            "text": "Bauer Krüsmann in Wuppertal (Nr.1284-000)",
            "Street": "Unterdüssler Weg 25",
            "ZIP": "42113",
            "City": "Wuppertal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Loots",
            "id": "1285-000",
            "text": "Privatstall Loots in Wachum (Nr.1285-000)",
            "Street": "Nordweg  97",
            "ZIP": "26907",
            "City": "Wachum",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hövel",
            "id": "1286-000",
            "text": "Privatstall Hövel in Hamminkeln (Nr.1286-000)",
            "Street": "Bahnhofstraße 78",
            "ZIP": "46499",
            "City": "Hamminkeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rosenhof",
            "id": "1287-000",
            "text": "Rosenhof in Wesel (Nr.1287-000)",
            "Street": "Bislicher Str.  68",
            "ZIP": "46487",
            "City": "Wesel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hartig",
            "id": "1288-000",
            "text": "Privatstall Hartig in Grasberg (Nr.1288-000)",
            "Street": "Rautendorfer Straße  24",
            "ZIP": "28879",
            "City": "Grasberg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stallgemeinschaft Kröger",
            "id": "1289-000",
            "text": "Stallgemeinschaft Kröger in Haren (Ems) (Nr.1289-000)",
            "Street": "Emen  6",
            "ZIP": "49733",
            "City": "Haren (Ems)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hähner",
            "id": "1290-000",
            "text": "Privatstall Hähner in Berne (Nr.1290-000)",
            "Street": "An den Sielen 24",
            "ZIP": "27804",
            "City": "Berne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Scheich",
            "id": "NL040-000",
            "text": "Scheich in Harkstede (Nr.NL040-000)",
            "Street": "Hamweg  92",
            "ZIP": "9617AT",
            "City": "Harkstede",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Musall",
            "id": "1291-000",
            "text": "Privatstall Musall in Struvenhütten (Nr.1291-000)",
            "Street": "Mühlenstraße  33a",
            "ZIP": "24643",
            "City": "Struvenhütten",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Schönbuchen",
            "id": "1292-000",
            "text": "Reitanlage Schönbuchen in Dierkshausen (Nr.1292-000)",
            "Street": "Zum Moor  46",
            "ZIP": "21271",
            "City": "Dierkshausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Onrust",
            "id": "1293-000",
            "text": "Privatstall Onrust in Rhauderfehn (Nr.1293-000)",
            "Street": "Schwarzmoorstraße 34",
            "ZIP": "26817",
            "City": "Rhauderfehn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Klintworth",
            "id": "1294-000",
            "text": "Reitstall Klintworth in Ohrensen (Nr.1294-000)",
            "Street": "Hauptstraße 16",
            "ZIP": "21698",
            "City": "Ohrensen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Boms",
            "id": "1295-000",
            "text": "Reitstall Boms in Korschenbroich (Nr.1295-000)",
            "Street": "Willicher Straße 26 A",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Bodenwerder",
            "id": "1296-000",
            "text": "RV Bodenwerder in Bodenwerder (Nr.1296-000)",
            "Street": "Ziegeleiweg  20",
            "ZIP": "37619",
            "City": "Bodenwerder",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Neuwiesenhof ",
            "id": "1297-000",
            "text": "Neuwiesenhof  in Burbach (Nr.1297-000)",
            "Street": "Höhgarten  5",
            "ZIP": "57299",
            "City": "Burbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Verhasselt",
            "id": "1298-000",
            "text": "Reitstall Verhasselt in Uedem (Nr.1298-000)",
            "Street": "Steinbergen 37",
            "ZIP": "47589",
            "City": "Uedem",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Schulz",
            "id": "1299-000",
            "text": "Reitstall Schulz in Brakel (Nr.1299-000)",
            "Street": "Zum Tiefental  9",
            "ZIP": "33034",
            "City": "Brakel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Schoemann",
            "id": "1300-000",
            "text": "Reitstall Schoemann in Warpe (Nr.1300-000)",
            "Street": "Windhorst 14",
            "ZIP": "27333",
            "City": "Warpe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Bies",
            "id": "1301-000",
            "text": "Privatstall Bies in Kleve (Nr.1301-000)",
            "Street": "Südendörp  21",
            "ZIP": "25779",
            "City": "Kleve",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Johannsen",
            "id": "1302-000",
            "text": "Privatstall Johannsen in Borstel (Nr.1302-000)",
            "Street": "Sether Straße 14",
            "ZIP": "23845",
            "City": "Borstel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ginsterhof",
            "id": "1303-000",
            "text": "Ginsterhof in Wulfstorf (Nr.1303-000)",
            "Street": "Ginsterweg 6",
            "ZIP": "29553",
            "City": "Wulfstorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Kambergs",
            "id": "1304-000",
            "text": "Pferdepension Kambergs in Viersen (Nr.1304-000)",
            "Street": "Hochfeld 1",
            "ZIP": "41751",
            "City": "Viersen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Flemming",
            "id": "1305-000",
            "text": "Stall Flemming in Walsrode (Nr.1305-000)",
            "Street": "Hamwiede 4",
            "ZIP": "29664",
            "City": "Walsrode",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionspferdehaltung Thelen",
            "id": "1306-000",
            "text": "Pensionspferdehaltung Thelen in Geilenkirchen (Nr.1306-000)",
            "Street": "Hatterather Weg 11",
            "ZIP": "52511",
            "City": "Geilenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Welter",
            "id": "1307-000",
            "text": "Reitstall Welter in Dormagen (Nr.1307-000)",
            "Street": "Marienhof 1",
            "ZIP": "41542",
            "City": "Dormagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Krebs",
            "id": "1308-000",
            "text": "Privatstall Krebs in Wiedensahl (Nr.1308-000)",
            "Street": "In der Hespe  19",
            "ZIP": "31719",
            "City": "Wiedensahl",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fürst",
            "id": "1309-000",
            "text": "Privatstall Fürst in Bülkau (Nr.1309-000)",
            "Street": "Süderende ",
            "ZIP": "21782",
            "City": "Bülkau",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "B&B Reitstall Hesel",
            "id": "1310-000",
            "text": "B&B Reitstall Hesel in Hesel (Nr.1310-000)",
            "Street": "Vorwerker str 11",
            "ZIP": "26835",
            "City": "Hesel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Gödde",
            "id": "1311-000",
            "text": "Reitstall Gödde in Dortmund (Nr.1311-000)",
            "Street": "Ostberger Str.  19",
            "ZIP": "44289",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Steiner",
            "id": "1312-000",
            "text": "Privatstall Steiner in Nahe (Nr.1312-000)",
            "Street": "Hauen 40",
            "ZIP": "23866",
            "City": "Nahe",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schulzentrum ",
            "id": "1313-000",
            "text": "Hof Schulzentrum  in Schneverdingen  (Nr.1313-000)",
            "Street": "Goosekamp  10",
            "ZIP": "29640",
            "City": "Schneverdingen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schildt",
            "id": "1314-000",
            "text": "Privatstall Schildt in Westerkappeln (Nr.1314-000)",
            "Street": "Hollenbergs Hügel  62",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Stern",
            "id": "1315-000",
            "text": "Privatstall Stern in  Eystrup (Nr.1315-000)",
            "Street": "Am Geestrand  6",
            "ZIP": "27324",
            "City": " Eystrup",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hammerich",
            "id": "1316-000",
            "text": "Hof Hammerich in Osdorf (Nr.1316-000)",
            "Street": "Haferrögen 100",
            "ZIP": "24251",
            "City": "Osdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Laumann",
            "id": "1317-000",
            "text": "Privatstall Laumann in Hörstel-Bevergern (Nr.1317-000)",
            "Street": "Kleiner Send  10",
            "ZIP": "48477",
            "City": "Hörstel-Bevergern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RSG Herne Börnig",
            "id": "1318-000",
            "text": "RSG Herne Börnig in Herne (Nr.1318-000)",
            "Street": "Sodingerstraße 563",
            "ZIP": "44623",
            "City": "Herne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Kücker ",
            "id": "1319-000",
            "text": "Reitstall Kücker  in Bielefeld (Nr.1319-000)",
            "Street": "Hobusch 28",
            "ZIP": "33619",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Riegels ",
            "id": "1320-000",
            "text": "Privatstall Riegels  in Velbert  (Nr.1320-000)",
            "Street": "Ewald-Jochemstr. 17",
            "ZIP": "42553",
            "City": "Velbert ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Tietz",
            "id": "1321-000",
            "text": "Privatstall Tietz in Emmerich (Nr.1321-000)",
            "Street": "Zum Waldkreuz 160",
            "ZIP": "46446",
            "City": "Emmerich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Otte in Holte",
            "id": "1322-000",
            "text": "Privatstall Otte in Holte in Ostercappeln (Nr.1322-000)",
            "Street": "Dreskenkamp  7",
            "ZIP": "49179",
            "City": "Ostercappeln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Springer",
            "id": "1323-000",
            "text": "Reitstall Springer in Großheide (Nr.1323-000)",
            "Street": "Schulweg  10a",
            "ZIP": "26532",
            "City": "Großheide",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Bannierink",
            "id": "1324-000",
            "text": "Reitstall Bannierink in Neuenkirchen (Nr.1324-000)",
            "Street": "Haarweg 75",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Pleßner ",
            "id": "1325-000",
            "text": "Privatstall Pleßner  in Telgte  (Nr.1325-000)",
            "Street": "Harkampsheide  4",
            "ZIP": "48291",
            "City": "Telgte ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "T Pompje Appeldoorn ",
            "id": "NL041-000",
            "text": "T Pompje Appeldoorn  in Apeldoorn  (Nr.NL041-000)",
            "Street": "Rumbastraat  71",
            "ZIP": "7323RL ",
            "City": "Apeldoorn ",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Holleman Stables ",
            "id": "NL042-000",
            "text": "Holleman Stables  in Huissen  (Nr.NL042-000)",
            "Street": "Papesestraat  4",
            "ZIP": "6851 DS ",
            "City": "Huissen ",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Brackmann ",
            "id": "1326-000",
            "text": "Brackmann  in Gehrde  (Nr.1326-000)",
            "Street": "Forststraße  12",
            "ZIP": "49596",
            "City": "Gehrde ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pakheiser ",
            "id": "1327-000",
            "text": "Pakheiser  in Burweg  (Nr.1327-000)",
            "Street": "Im Ring  7",
            "ZIP": "21709",
            "City": "Burweg ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Klug ",
            "id": "1328-000",
            "text": "Privatstall Klug  in Eydelstedt  (Nr.1328-000)",
            "Street": "Holzort  2",
            "ZIP": "49406",
            "City": "Eydelstedt ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wilke ",
            "id": "1329-000",
            "text": "Privatstall Wilke  in Drentwede  (Nr.1329-000)",
            "Street": "Große Heide  1",
            "ZIP": "49406",
            "City": "Drentwede ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Rensch ",
            "id": "1330-000",
            "text": "Reitstall Rensch  in Handewitt  (Nr.1330-000)",
            "Street": "Lecker Chaussee  18A ",
            "ZIP": "24983",
            "City": "Handewitt ",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Eichenhof",
            "id": "1331-000",
            "text": "Eichenhof in Ebstorf (Nr.1331-000)",
            "Street": "Im Winkel 2",
            "ZIP": "29574",
            "City": "Ebstorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Katharina Bostenmann",
            "id": "1332-000",
            "text": "Katharina Bostenmann in Neetze/Neu-Neetze (Nr.1332-000)",
            "Street": "Fraaschweg 3",
            "ZIP": "21398",
            "City": "Neetze/Neu-Neetze",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitgemeinschaft 77",
            "id": "1333-000",
            "text": "Reitgemeinschaft 77 in Essen Dellwig (Nr.1333-000)",
            "Street": "Klaumerbruch 40a",
            "ZIP": "45357",
            "City": "Essen Dellwig",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Gründker",
            "id": "1334-000",
            "text": "Privatstall Gründker in Rheine (Nr.1334-000)",
            "Street": "Dahlkampstraße  15",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Auringer",
            "id": "1335-000",
            "text": "Privatstall Auringer in Hemslingen (Nr.1335-000)",
            "Street": "Bockshorst  22",
            "ZIP": "27386",
            "City": "Hemslingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Meißner",
            "id": "1336-000",
            "text": "Reitstall Meißner in Wetter (Nr.1336-000)",
            "Street": "Auf Schölling  1",
            "ZIP": "58300",
            "City": "Wetter",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Koss",
            "id": "1337-000",
            "text": "Privatstall Koss in Stolzenau (Nr.1337-000)",
            "Street": "Krumme Straße ",
            "ZIP": "31592",
            "City": "Stolzenau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatadresse Hollje",
            "id": "1338-000",
            "text": "Privatadresse Hollje in Wardenburg (Nr.1338-000)",
            "Street": "Garreler Straße  128",
            "ZIP": "26203",
            "City": "Wardenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-RG",
            "text": "Loesdau Filiale in Rosengarten (Nr.LD-RG)",
            "Street": "Am Hatzberg  5",
            "ZIP": "21224",
            "City": "Rosengarten",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-LEH",
            "text": "Loesdau Filiale in Lehrte-Aligse (Nr.LD-LEH)",
            "Street": "Rudolf-Petzold-Ring  7",
            "ZIP": "31275",
            "City": "Lehrte-Aligse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-MUE",
            "text": "Loesdau Filiale in Mülheim an der Ruhr (Nr.LD-MUE)",
            "Street": "Duisburger Straße  399",
            "ZIP": "45478",
            "City": "Mülheim an der Ruhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-REK",
            "text": "Loesdau Filiale in Recklinghausen (Nr.LD-REK)",
            "Street": "Schmalkalder Straße  8",
            "ZIP": "45665",
            "City": "Recklinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-ERF",
            "text": "Loesdau Filiale in Erftstadt (Nr.LD-ERF)",
            "Street": "Albert-Einstein-Ring  8",
            "ZIP": "50374",
            "City": "Erftstadt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-RUE",
            "text": "Loesdau Filiale in Rüsselsheim-Königstädten (Nr.LD-RUE)",
            "Street": "Alexander-Fleming-Ring  39",
            "ZIP": "65428",
            "City": "Rüsselsheim-Königstädten",
            "Bundesland": "Hessen",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-MOE",
            "text": "Loesdau Filiale in Möglingen (Nr.LD-MOE)",
            "Street": "Raiffeisenstraße  7",
            "ZIP": "71696",
            "City": "Möglingen",
            "Bundesland": "Baden-Württemberg",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-BIS",
            "text": "Loesdau Filiale in Bisingen / Hohenzollern (Nr.LD-BIS)",
            "Street": "Hechinger Straße  58",
            "ZIP": "72406",
            "City": "Bisingen / Hohenzollern",
            "Bundesland": "Baden-Württemberg",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-RT",
            "text": "Loesdau Filiale in Reutlingen (Nr.LD-RT)",
            "Street": "Tübinger Straße  75",
            "ZIP": "72762",
            "City": "Reutlingen",
            "Bundesland": "Baden-Württemberg",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-VS",
            "text": "Loesdau Filiale in VS-Villingen (Nr.LD-VS)",
            "Street": "Vockenhauser Straße  26",
            "ZIP": "78048",
            "City": "VS-Villingen",
            "Bundesland": "Baden-Württemberg",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-FI",
            "text": "Loesdau Filiale in Forstinning-Moos (Nr.LD-FI)",
            "Street": "Römerstraße  16",
            "ZIP": "85661",
            "City": "Forstinning-Moos",
            "Bundesland": "Bayern",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-FRI",
            "text": "Loesdau Filiale in Friedberg (Nr.LD-FRI)",
            "Street": "Winterbruckenweg  56",
            "ZIP": "86316",
            "City": "Friedberg",
            "Bundesland": "Bayern",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-WG",
            "text": "Loesdau Filiale in Weingarten (Nr.LD-WG)",
            "Street": "Friedrich-Seifriz-Str.  2",
            "ZIP": "88250",
            "City": "Weingarten",
            "Bundesland": "Baden-Württemberg",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-HES",
            "text": "Loesdau Filiale in Heßdorf (Nr.LD-HES)",
            "Street": "Im Gewerbepark  37",
            "ZIP": "91093",
            "City": "Heßdorf",
            "Bundesland": "Bayern",
            "Land": "Deutschland"
        },
        {
            "name": "Loesdau Filiale",
            "id": "LD-WOE",
            "text": "Loesdau Filiale in Wörnitz (Nr.LD-WOE)",
            "Street": "Am Kreisel  3",
            "ZIP": "91637",
            "City": "Wörnitz",
            "Bundesland": "Bayern",
            "Land": "Deutschland"
        },
        {
            "name": "Markwitz ",
            "id": "1339-000",
            "text": "Markwitz  in Heersum  (Nr.1339-000)",
            "Street": "Neuer Weg  10",
            "ZIP": "31188",
            "City": "Heersum ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Halnerg ",
            "id": "1340-000",
            "text": "Gestüt Halnerg  in Hennef  (Nr.1340-000)",
            "Street": "Halberg  2",
            "ZIP": "53773",
            "City": "Hennef ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Schade ",
            "id": "1341-000",
            "text": "Schade  in Hohenlockstedt (Nr.1341-000)",
            "Street": "Ridders  58",
            "ZIP": "25551",
            "City": "Hohenlockstedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Landreitschule ",
            "id": "1342-000",
            "text": "Landreitschule  in Velbert  (Nr.1342-000)",
            "Street": "Donnenberger Str.  145",
            "ZIP": "42553",
            "City": "Velbert ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Mentzenhof",
            "id": "1343-000",
            "text": "Mentzenhof in Ense (Nr.1343-000)",
            "Street": "Mawickerstr. 3",
            "ZIP": "59469",
            "City": "Ense",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Jäger ",
            "id": "1344-000",
            "text": "Jäger  in Petershagen (Nr.1344-000)",
            "Street": "Heidberg  7",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Pintado",
            "id": "1345-000",
            "text": "Hof Pintado in Lindau (Nr.1345-000)",
            "Street": "Sander Weg 19",
            "ZIP": "24214",
            "City": "Lindau",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "SL Sporthorses ",
            "id": "1346-000",
            "text": "SL Sporthorses  in Gladbeck  (Nr.1346-000)",
            "Street": "Voßbrinkstraße  67",
            "ZIP": "45966",
            "City": "Gladbeck ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hegemeister ",
            "id": "1347-000",
            "text": "Hegemeister  in Espelkamp (Nr.1347-000)",
            "Street": "Fabbenstedter Straße  32",
            "ZIP": "32339",
            "City": "Espelkamp",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit Club Oberhausen",
            "id": "1348-000",
            "text": "Reit Club Oberhausen in Oberhausen (Nr.1348-000)",
            "Street": "Bauerfeld 159",
            "ZIP": "46045",
            "City": "Oberhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Heitmann",
            "id": "1349-000",
            "text": "Hof Heitmann in Werne (Nr.1349-000)",
            "Street": "Am Reiterhof 5",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Germann",
            "id": "1350-000",
            "text": "Germann in Lütetsburg  (Nr.1350-000)",
            "Street": "Lütetsburgerlandstraße 68",
            "ZIP": "26524",
            "City": "Lütetsburg ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Silies ",
            "id": "1351-000",
            "text": "Silies  in Emsbüren  (Nr.1351-000)",
            "Street": "Im Dunkern  1",
            "ZIP": "48488",
            "City": "Emsbüren ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Horse Competence ",
            "id": "1352-000",
            "text": "Horse Competence  in Beverstedt (Nr.1352-000)",
            "Street": "Am Blumenkamp  1",
            "ZIP": "27616",
            "City": "Beverstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schröder-Meyer Hof ",
            "id": "1353-000",
            "text": "Schröder-Meyer Hof  in Wienhausen-Bockelskamp  (Nr.1353-000)",
            "Street": "Ortfeld  1",
            "ZIP": "29342",
            "City": "Wienhausen-Bockelskamp ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Heidlooger Hof ",
            "id": "1354-000",
            "text": "Heidlooger Hof  in Varel (Nr.1354-000)",
            "Street": "Heidlooger Weg 2",
            "ZIP": "26316",
            "City": "Varel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstal Pinkster",
            "id": "NL040-000",
            "text": "Privatstal Pinkster in Enschede (Nr.NL040-000)",
            "Street": "Zuid Esmarkerrondweg 352",
            "ZIP": "7535DW",
            "City": "Enschede",
            "Bundesland": "Niederlande",
            "Land": "Deutschland"
        },
        {
            "name": "Ausbildungs- und Therapiezentrum Handorf",
            "id": "1355-000",
            "text": "Ausbildungs- und Therapiezentrum Handorf in Handorf (Nr.1355-000)",
            "Street": "Kiefernweg 29",
            "ZIP": "21447",
            "City": "Handorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Anika Siltmann",
            "id": "1356-000",
            "text": "Anika Siltmann in Grafeld (Nr.1356-000)",
            "Street": "Herzlaker Straße 44",
            "ZIP": "49626",
            "City": "Grafeld",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Schulte Hobein",
            "id": "1357-000",
            "text": "Schulte Hobein in Sundern (Nr.1357-000)",
            "Street": "Am Krausen Baum 11",
            "ZIP": "59846",
            "City": "Sundern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Ernst",
            "id": "1358-000",
            "text": "Hof Ernst in Marxen  (Nr.1358-000)",
            "Street": "Hauptstraße  5",
            "ZIP": "21439",
            "City": "Marxen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Tierische Begleiter",
            "id": "1359-000",
            "text": "Tierische Begleiter in Bielefeld (Nr.1359-000)",
            "Street": "Veerhoffstraße 20",
            "ZIP": "33649",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eichenhof",
            "id": "1360-000",
            "text": "Eichenhof in Geestland (Nr.1360-000)",
            "Street": "Reiterweg 7",
            "ZIP": "27607",
            "City": "Geestland",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Meggers",
            "id": "1361-000",
            "text": "Reitstall Meggers in Schwedeneck (Nr.1361-000)",
            "Street": "Gettorfer Landstr. 2",
            "ZIP": "24229",
            "City": "Schwedeneck",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wischemann",
            "id": "1362-000",
            "text": "Privatstall Wischemann in Ochtrup (Nr.1362-000)",
            "Street": "Wester 261",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Depembrock",
            "id": "1363-000",
            "text": "Privatstall Depembrock in Telgte  (Nr.1363-000)",
            "Street": "Kortenkamp 18",
            "ZIP": "48291",
            "City": "Telgte ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Breer",
            "id": "1364-000",
            "text": "Reitstall Breer in Werne (Nr.1364-000)",
            "Street": "Am Sunderbach 3",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal Schaerweijde",
            "id": "NL043-000",
            "text": "Stal Schaerweijde in Zeist (Nr.NL043-000)",
            "Street": "Burgemeester Patijnlaan 57",
            "ZIP": "3705 CB",
            "City": "Zeist",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Stal Tolhuis",
            "id": "NL044-000",
            "text": "Stal Tolhuis in Loenen (Nr.NL044-000)",
            "Street": "Groenendaalseweg ",
            "ZIP": "7371ez",
            "City": "Loenen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Huismann",
            "id": "1365-000",
            "text": "Privatstall Huismann in Ihlow (Nr.1365-000)",
            "Street": "Fennenstraße  17",
            "ZIP": "26632",
            "City": "Ihlow",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Eiken",
            "id": "1366-000",
            "text": "Privatstall Eiken in Ahlen (Nr.1366-000)",
            "Street": "Hauptstraße 11",
            "ZIP": "26892",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Krusenhoff",
            "id": "1367-000",
            "text": "Reitstall Krusenhoff in Kirchlinteln (Nr.1367-000)",
            "Street": "Verdenermoorstraße 1",
            "ZIP": "27308",
            "City": "Kirchlinteln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Jordan",
            "id": "1368-000",
            "text": "Reitstall Jordan in Gifhorn (Nr.1368-000)",
            "Street": "Wendenerstraße 18",
            "ZIP": "38527",
            "City": "Gifhorn",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Tönns ",
            "id": "1369-000",
            "text": "Hof Tönns  in Marxen  (Nr.1369-000)",
            "Street": "Lindenallee 30",
            "ZIP": "21439",
            "City": "Marxen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Aktivlaufstall Wessing",
            "id": "1370-000",
            "text": "Aktivlaufstall Wessing in Borken (Nr.1370-000)",
            "Street": "Sonnenbrink 60",
            "ZIP": "46325",
            "City": "Borken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Doepke",
            "id": "1371-000",
            "text": "Privatstall Doepke in Zetel (Nr.1371-000)",
            "Street": "An der Eiche 11",
            "ZIP": "26340",
            "City": "Zetel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wettersberg",
            "id": "1372-000",
            "text": "Hof Wettersberg in Haale (Nr.1372-000)",
            "Street": "Wettersberg 20",
            "ZIP": "24819",
            "City": "Haale",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Storb ",
            "id": "1373-000",
            "text": "Privatstall Storb  in Mühlheim an der Ruhr (Nr.1373-000)",
            "Street": "Hansbergstraße 1",
            "ZIP": "45472",
            "City": "Mühlheim an der Ruhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Praxis für Physiotherapie",
            "id": "1374-000",
            "text": "Praxis für Physiotherapie in Hambühren (Nr.1374-000)",
            "Street": "Mittelstraße 25",
            "ZIP": "29313",
            "City": "Hambühren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rickert",
            "id": "1375-000",
            "text": "Privatstall Rickert in Winsen-Luhe (Nr.1375-000)",
            "Street": "Pattenser Hauptstraße 30",
            "ZIP": "21423",
            "City": "Winsen-Luhe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Waterboer",
            "id": "1376-000",
            "text": "Reitstall Waterboer in Bielefeld (Nr.1376-000)",
            "Street": "Waterboerstraße  77b",
            "ZIP": "33659",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Nohn",
            "id": "1377-000",
            "text": "Privatstall Nohn in Sankt Augustin (Nr.1377-000)",
            "Street": "Langstraße  5",
            "ZIP": "53757",
            "City": "Sankt Augustin",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Wocklum",
            "id": "1378-000",
            "text": "Reitanlage Wocklum in Balve (Nr.1378-000)",
            "Street": "Wocklumer Allee  7",
            "ZIP": "58802",
            "City": "Balve",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal Hagen",
            "id": "NL045-000",
            "text": "Stal Hagen in Appeldoorn (Nr.NL045-000)",
            "Street": "De Hegge 63",
            "ZIP": "7314JR",
            "City": "Appeldoorn",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Gast",
            "id": "1379-000",
            "text": "Privatstall Gast in Burgwedel (Nr.1379-000)",
            "Street": "Alter Postweg  5b",
            "ZIP": "30938",
            "City": "Burgwedel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathaus Andreas/Recke",
            "id": "1380-000",
            "text": "Privathaus Andreas/Recke in Hannover (Nr.1380-000)",
            "Street": "Kleifeld 5",
            "ZIP": "30539",
            "City": "Hannover",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Apfelhof",
            "id": "1381-000",
            "text": "Reitstall Apfelhof in Marschacht (Nr.1381-000)",
            "Street": "Elbuferstraße  29a",
            "ZIP": "21436",
            "City": "Marschacht",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Eckay",
            "id": "1382-000",
            "text": "Reitstall Eckay in Hamm (Nr.1382-000)",
            "Street": "Dasbeck  16",
            "ZIP": "59073",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reistall Erkes",
            "id": "1383-000",
            "text": "Reistall Erkes in Viersen (Nr.1383-000)",
            "Street": "Heyerhöfe  1",
            "ZIP": "41751",
            "City": "Viersen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Thiel",
            "id": "1384-000",
            "text": "Privatstall Thiel in Diemelsee (Nr.1384-000)",
            "Street": "Steinweg 3",
            "ZIP": "34519",
            "City": "Diemelsee",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Silberberg ",
            "id": "1385-000",
            "text": "Privatstall Silberberg  in Oer-Erkenschwick (Nr.1385-000)",
            "Street": "Mühlenweg  234",
            "ZIP": "45739",
            "City": "Oer-Erkenschwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Matischewitz",
            "id": "1386-000",
            "text": "Privatstall Matischewitz in Brunsbüttel (Nr.1386-000)",
            "Street": "Gerhart-Hauptmann-Straße 18",
            "ZIP": "25541",
            "City": "Brunsbüttel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Genuneit",
            "id": "1387-000",
            "text": "Privatstall Genuneit in Varel (Nr.1387-000)",
            "Street": "Zum Jadebusen  180a",
            "ZIP": "26316",
            "City": "Varel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Szillat",
            "id": "1388-000",
            "text": "Reitstall Szillat in Clauen (Nr.1388-000)",
            "Street": "Schlütenstraße  19",
            "ZIP": "31249",
            "City": "Clauen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kellerhof Fam. Keller",
            "id": "1389-000",
            "text": "Kellerhof Fam. Keller in Coesfeld (Nr.1389-000)",
            "Street": "Harle  35",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schumacher",
            "id": "1390-000",
            "text": "Stall Schumacher in Friesoythe (Nr.1390-000)",
            "Street": "An der Berme 2",
            "ZIP": "26169",
            "City": "Friesoythe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schnäbele",
            "id": "1391-000",
            "text": "Stall Schnäbele in Adendorf (Nr.1391-000)",
            "Street": "Grüner-Jäger-Weg ",
            "ZIP": "21365",
            "City": "Adendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Höge",
            "id": "1392-000",
            "text": "Hof Höge in Oeyten (Nr.1392-000)",
            "Street": "Klein Hollen 33",
            "ZIP": "28876",
            "City": "Oeyten",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Mühlenhof",
            "id": "1393-000",
            "text": "Mühlenhof in Greven - Gimbte (Nr.1393-000)",
            "Street": "Mühlenweg  33",
            "ZIP": "48268",
            "City": "Greven - Gimbte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal de Koster",
            "id": "NL046-000",
            "text": "Stal de Koster in Eeserveen (Nr.NL046-000)",
            "Street": "Brammershoopstraat  7",
            "ZIP": "7858 TB",
            "City": "Eeserveen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reitstall Palmberg",
            "id": "1394-000",
            "text": "Reitstall Palmberg in Soest (Nr.1394-000)",
            "Street": "Gartenkamp 15",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV Legden e.V.",
            "id": "1395-000",
            "text": "ZRFV Legden e.V. in Legden (Nr.1395-000)",
            "Street": "Bleikenkamp 20",
            "ZIP": "48739",
            "City": "Legden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Helgihof",
            "id": "1396-000",
            "text": "Helgihof in Twistringen (Nr.1396-000)",
            "Street": "Nienburger Straße  123",
            "ZIP": "27239",
            "City": "Twistringen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ehlers",
            "id": "1397-000",
            "text": "Privatstall Ehlers in Lemwerder (Nr.1397-000)",
            "Street": "Ollenstraße  2",
            "ZIP": "27809",
            "City": "Lemwerder",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Horsewellfarm Niederrhein",
            "id": "1398-000",
            "text": "Horsewellfarm Niederrhein in Issum (Nr.1398-000)",
            "Street": "Nordring  155",
            "ZIP": "47661",
            "City": "Issum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kersting ",
            "id": "1399-000",
            "text": "Privatstall Kersting  in Dorsten (Nr.1399-000)",
            "Street": "Philosophenweg 10",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Minzera",
            "id": "1400-000",
            "text": "Privatstall Minzera in Halle (Nr.1400-000)",
            "Street": "Eichenweg 21a",
            "ZIP": "33790",
            "City": "Halle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stap voor stap Paardencoaching",
            "id": "NL047-000",
            "text": "Stap voor stap Paardencoaching in Zaandijk (Nr.NL047-000)",
            "Street": "Prunuslaan 34",
            "ZIP": "1544PP",
            "City": "Zaandijk",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Stall Stegmann",
            "id": "1401-000",
            "text": "Stall Stegmann in Twistringen (Nr.1401-000)",
            "Street": "Steinstraße  12",
            "ZIP": "27239",
            "City": "Twistringen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schlieske",
            "id": "1402-000",
            "text": "Privatstall Schlieske in Petershagen (Nr.1402-000)",
            "Street": "Bockmühlenweg 3",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kullmann",
            "id": "1403-000",
            "text": "Privatstall Kullmann in Celle (Nr.1403-000)",
            "Street": "Hannoversche Herrstr. 160",
            "ZIP": "29227",
            "City": "Celle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Reineke",
            "id": "1404-000",
            "text": "Hof Reineke in Hemmingen (Nr.1404-000)",
            "Street": "Heifeld 4",
            "ZIP": "30966",
            "City": "Hemmingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hoster ",
            "id": "1405-000",
            "text": "Hof Hoster  in Issum (Nr.1405-000)",
            "Street": "Großholthuysen  31",
            "ZIP": "47661",
            "City": "Issum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Jostes",
            "id": "1406-000",
            "text": "Reitstall Jostes in Mühlheim an der Ruhr (Nr.1406-000)",
            "Street": "Mintarder Straße  101",
            "ZIP": "45481",
            "City": "Mühlheim an der Ruhr",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Paddock Trail Müller",
            "id": "1407-000",
            "text": "Paddock Trail Müller in Wegberg (Nr.1407-000)",
            "Street": "Marktstraße  21",
            "ZIP": "41844",
            "City": "Wegberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Möllmann",
            "id": "1408-000",
            "text": "Privatstall Möllmann in Selm (Nr.1408-000)",
            "Street": "Strandweg 2",
            "ZIP": "59379",
            "City": "Selm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Litjes",
            "id": "1409-000",
            "text": "Reitstall Litjes in Weeze (Nr.1409-000)",
            "Street": "Niederhelsum 23a",
            "ZIP": "47652",
            "City": "Weeze",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Semmelhack ",
            "id": "1410-000",
            "text": "Reitstall Semmelhack  in Engelbrechtsche Wildnis (Nr.1410-000)",
            "Street": "Obendeich 2",
            "ZIP": "25379",
            "City": "Engelbrechtsche Wildnis",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Franzen",
            "id": "1412-000",
            "text": "Reitanlage Franzen in Korschenbroich (Nr.1412-000)",
            "Street": "Krünsend 1",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Urbaniak",
            "id": "1413-000",
            "text": "Privatstall Urbaniak in Beesten (Nr.1413-000)",
            "Street": "Waldstraße 1",
            "ZIP": "49832",
            "City": "Beesten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Hof Heling",
            "id": "1414-000",
            "text": "Pensionsstall Hof Heling in Ahaus  (Nr.1414-000)",
            "Street": "Averesch 18",
            "ZIP": "48683",
            "City": "Ahaus ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hulingshof Kempen",
            "id": "1415-000",
            "text": "Hulingshof Kempen in Kempen (Nr.1415-000)",
            "Street": "Klixdorfer Straße  16",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Balve",
            "id": "1416-000",
            "text": "RV Balve in Balve (Nr.1416-000)",
            "Street": "Wocklum  14",
            "ZIP": "58802",
            "City": "Balve",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Schlß Söder",
            "id": "1417-000",
            "text": "Reitstall Schlß Söder in Holle (Nr.1417-000)",
            "Street": "Hainbergstraße 13",
            "ZIP": "31188",
            "City": "Holle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuFV Samern",
            "id": "1418-000",
            "text": "RuFV Samern in Samern (Nr.1418-000)",
            "Street": "Salzbergener Str.  93",
            "ZIP": "48465",
            "City": "Samern",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Ruthemeier",
            "id": "1419-000",
            "text": "Stall Ruthemeier in Osterholz-Scharmbeck (Nr.1419-000)",
            "Street": "Röntgenstraße 14",
            "ZIP": "27711",
            "City": "Osterholz-Scharmbeck",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal Schuur",
            "id": "NL048-000",
            "text": "Stal Schuur in Oude Pekela (Nr.NL048-000)",
            "Street": "Oogstlaan 8",
            "ZIP": "9665AG",
            "City": "Oude Pekela",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Holz",
            "id": "1420-000",
            "text": "Privatstall Holz in Mittelangeln (Nr.1420-000)",
            "Street": "Norderholz Weg  1a",
            "ZIP": "24986",
            "City": "Mittelangeln",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Otte",
            "id": "1421-000",
            "text": "Privatstall Otte in Wuppertal (Nr.1421-000)",
            "Street": "Untenrohleder  4",
            "ZIP": "42111",
            "City": "Wuppertal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Kaiser ",
            "id": "1422-000",
            "text": "Stall Kaiser  in Seevetal  (Nr.1422-000)",
            "Street": "Am Heestern  28",
            "ZIP": "21218",
            "City": "Seevetal ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Star Light Ranch",
            "id": "1423-000",
            "text": "Star Light Ranch in Essen (Nr.1423-000)",
            "Street": "Langestraße  144",
            "ZIP": "45307",
            "City": "Essen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Heinze",
            "id": "1424-000",
            "text": "Privatstall Heinze in Lemgo (Nr.1424-000)",
            "Street": "Strüher Straße 94",
            "ZIP": "32657",
            "City": "Lemgo",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Niehoff ",
            "id": "1425-000",
            "text": "Niehoff  in Gronau (Nr.1425-000)",
            "Street": "Saarstraße  6",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Steinhoff ",
            "id": "1426-000",
            "text": "Privatstall Steinhoff  in Wickede (Nr.1426-000)",
            "Street": "Hopfenkamp 15",
            "ZIP": "58739",
            "City": "Wickede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitponyzucht Urienne",
            "id": "1427-000",
            "text": "Reitponyzucht Urienne in Sprockhövel  (Nr.1427-000)",
            "Street": "Hedtbleck 4",
            "ZIP": "45549",
            "City": "Sprockhövel ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyclub Ohlendorf Jugendfarm e.V.",
            "id": "1428-000",
            "text": "Ponyclub Ohlendorf Jugendfarm e.V. in Seevetal  (Nr.1428-000)",
            "Street": "Alter Postweg  160",
            "ZIP": "21220",
            "City": "Seevetal ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Dressurstal Mate & Copains",
            "id": "NL049-000",
            "text": "Dressurstal Mate & Copains in Schiedam  (Nr.NL049-000)",
            "Street": "Polderweg 208",
            "ZIP": "3125KH ",
            "City": "Schiedam ",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Hof Lobbel ",
            "id": "1429-000",
            "text": "Hof Lobbel  in Horstmar-Leer (Nr.1429-000)",
            "Street": "Ostendorf  72",
            "ZIP": "48612",
            "City": "Horstmar-Leer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schweer",
            "id": "1430-000",
            "text": "Hof Schweer in Wiedensahl (Nr.1430-000)",
            "Street": "Bahnhofstraße ",
            "ZIP": "31719",
            "City": "Wiedensahl",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Vierthof",
            "id": "1431-000",
            "text": "Vierthof in Albersdorf (Nr.1431-000)",
            "Street": "Vierthof 2",
            "ZIP": "25767",
            "City": "Albersdorf",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Dressurstal Mate & Copains",
            "id": "NL050-000",
            "text": "Dressurstal Mate & Copains in Schiedam  (Nr.NL050-000)",
            "Street": "Polderweg 208",
            "ZIP": "3125KH ",
            "City": "Schiedam ",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reiterhof Benien",
            "id": "1432-000",
            "text": "Reiterhof Benien in Bottrop Kirchhellen (Nr.1432-000)",
            "Street": "Hofwiese 26",
            "ZIP": "46244",
            "City": "Bottrop Kirchhellen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "De Zonnehoeve",
            "id": "NL051-000",
            "text": "De Zonnehoeve in Zeewolde (Nr.NL051-000)",
            "Street": "Priempad 5",
            "ZIP": "3896LJ",
            "City": "Zeewolde",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reitstall Elisenhof ",
            "id": "1433-000",
            "text": "Reitstall Elisenhof  in Hörstel (Nr.1433-000)",
            "Street": "Elisenhofstraße 5",
            "ZIP": "48477",
            "City": "Hörstel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule Peters",
            "id": "1434-000",
            "text": "Reitschule Peters in Heinsberg  (Nr.1434-000)",
            "Street": "Wurmaue  11",
            "ZIP": "52525",
            "City": "Heinsberg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Höwer",
            "id": "1435-000",
            "text": "Privatstall Höwer in Schmallenberg- Grafschaft (Nr.1435-000)",
            "Street": "Hauptstraße  17",
            "ZIP": "57392",
            "City": "Schmallenberg- Grafschaft",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponystall ",
            "id": "1436-000",
            "text": "Ponystall  in Stöckse (Nr.1436-000)",
            "Street": "In der Twacht  9",
            "ZIP": "31638",
            "City": "Stöckse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Gut Abtshof",
            "id": "1437-000",
            "text": "Reitanlage Gut Abtshof in Mönchengladbach (Nr.1437-000)",
            "Street": "Krefelder Straße  726",
            "ZIP": "41066",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fohlenhof Felsen in Herzlake",
            "id": "1438-000",
            "text": "Fohlenhof Felsen in Herzlake in Herzlake (Nr.1438-000)",
            "Street": "An der Högede 3",
            "ZIP": "49770",
            "City": "Herzlake",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Drakenburg ",
            "id": "1439-000",
            "text": "Hof Drakenburg  in Drakenburg (Nr.1439-000)",
            "Street": "Liethenkämpen 3",
            "ZIP": "31623",
            "City": "Drakenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Pulheim Frechen",
            "id": "1440-000",
            "text": "Reiterhof Pulheim Frechen in Pulheim (Nr.1440-000)",
            "Street": "Bonnstraße ",
            "ZIP": "50259",
            "City": "Pulheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Lanner Marschhof ",
            "id": "1441-000",
            "text": "Lanner Marschhof  in Hetlingen (Nr.1441-000)",
            "Street": "Grüner Damm  14",
            "ZIP": "25491",
            "City": "Hetlingen",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Sophia Schröder ",
            "id": "1442-000",
            "text": "Reitstall Sophia Schröder  in Isernhagen (Nr.1442-000)",
            "Street": "Dorfstraße  83",
            "ZIP": "30916",
            "City": "Isernhagen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitgemeinschaft Stall Prost ",
            "id": "1443-000",
            "text": "Reitgemeinschaft Stall Prost  in Gelsenkirchen (Nr.1443-000)",
            "Street": "Koesfeld  ",
            "ZIP": "45896",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Hehler ",
            "id": "1444-000",
            "text": "Reitstall Hehler  in Schwalmtal  (Nr.1444-000)",
            "Street": "Hehler 52",
            "ZIP": "41366",
            "City": "Schwalmtal ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Landwirtschaftlicher Betrieb Manuela Pirdzuhn",
            "id": "1445-000",
            "text": "Landwirtschaftlicher Betrieb Manuela Pirdzuhn in Borstel (Nr.1445-000)",
            "Street": "Holmer Weg 6",
            "ZIP": "23845",
            "City": "Borstel",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Manege de Eekwal",
            "id": "NL052-000",
            "text": "Manege de Eekwal in Emmen (Nr.NL052-000)",
            "Street": "Heinweg  17",
            "ZIP": "7814TD",
            "City": "Emmen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Stalhouderij de Vliers",
            "id": "NL053-000",
            "text": "Stalhouderij de Vliers in Dalen (Nr.NL053-000)",
            "Street": "Vliers 11",
            "ZIP": "7751ZS",
            "City": "Dalen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "HypoStore",
            "id": "NL054-000",
            "text": "HypoStore in Emmeloord (Nr.NL054-000)",
            "Street": "Gildenweg 14",
            "ZIP": "8304BC",
            "City": "Emmeloord",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Wellmann",
            "id": "1446-000",
            "text": "Privatstall Wellmann in Metelen (Nr.1446-000)",
            "Street": "Naendorf 95",
            "ZIP": "48629",
            "City": "Metelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Berning",
            "id": "1447-000",
            "text": "Privatstall Berning in Ochtrup (Nr.1447-000)",
            "Street": "Oster 331",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Wittenbergshof ",
            "id": "1448-000",
            "text": "Reitanlage Wittenbergshof  in Sonsbeck (Nr.1448-000)",
            "Street": "Gossendeich 32",
            "ZIP": "47665",
            "City": "Sonsbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reistall Twietenhof",
            "id": "1449-000",
            "text": "Reistall Twietenhof in Winsen-Luhe (Nr.1449-000)",
            "Street": "Brückenfeld 21",
            "ZIP": "21423",
            "City": "Winsen-Luhe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Werner Mahlstedt Pferdezucht",
            "id": "1450-000",
            "text": "Werner Mahlstedt Pferdezucht in Schwanewede (Nr.1450-000)",
            "Street": "Großer Kamp 28",
            "ZIP": "28790",
            "City": "Schwanewede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hoeve Zonnedael",
            "id": "NL055-000",
            "text": "Hoeve Zonnedael in Sint Jacobiparochi (Nr.NL055-000)",
            "Street": "Westeinde 23",
            "ZIP": "9079LH",
            "City": "Sint Jacobiparochi",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reiterhof Kolb",
            "id": "1451-000",
            "text": "Reiterhof Kolb in Sophienhamm (Nr.1451-000)",
            "Street": "Dorfstraße 5",
            "ZIP": "24806",
            "City": "Sophienhamm",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Unsere kleine Ranch ",
            "id": "1452-000",
            "text": "Unsere kleine Ranch  in Edemissen (Nr.1452-000)",
            "Street": "An der Brandwiese 1",
            "ZIP": "31234",
            "City": "Edemissen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wendel ",
            "id": "1453-000",
            "text": "Privatstall Wendel  in Welle (Nr.1453-000)",
            "Street": "Cordshagen  4",
            "ZIP": "21216",
            "City": "Welle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Spliethoff",
            "id": "1454-000",
            "text": "Privatstall Spliethoff in Salzbergen  (Nr.1454-000)",
            "Street": "Neuenkirchener Straße  34",
            "ZIP": "48499",
            "City": "Salzbergen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Nieberg ",
            "id": "1455-000",
            "text": "Reiterhof Nieberg  in Hagen a.T.W. (Nr.1455-000)",
            "Street": "Am Silbersee 18",
            "ZIP": "49170",
            "City": "Hagen a.T.W.",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Britta´s Ponyhof",
            "id": "1456-000",
            "text": "Britta´s Ponyhof in Duisburg (Nr.1456-000)",
            "Street": "Obermeidericher Straße  181A",
            "ZIP": "47138",
            "City": "Duisburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdeparadies Asche ",
            "id": "1457-000",
            "text": "Pferdeparadies Asche  in Petershagen (Nr.1457-000)",
            "Street": "Im Grünen  3",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Kornmasch",
            "id": "1458-000",
            "text": "Reitstall Kornmasch in Bückeburg (Nr.1458-000)",
            "Street": "An der Kornmasch 5",
            "ZIP": "31675",
            "City": "Bückeburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Krützkemper",
            "id": "1459-000",
            "text": "Hof Krützkemper in Münster (Nr.1459-000)",
            "Street": "Roxeler Str 466",
            "ZIP": "48161",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Johannesson Showjumpers",
            "id": "NL056-000",
            "text": "Johannesson Showjumpers in Deurningen (Nr.NL056-000)",
            "Street": "Vliegveldstraat 47",
            "ZIP": "7561 RV",
            "City": "Deurningen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Pferdepension Wübbels",
            "id": "1460-000",
            "text": "Pferdepension Wübbels in Wietmarschen (Nr.1460-000)",
            "Street": "Lohnerbrucher Str. 14",
            "ZIP": "49835",
            "City": "Wietmarschen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Frenz",
            "id": "1461-000",
            "text": "Hof Frenz in Gütersloh (Nr.1461-000)",
            "Street": "Rothaarweg 15",
            "ZIP": "33332",
            "City": "Gütersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Lilienthal",
            "id": "1462-000",
            "text": "Reitverein Lilienthal in Lilienthal (Nr.1462-000)",
            "Street": "Im Orth 11",
            "ZIP": "28865",
            "City": "Lilienthal",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Müller ",
            "id": "1463-000",
            "text": "Privatstall Müller  in Ippensen (Nr.1463-000)",
            "Street": "Zum Feldblick 5",
            "ZIP": "27419",
            "City": "Ippensen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Kikes Pferdebox",
            "id": "1464-000",
            "text": "Kikes Pferdebox in Horn- Bad Meinberg (Nr.1464-000)",
            "Street": "Hoher Weg 10",
            "ZIP": "32805",
            "City": "Horn- Bad Meinberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Long Mountain Ranch",
            "id": "1465-000",
            "text": "Long Mountain Ranch in Schwanewede (Nr.1465-000)",
            "Street": "Langenberger Weg 3",
            "ZIP": "28790",
            "City": "Schwanewede",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ederveen",
            "id": "1466-000",
            "text": "Ederveen in Ederveen (Nr.1466-000)",
            "Street": "Poelweg ",
            "ZIP": "6744 PJ",
            "City": "Ederveen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Privatstall Blömer",
            "id": "1467-000",
            "text": "Privatstall Blömer in Dinklage (Nr.1467-000)",
            "Street": "Lager Straße  7",
            "ZIP": "49413",
            "City": "Dinklage",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sport & Zucht Stall Temmen",
            "id": "1468-000",
            "text": "Sport & Zucht Stall Temmen in Rheine (Nr.1468-000)",
            "Street": "Hohe Allee 101",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Müscher",
            "id": "1469-000",
            "text": "Reiterhof Müscher in Bad Laer (Nr.1469-000)",
            "Street": "Aschendorfer Weg 14",
            "ZIP": "49196",
            "City": "Bad Laer",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Göcking",
            "id": "1470-000",
            "text": "Privathof Göcking in Rheine (Nr.1470-000)",
            "Street": "Osnabrücker Straße 359",
            "ZIP": "48429",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Plugge",
            "id": "1471-000",
            "text": "Privatstall Plugge in Meschede (Nr.1471-000)",
            "Street": "Hoppegarten 35",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hannen",
            "id": "1472-000",
            "text": "Hof Hannen in Wesel (Nr.1472-000)",
            "Street": "Am Spyker 15",
            "ZIP": "46485",
            "City": "Wesel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Kleine",
            "id": "1473-000",
            "text": "Privathof Kleine in Wetter (Nr.1473-000)",
            "Street": "Albringhauser Straße 278",
            "ZIP": "58300",
            "City": "Wetter",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal Conijn",
            "id": "NL057-000",
            "text": "Stal Conijn in Arriën (Nr.NL057-000)",
            "Street": "Dwarsweg 3",
            "ZIP": "7735 KS",
            "City": "Arriën",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Brings",
            "id": "1474-000",
            "text": "Brings in Korschenbroich (Nr.1474-000)",
            "Street": "Jahnstraße 18",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportzentrum Bremervörde ",
            "id": "1476-000",
            "text": "Reitsportzentrum Bremervörde  in Bremervörde (Nr.1476-000)",
            "Street": "Stader Str. 98a",
            "ZIP": "27432",
            "City": "Bremervörde",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Pensionsstall Ramcke",
            "id": "1477-000",
            "text": "Reit- und Pensionsstall Ramcke in Hamburg (Nr.1477-000)",
            "Street": "Schlankweg 30",
            "ZIP": "22587",
            "City": "Hamburg",
            "Bundesland": "Hamburg",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Klaus Reinacher",
            "id": "1478-000",
            "text": "Stall Klaus Reinacher in Rosendahl-Osterwick (Nr.1478-000)",
            "Street": "Holtwicker Straße 56",
            "ZIP": "48720",
            "City": "Rosendahl-Osterwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "DBT GmbH",
            "id": "1479-000",
            "text": "DBT GmbH in Korschenbroich (Nr.1479-000)",
            "Street": "Glehner Heide 3",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitschule Gut Spascher Sand",
            "id": "1480-000",
            "text": "Reitschule Gut Spascher Sand in Wildeshausen (Nr.1480-000)",
            "Street": "Spasche 1",
            "ZIP": "27793",
            "City": "Wildeshausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Strassburg / WICHTIG Anfahrtshilfe Lesen WICHTIG !!! 0174 1891243 anrufen",
            "id": "1481-000",
            "text": "Reitstall Strassburg / WICHTIG Anfahrtshilfe Lesen WICHTIG !!! 0174 1891243 anrufen in Goch (Nr.1481-000)",
            "Street": "Gaesdoncker Str. 215",
            "ZIP": "47574",
            "City": "Goch",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ptivatstall Frank",
            "id": "1482-000",
            "text": "Ptivatstall Frank in Süsel (Nr.1482-000)",
            "Street": "Neustädter Str. 33c",
            "ZIP": "23701",
            "City": "Süsel",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Heinrich",
            "id": "1483-000",
            "text": "Privatstall Heinrich in Wardenburg (Nr.1483-000)",
            "Street": "Moorweg 49",
            "ZIP": "26203",
            "City": "Wardenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ribbers",
            "id": "1484-000",
            "text": "Ribbers in Neuenkirchen (Nr.1484-000)",
            "Street": "Emsdettener Str 263",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lippa",
            "id": "1485-000",
            "text": "Privatstall Lippa in Nordenham (Nr.1485-000)",
            "Street": "Abbehauser Wischweg 1a",
            "ZIP": "26954",
            "City": "Nordenham",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Schulze Tenberge",
            "id": "1486-000",
            "text": "Reiterhof Schulze Tenberge in Gronau (Nr.1486-000)",
            "Street": "Gerdingseite 3",
            "ZIP": "48599",
            "City": "Gronau",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Uekötter",
            "id": "1487-000",
            "text": "Privatstall Uekötter in Nottuln (Nr.1487-000)",
            "Street": "Am Vogelbusch 17",
            "ZIP": "48301",
            "City": "Nottuln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Niebüll",
            "id": "1488-000",
            "text": "Reitverein Niebüll in Niebüll (Nr.1488-000)",
            "Street": "Gotteskoogstraße 62",
            "ZIP": "25899",
            "City": "Niebüll",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Eichen-Hof Abbensen (Privat)",
            "id": "1489-000",
            "text": "Eichen-Hof Abbensen (Privat) in Wedemark (Nr.1489-000)",
            "Street": "Alte Zollstraße 3",
            "ZIP": "30900",
            "City": "Wedemark",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Aktivstall Brüning",
            "id": "1490-000",
            "text": "Aktivstall Brüning in Coesfeld (Nr.1490-000)",
            "Street": "Stevede  72",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Fröhlich",
            "id": "1491-000",
            "text": "Hof Fröhlich in Ladelund (Nr.1491-000)",
            "Street": "Königsacker  9",
            "ZIP": "25926",
            "City": "Ladelund",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Meier",
            "id": "1492-000",
            "text": "Privatstall Meier in Bad Münder (Nr.1492-000)",
            "Street": "Zum Wittkopfstein 1",
            "ZIP": "31848",
            "City": "Bad Münder",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Berndsmann",
            "id": "1493-000",
            "text": "Stall Berndsmann in Dortmund (Nr.1493-000)",
            "Street": "Persebeckerstrasse 1",
            "ZIP": "44227",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen-Markt Soest",
            "id": "RM-SOE",
            "text": "Raiffeisen-Markt Soest in Soest (Nr.RM-SOE)",
            "Street": "Nottebohmweg 17",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Heimbach",
            "id": "1495-000",
            "text": "Stall Heimbach in Beringstedt (Nr.1495-000)",
            "Street": "Aukamp 1",
            "ZIP": "25575",
            "City": "Beringstedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Bentstreek ",
            "id": "1496-000",
            "text": "Stall Bentstreek  in Friedeburg (Nr.1496-000)",
            "Street": "Flakstellungsweg  4",
            "ZIP": "26446",
            "City": "Friedeburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schimmelpfennig",
            "id": "1497-000",
            "text": "Privatstall Schimmelpfennig in Telgte (Nr.1497-000)",
            "Street": "Brink 28",
            "ZIP": "48291",
            "City": "Telgte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Tostedt",
            "id": "1498-000",
            "text": "Reitverein Tostedt in Tostedt (Nr.1498-000)",
            "Street": "Alter Moorweg 10",
            "ZIP": "21255",
            "City": "Tostedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Peters",
            "id": "1499-000",
            "text": "Privatstall Peters in Lingen (Nr.1499-000)",
            "Street": "Bruchstraße 15",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall König",
            "id": "1500-000",
            "text": "Stall König in Ladbergen (Nr.1500-000)",
            "Street": "Westerweg 130",
            "ZIP": "49549",
            "City": "Ladbergen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Brands",
            "id": "1501-000",
            "text": "Privatstall Brands in Leverkusen (Nr.1501-000)",
            "Street": "Grunder Wiesen 18",
            "ZIP": "51381",
            "City": "Leverkusen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Harmeyer",
            "id": "1502-000",
            "text": "Privatstall Harmeyer in Quendorf (Nr.1502-000)",
            "Street": "Am Kapellenplatz 1",
            "ZIP": "48465",
            "City": "Quendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wedig",
            "id": "1503-000",
            "text": "Wedig in Harsum (Nr.1503-000)",
            "Street": "Am Thie 7",
            "ZIP": "31177",
            "City": "Harsum",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "JoKa Farm",
            "id": "1504-000",
            "text": "JoKa Farm in Schwanewede (Nr.1504-000)",
            "Street": "Lehmhorst 226a",
            "ZIP": "28790",
            "City": "Schwanewede",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Zorgboerderij Zeemanslust",
            "id": "NL058-000",
            "text": "Zorgboerderij Zeemanslust in Spijkerboor (Nr.NL058-000)",
            "Street": "Oudelandsdijk 5",
            "ZIP": "1458 PN",
            "City": "Spijkerboor",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Pferdezahnbehandlung Martin Hüpen ",
            "id": "1505-000",
            "text": "Pferdezahnbehandlung Martin Hüpen  in Straelen (Nr.1505-000)",
            "Street": "Op den tupp 6",
            "ZIP": "47638",
            "City": "Straelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lammers",
            "id": "1506-000",
            "text": "Privatstall Lammers in Rheine (Nr.1506-000)",
            "Street": "Möllerhookstraße 11",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Visbek",
            "id": "1507-000",
            "text": "Reitverein Visbek in Visbek (Nr.1507-000)",
            "Street": "Schützenstraße 5",
            "ZIP": "49429",
            "City": "Visbek",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Max Weber",
            "id": "1508-000",
            "text": "Reitstall Max Weber in Werne (Nr.1508-000)",
            "Street": "Am Reiterhof 4",
            "ZIP": "59368",
            "City": "Werne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Willy Vogel",
            "id": "1509-000",
            "text": "Reitstall Willy Vogel in Bielefeld (Nr.1509-000)",
            "Street": "Senner Hellweg 138",
            "ZIP": "33659",
            "City": "Bielefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rockers Peerstall",
            "id": "1510-000",
            "text": "Rockers Peerstall in Aurich (Nr.1510-000)",
            "Street": "Holzweg 111",
            "ZIP": "26607",
            "City": "Aurich",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferde Gestüt Borgarstadur",
            "id": "1511-000",
            "text": "Islandpferde Gestüt Borgarstadur in Dülmen (Nr.1511-000)",
            "Street": "Bauernschaft 190",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wullenweber",
            "id": "1512-000",
            "text": "Hof Wullenweber in Meschede (Nr.1512-000)",
            "Street": "Enste 2",
            "ZIP": "49872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stal Broekhof",
            "id": "NL059-000",
            "text": "Stal Broekhof in Lochem (Nr.NL059-000)",
            "Street": "Tusselerdijk  7",
            "ZIP": "7241 PZ",
            "City": "Lochem",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Pferdepension am Abbabach",
            "id": "1513-000",
            "text": "Pferdepension am Abbabach in Menden (Nr.1513-000)",
            "Street": "Am Abbabach 2",
            "ZIP": "58708",
            "City": "Menden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kostka",
            "id": "1514-000",
            "text": "Privatstall Kostka in Wermelskirchen (Nr.1514-000)",
            "Street": "Eipringhausen  60",
            "ZIP": "42929",
            "City": "Wermelskirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage zum Batz",
            "id": "1515-000",
            "text": "Reitanlage zum Batz in Hanerau-Hademarschen (Nr.1515-000)",
            "Street": "Batzer Weg 3",
            "ZIP": "25557",
            "City": "Hanerau-Hademarschen",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Brüggemeier",
            "id": "1516-000",
            "text": "Privatstall Brüggemeier in Ibbenbüren (Nr.1516-000)",
            "Street": "Haarweg 99",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Doppe",
            "id": "1517-000",
            "text": "Doppe in Rietberg (Nr.1517-000)",
            "Street": "Doppstaße 23",
            "ZIP": "33397",
            "City": "Rietberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Baden",
            "id": "1518-000",
            "text": "Hof Baden in Schneverdingen (Nr.1518-000)",
            "Street": "Dorfstraße 61",
            "ZIP": "29640",
            "City": "Schneverdingen",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Apfelhof Hördinghausen Fam. Borgmann",
            "id": "1519-000",
            "text": "Apfelhof Hördinghausen Fam. Borgmann in Bad Essen  (Nr.1519-000)",
            "Street": "Hördinghauser Str. 22",
            "ZIP": "49152",
            "City": "Bad Essen ",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Wettmershagen",
            "id": "1520-000",
            "text": "Reitstall Wettmershagen in Calberlah (Nr.1520-000)",
            "Street": "Höpenweg 6",
            "ZIP": "38547",
            "City": "Calberlah",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Grotwinkel",
            "id": "1521-000",
            "text": "Hof Grotwinkel in Kamp-Lintfort (Nr.1521-000)",
            "Street": "Niephauser Str. 18",
            "ZIP": "47475",
            "City": "Kamp-Lintfort",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Wietrehm",
            "id": "1522-000",
            "text": "Reitsportanlage Wietrehm in Wedemark (Nr.1522-000)",
            "Street": "Fuhrberger Weg 14",
            "ZIP": "30900",
            "City": "Wedemark",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Gleidorf",
            "id": "RV-GL",
            "text": "Raiffeisen Vital Gleidorf in Schmallenberg-Gleidorf (Nr.RV-GL)",
            "Street": "Kornhausstraße  11",
            "ZIP": "57392",
            "City": "Schmallenberg-Gleidorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Ense-Bremen",
            "id": "RV-EB",
            "text": "Raiffeisen Vital Ense-Bremen in Ense-Bremen (Nr.RV-EB)",
            "Street": "Werler Straße 57",
            "ZIP": "59469",
            "City": "Ense-Bremen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Herzfeld",
            "id": "RV-HE",
            "text": "Raiffeisen Vital Herzfeld in Lippetal-Herzfeld (Nr.RV-HE)",
            "Street": "Lippborger Straße 21",
            "ZIP": "59510",
            "City": "Lippetal-Herzfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Rhynern",
            "id": "RV-RH",
            "text": "Raiffeisen Vital Rhynern in Hamm-Osttünnen (Nr.RV-RH)",
            "Street": "Twärsweg 2",
            "ZIP": "59069",
            "City": "Hamm-Osttünnen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Unna",
            "id": "RV-UN",
            "text": "Raiffeisen Vital Unna in Unna (Nr.RV-UN)",
            "Street": "Alfred-Nobel-Straße 19",
            "ZIP": "59423",
            "City": "Unna",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Werl",
            "id": "RV-WE",
            "text": "Raiffeisen Vital Werl in Werl (Nr.RV-WE)",
            "Street": "Zur Mersch 14",
            "ZIP": "59457",
            "City": "Werl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Raiffeisen Vital Balve",
            "id": "RV-BA",
            "text": "Raiffeisen Vital Balve in Balve (Nr.RV-BA)",
            "Street": "An der Kormke 20-24",
            "ZIP": "58802",
            "City": "Balve",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Burmann",
            "id": "1523-000",
            "text": "Privatstall Burmann in Lippetal (Nr.1523-000)",
            "Street": "Am Heitkamp 8",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Calle-Meschede",
            "id": "1524-000",
            "text": "Reitverein Calle-Meschede in Meschede (Nr.1524-000)",
            "Street": "An der Reithalle 1",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RuVV am Hallohberg",
            "id": "1525-000",
            "text": "RuVV am Hallohberg in Wiemersdorf (Nr.1525-000)",
            "Street": "Grünplan 3",
            "ZIP": "24623",
            "City": "Wiemersdorf",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fröbel",
            "id": "1526-000",
            "text": "Privatstall Fröbel in Morsbach (Nr.1526-000)",
            "Street": "Herbertshagen 2",
            "ZIP": "51597",
            "City": "Morsbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit und Fahrverein Wickede-Asseln-Sölde",
            "id": "1527-000",
            "text": "Reit und Fahrverein Wickede-Asseln-Sölde in Dortmund (Nr.1527-000)",
            "Street": "Eschenwaldstraß 45",
            "ZIP": "44319",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Thomas Voss Reitanlage Höllnhof",
            "id": "1528-000",
            "text": "Thomas Voss Reitanlage Höllnhof in Schülp bei Nortorf (Nr.1528-000)",
            "Street": "Looper Weg 2",
            "ZIP": "24589",
            "City": "Schülp bei Nortorf",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Keuter",
            "id": "1529-000",
            "text": "Privatstall Keuter in Papenburg (Nr.1529-000)",
            "Street": "Zum Wehr 41",
            "ZIP": "26871",
            "City": "Papenburg",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitpark Gut Nienhausen",
            "id": "1530-000",
            "text": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1530-000)",
            "Street": "Feldmarkstraße 180",
            "ZIP": "45883",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Große Hellmann",
            "id": "1531-000",
            "text": "Hof Große Hellmann in Senden (Nr.1531-000)",
            "Street": "Brock 7",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Geuking",
            "id": "1532-000",
            "text": "Privatstall Geuking in Coesfeld (Nr.1532-000)",
            "Street": "Letter Berg 102",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Stoffers",
            "id": "1533-000",
            "text": "Hof Stoffers in Gelsenkirchen (Nr.1533-000)",
            "Street": "Bußmannstrase 62a",
            "ZIP": "45896",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage M. Langer",
            "id": "1534-000",
            "text": "Reitanlage M. Langer in Kamen (Nr.1534-000)",
            "Street": "Zum Lüchting 1",
            "ZIP": "59174",
            "City": "Kamen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schütte",
            "id": "1535-000",
            "text": "Privatstall Schütte in Düsseldorf (Nr.1535-000)",
            "Street": "Duisburger Landstraße 203",
            "ZIP": "40489",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kirchner",
            "id": "1536-000",
            "text": "Privatstall Kirchner in Neustadt (Nr.1536-000)",
            "Street": "Mandelsloher Str. 6",
            "ZIP": "31535",
            "City": "Neustadt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Pape",
            "id": "1537-000",
            "text": "Privathof Pape in Delbrück (Nr.1537-000)",
            "Street": "Neubrückstraße 10",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Delbrück",
            "Land": "Deutschland"
        },
        {
            "name": "Outback Corona",
            "id": "1538-000",
            "text": "Outback Corona in Willich (Nr.1538-000)",
            "Street": "Fonger 30",
            "ZIP": "47877",
            "City": "Willich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Eulental Reitstall",
            "id": "1539-000",
            "text": "Gut Eulental Reitstall in Erkrath (Nr.1539-000)",
            "Street": "Eulental 32",
            "ZIP": "40699",
            "City": "Erkrath",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wade",
            "id": "1540-000",
            "text": "Privatstall Wade in Emmerthal (Nr.1540-000)",
            "Street": "In der Meinte 9",
            "ZIP": "31860",
            "City": "Emmerthal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Flüsterpferde",
            "id": "1541-000",
            "text": "Flüsterpferde in Stade (Nr.1541-000)",
            "Street": "Götzdorfer Str 214",
            "ZIP": "21683",
            "City": "Stade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Vibrans",
            "id": "1542-000",
            "text": "Reitanlage Vibrans in Langelsheim (Nr.1542-000)",
            "Street": "Unterdorf 5a",
            "ZIP": "38685",
            "City": "Langelsheim",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Jobmann",
            "id": "1543-000",
            "text": "Reiterhof Jobmann in Hamburg (Nr.1543-000)",
            "Street": "Neuländer Elbdeich 234",
            "ZIP": "21079",
            "City": "Hamburg",
            "Bundesland": "Hamburg",
            "Land": "Deutschland"
        },
        {
            "name": "Islandpferdehof Vierhohen",
            "id": "1544-000",
            "text": "Islandpferdehof Vierhohen in Weddelbrook (Nr.1544-000)",
            "Street": "Krücken 5",
            "ZIP": "24576",
            "City": "Weddelbrook",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Noack",
            "id": "1545-000",
            "text": "Privatstall Noack in Ennigerloh (Nr.1545-000)",
            "Street": "Wessenhorst 32",
            "ZIP": "59320",
            "City": "Ennigerloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Petersen",
            "id": "1546-000",
            "text": "Privatstall Petersen in Wohlde (Nr.1546-000)",
            "Street": "Mittelstraße 14",
            "ZIP": "24899",
            "City": "Wohlde",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Blume",
            "id": "1547-000",
            "text": "Privatstall Blume in Wülfrath (Nr.1547-000)",
            "Street": "Velberter Straße 36",
            "ZIP": "42489",
            "City": "Wülfrath",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Lange",
            "id": "1548-000",
            "text": "Reitstall Lange in Rehburg-Loccum (Nr.1548-000)",
            "Street": "Düsselburger Str. 70",
            "ZIP": "31547",
            "City": "Rehburg-Loccum",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Röring",
            "id": "1549-000",
            "text": "Hof Röring in Ahaus (Nr.1549-000)",
            "Street": "Barle 8",
            "ZIP": "48683",
            "City": "Ahaus",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rorup Holsterbrink",
            "id": "1550-000",
            "text": "Privatstall Rorup Holsterbrink in Dülmen (Nr.1550-000)",
            "Street": "Holsterbrink 22",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rosenberger",
            "id": "1551-000",
            "text": "Privatstall Rosenberger in Senden (Nr.1551-000)",
            "Street": "Gettrup 14",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Steinhoff",
            "id": "1552-000",
            "text": "Steinhoff in Kerken (Nr.1552-000)",
            "Street": "Dorfstr. 105",
            "ZIP": "47647",
            "City": "Kerken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Braß - Gut Kückshausen",
            "id": "1553-000",
            "text": "Reitanlage Braß - Gut Kückshausen in Dortmund (Nr.1553-000)",
            "Street": "Syburgstr. 9",
            "ZIP": "44265",
            "City": "Dortmund",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Wilkens",
            "id": "1554-000",
            "text": "Reitstall Wilkens in Thedinghausen (Nr.1554-000)",
            "Street": "Rieder Straße 81a",
            "ZIP": "27321",
            "City": "Thedinghausen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wendt",
            "id": "1555-000",
            "text": "Privatstall Wendt in Willebadessen (Nr.1555-000)",
            "Street": "Schönthal 3",
            "ZIP": "34439",
            "City": "Willebadessen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Elsermann kamen Methler",
            "id": "1556-000",
            "text": "Elsermann kamen Methler in Kamen (Nr.1556-000)",
            "Street": "Hilsingstraße  22",
            "ZIP": "59174",
            "City": "Kamen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Bendel",
            "id": "1557-000",
            "text": "Hof Bendel in Balve (Nr.1557-000)",
            "Street": "Wocklum 3a",
            "ZIP": "48802",
            "City": "Balve",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Wellin",
            "id": "1558-000",
            "text": "Wellin in Herscheid (Nr.1558-000)",
            "Street": "Wellin 6",
            "ZIP": "58859",
            "City": "Herscheid",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RC Senne e.V. Stukenbrock",
            "id": "1559-000",
            "text": "RC Senne e.V. Stukenbrock in Schloß-Holte Stuckenbrock (Nr.1559-000)",
            "Street": "Flugplatzstr. 80",
            "ZIP": "33758",
            "City": "Schloß-Holte Stuckenbrock",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "WD Quarter horses",
            "id": "NL060-000",
            "text": "WD Quarter horses in Wijdewormer (Nr.NL060-000)",
            "Street": "Zuiderweg 7",
            "ZIP": "1456 NC",
            "City": "Wijdewormer",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reitverein Oelde e.V.",
            "id": "1560-000",
            "text": "Reitverein Oelde e.V. in Oelde (Nr.1560-000)",
            "Street": "Am Ruthenfeld 40",
            "ZIP": "59302",
            "City": "Oelde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Freizeitpferdehof Meier",
            "id": "1561-000",
            "text": "Freizeitpferdehof Meier in Extertal (Nr.1561-000)",
            "Street": "Schneppel  1",
            "ZIP": "32699",
            "City": "Extertal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wiesmann",
            "id": "1562-000",
            "text": "Hof Wiesmann in Castrop Rauxel (Nr.1562-000)",
            "Street": "Im Finkenbrink 33",
            "ZIP": "44581",
            "City": "Castrop Rauxel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Appel",
            "id": "1563-000",
            "text": "Privatstall Appel in Leezdorf  (Nr.1563-000)",
            "Street": "Heideweg 16",
            "ZIP": "26529",
            "City": "Leezdorf ",
            "Bundesland": "Niedersachesen",
            "Land": "Deutschland"
        },
        {
            "name": "Niehues",
            "id": "1564-000",
            "text": "Niehues in Legden (Nr.1564-000)",
            "Street": "Isingoort 63",
            "ZIP": "48739",
            "City": "Legden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Lorenz",
            "id": "1565-000",
            "text": "Hof Lorenz in Loxstedt (Nr.1565-000)",
            "Street": "Am Schafdamm 10",
            "ZIP": "27612",
            "City": "Loxstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Freizeithof Mesterscheidt",
            "id": "1566-000",
            "text": "Freizeithof Mesterscheidt in Hemer (Nr.1566-000)",
            "Street": "Mesterscheid 2",
            "ZIP": "58675",
            "City": "Hemer",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Glüsing",
            "id": "1567-000",
            "text": "Hof Glüsing in Osterbruch  (Nr.1567-000)",
            "Street": "Süderende  16",
            "ZIP": "21762",
            "City": "Osterbruch ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Krohn",
            "id": "1568-000",
            "text": "Hof Krohn in Flintbek (Nr.1568-000)",
            "Street": "Sörenberg  23",
            "ZIP": "24220",
            "City": "Flintbek",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Römerhof",
            "id": "1569-000",
            "text": "Gut Römerhof in Düsseldorf (Nr.1569-000)",
            "Street": "am Schmidtberg 15",
            "ZIP": "40629",
            "City": "Düsseldorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Lohe",
            "id": "1570-000",
            "text": "Stall Lohe in Ascheberg (Nr.1570-000)",
            "Street": "Ostereckern 9",
            "ZIP": "59387",
            "City": "Ascheberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Sältz",
            "id": "1571-000",
            "text": "Stall Sältz in Bohmstedt (Nr.1571-000)",
            "Street": "Sick 2",
            "ZIP": "25853",
            "City": "Bohmstedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Fragen",
            "id": "1572-000",
            "text": "Reitstall Fragen in Korschenbroich (Nr.1572-000)",
            "Street": "Fragenhütte ",
            "ZIP": "41352",
            "City": "Korschenbroich",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Wylack",
            "id": "1573-000",
            "text": "Gut Wylack in Wassenberg (Nr.1573-000)",
            "Street": "Gut Wylack ",
            "ZIP": "41849",
            "City": "Wassenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Rüter",
            "id": "1574-000",
            "text": "Reiterhof Rüter in Wetzen (Nr.1574-000)",
            "Street": "Dorfstraße 6",
            "ZIP": "21385",
            "City": "Wetzen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Dammackerhof ",
            "id": "1575-000",
            "text": "Dammackerhof  in Sarstedt (Nr.1575-000)",
            "Street": "Wenderter Str. 14",
            "ZIP": "31157",
            "City": "Sarstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "LZ sporthorses",
            "id": "NL061-000",
            "text": "LZ sporthorses in Vriezenveen (Nr.NL061-000)",
            "Street": "Wierdenseweg  19",
            "ZIP": "7671 JJ",
            "City": "Vriezenveen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Reiterverein Sintfeld St. Martin Fürstenberg e.V.",
            "id": "1576-000",
            "text": "Reiterverein Sintfeld St. Martin Fürstenberg e.V. in Bad Wünnenberg (Nr.1576-000)",
            "Street": "Grasweg 3",
            "ZIP": "33181",
            "City": "Bad Wünnenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall Luckhaus",
            "id": "1577-000",
            "text": "Privater Offenstall Luckhaus in Hamm (Nr.1577-000)",
            "Street": "Soester Str. 407",
            "ZIP": "49199",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Heine",
            "id": "1578-000",
            "text": "Hof Heine in Drebber (Nr.1578-000)",
            "Street": "Marienstraße  5",
            "ZIP": "49457",
            "City": "Drebber",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Offenstall Grzesiek",
            "id": "1579-000",
            "text": "Offenstall Grzesiek in Stelle (Nr.1579-000)",
            "Street": "Fohrsfeld 7",
            "ZIP": "21435",
            "City": "Stelle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hünnekes",
            "id": "1580-000",
            "text": "Hof Hünnekes in Niederkrüchten (Nr.1580-000)",
            "Street": "Am Hügelhof 1",
            "ZIP": "41372",
            "City": "Niederkrüchten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Mateos",
            "id": "1581-000",
            "text": "Reitstall Mateos in Bochum (Nr.1581-000)",
            "Street": "An der Holtbrügge 25",
            "ZIP": "44795",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Langenfeld",
            "id": "1582-000",
            "text": "Pferdepension Langenfeld in Hessisch Oldendorf (Nr.1582-000)",
            "Street": "Pensionsstraße 2",
            "ZIP": "31840",
            "City": "Hessisch Oldendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Heinrichs",
            "id": "1583-000",
            "text": "Hof Heinrichs in Wegberg (Nr.1583-000)",
            "Street": "In Ellinghoven 10",
            "ZIP": "41844",
            "City": "Wegberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Einstellerhof Jessen",
            "id": "1584-000",
            "text": "Einstellerhof Jessen in Oeversee  (Nr.1584-000)",
            "Street": "Munkwolstruper Weg 35",
            "ZIP": "24988",
            "City": "Oeversee ",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Geenen",
            "id": "1585-000",
            "text": "Hof Geenen in Sprockhövel  (Nr.1585-000)",
            "Street": "Heidestraße 26",
            "ZIP": "45549",
            "City": "Sprockhövel ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall am Himmelmoor GbR",
            "id": "1586-000",
            "text": "Reitstall am Himmelmoor GbR in Quickborn (Nr.1586-000)",
            "Street": "Heinrich-Hertz-Str. 18",
            "ZIP": "25451",
            "City": "Quickborn",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Holland",
            "id": "NL062-000",
            "text": "Hof Holland in Vriezenveen (Nr.NL062-000)",
            "Street": "Oosteinde  304",
            "ZIP": "7671 AG",
            "City": "Vriezenveen",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Carolin Thomsen Pferdestärken",
            "id": "1587-000",
            "text": "Carolin Thomsen Pferdestärken in Stoltebüll (Nr.1587-000)",
            "Street": "Levshöh 1",
            "ZIP": "24409",
            "City": "Stoltebüll",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kathmann ",
            "id": "1588-000",
            "text": "Privatstall Kathmann  in Haren (Ems) (Nr.1588-000)",
            "Street": "Ostereschweg 65",
            "ZIP": "49733",
            "City": "Haren (Ems)",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Reeger",
            "id": "1589-000",
            "text": "Hof Reeger in Hagen (Nr.1589-000)",
            "Street": "Niggenbölling  ",
            "ZIP": "58091",
            "City": "Hagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Helbig-Baldt",
            "id": "1590-000",
            "text": "Hof Helbig-Baldt in Hamm (Nr.1590-000)",
            "Street": "Im Nachtigallental 4",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage-Behrens",
            "id": "1591-000",
            "text": "Reitanlage-Behrens in Soest (Nr.1591-000)",
            "Street": "Wasserweg 17",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hörsters Farmer",
            "id": "1592-000",
            "text": "Hörsters Farmer in Arnsberg (Nr.1592-000)",
            "Street": "Im Schmiemketal 1",
            "ZIP": "59821",
            "City": "Arnsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Witte",
            "id": "1593-000",
            "text": "Stall Witte in Ovelgönne (Nr.1593-000)",
            "Street": "Anton-Hullmann-Weg 2",
            "ZIP": "26939",
            "City": "Ovelgönne",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Laves",
            "id": "1594-000",
            "text": "Hof Laves in Einbeck (Nr.1594-000)",
            "Street": "Clusweg 2",
            "ZIP": "37574",
            "City": "Einbeck",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyhof Rottmann",
            "id": "1595-000",
            "text": "Ponyhof Rottmann in Hagen (Nr.1595-000)",
            "Street": "Bergstr 12",
            "ZIP": "49170",
            "City": "Hagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Brauershof",
            "id": "1596-000",
            "text": "Gestüt Brauershof in Geldern (Nr.1596-000)",
            "Street": "An den Niersauen  42",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Danielles Pferdehof",
            "id": "1597-000",
            "text": "Danielles Pferdehof in Kluse (Nr.1597-000)",
            "Street": "Hauptstrasse 8",
            "ZIP": "26892",
            "City": "Kluse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wuppertaler Ponyfreunde e.V.",
            "id": "1598-000",
            "text": "Wuppertaler Ponyfreunde e.V. in Wuppertal (Nr.1598-000)",
            "Street": "Sonnenblume 22",
            "ZIP": "42281",
            "City": "Wuppertal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schnellenberg",
            "id": "1599-000",
            "text": "Hof Schnellenberg in Hörstel-Riesenbeck (Nr.1599-000)",
            "Street": "Surenburg 4",
            "ZIP": "48477",
            "City": "Hörstel-Riesenbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Müther",
            "id": "1600-000",
            "text": "Hof Müther in Rosendahl (Nr.1600-000)",
            "Street": "Hermann-Löns-Weg 48",
            "ZIP": "48720",
            "City": "Rosendahl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Berenyi",
            "id": "1601-000",
            "text": "Reitstall Berenyi in Garbsen (Nr.1601-000)",
            "Street": "Mühlenstraße  37",
            "ZIP": "30826",
            "City": "Garbsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Knop",
            "id": "1602-000",
            "text": "Hof Knop in Edemissen (Nr.1602-000)",
            "Street": "Klein Blumenhagen 3",
            "ZIP": "31234",
            "City": "Edemissen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Jürgens",
            "id": "1603-000",
            "text": "Pferdepension Jürgens in Dinslaken (Nr.1603-000)",
            "Street": "Sterkraderstr  111",
            "ZIP": "46539",
            "City": "Dinslaken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Andree",
            "id": "1604-000",
            "text": "Reitstall Andree in Marsberg (Nr.1604-000)",
            "Street": "Markeweg 9",
            "ZIP": "34431",
            "City": "Marsberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Reismann",
            "id": "1605-000",
            "text": "Hof Reismann in Ibbenbüren (Nr.1605-000)",
            "Street": "Püsselbürener Damm 251",
            "ZIP": "49479",
            "City": "Ibbenbüren",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Vom Körfkens Hof ",
            "id": "1606-000",
            "text": "Vom Körfkens Hof  in Stadtlohn  (Nr.1606-000)",
            "Street": "Schützenweg 144",
            "ZIP": "48703",
            "City": "Stadtlohn ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Tillmann",
            "id": "1607-000",
            "text": "Hof Tillmann in Geseke (Nr.1607-000)",
            "Street": "Ziegelweg 2",
            "ZIP": "59590",
            "City": "Geseke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Weber",
            "id": "1608-000",
            "text": "Hof Weber in Bad Essen  (Nr.1608-000)",
            "Street": "Am Bülten 1",
            "ZIP": "49152",
            "City": "Bad Essen ",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Thiel",
            "id": "1609-000",
            "text": "Hof Thiel in Oer-Erkenschwick (Nr.1609-000)",
            "Street": "Westfeldweg ",
            "ZIP": "45739",
            "City": "Oer-Erkenschwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Haus Alaquint",
            "id": "1610-000",
            "text": "Privatstall Haus Alaquint in Mettmann (Nr.1610-000)",
            "Street": "Hoppenhofweg 1",
            "ZIP": "40822",
            "City": "Mettmann",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Langenhagen",
            "id": "1611-000",
            "text": "RV Langenhagen in Langenhagen (Nr.1611-000)",
            "Street": "Walsroder Str 179",
            "ZIP": "30855",
            "City": "Langenhagen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Feines Reiten",
            "id": "1612-000",
            "text": "Feines Reiten in Varrel (Nr.1612-000)",
            "Street": "Schäkeln 2",
            "ZIP": "27259",
            "City": "Varrel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Winterberg",
            "id": "1613-000",
            "text": "RV Winterberg in Winterberg (Nr.1613-000)",
            "Street": "Am Postteich 7",
            "ZIP": "59955",
            "City": "Winterberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Benning",
            "id": "1614-000",
            "text": "Privatstall Benning in Coesfeld (Nr.1614-000)",
            "Street": "Gaupel  36",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RG Landgraben ",
            "id": "1615-000",
            "text": "RG Landgraben  in Schönkirchen  (Nr.1615-000)",
            "Street": "Landgraben  73",
            "ZIP": "24232",
            "City": "Schönkirchen ",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Riedel (Postversand)",
            "id": "1616-000",
            "text": "Reitstall Riedel (Postversand) in Heiligengrabe OT Liebenthal (Nr.1616-000)",
            "Street": "Liebenthaler Dorfstraße  16",
            "ZIP": "16909",
            "City": "Heiligengrabe OT Liebenthal",
            "Bundesland": "Brandenburg",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterverein Altes Amt Dielingen e.V ",
            "id": "1617-000",
            "text": "Reiterverein Altes Amt Dielingen e.V  in Stemwede  (Nr.1617-000)",
            "Street": "Zur Toppheide 9",
            "ZIP": "32351",
            "City": "Stemwede ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat Köster",
            "id": "1618-000",
            "text": "Privat Köster in Veelen (Nr.1618-000)",
            "Street": "Bischof-Averkamp-Straße 6",
            "ZIP": "46342",
            "City": "Veelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wallhorn",
            "id": "1619-000",
            "text": "Hof Wallhorn in Duisburg (Nr.1619-000)",
            "Street": "Stalbergstraße 29",
            "ZIP": "47167",
            "City": "Duisburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Hofstedde",
            "id": "1620-000",
            "text": "Reitanlage Hofstedde in Datteln (Nr.1620-000)",
            "Street": "Am Alten Busch 8 8",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Erich Robert",
            "id": "1621-000",
            "text": "Hof Erich Robert in Altenberge (Nr.1621-000)",
            "Street": "Hohenhorst  60",
            "ZIP": "48341",
            "City": "Altenberge",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Scheepker",
            "id": "1622-000",
            "text": "Hof Scheepker in Aurich (Nr.1622-000)",
            "Street": "Heuweg 94",
            "ZIP": "26607",
            "City": "Aurich",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdeland",
            "id": "1623-000",
            "text": "Pferdeland in Leichlingen (Nr.1623-000)",
            "Street": "Zum Buschtor 3",
            "ZIP": "42799",
            "City": "Leichlingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schlattmann",
            "id": "1624-000",
            "text": "Hof Schlattmann in Neuenkirchen (Nr.1624-000)",
            "Street": "Sutrum Harum 16",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitanlage Wierling",
            "id": "1625-000",
            "text": "Reitanlage Wierling in Senden (Nr.1625-000)",
            "Street": "Dorfbauernschaft 115",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Nonte",
            "id": "1626-000",
            "text": "Reiterhof Nonte in Münster (Nr.1626-000)",
            "Street": "Verth 66",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Blomberg",
            "id": "1627-000",
            "text": "Pferdepension Blomberg in Meinerzhagen Blomberg (Nr.1627-000)",
            "Street": "Blomberg 1",
            "ZIP": "58540",
            "City": "Meinerzhagen Blomberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Kempken",
            "id": "1628-000",
            "text": "Hof Kempken in Alpen (Nr.1628-000)",
            "Street": "Mühlenweg 30",
            "ZIP": "46519",
            "City": "Alpen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof van Bevern",
            "id": "1629-000",
            "text": "Hof van Bevern in Saerbeck (Nr.1629-000)",
            "Street": "Sinningen  17",
            "ZIP": "48369",
            "City": "Saerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wentzlaff (Privat)",
            "id": "1630-000",
            "text": "Hof Wentzlaff (Privat) in Schneverdingen (Nr.1630-000)",
            "Street": "Lindenstraße  42",
            "ZIP": "29640",
            "City": "Schneverdingen",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Dieckmann",
            "id": "1631-000",
            "text": "Stall Dieckmann in Bottrop Kirchhellen (Nr.1631-000)",
            "Street": "Lohbraucksweg  6",
            "ZIP": "46244",
            "City": "Bottrop Kirchhellen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hohmannshof Spanier / Dols",
            "id": "1632-000",
            "text": "Hohmannshof Spanier / Dols in Kerken (Nr.1632-000)",
            "Street": "Kappelenweg 12",
            "ZIP": "47647",
            "City": "Kerken",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Leeling",
            "id": "1633-000",
            "text": "Privatstall Leeling in Mönchengladbach (Nr.1633-000)",
            "Street": "Baueshütte 41",
            "ZIP": "41238",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Steinmetz",
            "id": "1634-000",
            "text": "Hof Steinmetz in Zeven-Badenstedt (Nr.1634-000)",
            "Street": "Ziegeleistr 14",
            "ZIP": "27404",
            "City": "Zeven-Badenstedt",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Privat Junge",
            "id": "1635-000",
            "text": "Privat Junge in Belm (Nr.1635-000)",
            "Street": "Bröckerskamp 5",
            "ZIP": "49191",
            "City": "Belm",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Reul",
            "id": "1636-000",
            "text": "Hof Reul in Holle (Nr.1636-000)",
            "Street": "Hainbergstraße 13a",
            "ZIP": "31188",
            "City": "Holle",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Gäher",
            "id": "1637-000",
            "text": "Reitstall Gäher in Sassenberg (Nr.1637-000)",
            "Street": "Steinkamps Heide 1",
            "ZIP": "48336",
            "City": "Sassenberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Zeletzki",
            "id": "1638-000",
            "text": "Hof Zeletzki in Greven (Nr.1638-000)",
            "Street": "Pentruper Str. 73",
            "ZIP": "48268",
            "City": "Greven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bucks Stall ",
            "id": "1639-000",
            "text": "Bucks Stall  in Lehe (Nr.1639-000)",
            "Street": "Flüte 7",
            "ZIP": "26892",
            "City": "Lehe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Equestrian Sports Wamers / Wamers Wamers GbR",
            "id": "1640-000",
            "text": "Equestrian Sports Wamers / Wamers Wamers GbR in Niederkrüchten (Nr.1640-000)",
            "Street": "Erkelenzer Straße 71",
            "ZIP": "41372",
            "City": "Niederkrüchten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Predovic",
            "id": "1641-000",
            "text": "Hof Predovic in Bünde (Nr.1641-000)",
            "Street": "Südlengerstr. 157",
            "ZIP": "32257",
            "City": "Bünde",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Linßenhof in Rheurdt",
            "id": "1642-000",
            "text": "Linßenhof in Rheurdt in Rheurdt (Nr.1642-000)",
            "Street": "Hochend 138",
            "ZIP": "47509",
            "City": "Rheurdt",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eumeshof Halle",
            "id": "1643-000",
            "text": "Eumeshof Halle in Krefeld (Nr.1643-000)",
            "Street": "Vorderorbroich 93",
            "ZIP": "47839 ",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schütte",
            "id": "1644-000",
            "text": "Stall Schütte in Meppen (Nr.1644-000)",
            "Street": "Backemühle 2",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Kreickmann",
            "id": "1645-000",
            "text": "Reiterhof Kreickmann in Ahlen (Nr.1645-000)",
            "Street": "Im Oestricher Holt 100",
            "ZIP": "59227",
            "City": "Ahlen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Elkar",
            "id": "1646-000",
            "text": "Privatstall Elkar in Dorsten (Nr.1646-000)",
            "Street": "Reiherstraße 33",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Abbink",
            "id": "NL063-000",
            "text": "Stall Abbink in Holten (Nr.NL063-000)",
            "Street": "Menumsweg  3",
            "ZIP": "7451 NK",
            "City": "Holten",
            "Bundesland": "Niederlande",
            "Land": "Niederlande"
        },
        {
            "name": "Hof Veldmann",
            "id": "1647-000",
            "text": "Hof Veldmann in Laar (Nr.1647-000)",
            "Street": "Veldgoorstr 2",
            "ZIP": "49824",
            "City": "Laar",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Gabriel",
            "id": "1648-000",
            "text": "Hof Gabriel in Schenefeld (Nr.1648-000)",
            "Street": "Seggerweg 12",
            "ZIP": "25469",
            "City": "Schenefeld",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall König",
            "id": "1649-000",
            "text": "Reitstall König in Herdecke (Nr.1649-000)",
            "Street": "Im Bruch 11",
            "ZIP": "58313",
            "City": "Herdecke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Strunk",
            "id": "1650-000",
            "text": "Hof Strunk in Bochum (Nr.1650-000)",
            "Street": "Haarstr. 59",
            "ZIP": "44797",
            "City": "Bochum",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Schmiemann ",
            "id": "1651-000",
            "text": "Hof Schmiemann  in Recke (Nr.1651-000)",
            "Street": "Twenhusen 29",
            "ZIP": "49509",
            "City": "Recke",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Steffens",
            "id": "1652-000",
            "text": "Hof Steffens in Schloß Holte-Stukenbrock (Nr.1652-000)",
            "Street": "Römerstraße  3",
            "ZIP": "33758",
            "City": "Schloß Holte-Stukenbrock",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Osterheidehof ",
            "id": "1653-000",
            "text": "Osterheidehof  in Borstel (Nr.1653-000)",
            "Street": "An der Osterheide 34",
            "ZIP": "27246",
            "City": "Borstel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Becker",
            "id": "1654-000",
            "text": "Hof Becker in Hamm (Nr.1654-000)",
            "Street": "Lippestraße 130",
            "ZIP": "59071",
            "City": "Hamm",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Stein",
            "id": "1655-000",
            "text": "Hof Stein in Himmelpforten  (Nr.1655-000)",
            "Street": "Ramels 2",
            "ZIP": "21709",
            "City": "Himmelpforten ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Rinklake",
            "id": "1656-000",
            "text": "Hof Rinklake in Bad Laer (Nr.1656-000)",
            "Street": "Glaner Weg  8",
            "ZIP": "49196",
            "City": "Bad Laer",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Güldner",
            "id": "1657-000",
            "text": "Stall Güldner in Hopsten (Nr.1657-000)",
            "Street": "Zum Wurftaubenstand  1",
            "ZIP": "48596",
            "City": "Hopsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Beckmeier",
            "id": "1658-000",
            "text": "Hof Beckmeier in Horn-Bad Meinberg (Nr.1658-000)",
            "Street": "Lakeweg 10",
            "ZIP": "32805",
            "City": "Horn-Bad Meinberg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Felix Kassen Westerntraining",
            "id": "1659-000",
            "text": "Felix Kassen Westerntraining in Herne (Nr.1659-000)",
            "Street": "Hofstr 42",
            "ZIP": "44651",
            "City": "Herne",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Love and Trust Ranch",
            "id": "1660-000",
            "text": "Love and Trust Ranch in Datteln (Nr.1660-000)",
            "Street": "Ahsener Allee  4",
            "ZIP": "45711",
            "City": "Datteln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Paul Vocke Mesum",
            "id": "1661-000",
            "text": "Paul Vocke Mesum in Rheine (Nr.1661-000)",
            "Street": "Feuerstiege 33",
            "ZIP": "48432",
            "City": "Rheine",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit und Fahrverein Ostönnen",
            "id": "1662-000",
            "text": "Reit und Fahrverein Ostönnen in Soest (Nr.1662-000)",
            "Street": "Werler Landstraße 301",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- u. Fahrverein",
            "id": "1663-000",
            "text": "Reit- u. Fahrverein in Neuenkirchen-Vörden (Nr.1663-000)",
            "Street": "Brakenstraße 3",
            "ZIP": "49434",
            "City": "Neuenkirchen-Vörden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privater Offenstall Freckmann",
            "id": "1664-000",
            "text": "Privater Offenstall Freckmann in Lingen (Nr.1664-000)",
            "Street": "Antoniusstraße/Ecke Deeringhook ",
            "ZIP": "49811",
            "City": "Lingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Theo Wulhorst",
            "id": "1665-000",
            "text": "Theo Wulhorst in Waltrop (Nr.1665-000)",
            "Street": "Unterlippe  3",
            "ZIP": "45731",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Rathjens",
            "id": "1666-000",
            "text": "Hof Rathjens in Horneburg (Nr.1666-000)",
            "Street": "Moorstr. 18",
            "ZIP": "21640",
            "City": "Horneburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Vollenbroich",
            "id": "1667-000",
            "text": "Hof Vollenbroich in Erkelenz (Nr.1667-000)",
            "Street": "Klosterstr. 19",
            "ZIP": "41812",
            "City": "Erkelenz",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehofliebe",
            "id": "1668-000",
            "text": "Pferdehofliebe in Bad Bentheim (Nr.1668-000)",
            "Street": "Isterberger Weg 5",
            "ZIP": "48455",
            "City": "Bad Bentheim",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Metzger",
            "id": "1669-000",
            "text": "Privatstall Metzger in Dülmen (Nr.1669-000)",
            "Street": "Bauerschaft  122",
            "ZIP": "48249",
            "City": "Dülmen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Thomsen",
            "id": "1670-000",
            "text": "Hof Thomsen in Poppenbüll (Nr.1670-000)",
            "Street": "Achter de Kark 3",
            "ZIP": "25836",
            "City": "Poppenbüll",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Aktiv- und Bewegungsstall Sievers",
            "id": "1671-000",
            "text": "Aktiv- und Bewegungsstall Sievers in Syke  (Nr.1671-000)",
            "Street": "Okeler Heide 8",
            "ZIP": "28857",
            "City": "Syke ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Oertker",
            "id": "1672-000",
            "text": "Hof Oertker in Holdorf (Nr.1672-000)",
            "Street": "Ihorst 3",
            "ZIP": "49451",
            "City": "Holdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Brosche",
            "id": "1673-000",
            "text": "Privatstall Brosche in Münster (Nr.1673-000)",
            "Street": "Hölkenbusch 200",
            "ZIP": "48161 ",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Kövener ",
            "id": "1674-000",
            "text": "Hof Kövener  in Ostbevern (Nr.1674-000)",
            "Street": "Überwasser 7",
            "ZIP": "48346",
            "City": "Ostbevern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Rehazentrum Eichenhof",
            "id": "1675-000",
            "text": "Rehazentrum Eichenhof in Debstedterbüttel (Nr.1675-000)",
            "Street": "Reiterweg  7",
            "ZIP": "27607",
            "City": "Debstedterbüttel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wöbken",
            "id": "1676-000",
            "text": "Privatstall Wöbken in Oldenburg (Nr.1676-000)",
            "Street": "Geestkamp 29",
            "ZIP": "26125",
            "City": "Oldenburg",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitpark Gut Nienhausen",
            "id": "1677-000",
            "text": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1677-000)",
            "Street": "Feldmarkstraße 180",
            "ZIP": "45883",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Wekenborg",
            "id": "1678-000",
            "text": "Reiterhof Wekenborg in Meppen (Nr.1678-000)",
            "Street": "Landwehr 80",
            "ZIP": "49716",
            "City": "Meppen",
            "Bundesland": "Niedersachen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Clarholz-Lette",
            "id": "1679-000",
            "text": "RV Clarholz-Lette in Herzebrock-Clarholz (Nr.1679-000)",
            "Street": "Langemersch 1",
            "ZIP": "33442",
            "City": "Herzebrock-Clarholz",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Nagel",
            "id": "1680-000",
            "text": "Hof Nagel in Hövelhof (Nr.1680-000)",
            "Street": "Balkenweg 15",
            "ZIP": "33161",
            "City": "Hövelhof",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eskingerhof ",
            "id": "1681-000",
            "text": "Eskingerhof  in Billerbeck  (Nr.1681-000)",
            "Street": "Esking  41",
            "ZIP": "48727",
            "City": "Billerbeck ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ostseeferien Evershof Halske",
            "id": "1682-000",
            "text": "Ostseeferien Evershof Halske in Lübeck (Nr.1682-000)",
            "Street": "Kowitzberg 3",
            "ZIP": "23570",
            "City": "Lübeck",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- unf Fahrverein Emsbüren e.V.",
            "id": "1683-000",
            "text": "Reit- unf Fahrverein Emsbüren e.V. in Emsbüren (Nr.1683-000)",
            "Street": "Hügeleschweg 5",
            "ZIP": "48488",
            "City": "Emsbüren",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schröder",
            "id": "1684-000",
            "text": "Privatstall Schröder in Isernhagen (Nr.1684-000)",
            "Street": "Dorfstr. 41",
            "ZIP": "30916",
            "City": "Isernhagen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Biermeier ",
            "id": "1685-000",
            "text": "Privathof Biermeier  in Schloß Holte-Stukenbrock (Nr.1685-000)",
            "Street": "Auf den Holen 1",
            "ZIP": "33758",
            "City": "Schloß Holte-Stukenbrock",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wöbcke",
            "id": "1686-000",
            "text": "Privatstall Wöbcke in Elskop (Nr.1686-000)",
            "Street": "Dorfstraße 27",
            "ZIP": "25361",
            "City": "Elskop",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Gruhnert",
            "id": "1687-000",
            "text": "Privatstall Gruhnert in Sundern (Nr.1687-000)",
            "Street": "Illingheimer Str 3",
            "ZIP": "59846",
            "City": "Sundern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall von Öhsen",
            "id": "1688-000",
            "text": "Reitstall von Öhsen in Hagen im Bremischen (Nr.1688-000)",
            "Street": "Wiesenstraße 4",
            "ZIP": "27628",
            "City": "Hagen im Bremischen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Teismann",
            "id": "1689-000",
            "text": "Hof Teismann in Senden (Nr.1689-000)",
            "Street": "Gettrup 30",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Haase",
            "id": "1690-000",
            "text": "Privatstall Haase in Twistringen (Nr.1690-000)",
            "Street": "Am Brink 17",
            "ZIP": "27239",
            "City": "Twistringen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Ehlting",
            "id": "1691-000",
            "text": "Privatstall Ehlting in Prinzhöfte (Nr.1691-000)",
            "Street": "Hauptstraße 5",
            "ZIP": "27243",
            "City": "Prinzhöfte",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Stadler",
            "id": "1692-000",
            "text": "Privatstall Stadler in Oerel (Nr.1692-000)",
            "Street": "Sünderbeeksweg 9",
            "ZIP": "27432",
            "City": "Oerel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Geiger",
            "id": "1693-000",
            "text": "Privatstall Geiger in Labenz (Nr.1693-000)",
            "Street": "Steinhorster Straße 4",
            "ZIP": "23898",
            "City": "Labenz",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Schulze Balhorn ",
            "id": "1694-000",
            "text": "Schulze Balhorn  in Sendenhorst (Nr.1694-000)",
            "Street": "Bracht 18",
            "ZIP": "48324",
            "City": "Sendenhorst",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pivatstall Sevenich",
            "id": "1695-000",
            "text": "Pivatstall Sevenich in Welver (Nr.1695-000)",
            "Street": "Illinger Str. 38a",
            "ZIP": "59514",
            "City": "Welver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Büsgeshof",
            "id": "1696-000",
            "text": "Büsgeshof in Ratingen  (Nr.1696-000)",
            "Street": "Götschenbeck  1",
            "ZIP": "40883",
            "City": "Ratingen ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eggers",
            "id": "1697-000",
            "text": "Eggers in Kaiser-Wilhelm-Kroog (Nr.1697-000)",
            "Street": "Norderstraße 2",
            "ZIP": "25709",
            "City": "Kaiser-Wilhelm-Kroog",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitsportanlage Eichholz",
            "id": "1698-000",
            "text": "Reitsportanlage Eichholz in Steinheim (Nr.1698-000)",
            "Street": "Heinrich-Spier-Straße 32",
            "ZIP": "32839",
            "City": "Steinheim",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Wojewski",
            "id": "1699-000",
            "text": "Privatstall Wojewski in Rosendahl-Holtwick (Nr.1699-000)",
            "Street": "Riege 9",
            "ZIP": "48720",
            "City": "Rosendahl-Holtwick",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitverein Balve",
            "id": "1700-000",
            "text": "Reitverein Balve in Balve (Nr.1700-000)",
            "Street": "Wocklum  9",
            "ZIP": "58802",
            "City": "Balve",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schowwe",
            "id": "1701-000",
            "text": "Privatstall Schowwe in Osnabrück (Nr.1701-000)",
            "Street": "Bauerschaft Hickingen 40",
            "ZIP": "49086",
            "City": "Osnabrück",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Weilinghoff",
            "id": "1702-000",
            "text": "Privatstall Weilinghoff in Heek (Nr.1702-000)",
            "Street": "Ahle  117",
            "ZIP": "48619",
            "City": "Heek",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Gut Ruhrfeld",
            "id": "1703-000",
            "text": "Gut Ruhrfeld in Schwerte (Nr.1703-000)",
            "Street": "Gut Ruhrfeld ",
            "ZIP": "58239",
            "City": "Schwerte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RTG Berge Halver",
            "id": "1704-000",
            "text": "RTG Berge Halver in Halver (Nr.1704-000)",
            "Street": "Berge 3",
            "ZIP": "58553",
            "City": "Halver",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pensionsstall Hüttmann",
            "id": "1705-000",
            "text": "Pensionsstall Hüttmann in Essen (Nr.1705-000)",
            "Street": "Donnerberg 92a",
            "ZIP": "45357",
            "City": "Essen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Quast",
            "id": "1706-000",
            "text": "Hof Quast in Olpe (Nr.1706-000)",
            "Street": "Fahlenscheid  3",
            "ZIP": "57462",
            "City": "Olpe",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reit- und Fahrrverein Attendorn – Askay e.V.",
            "id": "1707-000",
            "text": "Reit- und Fahrrverein Attendorn – Askay e.V. in Attendorn (Nr.1707-000)",
            "Street": "Lamfertweg ",
            "ZIP": "57439",
            "City": "Attendorn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wulf",
            "id": "1708-000",
            "text": "Hof Wulf in Werl (Nr.1708-000)",
            "Street": "Soester Str. 41",
            "ZIP": "59457",
            "City": "Werl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Zenshof",
            "id": "1709-000",
            "text": "Zenshof in Bedburg (Nr.1709-000)",
            "Street": "Friedensstraße  39",
            "ZIP": "50181",
            "City": "Bedburg",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Anumee Bendestorf ",
            "id": "1710-000",
            "text": "Hof Anumee Bendestorf  in Bendestorf  (Nr.1710-000)",
            "Street": "Kleckerwaldstraße  39",
            "ZIP": "21227",
            "City": "Bendestorf ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Kooymans",
            "id": "1711-000",
            "text": "Privatstall Kooymans in Höxter (Nr.1711-000)",
            "Street": "Wiesenstraße  30",
            "ZIP": "37671",
            "City": "Höxter",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schulz",
            "id": "1712-000",
            "text": "Privatstall Schulz in Düdenbüttel (Nr.1712-000)",
            "Street": "Weißenmoor 15",
            "ZIP": "21709",
            "City": "Düdenbüttel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Simon",
            "id": "1713-000",
            "text": "Privatstall Simon in Tating (Nr.1713-000)",
            "Street": "Dorfstraße  1",
            "ZIP": "25881",
            "City": "Tating",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Dreger",
            "id": "1714-000",
            "text": "Privatstall Dreger in Südheide / Hermannsburg (Nr.1714-000)",
            "Street": "Hemmetworth  6",
            "ZIP": "29320",
            "City": "Südheide / Hermannsburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Stefan Heling",
            "id": "1715-000",
            "text": "Stall Stefan Heling in Ahaus (Nr.1715-000)",
            "Street": "Averesch 18",
            "ZIP": "48683",
            "City": "Ahaus",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schermbeck",
            "id": "1716-000",
            "text": "Privatstall Schermbeck in Schermbeck (Nr.1716-000)",
            "Street": "Zur Alten Lippe 22",
            "ZIP": "46514",
            "City": "Schermbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Stegemann",
            "id": "1717-000",
            "text": "Privatstall Stegemann in Coesfeld (Nr.1717-000)",
            "Street": "Stripperhook 26",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Riedemann",
            "id": "1718-000",
            "text": "Hof Riedemann in Oerlinghausen (Nr.1718-000)",
            "Street": "Oetenhauser Str. 43",
            "ZIP": "33813",
            "City": "Oerlinghausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Laurienshof Christian Uelschen",
            "id": "1719-000",
            "text": "Laurienshof Christian Uelschen in Garbsen (Nr.1719-000)",
            "Street": "Stöckener Str. 1",
            "ZIP": "30826",
            "City": "Garbsen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatadresse Basylec",
            "id": "1720-000",
            "text": "Privatadresse Basylec in Hohenwestedt (Nr.1720-000)",
            "Street": "An der Kleinbahn 28",
            "ZIP": "24594",
            "City": "Hohenwestedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Büttner",
            "id": "1721-000",
            "text": "Privatstall Büttner in Rees (Nr.1721-000)",
            "Street": "Schledenhorst 1",
            "ZIP": "46459",
            "City": "Rees",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Winkel",
            "id": "1722-000",
            "text": "Winkel in Blender (Nr.1722-000)",
            "Street": "Winkel 5",
            "ZIP": "27337",
            "City": "Blender",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Funke",
            "id": "1723-000",
            "text": "Hof Funke in Wadersloh (Nr.1723-000)",
            "Street": "Vahlhauser Weg 4",
            "ZIP": "49329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Wöllersberg",
            "id": "1724-000",
            "text": "Reitstall Wöllersberg in Wermelskirchen (Nr.1724-000)",
            "Street": "Wöllersberg  2",
            "ZIP": "42929",
            "City": "Wermelskirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV Dorsten",
            "id": "1725-000",
            "text": "ZRFV Dorsten in Dorsten (Nr.1725-000)",
            "Street": "Im Ovelgünne 16",
            "ZIP": "46282",
            "City": "Dorsten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Förderverein für Hippopädagogik & Reitsport e.V. Zeven",
            "id": "1726-000",
            "text": "Förderverein für Hippopädagogik & Reitsport e.V. Zeven in Zeven (Nr.1726-000)",
            "Street": "Kirchhofsallee ",
            "ZIP": "27404",
            "City": "Zeven",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdestall Haskenau",
            "id": "1727-000",
            "text": "Pferdestall Haskenau in Münster (Nr.1727-000)",
            "Street": "Zur Haskenau 71",
            "ZIP": "48157",
            "City": "Münster",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Christinenhof",
            "id": "1728-000",
            "text": "Christinenhof in Frechen (Nr.1728-000)",
            "Street": "Freimersdorfer Weg 9",
            "ZIP": "50226",
            "City": "Frechen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitclub Walle e.V.",
            "id": "1729-000",
            "text": "Reitclub Walle e.V. in Bremen (Nr.1729-000)",
            "Street": "Mittelwischweg  1",
            "ZIP": "28237",
            "City": "Bremen",
            "Bundesland": "Bremen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wente",
            "id": "1730-000",
            "text": "Hof Wente in Unna (Nr.1730-000)",
            "Street": "Hinterstraße  1",
            "ZIP": "59427",
            "City": "Unna",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "TJ Quarter Horses",
            "id": "1731-000",
            "text": "TJ Quarter Horses in Emmerthal (Nr.1731-000)",
            "Street": "Völkerhausen 5",
            "ZIP": "31860",
            "City": "Emmerthal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kruthoff ",
            "id": "1732-000",
            "text": "Kruthoff  in Ahaus-Alstätte (Nr.1732-000)",
            "Street": "Buurser Straße 85",
            "ZIP": "48683",
            "City": "Ahaus-Alstätte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Ritzenhof",
            "id": "1733-000",
            "text": "Ritzenhof in Elsdorf (Nr.1733-000)",
            "Street": "Hahnenstr. 65",
            "ZIP": "50189",
            "City": "Elsdorf",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Frieling",
            "id": "1734-000",
            "text": "Privathof Frieling in Emsdetten (Nr.1734-000)",
            "Street": "Westumer Landstr.  69",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Voss",
            "id": "1735-000",
            "text": "Privathof Voss in Heinsberg  (Nr.1735-000)",
            "Street": "Rurstraße 7",
            "ZIP": "52525",
            "City": "Heinsberg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Ellernhof",
            "id": "1736-000",
            "text": "Pferdepension Ellernhof in Springe (Nr.1736-000)",
            "Street": "In der Ellern 2",
            "ZIP": "31832",
            "City": "Springe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Heiduk",
            "id": "1737-000",
            "text": "Privatstall Heiduk in Hagen im Bremischen (Nr.1737-000)",
            "Street": "Dorfhagener Allee 1",
            "ZIP": "27628",
            "City": "Hagen im Bremischen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Ksinski",
            "id": "1738-000",
            "text": "Privathof Ksinski in Verl (Nr.1738-000)",
            "Street": "Binnerweg 55",
            "ZIP": "33415",
            "City": "Verl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Dercks",
            "id": "1739-000",
            "text": "Privathof Dercks in Geldern (Nr.1739-000)",
            "Street": "Loerheideweg  21a",
            "ZIP": "47608",
            "City": "Geldern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Sonnenhof Hofolpe",
            "id": "1740-000",
            "text": "Sonnenhof Hofolpe in Kirchhundem (Nr.1740-000)",
            "Street": "Saalweg  53",
            "ZIP": "57399",
            "City": "Kirchhundem",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Wilk",
            "id": "1741-000",
            "text": "Privathof Wilk in Langenfeld (Nr.1741-000)",
            "Street": "Rothenberger Str. 6",
            "ZIP": "40764",
            "City": "Langenfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hölzle",
            "id": "1742-000",
            "text": "Hölzle in Jüchen (Nr.1742-000)",
            "Street": "Dürselen 176",
            "ZIP": "41363",
            "City": "Jüchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Schaper",
            "id": "1743-000",
            "text": "Privathof Schaper in Didderse (Nr.1743-000)",
            "Street": "Celler Straße 1",
            "ZIP": "38530",
            "City": "Didderse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "RFV Steele-Horst",
            "id": "1744-000",
            "text": "RFV Steele-Horst in Essen (Nr.1744-000)",
            "Street": "Schultenweg  98",
            "ZIP": "45279",
            "City": "Essen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Werth",
            "id": "1745-000",
            "text": "Privatstall Werth in Soest (Nr.1745-000)",
            "Street": "Bördenstraße 22",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Global Dressage Horses",
            "id": "1746-000",
            "text": "Global Dressage Horses in Wallenhorst (Nr.1746-000)",
            "Street": "Im alten Dorf 13a",
            "ZIP": "49134",
            "City": "Wallenhorst",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Haak",
            "id": "1747-000",
            "text": "Privathof Haak in Westerkappeln (Nr.1747-000)",
            "Street": "Wulverliet  2",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rittmeyer",
            "id": "1748-000",
            "text": "Privatstall Rittmeyer in Jade (Nr.1748-000)",
            "Street": "Oldenbroker Str. 5",
            "ZIP": "26349",
            "City": "Jade",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Victoria",
            "id": "1749-000",
            "text": "Privatstall Victoria in Loxstedt (Nr.1749-000)",
            "Street": "Frankensteiner Str. 4a",
            "ZIP": "27612",
            "City": "Loxstedt",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Tidow ",
            "id": "1750-000",
            "text": "Reitstall Tidow  in Springe (Nr.1750-000)",
            "Street": "Am Thie 25",
            "ZIP": "31832",
            "City": "Springe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Funke",
            "id": "1751-000",
            "text": "Privatstall Funke in Sundern (Nr.1751-000)",
            "Street": "Altenhellefelder Str. 1",
            "ZIP": "59846",
            "City": "Sundern",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Knigge",
            "id": "1752-000",
            "text": "Privatstall Knigge in Belm (Nr.1752-000)",
            "Street": "Bergstraße 121",
            "ZIP": "49191",
            "City": "Belm",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Bröckmann",
            "id": "1753-000",
            "text": "Reitstall Bröckmann in Bönen (Nr.1753-000)",
            "Street": "Sinnerstraße  7",
            "ZIP": "59199",
            "City": "Bönen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hackmann's Biohof",
            "id": "1754-000",
            "text": "Hackmann's Biohof in Westerkappeln (Nr.1754-000)",
            "Street": "Heerstr. 71",
            "ZIP": "49492",
            "City": "Westerkappeln",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Rolle",
            "id": "1755-000",
            "text": "Hof Rolle in Meinerzhagen (Nr.1755-000)",
            "Street": "Neuhohlinden 1",
            "ZIP": "58540",
            "City": "Meinerzhagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Große Kleimann",
            "id": "1756-000",
            "text": "Privatstall Große Kleimann in Metelen (Nr.1756-000)",
            "Street": "Samberg 35",
            "ZIP": "48629",
            "City": "Metelen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Steinberg",
            "id": "1757-000",
            "text": "Privatstall Steinberg in Meschede (Nr.1757-000)",
            "Street": "Enste 5",
            "ZIP": "59872",
            "City": "Meschede",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall David in Heilshoop ",
            "id": "1758-000",
            "text": "Stall David in Heilshoop  in Zarpen (Nr.1758-000)",
            "Street": "Hauptstraße 26",
            "ZIP": "23619",
            "City": "Zarpen",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Strohbücker",
            "id": "1759-000",
            "text": "Strohbücker in Coesfeld (Nr.1759-000)",
            "Street": "Harle  48a",
            "ZIP": "48653",
            "City": "Coesfeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Piel",
            "id": "1760-000",
            "text": "Reitstall Piel in Sibbesse (Nr.1760-000)",
            "Street": "Westfelder Hauptstraße 35",
            "ZIP": "31079",
            "City": "Sibbesse",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Gestüt Ebbing",
            "id": "1761-000",
            "text": "Gestüt Ebbing in Kempen (Nr.1761-000)",
            "Street": "Krefelder Weg 68",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "ZRFV Salzbergen",
            "id": "1762-000",
            "text": "ZRFV Salzbergen in Salzbergen (Nr.1762-000)",
            "Street": "Emsstraße 15",
            "ZIP": "48499",
            "City": "Salzbergen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension und Zuchtstall Lauer",
            "id": "1763-000",
            "text": "Pferdepension und Zuchtstall Lauer in Handewitt  (Nr.1763-000)",
            "Street": "Ahnebylund 15",
            "ZIP": "24983",
            "City": "Handewitt ",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Zimmermann",
            "id": "1764-000",
            "text": "Reitstall Zimmermann in Uetze (Nr.1764-000)",
            "Street": "Schwüblingserstr. 13",
            "ZIP": "31311",
            "City": "Uetze",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Nobiskrug",
            "id": "1765-000",
            "text": "Pferdehof Nobiskrug in Jever (Nr.1765-000)",
            "Street": "Sandeler Mühlenweg  1-3",
            "ZIP": "26441",
            "City": "Jever",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Krampitz",
            "id": "1766-000",
            "text": "Krampitz in Pohle (Nr.1766-000)",
            "Street": "Apelerner Straße 11",
            "ZIP": "31867",
            "City": "Pohle",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Ponyparadies Waltrop",
            "id": "1768-000",
            "text": "Ponyparadies Waltrop in Waltrop (Nr.1768-000)",
            "Street": "Auf dem Heiken 28",
            "ZIP": "45731",
            "City": "Waltrop",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Landgut Diepeschrath",
            "id": "1769-000",
            "text": "Landgut Diepeschrath in Bergisch Gladbach (Nr.1769-000)",
            "Street": "Diepeschrath  1",
            "ZIP": "51469",
            "City": "Bergisch Gladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Bei Dornuf",
            "id": "1770-000",
            "text": "Bei Dornuf in Krefeld (Nr.1770-000)",
            "Street": "Hökendyk 2",
            "ZIP": "47802",
            "City": "Krefeld",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Breuer",
            "id": "1771-000",
            "text": "Privatstall Breuer in Schiphorst (Nr.1771-000)",
            "Street": "Steinhorster Weg 5",
            "ZIP": "23847",
            "City": "Schiphorst",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Erlenhagen ",
            "id": "1772-000",
            "text": "Reitstall Erlenhagen  in Gummersbach (Nr.1772-000)",
            "Street": "Wasserwerkstraße  5",
            "ZIP": "51647",
            "City": "Gummersbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fiege",
            "id": "1773-000",
            "text": "Privatstall Fiege in Velbert  (Nr.1773-000)",
            "Street": "Asbachtal 6",
            "ZIP": "42553",
            "City": "Velbert ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Neumann",
            "id": "1774-000",
            "text": "Privathof Neumann in Reken  (Nr.1774-000)",
            "Street": "Heltweg 18",
            "ZIP": "48734",
            "City": "Reken ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Dahlhoff ",
            "id": "1775-000",
            "text": "Reitstall Dahlhoff  in Kempen (Nr.1775-000)",
            "Street": "An der Gastendonk 25a",
            "ZIP": "47906",
            "City": "Kempen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Becker",
            "id": "1776-000",
            "text": "Privatstall Becker in Neuenkirchen-Vörden (Nr.1776-000)",
            "Street": "Astrup  19",
            "ZIP": "49434",
            "City": "Neuenkirchen-Vörden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Voss",
            "id": "1777-000",
            "text": "Voss in Lingen  (Nr.1777-000)",
            "Street": "Bramharstr 5",
            "ZIP": "49811",
            "City": "Lingen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hansen",
            "id": "1778-000",
            "text": "Hof Hansen in Duisburg  (Nr.1778-000)",
            "Street": "Holtumer Mühlenweg  25",
            "ZIP": "47259",
            "City": "Duisburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdehof Sophie",
            "id": "1779-000",
            "text": "Pferdehof Sophie in Henstedt Ulzburg (Nr.1779-000)",
            "Street": "Weedentwiete  ",
            "ZIP": "24558",
            "City": "Henstedt Ulzburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hofer Hof",
            "id": "1780-000",
            "text": "Hofer Hof in Viersen (Nr.1780-000)",
            "Street": "Amrather Weg 13",
            "ZIP": "41751",
            "City": "Viersen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Eagle Free Ranch",
            "id": "1781-000",
            "text": "Eagle Free Ranch in Steyerberg (Nr.1781-000)",
            "Street": "Deblinghausen  19",
            "ZIP": "31595",
            "City": "Steyerberg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Bockholtshoff ",
            "id": "1782-000",
            "text": "Bockholtshoff  in Schneverdingen  (Nr.1782-000)",
            "Street": "Pappelallee  5",
            "ZIP": "29640",
            "City": "Schneverdingen ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "HofLeben eV",
            "id": "1783-000",
            "text": "HofLeben eV in Dahlenburg (Nr.1783-000)",
            "Street": "Hauptstraße 1",
            "ZIP": "21368",
            "City": "Dahlenburg",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Böke",
            "id": "1784-000",
            "text": "Privathof Böke in Porta Westfalica (Nr.1784-000)",
            "Street": "Weserblick 17",
            "ZIP": "32457",
            "City": "Porta Westfalica",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Büsing",
            "id": "1785-000",
            "text": "Privatstall Büsing in Burgwedel (Nr.1785-000)",
            "Street": "Dorfstraße 29",
            "ZIP": "30938",
            "City": "Burgwedel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Humpert",
            "id": "1786-000",
            "text": "Privatstall Humpert in Hessisch Oldendorf (Nr.1786-000)",
            "Street": "Teichstrasse  4",
            "ZIP": "31840",
            "City": "Hessisch Oldendorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Fey",
            "id": "1787-000",
            "text": "Privatstall Fey in Ochtrup (Nr.1787-000)",
            "Street": "Spinnereistraße  5",
            "ZIP": "48607",
            "City": "Ochtrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Rosenstengel",
            "id": "1788-000",
            "text": "Privatstall Rosenstengel in Neuenrade (Nr.1788-000)",
            "Street": "Vorm Schorfe 1",
            "ZIP": "58809",
            "City": "Neuenrade",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Klingeberg Burgstemmen ",
            "id": "1789-000",
            "text": "Hof Klingeberg Burgstemmen  in Nordstemmen (Nr.1789-000)",
            "Street": "Berkel 3",
            "ZIP": "31171",
            "City": "Nordstemmen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Fleck",
            "id": "1790-000",
            "text": "Privathof Fleck in Lienen (Nr.1790-000)",
            "Street": "Mühlenweg 2",
            "ZIP": "49536",
            "City": "Lienen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Senden",
            "id": "1791-000",
            "text": "RV Senden in Senden (Nr.1791-000)",
            "Street": "Dorfbauernschaft 102b",
            "ZIP": "48308",
            "City": "Senden",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Hauptmeier",
            "id": "1792-000",
            "text": "Stall Hauptmeier in Wadersloh (Nr.1792-000)",
            "Street": "Stromberger Str 62",
            "ZIP": "59329",
            "City": "Wadersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Heinz",
            "id": "1793-000",
            "text": "Privathof Heinz in Hagen a.T.W. (Nr.1793-000)",
            "Street": "Achter De Welt 2",
            "ZIP": "49170",
            "City": "Hagen a.T.W.",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Pleines",
            "id": "1794-000",
            "text": "Privatstall Pleines in Delbrück (Nr.1794-000)",
            "Street": "Lippstädter Str. 109",
            "ZIP": "33129",
            "City": "Delbrück",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Uphoff",
            "id": "1795-000",
            "text": "Privatstall Uphoff in Großheide (Nr.1795-000)",
            "Street": "Südarlerlandstr. 24",
            "ZIP": "26532",
            "City": "Großheide",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Haerskötter",
            "id": "1796-000",
            "text": "Privathof Haerskötter in Emsdetten (Nr.1796-000)",
            "Street": "Austum 26",
            "ZIP": "48282",
            "City": "Emsdetten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Große-Hartmann",
            "id": "1797-000",
            "text": "Hof Große-Hartmann in Warendorf  (Nr.1797-000)",
            "Street": "Vohren 7",
            "ZIP": "48231",
            "City": "Warendorf ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "RV Saerbeck",
            "id": "1798-000",
            "text": "RV Saerbeck in Saerbeck (Nr.1798-000)",
            "Street": "Riesenbecker Straße 44",
            "ZIP": "48369",
            "City": "Saerbeck",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Pferdepension Ameln",
            "id": "1799-000",
            "text": "Pferdepension Ameln in Oberlangen (Nr.1799-000)",
            "Street": "Marienstraße  13",
            "ZIP": "49779",
            "City": "Oberlangen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Albers Rosenhof",
            "id": "1800-000",
            "text": "Albers Rosenhof in Bispingen (Nr.1800-000)",
            "Street": "Rosenhof 2",
            "ZIP": "29646",
            "City": "Bispingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Freyer",
            "id": "1801-000",
            "text": "Freyer in Neetze/Neu-Neetze (Nr.1801-000)",
            "Street": "Neu Süttorf 16",
            "ZIP": "21398",
            "City": "Neetze/Neu-Neetze",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Renz",
            "id": "1802-000",
            "text": "Privathof Renz in Weyhe (Nr.1802-000)",
            "Street": "Heidstraße 53",
            "ZIP": "28844",
            "City": "Weyhe",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Nimmert",
            "id": "1803-000",
            "text": "Privathof Nimmert in Großenwörden (Nr.1803-000)",
            "Street": "Seestraße  13",
            "ZIP": "21712",
            "City": "Großenwörden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Trauzettel",
            "id": "1804-000",
            "text": "Privatstall Trauzettel in Marl  (Nr.1804-000)",
            "Street": "Herner Weg 20",
            "ZIP": "45772",
            "City": "Marl ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Püschel",
            "id": "1805-000",
            "text": "Privathof Püschel in Verl (Nr.1805-000)",
            "Street": "Holter Landstraße  81",
            "ZIP": "33415",
            "City": "Verl",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lüthje",
            "id": "1806-000",
            "text": "Privatstall Lüthje in Hemmingen (Nr.1806-000)",
            "Street": "Ostertorstraße  25a",
            "ZIP": "30966",
            "City": "Hemmingen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Breiderhoff",
            "id": "1807-000",
            "text": "Privatstall Breiderhoff in Duisburg  (Nr.1807-000)",
            "Street": "Orsoyer Str.  1",
            "ZIP": "47199",
            "City": "Duisburg ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Silver Diamond Ranch",
            "id": "1808-000",
            "text": "Silver Diamond Ranch in Velbert  (Nr.1808-000)",
            "Street": "Wallmichrather Straße  26a",
            "ZIP": "42555",
            "City": "Velbert ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Kuhlmann",
            "id": "1809-000",
            "text": "Kuhlmann in Gelsenkirchen (Nr.1809-000)",
            "Street": "Böningstr. 153a",
            "ZIP": "45892",
            "City": "Gelsenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Post",
            "id": "1810-000",
            "text": "Privatstall Post in Twistringen (Nr.1810-000)",
            "Street": "Zur Mühle 64",
            "ZIP": "27239",
            "City": "Twistringen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Lutter",
            "id": "1811-000",
            "text": "Privatstall Lutter in Vahlbruch (Nr.1811-000)",
            "Street": "An der Kirche 8",
            "ZIP": "37647",
            "City": "Vahlbruch",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstsall Scheepers",
            "id": "1812-000",
            "text": "Privatstsall Scheepers in Niederkrüchten (Nr.1812-000)",
            "Street": "Erkelenzer Straße 69",
            "ZIP": "41372",
            "City": "Niederkrüchten",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Nordmann",
            "id": "1813-000",
            "text": "Stall Nordmann in Saterland  (Nr.1813-000)",
            "Street": "Vorm Moor 34",
            "ZIP": "26683",
            "City": "Saterland ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Isaak",
            "id": "1814-000",
            "text": "Hof Isaak in Soest (Nr.1814-000)",
            "Street": "Erzväterring  5",
            "ZIP": "59494",
            "City": "Soest",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Messing",
            "id": "1815-000",
            "text": "Hof Messing in Schöppingen (Nr.1815-000)",
            "Street": "Heven 40",
            "ZIP": "48624",
            "City": "Schöppingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reitstall Bega",
            "id": "1816-000",
            "text": "Reitstall Bega in Dörentrup (Nr.1816-000)",
            "Street": "Sibbentruper Str. 12",
            "ZIP": "32694",
            "City": "Dörentrup",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": " Reitstall Claßen - Brachelen",
            "id": "1817-000",
            "text": " Reitstall Claßen - Brachelen in Hückelhoven (Nr.1817-000)",
            "Street": "Kahrweghof  1",
            "ZIP": "41836",
            "City": "Hückelhoven",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Wollesen",
            "id": "1818-000",
            "text": "Stall Wollesen in Twedt (Nr.1818-000)",
            "Street": "Kappelner Straße 6",
            "ZIP": "24894",
            "City": "Twedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Wiefel",
            "id": "1819-000",
            "text": "Privathof Wiefel in Greven  (Nr.1819-000)",
            "Street": "Postdamm 30",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Reiterhof Laubner",
            "id": "1820-000",
            "text": "Reiterhof Laubner in Gütersloh (Nr.1820-000)",
            "Street": "Blankenhagener Weg 139",
            "ZIP": "22224",
            "City": "Gütersloh",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Thomsen",
            "id": "1821-000",
            "text": "Privatstall Thomsen in Lindewitt (Nr.1821-000)",
            "Street": "Süderreihe 3",
            "ZIP": "24969",
            "City": "Lindewitt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Schlecht",
            "id": "1822-000",
            "text": "Privatstall Schlecht in Unna (Nr.1822-000)",
            "Street": "Zum Bröhl 1",
            "ZIP": "59427",
            "City": "Unna",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Meinhardt",
            "id": "1823-000",
            "text": "Privatstall Meinhardt in Mönchengladbach (Nr.1823-000)",
            "Street": "Großheide 248",
            "ZIP": "41063",
            "City": "Mönchengladbach",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Spiekerhof",
            "id": "1824-000",
            "text": "Spiekerhof in Borgholzhausen (Nr.1824-000)",
            "Street": "Wichlinghausen 11",
            "ZIP": "33829",
            "City": "Borgholzhausen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Birkenhof",
            "id": "1825-000",
            "text": "Birkenhof in Stapelfeld (Nr.1825-000)",
            "Street": "Hauptstraße 5",
            "ZIP": "22145",
            "City": "Stapelfeld",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Löcke",
            "id": "1826-000",
            "text": "Hof Löcke in Neuenkirchen (Nr.1826-000)",
            "Street": "Landersum 13",
            "ZIP": "48485",
            "City": "Neuenkirchen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Andersen",
            "id": "1827-000",
            "text": "Privathof Andersen in Silberstedt (Nr.1827-000)",
            "Street": "Stapelholmer Weg 8",
            "ZIP": "24887",
            "City": "Silberstedt",
            "Bundesland": "Schleswig-Holstein",
            "Land": "Deutschland"
        },
        {
            "name": "Bat Oak Ranch",
            "id": "1828-000",
            "text": "Bat Oak Ranch in Winsen OT Stedden (Nr.1828-000)",
            "Street": "Zum Hahnenberg ",
            "ZIP": "29308",
            "City": "Winsen OT Stedden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Sattelberatung & Mehr",
            "id": "1829-000",
            "text": "Sattelberatung & Mehr in Ratingen (Nr.1829-000)",
            "Street": "August-Prell-Strasse 34",
            "ZIP": "40885",
            "City": "Ratingen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Eilers",
            "id": "1830-000",
            "text": "Privathof Eilers in Ostbevern  (Nr.1830-000)",
            "Street": "Kattmannskamp  8",
            "ZIP": "48346",
            "City": "Ostbevern ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Tenhumberg",
            "id": "1831-000",
            "text": "Privathof Tenhumberg in Horstmar (Nr.1831-000)",
            "Street": "Haltern 60",
            "ZIP": "48612",
            "City": "Horstmar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schubert",
            "id": "1832-000",
            "text": "Stall Schubert in Melle  (Nr.1832-000)",
            "Street": "Brockmannsweg  8",
            "ZIP": "49326",
            "City": "Melle ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Flothhof",
            "id": "1833-000",
            "text": "Flothhof in Greven  (Nr.1833-000)",
            "Street": "Flothdamm 6",
            "ZIP": "48268",
            "City": "Greven ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Adrian",
            "id": "1834-000",
            "text": "Privathof Adrian in Welver  (Nr.1834-000)",
            "Street": "Hammer Landstraße 4",
            "ZIP": "59514",
            "City": "Welver ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Wemmel",
            "id": "1835-000",
            "text": "Hof Wemmel in Leiferde (Nr.1835-000)",
            "Street": "Glider Weg 78",
            "ZIP": "38542",
            "City": "Leiferde",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hesse",
            "id": "1836-000",
            "text": "Privatstall Hesse in Kalkar (Nr.1836-000)",
            "Street": "Hochstrasse  6a",
            "ZIP": "47546",
            "City": "Kalkar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Peveling",
            "id": "1837-000",
            "text": "Peveling in Castrop-Rauxel (Nr.1837-000)",
            "Street": "Kanalstraße 58",
            "ZIP": "44579",
            "City": "Castrop-Rauxel",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "OS Sporthorses",
            "id": "1838-000",
            "text": "OS Sporthorses in Stadtlohn  (Nr.1838-000)",
            "Street": "Am Esch 9",
            "ZIP": "48703",
            "City": "Stadtlohn ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privathof Wallrabenstein",
            "id": "1839-000",
            "text": "Privathof Wallrabenstein in Grube (Nr.1839-000)",
            "Street": "Fährkamp 4",
            "ZIP": "23749",
            "City": "Grube",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Planwagenfahrten Wendel ",
            "id": "1840-000",
            "text": "Planwagenfahrten Wendel  in Hamm  (Nr.1840-000)",
            "Street": "Dortmunder Straße 269",
            "ZIP": "59077",
            "City": "Hamm ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Schering",
            "id": "1841-000",
            "text": "Stall Schering in Petershagen (Nr.1841-000)",
            "Street": "Mitteldorf 17",
            "ZIP": "32469",
            "City": "Petershagen",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Heil",
            "id": "1842-000",
            "text": "Privatstall Heil in Lindlar (Nr.1842-000)",
            "Street": "Müllersommer 2",
            "ZIP": "51789",
            "City": "Lindlar",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Privatstall Hanisch",
            "id": "1843-000",
            "text": "Privatstall Hanisch in Engden (Nr.1843-000)",
            "Street": "Emsfort 8a",
            "ZIP": "48465",
            "City": "Engden",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Wentholt",
            "id": "1844-000",
            "text": "Wentholt in Südlohn (Nr.1844-000)",
            "Street": "Tünte 3",
            "ZIP": "46354",
            "City": "Südlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Efker",
            "id": "1845-000",
            "text": "Hof Efker in Lippetal (Nr.1845-000)",
            "Street": "Heintroper Str 23",
            "ZIP": "59510",
            "City": "Lippetal",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Fam. Assen",
            "id": "1846-000",
            "text": "Fam. Assen in Vreden  (Nr.1846-000)",
            "Street": "Nork 113",
            "ZIP": "48691",
            "City": "Vreden ",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Hesse",
            "id": "1847-000",
            "text": "Hof Hesse in Binnen (Nr.1847-000)",
            "Street": " Am Rohrbach 12",
            "ZIP": "31619",
            "City": "Binnen",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Stall Büter",
            "id": "1848-000",
            "text": "Stall Büter in Surwold (Nr.1848-000)",
            "Street": "Hauptstraße  14",
            "ZIP": "26903",
            "City": "Surwold",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Brinkerhook",
            "id": "1849-000",
            "text": "Brinkerhook in  Ahaus- Alstätte (Nr.1849-000)",
            "Street": "Brinkerhook  12",
            "ZIP": "48683",
            "City": " Ahaus- Alstätte",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "De Paddloepers - Bewegungsstall Schnelle",
            "id": "1850-000",
            "text": "De Paddloepers - Bewegungsstall Schnelle in Martfeld (Nr.1850-000)",
            "Street": "Kiwitt  13",
            "ZIP": "27327",
            "City": "Martfeld",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Geitmann",
            "id": "1851-000",
            "text": "Hof Geitmann in Iserlohn (Nr.1851-000)",
            "Street": "Leckerhorstweg  22",
            "ZIP": "58642",
            "City": "Iserlohn",
            "Bundesland": "Nordrhein-Westfalen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Liedke",
            "id": "1852-000",
            "text": "Hof Liedke in Adelheidsdorf  (Nr.1852-000)",
            "Street": "Kurfürstendamm 39",
            "ZIP": "29352",
            "City": "Adelheidsdorf ",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Otten",
            "id": "1853-000",
            "text": "Hof Otten in Elsdorf (Nr.1853-000)",
            "Street": "Ostestraße  10",
            "ZIP": "27404",
            "City": "Elsdorf",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "name": "Hof Auetal",
            "id": "1854-000",
            "text": "Hof Auetal in Barsbüttel (Nr.1854-000)",
            "Street": "Bahnhofstraße  10",
            "ZIP": "22885",
            "City": "Barsbüttel",
            "Bundesland": "Niedersachsen",
            "Land": "Deutschland"
        },
        {
            "ID": "10-000",
            "name": "Brockhausen in Münster (Nr.10-000)",
            "street": "Böddingheideweg 48a",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "11-000",
            "name": "Hinske/Dunkelmann in Münster (Nr.11-000)",
            "street": "Angelsachsenweg 111",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "12-000",
            "name": "RV Sendenhorst in Sendenhorst (Nr.12-000)",
            "street": "Alter Postweg 3",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "13-000",
            "name": "RV Amelsbüren in Münster (Nr.13-000)",
            "street": "Thierstraße 291",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "14-000",
            "name": "Schulze Hobeling in Telgte (Nr.14-000)",
            "street": "Grevener Straße 161",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "15-000",
            "name": "Averkamp in Münster (Nr.15-000)",
            "street": "Gremmendorfer Weg 210",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "16-000",
            "name": "Gestüt Förster in Lüdinghausen (Nr.16-000)",
            "street": "Ermen 55",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "17-000",
            "name": "Rusticus in Münster (Nr.17-000)",
            "street": "Münsterstraße 128b",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "18-000",
            "name": "Ponyhof Georgenbruch in Everswinkel (Nr.18-000)",
            "street": "Müssingen 25",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "19-000",
            "name": "Holtkötter in Münster (Nr.19-000)",
            "street": "Kötterstr. 120",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "20-000",
            "name": "Niehoff in Münster (Nr.20-000)",
            "street": "Westfalenstr. 90",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "21-000",
            "name": "AR Trainingstable in Sendenhorst (Nr.21-000)",
            "street": "Rummler 32",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "22-000",
            "name": "Jostmeier  in Dülmen (Nr.22-000)",
            "street": "Feldmark 18",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "23-000",
            "name": "Reitstall Haves in Sendenhorst (Nr.23-000)",
            "street": "Sunger 7",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "24-000",
            "name": "Pferdehof Ludwig in Drensteinfurt (Nr.24-000)",
            "street": "Eickendorf 36",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "25-000",
            "name": "Pferdehof Schabhüser in Warendorf (Nr.25-000)",
            "street": "Neuwarendorf 3",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "26-000",
            "name": "Weidenhof in Drensteinfurt (Nr.26-000)",
            "street": "Göttendorfer Weg 94",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "27-000",
            "name": "Hengststation Holkenbrink in Münster (Nr.27-000)",
            "street": "Oberort 20",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "28-000",
            "name": "West I 12 (Privat)  in Sendenhorst (Nr.28-000)",
            "street": "West I 12",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "29-000",
            "name": "Stegemann-Wibbelt in Münster (Nr.29-000)",
            "street": "Kanalstraße 258",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "30-000",
            "name": "RV Albachten in Münster (Nr.30-000)",
            "street": "Oberort 105",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "31-000",
            "name": "Sekic in Sendenhorst (Nr.31-000)",
            "street": "Sudfeld 9",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "32-000",
            "name": "RV Ascheberg in Ascheberg (Nr.32-000)",
            "street": "Windmühlenweg 10",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "33-000",
            "name": "RuF Greven in Greven (Nr.33-000)",
            "street": "Saerbeckerstrasse 190",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "34-000",
            "name": "Westphalia Stables in Hörstel (Nr.34-000)",
            "street": "Ludwigswald 101",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "35-000",
            "name": "Kammler in Emsdetten (Nr.35-000)",
            "street": "Saerbecker Weg 32",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "36-000",
            "name": "RV Enigger Vorhelm in Ennigerloh (Nr.36-000)",
            "street": "Balhorn 1",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "37-000",
            "name": "Berkenheide in Greven (Nr.37-000)",
            "street": "Am Mühlenbach 46",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "38-000",
            "name": "Reitanlage Hase  in Welver (Nr.38-000)",
            "street": "Postweg 1-3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "39-000",
            "name": "Weringhof  in Hamm (Nr.39-000)",
            "street": "Am Weringhof 1",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "40-000",
            "name": "Reitanlage Hidding in Greven (Nr.40-000)",
            "street": "Wentruper Mark 45",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "41-000",
            "name": "Möllenbeck  in Münster (Nr.41-000)",
            "street": "Kreuzbach 326",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "43-000",
            "name": "Herrenstein (Kruckenbaum) in Drensteinfurt (Nr.43-000)",
            "street": "Kerkpatt 24",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "44-000",
            "name": "Reitstall Twent  in Nottuln (Nr.44-000)",
            "street": "Gladbeck 10",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "45-000",
            "name": "Landhof Große-Hellmann in münster (Nr.45-000)",
            "street": "Niederort 131",
            "house_number": "1",
            "zipcode": "48308",
            "city": "münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "46-000",
            "name": "Stall Beckmann  in Münster (Nr.46-000)",
            "street": "Hofkamp 132",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "47-000",
            "name": "Korte  in Telgte (Nr.47-000)",
            "street": "Lauheide 26",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "48-000",
            "name": "RuV Hiltrup  in Münster (Nr.48-000)",
            "street": "Hünenburg 22",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "49-000",
            "name": "RV Albersloh in Sendenhorst (Nr.49-000)",
            "street": "Hohe Ward 5",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "50-000",
            "name": "Frankenhof in Rehau (Nr.50-000)",
            "street": "Degenreuth 2",
            "house_number": "1",
            "zipcode": "95111",
            "city": "Rehau",
            "state": "Bayern",
            "collect_point": "nein"
        },
        {
            "ID": "51-000",
            "name": "Triebus Fallenberg  in Ennigerloh (Nr.51-000)",
            "street": "Wessenhorst 20",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "52-000",
            "name": "Grumbach  in Harsewinkel (Nr.52-000)",
            "street": "Hallerstrasse 37",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "53-000",
            "name": "RV Rhynern  in Hamm (Nr.53-000)",
            "street": "Holthöfener Weg 1A",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "54-000",
            "name": "Feddermann  in Greven (Nr.54-000)",
            "street": "Saerbeckerstr. 150",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "55-000",
            "name": "RV Roxel  in Münster (Nr.55-000)",
            "street": "Bösenseller Straße 6",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "56-000",
            "name": "Zur Rossheide  in Münster (Nr.56-000)",
            "street": "Zur Rossheide 2",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "57-000",
            "name": "Don A Rima Ranch in Warendorf (Nr.57-000)",
            "street": "Neuwarendorf 56A",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "58-000",
            "name": "RuFWadelheim-Rheine  in Rheine (Nr.58-000)",
            "street": "Ohner Damm 9",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "59-000",
            "name": "Kögel in Porta Westfalica (Nr.59-000)",
            "street": "Am Rehm 10",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "60-000",
            "name": "Heimann in Sendenhorst (Nr.60-000)",
            "street": "Rummler 1",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "61-000",
            "name": "Pferdepension Kellenberg in Hemsloh (Nr.61-000)",
            "street": "Wagenfelderstraße 28",
            "house_number": "1",
            "zipcode": "49453",
            "city": "Hemsloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "62-000",
            "name": "Laumann in Greven (Nr.62-000)",
            "street": "Laumanns Damm 22",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "63-000",
            "name": "RuF Recklinghausen  in Recklinghausen (Nr.63-000)",
            "street": "Lindenstr. 82",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "64-000",
            "name": "Gut Holtmann  in Billerbeck (Nr.64-000)",
            "street": "Dörholt 14",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "65-000",
            "name": "Jana Preissing  in Senden (Nr.65-000)",
            "street": "Gettrup 13",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "66-000",
            "name": "Meckmann-Dorsel in Münster (Nr.66-000)",
            "street": "Markweg 100",
            "house_number": "1",
            "zipcode": "48147",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "67-000",
            "name": "Pfedehof Rohmann  in Hörstel (Nr.67-000)",
            "street": "Brachtesendeweg 215",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "68-000",
            "name": "RV Ennigerloh-Neubeckum in Ennigerloh (Nr.68-000)",
            "street": "In der Hoest  22",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "69-000",
            "name": "Reitanlage Ansgar Westrup  in Havixbeck (Nr.69-000)",
            "street": "Schonebeck 21",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "70-000",
            "name": "Mölllers  in Münster (Nr.70-000)",
            "street": "Lauheide 31",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "72-000",
            "name": "Privater Offenstall in Bottrop (Nr.72-000)",
            "street": "Im Spring 87",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "73-000",
            "name": "RV Wadelheim Rheine in Rheine (Nr.73-000)",
            "street": "Ohner Damm 13",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "74-000",
            "name": "Reiterhof Rohmann  in Nordwalde (Nr.74-000)",
            "street": "Westerode 41",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "75-000",
            "name": "Hof Hinterberg  in Westernkappeln (Nr.75-000)",
            "street": "Hoppenliet 21",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westernkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "76-000",
            "name": "Hengsthaltung Becks in Senden (Nr.76-000)",
            "street": "Dorfbauerschaft 39",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "77-000",
            "name": "Wernsmann  in Hörstel (Nr.77-000)",
            "street": "Münsterdamm 16a",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "78-000",
            "name": "Pferdehof  Hillebrandt in Coesfeld (Nr.78-000)",
            "street": "Letter Berg 16",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "79-000",
            "name": "Kinnebrock in Münster (Nr.79-000)",
            "street": "Erbdrostenweg 285",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "81-000",
            "name": "Hof Leusmann in Rheine (Nr.81-000)",
            "street": "Riesenbeckerstr. 180",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "82-000",
            "name": "Stall Schmitz in Ibbenbüren-Dickenberg (Nr.82-000)",
            "street": "Am Mariannenschacht  85",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren-Dickenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "83-000",
            "name": "Pferdehof Hackenesch in Münster (Nr.83-000)",
            "street": "Im Dahl 13a",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "84-000",
            "name": "Kammann in Senden (Nr.84-000)",
            "street": "Wierling 33",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "85-000",
            "name": "Pferdehof Lohmann in Münster (Nr.85-000)",
            "street": "Westfalen Strasse 48",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "86-000",
            "name": " in Billerbeck (Nr.86-000)",
            "street": "Bockelsdorf 22",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "87-000",
            "name": "Reitanlage Kost in Bochum (Nr.87-000)",
            "street": "Havkenscheider Straße 243",
            "house_number": "1",
            "zipcode": "44803",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "88-000",
            "name": "Privatstall in Viernheim (Nr.88-000)",
            "street": "Am Alten Weinheimer Weg 13",
            "house_number": "1",
            "zipcode": "68589",
            "city": "Viernheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "89-000",
            "name": "Burfeind in Sittensen (Nr.89-000)",
            "street": "Alte Dorfstraße ",
            "house_number": "1",
            "zipcode": "27419",
            "city": "Sittensen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "90-000",
            "name": "Fam. Aupers in Münster (Nr.90-000)",
            "street": "Havixbecker Straße 101",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "91-000",
            "name": "RV Ahlen in Ahlen (Nr.91-000)",
            "street": "Walstedderstr. 176",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "92-000",
            "name": "Hof Beckmann in Recklinghausen (Nr.92-000)",
            "street": "Bockholterstraße 445",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "93-000",
            "name": "Hildesheim marienburg in Hildesheim (Nr.93-000)",
            "street": "Beusterstrasse 22",
            "house_number": "1",
            "zipcode": "31141",
            "city": "Hildesheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "94-000",
            "name": "Reitstall Engelke in Hülsede (Nr.94-000)",
            "street": "Zur Bauernstelle 7",
            "house_number": "1",
            "zipcode": "31867",
            "city": "Hülsede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "95-000",
            "name": "RV Loikum in Hamminkeln (Nr.95-000)",
            "street": "Mehrbruch 1",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "96-000",
            "name": "Niehues in Ledgen (Nr.96-000)",
            "street": "Isingort 63",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Ledgen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "97-000",
            "name": "Pferdepension Peter Horstmann in Sendenhorst (Nr.97-000)",
            "street": "Alter Postweg 38",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "98-000",
            "name": "Hof Freisfeld in Ascheberg (Nr.98-000)",
            "street": "Ostereckern 11",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "99-000",
            "name": "Vechtehof Pröbsting in Wettringen (Nr.99-000)",
            "street": "Vollenbrok 1",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "100-000",
            "name": "Reit- und Fahrverein Lüdinghausen in Lüdinghausen (Nr.100-000)",
            "street": "Elvert 26",
            "house_number": "1",
            "zipcode": "53948",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "101-000",
            "name": "Engemann in Rheda Wiedenbrück (Nr.101-000)",
            "street": "Auf der Horst 29",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "102-000",
            "name": "Hof Schütte in Spelle (Nr.102-000)",
            "street": "An der Koppel 1",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "103-000",
            "name": "ZRFV Neuenkirchen in Neuenkirchen (Nr.103-000)",
            "street": "Haarweg 42",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "104-000",
            "name": "Schulte Mesum in Rheine (Nr.104-000)",
            "street": "Feuerstiege 31",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "106-000",
            "name": "Gestüt Borgert in Coesfeld (Nr.106-000)",
            "street": "Harle 51",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "107-000",
            "name": "Hollenhorst Stables in Thuine (Nr.107-000)",
            "street": "Hollenhorst 1",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "108-000",
            "name": "Steinschulte in Hamm (Nr.108-000)",
            "street": "Frielick 6",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "109-000",
            "name": "Hof Schulze Everding in Münster (Nr.109-000)",
            "street": "Brock 200",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "110-000",
            "name": "Birkenhof Birgte / Riesenbeck in Hörstel (Nr.110-000)",
            "street": "Saerbecker Damm 261",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "111-000",
            "name": "Reitverein Reken in Reken (Nr.111-000)",
            "street": "Berge 12",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "112-000",
            "name": "Reitverein Billerbeck in Billerbeck (Nr.112-000)",
            "street": "Hamern 13",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "113-000",
            "name": "Reitanlage Kettlerholz in Welver (Nr.113-000)",
            "street": "Kettlerholz 39",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "115-000",
            "name": "Selbstabholer in Rheine (Nr.115-000)",
            "street": "Max-Born-Straße 4",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "116-000",
            "name": "Grothues-Homann in Senden (Nr.116-000)",
            "street": "Schölling 17",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "117-000",
            "name": "Reitanlage Hilbring in Recklinghausen (Nr.117-000)",
            "street": "Rittbörden 48",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "118-000",
            "name": "Hof Westerfeld in Datteln (Nr.118-000)",
            "street": "Hagemer Kirchweg 104",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "119-000",
            "name": "Falkhof in Lienen (Nr.119-000)",
            "street": "Im Siensfeld 1",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "120-000",
            "name": "Teigeler Datteln in Datteln (Nr.120-000)",
            "street": "Hagemer Kirchweg 82",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "121-000",
            "name": "Pferdehof Stöppelmann in Hamm (Nr.121-000)",
            "street": "Wambelner Straße 9",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "122-000",
            "name": "Reit- und Fahrverein Bawinkel in Bawinkel (Nr.122-000)",
            "street": "Am Sportplatz ",
            "house_number": "1",
            "zipcode": "49844",
            "city": "Bawinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "123-000",
            "name": "Reitverein St.Georg Heek-Nienborg e.V. in Heek (Nr.123-000)",
            "street": "Averbeck 105",
            "house_number": "1",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "124-000",
            "name": "Reitanlage Harde in Welver (Nr.124-000)",
            "street": "Hillingsen 1",
            "house_number": "1",
            "zipcode": "59515",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "125-000",
            "name": "Reitanlage Lippetal in Lippetal (Nr.125-000)",
            "street": "Dolberger Str. 76",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "126-000",
            "name": "Privatstall Fenner in Greven (Nr.126-000)",
            "street": "Kroner Heide 33",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "127-000",
            "name": "Alte Vogtei Schloss Vornholz in Ennigerloh (Nr.127-000)",
            "street": "Zum Hohen Kreuz 16",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "128-000",
            "name": "Small Hill Stable in Hamm (Nr.128-000)",
            "street": "Hölter 21",
            "house_number": "1",
            "zipcode": "59065",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "129-000",
            "name": "Hof Floer in Nordwalde (Nr.129-000)",
            "street": "Suttorf 11",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "130-000",
            "name": "Gisa de Angelis in Münster (Nr.130-000)",
            "street": "Bredeheide 152",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "131-000",
            "name": "Hülskötter in Greven (Nr.131-000)",
            "street": "Hüttruper Str. 86",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "132-000",
            "name": "Hoogenhof in Kamp-Lintfort (Nr.132-000)",
            "street": "Xantener Str. 80",
            "house_number": "1",
            "zipcode": "47475",
            "city": "Kamp-Lintfort",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "133-000",
            "name": "RuF Spelle in Spelle (Nr.133-000)",
            "street": "In den Gärten 20",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "134-000",
            "name": "Hövelmann in Sendenhorst (Nr.134-000)",
            "street": "West II",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "137-000",
            "name": "Thurau in Haselünne (Nr.137-000)",
            "street": "Kreuzweg 14",
            "house_number": "1",
            "zipcode": "49740",
            "city": "Haselünne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "138-000",
            "name": "Raming-Freesen in Oberlangen (Nr.138-000)",
            "street": "Zur Marsch 15",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "139-000",
            "name": "Therapiehof Welp in Wettringen (Nr.139-000)",
            "street": "Bilk 57",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "140-000",
            "name": "Burlage in Telgte-Westbevern (Nr.140-000)",
            "street": "Lütken Heide 32",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte-Westbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "141-000",
            "name": "Vinzenzwerk handorf e.V. in Münster (Nr.141-000)",
            "street": "Flugplatz 53",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "142-000",
            "name": "Overbeck in Herten (Nr.142-000)",
            "street": "Weiherstraße ",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "143-000",
            "name": "Schulte  in Spelle (Nr.143-000)",
            "street": "Bönnestr. 8",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "144-000",
            "name": "Weymanns Pony Ranch in Neuenkirchen (Nr.144-000)",
            "street": "Mühlendamm 97",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "146-000",
            "name": "Reitanlage am Rehrbach in Schermbeck (Nr.146-000)",
            "street": "Am Rehrbach 98",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "147-000",
            "name": "Hof Zumkley in Senden (Nr.147-000)",
            "street": "Kley 14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "148-000",
            "name": "Horses in Flames Bleckum in Beckum (Nr.148-000)",
            "street": "Elker 16",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "149-000",
            "name": "Felix Ponyhof in Rietberg (Nr.149-000)",
            "street": "Schulstr. 130",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "150-000",
            "name": "Reiterhof Hunsche in Lienen (Nr.150-000)",
            "street": "Reiterweg 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "152-000",
            "name": "Hof Stimberg in Datteln (Nr.152-000)",
            "street": "Recklinghäuserstr. 140",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "153-000",
            "name": "Schmidt in Everswinkel (Nr.153-000)",
            "street": "Müssingen 38",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "155-000",
            "name": "Privatstall Wiermann in Mettingen (Nr.155-000)",
            "street": "Hagebröcker Weg 22",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "156-000",
            "name": "Lieningshof in Neuenhaus (Nr.156-000)",
            "street": "Lager Str. 110",
            "house_number": "1",
            "zipcode": "49828",
            "city": "Neuenhaus",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "157-000",
            "name": "Ostkotte in Ochtrup (Nr.157-000)",
            "street": "Winkelstraße 31",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "158-000",
            "name": "Reitanlage Wilhelm Mönnich in Datteln (Nr.158-000)",
            "street": "Klosterner Weg 2",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "159-000",
            "name": "Pach in Nordhorn (Nr.159-000)",
            "street": "Am Nolland 18",
            "house_number": "1",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "160-000",
            "name": "Veltmaat in Wietmarschen (Nr.160-000)",
            "street": "Pferdebahn 5",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "161-000",
            "name": "Berning in Rheine (Nr.161-000)",
            "street": "Bredeweg 161",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "162-000",
            "name": "Vischedyk in Gronau (Nr.162-000)",
            "street": "Metelner Damm ",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "163-000",
            "name": "Gripshöver in Werne (Nr.163-000)",
            "street": "Martinsweg 4",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "164-000",
            "name": "Schlüter in Werne (Nr.164-000)",
            "street": "Martinsweg 19",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "165-000",
            "name": "St. Georg Werne in Werne (Nr.165-000)",
            "street": "Kähte-Kollwitz Str. 103",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "166-000",
            "name": "Thünemann in Andervenne (Nr.166-000)",
            "street": "Toschlag 6",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Andervenne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "167-000",
            "name": "Ross in Rheine (Nr.167-000)",
            "street": "Kämpe 75",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "168-000",
            "name": "Die Freigänger in Borken (Nr.168-000)",
            "street": "Coesfelder Straße 69",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "169-000",
            "name": "Werpers in Emsdetten (Nr.169-000)",
            "street": "Ahlintel 45",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "170-000",
            "name": "Pensionsstall Brinker in Fürstenau (Nr.170-000)",
            "street": "Kellinghausen 27",
            "house_number": "1",
            "zipcode": "49584",
            "city": "Fürstenau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "171-000",
            "name": "Frie in Greven (Nr.171-000)",
            "street": "Aldruper Oberesch 26",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "172-000",
            "name": "Privatstall Neumann in Gütersloh (Nr.172-000)",
            "street": "Luise-Henselstraße 129",
            "house_number": "1",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "173-000",
            "name": "Reitanlage Münstermann in Werl-Holtum (Nr.173-000)",
            "street": "Am Jahenbrink 10",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl-Holtum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "174-000",
            "name": "Privatstall Muke in Geeste (Nr.174-000)",
            "street": "Zur Schleuse 25",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "175-000",
            "name": "Reitanlage Kohlmann in Dortmund (Nr.175-000)",
            "street": "Eichwaldstr. 103",
            "house_number": "1",
            "zipcode": "44419",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "176-000",
            "name": "Offenstall Nordwalde Reckenfeld in Nordwalde (Nr.176-000)",
            "street": "Suttorf 99",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "177-000",
            "name": "Tankstelle Holtwick Öffentlich in Rosendahl (Nr.177-000)",
            "street": "Coesfelder Straße 6",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "178-000",
            "name": "Berghoff in Albersloh (Nr.178-000)",
            "street": "Sunger 15",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Albersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "179-000",
            "name": "Blömker in Lienen (Nr.179-000)",
            "street": "Kattenvenner Str. 60",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "180-000",
            "name": "Reitanlage Nordhoff in Emsdetten (Nr.180-000)",
            "street": "Reckenfelderstr. 92",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "181-000",
            "name": "Rawert in Coesfeld-Lette (Nr.181-000)",
            "street": "Herteler 74",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld-Lette",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "182-000",
            "name": "Hof Schulte-Kellinghaus in Gladbeck (Nr.182-000)",
            "street": "Feldhauserstraße 416",
            "house_number": "1",
            "zipcode": "45966",
            "city": "Gladbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "183-000",
            "name": "Einfach Pferdisch in Dorsten (Nr.183-000)",
            "street": "Kippheide 60",
            "house_number": "1",
            "zipcode": "46286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "184-000",
            "name": "Ruhmann in Beckum (Nr.184-000)",
            "street": "Holtmar 4",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "185-000",
            "name": "Hof Balzer in Herten  (Nr.185-000)",
            "street": "Elper Straße 217",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "186-000",
            "name": "RfV Rheine/Catenhorn in Rheine (Nr.186-000)",
            "street": "Bauernschaftsstrasse 153",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "187-000",
            "name": "Rv St. Georg Münster in Münster (Nr.187-000)",
            "street": "Reiner-Klimke-Weg 1",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "188-000",
            "name": "JP - Reiten mit Verstand und Gefühl in Geeste (Nr.188-000)",
            "street": "Süd-Nord-Straße 20",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "189-000",
            "name": "RuF Nordhorn e.V. in Nordhorn (Nr.189-000)",
            "street": "Neuenhauser Str. 257",
            "house_number": "1",
            "zipcode": "48527",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "190-000",
            "name": "Schulze Everding Amelsbüren in Münster (Nr.190-000)",
            "street": "Daverstr. 7",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "191-000",
            "name": "Gerd Niederschabbehard in Steinhagen (Nr.191-000)",
            "street": "In der Howe 1",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "192-000",
            "name": "Busmann in Schüttorf (Nr.192-000)",
            "street": "Alter Emsbürener Weg 21",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "193-000",
            "name": "Hof Wilhelmer in Telgte (Nr.193-000)",
            "street": "Verth 13",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "194-000",
            "name": "Reitverein Marl Hof Ostgathe in Marl (Nr.194-000)",
            "street": "Rottmanskamp 23a",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "195-000",
            "name": "Pferdehof Osterholt in Südlohn (Nr.195-000)",
            "street": "Hessinghook 14",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "196-000",
            "name": "Pferdehof Wiegard in Ennigerloh (Nr.196-000)",
            "street": "Hoest 19",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "197-000",
            "name": "Private Stallgemeinschaft Banker in Rosendahl (Nr.197-000)",
            "street": "Rockel 60",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "198-000",
            "name": "Privatstall Mennemann in Lienen (Nr.198-000)",
            "street": "Am Hagen 3",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "199-000",
            "name": "Reiterhof Jungkamp in Rhede (Nr.199-000)",
            "street": "Zum Venn 34",
            "house_number": "1",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "200-000",
            "name": "Equiva Münster in Münster (öffentlich) (Nr.200-000)",
            "street": "Dieckstraße 71-75",
            "house_number": "1",
            "zipcode": "48145",
            "city": "Münster (öffentlich)",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "201-000",
            "name": "Fohlenhof Steins  in Waltrop (Nr.201-000)",
            "street": "Unterlippe 26",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "202-000",
            "name": "Reitverein St. Martin Stadtlohn in Stadtlohn (Nr.202-000)",
            "street": "Losberg 1",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "203-000",
            "name": "Reitstall Engelernerhof in Merzen  (Nr.203-000)",
            "street": "Fürstenauer Damm 22",
            "house_number": "1",
            "zipcode": "49586",
            "city": "Merzen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "204-000",
            "name": "Rennstall Pavel  in Halle  (Nr.204-000)",
            "street": "Gewerbestr. 4",
            "house_number": "1",
            "zipcode": "33790",
            "city": "Halle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "205-000",
            "name": "Hof Quante  in Münster  (Nr.205-000)",
            "street": "Am Mooresch 35",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "206-000",
            "name": "Haverkamp  in Ostbevern  (Nr.206-000)",
            "street": "Loburg 39",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "207-000",
            "name": "Harenburg  in Hollage (Nr.207-000)",
            "street": "Dörnter Weg 2",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Hollage",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "208-000",
            "name": "Bussmann  in Haltern am See  (Nr.208-000)",
            "street": "Flaesheimerstraße 276",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "209-000",
            "name": "Wienken  in Südlohn (Nr.209-000)",
            "street": "Sickinghook 5",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "210-000",
            "name": "Strosi  in Salzbergen  (Nr.210-000)",
            "street": "Brandeweg 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "211-000",
            "name": "Pferdehof Helmert  in Marienfeld/Harsewinkel  (Nr.211-000)",
            "street": "Lutterstrang 16",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Marienfeld/Harsewinkel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "212-000",
            "name": "Grossmann/Brockmann  in Rheine (Nr.212-000)",
            "street": "Kloddenhook 23",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "213-000",
            "name": "Privatstall Laurenz  in Gronau  (Nr.213-000)",
            "street": "Bergstraße 67",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "214-000",
            "name": "Pferdepension Bauer  in Greven  (Nr.214-000)",
            "street": "Herberner Mersch 70",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "215-000",
            "name": "Kleinblei  in Nordkirchen  (Nr.215-000)",
            "street": "Funneweg 2",
            "house_number": "1",
            "zipcode": "59394",
            "city": "Nordkirchen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "216-000",
            "name": "Colrado-Ranch  in Recklinghausen (Nr.216-000)",
            "street": "Hestermannweg Ecke Heinrichstraße ",
            "house_number": "1",
            "zipcode": "45663",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "217-000",
            "name": "Osthoff  in Welver  (Nr.217-000)",
            "street": "Recklingser Straße  1",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "218-000",
            "name": "Pferdehof Gerling  in Greven  (Nr.218-000)",
            "street": "Maestruper Brook 19",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "219-000",
            "name": "Reit-und Pferdepension Bartling  in Meppen  (Nr.219-000)",
            "street": "Dorfstraße 1",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "220-000",
            "name": "Wilde  in Rosendahl  (Nr.220-000)",
            "street": "Schlee 4",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "221-000",
            "name": "Reitstall FN Elberich  in Münster  (Nr.221-000)",
            "street": "Alter Mühlenweg 41",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "222-000",
            "name": "Privatstall Ripperda  in Lingen  (Nr.222-000)",
            "street": "Altenlingener Weg 85",
            "house_number": "1",
            "zipcode": "49808",
            "city": "Lingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "223-000",
            "name": "Privatstall Suttrup  in Senden  (Nr.223-000)",
            "street": "Dorfbauerschaft 122",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "224-000",
            "name": "Privatstall Bad Iburg  in Bad Iburg  (Nr.224-000)",
            "street": "Alter Postdamm 2",
            "house_number": "1",
            "zipcode": "49186",
            "city": "Bad Iburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "225-000",
            "name": "Sportpferde Hüsken  in Wietmarschen  (Nr.225-000)",
            "street": "Auf der Haare 2",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "226-000",
            "name": "Privatstall Christaller  in Rosendahl  (Nr.226-000)",
            "street": "Rockel 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "227-000",
            "name": "Rieskamp  in Recke  (Nr.227-000)",
            "street": "Haarkamp 15",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "228-000",
            "name": "Reiterhof Thier  in Marl  (Nr.228-000)",
            "street": "Johannesstraße 52",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "229-000",
            "name": "ZRFV St. Hubertus in Dreierwalde (Nr.229-000)",
            "street": "Venhäuser Weg  7",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Dreierwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "230-000",
            "name": "Stall Decker  in Vreden  (Nr.230-000)",
            "street": "Lünten Sand ",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "231-000",
            "name": "Aschhoff  in Ennigerloh  (Nr.231-000)",
            "street": "Pilatusberg 18",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "232-000",
            "name": "Temminghoff  in Heiden  (Nr.232-000)",
            "street": "Stegge 4",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "233-000",
            "name": "RUF Nordbögge-Lerch  in Bönen (Nr.233-000)",
            "street": "Schmerhöfeler Weg 5",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "234-000",
            "name": "Paddocktrail  in Melle  (Nr.234-000)",
            "street": "Haseweg 11",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "235-000",
            "name": "Repeler Hof  in Bottrop  (Nr.235-000)",
            "street": "Repeler Weg 25",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "236-000",
            "name": "DraBo Ranch  in Nottuln  (Nr.236-000)",
            "street": "Kley 66",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "238-000",
            "name": "Privatstall Bindernagel  in Rheine  (Nr.238-000)",
            "street": "Russenweg 16",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "239-000",
            "name": "RC. St. Mauritz  in Münster (Nr.239-000)",
            "street": "Pleistermühlenweg 144",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "240-000",
            "name": "Hof Brengenberg  in Haltern am See (Nr.240-000)",
            "street": "Dorstener Straße 950",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "241-000",
            "name": "Reiterhof Wilmsberg  in Steinfurt (Nr.241-000)",
            "street": "Wilmsberg 35a",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "242-000",
            "name": "Stall Hesseler  in Bottrop  (Nr.242-000)",
            "street": "Brabecker Feld  29A",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "243-000",
            "name": "Hof Mersmann  in Laer (Nr.243-000)",
            "street": "Altenbergerstrasse 3",
            "house_number": "1",
            "zipcode": "48366",
            "city": "Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "244-000",
            "name": "Mein Offenstall in Nordhorn (Nr.244-000)",
            "street": "Harmsenweg 6",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "245-000",
            "name": "Privatstall Surmann in Lingen (Nr.245-000)",
            "street": "Bawinkler Straße 5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "246-000",
            "name": "RuFV von Nagel Herbern in Ascheberg (Nr.246-000)",
            "street": "Am Haselbüschken 5",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "247-000",
            "name": "Reitanlage Tögemann in Marl (Nr.247-000)",
            "street": "Obersinsener Str 172",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "248-000",
            "name": "Sennekamp in Hamm (Nr.248-000)",
            "street": "Baumstraße 47",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "249-000",
            "name": "Stall Schulze Zumkley in Olfen (Nr.249-000)",
            "street": "Im Hagen 1",
            "house_number": "1",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "250-000",
            "name": "Can Equi in Halle Westfalen (Nr.250-000)",
            "street": "Haller Strasse 8",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Halle Westfalen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "251-000",
            "name": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See e.V. in Haltern am See (Nr.251-000)",
            "street": "Münsterstraße 163",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "252-000",
            "name": "Vor dem Brocke in Lingen (Nr.252-000)",
            "street": "Hohlweg 2",
            "house_number": "1",
            "zipcode": "49808",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "253-000",
            "name": "Reitverein Vorhelm Schäringer Feld in Ahlen (Nr.253-000)",
            "street": "Enniger Str. 70",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "254-000",
            "name": "Gut Hohenkamp in Dorsten (Nr.254-000)",
            "street": "Hohenkamp 75",
            "house_number": "1",
            "zipcode": "46284",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "255-000",
            "name": "Pferdepension Mühlenbeck in Münster  (Nr.255-000)",
            "street": "Roxeler Straße 447",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "256-000",
            "name": "Lackmanns Hof in Recklinghausen (Nr.256-000)",
            "street": "Nonnenbuschweg 24",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "257-000",
            "name": "Weeke in Lienen (Nr.257-000)",
            "street": "Glandorfer Damm 48",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "258-000",
            "name": "Privatstall Dijital Santalar in Thuine (Nr.258-000)",
            "street": "Messinger Straße 4",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "259-000",
            "name": "Privater Bauernhof Albersloh in Sendenhorst (Nr.259-000)",
            "street": "Sunger 6a",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "260-000",
            "name": "Gut Behringhausen in Castrop-Rauxel (Nr.260-000)",
            "street": "Westring 135",
            "house_number": "1",
            "zipcode": "44575",
            "city": "Castrop-Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "261-000",
            "name": "Kinderreitschule Gießler in Münster (Nr.261-000)",
            "street": "Buddenbrink 70",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "262-000",
            "name": "Schräder in Ladbergen (Nr.262-000)",
            "street": "Am Venn 26",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "263-000",
            "name": "Mindrup in Münster (Nr.263-000)",
            "street": "Kreuzbach 40",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "264-000",
            "name": "Otte in Gronau-Epe (Nr.264-000)",
            "street": "Gerdingseite 13",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "265-000",
            "name": "Pensionsstall Perm in Ibbenbbüren (Nr.265-000)",
            "street": "Permer Straße 120",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "266-000",
            "name": "Reitanlage Schloss Wilbringen  in Waltrop (Nr.266-000)",
            "street": "Wilbringen 1",
            "house_number": "1",
            "zipcode": "45371",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "267-000",
            "name": "Familie Winzen  in Reken (Nr.267-000)",
            "street": "Vossplacke 4a",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "268-000",
            "name": "Am Dewesberg in Hopsten (Nr.268-000)",
            "street": "Am Dewesberg 1",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "269-000",
            "name": "Pferdehof Bohlmann in Bippen (Nr.269-000)",
            "street": "Schockländer Straße 5",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Bippen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "270-000",
            "name": "Diekmanns Freigänger in Borken  (Nr.270-000)",
            "street": "Boesweg 38",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "271-000",
            "name": "Hof Dahlkamp in Selm - Cappenberg (Nr.271-000)",
            "street": "Zum Birkenbaum 60",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm - Cappenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "272-000",
            "name": "Privatstall Boedeker in Vreden  (Nr.272-000)",
            "street": "Theodor Heuss Str. 4",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "273-000",
            "name": "Kurk in Greven  (Nr.273-000)",
            "street": "Hüttruper Str. 193",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "274-000",
            "name": "Ponyrosa Ranch in Wadersloh (Nr.274-000)",
            "street": "Herzebrockweg 3",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "275-000",
            "name": "Privatstall Deupmann in Rheine  (Nr.275-000)",
            "street": "Salzbergener Str. ",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "276-000",
            "name": "Münch in Recklinghausen (Nr.276-000)",
            "street": "Hoher Steinweg 33",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "277-000",
            "name": "Schwenken in Münster (Nr.277-000)",
            "street": "Davertstrasse 137",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "278-000",
            "name": "Pferdepension Middelhoff in Steinfurt (Nr.278-000)",
            "street": "Hollicher Straße 99",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "279-000",
            "name": "Pferdepension Northoff  in Ahlen  (Nr.279-000)",
            "street": "Borbeiner Straße 28",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "280-000",
            "name": "Privatstall Ehring in Hörstel (Nr.280-000)",
            "street": "Emsdettener Str. 205",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "281-000",
            "name": "Privatstall Schaffrinna in Lünen (Nr.281-000)",
            "street": "An der Wethmarheide 120",
            "house_number": "1",
            "zipcode": "44536",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "282-000",
            "name": "Keßler's Landhaus in Münster (Nr.282-000)",
            "street": "Raringheide 226",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "283-000",
            "name": "Reiterhof Beermann in Senden (Nr.283-000)",
            "street": "Leversum 13",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "284-000",
            "name": "Privatstall Dove in Schüttorf (Nr.284-000)",
            "street": "Narzissenstraße 18",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "285-000",
            "name": "Stall Gruber in Vreden  (Nr.285-000)",
            "street": "Doemern ",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "286-000",
            "name": "Privatstall Riering in Havixbeck (Nr.286-000)",
            "street": "Sentrupskamp 14",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "287-000",
            "name": "Hof Koch in Marl (Nr.287-000)",
            "street": "Forststr. 78",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "288-000",
            "name": "Privatstall Burgmann in Rheine  (Nr.288-000)",
            "street": "Wadelheimer Chaussee 84",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "289-000",
            "name": "Privatstall Bütergerds in Neuenkirchen (Nr.289-000)",
            "street": "Pfarrer-Bette-Str. 5",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "290-000",
            "name": "Pferdezucht Brömmelland in Dorsten (Nr.290-000)",
            "street": "Endelner Weg 201",
            "house_number": "1",
            "zipcode": "48286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "291-000",
            "name": "Ütrecht in Samern (Nr.291-000)",
            "street": "Ohnerstr. 129 129",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Samern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "292-000",
            "name": "Föcking in Südlohn (Nr.292-000)",
            "street": "Amselstrasse 29",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "293-000",
            "name": "Islandpferde Ems-Land in Geeste (Nr.293-000)",
            "street": "Erikastrasse 5",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "294-000",
            "name": "Winterhalder in Gronau (Nr.294-000)",
            "street": "Röntgenstr. 11",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "295-000",
            "name": "Hof Stukenborg in Haltern am See (Nr.295-000)",
            "street": "Rekenerstraße 221",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "296-000",
            "name": "Equiva Rheine in Rheine  (Nr.296-000)",
            "street": "Hansaallee 49-51",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "297-000",
            "name": "Hof Heemann - Pensionsstallbetrieb in Lienen (Nr.297-000)",
            "street": "Nigge Weg ",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "298-000",
            "name": "Privatstall Kempkes in Hörstel (Nr.298-000)",
            "street": "Waldstr 17",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "299-000",
            "name": "Privatstall Janson in Coesfeld (Nr.299-000)",
            "street": "Herteler 32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "300-000",
            "name": "Lüttecke in Telgte (Nr.300-000)",
            "street": "Sickerhook 9",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "301-000",
            "name": "Gestüt Wechter Mark in Lengerich (Nr.301-000)",
            "street": "Wechter Str. 108",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "305-000",
            "name": "Equiva Osnabrück in Osnabrück (öffentlich) (Nr.305-000)",
            "street": "Pagenstecherstraße 28",
            "house_number": "1",
            "zipcode": "49090",
            "city": "Osnabrück (öffentlich)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "306-000",
            "name": "Bönen Hacheney in Bönen (Nr.306-000)",
            "street": "Heidestrasse 2",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "307-000",
            "name": "Pferdehof Brinkrolf in Rheda-Wiedenbrück (Nr.307-000)",
            "street": "Moorweg 112",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "308-000",
            "name": "Schulze Brüning in Münster (Nr.308-000)",
            "street": "Kanalstraße 340",
            "house_number": "1",
            "zipcode": "48143",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "309-000",
            "name": "Privatstall Jäschke in Coesfeld (Nr.309-000)",
            "street": "Südring 10",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "310-000",
            "name": "Funke in Hamm (Nr.310-000)",
            "street": "Ahlenerstrasse 240",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "311-000",
            "name": "Ludger Zumvenne in Senden (Nr.311-000)",
            "street": "Gettrup 44",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "312-000",
            "name": "Spreckelmeyer in Lienen (Nr.312-000)",
            "street": "Am Hagen 2",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "313-000",
            "name": "Lennarz in Münster (Nr.313-000)",
            "street": "Am Knapp ",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "314-000",
            "name": "Reitanlage Niehoff in Havixbeck (Nr.314-000)",
            "street": "Schonebeck 24",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "315-000",
            "name": "Privatstall Annuß in Recklinghausen (Nr.315-000)",
            "street": "Marienstr. 36",
            "house_number": "1",
            "zipcode": "45663",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "316-000",
            "name": "Köpper in Schermbeck (Nr.316-000)",
            "street": "Janbrucksfeld 92",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "317-000",
            "name": "Brinkel in Spelle (Nr.317-000)",
            "street": "Englandstraße 11",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "318-000",
            "name": "Holz Ahmann in Emsdetten (Nr.318-000)",
            "street": "Dettener Straße 10a",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "319-000",
            "name": "Privater Offenstall Scholten in Velen-Ramsdorf (Nr.319-000)",
            "street": "Südlohner Diek ",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Velen-Ramsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "320-000",
            "name": "Hölscher Pferde in Emsdetten (Nr.320-000)",
            "street": "Grünring  74",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "321-000",
            "name": "Doetkotte in Gronau (Nr.321-000)",
            "street": "Doetkottenweg  66",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "322-000",
            "name": "Hof Hidding Schulte-Bockum in Bottrop  (Nr.322-000)",
            "street": "Kreienkampsweg  9",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "323-000",
            "name": "Reitstall Neumann in Haltern am See (Nr.323-000)",
            "street": "Hellweg 230",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "324-000",
            "name": "Privatstall Meusel in Werne (Nr.324-000)",
            "street": "Münsterstraße 42",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "325-000",
            "name": "Gestüt Forellenhof in Borken  (Nr.325-000)",
            "street": "Zum Homborn 9",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "326-000",
            "name": "Reitsportanlage Melanie Menzefricke in Versmold (Nr.326-000)",
            "street": "Friedrich-Menzefrickestr. 51",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "327-000",
            "name": "Hemme in Emsbüren (Nr.327-000)",
            "street": "Zum Schultenhook 8",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "328-000",
            "name": "Pferdehof Moorheide in Senden (Nr.328-000)",
            "street": "Kley 32",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "329-000",
            "name": "Hollmann in Senden (Nr.329-000)",
            "street": "Kley  14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "330-000",
            "name": "Pferdeparadies Lögering in Lingen-Bramsche (Nr.330-000)",
            "street": "Wesel  4",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen-Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "331-000",
            "name": "Privatstall Storp in Münster (Nr.331-000)",
            "street": "Hartmannsbrook 92",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "332-000",
            "name": "Hof Wimschulte in Drensteinfurt (Nr.332-000)",
            "street": "Nordholt 3",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "333-000",
            "name": "Privatstall Dasmann in Tecklenburg (Nr.333-000)",
            "street": "Dast 1",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "335-000",
            "name": "Selbstversorger Niemand in Welver (Nr.335-000)",
            "street": "Im Loh 7a",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "336-000",
            "name": "Ausbildungsstall Koeppel in Glandorf (Nr.336-000)",
            "street": "Laersche Straße  28",
            "house_number": "1",
            "zipcode": "49219",
            "city": "Glandorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "337-000",
            "name": "Menke in Thuine (Nr.337-000)",
            "street": "Mühlenstraße 4a",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "338-000",
            "name": "Schulze Topphoff in Telgte (Nr.338-000)",
            "street": "Lütken Heide 45",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "339-000",
            "name": "Privatstall Helms in Bergkamen (Nr.339-000)",
            "street": "Kamer Heide  34",
            "house_number": "1",
            "zipcode": "59192",
            "city": "Bergkamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "340-000",
            "name": "Zeirabenhof in Sendenhorst (Nr.340-000)",
            "street": "Jönsthövel  6",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "341-000",
            "name": "Beckmann in Coesfeld (Nr.341-000)",
            "street": "Flamschen 8",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "342-000",
            "name": "Reitsportanlage Kuhlmann in Marl (Nr.342-000)",
            "street": "Dahlbrede 5",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "343-000",
            "name": "Privatstall Jansen in Rheine  (Nr.343-000)",
            "street": "Steinstr.  13b",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "344-000",
            "name": "SG Schröder Hardinghausen in Bottrop-Kirchhellen (Nr.344-000)",
            "street": "An der Harre  2",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop-Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "345-000",
            "name": "Privatstall Greven / Schmedehausen in Greven  (Nr.345-000)",
            "street": "Ostbevener Straße 26",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "346-000",
            "name": "FuRV Wettringen in Wettringen (Nr.346-000)",
            "street": "Burgsteinfurter Straße  28",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "347-000",
            "name": "Bennie Kleijn in Havixbeck (Nr.347-000)",
            "street": "Natrup  35",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "348-000",
            "name": "Jährlingsstation Deitermann in Horstmar, Leer (Nr.348-000)",
            "street": "Haltern 30",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar, Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "349-000",
            "name": "Privatstall Grave in Lienen (Nr.349-000)",
            "street": "Wulversump 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "350-000",
            "name": "Pensionsstall in Warendorf (Nr.350-000)",
            "street": "Neuwarendorf 64",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "351-000",
            "name": "Familie Beckersjürgen in Nottuln  (Nr.351-000)",
            "street": "Leopoldshöhe 6",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "352-000",
            "name": "Privatstall Wenzel in Greven  (Nr.352-000)",
            "street": "Anna-Badouin-Straße  55",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "353-000",
            "name": "Reitgemeinschaft Bönen Hacheney in Bönen (Nr.353-000)",
            "street": "Heidestraße 45",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "354-000",
            "name": "Hof Rottmann in Münster (Nr.354-000)",
            "street": "Gasselstiege 235",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "355-000",
            "name": "Fahrsportzentrum Ennigerloh in Ennigerloh  (Nr.355-000)",
            "street": "Vossmar 10",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "356-000",
            "name": "Hofstelle Dennemann in Ohne (Nr.356-000)",
            "street": "Möllenweg ",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Ohne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "357-000",
            "name": "Gestüt Heidhügel in Emsdetten (Nr.357-000)",
            "street": "Isendorfer Weg 34",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "358-000",
            "name": "Offenstall Vandreuke in Herten (Nr.358-000)",
            "street": "Backumerstr. 416",
            "house_number": "1",
            "zipcode": "45699",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "359-000",
            "name": "Klostermann in Rheine  (Nr.359-000)",
            "street": "Maiglöckchenweg  45",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "360-000",
            "name": "Kuper in Spelle (Nr.360-000)",
            "street": "Schlanestraße  17",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "361-000",
            "name": "Schürkamp in Ahlen (Nr.361-000)",
            "street": "Hagenbrede 70",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "362-000",
            "name": "Beutnagel in Spelle (Nr.362-000)",
            "street": "Stubbendorfstraße 11",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "363-000",
            "name": "Privatstall Viefhues in Riesenbeck (Nr.363-000)",
            "street": "Kanalstraße 179",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "364-000",
            "name": "Franke in Lüdinghausen (Nr.364-000)",
            "street": "Westrup  59",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "365-000",
            "name": "Ulmker in Neuenkirchen (Nr.365-000)",
            "street": "Mesumer Str.  75",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "366-000",
            "name": "Mersmann in Münster (Nr.366-000)",
            "street": "Böckenhorst 18",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "367-000",
            "name": "FS Paradise in Nordhorn (Nr.367-000)",
            "street": "Emsbürener Str. 50",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "368-000",
            "name": "Haus Küchen in Ahlen (Nr.368-000)",
            "street": "Mallinckrodtweg 25",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "369-000",
            "name": "Hof Gerlemann in Meppen (Nr.369-000)",
            "street": "Dorfstraße 14",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "371-000",
            "name": "Schnarre in Lotte (Nr.371-000)",
            "street": "Düter Str. 8",
            "house_number": "1",
            "zipcode": "49504",
            "city": "Lotte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "372-000",
            "name": "Gestüt Landhaus Schweckendieck in Wietmarschen  (Nr.372-000)",
            "street": "Am Moersfeld 33",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "373-000",
            "name": "Große Wittler in Münster (Nr.373-000)",
            "street": "Davertstraße 198",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "374-000",
            "name": "Hof Diesen in Emsdetten (Nr.374-000)",
            "street": "Aechterhoek 16",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "375-000",
            "name": "Trainingszentrum Hoffrogge in Dorsten (Nr.375-000)",
            "street": "Bestener Straße 145",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "376-000",
            "name": "Reitanlage Stapelskotten in Münster (Nr.376-000)",
            "street": "Am Mooresch  34",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "377-000",
            "name": "ZRFV Borken e.V in Borken Weseken (Nr.377-000)",
            "street": "Pröbstinger Allee 10",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken Weseken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "378-000",
            "name": "Von Kleinsorgen in Coesfeld (Nr.378-000)",
            "street": "Kalte 4",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "379-000",
            "name": "Zucht,-Reit und Fahrverein Rheine e.V. in Rheine  (Nr.379-000)",
            "street": "In der Lake 12",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "380-000",
            "name": "Strotjohann in Ostbevern (Nr.380-000)",
            "street": "Reichard-Str.  9",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "381-000",
            "name": "Schulze Temberge in Gronau (Nr.381-000)",
            "street": "Gerdingseite 3",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "382-000",
            "name": "Privatstall Rehbaum in Sendenhorst (Nr.382-000)",
            "street": "Sunger 18",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "383-000",
            "name": "Schulze Elfringhof in Ochtrup (Nr.383-000)",
            "street": "Weiner 133",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "384-000",
            "name": "Averhaus in Emsdetten (Nr.384-000)",
            "street": "Saerbecker Weg 31",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "385-000",
            "name": "Ahlbrand Pferdefutter in Münster (Nr.385-000)",
            "street": "Dalkamp  14",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "386-000",
            "name": "Peterka in Legden (Nr.386-000)",
            "street": "Wehr 159",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "387-000",
            "name": "Reitstall Stein in Wietmarschen  (Nr.387-000)",
            "street": "Wietmarschener Straße 9",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "388-000",
            "name": "Reitstall Hille in Ladbergen (Nr.388-000)",
            "street": "Brockwiesen 32",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "389-000",
            "name": "Reitstall Otten in Lingen (Nr.389-000)",
            "street": "Hüsinger Hook 2",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "390-000",
            "name": "Strodt in Lingen (Nr.390-000)",
            "street": "Schulstraße  5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "391-000",
            "name": "Eichenhof in Havixbeck (Nr.391-000)",
            "street": "Masbeck 2",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "392-000",
            "name": "Privatstall Gottschald in Stavern (Nr.392-000)",
            "street": "Sögeler Straße 19",
            "house_number": "1",
            "zipcode": "49777",
            "city": "Stavern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "393-000",
            "name": "Privatstall Beckmann in Lienen (Nr.393-000)",
            "street": "Glandorfer Damm 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "394-000",
            "name": "Eichenhof Beppen in Thedinghausen (Nr.394-000)",
            "street": "Neu-Morsumer-Weg  8",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "395-000",
            "name": "Siedehof in Steyerberg (Nr.395-000)",
            "street": "Voigtei 111",
            "house_number": "1",
            "zipcode": "31595",
            "city": "Steyerberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "396-000",
            "name": "Pferdepension Wilke in Diepholz (Nr.396-000)",
            "street": "Moorhäuser Str.  25",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "397-000",
            "name": "Stall Daubert in Sögel (Nr.397-000)",
            "street": "Stavernerstrasse  1",
            "house_number": "1",
            "zipcode": "49751",
            "city": "Sögel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "398-000",
            "name": "Schnier in Bad Oeynhausen/ Werste (Nr.398-000)",
            "street": "Ringstraße 77",
            "house_number": "1",
            "zipcode": "32549",
            "city": "Bad Oeynhausen/ Werste",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "399-000",
            "name": "Sasse in Recklinghausen (Nr.399-000)",
            "street": "Franziskanerstr. 60",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "400-000",
            "name": "Hof Suntrup in Warendorf (Nr.400-000)",
            "street": "Gronhorst 14",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "401-000",
            "name": "Hugerlandshof in Münster-Handorf (Nr.401-000)",
            "street": "Hugerlandshofweg 70",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster-Handorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "402-000",
            "name": "Privatstall von Abel in Elsfleth (Nr.402-000)",
            "street": "Oberrege  49",
            "house_number": "1",
            "zipcode": "26931",
            "city": "Elsfleth",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "403-000",
            "name": "Reiterhof Redder in Bad Driburg (Nr.403-000)",
            "street": "An der Steinbrücke ",
            "house_number": "1",
            "zipcode": "33014",
            "city": "Bad Driburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "404-000",
            "name": "Pensionsstall Heuermann in Vlotho (Nr.404-000)",
            "street": "Hettenholter Weg  37",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "405-000",
            "name": "Gerusel in Dörentrup Wendlinghausen (Nr.405-000)",
            "street": "Friedrichsfeld 2",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup Wendlinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "406-000",
            "name": "Campingplatz Schöne Ausdicht in Vlotho (Nr.406-000)",
            "street": "Lehmhöhlenweg 5",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "407-000",
            "name": "Pferdepension Wibbelmann in Bissendorf (Nr.407-000)",
            "street": "Niederberger Mark  31",
            "house_number": "1",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "408-000",
            "name": "Stall Holtkamp in Kirchlegern (Nr.408-000)",
            "street": "Brannecker Str. 56",
            "house_number": "1",
            "zipcode": "32278",
            "city": "Kirchlegern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "409-000",
            "name": "Igelmann in Bissendorf (Nr.409-000)",
            "street": "Bergstrasse  98a",
            "house_number": "1",
            "zipcode": "49153",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "410-000",
            "name": "Hof Gockel in Paderborn (Nr.410-000)",
            "street": "Dörener Holzweg 65",
            "house_number": "1",
            "zipcode": "33100",
            "city": "Paderborn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "411-000",
            "name": "Meiners in Lorup (Nr.411-000)",
            "street": "Kirchkamp 37",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Lorup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "412-000",
            "name": "Stall Aldag in Minden (Nr.412-000)",
            "street": "Mitteldamm 60",
            "house_number": "1",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "413-000",
            "name": "Privatstall Ewen in Hude (Nr.413-000)",
            "street": "Erlenweg 1",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "414-000",
            "name": "Blub in Colnrade (Nr.414-000)",
            "street": "Holtesche 5",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Colnrade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "415-000",
            "name": "Reitsport-Waldweg in Emtinghausen (Nr.415-000)",
            "street": "Waldweg 8",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Emtinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "416-000",
            "name": "Reit-und Fahrverein Wagenfeld in Wagenfeld (Nr.416-000)",
            "street": "Fritz-Cording-Str. 1",
            "house_number": "1",
            "zipcode": "49419",
            "city": "Wagenfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "417-000",
            "name": "Privatstall Kröger in Löhne (Nr.417-000)",
            "street": "Kirschenweg 5",
            "house_number": "1",
            "zipcode": "32584",
            "city": "Löhne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "418-000",
            "name": "Privatstall Goßling in Westoverledingen (Nr.418-000)",
            "street": "Heerweg 6",
            "house_number": "1",
            "zipcode": "26810",
            "city": "Westoverledingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "419-000",
            "name": "Sonntag Bielefeld in Bielefeld (Nr.419-000)",
            "street": "Hillegosser Str. 135",
            "house_number": "1",
            "zipcode": "33719",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "420-000",
            "name": "Lieschen's Ranch in Kirchlengern (Nr.420-000)",
            "street": "Horstfeld 37",
            "house_number": "1",
            "zipcode": "32278",
            "city": "Kirchlengern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "421-000",
            "name": "Gut Vinnen in Bad Salzuflen (Nr.421-000)",
            "street": "Vinnen 2",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "422-000",
            "name": "Radtke in Bremen (Nr.422-000)",
            "street": "Am Grenzknick 17a",
            "house_number": "1",
            "zipcode": "28755",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "423-000",
            "name": "Islandpferdehof Lukka in Lemgo (Nr.423-000)",
            "street": "Am Tiefen Siek 65",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "424-000",
            "name": "Ratering in Walchum (Nr.424-000)",
            "street": "Westweg  61",
            "house_number": "1",
            "zipcode": "26907",
            "city": "Walchum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "425-000",
            "name": "Kronenkamp Ranch in Bad Zwischenahn (Nr.425-000)",
            "street": "Kronenkamp 2",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "426-000",
            "name": "Petvitalshop in Bünde (Nr.426-000)",
            "street": "Elsemühlenweg 85",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "427-000",
            "name": "Overhagener Pferdehof in Bottrop (Nr.427-000)",
            "street": "Hoheheideweg 4",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "428-000",
            "name": "Claaßen in Bramsche (Nr.428-000)",
            "street": "Schleptruper Strang 64",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "429-000",
            "name": "Privatstall Junga in Bramsche (Nr.429-000)",
            "street": "Rote Riede  8",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "430-000",
            "name": "Halhof in Bielefeld (Nr.430-000)",
            "street": "Talbrückenstr. 142",
            "house_number": "1",
            "zipcode": "33609",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "431-000",
            "name": "Privatstall Rippelbeck in Bramsche (Nr.431-000)",
            "street": "Wiechmanns Ecke 3",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "432-000",
            "name": "Privatstall Semmler in Bramsche (Nr.432-000)",
            "street": "Haferkamp 21",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "433-000",
            "name": "Landgut Papenhausen in Bad Salzuflen (Nr.433-000)",
            "street": "Papenhausen 2",
            "house_number": "1",
            "zipcode": "32108",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "434-000",
            "name": "Stall Wessels in Rastede (Nr.434-000)",
            "street": "Am Eichenwall 100",
            "house_number": "1",
            "zipcode": "26180",
            "city": "Rastede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "435-000",
            "name": "Von Essen in Rastede (Nr.435-000)",
            "street": "Heiddornweg  14",
            "house_number": "1",
            "zipcode": "26180",
            "city": "Rastede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "436-000",
            "name": "Privatstall Börger in Delbrück (Nr.436-000)",
            "street": "Ehlersweg 5",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "437-000",
            "name": "Hof Eicheneck in Menslage (Nr.437-000)",
            "street": "Antener Str. 5",
            "house_number": "1",
            "zipcode": "49637",
            "city": "Menslage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "438-000",
            "name": "Knemeyer in Borgholzhausen (Nr.438-000)",
            "street": "Illenbruch 3",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Borgholzhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "439-000",
            "name": "Gnadenhof die Geretteten e.V. in Rahden (Nr.439-000)",
            "street": "Örlingerhausen 4",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "440-000",
            "name": "Stallgemeinschaft in Esterwegen (Nr.440-000)",
            "street": "Mühlenberg 9",
            "house_number": "1",
            "zipcode": "26897",
            "city": "Esterwegen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "441-000",
            "name": "Reitsportanlage Berg in Hiddenhausen (Nr.441-000)",
            "street": "Lipinghauserstr. 101",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "442-000",
            "name": "Kinder Wald und Wiese Bremen e.V. in Bremen (Nr.442-000)",
            "street": "Papenkampsweg  12",
            "house_number": "1",
            "zipcode": "28213",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "443-000",
            "name": "Harms in Wardenburg (Nr.443-000)",
            "street": "Saarländer Weg 335",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "444-000",
            "name": "Brunklaus in Benstrup (Nr.444-000)",
            "street": "Zuschläge 2",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Benstrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "445-000",
            "name": "Stall Mehrhoff in Hille (Nr.445-000)",
            "street": "Burkampweg 21",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "446-000",
            "name": "Freiberger Zucht Solenzki in Bremen (Nr.446-000)",
            "street": "Hospitalstr ",
            "house_number": "1",
            "zipcode": "28777",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "447-000",
            "name": "Reitstall Niederbäumer in Hiddenhausen (Nr.447-000)",
            "street": "Lippinghauser Str. 59",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "448-000",
            "name": "Privatstall Scharringhausen in Harpstedt (Nr.448-000)",
            "street": "Nordstr. 72",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Harpstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "449-000",
            "name": "Struckmann in Lähden (Nr.449-000)",
            "street": "An der Riehe 15",
            "house_number": "1",
            "zipcode": "49774",
            "city": "Lähden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "450-000",
            "name": "Reit- und Fahrverein Cappeln e.V. in Cappeln (Nr.450-000)",
            "street": "Kösters Weg 3",
            "house_number": "1",
            "zipcode": "49692",
            "city": "Cappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "451-000",
            "name": "R.V Welver in Welver (Nr.451-000)",
            "street": "Werlerstr 32",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "452-000",
            "name": "Privatstall Leymann in Diepholz (Nr.452-000)",
            "street": "An der Bahn 39",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "453-000",
            "name": "Molenberg in Rhede/Neurhede (Nr.453-000)",
            "street": "Hauptstraße  49",
            "house_number": "1",
            "zipcode": "26899",
            "city": "Rhede/Neurhede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "454-000",
            "name": "Reitverein Espelkamp in Vehlage (Nr.454-000)",
            "street": "Levenerstraße 4",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Vehlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "455-000",
            "name": "Islandpferdehof Frank Kasperczyk in Stuhr (Nr.455-000)",
            "street": "Kronsbruch 9",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "456-000",
            "name": "Reitstall Rath in Borchen (Nr.456-000)",
            "street": "Schmalzgrube  1",
            "house_number": "1",
            "zipcode": "33178",
            "city": "Borchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "457-000",
            "name": "Rosenberg in Freren (Nr.457-000)",
            "street": "Oststrasse 11",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Freren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "458-000",
            "name": "Privatstall Lübbe in Höltinghausen (Nr.458-000)",
            "street": "Eschstraße 18",
            "house_number": "1",
            "zipcode": "49685",
            "city": "Höltinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "459-000",
            "name": "Privatstall Dehlwisch in Bremen (Nr.459-000)",
            "street": "Waller Heerstr. 61",
            "house_number": "1",
            "zipcode": "28217",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "460-000",
            "name": "Eike Holfeld in Wiefelstede (Nr.460-000)",
            "street": "Hoher Kamp 5",
            "house_number": "1",
            "zipcode": "26215",
            "city": "Wiefelstede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "461-000",
            "name": "Meyer zu Lösebeck in Melle (Nr.461-000)",
            "street": "Gerdenerstr. 20",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "462-000",
            "name": "Privatstall Damrow in Hatten (Nr.462-000)",
            "street": "Hatter Straße 8",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "463-000",
            "name": "Hof Franzen in Marl (Nr.463-000)",
            "street": "Linder Weg 1",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "464-000",
            "name": "Beyer in Melle (Nr.464-000)",
            "street": "Hünenburgweg 52",
            "house_number": "1",
            "zipcode": "49328",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "465-000",
            "name": "Nehring/Maßmann in Rhauderfehn (Nr.465-000)",
            "street": "Buurnweg  5",
            "house_number": "1",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "466-000",
            "name": "Offenstall Köhler Dingstede in Hatten (Nr.466-000)",
            "street": "Nutteler Str. 1a",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "467-000",
            "name": "Hof Wöschenland in Hude (Nr.467-000)",
            "street": "Holler Landstr. 74",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "468-000",
            "name": "Lensmann in Oer-Erkenschwick (Nr.468-000)",
            "street": "Sinsenerstr. 315",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "469-000",
            "name": "Pensionsstall Heidehof in Wardenburg (Nr.469-000)",
            "street": "Saarländer Weg 400",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "470-000",
            "name": "Reiterhof Keuper in Salzkotten (Nr.470-000)",
            "street": "Hederbornstraße 11",
            "house_number": "1",
            "zipcode": "33154",
            "city": "Salzkotten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "471-000",
            "name": "Privatstall Müller-Klein in Bruchhausen-Vilsen (Nr.471-000)",
            "street": "Wöpser Berg 1",
            "house_number": "1",
            "zipcode": "27305",
            "city": "Bruchhausen-Vilsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "472-000",
            "name": "Ostholz in Hamm (Nr.472-000)",
            "street": "Alter Uentroper Weg 263",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "473-000",
            "name": "Privatstall Dauth in Ganderkesee (Nr.473-000)",
            "street": "Müllerweg 11",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "474-000",
            "name": "Privatstall Hrudzik in Mellinghausen (Nr.474-000)",
            "street": "Hoyanerstrasse 21",
            "house_number": "1",
            "zipcode": "27349",
            "city": "Mellinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "475-000",
            "name": "Stall Sahlenbeck in Haren (Nr.475-000)",
            "street": "Am Donnerberg 19",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "476-000",
            "name": "Privatstall Kral in Groß Ippener (Nr.476-000)",
            "street": "Dorfstr. 13",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Groß Ippener",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "477-000",
            "name": "Hüting in Paderborn (Nr.477-000)",
            "street": "Fürstenallee 124",
            "house_number": "1",
            "zipcode": "33102",
            "city": "Paderborn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "478-000",
            "name": "Reiterhof Holsterbrink in Dülmen (Nr.478-000)",
            "street": "Holsterbrink 38",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "479-000",
            "name": "Helming Drees in Engden (Nr.479-000)",
            "street": "Emsbürener Straße 9",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Engden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "480-000",
            "name": "Alte Heide in Vrees (Nr.480-000)",
            "street": "Alte Heide 2",
            "house_number": "1",
            "zipcode": "49757",
            "city": "Vrees",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "481-000",
            "name": "Stall Obermowe in Vlotho (Nr.481-000)",
            "street": "Zum Mergelbruch 1",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "482-000",
            "name": "Kampeter in Bielefeld (Nr.482-000)",
            "street": "Buschkampstraße 1",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "483-000",
            "name": "Reitstall Howe in Lengerich (Nr.483-000)",
            "street": "Strohdamm 10",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "484-000",
            "name": "Ponyhof Deipenbrock in Hamm (Nr.484-000)",
            "street": "Holsen 9",
            "house_number": "1",
            "zipcode": "59075",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "485-000",
            "name": "Dengler in Werne (Nr.485-000)",
            "street": "Hagenrain 1",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "486-000",
            "name": "Kappel in Rheda-Wiedenbrück (Nr.486-000)",
            "street": "Emser Landstr 13",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "487-000",
            "name": "Wacker in Nordkirchen (Nr.487-000)",
            "street": "Zum Brotacker 13",
            "house_number": "1",
            "zipcode": "59394",
            "city": "Nordkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "488-000",
            "name": "H.S. Reitsport in Hude (Nr.488-000)",
            "street": "Knutzenweg 1",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "489-000",
            "name": "Josephshof in Warendorf (Nr.489-000)",
            "street": "Sassenberger Strasse  43",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "490-000",
            "name": "Privatstall Hermann in Gütersloh (Nr.490-000)",
            "street": "Münsterlandstr. 110",
            "house_number": "1",
            "zipcode": "33334",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "491-000",
            "name": "Privatstall Meyer in Rastdorf (Nr.491-000)",
            "street": "Wiesenweg 1",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Rastdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "492-000",
            "name": "Weetkorn in Bad Zwischenahn (Nr.492-000)",
            "street": "Mastenweg 67",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "493-000",
            "name": "Reitsportanlage Sonntag in Jöllenbeck (Nr.493-000)",
            "street": "Eckumer Straße 168",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Jöllenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "494-000",
            "name": "Reitstall Brinkmann in Lüdinghausen (Nr.494-000)",
            "street": "Westrup  37",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "495-000",
            "name": "Huster-Klatte in Lastrup (Nr.495-000)",
            "street": "Molbergstr. 37",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "496-000",
            "name": "Huder Pferdehof in Hude (Nr.496-000)",
            "street": "Am Postweg 4",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "497-000",
            "name": "Privatstall Bünde Holsen in Enger (Nr.497-000)",
            "street": "Rödinghauserstrasse 190",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Enger",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "498-000",
            "name": "Trippel Trappel Hof in Goldenstedt (Nr.498-000)",
            "street": "Brombeerhagen 11",
            "house_number": "1",
            "zipcode": "49424",
            "city": "Goldenstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "499-000",
            "name": "Reitsportzentrum Brundiers in Löningen Ehren (Nr.499-000)",
            "street": "Ehrener Kirchweg 3",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Löningen Ehren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "500-000",
            "name": "Hof Plate  in Syke  (Nr.500-000)",
            "street": "Bremer Str.  45",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "501-000",
            "name": "Vaske-Menke in Halen  (Nr.501-000)",
            "street": "Am Dorfplatz 16",
            "house_number": "1",
            "zipcode": "49685",
            "city": "Halen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "502-000",
            "name": "Aktivstall Steinloge in Großkneten  (Nr.502-000)",
            "street": "Im Glaner 10",
            "house_number": "1",
            "zipcode": "26197",
            "city": "Großkneten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "503-000",
            "name": "Hof Uhlmann  in Bad Essen  (Nr.503-000)",
            "street": "Eichkamp 14",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "504-000",
            "name": "Hof Wilmer in Coesfeld  in Coesfeld  (Nr.504-000)",
            "street": "Goxel  38",
            "house_number": "1",
            "zipcode": "48654",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "505-000",
            "name": "Hof Lossau in Rheine  in Rheine  (Nr.505-000)",
            "street": "Gottkenweg  57",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "506-000",
            "name": "Hof Schwert in Werne (Nr.506-000)",
            "street": "Südkirchener Straße 61",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "507-000",
            "name": "Hof Schlüter in Haltern am See (Nr.507-000)",
            "street": "Hülstener Weg  26",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "508-000",
            "name": "Dörhoff in Delbrück (Nr.508-000)",
            "street": "Haselhorster Straße 57",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "510-000",
            "name": "Kloppenburg in Edewecht (Nr.510-000)",
            "street": "Parkstraße 18e",
            "house_number": "1",
            "zipcode": "26188",
            "city": "Edewecht",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "511-000",
            "name": "Hilgen in Bad Zwischenahn (Nr.511-000)",
            "street": "Mittellinie 149",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "580-000",
            "name": "Kochjohann in Rietberg-Bokel (Nr.580-000)",
            "street": "An der Mühle 11",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg-Bokel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "513-000",
            "name": "Hof Landleben in Wettringen (Nr.513-000)",
            "street": "Rothenberge  12",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "514-000",
            "name": "Jostwerner in Delbrück (Nr.514-000)",
            "street": "Heierweg 73",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "515-000",
            "name": "Reitstall Heinrich Buschmann in Stuhr (Nr.515-000)",
            "street": "Siekstraße  150",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "516-000",
            "name": "Privatstall Wienöbst in Essen Oldenburg (Nr.516-000)",
            "street": "Postdamm 1",
            "house_number": "1",
            "zipcode": "49632",
            "city": "Essen Oldenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "517-000",
            "name": "Gut Berghausen in Recklinghausen (Nr.517-000)",
            "street": "Hoher Steinweg 40",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "518-000",
            "name": "Privatstall Tapken in Bad Zwischenahn (Nr.518-000)",
            "street": "Ekenermoorstraße 4",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "519-000",
            "name": "Privatstall Ramnitz in Rheine  (Nr.519-000)",
            "street": "Emscherstraße  7",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "520-000",
            "name": "Sudowe in Wallenhorst (Nr.520-000)",
            "street": "Haster Berg 2",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Wallenhorst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "521-000",
            "name": "Reiterhof Ahlemeyer in Melle (Nr.521-000)",
            "street": "Brinker Str. 36",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "522-000",
            "name": "Privatstall Keimeier in Ennigerloh  (Nr.522-000)",
            "street": "Zur Bunten Brücke 80",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "523-000",
            "name": "Vehlager Zucht-, Reit- und Fahrverein in Vehlage (Nr.523-000)",
            "street": "Siebenweg ",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Vehlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "525-000",
            "name": "Schäfer in Delbrück (Nr.525-000)",
            "street": "Im Brinkort  15",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "526-000",
            "name": "Reitstall Wüllner in Bünde (Nr.526-000)",
            "street": "Lübbecker Str. 306",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "527-000",
            "name": "RG Eichengrund Welver in Welver (Nr.527-000)",
            "street": "Werler Strasse 34",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "528-000",
            "name": "Spiegeler in Gehrde (Nr.528-000)",
            "street": "Holdorferstrasse 4",
            "house_number": "1",
            "zipcode": "49596",
            "city": "Gehrde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "529-000",
            "name": "Bruchwiesen in Espelkamp (Nr.529-000)",
            "street": "Bruchwiesen  10",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "530-000",
            "name": "Zucht- und Pensionsstall Dirks in Isterberg (Nr.530-000)",
            "street": "Bentheimer Straße  8",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Isterberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "531-000",
            "name": "Wilken in Bockhorn (Nr.531-000)",
            "street": "Grabhorner Weg ",
            "house_number": "1",
            "zipcode": "26345",
            "city": "Bockhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "532-000",
            "name": "Schön in Barßel (Nr.532-000)",
            "street": "Carolinenhofstr.  2",
            "house_number": "1",
            "zipcode": "26676",
            "city": "Barßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "533-000",
            "name": "Hengstebeck in Heiden (Nr.533-000)",
            "street": "Neuer Weg 6",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "534-000",
            "name": "Reiterverein St Georg Saerbeck in Saerbeck (Nr.534-000)",
            "street": "Ibbenbürener Straße  47",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "535-000",
            "name": "Privatstall Börgel in Mettingen (Nr.535-000)",
            "street": "Nieheweg 66",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "536-000",
            "name": "Pferdehof Nolte in Vlotho (Nr.536-000)",
            "street": "Dornberger Heide 39",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "537-000",
            "name": "Ferienhof Junkern-Beel in Lathen (Nr.537-000)",
            "street": "Junkern-Beel 1",
            "house_number": "1",
            "zipcode": "49762",
            "city": "Lathen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "538-000",
            "name": "Reitanlage Wehmeyer in Bielefed (Nr.538-000)",
            "street": "Detmolder Str. 820",
            "house_number": "1",
            "zipcode": "33699",
            "city": "Bielefed",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "539-000",
            "name": "539000 in Herten (Nr.539-000)",
            "street": "Zufahrt Heukamp Backumer Straße 459",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "540-000",
            "name": "Hof Gerdes in Bad Zwischenahn (Nr.540-000)",
            "street": "Bloher Landstraße ",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "541-000",
            "name": "Reit- und Fahrverein Bottrop in Bottrop (Nr.541-000)",
            "street": "Beisenstrasse 18",
            "house_number": "1",
            "zipcode": "46242",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "542-000",
            "name": "Arens in Meppen (Nr.542-000)",
            "street": "Fullenerstr. 45",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "543-000",
            "name": "Poggemann in Greven  (Nr.543-000)",
            "street": "Emsdettener Damm 15",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "544-000",
            "name": "Katharina Jürgens in Hamm (Nr.544-000)",
            "street": "Lange Reihe 214",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "545-000",
            "name": "Privatstall May-Rosen in Marl (Nr.545-000)",
            "street": "Buerer Str.  65",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "546-000",
            "name": "Stall Haverkamp in Haltern am See (Nr.546-000)",
            "street": "Kuhlenweg 64",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "547-000",
            "name": "Hötkemeier in Porta Westfalica (Nr.547-000)",
            "street": "Möllbergerstr.  176",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "548-000",
            "name": "Schimmelhof Bremen in Bremen (Nr.548-000)",
            "street": "Osterholzer Dorfstraße 95",
            "house_number": "1",
            "zipcode": "28307",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "549-000",
            "name": "Reitstall Katenkamp in Stuhr Groß Mackenstedt (Nr.549-000)",
            "street": "Bremer Weg  52",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr Groß Mackenstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "550-000",
            "name": "FreeSpiritNaturalHorses in Rahden (Nr.550-000)",
            "street": "Wagenfelder Straße  66",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "551-000",
            "name": "Sentker in Lemgo (Nr.551-000)",
            "street": "Meinertsberg 11",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "552-000",
            "name": "Ziegenmichel in Gelsenkirchen (Nr.552-000)",
            "street": "Eggemannstr.  51",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "553-000",
            "name": "Reck in Jade (Nr.553-000)",
            "street": "Lisztweg  15",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "554-000",
            "name": "Nau  in Hopsten  (Nr.554-000)",
            "street": " Napoleondamm  13",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "555-000",
            "name": "Farwick  in Glandorf  (Nr.555-000)",
            "street": "Auf der Wichelten  2",
            "house_number": "1",
            "zipcode": "49219",
            "city": "Glandorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "556-000",
            "name": "Islandpferde Witthushof in Schwanenwede (Nr.556-000)",
            "street": "Hinnebecker Furth  31",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanenwede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "557-000",
            "name": "Pferdehof Pool  in Lingen  (Nr.557-000)",
            "street": "Kleekamp  1",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "558-000",
            "name": "Held in Ovelgönne (Nr.558-000)",
            "street": "Kirchstraße  ",
            "house_number": "1",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "559-000",
            "name": "Ollen River Ranch in Ganderkesee (Nr.559-000)",
            "street": "Zur Ollen 2",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "560-000",
            "name": "Hermann in Enger (Nr.560-000)",
            "street": "Enger ",
            "house_number": "1",
            "zipcode": "32130",
            "city": "Enger",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "561-000",
            "name": "Reitstall Fitje in Bad Zwischenahn (Nr.561-000)",
            "street": "Goldene Linie 23a",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "562-000",
            "name": "An der Engelbrücke in Borken (Nr.562-000)",
            "street": "An der Eggelbrücke 25",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "563-000",
            "name": "Raht in Büren (Nr.563-000)",
            "street": "Sehrweg 1",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "564-000",
            "name": "Privatstall Beermann in Harsewinkel (Nr.564-000)",
            "street": "Kortenhegge 10a",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "565-000",
            "name": "Reit- und Fahrverein St.Hülfe/Heede e.V. in Diepholz (Nr.565-000)",
            "street": "Am Turnierplatz 1",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "566-000",
            "name": "Private Stallgemeinschaft Brinkmann in Soest (Nr.566-000)",
            "street": "Landwehr 12",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "567-000",
            "name": "Boemer  in Ohne  (Nr.567-000)",
            "street": "Feldhoek  6",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Ohne ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "568-000",
            "name": "Privatstall Arndt  in Landesbergen  (Nr.568-000)",
            "street": "Birkenweg  7",
            "house_number": "1",
            "zipcode": "31628",
            "city": "Landesbergen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "569-000",
            "name": "Vor dem Brocke Lingen  in Lingen  (Nr.569-000)",
            "street": "Hohlweg  2",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "570-000",
            "name": "Hof Eiling in Heiden (Nr.570-000)",
            "street": "Drögen Bokelt 8",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "571-000",
            "name": "Stall Scheffler in Westoverledingen (Nr.571-000)",
            "street": "Birkenstraße 200",
            "house_number": "1",
            "zipcode": "26810",
            "city": "Westoverledingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "572-000",
            "name": "Hellmers Hof in Brake (Nr.572-000)",
            "street": "Sinaburger Straße 83",
            "house_number": "1",
            "zipcode": "26919",
            "city": "Brake",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "573-000",
            "name": "Hof Nordendorf in Reken  (Nr.573-000)",
            "street": "Alter Landweg  2",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "574-000",
            "name": "Geers  in Goldenstedt  (Nr.574-000)",
            "street": "Erikaweg  6",
            "house_number": "1",
            "zipcode": "49424",
            "city": "Goldenstedt ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "575-000",
            "name": "Wilkens in Bremen (Nr.575-000)",
            "street": "Waller Straße 300",
            "house_number": "1",
            "zipcode": "28719",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "576-000",
            "name": "Reitverein Velen in Velen (Nr.576-000)",
            "street": "Borkener Damm 12",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Velen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "577-000",
            "name": "Weetkornhof Klostermann in Bad Zwischenahn (Nr.577-000)",
            "street": "Weetkornstrasse  12",
            "house_number": "1",
            "zipcode": "46160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "578-000",
            "name": "Pferdepension Völker in Spelle (Nr.578-000)",
            "street": "Osterwiesenweg  6",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "579-000",
            "name": "Stall Cohausz in Telgte (Nr.579-000)",
            "street": "Voßhaar 15",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "512-000",
            "name": "Konert in Wadersloh (Nr.512-000)",
            "street": "Bredenweg 9",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "581-000",
            "name": "RC St. Georg zu Bremen e.V. in Bremen (Nr.581-000)",
            "street": "Wetterungsweg 1",
            "house_number": "1",
            "zipcode": "28359",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "582-000",
            "name": "Reitschule Isadora Siekmann in Detmold (Nr.582-000)",
            "street": "Unternienhagen 21",
            "house_number": "1",
            "zipcode": "32758",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "583-000",
            "name": "Raiffeisen Ochtrup in Ochtrup (öffentlich) (Nr.583-000)",
            "street": "Gronauer Str. 52",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup (öffentlich)",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "584-000",
            "name": "Privatstall Gausepohl in Versmold (Nr.584-000)",
            "street": "Stränger Str. 11",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "585-000",
            "name": "Jana Dreckmann in Ostbevern (Nr.585-000)",
            "street": "Ravel-Weg 6",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "586-000",
            "name": "Privatstall Woestmann in Steinfurt (Nr.586-000)",
            "street": "Hollich 46",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "587-000",
            "name": "Horseman Ranch in Bad Oeynhausen (Nr.587-000)",
            "street": "Holzmark 35",
            "house_number": "1",
            "zipcode": "32549",
            "city": "Bad Oeynhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "588-000",
            "name": "Privater Offenstall Jenderzi in Friesoythe (Nr.588-000)",
            "street": "Röpkendamm 4",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "589-000",
            "name": "Hof Schulze Schleithoff in Havixbeck (Nr.589-000)",
            "street": "Herkentrup 4",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "590-000",
            "name": "Averbeck in Ochtrup (Nr.590-000)",
            "street": "Schweringhook 3",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "591-000",
            "name": "Privatstall Braun in Schwanewede (Nr.591-000)",
            "street": "Am Wald  1a",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "592-000",
            "name": "Zurhove in Senden (Nr.592-000)",
            "street": "Dorfbauerschaft 27",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "594-000",
            "name": "Sandhaus in Menslage (Nr.594-000)",
            "street": "Hahlener Straße 7",
            "house_number": "1",
            "zipcode": "49637",
            "city": "Menslage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "597-000",
            "name": "Corina Carius in Lippetal (Nr.597-000)",
            "street": "Breite Str. 24",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "598-000",
            "name": "Camping Simon in Uelsen (Nr.598-000)",
            "street": "Hesinger Str.  13",
            "house_number": "1",
            "zipcode": "49843",
            "city": "Uelsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "599-000",
            "name": "Vethacke in Herne (Nr.599-000)",
            "street": "Holsterhauser Straße  323",
            "house_number": "1",
            "zipcode": "44625",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "600-000",
            "name": "Offenstall Heiner Kerkhof in Selm-Bork (Nr.600-000)",
            "street": "Zum Wegebild 5",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm-Bork",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "601-000",
            "name": "Privatstall Katrin Böker in Willebadessen (Nr.601-000)",
            "street": "Von- Ike- Str. 13",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "602-000",
            "name": "Privatstall Bockschatz in Bielefeld (Nr.602-000)",
            "street": "Lübbecker Str. 361",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "603-000",
            "name": "Reit- und Fahrverein Ochtrup e.V. in Ochtrup (Nr.603-000)",
            "street": "Kreuzweg  77",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "604-000",
            "name": "Reiterverein Bayer Leverkusen in Köln (Nr.604-000)",
            "street": "Otto-Bayer-Str 1",
            "house_number": "1",
            "zipcode": "51061",
            "city": "Köln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "605-000",
            "name": "Beelmann Stavern in Stavern (Nr.605-000)",
            "street": "Hinterstr 7",
            "house_number": "1",
            "zipcode": "49777",
            "city": "Stavern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "606-000",
            "name": "Reitschule Füchtmann in Gronau (Nr.606-000)",
            "street": "Gerdingseite 9",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "607-000",
            "name": "Reitstall Bianca in Büren (Nr.607-000)",
            "street": "Niederburgstraße 1",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "608-000",
            "name": "Reitstall Welslau in Bad Salzuflen (Nr.608-000)",
            "street": "Im Wölkental /",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "609-000",
            "name": "Reitanlage Gräve in Hamm (Nr.609-000)",
            "street": "Ostwennemarstraße 125",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "610-000",
            "name": "Gut Wewel in Senden (Nr.610-000)",
            "street": "Gettrup ",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "611-000",
            "name": "Böckenholt in Telgte (Nr.611-000)",
            "street": "Kiebitzpohl 18",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "612-000",
            "name": "Bücker in Emsdetten (Nr.612-000)",
            "street": "Austum 36",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "613-000",
            "name": "Geisthoff in Ahlen (Nr.613-000)",
            "street": "Westhusener Weg  5",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "614-000",
            "name": "Fam. Göcke, Eichenhof in Recke (Nr.614-000)",
            "street": "Twenhusen 33",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "615-000",
            "name": "Hof Bavendamm in Bremen (Nr.615-000)",
            "street": "Wallerstraße  300",
            "house_number": "1",
            "zipcode": "28719",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "616-000",
            "name": "Burghof in Recklinghausen (Nr.616-000)",
            "street": "Burgstr. 21",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "617-000",
            "name": "Reitanlage Berg in Hiddenhausen (Nr.617-000)",
            "street": "Lippinghauser Straße 101",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "618-000",
            "name": "Privatstall Vorsthove in Ibbenbüren (Nr.618-000)",
            "street": "Fahlbachtal 12",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "619-000",
            "name": "Stall Temmen in Rheine  (Nr.619-000)",
            "street": "Hohe Alle 101",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "620-000",
            "name": "CTH Sporthorses in Emsbüren (Nr.620-000)",
            "street": "Moorlage 9",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "621-000",
            "name": "Privatstall Assel in Bissendorf (Nr.621-000)",
            "street": "Werscher Straße 2",
            "house_number": "1",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "622-000",
            "name": "Privatstall Jäger in Dülmen (Nr.622-000)",
            "street": "Dernekamp 24a",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "623-000",
            "name": "Kollmer in Lastrup (Nr.623-000)",
            "street": "Blaubusch 5",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "624-000",
            "name": "Immer in Bremen (Nr.624-000)",
            "street": "Stromer Landstraße 38L",
            "house_number": "1",
            "zipcode": "28197",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "625-000",
            "name": "Reitanlage an der Stever in Senden (Nr.625-000)",
            "street": "Wierling 3b",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "626-000",
            "name": "Ulmenhof Albers in Meppen (Nr.626-000)",
            "street": "Ulmenhof 1",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "627-000",
            "name": "Weilichmann in Havixbeck (Nr.627-000)",
            "street": "Herkentrup 7",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "628-000",
            "name": "Reitanlage Döring in Espelkamp (Nr.628-000)",
            "street": "Siebenweg 1",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "629-000",
            "name": "Achterhörner Reitstall in Friesoythe (Nr.629-000)",
            "street": "Feddenbergsweg 2",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "630-000",
            "name": "Sportpferde Piotrowski in Senden (Nr.630-000)",
            "street": "Brock  8",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "631-000",
            "name": "Privatstall Höfener in Sendenhorst (Nr.631-000)",
            "street": "Ahrenhorst 33",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "632-000",
            "name": "Privatstall Denker in Wettringen (Nr.632-000)",
            "street": "Vollenbrok 22",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "633-000",
            "name": "Privatstall Ostermann in Voltlage (Nr.633-000)",
            "street": "Knappstr. 8",
            "house_number": "1",
            "zipcode": "49599",
            "city": "Voltlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "634-000",
            "name": "Schmiemann in Ibbenbüren (Nr.634-000)",
            "street": "Brochterbecker Str. 8",
            "house_number": "1",
            "zipcode": "49477",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "635-000",
            "name": "Reit- und Fahrverein Steinfurt-Dumte e.V. in Steinfurt (Nr.635-000)",
            "street": "Dumte 20",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "636-000",
            "name": "Reitstall Molkembur in Münster (Nr.636-000)",
            "street": "Kasewinkel 94",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "637-000",
            "name": "Stall Fischer in Vechta (Nr.637-000)",
            "street": "Holtruper Straße 36",
            "house_number": "1",
            "zipcode": "49377",
            "city": "Vechta",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "638-000",
            "name": "Privathof Blank in Achim (Nr.638-000)",
            "street": "Roedenbeckstraße 141d",
            "house_number": "1",
            "zipcode": "28832",
            "city": "Achim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "639-000",
            "name": "Robert in Vreden (Nr.639-000)",
            "street": "Köckelwick 57",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "640-000",
            "name": "Borggreve Dressage in Ahaus (Nr.640-000)",
            "street": "Ammeln 99a",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "641-000",
            "name": "Spieker in Greven  (Nr.641-000)",
            "street": "Ostbevenerstr. 64",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "642-000",
            "name": "Privatstall Schlüter in Stadtlohn (Nr.642-000)",
            "street": "Boschstraße 30",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "643-000",
            "name": "Hof Tenberge in Lüdinghausen (Nr.643-000)",
            "street": "Tetekum 9",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "644-000",
            "name": "Reitanlage Hof Ebel in Arnsberg (Nr.644-000)",
            "street": "Neheimer Str. 108",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "645-000",
            "name": "Privatstall Voß in Rinkerode (Nr.645-000)",
            "street": "Eickenbeck 25",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Rinkerode",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "646-000",
            "name": "Zrg St.Sebastian Amelsbüren in Münster (Nr.646-000)",
            "street": "Von Renesseweg 20",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "650-000",
            "name": "Pferdestall Haarmann in Ahaus (Nr.650-000)",
            "street": "Oberortwick  27a",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "651-000",
            "name": "Reitstall Hartz in Nottuln (Nr.651-000)",
            "street": "Stevern 52",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "652-000",
            "name": "Hellenkamp in Ahaus (Nr.652-000)",
            "street": "Ammeln  91",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "653-000",
            "name": "Stammkötter in Steinhagen (Nr.653-000)",
            "street": "Sandforther Straße 64",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "654-000",
            "name": "Meine kleine Farm in Ostercappeln (Nr.654-000)",
            "street": "Bremer Str.  42a",
            "house_number": "1",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "656-000",
            "name": "Mau in Sendenhorst (Nr.656-000)",
            "street": "Sunger 27",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "657-000",
            "name": "RV Geisterholz in Oelde (Nr.657-000)",
            "street": "Robert-Schumann-Ring  25",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "658-000",
            "name": "Rosenhof in Horn Bad-Meinberg (Nr.658-000)",
            "street": "Zum Rosenbusch 102",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn Bad-Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "659-000",
            "name": "Hof Knickenberg in Hamm (Nr.659-000)",
            "street": "Im Nachtigallental 6",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "661-000",
            "name": "Hof Schuckenberg in Milte (Nr.661-000)",
            "street": "Beverstrang 31a",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Milte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "662-000",
            "name": "Privatstall Haak in Borken (Nr.662-000)",
            "street": "Neumühlenallee 114",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "663-000",
            "name": "Kohlmannhof in Westerkappeln (Nr.663-000)",
            "street": "Kuhlmannstraße 5",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "664-000",
            "name": "Privatstall Wischermann in Rosendahl (Nr.664-000)",
            "street": "Brockbauerschaft 30",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "665-000",
            "name": "Albers Hof in Oberlangen (Nr.665-000)",
            "street": "Sandstraße 1",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "666-000",
            "name": "Verstegge in Gronau (Nr.666-000)",
            "street": "Windmühlenweg 1",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "667-000",
            "name": "Privatstall Döme in Münster (Nr.667-000)",
            "street": "Einigweg 11",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "668-000",
            "name": "Hof Gövert in Havixbeck (Nr.668-000)",
            "street": "Poppenbeck 17",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "669-000",
            "name": "Lödding in Senden (Nr.669-000)",
            "street": "Kreuzbauerschaft 6",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "670-000",
            "name": "Göcking in Rheine  (Nr.670-000)",
            "street": "Osnabrücker Straße ",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "671-000",
            "name": "Telljohann in Lienen (Nr.671-000)",
            "street": "Ellerhooksweg 6",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "672-000",
            "name": "Margaretenhof in Neuenkirchen (Nr.672-000)",
            "street": "Rote Erde 12",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "674-000",
            "name": "Reiterhof Engeler in Saerbeck (Nr.674-000)",
            "street": "Middendorf 31",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "675-000",
            "name": "Lackenberg in Drensteinfurt (Nr.675-000)",
            "street": "Eickenbeck 33",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "676-000",
            "name": "Familie Espelkott in Rosendahl (Nr.676-000)",
            "street": "Helenenweg 4",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "677-000",
            "name": "Reitstall Schierbaum in Osnabrück (Nr.677-000)",
            "street": "Schierbaumsfeld ",
            "house_number": "1",
            "zipcode": "49086",
            "city": "Osnabrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "678-000",
            "name": "Privatstall Strotmeier in Ibbenbüren (Nr.678-000)",
            "street": "Teutohang 83",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "679-000",
            "name": "Ponyhof Benning in Emsdetten (Nr.679-000)",
            "street": "Up'mMersk 1",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "680-000",
            "name": "Privatstall Bringemeier in Steinfurt (Nr.680-000)",
            "street": "Emsdettener Straße 73",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "681-000",
            "name": "Pagliarini in Havixbeck (Nr.681-000)",
            "street": "Walingen 11",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "682-000",
            "name": "Dr. Ute Vaske in Lastrup (Nr.682-000)",
            "street": "Bei der Groberei 4",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "683-000",
            "name": "Jörns bei Zimmerei Stärke in Riede (Nr.683-000)",
            "street": "Wegstätte 25",
            "house_number": "1",
            "zipcode": "27339",
            "city": "Riede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "684-000",
            "name": "Pferdepension zu Stoltenberg in Lüdinghausen-Seppenrade (Nr.684-000)",
            "street": "Leversum 38",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen-Seppenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "685-000",
            "name": "Böckmann in Ibbenbüren (Nr.685-000)",
            "street": "Riesenbeckerstr. 45",
            "house_number": "1",
            "zipcode": "49477",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "686-000",
            "name": "Reitanlage Sylvia Werft in Bad Laer (Nr.686-000)",
            "street": "Hagestrasse 5",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "687-000",
            "name": "Gilhaus in Schermbeck (Nr.687-000)",
            "street": "Vor der Burg 1",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "688-000",
            "name": "Privatstall Müller in Werl (Nr.688-000)",
            "street": "Am krummen Rücken 24",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "689-000",
            "name": "Mareike Sanders in Westbevern (Nr.689-000)",
            "street": "Voßhaar 13",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Westbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "690-000",
            "name": "Privatstall Schulz in Westerkappeln (Nr.690-000)",
            "street": "Telgte 12",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "691-000",
            "name": "Rusinek in Lengerich (Nr.691-000)",
            "street": "Am Steinernen Kreuz 38",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "692-000",
            "name": "Starwood Stables (Hof Brumley) in Emsdetten (Nr.692-000)",
            "street": "Nordwalderstr. 197",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "693-000",
            "name": "Stall Leichhauer in Oer-Erkenschwick (Nr.693-000)",
            "street": "Johannesstr. 248",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "694-000",
            "name": "Matthaiwe in Xanten (Nr.694-000)",
            "street": "Heesweg 25",
            "house_number": "1",
            "zipcode": "46509",
            "city": "Xanten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "695-000",
            "name": "Reitverein Südlohn in Südlohn (Nr.695-000)",
            "street": "Pingelerhook 26",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "696-000",
            "name": "Wessling in Ochtrup (Nr.696-000)",
            "street": "Kreuzweg 77",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "697-000",
            "name": "Stall Marx in Belm (Nr.697-000)",
            "street": "An der Haarener Grenze 1",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "698-000",
            "name": "RV Helleforth in Schloß Holte-Stukenbrock (Nr.698-000)",
            "street": "Kaunitzer Str. 174",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "699-000",
            "name": "Privatstall Pothmann in Metelen (Nr.699-000)",
            "street": "Samberg 56",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "700-000",
            "name": "Privatstall Köttermann in Ahlen (Nr.700-000)",
            "street": "Walstedderstraße 251",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "701-000",
            "name": "RV Riesenbeck in Hörstel-Riesenbeck (Nr.701-000)",
            "street": "Surenburg 20",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "702-000",
            "name": "Privatstall Ernsting in Coesfeld  (Nr.702-000)",
            "street": "Gaupel 32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "703-000",
            "name": "Schulte-Schedding in Herten (Nr.703-000)",
            "street": "Kampstr. 9",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "704-000",
            "name": "Reitstall Binder in Greven  (Nr.704-000)",
            "street": "Saerbeckerstr. 144",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "705-000",
            "name": "RV Wehdem-Oppendorf in Stemwede (Nr.705-000)",
            "street": "Am Birkenhain 4",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "706-000",
            "name": "Privatstall Rekers in Emsbüren (Nr.706-000)",
            "street": "Zur Venhauser Schleuse  2",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "707-000",
            "name": "ebe Pferdegesundheitszentrum Münster GmbH in Münster (Nr.707-000)",
            "street": "Tweehues 17",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "708-000",
            "name": "Privatstall Beuker in Steinfurt (Nr.708-000)",
            "street": "Hollich 120",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "709-000",
            "name": "Privatstall Keeve-Gerling in Recke (Nr.709-000)",
            "street": "Venneweg 13",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "710-000",
            "name": "Privatstall Rabe in Bohmte (Nr.710-000)",
            "street": "Meyerhöfener Straße 5",
            "house_number": "1",
            "zipcode": "49163",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "711-000",
            "name": "Islandpferde Oberkarthausen in Radevormwald (Nr.711-000)",
            "street": "Oberkarthausen 1",
            "house_number": "1",
            "zipcode": "42499",
            "city": "Radevormwald",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "712-000",
            "name": "Boltrayhof in Voerde (Nr.712-000)",
            "street": "Rheinstraße 183",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "713-000",
            "name": "Zumloh in Ahlen (Nr.713-000)",
            "street": "In der Groeft 33",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "714-000",
            "name": "Hufbeschlag Hötte in Ahlen (Nr.714-000)",
            "street": "Westhusenerweg 1",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "715-000",
            "name": "Reitstall Pegasus in Wülfrath (Nr.715-000)",
            "street": "Nord-Erbach 25",
            "house_number": "1",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "716-000",
            "name": "Korth in Gummersbach (Nr.716-000)",
            "street": "Kerbelweg  15",
            "house_number": "1",
            "zipcode": "51647",
            "city": "Gummersbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "717-000",
            "name": "Reitanlage Gessmann in Münster (Nr.717-000)",
            "street": "Hunnebeckweg 97",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "718-000",
            "name": "Stall Pölling  in Coesfeld  (Nr.718-000)",
            "street": "Stevede  60",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "719-000",
            "name": "Haltergemeinschaft Dölling  in Rheine  (Nr.719-000)",
            "street": "Zur Vogelstange  5",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "720-000",
            "name": "Gut Henscheshof  in Erkrath  (Nr.720-000)",
            "street": "Hubbelrather Weg 19",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "721-000",
            "name": "Benger Hof  in Duisburg  (Nr.721-000)",
            "street": "An der Bastei 118",
            "house_number": "1",
            "zipcode": "47529",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "722-000",
            "name": "Hüsing  in Emsbüren  (Nr.722-000)",
            "street": "Emsstraße  ",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "723-000",
            "name": "Te Heesen  in Voerde (Nr.723-000)",
            "street": "Hindenburgstraße  160",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "724-000",
            "name": "Centura Reitakademie  in Schwanenwede (Nr.724-000)",
            "street": "Hamfährer Weg  19",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanenwede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "725-000",
            "name": "Reitverein Nienberge in Münster (Nr.725-000)",
            "street": "Beerwiede 160A",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "726-000",
            "name": "DIPO - Hof Thier zum Berge in Dülmen (Nr.726-000)",
            "street": "Mitwick 32",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "727-000",
            "name": "Wessendorf in Dülmen (Nr.727-000)",
            "street": "Börnste  36",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "729-000",
            "name": "Kamps in Bönen (Nr.729-000)",
            "street": "Dorfstraße 11",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "730-000",
            "name": "Tenbrok in Bocholt (Nr.730-000)",
            "street": "Franzstr 76",
            "house_number": "1",
            "zipcode": "46395",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "731-000",
            "name": "Hof Schettler in Haltern am See (Nr.731-000)",
            "street": "Dorstener Str. 880",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "732-000",
            "name": "Stall Nordhues in Saerbeck (Nr.732-000)",
            "street": "Südhoek 15",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "733-000",
            "name": "Stall Deipenwisch in Everswinkel (Nr.733-000)",
            "street": "Holling 17",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "737-000",
            "name": "Reitstall Elling in Salzbergen (Nr.737-000)",
            "street": "Devestr. 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "738-000",
            "name": "Reiterhof Kottig in Gronau-Epe (Nr.738-000)",
            "street": "Gerdingseite 4",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "740-000",
            "name": "Meyer  in Saterland  (Nr.740-000)",
            "street": "An der Wieke  7",
            "house_number": "1",
            "zipcode": "26683",
            "city": "Saterland ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "741-000",
            "name": "Raude Sudhoff  in Osnabrück (Nr.741-000)",
            "street": "DarumerStr.  ",
            "house_number": "1",
            "zipcode": "49090",
            "city": "Osnabrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "742-000",
            "name": "Meier  in Vloth  (Nr.742-000)",
            "street": "Im Nienhagen  3",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vloth ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "743-000",
            "name": "Erlemeyer  in Warendorf  (Nr.743-000)",
            "street": "Westbezirk  82",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "744-000",
            "name": "Minnerup  in Ibbenbüren (Nr.744-000)",
            "street": "Brumleyweg  8",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "745-000",
            "name": "Figge  in Welver  (Nr.745-000)",
            "street": "Zur Binnekoh  13",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "746-000",
            "name": "Privatstall Brinkbäumer in Soest (Nr.746-000)",
            "street": "Eichenweg 8b",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "747-000",
            "name": "Döring Quarter Horses  in Marl  (Nr.747-000)",
            "street": "Herner Weg  46",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "748-000",
            "name": "Weitkamp in Billerbeck  (Nr.748-000)",
            "street": "Hamern  36",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "749-000",
            "name": "Hovestadt  in Warendorf  (Nr.749-000)",
            "street": "Dr.-Rau-Allee 82",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "750-000",
            "name": "Red Blaze Ranch in Ascheberg (Nr.750-000)",
            "street": "Davensbergerstraße 15",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "751-000",
            "name": "Reitstall Laurenz in Gronau-Epe (Nr.751-000)",
            "street": "Am Fürstenbusch 20",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "752-000",
            "name": "RSC Norden Nordsee in Norden (Nr.752-000)",
            "street": "Schwarzer Weg 32",
            "house_number": "1",
            "zipcode": "26506",
            "city": "Norden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "753-000",
            "name": "Reit- und Fahrverein Dornberg in Bielefeld (Nr.753-000)",
            "street": "Am Krebsbach 19",
            "house_number": "1",
            "zipcode": "33619",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "754-000",
            "name": "Hof Janning in Rheine  (Nr.754-000)",
            "street": "Brookstr. 45",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "755-000",
            "name": "Privatstall Hackländer in Rüthen (Nr.755-000)",
            "street": "Königstraße 17",
            "house_number": "1",
            "zipcode": "59602",
            "city": "Rüthen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "756-000",
            "name": "Privatstall Ratz in Beelen  (Nr.756-000)",
            "street": "Pohlstadt 10",
            "house_number": "1",
            "zipcode": "48361",
            "city": "Beelen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "757-000",
            "name": "Münsterland Stables & Curly Horses in Rosendahl (Nr.757-000)",
            "street": "Midlicher Straße 7",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "758-000",
            "name": "Pferdepension Drei Eichen  in Welver  (Nr.758-000)",
            "street": "Bergstrasser Weg  3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "759-000",
            "name": "Holling  in Greven  (Nr.759-000)",
            "street": "Gronenweg  1a ",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "760-000",
            "name": "Schulze Feldmann  in Hörstel-Riesenbeck (Nr.760-000)",
            "street": "Pastorenkamp 20",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "761-000",
            "name": "RV Heessen  in Hamm  (Nr.761-000)",
            "street": "Dasbeck  6",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "762-000",
            "name": "Wickensack  in Ostbevern  (Nr.762-000)",
            "street": "Brock  29",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "763-000",
            "name": "Wesling  in Ostbevern  (Nr.763-000)",
            "street": "Deppengau  30",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "764-000",
            "name": "Hof Becker in Hamm (Nr.764-000)",
            "street": "Lippestr 130",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "765-000",
            "name": "Hof Grünwald  in Tecklenburg  (Nr.765-000)",
            "street": "Holthausen  25",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "766-000",
            "name": "Hof Stratmann in Senden (Nr.766-000)",
            "street": "Dorfbauerschaft 26",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "767-000",
            "name": "Offenstall Schulte-Walter in Münster (Nr.767-000)",
            "street": "Wittoverstiege 68",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "768-000",
            "name": "Nadine Nölle in Hamm (Nr.768-000)",
            "street": "Wambelner Berg 3",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "769-000",
            "name": "Privatstall Wirth in Gütersloh (Nr.769-000)",
            "street": "Erikenstraße ",
            "house_number": "1",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "770-000",
            "name": "EquiFit in Hüven (Nr.770-000)",
            "street": "Berßener Str. 99",
            "house_number": "1",
            "zipcode": "49751",
            "city": "Hüven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "771-000",
            "name": "Privatstall Lüken in Rastdorf (Nr.771-000)",
            "street": "Hauptstr.  19",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Rastdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "772-000",
            "name": "Wiesenhof in Duisburg  (Nr.772-000)",
            "street": "Straußplatz 3",
            "house_number": "1",
            "zipcode": "47057",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "773-000",
            "name": "Hof Harkotten in Emsdetten (Nr.773-000)",
            "street": "Hollingen 19",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "774-000",
            "name": "Terheiden in Hopsten (Nr.774-000)",
            "street": "Breischenerstr. 4",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "775-000",
            "name": "Reitstall Rieping in Ahlen (Nr.775-000)",
            "street": "Dorffeld 25",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "776-000",
            "name": "Constanze Möller in Ennigerloh (Nr.776-000)",
            "street": "Im Sportpark 1",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "777-000",
            "name": "Majewski in Horstmar (Nr.777-000)",
            "street": "Ostendorf 17",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "778-000",
            "name": "Neuß in Bochum (Nr.778-000)",
            "street": "Auf dem Kalwes 239",
            "house_number": "1",
            "zipcode": "44801",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "779-000",
            "name": "RV Ostönnen in Werl (Nr.779-000)",
            "street": "Breite Straße 7",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "780-000",
            "name": "Busch in Melle (Nr.780-000)",
            "street": "Westerheide 28",
            "house_number": "1",
            "zipcode": "49324",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "781-000",
            "name": "Tierpension Groll in Hagen (Nr.781-000)",
            "street": "Düinghauser Weg  33",
            "house_number": "1",
            "zipcode": "58091",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "782-000",
            "name": "Ziegler in Menden (Nr.782-000)",
            "street": "Neue Straße 26",
            "house_number": "1",
            "zipcode": "58708",
            "city": "Menden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "783-000",
            "name": "Privatstall Farwick in Wadersloh (Nr.783-000)",
            "street": "Liesborner Str. 28",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "784-000",
            "name": "Reitstall Hoffmann in Düsseldorf (Nr.784-000)",
            "street": "Edmund-Bertram-Straße  54",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "785-000",
            "name": "Schulze Zur Verth in Borken (Nr.785-000)",
            "street": "Pröbstinger Allee 1",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "786-000",
            "name": "Niemeyer in Westerkappeln (Nr.786-000)",
            "street": "Bathmener Str. 28",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "787-000",
            "name": "J&A Ranch in Olsberg (Nr.787-000)",
            "street": "Ibergstraße ",
            "house_number": "1",
            "zipcode": "59939",
            "city": "Olsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "788-000",
            "name": "Ramrath in Sendenhorst (Nr.788-000)",
            "street": "Hohe Ward 4",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "789-000",
            "name": "Pensionsstall Lukat in Nordhorn (Nr.789-000)",
            "street": "Karl-Braun-Straße  18",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "790-000",
            "name": "Ponyschule Sauerland in Meschede (Nr.790-000)",
            "street": "Erflinghausen 13",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "791-000",
            "name": "Anne Lauderbach in Lastrup (Nr.791-000)",
            "street": "Blaubusch 1",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "792-000",
            "name": "Klaas in Meppen (Nr.792-000)",
            "street": "In den Höften 11",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "793-000",
            "name": "Privatstall Frers in Oelde (Nr.793-000)",
            "street": "Katthagenstr. 25",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "794-000",
            "name": "Rönnebäumer in Havixbeck (Nr.794-000)",
            "street": "Brock 18",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "795-000",
            "name": "PferdeAktivStall in Stadthagen (Nr.795-000)",
            "street": "Hauptstraße 23",
            "house_number": "1",
            "zipcode": "31655",
            "city": "Stadthagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "796-000",
            "name": "Vogel/Haar in Nordhorn (Nr.796-000)",
            "street": "Bentheimer Straße 405",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "797-000",
            "name": "Tünte Cappenberg in Telgte (Nr.797-000)",
            "street": "Bockhorner Heide 27",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "798-000",
            "name": "Reit- und Fahrverein Emsdetten in Emsdetten (Nr.798-000)",
            "street": "Am Teekotten 1",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "799-000",
            "name": "Sportpferde Premiumhorses in Emsdetten (Nr.799-000)",
            "street": "Westumer Landstr.  68b",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "800-000",
            "name": "Holzbau Fieke in Altenberge (Nr.800-000)",
            "street": "Kümper 110b",
            "house_number": "1",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "801-000",
            "name": "Reckers in Hörstel (Nr.801-000)",
            "street": "Altenrheiner Weg 60",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "802-000",
            "name": "Werning  in Lage  (Nr.802-000)",
            "street": "Eggeweg  21",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "803-000",
            "name": "Kamphorst  in Nordhorn-Hestrup (Nr.803-000)",
            "street": "Katthorstweg  15",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn-Hestrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "804-000",
            "name": "Reitanlage Vedder in Waltrop (Nr.804-000)",
            "street": "Im Abdinghof ",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "805-000",
            "name": "Privatstall Schönberg in Dreierwalde (Nr.805-000)",
            "street": "Hopstener Straße 46",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Dreierwalde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "806-000",
            "name": "Privatstall Dingwerth in Versmold (Nr.806-000)",
            "street": "Hollmortstr 3",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "807-000",
            "name": "Reitstall Pulte in Attendorn-Mecklinghausen (Nr.807-000)",
            "street": "Talstrasse ",
            "house_number": "1",
            "zipcode": "57439",
            "city": "Attendorn-Mecklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "808-000",
            "name": "Sonnenhol in Lüdenscheid (Nr.808-000)",
            "street": "Hottenbruch 24",
            "house_number": "1",
            "zipcode": "58515",
            "city": "Lüdenscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "809-000",
            "name": "Hof Pöppelmann in Münster (Nr.809-000)",
            "street": "Ramertsweg 104",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "810-000",
            "name": "Zuchtgemeinschaft Espelkott in Rosendahl (Nr.810-000)",
            "street": "Geitendorf 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "811-000",
            "name": "Privatstall Lütke-Stratkötter in Wadersloh (Nr.811-000)",
            "street": "Herzebrockweg 8",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "812-000",
            "name": "Privatstall Rose in Büren (Nr.812-000)",
            "street": "Burgwall 4",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "813-000",
            "name": "Schmitz in Wadersloh (Nr.813-000)",
            "street": "Soester Str. 14",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "814-000",
            "name": "Hill of the Moon in Arnsberg (Nr.814-000)",
            "street": "Echthauserstr. 55",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "815-000",
            "name": "Wittkemper in Wadersloh (Nr.815-000)",
            "street": "Buchenweg 5",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "816-000",
            "name": "Osenberg in Radevormwald (Nr.816-000)",
            "street": "Ispingrade 13",
            "house_number": "1",
            "zipcode": "42477",
            "city": "Radevormwald",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "817-000",
            "name": "Hovestadt  in Gronau (Nr.817-000)",
            "street": "Am Berge 53",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "818-000",
            "name": "Ferienbauernhof Voß in Schmallenberg (Nr.818-000)",
            "street": "Uentropstr. 12",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "819-000",
            "name": "Meierhof in Detmold (Nr.819-000)",
            "street": "Barntruper Straße 44",
            "house_number": "1",
            "zipcode": "32758",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "820-000",
            "name": "Fellnasen in Dreierwalde (Nr.820-000)",
            "street": "Uthuiserstraße 33",
            "house_number": "1",
            "zipcode": "48486",
            "city": "Dreierwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "821-000",
            "name": "Privatstall Keller in Ibbenbüren (Nr.821-000)",
            "street": "Adlerstiege  80",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "822-000",
            "name": "Gestüt Schultenhof in Bochum (Nr.822-000)",
            "street": "Zum Schultenhof 34",
            "house_number": "1",
            "zipcode": "44807",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "823-000",
            "name": "Buse in Holzwickede (Nr.823-000)",
            "street": "Talstr. 12",
            "house_number": "1",
            "zipcode": "59439",
            "city": "Holzwickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "824-000",
            "name": "Privatstall Wewers in Belm (Nr.824-000)",
            "street": "Nelkenweg 4",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "825-000",
            "name": "Privatstall Gelking in Nordwalde (Nr.825-000)",
            "street": "Suttorf 5",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "826-000",
            "name": "Privatstall Hüntemann in Wettringen (Nr.826-000)",
            "street": "Wilhelm-Busch-Str.  17",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "827-000",
            "name": "Privatstall Bracht in Kluse (Nr.827-000)",
            "street": "Wippinger Str  7",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Kluse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "828-000",
            "name": "Große Hühnfeld in Münster (Nr.828-000)",
            "street": "Lindberghweg 131",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "829-000",
            "name": "Nienhaus in Bocholt (Nr.829-000)",
            "street": "Degelingsesch 5",
            "house_number": "1",
            "zipcode": "46395",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "830-000",
            "name": "Reitanlage Fockenberg in Bottrop (Nr.830-000)",
            "street": "In der Koppel 82",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "831-000",
            "name": "Schaafhausen in Mettmann (Nr.831-000)",
            "street": "Diepensiepen 53",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "832-000",
            "name": "Forsthof Haschert in Witten (Nr.832-000)",
            "street": "Krünerstr. 52",
            "house_number": "1",
            "zipcode": "58456",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "833-000",
            "name": "Brockmann in Bergen (Nr.833-000)",
            "street": "Peerborm 6",
            "house_number": "1",
            "zipcode": "29303",
            "city": "Bergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "834-000",
            "name": "Dortmund Kirchlinde in Dortmund (Nr.834-000)",
            "street": "Mosselde 150",
            "house_number": "1",
            "zipcode": "44357",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "835-000",
            "name": "Pferdehof Schütte in Schortens (Nr.835-000)",
            "street": "Stummeldorf 1",
            "house_number": "1",
            "zipcode": "26419",
            "city": "Schortens",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "836-000",
            "name": "Reitsportanlage Könemann in Petershagen (Nr.836-000)",
            "street": "Stehbrink 37",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "837-000",
            "name": "Gut Beringhof in Wickede (Nr.837-000)",
            "street": "Zum Beringhof 2",
            "house_number": "1",
            "zipcode": "58739",
            "city": "Wickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "838-000",
            "name": "Artmanns Hof in  Horstmar (Nr.838-000)",
            "street": "Ostendorf 38",
            "house_number": "1",
            "zipcode": "48565",
            "city": " Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "839-000",
            "name": "Neitemeier in Meschede (Nr.839-000)",
            "street": "Stesse ",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "840-000",
            "name": "Backhaus in Wetter (Nr.840-000)",
            "street": "Limbeckerweg ",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "841-000",
            "name": "Reitverein Werl in Werl (Nr.841-000)",
            "street": "Neheimer Str. 49",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "842-000",
            "name": "Hasenhorst in Münster (Nr.842-000)",
            "street": "Bremerfeld 4",
            "house_number": "1",
            "zipcode": "48147",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "843-000",
            "name": "Pension Tiemann in Löhne (Nr.843-000)",
            "street": "Börstelstraße 109",
            "house_number": "1",
            "zipcode": "32584",
            "city": "Löhne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "844-000",
            "name": "Jasper in Hopsten (Nr.844-000)",
            "street": "Stadener Straße  14",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "845-000",
            "name": "Holtumer Landhof in Duisburg  (Nr.845-000)",
            "street": "Holtumer Mühlenweg  1",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "846-000",
            "name": "Steinbrückhof in Müden (Aller) (Nr.846-000)",
            "street": "Gilde 1a",
            "house_number": "1",
            "zipcode": "38539",
            "city": "Müden (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "847-000",
            "name": "Güldner in Hopsten (Nr.847-000)",
            "street": "Zum Wurftaubenstand 1",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "848-000",
            "name": "Wilde in Nottuln (Nr.848-000)",
            "street": "Mühlenweg  2",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "849-000",
            "name": "Kaspar in Korschenbroich (Nr.849-000)",
            "street": "Glehner Str. 14a",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "850-000",
            "name": "Privatstall Nienhuis in Heede (Nr.850-000)",
            "street": "Schuckenbrock 14",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Heede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "851-000",
            "name": "Reiterverein Iserlohn in Iserlohn (Nr.851-000)",
            "street": "Reiterweg 16",
            "house_number": "1",
            "zipcode": "58636",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "852-000",
            "name": "Privatstall Niggemann Hunteburg in Bohmte (Nr.852-000)",
            "street": "Am Strohtkanal 3",
            "house_number": "1",
            "zipcode": "49163",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "853-000",
            "name": "Gut Hellerhof in Düsseldorf (Nr.853-000)",
            "street": "Rudolf-Breitscheid-Strasse ",
            "house_number": "1",
            "zipcode": "40721",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "854-000",
            "name": "Reitanlage am Thabrauck in Frödenberg (Nr.854-000)",
            "street": "Thabrauck 22",
            "house_number": "1",
            "zipcode": "58730",
            "city": "Frödenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "855-000",
            "name": "Privatstall Weller in Goch (Nr.855-000)",
            "street": "Kapellenhofstr. 13",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "856-000",
            "name": "Sonntagsfarm in Kaarst (Nr.856-000)",
            "street": "Neersener Straße 38",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "857-000",
            "name": "Stall Deimann/Sprankel in Schmallenberg-Oberkirchen (Nr.857-000)",
            "street": "Hammerweg ",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Oberkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "858-000",
            "name": "Reitanlage Hubertus in Gladbeck-Brauck (Nr.858-000)",
            "street": "Brauckstr 10",
            "house_number": "1",
            "zipcode": "45968",
            "city": "Gladbeck-Brauck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "859-000",
            "name": "Carranza Sport Horses in Nordhorn (Nr.859-000)",
            "street": "Buchenstraße 84",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "861-000",
            "name": "Privatstall Brautmeier in Delbrück (Nr.861-000)",
            "street": "Lippstädter Str. 104",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "862-000",
            "name": "Pferdehof Behle in Ense-Lüttringen (Nr.862-000)",
            "street": "Auf den Weiden  6",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense-Lüttringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "863-000",
            "name": "Privatstall Götten in Ibbenbüren (Nr.863-000)",
            "street": "Iltisweg  15e",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "864-000",
            "name": "Harberg in Beckum (Nr.864-000)",
            "street": "Harberg 1",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "865-000",
            "name": "Petershagen in Petershagen (Nr.865-000)",
            "street": "Riehe Höfe 6",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "866-000",
            "name": "Frickenstein in Ibbenbüren (Nr.866-000)",
            "street": "An der Umfluth 19a",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "867-000",
            "name": "Privatstall Steinberg in Schwerte (Nr.867-000)",
            "street": "Steinberg  31",
            "house_number": "1",
            "zipcode": "58239",
            "city": "Schwerte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "868-000",
            "name": "Privatstall Deuper in Bad Laer (Nr.868-000)",
            "street": "Wechel  7",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "869-000",
            "name": "Privatstall Engemann in Willebadessen (Nr.869-000)",
            "street": "Klosterstr 5",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "870-000",
            "name": "Islandpferdepension Haasenbau in Dorsten (Nr.870-000)",
            "street": "Nierleistr. 64",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "871-000",
            "name": "Hertenhof in Meerbusch (Nr.871-000)",
            "street": "Bovert  33",
            "house_number": "1",
            "zipcode": "40670",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "872-000",
            "name": "Reitanl. am Kressenberg in Hattingen (Nr.872-000)",
            "street": "Langes Feld 17",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "873-000",
            "name": "Hof der Pferde in Adelheidsdorf (Nr.873-000)",
            "street": "Dasselsbrucher Str.  82",
            "house_number": "1",
            "zipcode": "29352",
            "city": "Adelheidsdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "874-000",
            "name": "Zur Kummerwie in Bad Sassendorf (Nr.874-000)",
            "street": "Weslarner Weg 2",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "875-000",
            "name": "RV Lengerich in Lengerich (Nr.875-000)",
            "street": "Erlenweg  3",
            "house_number": "1",
            "zipcode": "49838",
            "city": "Lengerich",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "876-000",
            "name": "Privatstall Vogt  (kleiner Offenstall) in Marl  (Nr.876-000)",
            "street": "Haßlinger Bogen 22",
            "house_number": "1",
            "zipcode": "49448",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "877-000",
            "name": "Privatstall Adams in Rheinberg (Nr.877-000)",
            "street": "Rheinkamper Str.  71",
            "house_number": "1",
            "zipcode": "47495",
            "city": "Rheinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "878-000",
            "name": "Privatstall Stappers in Spelle (Nr.878-000)",
            "street": "Englandstr.  30",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "879-000",
            "name": "Privatstall Krasenbrink in Nordhorn (Nr.879-000)",
            "street": "Feldflurweg  86",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "880-000",
            "name": "Pensionsstall Johst in Grevenbroich (Nr.880-000)",
            "street": "Am Blauen Stein 3",
            "house_number": "1",
            "zipcode": "41516",
            "city": "Grevenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "881-000",
            "name": "Privatstall Lügan in Löningen (Nr.881-000)",
            "street": "Weißer Damm 5",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Löningen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "882-000",
            "name": "Kleine Auszeit in Würselen (Nr.882-000)",
            "street": "Broicher Str 130",
            "house_number": "1",
            "zipcode": "52146",
            "city": "Würselen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "883-000",
            "name": "Hunder in Warmsen (Nr.883-000)",
            "street": "Hauskämper Str.  6",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "884-000",
            "name": "Privatstsall Wiethoff in Neukirchen-Vluyn (Nr.884-000)",
            "street": "Geldernsche Str.  405",
            "house_number": "1",
            "zipcode": "47506",
            "city": "Neukirchen-Vluyn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "885-000",
            "name": "Stall Volkmer Meinhard in Ochtrup (Nr.885-000)",
            "street": "Weiner  231",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "886-000",
            "name": "Pabsthof in Düsseldorf (Nr.886-000)",
            "street": "Pabsthofweg  2",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "887-000",
            "name": "Birtes Ranch in Ense Vollbringen (Nr.887-000)",
            "street": "Lanner 9",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense Vollbringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "888-000",
            "name": "Privatstall Stegemann in Neuenrade (Nr.888-000)",
            "street": "Hofstr  5b",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "889-000",
            "name": "Privatstall Bacchiocchi in Ratingen (Nr.889-000)",
            "street": "Lintorfer Weg 16",
            "house_number": "1",
            "zipcode": "40885",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "890-000",
            "name": "Privatstall Göppinger in Grefrath (Nr.890-000)",
            "street": "Auffeld  26",
            "house_number": "1",
            "zipcode": "47929",
            "city": "Grefrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "891-000",
            "name": "Joeressen in Mönchengladbach (Nr.891-000)",
            "street": "Günhovener Str  49",
            "house_number": "1",
            "zipcode": "41179",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "892-000",
            "name": "Jürgensmeyerhof in Lage  (Nr.892-000)",
            "street": "Billinghauser 167",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "893-000",
            "name": "Gut Klein Düssel in Düsseldorf (Nr.893-000)",
            "street": "Gödinghover Weg 80",
            "house_number": "1",
            "zipcode": "40627",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "894-000",
            "name": "Stall Bahr in Schwanewede (Nr.894-000)",
            "street": "Hamfährer Weg  34",
            "house_number": "1",
            "zipcode": "27890",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "895-000",
            "name": "Privatstall Entrup in Rheda-Wiedenbrück (Nr.895-000)",
            "street": "Kleestr 44",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "896-000",
            "name": "Friedrich Dehmann in Nordstemmen (Nr.896-000)",
            "street": "Hallerstr 9",
            "house_number": "1",
            "zipcode": "31171",
            "city": "Nordstemmen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "897-000",
            "name": "Privatstall Göbel in Schmallenberg-Felbecke (Nr.897-000)",
            "street": "Hawerlandstr 7",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Felbecke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "898-000",
            "name": "Dyckers in Neuss Grefrath (Nr.898-000)",
            "street": "Lüttenglehnerstrasse 116",
            "house_number": "1",
            "zipcode": "41472",
            "city": "Neuss Grefrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "899-000",
            "name": "Reiterhof Ressing in Hünxe (Nr.899-000)",
            "street": "Hoher Wardweg 12a",
            "house_number": "1",
            "zipcode": "46569",
            "city": "Hünxe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "900-000",
            "name": "Watermann in Witten (Nr.900-000)",
            "street": "Am Katterloh  12",
            "house_number": "1",
            "zipcode": "58454",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "901-000",
            "name": "Privatstall Lampe in Friesoythe (Nr.901-000)",
            "street": "Altenoyther Str. 66",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "902-000",
            "name": "Hof Eckey in Bönen (Nr.902-000)",
            "street": "Auf dem hachenei 6",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "903-000",
            "name": "Privatstall Fricke in Algermissen (Nr.903-000)",
            "street": "Pfingstanger 5",
            "house_number": "1",
            "zipcode": "31191",
            "city": "Algermissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "904-000",
            "name": "Jennifer Wulf und Thorben Schulte in Witten (Nr.904-000)",
            "street": "Oberkrone 76",
            "house_number": "1",
            "zipcode": "58455",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "905-000",
            "name": "Fahrstall in Rheine  (Nr.905-000)",
            "street": "Im Uhlenhook 11",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "906-000",
            "name": "Privatstall Aumann in Hespe (Nr.906-000)",
            "street": "Hauptstr 33",
            "house_number": "1",
            "zipcode": "31693",
            "city": "Hespe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "907-000",
            "name": "Friedrich Döpke in Langenhagen (Nr.907-000)",
            "street": "Dorfstraße 60",
            "house_number": "1",
            "zipcode": "30855",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "908-000",
            "name": "Zuchtstall Schäfers in Ense (Nr.908-000)",
            "street": "Soester Straße  6",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "909-000",
            "name": "Herbsthof in Garbsen (Nr.909-000)",
            "street": "Burgstraße 42",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "910-000",
            "name": "Gut Wolfsaap / Prange in Düsseldorf (Nr.910-000)",
            "street": "Bauernhäuser Weg  100",
            "house_number": "1",
            "zipcode": "40472",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "911-000",
            "name": "Reinstall Stuhr in Stuhr (Nr.911-000)",
            "street": "Klardinger Straße 8",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "912-000",
            "name": "Piepel in Rheine (Nr.912-000)",
            "street": "Devesburg 30",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "913-000",
            "name": "Noeke in Meschede (Nr.913-000)",
            "street": "In der Giesmecke 3",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "914-000",
            "name": "Resser RV in Gelsenkirchen (Nr.914-000)",
            "street": "Brauckstraße  21",
            "house_number": "1",
            "zipcode": "45892",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "915-000",
            "name": "Gestüt Ziegelhof in Rommerskirchen (Nr.915-000)",
            "street": "Am Ziegelhof  2",
            "house_number": "1",
            "zipcode": "41569",
            "city": "Rommerskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "916-000",
            "name": "Meyers Pferdehof in Stuhr (Nr.916-000)",
            "street": "Zur Malsch 2",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "917-000",
            "name": "RTG Gut Hellerhof in Düsseldorf (Nr.917-000)",
            "street": "Rudolf-Breitscheidstr.  71",
            "house_number": "1",
            "zipcode": "40595",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "918-000",
            "name": "Hof Holtmann/Schulze Isfort in Ascheberg (Nr.918-000)",
            "street": "Davensbergerstraße 18",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "919-000",
            "name": "Reit- und Fahrverein Altlünen e.V. in Lünen (Nr.919-000)",
            "street": "Im Geistwinkel  62",
            "house_number": "1",
            "zipcode": "44534",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "920-000",
            "name": "Dieckmann in Melle (Nr.920-000)",
            "street": "Borgloher Str 65",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "921-000",
            "name": "Privatstall Meißner in Nottuln (Nr.921-000)",
            "street": "Appelhülsener Strasse 74",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "922-000",
            "name": "Privatstall Otte-Krone in Stemwede (Nr.922-000)",
            "street": "Oppenweher Str. 15",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "923-000",
            "name": "Ulli Schröder in Warstein (Nr.923-000)",
            "street": "St Barbara str 42",
            "house_number": "1",
            "zipcode": "59581",
            "city": "Warstein",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "924-000",
            "name": "Wilms in Schwalmtal (Nr.924-000)",
            "street": "Berg 36",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "925-000",
            "name": "Heidehof in Horstmar (Nr.925-000)",
            "street": "Haltern 73",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "926-000",
            "name": "Vereinigter Reit und Fahrverein Remscheid in Remscheid (Nr.926-000)",
            "street": "Buscherhof  3",
            "house_number": "1",
            "zipcode": "42899",
            "city": "Remscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "927-000",
            "name": "Shamrock Stables in Kierspe (Nr.927-000)",
            "street": "Berkenbaum 1",
            "house_number": "1",
            "zipcode": "58566",
            "city": "Kierspe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "928-000",
            "name": "R.V. Stuhr in Stuhr (Nr.928-000)",
            "street": "Stuhrer Landstraße 144",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "929-000",
            "name": "Landgut Steeg in Issum (Nr.929-000)",
            "street": "Hamsfeld 24a",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "930-000",
            "name": "Privatstall Dzialdowski in Gescher (Nr.930-000)",
            "street": "Estern  4",
            "house_number": "1",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "931-000",
            "name": "Privatstall Beerens in Selm (Nr.931-000)",
            "street": "Lüdinghausener Str 69",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "932-000",
            "name": "Privatstall Deppe in Heiden (Nr.932-000)",
            "street": "Deel 18",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "933-000",
            "name": "Leimkühler KG in Moers (Nr.933-000)",
            "street": "Wefortstraße 99",
            "house_number": "1",
            "zipcode": "47445",
            "city": "Moers",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "934-000",
            "name": "Roter stall in Bedburg (Nr.934-000)",
            "street": "Hohenholzer Straße 32",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "935-000",
            "name": "Reit- und Fahrverein Rinkerode e.V. in Drensteinfurt (Nr.935-000)",
            "street": "Im Breul 35",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "936-000",
            "name": "Reitstall Lübbehusen in Visbeck (Nr.936-000)",
            "street": "Norddöllen 1",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "937-000",
            "name": "Hubert in Haltern am See (Nr.937-000)",
            "street": "Hennewigerweg 203",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "938-000",
            "name": "Hof Schuze Vels in Kamen (Nr.938-000)",
            "street": "Im Haferfeld 5",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "939-000",
            "name": "Pferdepension Rolf in Herzebrock-Clarholz (Nr.939-000)",
            "street": "Groppeler Straße 29",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "940-000",
            "name": "Privatstall Schulze Balhorn in Sendenhorst (Nr.940-000)",
            "street": "Blankenweg 2",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "941-000",
            "name": "Privatstall Lindenbrink in Ronnenberg (Nr.941-000)",
            "street": "Reitverein Lindert 15",
            "house_number": "1",
            "zipcode": "30952",
            "city": "Ronnenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "942-000",
            "name": "Stall Bockumsfeld in Dorsten (Nr.942-000)",
            "street": "Bockumsfeld 21",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "943-000",
            "name": "Gut Nienhausen in Gelsenkirchen (Nr.943-000)",
            "street": "Laurentiusstr 38",
            "house_number": "1",
            "zipcode": "45899",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "944-000",
            "name": "Luela in Petershagen (Nr.944-000)",
            "street": "Galgenheider Str ",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "945-000",
            "name": "Reitverein vilsendorf in Bielefeld (Nr.945-000)",
            "street": "Vilsendorfer Straße 210 210",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "946-000",
            "name": "Hof Gehrendes in Willebadessen (Nr.946-000)",
            "street": "Eissener Straße  5",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "947-000",
            "name": "Süssmann in Sibbesse (Nr.947-000)",
            "street": "Mittelweg  7",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "948-000",
            "name": "Junker in Bad Sassendorf (Nr.948-000)",
            "street": "Alter Soestweg 1",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "950-000",
            "name": "Börgel in Mettingen (Nr.950-000)",
            "street": "Alte Bockradener Straße 13",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "951-000",
            "name": "Kappmeyer in Achim (Nr.951-000)",
            "street": "Am Feldrain  16",
            "house_number": "1",
            "zipcode": "28832",
            "city": "Achim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "952-000",
            "name": "Hansen in Duisburg (Nr.952-000)",
            "street": "Holtumer Mühlenweg 25",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "953-000",
            "name": "Reitverein Lengerich in Lengerich (Nr.953-000)",
            "street": "An der Reithalle 2",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "954-000",
            "name": "Gut Breitenhaupt in Steinheim (Nr.954-000)",
            "street": "Breitenhaupter Weg 1",
            "house_number": "1",
            "zipcode": "32839",
            "city": "Steinheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "955-000",
            "name": "Stall Stecklenberg in Fröndenberg (Nr.955-000)",
            "street": "Hauptstr 95",
            "house_number": "1",
            "zipcode": "58730",
            "city": "Fröndenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "956-000",
            "name": "Hof Averbeck in Greven (Nr.956-000)",
            "street": "Guntruper Str 44",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "957-000",
            "name": "Caballos de la Luz in Mülheim (Nr.957-000)",
            "street": "Stooter Strasse 100",
            "house_number": "1",
            "zipcode": "45481",
            "city": "Mülheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "959-000",
            "name": "Privatstall Nährmann in Salzbergen (Nr.959-000)",
            "street": "Wittenweg 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "960-000",
            "name": "Privat Stall Storat in Reichshof (Nr.960-000)",
            "street": "Im alten Garten 3",
            "house_number": "1",
            "zipcode": "51580",
            "city": "Reichshof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "961-000",
            "name": "Stenmans in Kerken (Nr.961-000)",
            "street": "Dorfstraße 1",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "962-000",
            "name": "Stall Schuh in Mönchengladbach (Nr.962-000)",
            "street": "Seidenweberstr 9",
            "house_number": "1",
            "zipcode": "41189",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "963-000",
            "name": "Hof Voltmer in Isernhagen (Nr.963-000)",
            "street": "Höfestraße 22",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "964-000",
            "name": "Westernranch Isterberg in Isterberg (Nr.964-000)",
            "street": "Am Wald 4",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Isterberg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "965-000",
            "name": "Privater Offenstall in Hörstel (Nr.965-000)",
            "street": "Horstesch 11",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "966-000",
            "name": "Schulze-Oeing in Schöppingen (Nr.966-000)",
            "street": "Heven 4",
            "house_number": "1",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "967-000",
            "name": "Gut Volkardey in Ratingen (Nr.967-000)",
            "street": "Volkardeyer Str 51",
            "house_number": "1",
            "zipcode": "40880",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "968-000",
            "name": "Pielerhof in Rheurdt (Nr.968-000)",
            "street": "Moerserstraße 53",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "969-000",
            "name": "Kotten Leifeld in Oelde (Nr.969-000)",
            "street": "Stromberger Schweiz 5",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "971-000",
            "name": "Privat Averes in Wilsum (Nr.971-000)",
            "street": "Zur Hopfenbachquelle 2",
            "house_number": "1",
            "zipcode": "49849",
            "city": "Wilsum",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "972-000",
            "name": "Privatstall Funke in Ramsdorf (Nr.972-000)",
            "street": "Borkener Strasse 93",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Ramsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "973-000",
            "name": "Reitstall am Bückeberg in Stadthagen (Nr.973-000)",
            "street": "An der Bornau 9",
            "house_number": "1",
            "zipcode": "31655",
            "city": "Stadthagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "974-000",
            "name": "Conradshof in Ratingen (Nr.974-000)",
            "street": "Zu den Höfen 48",
            "house_number": "1",
            "zipcode": "40882",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "975-000",
            "name": "Liethen in Erkrath (Nr.975-000)",
            "street": "Steinkaule  1",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "976-000",
            "name": "Götting in Bad Salzuflen (Nr.976-000)",
            "street": "Am lockhauserbaum 19",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "977-000",
            "name": "RV Hellefeld in Sundern-Hellefeld (Nr.977-000)",
            "street": "Hellefelderstr. 1a",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern-Hellefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "978-000",
            "name": "Löw Reitsport in Bocholt (Nr.978-000)",
            "street": "Westend 31-39",
            "house_number": "1",
            "zipcode": "46399 ",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "979-000",
            "name": "Familie Flunkert in Iserlohn (Nr.979-000)",
            "street": "Gerkendahler Weg 3",
            "house_number": "1",
            "zipcode": "58640",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "980-000",
            "name": "Reitsport Bippen e.V. in Bippen (Nr.980-000)",
            "street": "Sunderhausstraße 1",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Bippen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "981-000",
            "name": "Privatstall Bottländer in Issum (Nr.981-000)",
            "street": "Mühlenstr. 41",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "982-000",
            "name": "Reitanlage Langenhof in Plettenberg (Nr.982-000)",
            "street": "Bremcke 7",
            "house_number": "1",
            "zipcode": "58840",
            "city": "Plettenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "983-000",
            "name": "Haus Giesking in Nottuln (Nr.983-000)",
            "street": "Hangenau 25",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "984-000",
            "name": "Privatstall Warnders in Weener (Nr.984-000)",
            "street": "Alt Möhlenwarf 27",
            "house_number": "1",
            "zipcode": "26826",
            "city": "Weener",
            "state": "NIedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "985-000",
            "name": "Privatstall Oelschner in Raesfeld (Nr.985-000)",
            "street": "Hamborg  19",
            "house_number": "1",
            "zipcode": "46348",
            "city": "Raesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "986-000",
            "name": "Rennstall Jatzke in Düsseldorf (Nr.986-000)",
            "street": "Rennbahnstr 20",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "987-000",
            "name": "RV Münster Sprakel in Münster (Nr.987-000)",
            "street": "Heidegrund 233",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "988-000",
            "name": "Dudler Hof in Dinslaken (Nr.988-000)",
            "street": "Dickerstraße  464",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "989-000",
            "name": "Schetters Busch in Essen (Nr.989-000)",
            "street": "Schetters Busch 1",
            "house_number": "1",
            "zipcode": "45309",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "990-000",
            "name": "Küppers in Solingen (Nr.990-000)",
            "street": "Haumannst 22",
            "house_number": "1",
            "zipcode": "42651",
            "city": "Solingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "991-000",
            "name": "Reithof Remberg in Dinslaken (Nr.991-000)",
            "street": "Buschst 80",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "992-000",
            "name": "Privatstall Baldus in Ennepetal (Nr.992-000)",
            "street": "Mönninghof 33",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "993-000",
            "name": "Privatstall Wilke in Neustadt Am Rübenberge (Nr.993-000)",
            "street": "An Der Waldbühn 7",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt Am Rübenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "994-000",
            "name": "Kreutzerhof in Krefeld (Nr.994-000)",
            "street": "Vennikelstraße 44",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "995-000",
            "name": "Privatstall Leon in Fürstenau (Nr.995-000)",
            "street": "Große Haar 20",
            "house_number": "1",
            "zipcode": "49584",
            "city": "Fürstenau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "996-000",
            "name": "Reitstall Höfkes in Kempen (Nr.996-000)",
            "street": "Unterweidener Str 2",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "997-000",
            "name": "Hof Begemann in Dörentrup (Nr.997-000)",
            "street": "Untere Dorfstrasse 17",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "998-000",
            "name": "Pferdepension Ulrich Schulte in Bad Sassenberg (Nr.998-000)",
            "street": "Mühlenweg  33",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "999-000",
            "name": "Privatstall Heinz in Geldern (Nr.999-000)",
            "street": "Montessoristr 13",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1000-000",
            "name": "Reitanlage Baumann in Bielefeld (Nr.1000-000)",
            "street": "Heidsieker Heide 116",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1001-000",
            "name": "Privatstall Ottensmeyer in Hille (Nr.1001-000)",
            "street": "Friedensweg 41",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1002-000",
            "name": "Kliedter Hof in Krefeld (Nr.1002-000)",
            "street": "Papendyk 138",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1003-000",
            "name": "Fritzenhof in Neumünster (Nr.1003-000)",
            "street": "Kieler Straße 648a",
            "house_number": "1",
            "zipcode": "24536",
            "city": "Neumünster",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1004-000",
            "name": "Stall Seemann in Nienborstel (Nr.1004-000)",
            "street": "Kluhs 4",
            "house_number": "1",
            "zipcode": "24819",
            "city": "Nienborstel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1005-000",
            "name": "Hof Rützenhagen in Negernbötel (Nr.1005-000)",
            "street": "Rützenhagen 1",
            "house_number": "1",
            "zipcode": "23795",
            "city": "Negernbötel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1012-000",
            "name": "Gesenhues in Ahaus-Alstätte (Nr.1012-000)",
            "street": "Öddingstraße 5",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus-Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1006-000",
            "name": "Hof Frölich in Beckum (Nr.1006-000)",
            "street": "Unterberg II nr 19",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1007-000",
            "name": "Lieningshof in Neuenhaus (Nr.1007-000)",
            "street": "Lagerstr. 110",
            "house_number": "1",
            "zipcode": "49828",
            "city": "Neuenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1008-000",
            "name": " in Bassum (Nr.1008-000)",
            "street": "Fuhrenkamp 25 25",
            "house_number": "1",
            "zipcode": "27211",
            "city": "Bassum",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1009-000",
            "name": "Reitanlage Tellez in Fintel (Nr.1009-000)",
            "street": "Himberg  80",
            "house_number": "1",
            "zipcode": "27389",
            "city": "Fintel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1010-000",
            "name": "Klüsener in Herzebrock-Clarholz (Nr.1010-000)",
            "street": "Udenbrink  15",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1013-000",
            "name": "Vogtes Erbe Reitanlage Thier in Lüdinghausen (Nr.1013-000)",
            "street": "Ondrup 34",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1014-000",
            "name": "Hof Riedemann in Bramsche (Nr.1014-000)",
            "street": "Schleptruper Strang 82",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1015-000",
            "name": "Privatstall Seibel in Bockhorst (Nr.1015-000)",
            "street": "Melmstraße 15",
            "house_number": "1",
            "zipcode": "26897",
            "city": "Bockhorst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1016-000",
            "name": "Am Ravenschlag in Ennepetal (Nr.1016-000)",
            "street": "Ravenschlag  82",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1017-000",
            "name": "Niki's Ponystall in Hannover (Nr.1017-000)",
            "street": "Varrelheide  25",
            "house_number": "1",
            "zipcode": "30657",
            "city": "Hannover",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1018-000",
            "name": "Ruland in Emsdetten (Nr.1018-000)",
            "street": "Lange water  10",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1019-000",
            "name": "Lambardt in Bergkamen (Nr.1019-000)",
            "street": "Heinrichstrasse 41",
            "house_number": "1",
            "zipcode": "59192",
            "city": "Bergkamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1020-000",
            "name": "Mewissen in Schwalmtal (Nr.1020-000)",
            "street": "Eschenrath  55-57",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1021-000",
            "name": "Homann Niehoff in Münster (Nr.1021-000)",
            "street": "Homannstrasse 37",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1022-000",
            "name": "Pappelhof in Rheurdt (Nr.1022-000)",
            "street": "Moerser Str 51",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1023-000",
            "name": "Scheidtmann in Hattingen (Nr.1023-000)",
            "street": "Kohlenstrasse 183",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1024-000",
            "name": "Grönings Hof in Marl (Nr.1024-000)",
            "street": "Wellerfeldweg 13",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1025-000",
            "name": "Bussmann in  (Nr.1025-000)",
            "street": " ",
            "house_number": "1",
            "collect_point": "nein"
        },
        {
            "ID": "1026-000",
            "name": "Hof Reipen in Rhede (Nr.1026-000)",
            "street": "Büngerner Allee 17",
            "house_number": "1",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1027-000",
            "name": "Privatstall Arndt in Neuenkirchen (Nr.1027-000)",
            "street": "Friedenstr. 57",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1028-000",
            "name": "Offenstall Vor den Moore - Privat in Neustadt (Nr.1028-000)",
            "street": "Ahnser Weg 8",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1057-000",
            "name": "Lützow Schuckenbaum in Leopoldshöhe (Nr.1057-000)",
            "street": "Eckendorferstr 74",
            "house_number": "1",
            "zipcode": "33818",
            "city": "Leopoldshöhe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1029-000",
            "name": "Leas Reitschule in Straelen (Nr.1029-000)",
            "street": "Broekhuysener Str. 1",
            "house_number": "1",
            "zipcode": "47638",
            "city": "Straelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1030-000",
            "name": "Luisenhof in Krefeld (Nr.1030-000)",
            "street": "Flünnertzdyk 161",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1031-000",
            "name": "sportpferde Lohhof in Wedemark (Nr.1031-000)",
            "street": "lange loh  15",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1032-000",
            "name": "Stall Rohleder in Dortmund (Nr.1032-000)",
            "street": "Am Hausacker 5",
            "house_number": "1",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1033-000",
            "name": "Scheibe in Söhlde (Nr.1033-000)",
            "street": "Lindenallee 10",
            "house_number": "1",
            "zipcode": "31185",
            "city": "Söhlde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1034-000",
            "name": "Reitstall Boerger in Lennestadt (Nr.1034-000)",
            "street": "Seilmecke 17a",
            "house_number": "1",
            "zipcode": "57368",
            "city": "Lennestadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1035-000",
            "name": "Offenstall Warneke in Alveslohe (Nr.1035-000)",
            "street": "Dieckskamp 23",
            "house_number": "1",
            "zipcode": "25486",
            "city": "Alveslohe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1036-000",
            "name": "Topp in Lippetal (Nr.1036-000)",
            "street": "Hüttinghauserweg 3",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1037-000",
            "name": "Offenstall Kopp in Dorsten (Nr.1037-000)",
            "street": "Nelkenstr. 15",
            "house_number": "1",
            "zipcode": "46284",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1038-000",
            "name": "Kersebohm in Lünen (Nr.1038-000)",
            "street": "Im Siepen 3",
            "house_number": "1",
            "zipcode": "44536",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1039-000",
            "name": "Zucht-&Pensionsstall Becker-lütke-Bexten in Ostbevern (Nr.1039-000)",
            "street": "Schirl  68",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1040-000",
            "name": "Uesbeck in Gronau (Nr.1040-000)",
            "street": "Schlamannweg 62a",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1041-000",
            "name": "Kriest in Recklinghausen (Nr.1041-000)",
            "street": "Christine-Englerth-Str.  24",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1042-000",
            "name": "Reit und Fahrverein e.V. in Dörentrup (Nr.1042-000)",
            "street": "Untere Dorfstraße 36",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1043-000",
            "name": "Grabe in Lippetal (Nr.1043-000)",
            "street": "Schachtruper weg  1",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1044-000",
            "name": "Quitthoevelshof Tennagels in Geldern (Nr.1044-000)",
            "street": "Am Mühlenwasser  56",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1045-000",
            "name": "Wiebke Felderhoff in Bremen (Nr.1045-000)",
            "street": "Oberneulander Landstraße 145c",
            "house_number": "1",
            "zipcode": "28355",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "1046-000",
            "name": "Spiekermann in Bönen (Nr.1046-000)",
            "street": "Sinnerstraße 4",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1047-000",
            "name": "Gütges in Geldern (Nr.1047-000)",
            "street": "Poststr. 6",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1048-000",
            "name": "Malorny in Viersen (Nr.1048-000)",
            "street": "Am Buschfeld 87",
            "house_number": "1",
            "zipcode": "41747",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1049-000",
            "name": "Gilbers in Rheurdt (Nr.1049-000)",
            "street": "Kengen 66",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1050-000",
            "name": "Ruf Lohne in Lohne (Nr.1050-000)",
            "street": "Reiterweg  10",
            "house_number": "1",
            "zipcode": "49393",
            "city": "Lohne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1051-000",
            "name": "Hilling in Lathen (Nr.1051-000)",
            "street": "Emsweg 29b",
            "house_number": "1",
            "zipcode": "49762",
            "city": "Lathen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1052-000",
            "name": "Ponyfarm in Rheine (Nr.1052-000)",
            "street": "Bauerschaftsstraße 196",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1053-000",
            "name": "Hof Eulenkrug in Ahrensburg (Nr.1053-000)",
            "street": "Hamburger Straße 248",
            "house_number": "1",
            "zipcode": "22926",
            "city": "Ahrensburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1054-000",
            "name": "Schröder in Hille-Hartum (Nr.1054-000)",
            "street": "Holzhauser Straße 119",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille-Hartum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1055-000",
            "name": "Reit- und Fahverein Wilhelminenhof e.V. in Ladelund (Nr.1055-000)",
            "street": "Wilhelmine Straße 3",
            "house_number": "1",
            "zipcode": "25926",
            "city": "Ladelund",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1056-000",
            "name": "Privatstall Schumacher in Kappeln (Nr.1056-000)",
            "street": "Heidesiedlung 50",
            "house_number": "1",
            "zipcode": "24376",
            "city": "Kappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1059-000",
            "name": "Pferdestall Pool in Lingen (Nr.1059-000)",
            "street": "Kleekamp 1",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1060-000",
            "name": "Sportpferdezucht Hof Charlottenlind in Gudow (Nr.1060-000)",
            "street": "Hauptstrasse 45",
            "house_number": "1",
            "zipcode": "23899",
            "city": "Gudow",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1061-000",
            "name": "Mühlenhof in Hürth (Nr.1061-000)",
            "street": "Mühlenweg 11",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1062-000",
            "name": "Hof Büsse in Sibbesse (Nr.1062-000)",
            "street": "Kirchstraße 28",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1064-000",
            "name": "Reit und Fahrverein Uetze und Umgebung e.V. in Uetze (Nr.1064-000)",
            "street": "Am Wolfsbusch 2",
            "house_number": "1",
            "zipcode": "31311",
            "city": "Uetze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1065-000",
            "name": "Privat/Kirschbaum/Borgs in Rosendahl-Holtwick (Nr.1065-000)",
            "street": "Bleck 8",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Holtwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1066-000",
            "name": "Bökhaus in Lage (Nr.1066-000)",
            "street": "Lemgoer Str 154",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1067-000",
            "name": "Stonehouse Ranch in Herne (Nr.1067-000)",
            "street": "Wiedehopfstrasse  200",
            "house_number": "1",
            "zipcode": "44653",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1068-000",
            "name": "Selker in Horstmar-Leer (Nr.1068-000)",
            "street": "Haltern  59",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar-Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1069-000",
            "name": "Ohana in Bargtheide (Nr.1069-000)",
            "street": "Alte Landstraße 111",
            "house_number": "1",
            "zipcode": "22941",
            "city": "Bargtheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1070-000",
            "name": "Privatstall Hindersmann in Mettingen (Nr.1070-000)",
            "street": "Neuenkirchener Straße  128",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1071-000",
            "name": "Reitstall Janneby in Janneby (Nr.1071-000)",
            "street": "Ringstraße 8",
            "house_number": "1",
            "zipcode": "24992",
            "city": "Janneby",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1072-000",
            "name": "Hof Ohlemeyer in Minden (Nr.1072-000)",
            "street": "Barrlinge 4",
            "house_number": "1",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1073-000",
            "name": "Privater Stall in Nöpke in Neustadt (Nr.1073-000)",
            "street": "Kleieweg 3a",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1074-000",
            "name": "Stentenbach in Nordhorn (Nr.1074-000)",
            "street": "Isterberger Weg 56",
            "house_number": "1",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1075-000",
            "name": "Pferdehof Kruse in Neuenrade (Nr.1075-000)",
            "street": "Oberer Beuler Weg 25",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1076-000",
            "name": "Gut Holtau in Winsen (Aller) (Nr.1076-000)",
            "street": "Gut Holtau 1",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1077-000",
            "name": "Reitgemeinschaft Schlagbaum in Ennepetal (Nr.1077-000)",
            "street": "Schlagbaum  17",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1078-000",
            "name": "Marie‘s Pony Paradies in Kaarst (Nr.1078-000)",
            "street": "Rottes 155",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1079-000",
            "name": "Haus Steprath in Geldern (Nr.1079-000)",
            "street": "Am Böckelken 35",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1080-000",
            "name": "Reiterhof Tramm in Damp (Nr.1080-000)",
            "street": "Dorotheental  1",
            "house_number": "1",
            "zipcode": "24351",
            "city": "Damp",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1081-000",
            "name": "Kaltenborner Offenstall in Overath (Nr.1081-000)",
            "street": "Kaltenborn 15a",
            "house_number": "1",
            "zipcode": "51491",
            "city": "Overath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1082-000",
            "name": "Reitstall Pasternhof in Krefeld (Nr.1082-000)",
            "street": "Vorderorbroich 63",
            "house_number": "1",
            "zipcode": "47839 ",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1083-000",
            "name": "Reitstall Embsen in Embsen (Nr.1083-000)",
            "street": "Ringstr 1",
            "house_number": "1",
            "zipcode": "21409",
            "city": "Embsen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1084-000",
            "name": "Seibel Ranch in Brekendorf (Nr.1084-000)",
            "street": "Hammer 2",
            "house_number": "1",
            "zipcode": "24811",
            "city": "Brekendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1085-000",
            "name": "Mühlenhof in Westerkappeln (Nr.1085-000)",
            "street": "Mühlenweg 13",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1086-000",
            "name": "Privatstall Helfgerdt in Delbrück (Nr.1086-000)",
            "street": "Baumweg 21",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1087-000",
            "name": "Sport- und Freizeitstall Grefen in Meerbusch (Nr.1087-000)",
            "street": "Am oberen Feld 94",
            "house_number": "1",
            "zipcode": "40668",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1088-000",
            "name": "PSV Meeresreiter in Seelze (Nr.1088-000)",
            "street": "Am Wall 4",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1089-000",
            "name": "Am Mühlenbach in Bliestorf (Nr.1089-000)",
            "street": "Am Mühlenbach  2",
            "house_number": "1",
            "zipcode": "23847",
            "city": "Bliestorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1090-000",
            "name": "Niemann in Visbek (Nr.1090-000)",
            "street": "Lohe 7",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1092-000",
            "name": "Platen in Kempen (Nr.1092-000)",
            "street": "Neuenweg 4",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1093-000",
            "name": "Annika Mielke (privat) in Ganderkesee (Nr.1093-000)",
            "street": "Wildeshauser Landstraße ",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1094-000",
            "name": "Stallgemeinschaft Metelen in Metelen (Nr.1094-000)",
            "street": "Schreiber Esch 8",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1095-000",
            "name": "Gestüt Forstwald in Castrop Rauxel (Nr.1095-000)",
            "street": "Westring 347",
            "house_number": "1",
            "zipcode": "44575",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1096-000",
            "name": "Reitanlage Franzen in Korschenbroich (Nr.1096-000)",
            "street": "Krünsend 64",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1097-000",
            "name": "Geisthoff in Ahlen (Nr.1097-000)",
            "street": "Westhusener weg 5",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1098-000",
            "name": "Gestüt Störtal  in Ehndorf (Nr.1098-000)",
            "street": "Heischredde 3",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1099-000",
            "name": "Gut Bimberg in Unna (Nr.1099-000)",
            "street": "Gut Bimberg ",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1101-000",
            "name": "RFG Auetal e.V. in Schwanewede (Nr.1101-000)",
            "street": "Wiesenstraße 43",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1100-000",
            "name": "Privatstall in Berge (Nr.1100-000)",
            "street": "Hekeser Str. 42",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Berge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1102-000",
            "name": "Schlungshof in Willich (Nr.1102-000)",
            "street": "Stock 110",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1103-000",
            "name": "Hof Eckhorst in Güby (Nr.1103-000)",
            "street": "Eckhorst 6",
            "house_number": "1",
            "zipcode": "24357",
            "city": "Güby",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1104-000",
            "name": "Privatstall Utta in Greven (Nr.1104-000)",
            "street": "Herberner Mersch 22",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1105-000",
            "name": "Steinburg Shires Fam. Hauschildt in Winseldorf (Nr.1105-000)",
            "street": "Oberstr. 22",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Winseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1106-000",
            "name": "Privatstall Rinas-Tenberg in Mettingen (Nr.1106-000)",
            "street": "Woorteweg  9",
            "house_number": "1",
            "zipcode": "49497 ",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1107-000",
            "name": "Katrin Kreihe in Braunschweig (Nr.1107-000)",
            "street": "Eutschenwinkel  1",
            "house_number": "1",
            "zipcode": "38124 ",
            "city": "Braunschweig",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1108-000",
            "name": "Hof Schierenbeck in Weyhe (Nr.1108-000)",
            "street": "Weyher Bruch 30",
            "house_number": "1",
            "zipcode": "28844",
            "city": "Weyhe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1109-000",
            "name": "Gestüt Kobbensen in Heuerßen (Nr.1109-000)",
            "street": "Im Krümmel 8",
            "house_number": "1",
            "zipcode": "31700",
            "city": "Heuerßen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1110-000",
            "name": "Privatstall Göfert in Coesfeld (Nr.1110-000)",
            "street": "Coesfelder Berg  17",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1111-000",
            "name": "Tiemann in Hamm (Nr.1111-000)",
            "street": "Dasbeck  10",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1117-000",
            "name": "Perlenhof in Winsen (Nr.1117-000)",
            "street": "Ostenholzer Str 51",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1118-000",
            "name": "Hof Wichmann in Coesfeld (Nr.1118-000)",
            "street": "Herteler  32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1119-000",
            "name": "Gartz in Nettetal (Nr.1119-000)",
            "street": "An Schönkes Krüz 2",
            "house_number": "1",
            "zipcode": "41334",
            "city": "Nettetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1120-000",
            "name": "RuFV Eiderstedt in Garding (Nr.1120-000)",
            "street": "Graureiherweg ",
            "house_number": "1",
            "zipcode": "25836",
            "city": "Garding",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1121-000",
            "name": "Gerding in Nottuln-Darup (Nr.1121-000)",
            "street": "Hastehausen 9",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln-Darup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1122-000",
            "name": "Privatstall Mahmens in Stapel (Nr.1122-000)",
            "street": "Breite Str. 7",
            "house_number": "1",
            "zipcode": "25879",
            "city": "Stapel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1123-000",
            "name": "Gut Reuschenberg in Leverkusen (Nr.1123-000)",
            "street": "Gut Reuschenberg 1",
            "house_number": "1",
            "zipcode": "51373",
            "city": "Leverkusen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1124-000",
            "name": "Rennstall Kleinbrahm in Bottrop (Nr.1124-000)",
            "street": "Brabecker Feld 27",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1125-000",
            "name": "Postkunden in  (Nr.1125-000)",
            "street": "Postkunden ",
            "house_number": "1",
            "zipcode": "Postkunden",
            "collect_point": "nein"
        },
        {
            "ID": "1126-000",
            "name": "Privatstall Ingwersen in Ostenfeld (Nr.1126-000)",
            "street": "Heidweg  13",
            "house_number": "1",
            "zipcode": "25872",
            "city": "Ostenfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1127-000",
            "name": "Engelking in Raddestorf (Nr.1127-000)",
            "street": "Harrienstedt 60",
            "house_number": "1",
            "zipcode": "31604",
            "city": "Raddestorf",
            "collect_point": "nein"
        },
        {
            "ID": "1128-000",
            "name": "Hof Segbert in Dülmen (Nr.1128-000)",
            "street": "Bauerschaft  20",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1129-000",
            "name": "Kretschmann in Heidgraben (Nr.1129-000)",
            "street": "Pipenblink 27",
            "house_number": "1",
            "zipcode": "25436",
            "city": "Heidgraben",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1130-000",
            "name": "Finkenbrink in Recklinghausen (Nr.1130-000)",
            "street": "Dortmunderstr. 163",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1131-000",
            "name": "Raedgeshof Kempen in Kempen (Nr.1131-000)",
            "street": "An Haus Steinfunder 9",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1132-000",
            "name": "Reitanlage auf dem Ströhen in Steinhagen (Nr.1132-000)",
            "street": "Ströher Str. 46",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1133-000",
            "name": "Pferdepension Blome in Arnsberg (Nr.1133-000)",
            "street": "Westerholtstr. 2",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1134-000",
            "name": "Pferdehof Nottuln (Wedding) in Nottuln (Nr.1134-000)",
            "street": "Horst 15",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1135-000",
            "name": "Pugge in Greven (Nr.1135-000)",
            "street": "Pentruper Mersch 45",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1136-000",
            "name": "Kaiser in Soest (Nr.1136-000)",
            "street": "Eichenweg  4",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1137-000",
            "name": "Holthäuser Hof in Waltrop (Nr.1137-000)",
            "street": "Im Eickel 42",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1138-000",
            "name": "Stallgemeinschaft Happy Hippos in Castrop Rauxel (Nr.1138-000)",
            "street": "Im Finkenbrink 34",
            "house_number": "1",
            "zipcode": "44581",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1140-000",
            "name": "Bültel in Emsbüren (Nr.1140-000)",
            "street": "Lingenerstraße 31",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1141-000",
            "name": "Kenzler in Nideggen (Nr.1141-000)",
            "street": "Neffeltalstrasse 24",
            "house_number": "1",
            "zipcode": "52385",
            "city": "Nideggen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1142-000",
            "name": "Wonderland Ranch in Wiehl (Nr.1142-000)",
            "street": "Scheidter Straße ",
            "house_number": "1",
            "zipcode": "51674",
            "city": "Wiehl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1143-000",
            "name": "Iron Horse Ranch in Hamminkeln (Nr.1143-000)",
            "street": "Ißhorst 6",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1144-000",
            "name": "Privat Kaiser in Ibbenbüren (Nr.1144-000)",
            "street": "An der Blankenburg 99",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1145-000",
            "name": "Krude in Schwalmtal (Nr.1145-000)",
            "street": "Renneperstr 32a",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1146-000",
            "name": "Privatstall Schönke in Peine/Vöhrum (Nr.1146-000)",
            "street": "Kirchvordenerstr 13A",
            "house_number": "1",
            "zipcode": "31228",
            "city": "Peine/Vöhrum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1147-000",
            "name": "Pferdepension und Landwirtschaft Muckhof in Bochum (Nr.1147-000)",
            "street": "Deimketal 44",
            "house_number": "1",
            "zipcode": "44879",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1148-000",
            "name": "Privatstall Weltring in Lingen (Nr.1148-000)",
            "street": "Hohlweg 7",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1149-000",
            "name": "Privatstall Möller in Dötlingen (Nr.1149-000)",
            "street": "Zur Loh 23",
            "house_number": "1",
            "zipcode": "27801",
            "city": "Dötlingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1150-000",
            "name": "Reitschule und Reiterhof Steinmeier-Beese in Everswinkel (Nr.1150-000)",
            "street": "Evener  16",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1151-000",
            "name": "Privatstall Bessmann in Harsewinkel (Nr.1151-000)",
            "street": "Tüllheide 6",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1152-000",
            "name": "Thunhof in Schloß Neuhaus (Nr.1152-000)",
            "street": "Am Thunhof ",
            "house_number": "1",
            "zipcode": "33104",
            "city": "Schloß Neuhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1153-000",
            "name": "Heumann in Stuhr (Nr.1153-000)",
            "street": "Kladdingerstr. 3",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1154-000",
            "name": "Privatstall Wittenburg in Hohenlockstedt (Nr.1154-000)",
            "street": "Ridders 31",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Hohenlockstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1155-000",
            "name": "Privatstall Beiermann in Hörstel (Nr.1155-000)",
            "street": "Nagels Damm 67",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1156-000",
            "name": "Eigener Offenstall in Witten (Nr.1156-000)",
            "street": "Oberkrone 36",
            "house_number": "1",
            "zipcode": "58455",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1157-000",
            "name": "Rohloff in Freienwill (Nr.1157-000)",
            "street": "Alte Dorfstr. 13",
            "house_number": "1",
            "zipcode": "24991",
            "city": "Freienwill",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1158-000",
            "name": "Mahner Berg in Salzgitter Bad (Nr.1158-000)",
            "street": "Mahner Berg 12",
            "house_number": "1",
            "zipcode": "38259",
            "city": "Salzgitter Bad",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1159-000",
            "name": "Privatstall Krallmann in Meppen (Nr.1159-000)",
            "street": "Flutmulde 8",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1160-000",
            "name": "RFV Bötenberg - Wietzen in  Balge  (Nr.1160-000)",
            "street": "Bötenberger Str. 82",
            "house_number": "1",
            "zipcode": "31609",
            "city": " Balge ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1161-000",
            "name": "Gut Höbek in Haßmoor (Nr.1161-000)",
            "street": "Gut Höbek 1",
            "house_number": "1",
            "zipcode": "24790",
            "city": "Haßmoor",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1162-000",
            "name": "Gut Waldhof Home of healthy horses in  Kisdorf (Nr.1162-000)",
            "street": "Am Waldhof 6",
            "house_number": "1",
            "zipcode": "24629",
            "city": " Kisdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1163-000",
            "name": "Lassen in Waabs (Nr.1163-000)",
            "street": "Flintholm 1",
            "house_number": "1",
            "zipcode": "24369",
            "city": "Waabs",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1164-000",
            "name": "Privatstall Straube in Stadtlohn  (Nr.1164-000)",
            "street": "Estern 78",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1165-000",
            "name": "Wenne Valley Ranch  in Schmallenberg (Nr.1165-000)",
            "street": "Grimminghausen 2",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1166-000",
            "name": "Mangelsen  in Wees (Nr.1166-000)",
            "street": "Blixberg 1",
            "house_number": "1",
            "zipcode": "24999",
            "city": "Wees",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1167-000",
            "name": "Privatstall Droste in Lingen (Nr.1167-000)",
            "street": "Duisenburgerstraße 9",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1168-000",
            "name": "Lengelshof in Ratingen  (Nr.1168-000)",
            "street": "Lengelshof 1",
            "house_number": "1",
            "zipcode": "40883",
            "city": "Ratingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1169-000",
            "name": "Reitstall Stegen in Jersbek  (Nr.1169-000)",
            "street": "Alte Landstraße 1H",
            "house_number": "1",
            "zipcode": "22941",
            "city": "Jersbek ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1170-000",
            "name": "Sandra in Velbert  (Nr.1170-000)",
            "street": "Nierenhofer Straße 10",
            "house_number": "1",
            "zipcode": "45509",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1171-000",
            "name": "Privatstall Schmidt in Seelze  (Nr.1171-000)",
            "street": "Im Busche 8",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1172-000",
            "name": "Stall Lüerdissen in Lemgo (Nr.1172-000)",
            "street": "Zur Behrensburg 19",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1173-000",
            "name": "Privatstall Neumann in Niederkassel (Nr.1173-000)",
            "street": "Sülzstr. 7",
            "house_number": "1",
            "zipcode": "53859",
            "city": "Niederkassel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1174-000",
            "name": "Privatstall Wenzel in Niederkrüchten (Nr.1174-000)",
            "street": "Dilborner Str. 5",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1175-000",
            "name": "Ekkehard Heuser  in Ahnatal  (Nr.1175-000)",
            "street": "Schulstr 17",
            "house_number": "1",
            "zipcode": "34292",
            "city": "Ahnatal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1176-000",
            "name": "Reitstall Hans Lugge in Mülheim  (Nr.1176-000)",
            "street": "Gänseweg 80",
            "house_number": "1",
            "zipcode": "45475",
            "city": "Mülheim ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1177-000",
            "name": "Hechmann in Lennestadt (Nr.1177-000)",
            "street": "Fredeburger Str 104",
            "house_number": "1",
            "zipcode": "57368",
            "city": "Lennestadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1178-000",
            "name": "Vogt in Drensteinfurt  (Nr.1178-000)",
            "street": "Herrenstein 26",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1179-000",
            "name": "Wilde Banausen  in Tostedt  (Nr.1179-000)",
            "street": "Poststraße 34",
            "house_number": "1",
            "zipcode": "21255",
            "city": "Tostedt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1180-000",
            "name": "Rayker Hof Matuszak in Lehe (Nr.1180-000)",
            "street": "Bundesstraße 12",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Lehe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1181-000",
            "name": "Equus Dynamics Daria Böker / Gut Lödding in Hamm (Nr.1181-000)",
            "street": "Holunderweg 11",
            "house_number": "1",
            "zipcode": "59063",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1182-000",
            "name": "RSG Busche in Hückeswagen  (Nr.1182-000)",
            "street": "Busche  3",
            "house_number": "1",
            "zipcode": "42499",
            "city": "Hückeswagen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1183-000",
            "name": "Wurth in Lindlar (Nr.1183-000)",
            "street": "Stellberg 1",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1184-000",
            "name": "Eichstädt in Münster (Nr.1184-000)",
            "street": "Westfalenstr. 88",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1185-000",
            "name": "Hof Berning in Emsdetten (Nr.1185-000)",
            "street": "Isendorf 64",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1186-000",
            "name": "Göbel in Bochum (Nr.1186-000)",
            "street": "Bertastraße 8",
            "house_number": "1",
            "zipcode": "44793",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1187-000",
            "name": "Reitsportanlage kisters in Oberhausen (Nr.1187-000)",
            "street": "Waldhuckstraße 187",
            "house_number": "1",
            "zipcode": "46147",
            "city": "Oberhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1188-000",
            "name": "Islandpferde vom Torhaus in Warnau (Nr.1188-000)",
            "street": "Dorfstraße  24",
            "house_number": "1",
            "zipcode": "24250",
            "city": "Warnau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1189-000",
            "name": "Reitstall Seehausen in Wunstorf (Nr.1189-000)",
            "street": "Heidorner Str. 63",
            "house_number": "1",
            "zipcode": "31515",
            "city": "Wunstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1190-000",
            "name": "Hepp in Schönbek (Nr.1190-000)",
            "street": "Dorfstraße 21",
            "house_number": "1",
            "zipcode": "24582",
            "city": "Schönbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1191-000",
            "name": "Stegerhof in Voerde (Nr.1191-000)",
            "street": "Stegerweg 19",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1192-000",
            "name": "Ristau in Fitzbek  (Nr.1192-000)",
            "street": "Mühlenstraße 4",
            "house_number": "1",
            "zipcode": "25579",
            "city": "Fitzbek ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1193-000",
            "name": "Pferderesort Wesling in Warmsen (Nr.1193-000)",
            "street": "Brüninghorstedt 5",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1194-000",
            "name": "Privatstall Ma in Eschede (Nr.1194-000)",
            "street": "Eichenstrasse 2",
            "house_number": "1",
            "zipcode": "29348",
            "city": "Eschede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1195-000",
            "name": "Offenstall Denkfein  in Mettmann (Nr.1195-000)",
            "street": "Laubach 26a",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1196-000",
            "name": "Wesche in Burgdorf  (Nr.1196-000)",
            "street": "Am Vorwerk 18",
            "house_number": "1",
            "zipcode": "31303",
            "city": "Burgdorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1197-000",
            "name": "Hof nedderby in Husby  (Nr.1197-000)",
            "street": "Nedderbyer str 11",
            "house_number": "1",
            "zipcode": "24975",
            "city": "Husby ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1198-000",
            "name": "Psv Coldinne  in Großheide (Nr.1198-000)",
            "street": "Heerweg  11",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1199-000",
            "name": "Wiesendahl in Hamm (Nr.1199-000)",
            "street": "Auf dem Südfelde 5",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1200-000",
            "name": "Kulturhof Neuner in Wingst (Nr.1200-000)",
            "street": "Altkehdinger Weg 50",
            "house_number": "1",
            "zipcode": "21789",
            "city": "Wingst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1201-000",
            "name": "Heineke in Syke  (Nr.1201-000)",
            "street": "Specken 1",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1202-000",
            "name": "Reitanlage Hassel in Bergen (Nr.1202-000)",
            "street": "Hassel 1a",
            "house_number": "1",
            "zipcode": "29303",
            "city": "Bergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1204-000",
            "name": "Erburt in Friesoythe (Nr.1204-000)",
            "street": "Bundesstraße 87",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1205-000",
            "name": "Loagshof in Warstein (Nr.1205-000)",
            "street": "Sauerlandstr 14",
            "house_number": "1",
            "zipcode": "59581",
            "city": "Warstein",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1206-000",
            "name": "RFZV St. Hubertus Herne  in Herne (Nr.1206-000)",
            "street": "Holthauser Str. 91",
            "house_number": "1",
            "zipcode": "44627",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1207-000",
            "name": "Eichkamp in Ehndorf (Nr.1207-000)",
            "street": "Heischredder 2",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1208-000",
            "name": "Privatstall Busch in Bad Laasphe  (Nr.1208-000)",
            "street": "Mittelstraße 21",
            "house_number": "1",
            "zipcode": "57334",
            "city": "Bad Laasphe ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1209-000",
            "name": "Büttger Buscherhöfe in Kaarst (Nr.1209-000)",
            "street": "Büttger Buscherhöfe 8a",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1210-000",
            "name": "Ebkens in Barßel (Nr.1210-000)",
            "street": "Carolinenhofstraße 1",
            "house_number": "1",
            "zipcode": "26676",
            "city": "Barßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1211-000",
            "name": "Reitstall Peters in Heinsberg- Randerath  (Nr.1211-000)",
            "street": "Am Hellenkamp 38",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg- Randerath ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1212-000",
            "name": "Privatstall Eifler in Hürth (Nr.1212-000)",
            "street": "Burgstraße  66",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1213-000",
            "name": "Antje Kötters in Rosendahl (Nr.1213-000)",
            "street": "Rockel  31",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1214-000",
            "name": "Hesping in Hörstel (Nr.1214-000)",
            "street": "Brandhakenweg 12",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1215-000",
            "name": "Pferdehof Mohme  in Porta Westfalica (Nr.1215-000)",
            "street": "Albert-Schweitzer-Str. 21",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1216-000",
            "name": "Privatstall Fenner in Buseck in Buseck (Nr.1216-000)",
            "street": "Grossen-Busecker Str.  41",
            "house_number": "1",
            "zipcode": "35418",
            "city": "Buseck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1217-000",
            "name": "Eichkamp Ehndorf in Ehndorf (Nr.1217-000)",
            "street": "Heischredder 2",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1218-000",
            "name": "Privatstall Lingens in Bramsche (Nr.1218-000)",
            "street": "Balkumer Str.  33",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1219-000",
            "name": "Privatstall Grose in Verden (Aller) (Nr.1219-000)",
            "street": "Osterortstr. 20",
            "house_number": "1",
            "zipcode": "27283",
            "city": "Verden (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1220-000",
            "name": "Leikop in Brilon (Nr.1220-000)",
            "street": "Remstoß 7",
            "house_number": "1",
            "zipcode": "59929",
            "city": "Brilon",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1221-000",
            "name": "Helmuth Schröder in Dänischenhagen (Nr.1221-000)",
            "street": "Kaltenhofer Allee 35",
            "house_number": "1",
            "zipcode": "24229",
            "city": "Dänischenhagen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1222-000",
            "name": "Reitstall Tempel in Kempen (Nr.1222-000)",
            "street": "Pielmey 6",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1223-000",
            "name": "Pferdefreunde Filsum in Filsum (Nr.1223-000)",
            "street": "Burgweg 9",
            "house_number": "1",
            "zipcode": "26849",
            "city": "Filsum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1224-000",
            "name": "Privatstall Weigand in Ilsede (Nr.1224-000)",
            "street": "Dorfstraße 23",
            "house_number": "1",
            "zipcode": "31241",
            "city": "Ilsede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1225-000",
            "name": "Hof Everding in Harsewinkel (Nr.1225-000)",
            "street": "Berkort 5",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1226-000",
            "name": "Privatstall Dunkel in Schalksmühle (Nr.1226-000)",
            "street": "Resswinkeler Weg 49",
            "house_number": "1",
            "zipcode": "58579",
            "city": "Schalksmühle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1227-000",
            "name": "Privatstall Breforth in Hamm (Nr.1227-000)",
            "street": "Dennehauptweg 3a",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1228-000",
            "name": "Privatstall Ganser in Pulheim (Nr.1228-000)",
            "street": "Johann-Hermanns-Weg  16",
            "house_number": "1",
            "zipcode": "50259",
            "city": "Pulheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1229-000",
            "name": "Hof Düren in Witten (Nr.1229-000)",
            "street": "Dürener Str. 32",
            "house_number": "1",
            "zipcode": "58454",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1230-000",
            "name": "Martin Düsterhöft in Melle (Nr.1230-000)",
            "street": "Bruchmühlener Straße 61",
            "house_number": "1",
            "zipcode": "49328",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1231-000",
            "name": "Reitschule Sandkrug in Hatten (Nr.1231-000)",
            "street": "Bümmersteder Straße 57",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1232-000",
            "name": "Privatstall Mannott in Hohn (Nr.1232-000)",
            "street": "Königsbach 10",
            "house_number": "1",
            "zipcode": "24806",
            "city": "Hohn",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1233-000",
            "name": "Hengststation Müller in Badbergen (Nr.1233-000)",
            "street": "Burlagerweg 10a",
            "house_number": "1",
            "zipcode": "49635",
            "city": "Badbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1234-000",
            "name": "Reit- und Fahrstall Lindenhof in Lindlar (Nr.1234-000)",
            "street": "Unterkotten 2",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1235-000",
            "name": "Sperath in Nordenham (Nr.1235-000)",
            "street": "Hansingstraße 62",
            "house_number": "1",
            "zipcode": "26954",
            "city": "Nordenham",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1236-000",
            "name": "Privatstall Kampe in Hürth (Nr.1236-000)",
            "street": "Marktweg 31",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1237-000",
            "name": "von Winterfell in Wedemark (Nr.1237-000)",
            "street": "Auf Dem Kiel 10",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1238-000",
            "name": "Luner Hof der Pferde in Beverstedt (Nr.1238-000)",
            "street": "Reithornsweg 32",
            "house_number": "1",
            "zipcode": "27616",
            "city": "Beverstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1239-000",
            "name": "Privatstall Hemsing in Steinfurt (Nr.1239-000)",
            "street": "Hollich 119",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1240-000",
            "name": "Lagemann in Tecklenburg (Nr.1240-000)",
            "street": "Horstmersch 41",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1242-000",
            "name": "Privatstall Brandt in Varel (Nr.1242-000)",
            "street": "Im Winkel 7",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1243-000",
            "name": "Privatstall Cleve in Hessisch Oldendorf (Nr.1243-000)",
            "street": "Rittergutstraße 47",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1244-000",
            "name": "Reit-Fahr-u. Zuchtverein Bochum-Nord in Bochum (Nr.1244-000)",
            "street": "Zillertalstraße 89",
            "house_number": "1",
            "zipcode": "44807",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1245-000",
            "name": "Reiterhof Stubbe in Hamburg (Nr.1245-000)",
            "street": "Billwerder Billdeich  272",
            "house_number": "1",
            "zipcode": "21033",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1246-000",
            "name": "Privatstall Beewen in Döhlen (Nr.1246-000)",
            "street": "Krumlander Straße 9",
            "house_number": "1",
            "zipcode": "26197",
            "city": "Döhlen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1247-000",
            "name": "Jill Flocke in Wuppertal (Nr.1247-000)",
            "street": "Teschensudberger Straße 24a",
            "house_number": "1",
            "zipcode": "42349",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1248-000",
            "name": "Privatstall Kowalski in Rheine (Nr.1248-000)",
            "street": "Auf dem Brink 13",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1249-000",
            "name": "Reitstall Burchard in Ronnenberg (Nr.1249-000)",
            "street": "Holtenser Straße 4",
            "house_number": "1",
            "zipcode": "30952",
            "city": "Ronnenberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1250-000",
            "name": "Reitverein Milte-Sassenberg in Warendorf-Milte (Nr.1250-000)",
            "street": "Velsen 20",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf-Milte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1251-000",
            "name": "Ponyhof Doose in Altenholz (Nr.1251-000)",
            "street": "Achtstückenberg 6",
            "house_number": "1",
            "zipcode": "24161",
            "city": "Altenholz",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1252-000",
            "name": "Hof Köhler in Mechtersen (Nr.1252-000)",
            "street": "In der Marsch 1",
            "house_number": "1",
            "zipcode": "21358",
            "city": "Mechtersen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1253-000",
            "name": "Privatstall Jacobowsky in Bochum (Nr.1253-000)",
            "street": "Steinring 30",
            "house_number": "1",
            "zipcode": "44789",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1254-000",
            "name": "Privatstall Wessels in Olfen (Nr.1254-000)",
            "street": "Hahnenberg 15",
            "house_number": "1",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1255-000",
            "name": "Hof Brahmkamp in Kosel (Nr.1255-000)",
            "street": "Lundshof 9",
            "house_number": "1",
            "zipcode": "24354",
            "city": "Kosel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1256-000",
            "name": "Privatstall Rochel in Rahden (Nr.1256-000)",
            "street": "Große Masch 12",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1257-000",
            "name": "Hof Hundemühle in Gronenberg (Nr.1257-000)",
            "street": "Hundemühle 1",
            "house_number": "1",
            "zipcode": "23684",
            "city": "Gronenberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1258-000",
            "name": "Rainbowranch in Hannover (Nr.1258-000)",
            "street": "Im Heidkampe 166",
            "house_number": "1",
            "zipcode": "30659",
            "city": "Hannover",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1259-000",
            "name": "RFV Hermannsburg-Berge in Südheide / Hermannsburg (Nr.1259-000)",
            "street": "Georgsstraße  19A",
            "house_number": "1",
            "zipcode": "29320",
            "city": "Südheide / Hermannsburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1260-000",
            "name": "Heuer in Springe (Nr.1260-000)",
            "street": "Steinhauserstraße 6",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1261-000",
            "name": "Hancken in Loxstedt (Nr.1261-000)",
            "street": "Eichenallee 72",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1262-000",
            "name": "Nussbaum in Mettmann (Nr.1262-000)",
            "street": "Wülfrather Str. 262",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1263-000",
            "name": "Pferdesport Brand in Steinfurt (Nr.1263-000)",
            "street": "Hollich 132",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1264-000",
            "name": "Reitstall Peters in Marl (Nr.1264-000)",
            "street": "Dämmerweg 101A",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1265-000",
            "name": "Privatstall Schmitz in Erftstadt (Nr.1265-000)",
            "street": "Genner Str 30",
            "house_number": "1",
            "zipcode": "50374",
            "city": "Erftstadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1266-000",
            "name": "Frerking in Walsrode (Nr.1266-000)",
            "street": "Ebbingen  2",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1267-000",
            "name": "Voltigier und Reitzentrum im Sunderholze in Gevelsberg (Nr.1267-000)",
            "street": "Sunderholzer Weg  24",
            "house_number": "1",
            "zipcode": "58285",
            "city": "Gevelsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1268-000",
            "name": "Privatstall Engstfeld in Detmold (Nr.1268-000)",
            "street": "Hornoldendorfer Str. 6",
            "house_number": "1",
            "zipcode": "32760",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1269-000",
            "name": "Rolf Thiede in Lehe (Nr.1269-000)",
            "street": "Schulstrasse 43",
            "house_number": "1",
            "zipcode": "25774",
            "city": "Lehe",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1270-000",
            "name": "Privatstall Dapper in Mucheln (Nr.1270-000)",
            "street": "Dweerredder 10",
            "house_number": "1",
            "zipcode": "24238",
            "city": "Mucheln",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1271-000",
            "name": "Privatstall Riedel in Essen (Nr.1271-000)",
            "street": "Eststraße 33",
            "house_number": "1",
            "zipcode": "45149",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1272-000",
            "name": "Privatstall Kull-Bor in Brockel (Nr.1272-000)",
            "street": "Bussardweg 15",
            "house_number": "1",
            "zipcode": "27386",
            "city": "Brockel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1273-000",
            "name": "Pferdezucht Steffens in Vorwerk (Nr.1273-000)",
            "street": "Mühlenhof 1",
            "house_number": "1",
            "zipcode": "27412",
            "city": "Vorwerk",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1274-000",
            "name": "Pferdehof Oltmanns in Bad Zwischenahn (Nr.1274-000)",
            "street": "Wildenlohslinie 22",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1275-000",
            "name": "Remus-Petersen in Lindewitt OT Linnau (Nr.1275-000)",
            "street": "Neue Str. 1",
            "house_number": "1",
            "zipcode": "24969",
            "city": "Lindewitt OT Linnau",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1276-000",
            "name": "Hof Groten Köß in Walsrode (Nr.1276-000)",
            "street": "Altenboitzen 13",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1277-000",
            "name": "Paganetty in Gronau (Nr.1277-000)",
            "street": "Am Berge 47b",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1278-000",
            "name": "Reitverein Schmallenberg-Lennestadt e. V. in Schmallenberg (Nr.1278-000)",
            "street": "Berndorfer Straße 2",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1279-000",
            "name": "Raetgeshof  in Kempen (Nr.1279-000)",
            "street": "An Haus Steinfunder 9",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1280-000",
            "name": "Privatstall Müller in Soltau (Nr.1280-000)",
            "street": "Reimerdingerstr  1",
            "house_number": "1",
            "zipcode": "29614",
            "city": "Soltau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1281-000",
            "name": "Kamphausen in Mönchengladbach (Nr.1281-000)",
            "street": "Am Chur  4",
            "house_number": "1",
            "zipcode": "41189",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1282-000",
            "name": "Privatstall Nowald in Jade (Nr.1282-000)",
            "street": "Harms Weg  6",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1283-000",
            "name": "Reistall in Beelen in Beelen (Nr.1283-000)",
            "street": "Greffener Str 19",
            "house_number": "1",
            "zipcode": "48361",
            "city": "Beelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1284-000",
            "name": "Bauer Krüsmann in Wuppertal (Nr.1284-000)",
            "street": "Unterdüssler Weg 25",
            "house_number": "1",
            "zipcode": "42113",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1285-000",
            "name": "Privatstall Loots in Wachum (Nr.1285-000)",
            "street": "Nordweg  97",
            "house_number": "1",
            "zipcode": "26907",
            "city": "Wachum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1286-000",
            "name": "Privatstall Hövel in Hamminkeln (Nr.1286-000)",
            "street": "Bahnhofstraße 78",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1287-000",
            "name": "Rosenhof in Wesel (Nr.1287-000)",
            "street": "Bislicher Str.  68",
            "house_number": "1",
            "zipcode": "46487",
            "city": "Wesel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1288-000",
            "name": "Privatstall Hartig in Grasberg (Nr.1288-000)",
            "street": "Rautendorfer Straße  24",
            "house_number": "1",
            "zipcode": "28879",
            "city": "Grasberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1289-000",
            "name": "Stallgemeinschaft Kröger in Haren (Ems) (Nr.1289-000)",
            "street": "Emen  6",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren (Ems)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1290-000",
            "name": "Privatstall Hähner in Berne (Nr.1290-000)",
            "street": "An den Sielen 24",
            "house_number": "1",
            "zipcode": "27804",
            "city": "Berne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1291-000",
            "name": "Privatstall Musall in Struvenhütten (Nr.1291-000)",
            "street": "Mühlenstraße  33a",
            "house_number": "1",
            "zipcode": "24643",
            "city": "Struvenhütten",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1292-000",
            "name": "Reitanlage Schönbuchen in Dierkshausen (Nr.1292-000)",
            "street": "Zum Moor  46",
            "house_number": "1",
            "zipcode": "21271",
            "city": "Dierkshausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1293-000",
            "name": "Privatstall Onrust in Rhauderfehn (Nr.1293-000)",
            "street": "Schwarzmoorstraße 34",
            "house_number": "1",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1294-000",
            "name": "Reitstall Klintworth in Ohrensen (Nr.1294-000)",
            "street": "Hauptstraße 16",
            "house_number": "1",
            "zipcode": "21698",
            "city": "Ohrensen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1295-000",
            "name": "Reitstall Boms in Korschenbroich (Nr.1295-000)",
            "street": "Willicher Straße 26 A",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1296-000",
            "name": "RV Bodenwerder in Bodenwerder (Nr.1296-000)",
            "street": "Ziegeleiweg  20",
            "house_number": "1",
            "zipcode": "37619",
            "city": "Bodenwerder",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1297-000",
            "name": "Neuwiesenhof  in Burbach (Nr.1297-000)",
            "street": "Höhgarten  5",
            "house_number": "1",
            "zipcode": "57299",
            "city": "Burbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1298-000",
            "name": "Reitstall Verhasselt in Uedem (Nr.1298-000)",
            "street": "Steinbergen 37",
            "house_number": "1",
            "zipcode": "47589",
            "city": "Uedem",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1299-000",
            "name": "Reitstall Schulz in Brakel (Nr.1299-000)",
            "street": "Zum Tiefental  9",
            "house_number": "1",
            "zipcode": "33034",
            "city": "Brakel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1300-000",
            "name": "Reitstall Schoemann in Warpe (Nr.1300-000)",
            "street": "Windhorst 14",
            "house_number": "1",
            "zipcode": "27333",
            "city": "Warpe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1301-000",
            "name": "Privatstall Bies in Kleve (Nr.1301-000)",
            "street": "Südendörp  21",
            "house_number": "1",
            "zipcode": "25779",
            "city": "Kleve",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1302-000",
            "name": "Privatstall Johannsen in Borstel (Nr.1302-000)",
            "street": "Sether Straße 14",
            "house_number": "1",
            "zipcode": "23845",
            "city": "Borstel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1303-000",
            "name": "Ginsterhof in Wulfstorf (Nr.1303-000)",
            "street": "Ginsterweg 6",
            "house_number": "1",
            "zipcode": "29553",
            "city": "Wulfstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1304-000",
            "name": "Pferdepension Kambergs in Viersen (Nr.1304-000)",
            "street": "Hochfeld 1",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1305-000",
            "name": "Stall Flemming in Walsrode (Nr.1305-000)",
            "street": "Hamwiede 4",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1306-000",
            "name": "Pensionspferdehaltung Thelen in Geilenkirchen (Nr.1306-000)",
            "street": "Hatterather Weg 11",
            "house_number": "1",
            "zipcode": "52511",
            "city": "Geilenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1307-000",
            "name": "Reitstall Welter in Dormagen (Nr.1307-000)",
            "street": "Marienhof 1",
            "house_number": "1",
            "zipcode": "41542",
            "city": "Dormagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1308-000",
            "name": "Privatstall Krebs in Wiedensahl (Nr.1308-000)",
            "street": "In der Hespe  19",
            "house_number": "1",
            "zipcode": "31719",
            "city": "Wiedensahl",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1309-000",
            "name": "Privatstall Fürst in Bülkau (Nr.1309-000)",
            "street": "Süderende ",
            "house_number": "1",
            "zipcode": "21782",
            "city": "Bülkau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1310-000",
            "name": "B&B Reitstall Hesel in Hesel (Nr.1310-000)",
            "street": "Vorwerker str 11",
            "house_number": "1",
            "zipcode": "26835",
            "city": "Hesel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1311-000",
            "name": "Reitstall Gödde in Dortmund (Nr.1311-000)",
            "street": "Ostberger Str.  19",
            "house_number": "1",
            "zipcode": "44289",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1312-000",
            "name": "Privatstall Steiner in Nahe (Nr.1312-000)",
            "street": "Hauen 40",
            "house_number": "1",
            "zipcode": "23866",
            "city": "Nahe",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1313-000",
            "name": "Hof Schulzentrum  in Schneverdingen  (Nr.1313-000)",
            "street": "Goosekamp  10",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1314-000",
            "name": "Privatstall Schildt in Westerkappeln (Nr.1314-000)",
            "street": "Hollenbergs Hügel  62",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1315-000",
            "name": "Privatstall Stern in  Eystrup (Nr.1315-000)",
            "street": "Am Geestrand  6",
            "house_number": "1",
            "zipcode": "27324",
            "city": " Eystrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1316-000",
            "name": "Hof Hammerich in Osdorf (Nr.1316-000)",
            "street": "Haferrögen 100",
            "house_number": "1",
            "zipcode": "24251",
            "city": "Osdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1317-000",
            "name": "Privatstall Laumann in Hörstel-Bevergern (Nr.1317-000)",
            "street": "Kleiner Send  10",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Bevergern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1318-000",
            "name": "RSG Herne Börnig in Herne (Nr.1318-000)",
            "street": "Sodingerstraße 563",
            "house_number": "1",
            "zipcode": "44623",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1319-000",
            "name": "Reitstall Kücker  in Bielefeld (Nr.1319-000)",
            "street": "Hobusch 28",
            "house_number": "1",
            "zipcode": "33619",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1320-000",
            "name": "Privatstall Riegels  in Velbert  (Nr.1320-000)",
            "street": "Ewald-Jochemstr. 17",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1321-000",
            "name": "Privatstall Tietz in Emmerich (Nr.1321-000)",
            "street": "Zum Waldkreuz 160",
            "house_number": "1",
            "zipcode": "46446",
            "city": "Emmerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1322-000",
            "name": "Privatstall Otte in Holte in Ostercappeln (Nr.1322-000)",
            "street": "Dreskenkamp  7",
            "house_number": "1",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1323-000",
            "name": "Reitstall Springer in Großheide (Nr.1323-000)",
            "street": "Schulweg  10a",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1324-000",
            "name": "Reitstall Bannierink in Neuenkirchen (Nr.1324-000)",
            "street": "Haarweg 75",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1325-000",
            "name": "Privatstall Pleßner  in Telgte  (Nr.1325-000)",
            "street": "Harkampsheide  4",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1326-000",
            "name": "Brackmann  in Gehrde  (Nr.1326-000)",
            "street": "Forststraße  12",
            "house_number": "1",
            "zipcode": "49596",
            "city": "Gehrde ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1327-000",
            "name": "Pakheiser  in Burweg  (Nr.1327-000)",
            "street": "Im Ring  7",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Burweg ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1328-000",
            "name": "Privatstall Klug  in Eydelstedt  (Nr.1328-000)",
            "street": "Holzort  2",
            "house_number": "1",
            "zipcode": "49406",
            "city": "Eydelstedt ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1329-000",
            "name": "Privatstall Wilke  in Drentwede  (Nr.1329-000)",
            "street": "Große Heide  1",
            "house_number": "1",
            "zipcode": "49406",
            "city": "Drentwede ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1330-000",
            "name": "Reitstall Rensch  in Handewitt  (Nr.1330-000)",
            "street": "Lecker Chaussee  18A ",
            "house_number": "1",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1331-000",
            "name": "Eichenhof in Ebstorf (Nr.1331-000)",
            "street": "Im Winkel 2",
            "house_number": "1",
            "zipcode": "29574",
            "city": "Ebstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1332-000",
            "name": "Katharina Bostenmann in Neetze/Neu-Neetze (Nr.1332-000)",
            "street": "Fraaschweg 3",
            "house_number": "1",
            "zipcode": "21398",
            "city": "Neetze/Neu-Neetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1333-000",
            "name": "Reitgemeinschaft 77 in Essen Dellwig (Nr.1333-000)",
            "street": "Klaumerbruch 40a",
            "house_number": "1",
            "zipcode": "45357",
            "city": "Essen Dellwig",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1334-000",
            "name": "Privatstall Gründker in Rheine (Nr.1334-000)",
            "street": "Dahlkampstraße  15",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1335-000",
            "name": "Privatstall Auringer in Hemslingen (Nr.1335-000)",
            "street": "Bockshorst  22",
            "house_number": "1",
            "zipcode": "27386",
            "city": "Hemslingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1336-000",
            "name": "Reitstall Meißner in Wetter (Nr.1336-000)",
            "street": "Auf Schölling  1",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1337-000",
            "name": "Privatstall Koss in Stolzenau (Nr.1337-000)",
            "street": "Krumme Straße ",
            "house_number": "1",
            "zipcode": "31592",
            "city": "Stolzenau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1338-000",
            "name": "Privatadresse Hollje in Wardenburg (Nr.1338-000)",
            "street": "Garreler Straße  128",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "LD-RG",
            "name": "Loesdau Filiale in Rosengarten (Nr.LD-RG)",
            "street": "Am Hatzberg  5",
            "house_number": "1",
            "zipcode": "21224",
            "city": "Rosengarten",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-LEH",
            "name": "Loesdau Filiale in Lehrte-Aligse (Nr.LD-LEH)",
            "street": "Rudolf-Petzold-Ring  7",
            "house_number": "1",
            "zipcode": "31275",
            "city": "Lehrte-Aligse",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-MUE",
            "name": "Loesdau Filiale in Mülheim an der Ruhr (Nr.LD-MUE)",
            "street": "Duisburger Straße  399",
            "house_number": "1",
            "zipcode": "45478",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-REK",
            "name": "Loesdau Filiale in Recklinghausen (Nr.LD-REK)",
            "street": "Schmalkalder Straße  8",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-ERF",
            "name": "Loesdau Filiale in Erftstadt (Nr.LD-ERF)",
            "street": "Albert-Einstein-Ring  8",
            "house_number": "1",
            "zipcode": "50374",
            "city": "Erftstadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-RUE",
            "name": "Loesdau Filiale in Rüsselsheim-Königstädten (Nr.LD-RUE)",
            "street": "Alexander-Fleming-Ring  39",
            "house_number": "1",
            "zipcode": "65428",
            "city": "Rüsselsheim-Königstädten",
            "state": "Hessen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-MOE",
            "name": "Loesdau Filiale in Möglingen (Nr.LD-MOE)",
            "street": "Raiffeisenstraße  7",
            "house_number": "1",
            "zipcode": "71696",
            "city": "Möglingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-BIS",
            "name": "Loesdau Filiale in Bisingen / Hohenzollern (Nr.LD-BIS)",
            "street": "Hechinger Straße  58",
            "house_number": "1",
            "zipcode": "72406",
            "city": "Bisingen / Hohenzollern",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-RT",
            "name": "Loesdau Filiale in Reutlingen (Nr.LD-RT)",
            "street": "Tübinger Straße  75",
            "house_number": "1",
            "zipcode": "72762",
            "city": "Reutlingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-VS",
            "name": "Loesdau Filiale in VS-Villingen (Nr.LD-VS)",
            "street": "Vockenhauser Straße  26",
            "house_number": "1",
            "zipcode": "78048",
            "city": "VS-Villingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-FI",
            "name": "Loesdau Filiale in Forstinning-Moos (Nr.LD-FI)",
            "street": "Römerstraße  16",
            "house_number": "1",
            "zipcode": "85661",
            "city": "Forstinning-Moos",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-FRI",
            "name": "Loesdau Filiale in Friedberg (Nr.LD-FRI)",
            "street": "Winterbruckenweg  56",
            "house_number": "1",
            "zipcode": "86316",
            "city": "Friedberg",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-WG",
            "name": "Loesdau Filiale in Weingarten (Nr.LD-WG)",
            "street": "Friedrich-Seifriz-Str.  2",
            "house_number": "1",
            "zipcode": "88250",
            "city": "Weingarten",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-HES",
            "name": "Loesdau Filiale in Heßdorf (Nr.LD-HES)",
            "street": "Im Gewerbepark  37",
            "house_number": "1",
            "zipcode": "91093",
            "city": "Heßdorf",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-WOE",
            "name": "Loesdau Filiale in Wörnitz (Nr.LD-WOE)",
            "street": "Am Kreisel  3",
            "house_number": "1",
            "zipcode": "91637",
            "city": "Wörnitz",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "1339-000",
            "name": "Markwitz  in Heersum  (Nr.1339-000)",
            "street": "Neuer Weg  10",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Heersum ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1340-000",
            "name": "Gestüt Halnerg  in Hennef  (Nr.1340-000)",
            "street": "Halberg  2",
            "house_number": "1",
            "zipcode": "53773",
            "city": "Hennef ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1341-000",
            "name": "Schade  in Hohenlockstedt (Nr.1341-000)",
            "street": "Ridders  58",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Hohenlockstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1342-000",
            "name": "Landreitschule  in Velbert  (Nr.1342-000)",
            "street": "Donnenberger Str.  145",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1343-000",
            "name": "Mentzenhof in Ense (Nr.1343-000)",
            "street": "Mawickerstr. 3",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1344-000",
            "name": "Jäger  in Petershagen (Nr.1344-000)",
            "street": "Heidberg  7",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1345-000",
            "name": "Hof Pintado in Lindau (Nr.1345-000)",
            "street": "Sander Weg 19",
            "house_number": "1",
            "zipcode": "24214",
            "city": "Lindau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1346-000",
            "name": "SL Sporthorses  in Gladbeck  (Nr.1346-000)",
            "street": "Voßbrinkstraße  67",
            "house_number": "1",
            "zipcode": "45966",
            "city": "Gladbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1347-000",
            "name": "Hegemeister  in Espelkamp (Nr.1347-000)",
            "street": "Fabbenstedter Straße  32",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1348-000",
            "name": "Reit Club Oberhausen in Oberhausen (Nr.1348-000)",
            "street": "Bauerfeld 159",
            "house_number": "1",
            "zipcode": "46045",
            "city": "Oberhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1349-000",
            "name": "Hof Heitmann in Werne (Nr.1349-000)",
            "street": "Am Reiterhof 5",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1350-000",
            "name": "Germann in Lütetsburg  (Nr.1350-000)",
            "street": "Lütetsburgerlandstraße 68",
            "house_number": "1",
            "zipcode": "26524",
            "city": "Lütetsburg ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1351-000",
            "name": "Silies  in Emsbüren  (Nr.1351-000)",
            "street": "Im Dunkern  1",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1352-000",
            "name": "Horse Competence  in Beverstedt (Nr.1352-000)",
            "street": "Am Blumenkamp  1",
            "house_number": "1",
            "zipcode": "27616",
            "city": "Beverstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1353-000",
            "name": "Schröder-Meyer Hof  in Wienhausen-Bockelskamp  (Nr.1353-000)",
            "street": "Ortfeld  1",
            "house_number": "1",
            "zipcode": "29342",
            "city": "Wienhausen-Bockelskamp ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1354-000",
            "name": "Heidlooger Hof  in Varel (Nr.1354-000)",
            "street": "Heidlooger Weg 2",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1355-000",
            "name": "Ausbildungs- und Therapiezentrum Handorf in Handorf (Nr.1355-000)",
            "street": "Kiefernweg 29",
            "house_number": "1",
            "zipcode": "21447",
            "city": "Handorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1356-000",
            "name": "Anika Siltmann in Grafeld (Nr.1356-000)",
            "street": "Herzlaker Straße 44",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Grafeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1357-000",
            "name": "Schulte Hobein in Sundern (Nr.1357-000)",
            "street": "Am Krausen Baum 11",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1358-000",
            "name": "Hof Ernst in Marxen  (Nr.1358-000)",
            "street": "Hauptstraße  5",
            "house_number": "1",
            "zipcode": "21439",
            "city": "Marxen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1359-000",
            "name": "Tierische Begleiter in Bielefeld (Nr.1359-000)",
            "street": "Veerhoffstraße 20",
            "house_number": "1",
            "zipcode": "33649",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1360-000",
            "name": "Eichenhof in Geestland (Nr.1360-000)",
            "street": "Reiterweg 7",
            "house_number": "1",
            "zipcode": "27607",
            "city": "Geestland",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1361-000",
            "name": "Reitstall Meggers in Schwedeneck (Nr.1361-000)",
            "street": "Gettorfer Landstr. 2",
            "house_number": "1",
            "zipcode": "24229",
            "city": "Schwedeneck",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1362-000",
            "name": "Privatstall Wischemann in Ochtrup (Nr.1362-000)",
            "street": "Wester 261",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1363-000",
            "name": "Privatstall Depembrock in Telgte  (Nr.1363-000)",
            "street": "Kortenkamp 18",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1364-000",
            "name": "Reitstall Breer in Werne (Nr.1364-000)",
            "street": "Am Sunderbach 3",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1365-000",
            "name": "Privatstall Huismann in Ihlow (Nr.1365-000)",
            "street": "Fennenstraße  17",
            "house_number": "1",
            "zipcode": "26632",
            "city": "Ihlow",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1366-000",
            "name": "Privatstall Eiken in Ahlen (Nr.1366-000)",
            "street": "Hauptstraße 11",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1367-000",
            "name": "Reitstall Krusenhoff in Kirchlinteln (Nr.1367-000)",
            "street": "Verdenermoorstraße 1",
            "house_number": "1",
            "zipcode": "27308",
            "city": "Kirchlinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1368-000",
            "name": "Reitstall Jordan in Gifhorn (Nr.1368-000)",
            "street": "Wendenerstraße 18",
            "house_number": "1",
            "zipcode": "38527",
            "city": "Gifhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1369-000",
            "name": "Hof Tönns  in Marxen  (Nr.1369-000)",
            "street": "Lindenallee 30",
            "house_number": "1",
            "zipcode": "21439",
            "city": "Marxen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1370-000",
            "name": "Aktivlaufstall Wessing in Borken (Nr.1370-000)",
            "street": "Sonnenbrink 60",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1371-000",
            "name": "Privatstall Doepke in Zetel (Nr.1371-000)",
            "street": "An der Eiche 11",
            "house_number": "1",
            "zipcode": "26340",
            "city": "Zetel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1372-000",
            "name": "Hof Wettersberg in Haale (Nr.1372-000)",
            "street": "Wettersberg 20",
            "house_number": "1",
            "zipcode": "24819",
            "city": "Haale",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1373-000",
            "name": "Privatstall Storb  in Mühlheim an der Ruhr (Nr.1373-000)",
            "street": "Hansbergstraße 1",
            "house_number": "1",
            "zipcode": "45472",
            "city": "Mühlheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1374-000",
            "name": "Praxis für Physiotherapie in Hambühren (Nr.1374-000)",
            "street": "Mittelstraße 25",
            "house_number": "1",
            "zipcode": "29313",
            "city": "Hambühren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1375-000",
            "name": "Privatstall Rickert in Winsen-Luhe (Nr.1375-000)",
            "street": "Pattenser Hauptstraße 30",
            "house_number": "1",
            "zipcode": "21423",
            "city": "Winsen-Luhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1376-000",
            "name": "Reitstall Waterboer in Bielefeld (Nr.1376-000)",
            "street": "Waterboerstraße  77b",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1377-000",
            "name": "Privatstall Nohn in Sankt Augustin (Nr.1377-000)",
            "street": "Langstraße  5",
            "house_number": "1",
            "zipcode": "53757",
            "city": "Sankt Augustin",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1378-000",
            "name": "Reitanlage Wocklum in Balve (Nr.1378-000)",
            "street": "Wocklumer Allee  7",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1379-000",
            "name": "Privatstall Gast in Burgwedel (Nr.1379-000)",
            "street": "Alter Postweg  5b",
            "house_number": "1",
            "zipcode": "30938",
            "city": "Burgwedel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1380-000",
            "name": "Privathaus Andreas/Recke in Hannover (Nr.1380-000)",
            "street": "Kleifeld 5",
            "house_number": "1",
            "zipcode": "30539",
            "city": "Hannover",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1381-000",
            "name": "Reitstall Apfelhof in Marschacht (Nr.1381-000)",
            "street": "Elbuferstraße  29a",
            "house_number": "1",
            "zipcode": "21436",
            "city": "Marschacht",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1382-000",
            "name": "Reitstall Eckay in Hamm (Nr.1382-000)",
            "street": "Dasbeck  16",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1383-000",
            "name": "Reistall Erkes in Viersen (Nr.1383-000)",
            "street": "Heyerhöfe  1",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1384-000",
            "name": "Privatstall Thiel in Diemelsee (Nr.1384-000)",
            "street": "Steinweg 3",
            "house_number": "1",
            "zipcode": "34519",
            "city": "Diemelsee",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1385-000",
            "name": "Privatstall Silberberg  in Oer-Erkenschwick (Nr.1385-000)",
            "street": "Mühlenweg  234",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1386-000",
            "name": "Privatstall Matischewitz in Brunsbüttel (Nr.1386-000)",
            "street": "Gerhart-Hauptmann-Straße 18",
            "house_number": "1",
            "zipcode": "25541",
            "city": "Brunsbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1387-000",
            "name": "Privatstall Genuneit in Varel (Nr.1387-000)",
            "street": "Zum Jadebusen  180a",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1388-000",
            "name": "Reitstall Szillat in Clauen (Nr.1388-000)",
            "street": "Schlütenstraße  19",
            "house_number": "1",
            "zipcode": "31249",
            "city": "Clauen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1389-000",
            "name": "Kellerhof Fam. Keller in Coesfeld (Nr.1389-000)",
            "street": "Harle  35",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1390-000",
            "name": "Stall Schumacher in Friesoythe (Nr.1390-000)",
            "street": "An der Berme 2",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1391-000",
            "name": "Stall Schnäbele in Adendorf (Nr.1391-000)",
            "street": "Grüner-Jäger-Weg ",
            "house_number": "1",
            "zipcode": "21365",
            "city": "Adendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1392-000",
            "name": "Hof Höge in Oeyten (Nr.1392-000)",
            "street": "Klein Hollen 33",
            "house_number": "1",
            "zipcode": "28876",
            "city": "Oeyten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1393-000",
            "name": "Mühlenhof in Greven - Gimbte (Nr.1393-000)",
            "street": "Mühlenweg  33",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven - Gimbte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1394-000",
            "name": "Reitstall Palmberg in Soest (Nr.1394-000)",
            "street": "Gartenkamp 15",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1395-000",
            "name": "ZRFV Legden e.V. in Legden (Nr.1395-000)",
            "street": "Bleikenkamp 20",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1396-000",
            "name": "Helgihof in Twistringen (Nr.1396-000)",
            "street": "Nienburger Straße  123",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1397-000",
            "name": "Privatstall Ehlers in Lemwerder (Nr.1397-000)",
            "street": "Ollenstraße  2",
            "house_number": "1",
            "zipcode": "27809",
            "city": "Lemwerder",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1398-000",
            "name": "Horsewellfarm Niederrhein in Issum (Nr.1398-000)",
            "street": "Nordring  155",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1399-000",
            "name": "Privatstall Kersting  in Dorsten (Nr.1399-000)",
            "street": "Philosophenweg 10",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1400-000",
            "name": "Privatstall Minzera in Halle (Nr.1400-000)",
            "street": "Eichenweg 21a",
            "house_number": "1",
            "zipcode": "33790",
            "city": "Halle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1401-000",
            "name": "Stall Stegmann in Twistringen (Nr.1401-000)",
            "street": "Steinstraße  12",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1402-000",
            "name": "Privatstall Schlieske in Petershagen (Nr.1402-000)",
            "street": "Bockmühlenweg 3",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1403-000",
            "name": "Privatstall Kullmann in Celle (Nr.1403-000)",
            "street": "Hannoversche Herrstr. 160",
            "house_number": "1",
            "zipcode": "29227",
            "city": "Celle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1404-000",
            "name": "Hof Reineke in Hemmingen (Nr.1404-000)",
            "street": "Heifeld 4",
            "house_number": "1",
            "zipcode": "30966",
            "city": "Hemmingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1405-000",
            "name": "Hof Hoster  in Issum (Nr.1405-000)",
            "street": "Großholthuysen  31",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1406-000",
            "name": "Reitstall Jostes in Mühlheim an der Ruhr (Nr.1406-000)",
            "street": "Mintarder Straße  101",
            "house_number": "1",
            "zipcode": "45481",
            "city": "Mühlheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1407-000",
            "name": "Paddock Trail Müller in Wegberg (Nr.1407-000)",
            "street": "Marktstraße  21",
            "house_number": "1",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1408-000",
            "name": "Privatstall Möllmann in Selm (Nr.1408-000)",
            "street": "Strandweg 2",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1409-000",
            "name": "Reitstall Litjes in Weeze (Nr.1409-000)",
            "street": "Niederhelsum 23a",
            "house_number": "1",
            "zipcode": "47652",
            "city": "Weeze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1410-000",
            "name": "Reitstall Semmelhack  in Engelbrechtsche Wildnis (Nr.1410-000)",
            "street": "Obendeich 2",
            "house_number": "1",
            "zipcode": "25379",
            "city": "Engelbrechtsche Wildnis",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1412-000",
            "name": "Reitanlage Franzen in Korschenbroich (Nr.1412-000)",
            "street": "Krünsend 1",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1413-000",
            "name": "Privatstall Urbaniak in Beesten (Nr.1413-000)",
            "street": "Waldstraße 1",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Beesten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1414-000",
            "name": "Pensionsstall Hof Heling in Ahaus  (Nr.1414-000)",
            "street": "Averesch 18",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1415-000",
            "name": "Hulingshof Kempen in Kempen (Nr.1415-000)",
            "street": "Klixdorfer Straße  16",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1416-000",
            "name": "RV Balve in Balve (Nr.1416-000)",
            "street": "Wocklum  14",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1417-000",
            "name": "Reitstall Schlß Söder in Holle (Nr.1417-000)",
            "street": "Hainbergstraße 13",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Holle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1418-000",
            "name": "RuFV Samern in Samern (Nr.1418-000)",
            "street": "Salzbergener Str.  93",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Samern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1419-000",
            "name": "Stall Ruthemeier in Osterholz-Scharmbeck (Nr.1419-000)",
            "street": "Röntgenstraße 14",
            "house_number": "1",
            "zipcode": "27711",
            "city": "Osterholz-Scharmbeck",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1420-000",
            "name": "Privatstall Holz in Mittelangeln (Nr.1420-000)",
            "street": "Norderholz Weg  1a",
            "house_number": "1",
            "zipcode": "24986",
            "city": "Mittelangeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1421-000",
            "name": "Privatstall Otte in Wuppertal (Nr.1421-000)",
            "street": "Untenrohleder  4",
            "house_number": "1",
            "zipcode": "42111",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1422-000",
            "name": "Stall Kaiser  in Seevetal  (Nr.1422-000)",
            "street": "Am Heestern  28",
            "house_number": "1",
            "zipcode": "21218",
            "city": "Seevetal ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1423-000",
            "name": "Star Light Ranch in Essen (Nr.1423-000)",
            "street": "Langestraße  144",
            "house_number": "1",
            "zipcode": "45307",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1424-000",
            "name": "Privatstall Heinze in Lemgo (Nr.1424-000)",
            "street": "Strüher Straße 94",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1425-000",
            "name": "Niehoff  in Gronau (Nr.1425-000)",
            "street": "Saarstraße  6",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1426-000",
            "name": "Privatstall Steinhoff  in Wickede (Nr.1426-000)",
            "street": "Hopfenkamp 15",
            "house_number": "1",
            "zipcode": "58739",
            "city": "Wickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1427-000",
            "name": "Reitponyzucht Urienne in Sprockhövel  (Nr.1427-000)",
            "street": "Hedtbleck 4",
            "house_number": "1",
            "zipcode": "45549",
            "city": "Sprockhövel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1428-000",
            "name": "Ponyclub Ohlendorf Jugendfarm e.V. in Seevetal  (Nr.1428-000)",
            "street": "Alter Postweg  160",
            "house_number": "1",
            "zipcode": "21220",
            "city": "Seevetal ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1429-000",
            "name": "Hof Lobbel  in Horstmar-Leer (Nr.1429-000)",
            "street": "Ostendorf  72",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar-Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1430-000",
            "name": "Hof Schweer in Wiedensahl (Nr.1430-000)",
            "street": "Bahnhofstraße ",
            "house_number": "1",
            "zipcode": "31719",
            "city": "Wiedensahl",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1431-000",
            "name": "Vierthof in Albersdorf (Nr.1431-000)",
            "street": "Vierthof 2",
            "house_number": "1",
            "zipcode": "25767",
            "city": "Albersdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1432-000",
            "name": "Reiterhof Benien in Bottrop Kirchhellen (Nr.1432-000)",
            "street": "Hofwiese 26",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1433-000",
            "name": "Reitstall Elisenhof  in Hörstel (Nr.1433-000)",
            "street": "Elisenhofstraße 5",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1434-000",
            "name": "Reitschule Peters in Heinsberg  (Nr.1434-000)",
            "street": "Wurmaue  11",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1435-000",
            "name": "Privatstall Höwer in Schmallenberg- Grafschaft (Nr.1435-000)",
            "street": "Hauptstraße  17",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg- Grafschaft",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1436-000",
            "name": "Ponystall  in Stöckse (Nr.1436-000)",
            "street": "In der Twacht  9",
            "house_number": "1",
            "zipcode": "31638",
            "city": "Stöckse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1437-000",
            "name": "Reitanlage Gut Abtshof in Mönchengladbach (Nr.1437-000)",
            "street": "Krefelder Straße  726",
            "house_number": "1",
            "zipcode": "41066",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1438-000",
            "name": "Fohlenhof Felsen in Herzlake in Herzlake (Nr.1438-000)",
            "street": "An der Högede 3",
            "house_number": "1",
            "zipcode": "49770",
            "city": "Herzlake",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1439-000",
            "name": "Hof Drakenburg  in Drakenburg (Nr.1439-000)",
            "street": "Liethenkämpen 3",
            "house_number": "1",
            "zipcode": "31623",
            "city": "Drakenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1440-000",
            "name": "Reiterhof Pulheim Frechen in Pulheim (Nr.1440-000)",
            "street": "Bonnstraße ",
            "house_number": "1",
            "zipcode": "50259",
            "city": "Pulheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1441-000",
            "name": "Lanner Marschhof  in Hetlingen (Nr.1441-000)",
            "street": "Grüner Damm  14",
            "house_number": "1",
            "zipcode": "25491",
            "city": "Hetlingen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1442-000",
            "name": "Reitstall Sophia Schröder  in Isernhagen (Nr.1442-000)",
            "street": "Dorfstraße  83",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1443-000",
            "name": "Reitgemeinschaft Stall Prost  in Gelsenkirchen (Nr.1443-000)",
            "street": "Koesfeld  ",
            "house_number": "1",
            "zipcode": "45896",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1444-000",
            "name": "Reitstall Hehler  in Schwalmtal  (Nr.1444-000)",
            "street": "Hehler 52",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1445-000",
            "name": "Landwirtschaftlicher Betrieb Manuela Pirdzuhn in Borstel (Nr.1445-000)",
            "street": "Holmer Weg 6",
            "house_number": "1",
            "zipcode": "23845",
            "city": "Borstel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1446-000",
            "name": "Privatstall Wellmann in Metelen (Nr.1446-000)",
            "street": "Naendorf 95",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1447-000",
            "name": "Privatstall Berning in Ochtrup (Nr.1447-000)",
            "street": "Oster 331",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1448-000",
            "name": "Reitanlage Wittenbergshof  in Sonsbeck (Nr.1448-000)",
            "street": "Gossendeich 32",
            "house_number": "1",
            "zipcode": "47665",
            "city": "Sonsbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1449-000",
            "name": "Reistall Twietenhof in Winsen-Luhe (Nr.1449-000)",
            "street": "Brückenfeld 21",
            "house_number": "1",
            "zipcode": "21423",
            "city": "Winsen-Luhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1450-000",
            "name": "Werner Mahlstedt Pferdezucht in Schwanewede (Nr.1450-000)",
            "street": "Großer Kamp 28",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1451-000",
            "name": "Reiterhof Kolb in Sophienhamm (Nr.1451-000)",
            "street": "Dorfstraße 5",
            "house_number": "1",
            "zipcode": "24806",
            "city": "Sophienhamm",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1452-000",
            "name": "Unsere kleine Ranch  in Edemissen (Nr.1452-000)",
            "street": "An der Brandwiese 1",
            "house_number": "1",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1453-000",
            "name": "Privatstall Wendel  in Welle (Nr.1453-000)",
            "street": "Cordshagen  4",
            "house_number": "1",
            "zipcode": "21216",
            "city": "Welle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1454-000",
            "name": "Privatstall Spliethoff in Salzbergen  (Nr.1454-000)",
            "street": "Neuenkirchener Straße  34",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1455-000",
            "name": "Reiterhof Nieberg  in Hagen a.T.W. (Nr.1455-000)",
            "street": "Am Silbersee 18",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen a.T.W.",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1456-000",
            "name": "Britta´s Ponyhof in Duisburg (Nr.1456-000)",
            "street": "Obermeidericher Straße  181A",
            "house_number": "1",
            "zipcode": "47138",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1457-000",
            "name": "Pferdeparadies Asche  in Petershagen (Nr.1457-000)",
            "street": "Im Grünen  3",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1458-000",
            "name": "Reitstall Kornmasch in Bückeburg (Nr.1458-000)",
            "street": "An der Kornmasch 5",
            "house_number": "1",
            "zipcode": "31675",
            "city": "Bückeburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1459-000",
            "name": "Hof Krützkemper in Münster (Nr.1459-000)",
            "street": "Roxeler Str 466",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1460-000",
            "name": "Pferdepension Wübbels in Wietmarschen (Nr.1460-000)",
            "street": "Lohnerbrucher Str. 14",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1461-000",
            "name": "Hof Frenz in Gütersloh (Nr.1461-000)",
            "street": "Rothaarweg 15",
            "house_number": "1",
            "zipcode": "33332",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1462-000",
            "name": "Reitverein Lilienthal in Lilienthal (Nr.1462-000)",
            "street": "Im Orth 11",
            "house_number": "1",
            "zipcode": "28865",
            "city": "Lilienthal",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1463-000",
            "name": "Privatstall Müller  in Ippensen (Nr.1463-000)",
            "street": "Zum Feldblick 5",
            "house_number": "1",
            "zipcode": "27419",
            "city": "Ippensen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1464-000",
            "name": "Kikes Pferdebox in Horn- Bad Meinberg (Nr.1464-000)",
            "street": "Hoher Weg 10",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn- Bad Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1465-000",
            "name": "Long Mountain Ranch in Schwanewede (Nr.1465-000)",
            "street": "Langenberger Weg 3",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1466-000",
            "name": "Ederveen in Ederveen (Nr.1466-000)",
            "street": "Poelweg ",
            "house_number": "1",
            "zipcode": "6744 PJ",
            "city": "Ederveen",
            "state": "Niederlande",
            "collect_point": "nein"
        },
        {
            "ID": "1467-000",
            "name": "Privatstall Blömer in Dinklage (Nr.1467-000)",
            "street": "Lager Straße  7",
            "house_number": "1",
            "zipcode": "49413",
            "city": "Dinklage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1468-000",
            "name": "Sport & Zucht Stall Temmen in Rheine (Nr.1468-000)",
            "street": "Hohe Allee 101",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1469-000",
            "name": "Reiterhof Müscher in Bad Laer (Nr.1469-000)",
            "street": "Aschendorfer Weg 14",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1470-000",
            "name": "Privathof Göcking in Rheine (Nr.1470-000)",
            "street": "Osnabrücker Straße 359",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1471-000",
            "name": "Privatstall Plugge in Meschede (Nr.1471-000)",
            "street": "Hoppegarten 35",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1472-000",
            "name": "Hof Hannen in Wesel (Nr.1472-000)",
            "street": "Am Spyker 15",
            "house_number": "1",
            "zipcode": "46485",
            "city": "Wesel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1473-000",
            "name": "Privathof Kleine in Wetter (Nr.1473-000)",
            "street": "Albringhauser Straße 278",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1474-000",
            "name": "Brings in Korschenbroich (Nr.1474-000)",
            "street": "Jahnstraße 18",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1476-000",
            "name": "Reitsportzentrum Bremervörde  in Bremervörde (Nr.1476-000)",
            "street": "Stader Str. 98a",
            "house_number": "1",
            "zipcode": "27432",
            "city": "Bremervörde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1477-000",
            "name": "Reit- und Pensionsstall Ramcke in Hamburg (Nr.1477-000)",
            "street": "Schlankweg 30",
            "house_number": "1",
            "zipcode": "22587",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1478-000",
            "name": "Stall Klaus Reinacher in Rosendahl-Osterwick (Nr.1478-000)",
            "street": "Holtwicker Straße 56",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Osterwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1479-000",
            "name": "DBT GmbH in Korschenbroich (Nr.1479-000)",
            "street": "Glehner Heide 3",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1480-000",
            "name": "Reitschule Gut Spascher Sand in Wildeshausen (Nr.1480-000)",
            "street": "Spasche 1",
            "house_number": "1",
            "zipcode": "27793",
            "city": "Wildeshausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1481-000",
            "name": "Reitstall Strassburg / WICHTIG Anfahrtshilfe Lesen WICHTIG !!! 0174 1891243 anrufen in Goch (Nr.1481-000)",
            "street": "Gaesdoncker Str. 215",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1482-000",
            "name": "Ptivatstall Frank in Süsel (Nr.1482-000)",
            "street": "Neustädter Str. 33c",
            "house_number": "1",
            "zipcode": "23701",
            "city": "Süsel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1483-000",
            "name": "Privatstall Heinrich in Wardenburg (Nr.1483-000)",
            "street": "Moorweg 49",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1484-000",
            "name": "Ribbers in Neuenkirchen (Nr.1484-000)",
            "street": "Emsdettener Str 263",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1485-000",
            "name": "Privatstall Lippa in Nordenham (Nr.1485-000)",
            "street": "Abbehauser Wischweg 1a",
            "house_number": "1",
            "zipcode": "26954",
            "city": "Nordenham",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1486-000",
            "name": "Reiterhof Schulze Tenberge in Gronau (Nr.1486-000)",
            "street": "Gerdingseite 3",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1487-000",
            "name": "Privatstall Uekötter in Nottuln (Nr.1487-000)",
            "street": "Am Vogelbusch 17",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1488-000",
            "name": "Reitverein Niebüll in Niebüll (Nr.1488-000)",
            "street": "Gotteskoogstraße 62",
            "house_number": "1",
            "zipcode": "25899",
            "city": "Niebüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1489-000",
            "name": "Eichen-Hof Abbensen (Privat) in Wedemark (Nr.1489-000)",
            "street": "Alte Zollstraße 3",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1490-000",
            "name": "Aktivstall Brüning in Coesfeld (Nr.1490-000)",
            "street": "Stevede  72",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1491-000",
            "name": "Hof Fröhlich in Ladelund (Nr.1491-000)",
            "street": "Königsacker  9",
            "house_number": "1",
            "zipcode": "25926",
            "city": "Ladelund",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1492-000",
            "name": "Privatstall Meier in Bad Münder (Nr.1492-000)",
            "street": "Zum Wittkopfstein 1",
            "house_number": "1",
            "zipcode": "31848",
            "city": "Bad Münder",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1493-000",
            "name": "Stall Berndsmann in Dortmund (Nr.1493-000)",
            "street": "Persebeckerstrasse 1",
            "house_number": "1",
            "zipcode": "44227",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-SOE",
            "name": "Raiffeisen-Markt Soest in Soest (Nr.RM-SOE)",
            "street": "Nottebohmweg 17",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "1495-000",
            "name": "Stall Heimbach in Beringstedt (Nr.1495-000)",
            "street": "Aukamp 1",
            "house_number": "1",
            "zipcode": "25575",
            "city": "Beringstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1496-000",
            "name": "Stall Bentstreek  in Friedeburg (Nr.1496-000)",
            "street": "Flakstellungsweg  4",
            "house_number": "1",
            "zipcode": "26446",
            "city": "Friedeburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1497-000",
            "name": "Privatstall Schimmelpfennig in Telgte (Nr.1497-000)",
            "street": "Brink 28",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1498-000",
            "name": "Reitverein Tostedt in Tostedt (Nr.1498-000)",
            "street": "Alter Moorweg 10",
            "house_number": "1",
            "zipcode": "21255",
            "city": "Tostedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1499-000",
            "name": "Privatstall Peters in Lingen (Nr.1499-000)",
            "street": "Bruchstraße 15",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1500-000",
            "name": "Stall König in Ladbergen (Nr.1500-000)",
            "street": "Westerweg 130",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1501-000",
            "name": "Privatstall Brands in Leverkusen (Nr.1501-000)",
            "street": "Grunder Wiesen 18",
            "house_number": "1",
            "zipcode": "51381",
            "city": "Leverkusen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1502-000",
            "name": "Privatstall Harmeyer in Quendorf (Nr.1502-000)",
            "street": "Am Kapellenplatz 1",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Quendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1503-000",
            "name": "Wedig in Harsum (Nr.1503-000)",
            "street": "Am Thie 7",
            "house_number": "1",
            "zipcode": "31177",
            "city": "Harsum",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1504-000",
            "name": "JoKa Farm in Schwanewede (Nr.1504-000)",
            "street": "Lehmhorst 226a",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1505-000",
            "name": "Pferdezahnbehandlung Martin Hüpen  in Straelen (Nr.1505-000)",
            "street": "Op den tupp 6",
            "house_number": "1",
            "zipcode": "47638",
            "city": "Straelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1506-000",
            "name": "Privatstall Lammers in Rheine (Nr.1506-000)",
            "street": "Möllerhookstraße 11",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1507-000",
            "name": "Reitverein Visbek in Visbek (Nr.1507-000)",
            "street": "Schützenstraße 5",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbek",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1508-000",
            "name": "Reitstall Max Weber in Werne (Nr.1508-000)",
            "street": "Am Reiterhof 4",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1509-000",
            "name": "Reitstall Willy Vogel in Bielefeld (Nr.1509-000)",
            "street": "Senner Hellweg 138",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1510-000",
            "name": "Rockers Peerstall in Aurich (Nr.1510-000)",
            "street": "Holzweg 111",
            "house_number": "1",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1511-000",
            "name": "Islandpferde Gestüt Borgarstadur in Dülmen (Nr.1511-000)",
            "street": "Bauernschaft 190",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1512-000",
            "name": "Hof Wullenweber in Meschede (Nr.1512-000)",
            "street": "Enste 2",
            "house_number": "1",
            "zipcode": "49872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1513-000",
            "name": "Pferdepension am Abbabach in Menden (Nr.1513-000)",
            "street": "Am Abbabach 2",
            "house_number": "1",
            "zipcode": "58708",
            "city": "Menden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1514-000",
            "name": "Privatstall Kostka in Wermelskirchen (Nr.1514-000)",
            "street": "Eipringhausen  60",
            "house_number": "1",
            "zipcode": "42929",
            "city": "Wermelskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1515-000",
            "name": "Reitanlage zum Batz in Hanerau-Hademarschen (Nr.1515-000)",
            "street": "Batzer Weg 3",
            "house_number": "1",
            "zipcode": "25557",
            "city": "Hanerau-Hademarschen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1516-000",
            "name": "Privatstall Brüggemeier in Ibbenbüren (Nr.1516-000)",
            "street": "Haarweg 99",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1517-000",
            "name": "Doppe in Rietberg (Nr.1517-000)",
            "street": "Doppstaße 23",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1518-000",
            "name": "Hof Baden in Schneverdingen (Nr.1518-000)",
            "street": "Dorfstraße 61",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1519-000",
            "name": "Apfelhof Hördinghausen Fam. Borgmann in Bad Essen  (Nr.1519-000)",
            "street": "Hördinghauser Str. 22",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1520-000",
            "name": "Reitstall Wettmershagen in Calberlah (Nr.1520-000)",
            "street": "Höpenweg 6",
            "house_number": "1",
            "zipcode": "38547",
            "city": "Calberlah",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1521-000",
            "name": "Hof Grotwinkel in Kamp-Lintfort (Nr.1521-000)",
            "street": "Niephauser Str. 18",
            "house_number": "1",
            "zipcode": "47475",
            "city": "Kamp-Lintfort",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1522-000",
            "name": "Reitsportanlage Wietrehm in Wedemark (Nr.1522-000)",
            "street": "Fuhrberger Weg 14",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "RV-GL",
            "name": "Raiffeisen Vital Gleidorf in Schmallenberg-Gleidorf (Nr.RV-GL)",
            "street": "Kornhausstraße  11",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Gleidorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-EB",
            "name": "Raiffeisen Vital Ense-Bremen in Ense-Bremen (Nr.RV-EB)",
            "street": "Werler Straße 57",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense-Bremen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-HE",
            "name": "Raiffeisen Vital Herzfeld in Lippetal-Herzfeld (Nr.RV-HE)",
            "street": "Lippborger Straße 21",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal-Herzfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-RH",
            "name": "Raiffeisen Vital Rhynern in Hamm-Osttünnen (Nr.RV-RH)",
            "street": "Twärsweg 2",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm-Osttünnen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-UN",
            "name": "Raiffeisen Vital Unna in Unna (Nr.RV-UN)",
            "street": "Alfred-Nobel-Straße 19",
            "house_number": "1",
            "zipcode": "59423",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-WE",
            "name": "Raiffeisen Vital Werl in Werl (Nr.RV-WE)",
            "street": "Zur Mersch 14",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-BA",
            "name": "Raiffeisen Vital Balve in Balve (Nr.RV-BA)",
            "street": "An der Kormke 20-24",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "1523-000",
            "name": "Privatstall Burmann in Lippetal (Nr.1523-000)",
            "street": "Am Heitkamp 8",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1524-000",
            "name": "Reitverein Calle-Meschede in Meschede (Nr.1524-000)",
            "street": "An der Reithalle 1",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1525-000",
            "name": "RuVV am Hallohberg in Wiemersdorf (Nr.1525-000)",
            "street": "Grünplan 3",
            "house_number": "1",
            "zipcode": "24623",
            "city": "Wiemersdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1526-000",
            "name": "Privatstall Fröbel in Morsbach (Nr.1526-000)",
            "street": "Herbertshagen 2",
            "house_number": "1",
            "zipcode": "51597",
            "city": "Morsbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1527-000",
            "name": "Reit und Fahrverein Wickede-Asseln-Sölde in Dortmund (Nr.1527-000)",
            "street": "Eschenwaldstraß 45",
            "house_number": "1",
            "zipcode": "44319",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1528-000",
            "name": "Thomas Voss Reitanlage Höllnhof in Schülp bei Nortorf (Nr.1528-000)",
            "street": "Looper Weg 2",
            "house_number": "1",
            "zipcode": "24589",
            "city": "Schülp bei Nortorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1529-000",
            "name": "Privatstall Keuter in Papenburg (Nr.1529-000)",
            "street": "Zum Wehr 41",
            "house_number": "1",
            "zipcode": "26871",
            "city": "Papenburg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1530-000",
            "name": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1530-000)",
            "street": "Feldmarkstraße 180",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1531-000",
            "name": "Hof Große Hellmann in Senden (Nr.1531-000)",
            "street": "Brock 7",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1532-000",
            "name": "Privatstall Geuking in Coesfeld (Nr.1532-000)",
            "street": "Letter Berg 102",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1533-000",
            "name": "Hof Stoffers in Gelsenkirchen (Nr.1533-000)",
            "street": "Bußmannstrase 62a",
            "house_number": "1",
            "zipcode": "45896",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1534-000",
            "name": "Reitanlage M. Langer in Kamen (Nr.1534-000)",
            "street": "Zum Lüchting 1",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1535-000",
            "name": "Privatstall Schütte in Düsseldorf (Nr.1535-000)",
            "street": "Duisburger Landstraße 203",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1536-000",
            "name": "Privatstall Kirchner in Neustadt (Nr.1536-000)",
            "street": "Mandelsloher Str. 6",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1537-000",
            "name": "Privathof Pape in Delbrück (Nr.1537-000)",
            "street": "Neubrückstraße 10",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Delbrück",
            "collect_point": "nein"
        },
        {
            "ID": "1538-000",
            "name": "Outback Corona in Willich (Nr.1538-000)",
            "street": "Fonger 30",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1539-000",
            "name": "Gut Eulental Reitstall in Erkrath (Nr.1539-000)",
            "street": "Eulental 32",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1540-000",
            "name": "Privatstall Wade in Emmerthal (Nr.1540-000)",
            "street": "In der Meinte 9",
            "house_number": "1",
            "zipcode": "31860",
            "city": "Emmerthal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1541-000",
            "name": "Flüsterpferde in Stade (Nr.1541-000)",
            "street": "Götzdorfer Str 214",
            "house_number": "1",
            "zipcode": "21683",
            "city": "Stade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1542-000",
            "name": "Reitanlage Vibrans in Langelsheim (Nr.1542-000)",
            "street": "Unterdorf 5a",
            "house_number": "1",
            "zipcode": "38685",
            "city": "Langelsheim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1543-000",
            "name": "Reiterhof Jobmann in Hamburg (Nr.1543-000)",
            "street": "Neuländer Elbdeich 234",
            "house_number": "1",
            "zipcode": "21079",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1544-000",
            "name": "Islandpferdehof Vierhohen in Weddelbrook (Nr.1544-000)",
            "street": "Krücken 5",
            "house_number": "1",
            "zipcode": "24576",
            "city": "Weddelbrook",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1545-000",
            "name": "Privatstall Noack in Ennigerloh (Nr.1545-000)",
            "street": "Wessenhorst 32",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1546-000",
            "name": "Privatstall Petersen in Wohlde (Nr.1546-000)",
            "street": "Mittelstraße 14",
            "house_number": "1",
            "zipcode": "24899",
            "city": "Wohlde",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1547-000",
            "name": "Privatstall Blume in Wülfrath (Nr.1547-000)",
            "street": "Velberter Straße 36",
            "house_number": "1",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1548-000",
            "name": "Reitstall Lange in Rehburg-Loccum (Nr.1548-000)",
            "street": "Düsselburger Str. 70",
            "house_number": "1",
            "zipcode": "31547",
            "city": "Rehburg-Loccum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1549-000",
            "name": "Hof Röring in Ahaus (Nr.1549-000)",
            "street": "Barle 8",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1550-000",
            "name": "Privatstall Rorup Holsterbrink in Dülmen (Nr.1550-000)",
            "street": "Holsterbrink 22",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1551-000",
            "name": "Privatstall Rosenberger in Senden (Nr.1551-000)",
            "street": "Gettrup 14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1552-000",
            "name": "Steinhoff in Kerken (Nr.1552-000)",
            "street": "Dorfstr. 105",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1553-000",
            "name": "Reitanlage Braß - Gut Kückshausen in Dortmund (Nr.1553-000)",
            "street": "Syburgstr. 9",
            "house_number": "1",
            "zipcode": "44265",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1554-000",
            "name": "Reitstall Wilkens in Thedinghausen (Nr.1554-000)",
            "street": "Rieder Straße 81a",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1555-000",
            "name": "Privatstall Wendt in Willebadessen (Nr.1555-000)",
            "street": "Schönthal 3",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1556-000",
            "name": "Elsermann kamen Methler in Kamen (Nr.1556-000)",
            "street": "Hilsingstraße  22",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1557-000",
            "name": "Hof Bendel in Balve (Nr.1557-000)",
            "street": "Wocklum 3a",
            "house_number": "1",
            "zipcode": "48802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1558-000",
            "name": "Wellin in Herscheid (Nr.1558-000)",
            "street": "Wellin 6",
            "house_number": "1",
            "zipcode": "58859",
            "city": "Herscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1559-000",
            "name": "RC Senne e.V. Stukenbrock in Schloß-Holte Stuckenbrock (Nr.1559-000)",
            "street": "Flugplatzstr. 80",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß-Holte Stuckenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1560-000",
            "name": "Reitverein Oelde e.V. in Oelde (Nr.1560-000)",
            "street": "Am Ruthenfeld 40",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1561-000",
            "name": "Freizeitpferdehof Meier in Extertal (Nr.1561-000)",
            "street": "Schneppel  1",
            "house_number": "1",
            "zipcode": "32699",
            "city": "Extertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1562-000",
            "name": "Hof Wiesmann in Castrop Rauxel (Nr.1562-000)",
            "street": "Im Finkenbrink 33",
            "house_number": "1",
            "zipcode": "44581",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1563-000",
            "name": "Privatstall Appel in Leezdorf  (Nr.1563-000)",
            "street": "Heideweg 16",
            "house_number": "1",
            "zipcode": "26529",
            "city": "Leezdorf ",
            "state": "Niedersachesen",
            "collect_point": "nein"
        },
        {
            "ID": "1564-000",
            "name": "Niehues in Legden (Nr.1564-000)",
            "street": "Isingoort 63",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1565-000",
            "name": "Hof Lorenz in Loxstedt (Nr.1565-000)",
            "street": "Am Schafdamm 10",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1566-000",
            "name": "Freizeithof Mesterscheidt in Hemer (Nr.1566-000)",
            "street": "Mesterscheid 2",
            "house_number": "1",
            "zipcode": "58675",
            "city": "Hemer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1567-000",
            "name": "Hof Glüsing in Osterbruch  (Nr.1567-000)",
            "street": "Süderende  16",
            "house_number": "1",
            "zipcode": "21762",
            "city": "Osterbruch ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1568-000",
            "name": "Hof Krohn in Flintbek (Nr.1568-000)",
            "street": "Sörenberg  23",
            "house_number": "1",
            "zipcode": "24220",
            "city": "Flintbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1569-000",
            "name": "Gut Römerhof in Düsseldorf (Nr.1569-000)",
            "street": "am Schmidtberg 15",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1570-000",
            "name": "Stall Lohe in Ascheberg (Nr.1570-000)",
            "street": "Ostereckern 9",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1571-000",
            "name": "Stall Sältz in Bohmstedt (Nr.1571-000)",
            "street": "Sick 2",
            "house_number": "1",
            "zipcode": "25853",
            "city": "Bohmstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1572-000",
            "name": "Reitstall Fragen in Korschenbroich (Nr.1572-000)",
            "street": "Fragenhütte ",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1573-000",
            "name": "Gut Wylack in Wassenberg (Nr.1573-000)",
            "street": "Gut Wylack ",
            "house_number": "1",
            "zipcode": "41849",
            "city": "Wassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1574-000",
            "name": "Reiterhof Rüter in Wetzen (Nr.1574-000)",
            "street": "Dorfstraße 6",
            "house_number": "1",
            "zipcode": "21385",
            "city": "Wetzen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1575-000",
            "name": "Dammackerhof  in Sarstedt (Nr.1575-000)",
            "street": "Wenderter Str. 14",
            "house_number": "1",
            "zipcode": "31157",
            "city": "Sarstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1576-000",
            "name": "Reiterverein Sintfeld St. Martin Fürstenberg e.V. in Bad Wünnenberg (Nr.1576-000)",
            "street": "Grasweg 3",
            "house_number": "1",
            "zipcode": "33181",
            "city": "Bad Wünnenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1577-000",
            "name": "Privater Offenstall Luckhaus in Hamm (Nr.1577-000)",
            "street": "Soester Str. 407",
            "house_number": "1",
            "zipcode": "49199",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1578-000",
            "name": "Hof Heine in Drebber (Nr.1578-000)",
            "street": "Marienstraße  5",
            "house_number": "1",
            "zipcode": "49457",
            "city": "Drebber",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1579-000",
            "name": "Offenstall Grzesiek in Stelle (Nr.1579-000)",
            "street": "Fohrsfeld 7",
            "house_number": "1",
            "zipcode": "21435",
            "city": "Stelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1580-000",
            "name": "Hof Hünnekes in Niederkrüchten (Nr.1580-000)",
            "street": "Am Hügelhof 1",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1581-000",
            "name": "Reitstall Mateos in Bochum (Nr.1581-000)",
            "street": "An der Holtbrügge 25",
            "house_number": "1",
            "zipcode": "44795",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1582-000",
            "name": "Pferdepension Langenfeld in Hessisch Oldendorf (Nr.1582-000)",
            "street": "Pensionsstraße 2",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1583-000",
            "name": "Hof Heinrichs in Wegberg (Nr.1583-000)",
            "street": "In Ellinghoven 10",
            "house_number": "1",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1584-000",
            "name": "Einstellerhof Jessen in Oeversee  (Nr.1584-000)",
            "street": "Munkwolstruper Weg 35",
            "house_number": "1",
            "zipcode": "24988",
            "city": "Oeversee ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1585-000",
            "name": "Hof Geenen in Sprockhövel  (Nr.1585-000)",
            "street": "Heidestraße 26",
            "house_number": "1",
            "zipcode": "45549",
            "city": "Sprockhövel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1586-000",
            "name": "Reitstall am Himmelmoor GbR in Quickborn (Nr.1586-000)",
            "street": "Heinrich-Hertz-Str. 18",
            "house_number": "1",
            "zipcode": "25451",
            "city": "Quickborn",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1587-000",
            "name": "Carolin Thomsen Pferdestärken in Stoltebüll (Nr.1587-000)",
            "street": "Levshöh 1",
            "house_number": "1",
            "zipcode": "24409",
            "city": "Stoltebüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1588-000",
            "name": "Privatstall Kathmann  in Haren (Ems) (Nr.1588-000)",
            "street": "Ostereschweg 65",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren (Ems)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1589-000",
            "name": "Hof Reeger in Hagen (Nr.1589-000)",
            "street": "Niggenbölling  ",
            "house_number": "1",
            "zipcode": "58091",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1590-000",
            "name": "Hof Helbig-Baldt in Hamm (Nr.1590-000)",
            "street": "Im Nachtigallental 4",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1591-000",
            "name": "Reitanlage-Behrens in Soest (Nr.1591-000)",
            "street": "Wasserweg 17",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1592-000",
            "name": "Hörsters Farmer in Arnsberg (Nr.1592-000)",
            "street": "Im Schmiemketal 1",
            "house_number": "1",
            "zipcode": "59821",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1593-000",
            "name": "Stall Witte in Ovelgönne (Nr.1593-000)",
            "street": "Anton-Hullmann-Weg 2",
            "house_number": "1",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1594-000",
            "name": "Hof Laves in Einbeck (Nr.1594-000)",
            "street": "Clusweg 2",
            "house_number": "1",
            "zipcode": "37574",
            "city": "Einbeck",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1595-000",
            "name": "Ponyhof Rottmann in Hagen (Nr.1595-000)",
            "street": "Bergstr 12",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1596-000",
            "name": "Gestüt Brauershof in Geldern (Nr.1596-000)",
            "street": "An den Niersauen  42",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1597-000",
            "name": "Danielles Pferdehof in Kluse (Nr.1597-000)",
            "street": "Hauptstrasse 8",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Kluse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1598-000",
            "name": "Wuppertaler Ponyfreunde e.V. in Wuppertal (Nr.1598-000)",
            "street": "Sonnenblume 22",
            "house_number": "1",
            "zipcode": "42281",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1599-000",
            "name": "Hof Schnellenberg in Hörstel-Riesenbeck (Nr.1599-000)",
            "street": "Surenburg 4",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1600-000",
            "name": "Hof Müther in Rosendahl (Nr.1600-000)",
            "street": "Hermann-Löns-Weg 48",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1601-000",
            "name": "Reitstall Berenyi in Garbsen (Nr.1601-000)",
            "street": "Mühlenstraße  37",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1602-000",
            "name": "Hof Knop in Edemissen (Nr.1602-000)",
            "street": "Klein Blumenhagen 3",
            "house_number": "1",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1603-000",
            "name": "Pferdepension Jürgens in Dinslaken (Nr.1603-000)",
            "street": "Sterkraderstr  111",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1604-000",
            "name": "Reitstall Andree in Marsberg (Nr.1604-000)",
            "street": "Markeweg 9",
            "house_number": "1",
            "zipcode": "34431",
            "city": "Marsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1605-000",
            "name": "Hof Reismann in Ibbenbüren (Nr.1605-000)",
            "street": "Püsselbürener Damm 251",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1606-000",
            "name": "Vom Körfkens Hof  in Stadtlohn  (Nr.1606-000)",
            "street": "Schützenweg 144",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1607-000",
            "name": "Hof Tillmann in Geseke (Nr.1607-000)",
            "street": "Ziegelweg 2",
            "house_number": "1",
            "zipcode": "59590",
            "city": "Geseke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1608-000",
            "name": "Hof Weber in Bad Essen  (Nr.1608-000)",
            "street": "Am Bülten 1",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1609-000",
            "name": "Hof Thiel in Oer-Erkenschwick (Nr.1609-000)",
            "street": "Westfeldweg ",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1610-000",
            "name": "Privatstall Haus Alaquint in Mettmann (Nr.1610-000)",
            "street": "Hoppenhofweg 1",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1611-000",
            "name": "RV Langenhagen in Langenhagen (Nr.1611-000)",
            "street": "Walsroder Str 179",
            "house_number": "1",
            "zipcode": "30855",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1612-000",
            "name": "Feines Reiten in Varrel (Nr.1612-000)",
            "street": "Schäkeln 2",
            "house_number": "1",
            "zipcode": "27259",
            "city": "Varrel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1613-000",
            "name": "RV Winterberg in Winterberg (Nr.1613-000)",
            "street": "Am Postteich 7",
            "house_number": "1",
            "zipcode": "59955",
            "city": "Winterberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1614-000",
            "name": "Privatstall Benning in Coesfeld (Nr.1614-000)",
            "street": "Gaupel  36",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1615-000",
            "name": "RG Landgraben  in Schönkirchen  (Nr.1615-000)",
            "street": "Landgraben  73",
            "house_number": "1",
            "zipcode": "24232",
            "city": "Schönkirchen ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1616-000",
            "name": "Reitstall Riedel (Postversand) in Heiligengrabe OT Liebenthal (Nr.1616-000)",
            "street": "Liebenthaler Dorfstraße  16",
            "house_number": "1",
            "zipcode": "16909",
            "city": "Heiligengrabe OT Liebenthal",
            "state": "Brandenburg",
            "collect_point": "nein"
        },
        {
            "ID": "1617-000",
            "name": "Reiterverein Altes Amt Dielingen e.V  in Stemwede  (Nr.1617-000)",
            "street": "Zur Toppheide 9",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1618-000",
            "name": "Privat Köster in Veelen (Nr.1618-000)",
            "street": "Bischof-Averkamp-Straße 6",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Veelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1619-000",
            "name": "Hof Wallhorn in Duisburg (Nr.1619-000)",
            "street": "Stalbergstraße 29",
            "house_number": "1",
            "zipcode": "47167",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1620-000",
            "name": "Reitanlage Hofstedde in Datteln (Nr.1620-000)",
            "street": "Am Alten Busch 8 8",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1621-000",
            "name": "Hof Erich Robert in Altenberge (Nr.1621-000)",
            "street": "Hohenhorst  60",
            "house_number": "1",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1622-000",
            "name": "Hof Scheepker in Aurich (Nr.1622-000)",
            "street": "Heuweg 94",
            "house_number": "1",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1623-000",
            "name": "Pferdeland in Leichlingen (Nr.1623-000)",
            "street": "Zum Buschtor 3",
            "house_number": "1",
            "zipcode": "42799",
            "city": "Leichlingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1624-000",
            "name": "Hof Schlattmann in Neuenkirchen (Nr.1624-000)",
            "street": "Sutrum Harum 16",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1625-000",
            "name": "Reitanlage Wierling in Senden (Nr.1625-000)",
            "street": "Dorfbauernschaft 115",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1626-000",
            "name": "Reiterhof Nonte in Münster (Nr.1626-000)",
            "street": "Verth 66",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1627-000",
            "name": "Pferdepension Blomberg in Meinerzhagen Blomberg (Nr.1627-000)",
            "street": "Blomberg 1",
            "house_number": "1",
            "zipcode": "58540",
            "city": "Meinerzhagen Blomberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1628-000",
            "name": "Hof Kempken in Alpen (Nr.1628-000)",
            "street": "Mühlenweg 30",
            "house_number": "1",
            "zipcode": "46519",
            "city": "Alpen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1629-000",
            "name": "Hof van Bevern in Saerbeck (Nr.1629-000)",
            "street": "Sinningen  17",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1630-000",
            "name": "Hof Wentzlaff (Privat) in Schneverdingen (Nr.1630-000)",
            "street": "Lindenstraße  42",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1631-000",
            "name": "Stall Dieckmann in Bottrop Kirchhellen (Nr.1631-000)",
            "street": "Lohbraucksweg  6",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1632-000",
            "name": "Hohmannshof Spanier / Dols in Kerken (Nr.1632-000)",
            "street": "Kappelenweg 12",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1633-000",
            "name": "Privatstall Leeling in Mönchengladbach (Nr.1633-000)",
            "street": "Baueshütte 41",
            "house_number": "1",
            "zipcode": "41238",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1634-000",
            "name": "Hof Steinmetz in Zeven-Badenstedt (Nr.1634-000)",
            "street": "Ziegeleistr 14",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Zeven-Badenstedt",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1635-000",
            "name": "Privat Junge in Belm (Nr.1635-000)",
            "street": "Bröckerskamp 5",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1636-000",
            "name": "Hof Reul in Holle (Nr.1636-000)",
            "street": "Hainbergstraße 13a",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Holle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1637-000",
            "name": "Reitstall Gäher in Sassenberg (Nr.1637-000)",
            "street": "Steinkamps Heide 1",
            "house_number": "1",
            "zipcode": "48336",
            "city": "Sassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1638-000",
            "name": "Hof Zeletzki in Greven (Nr.1638-000)",
            "street": "Pentruper Str. 73",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1639-000",
            "name": "Bucks Stall  in Lehe (Nr.1639-000)",
            "street": "Flüte 7",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Lehe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1640-000",
            "name": "Equestrian Sports Wamers / Wamers Wamers GbR in Niederkrüchten (Nr.1640-000)",
            "street": "Erkelenzer Straße 71",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1641-000",
            "name": "Hof Predovic in Bünde (Nr.1641-000)",
            "street": "Südlengerstr. 157",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1642-000",
            "name": "Linßenhof in Rheurdt in Rheurdt (Nr.1642-000)",
            "street": "Hochend 138",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1643-000",
            "name": "Eumeshof Halle in Krefeld (Nr.1643-000)",
            "street": "Vorderorbroich 93",
            "house_number": "1",
            "zipcode": "47839 ",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1644-000",
            "name": "Stall Schütte in Meppen (Nr.1644-000)",
            "street": "Backemühle 2",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1645-000",
            "name": "Reiterhof Kreickmann in Ahlen (Nr.1645-000)",
            "street": "Im Oestricher Holt 100",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1646-000",
            "name": "Privatstall Elkar in Dorsten (Nr.1646-000)",
            "street": "Reiherstraße 33",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1647-000",
            "name": "Hof Veldmann in Laar (Nr.1647-000)",
            "street": "Veldgoorstr 2",
            "house_number": "1",
            "zipcode": "49824",
            "city": "Laar",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1648-000",
            "name": "Hof Gabriel in Schenefeld (Nr.1648-000)",
            "street": "Seggerweg 12",
            "house_number": "1",
            "zipcode": "25469",
            "city": "Schenefeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1649-000",
            "name": "Reitstall König in Herdecke (Nr.1649-000)",
            "street": "Im Bruch 11",
            "house_number": "1",
            "zipcode": "58313",
            "city": "Herdecke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1650-000",
            "name": "Hof Strunk in Bochum (Nr.1650-000)",
            "street": "Haarstr. 59",
            "house_number": "1",
            "zipcode": "44797",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1651-000",
            "name": "Hof Schmiemann  in Recke (Nr.1651-000)",
            "street": "Twenhusen 29",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1652-000",
            "name": "Hof Steffens in Schloß Holte-Stukenbrock (Nr.1652-000)",
            "street": "Römerstraße  3",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1653-000",
            "name": "Osterheidehof  in Borstel (Nr.1653-000)",
            "street": "An der Osterheide 34",
            "house_number": "1",
            "zipcode": "27246",
            "city": "Borstel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1654-000",
            "name": "Hof Becker in Hamm (Nr.1654-000)",
            "street": "Lippestraße 130",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1655-000",
            "name": "Hof Stein in Himmelpforten  (Nr.1655-000)",
            "street": "Ramels 2",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Himmelpforten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1656-000",
            "name": "Hof Rinklake in Bad Laer (Nr.1656-000)",
            "street": "Glaner Weg  8",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1657-000",
            "name": "Stall Güldner in Hopsten (Nr.1657-000)",
            "street": "Zum Wurftaubenstand  1",
            "house_number": "1",
            "zipcode": "48596",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1658-000",
            "name": "Hof Beckmeier in Horn-Bad Meinberg (Nr.1658-000)",
            "street": "Lakeweg 10",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn-Bad Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1659-000",
            "name": "Felix Kassen Westerntraining in Herne (Nr.1659-000)",
            "street": "Hofstr 42",
            "house_number": "1",
            "zipcode": "44651",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1660-000",
            "name": "Love and Trust Ranch in Datteln (Nr.1660-000)",
            "street": "Ahsener Allee  4",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1661-000",
            "name": "Paul Vocke Mesum in Rheine (Nr.1661-000)",
            "street": "Feuerstiege 33",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1662-000",
            "name": "Reit und Fahrverein Ostönnen in Soest (Nr.1662-000)",
            "street": "Werler Landstraße 301",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1663-000",
            "name": "Reit- u. Fahrverein in Neuenkirchen-Vörden (Nr.1663-000)",
            "street": "Brakenstraße 3",
            "house_number": "1",
            "zipcode": "49434",
            "city": "Neuenkirchen-Vörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1664-000",
            "name": "Privater Offenstall Freckmann in Lingen (Nr.1664-000)",
            "street": "Antoniusstraße/Ecke Deeringhook ",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1665-000",
            "name": "Theo Wulhorst in Waltrop (Nr.1665-000)",
            "street": "Unterlippe  3",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1666-000",
            "name": "Hof Rathjens in Horneburg (Nr.1666-000)",
            "street": "Moorstr. 18",
            "house_number": "1",
            "zipcode": "21640",
            "city": "Horneburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1667-000",
            "name": "Hof Vollenbroich in Erkelenz (Nr.1667-000)",
            "street": "Klosterstr. 19",
            "house_number": "1",
            "zipcode": "41812",
            "city": "Erkelenz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1668-000",
            "name": "Pferdehofliebe in Bad Bentheim (Nr.1668-000)",
            "street": "Isterberger Weg 5",
            "house_number": "1",
            "zipcode": "48455",
            "city": "Bad Bentheim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1669-000",
            "name": "Privatstall Metzger in Dülmen (Nr.1669-000)",
            "street": "Bauerschaft  122",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1670-000",
            "name": "Hof Thomsen in Poppenbüll (Nr.1670-000)",
            "street": "Achter de Kark 3",
            "house_number": "1",
            "zipcode": "25836",
            "city": "Poppenbüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1671-000",
            "name": "Aktiv- und Bewegungsstall Sievers in Syke  (Nr.1671-000)",
            "street": "Okeler Heide 8",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1672-000",
            "name": "Hof Oertker in Holdorf (Nr.1672-000)",
            "street": "Ihorst 3",
            "house_number": "1",
            "zipcode": "49451",
            "city": "Holdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1673-000",
            "name": "Privatstall Brosche in Münster (Nr.1673-000)",
            "street": "Hölkenbusch 200",
            "house_number": "1",
            "zipcode": "48161 ",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1674-000",
            "name": "Hof Kövener  in Ostbevern (Nr.1674-000)",
            "street": "Überwasser 7",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1675-000",
            "name": "Rehazentrum Eichenhof in Debstedterbüttel (Nr.1675-000)",
            "street": "Reiterweg  7",
            "house_number": "1",
            "zipcode": "27607",
            "city": "Debstedterbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1676-000",
            "name": "Privatstall Wöbken in Oldenburg (Nr.1676-000)",
            "street": "Geestkamp 29",
            "house_number": "1",
            "zipcode": "26125",
            "city": "Oldenburg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1677-000",
            "name": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1677-000)",
            "street": "Feldmarkstraße 180",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1678-000",
            "name": "Reiterhof Wekenborg in Meppen (Nr.1678-000)",
            "street": "Landwehr 80",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1679-000",
            "name": "RV Clarholz-Lette in Herzebrock-Clarholz (Nr.1679-000)",
            "street": "Langemersch 1",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1680-000",
            "name": "Hof Nagel in Hövelhof (Nr.1680-000)",
            "street": "Balkenweg 15",
            "house_number": "1",
            "zipcode": "33161",
            "city": "Hövelhof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1681-000",
            "name": "Eskingerhof  in Billerbeck  (Nr.1681-000)",
            "street": "Esking  41",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1682-000",
            "name": "Ostseeferien Evershof Halske in Lübeck (Nr.1682-000)",
            "street": "Kowitzberg 3",
            "house_number": "1",
            "zipcode": "23570",
            "city": "Lübeck",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1683-000",
            "name": "Reit- unf Fahrverein Emsbüren e.V. in Emsbüren (Nr.1683-000)",
            "street": "Hügeleschweg 5",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1684-000",
            "name": "Privatstall Schröder in Isernhagen (Nr.1684-000)",
            "street": "Dorfstr. 41",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1685-000",
            "name": "Privathof Biermeier  in Schloß Holte-Stukenbrock (Nr.1685-000)",
            "street": "Auf den Holen 1",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1686-000",
            "name": "Privatstall Wöbcke in Elskop (Nr.1686-000)",
            "street": "Dorfstraße 27",
            "house_number": "1",
            "zipcode": "25361",
            "city": "Elskop",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1687-000",
            "name": "Privatstall Gruhnert in Sundern (Nr.1687-000)",
            "street": "Illingheimer Str 3",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1688-000",
            "name": "Reitstall von Öhsen in Hagen im Bremischen (Nr.1688-000)",
            "street": "Wiesenstraße 4",
            "house_number": "1",
            "zipcode": "27628",
            "city": "Hagen im Bremischen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1689-000",
            "name": "Hof Teismann in Senden (Nr.1689-000)",
            "street": "Gettrup 30",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1690-000",
            "name": "Privatstall Haase in Twistringen (Nr.1690-000)",
            "street": "Am Brink 17",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1691-000",
            "name": "Privatstall Ehlting in Prinzhöfte (Nr.1691-000)",
            "street": "Hauptstraße 5",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Prinzhöfte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1692-000",
            "name": "Privatstall Stadler in Oerel (Nr.1692-000)",
            "street": "Sünderbeeksweg 9",
            "house_number": "1",
            "zipcode": "27432",
            "city": "Oerel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1693-000",
            "name": "Privatstall Geiger in Labenz (Nr.1693-000)",
            "street": "Steinhorster Straße 4",
            "house_number": "1",
            "zipcode": "23898",
            "city": "Labenz",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1694-000",
            "name": "Schulze Balhorn  in Sendenhorst (Nr.1694-000)",
            "street": "Bracht 18",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1695-000",
            "name": "Pivatstall Sevenich in Welver (Nr.1695-000)",
            "street": "Illinger Str. 38a",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1696-000",
            "name": "Büsgeshof in Ratingen  (Nr.1696-000)",
            "street": "Götschenbeck  1",
            "house_number": "1",
            "zipcode": "40883",
            "city": "Ratingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1697-000",
            "name": "Eggers in Kaiser-Wilhelm-Kroog (Nr.1697-000)",
            "street": "Norderstraße 2",
            "house_number": "1",
            "zipcode": "25709",
            "city": "Kaiser-Wilhelm-Kroog",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1698-000",
            "name": "Reitsportanlage Eichholz in Steinheim (Nr.1698-000)",
            "street": "Heinrich-Spier-Straße 32",
            "house_number": "1",
            "zipcode": "32839",
            "city": "Steinheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1699-000",
            "name": "Privatstall Wojewski in Rosendahl-Holtwick (Nr.1699-000)",
            "street": "Riege 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Holtwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1700-000",
            "name": "Reitverein Balve in Balve (Nr.1700-000)",
            "street": "Wocklum  9",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1701-000",
            "name": "Privatstall Schowwe in Osnabrück (Nr.1701-000)",
            "street": "Bauerschaft Hickingen 40",
            "house_number": "1",
            "zipcode": "49086",
            "city": "Osnabrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1702-000",
            "name": "Privatstall Weilinghoff in Heek (Nr.1702-000)",
            "street": "Ahle  117",
            "house_number": "1",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1703-000",
            "name": "Gut Ruhrfeld in Schwerte (Nr.1703-000)",
            "street": "Gut Ruhrfeld ",
            "house_number": "1",
            "zipcode": "58239",
            "city": "Schwerte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1704-000",
            "name": "RTG Berge Halver in Halver (Nr.1704-000)",
            "street": "Berge 3",
            "house_number": "1",
            "zipcode": "58553",
            "city": "Halver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1705-000",
            "name": "Pensionsstall Hüttmann in Essen (Nr.1705-000)",
            "street": "Donnerberg 92a",
            "house_number": "1",
            "zipcode": "45357",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1706-000",
            "name": "Hof Quast in Olpe (Nr.1706-000)",
            "street": "Fahlenscheid  3",
            "house_number": "1",
            "zipcode": "57462",
            "city": "Olpe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1707-000",
            "name": "Reit- und Fahrrverein Attendorn – Askay e.V. in Attendorn (Nr.1707-000)",
            "street": "Lamfertweg ",
            "house_number": "1",
            "zipcode": "57439",
            "city": "Attendorn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1708-000",
            "name": "Hof Wulf in Werl (Nr.1708-000)",
            "street": "Soester Str. 41",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1709-000",
            "name": "Zenshof in Bedburg (Nr.1709-000)",
            "street": "Friedensstraße  39",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1710-000",
            "name": "Hof Anumee Bendestorf  in Bendestorf  (Nr.1710-000)",
            "street": "Kleckerwaldstraße  39",
            "house_number": "1",
            "zipcode": "21227",
            "city": "Bendestorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1711-000",
            "name": "Privatstall Kooymans in Höxter (Nr.1711-000)",
            "street": "Wiesenstraße  30",
            "house_number": "1",
            "zipcode": "37671",
            "city": "Höxter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1712-000",
            "name": "Privatstall Schulz in Düdenbüttel (Nr.1712-000)",
            "street": "Weißenmoor 15",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Düdenbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1713-000",
            "name": "Privatstall Simon in Tating (Nr.1713-000)",
            "street": "Dorfstraße  1",
            "house_number": "1",
            "zipcode": "25881",
            "city": "Tating",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1714-000",
            "name": "Privatstall Dreger in Südheide / Hermannsburg (Nr.1714-000)",
            "street": "Hemmetworth  6",
            "house_number": "1",
            "zipcode": "29320",
            "city": "Südheide / Hermannsburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1715-000",
            "name": "Stall Stefan Heling in Ahaus (Nr.1715-000)",
            "street": "Averesch 18",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1716-000",
            "name": "Privatstall Schermbeck in Schermbeck (Nr.1716-000)",
            "street": "Zur Alten Lippe 22",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1717-000",
            "name": "Privatstall Stegemann in Coesfeld (Nr.1717-000)",
            "street": "Stripperhook 26",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1718-000",
            "name": "Hof Riedemann in Oerlinghausen (Nr.1718-000)",
            "street": "Oetenhauser Str. 43",
            "house_number": "1",
            "zipcode": "33813",
            "city": "Oerlinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1719-000",
            "name": "Laurienshof Christian Uelschen in Garbsen (Nr.1719-000)",
            "street": "Stöckener Str. 1",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1720-000",
            "name": "Privatadresse Basylec in Hohenwestedt (Nr.1720-000)",
            "street": "An der Kleinbahn 28",
            "house_number": "1",
            "zipcode": "24594",
            "city": "Hohenwestedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1721-000",
            "name": "Privatstall Büttner in Rees (Nr.1721-000)",
            "street": "Schledenhorst 1",
            "house_number": "1",
            "zipcode": "46459",
            "city": "Rees",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1722-000",
            "name": "Winkel in Blender (Nr.1722-000)",
            "street": "Winkel 5",
            "house_number": "1",
            "zipcode": "27337",
            "city": "Blender",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1723-000",
            "name": "Hof Funke in Wadersloh (Nr.1723-000)",
            "street": "Vahlhauser Weg 4",
            "house_number": "1",
            "zipcode": "49329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1724-000",
            "name": "Reitstall Wöllersberg in Wermelskirchen (Nr.1724-000)",
            "street": "Wöllersberg  2",
            "house_number": "1",
            "zipcode": "42929",
            "city": "Wermelskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1725-000",
            "name": "ZRFV Dorsten in Dorsten (Nr.1725-000)",
            "street": "Im Ovelgünne 16",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1726-000",
            "name": "Förderverein für Hippopädagogik & Reitsport e.V. Zeven in Zeven (Nr.1726-000)",
            "street": "Kirchhofsallee ",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Zeven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1727-000",
            "name": "Pferdestall Haskenau in Münster (Nr.1727-000)",
            "street": "Zur Haskenau 71",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1728-000",
            "name": "Christinenhof in Frechen (Nr.1728-000)",
            "street": "Freimersdorfer Weg 9",
            "house_number": "1",
            "zipcode": "50226",
            "city": "Frechen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1729-000",
            "name": "Reitclub Walle e.V. in Bremen (Nr.1729-000)",
            "street": "Mittelwischweg  1",
            "house_number": "1",
            "zipcode": "28237",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "1730-000",
            "name": "Hof Wente in Unna (Nr.1730-000)",
            "street": "Hinterstraße  1",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1731-000",
            "name": "TJ Quarter Horses in Emmerthal (Nr.1731-000)",
            "street": "Völkerhausen 5",
            "house_number": "1",
            "zipcode": "31860",
            "city": "Emmerthal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1732-000",
            "name": "Kruthoff  in Ahaus-Alstätte (Nr.1732-000)",
            "street": "Buurser Straße 85",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus-Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1733-000",
            "name": "Ritzenhof in Elsdorf (Nr.1733-000)",
            "street": "Hahnenstr. 65",
            "house_number": "1",
            "zipcode": "50189",
            "city": "Elsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1734-000",
            "name": "Privathof Frieling in Emsdetten (Nr.1734-000)",
            "street": "Westumer Landstr.  69",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1735-000",
            "name": "Privathof Voss in Heinsberg  (Nr.1735-000)",
            "street": "Rurstraße 7",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1736-000",
            "name": "Pferdepension Ellernhof in Springe (Nr.1736-000)",
            "street": "In der Ellern 2",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1737-000",
            "name": "Privatstall Heiduk in Hagen im Bremischen (Nr.1737-000)",
            "street": "Dorfhagener Allee 1",
            "house_number": "1",
            "zipcode": "27628",
            "city": "Hagen im Bremischen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1738-000",
            "name": "Privathof Ksinski in Verl (Nr.1738-000)",
            "street": "Binnerweg 55",
            "house_number": "1",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1739-000",
            "name": "Privathof Dercks in Geldern (Nr.1739-000)",
            "street": "Loerheideweg  21a",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1740-000",
            "name": "Sonnenhof Hofolpe in Kirchhundem (Nr.1740-000)",
            "street": "Saalweg  53",
            "house_number": "1",
            "zipcode": "57399",
            "city": "Kirchhundem",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1741-000",
            "name": "Privathof Wilk in Langenfeld (Nr.1741-000)",
            "street": "Rothenberger Str. 6",
            "house_number": "1",
            "zipcode": "40764",
            "city": "Langenfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1742-000",
            "name": "Hölzle in Jüchen (Nr.1742-000)",
            "street": "Dürselen 176",
            "house_number": "1",
            "zipcode": "41363",
            "city": "Jüchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1743-000",
            "name": "Privathof Schaper in Didderse (Nr.1743-000)",
            "street": "Celler Straße 1",
            "house_number": "1",
            "zipcode": "38530",
            "city": "Didderse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1744-000",
            "name": "RFV Steele-Horst in Essen (Nr.1744-000)",
            "street": "Schultenweg  98",
            "house_number": "1",
            "zipcode": "45279",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1745-000",
            "name": "Privatstall Werth in Soest (Nr.1745-000)",
            "street": "Bördenstraße 22",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1746-000",
            "name": "Global Dressage Horses in Wallenhorst (Nr.1746-000)",
            "street": "Im alten Dorf 13a",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Wallenhorst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1747-000",
            "name": "Privathof Haak in Westerkappeln (Nr.1747-000)",
            "street": "Wulverliet  2",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1748-000",
            "name": "Privatstall Rittmeyer in Jade (Nr.1748-000)",
            "street": "Oldenbroker Str. 5",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1749-000",
            "name": "Privatstall Victoria in Loxstedt (Nr.1749-000)",
            "street": "Frankensteiner Str. 4a",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1750-000",
            "name": "Reitstall Tidow  in Springe (Nr.1750-000)",
            "street": "Am Thie 25",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1751-000",
            "name": "Privatstall Funke in Sundern (Nr.1751-000)",
            "street": "Altenhellefelder Str. 1",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1752-000",
            "name": "Privatstall Knigge in Belm (Nr.1752-000)",
            "street": "Bergstraße 121",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1753-000",
            "name": "Reitstall Bröckmann in Bönen (Nr.1753-000)",
            "street": "Sinnerstraße  7",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1754-000",
            "name": "Hackmann's Biohof in Westerkappeln (Nr.1754-000)",
            "street": "Heerstr. 71",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1755-000",
            "name": "Hof Rolle in Meinerzhagen (Nr.1755-000)",
            "street": "Neuhohlinden 1",
            "house_number": "1",
            "zipcode": "58540",
            "city": "Meinerzhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1756-000",
            "name": "Privatstall Große Kleimann in Metelen (Nr.1756-000)",
            "street": "Samberg 35",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1757-000",
            "name": "Privatstall Steinberg in Meschede (Nr.1757-000)",
            "street": "Enste 5",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1758-000",
            "name": "Stall David in Heilshoop  in Zarpen (Nr.1758-000)",
            "street": "Hauptstraße 26",
            "house_number": "1",
            "zipcode": "23619",
            "city": "Zarpen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1759-000",
            "name": "Strohbücker in Coesfeld (Nr.1759-000)",
            "street": "Harle  48a",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1760-000",
            "name": "Reitstall Piel in Sibbesse (Nr.1760-000)",
            "street": "Westfelder Hauptstraße 35",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1761-000",
            "name": "Gestüt Ebbing in Kempen (Nr.1761-000)",
            "street": "Krefelder Weg 68",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1762-000",
            "name": "ZRFV Salzbergen in Salzbergen (Nr.1762-000)",
            "street": "Emsstraße 15",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1763-000",
            "name": "Pferdepension und Zuchtstall Lauer in Handewitt  (Nr.1763-000)",
            "street": "Ahnebylund 15",
            "house_number": "1",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1764-000",
            "name": "Reitstall Zimmermann in Uetze (Nr.1764-000)",
            "street": "Schwüblingserstr. 13",
            "house_number": "1",
            "zipcode": "31311",
            "city": "Uetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1765-000",
            "name": "Pferdehof Nobiskrug in Jever (Nr.1765-000)",
            "street": "Sandeler Mühlenweg  1-3",
            "house_number": "1",
            "zipcode": "26441",
            "city": "Jever",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1766-000",
            "name": "Krampitz in Pohle (Nr.1766-000)",
            "street": "Apelerner Straße 11",
            "house_number": "1",
            "zipcode": "31867",
            "city": "Pohle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1768-000",
            "name": "Ponyparadies Waltrop in Waltrop (Nr.1768-000)",
            "street": "Auf dem Heiken 28",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1769-000",
            "name": "Landgut Diepeschrath in Bergisch Gladbach (Nr.1769-000)",
            "street": "Diepeschrath  1",
            "house_number": "1",
            "zipcode": "51469",
            "city": "Bergisch Gladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1770-000",
            "name": "Bei Dornuf in Krefeld (Nr.1770-000)",
            "street": "Hökendyk 2",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1771-000",
            "name": "Privatstall Breuer in Schiphorst (Nr.1771-000)",
            "street": "Steinhorster Weg 5",
            "house_number": "1",
            "zipcode": "23847",
            "city": "Schiphorst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1772-000",
            "name": "Reitstall Erlenhagen  in Gummersbach (Nr.1772-000)",
            "street": "Wasserwerkstraße  5",
            "house_number": "1",
            "zipcode": "51647",
            "city": "Gummersbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1773-000",
            "name": "Privatstall Fiege in Velbert  (Nr.1773-000)",
            "street": "Asbachtal 6",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1774-000",
            "name": "Privathof Neumann in Reken  (Nr.1774-000)",
            "street": "Heltweg 18",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1775-000",
            "name": "Reitstall Dahlhoff  in Kempen (Nr.1775-000)",
            "street": "An der Gastendonk 25a",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1776-000",
            "name": "Privatstall Becker in Neuenkirchen-Vörden (Nr.1776-000)",
            "street": "Astrup  19",
            "house_number": "1",
            "zipcode": "49434",
            "city": "Neuenkirchen-Vörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1777-000",
            "name": "Voss in Lingen  (Nr.1777-000)",
            "street": "Bramharstr 5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1778-000",
            "name": "Hof Hansen in Duisburg  (Nr.1778-000)",
            "street": "Holtumer Mühlenweg  25",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1779-000",
            "name": "Pferdehof Sophie in Henstedt Ulzburg (Nr.1779-000)",
            "street": "Weedentwiete  ",
            "house_number": "1",
            "zipcode": "24558",
            "city": "Henstedt Ulzburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1780-000",
            "name": "Hofer Hof in Viersen (Nr.1780-000)",
            "street": "Amrather Weg 13",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1781-000",
            "name": "Eagle Free Ranch in Steyerberg (Nr.1781-000)",
            "street": "Deblinghausen  19",
            "house_number": "1",
            "zipcode": "31595",
            "city": "Steyerberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1782-000",
            "name": "Bockholtshoff  in Schneverdingen  (Nr.1782-000)",
            "street": "Pappelallee  5",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1783-000",
            "name": "HofLeben eV in Dahlenburg (Nr.1783-000)",
            "street": "Hauptstraße 1",
            "house_number": "1",
            "zipcode": "21368",
            "city": "Dahlenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1784-000",
            "name": "Privathof Böke in Porta Westfalica (Nr.1784-000)",
            "street": "Weserblick 17",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1785-000",
            "name": "Privatstall Büsing in Burgwedel (Nr.1785-000)",
            "street": "Dorfstraße 29",
            "house_number": "1",
            "zipcode": "30938",
            "city": "Burgwedel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1786-000",
            "name": "Privatstall Humpert in Hessisch Oldendorf (Nr.1786-000)",
            "street": "Teichstrasse  4",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1787-000",
            "name": "Privatstall Fey in Ochtrup (Nr.1787-000)",
            "street": "Spinnereistraße  5",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1788-000",
            "name": "Privatstall Rosenstengel in Neuenrade (Nr.1788-000)",
            "street": "Vorm Schorfe 1",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1789-000",
            "name": "Hof Klingeberg Burgstemmen  in Nordstemmen (Nr.1789-000)",
            "street": "Berkel 3",
            "house_number": "1",
            "zipcode": "31171",
            "city": "Nordstemmen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1790-000",
            "name": "Privathof Fleck in Lienen (Nr.1790-000)",
            "street": "Mühlenweg 2",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1791-000",
            "name": "RV Senden in Senden (Nr.1791-000)",
            "street": "Dorfbauernschaft 102b",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1792-000",
            "name": "Stall Hauptmeier in Wadersloh (Nr.1792-000)",
            "street": "Stromberger Str 62",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1793-000",
            "name": "Privathof Heinz in Hagen a.T.W. (Nr.1793-000)",
            "street": "Achter De Welt 2",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen a.T.W.",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1794-000",
            "name": "Privatstall Pleines in Delbrück (Nr.1794-000)",
            "street": "Lippstädter Str. 109",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1795-000",
            "name": "Privatstall Uphoff in Großheide (Nr.1795-000)",
            "street": "Südarlerlandstr. 24",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1796-000",
            "name": "Privathof Haerskötter in Emsdetten (Nr.1796-000)",
            "street": "Austum 26",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1797-000",
            "name": "Hof Große-Hartmann in Warendorf  (Nr.1797-000)",
            "street": "Vohren 7",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1798-000",
            "name": "RV Saerbeck in Saerbeck (Nr.1798-000)",
            "street": "Riesenbecker Straße 44",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1799-000",
            "name": "Pferdepension Ameln in Oberlangen (Nr.1799-000)",
            "street": "Marienstraße  13",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1800-000",
            "name": "Albers Rosenhof in Bispingen (Nr.1800-000)",
            "street": "Rosenhof 2",
            "house_number": "1",
            "zipcode": "29646",
            "city": "Bispingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1801-000",
            "name": "Freyer in Neetze/Neu-Neetze (Nr.1801-000)",
            "street": "Neu Süttorf 16",
            "house_number": "1",
            "zipcode": "21398",
            "city": "Neetze/Neu-Neetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1802-000",
            "name": "Privathof Renz in Weyhe (Nr.1802-000)",
            "street": "Heidstraße 53",
            "house_number": "1",
            "zipcode": "28844",
            "city": "Weyhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1803-000",
            "name": "Privathof Nimmert in Großenwörden (Nr.1803-000)",
            "street": "Seestraße  13",
            "house_number": "1",
            "zipcode": "21712",
            "city": "Großenwörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1804-000",
            "name": "Privatstall Trauzettel in Marl  (Nr.1804-000)",
            "street": "Herner Weg 20",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1805-000",
            "name": "Privathof Püschel in Verl (Nr.1805-000)",
            "street": "Holter Landstraße  81",
            "house_number": "1",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1806-000",
            "name": "Privatstall Lüthje in Hemmingen (Nr.1806-000)",
            "street": "Ostertorstraße  25a",
            "house_number": "1",
            "zipcode": "30966",
            "city": "Hemmingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1807-000",
            "name": "Privatstall Breiderhoff in Duisburg  (Nr.1807-000)",
            "street": "Orsoyer Str.  1",
            "house_number": "1",
            "zipcode": "47199",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1808-000",
            "name": "Silver Diamond Ranch in Velbert  (Nr.1808-000)",
            "street": "Wallmichrather Straße  26a",
            "house_number": "1",
            "zipcode": "42555",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1809-000",
            "name": "Kuhlmann in Gelsenkirchen (Nr.1809-000)",
            "street": "Böningstr. 153a",
            "house_number": "1",
            "zipcode": "45892",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1810-000",
            "name": "Privatstall Post in Twistringen (Nr.1810-000)",
            "street": "Zur Mühle 64",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1811-000",
            "name": "Privatstall Lutter in Vahlbruch (Nr.1811-000)",
            "street": "An der Kirche 8",
            "house_number": "1",
            "zipcode": "37647",
            "city": "Vahlbruch",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1812-000",
            "name": "Privatstsall Scheepers in Niederkrüchten (Nr.1812-000)",
            "street": "Erkelenzer Straße 69",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1813-000",
            "name": "Stall Nordmann in Saterland  (Nr.1813-000)",
            "street": "Vorm Moor 34",
            "house_number": "1",
            "zipcode": "26683",
            "city": "Saterland ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1814-000",
            "name": "Hof Isaak in Soest (Nr.1814-000)",
            "street": "Erzväterring  5",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1815-000",
            "name": "Hof Messing in Schöppingen (Nr.1815-000)",
            "street": "Heven 40",
            "house_number": "1",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1816-000",
            "name": "Reitstall Bega in Dörentrup (Nr.1816-000)",
            "street": "Sibbentruper Str. 12",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1817-000",
            "name": " Reitstall Claßen - Brachelen in Hückelhoven (Nr.1817-000)",
            "street": "Kahrweghof  1",
            "house_number": "1",
            "zipcode": "41836",
            "city": "Hückelhoven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1818-000",
            "name": "Stall Wollesen in Twedt (Nr.1818-000)",
            "street": "Kappelner Straße 6",
            "house_number": "1",
            "zipcode": "24894",
            "city": "Twedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1819-000",
            "name": "Privathof Wiefel in Greven  (Nr.1819-000)",
            "street": "Postdamm 30",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1820-000",
            "name": "Reiterhof Laubner in Gütersloh (Nr.1820-000)",
            "street": "Blankenhagener Weg 139",
            "house_number": "1",
            "zipcode": "22224",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1821-000",
            "name": "Privatstall Thomsen in Lindewitt (Nr.1821-000)",
            "street": "Süderreihe 3",
            "house_number": "1",
            "zipcode": "24969",
            "city": "Lindewitt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1822-000",
            "name": "Privatstall Schlecht in Unna (Nr.1822-000)",
            "street": "Zum Bröhl 1",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1823-000",
            "name": "Privatstall Meinhardt in Mönchengladbach (Nr.1823-000)",
            "street": "Großheide 248",
            "house_number": "1",
            "zipcode": "41063",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1824-000",
            "name": "Spiekerhof in Borgholzhausen (Nr.1824-000)",
            "street": "Wichlinghausen 11",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Borgholzhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1825-000",
            "name": "Birkenhof in Stapelfeld (Nr.1825-000)",
            "street": "Hauptstraße 5",
            "house_number": "1",
            "zipcode": "22145",
            "city": "Stapelfeld",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1826-000",
            "name": "Hof Löcke in Neuenkirchen (Nr.1826-000)",
            "street": "Landersum 13",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1827-000",
            "name": "Privathof Andersen in Silberstedt (Nr.1827-000)",
            "street": "Stapelholmer Weg 8",
            "house_number": "1",
            "zipcode": "24887",
            "city": "Silberstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1828-000",
            "name": "Bat Oak Ranch in Winsen OT Stedden (Nr.1828-000)",
            "street": "Zum Hahnenberg ",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen OT Stedden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1829-000",
            "name": "Sattelberatung & Mehr in Ratingen (Nr.1829-000)",
            "street": "August-Prell-Strasse 34",
            "house_number": "1",
            "zipcode": "40885",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1830-000",
            "name": "Privathof Eilers in Ostbevern  (Nr.1830-000)",
            "street": "Kattmannskamp  8",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1831-000",
            "name": "Privathof Tenhumberg in Horstmar (Nr.1831-000)",
            "street": "Haltern 60",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1832-000",
            "name": "Stall Schubert in Melle  (Nr.1832-000)",
            "street": "Brockmannsweg  8",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1833-000",
            "name": "Flothhof in Greven  (Nr.1833-000)",
            "street": "Flothdamm 6",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1834-000",
            "name": "Privathof Adrian in Welver  (Nr.1834-000)",
            "street": "Hammer Landstraße 4",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1835-000",
            "name": "Hof Wemmel in Leiferde (Nr.1835-000)",
            "street": "Glider Weg 78",
            "house_number": "1",
            "zipcode": "38542",
            "city": "Leiferde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1836-000",
            "name": "Privatstall Hesse in Kalkar (Nr.1836-000)",
            "street": "Hochstrasse  6a",
            "house_number": "1",
            "zipcode": "47546",
            "city": "Kalkar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1837-000",
            "name": "Peveling in Castrop-Rauxel (Nr.1837-000)",
            "street": "Kanalstraße 58",
            "house_number": "1",
            "zipcode": "44579",
            "city": "Castrop-Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1838-000",
            "name": "OS Sporthorses in Stadtlohn  (Nr.1838-000)",
            "street": "Am Esch 9",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1839-000",
            "name": "Privathof Wallrabenstein in Grube (Nr.1839-000)",
            "street": "Fährkamp 4",
            "house_number": "1",
            "zipcode": "23749",
            "city": "Grube",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1840-000",
            "name": "Planwagenfahrten Wendel  in Hamm  (Nr.1840-000)",
            "street": "Dortmunder Straße 269",
            "house_number": "1",
            "zipcode": "59077",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1841-000",
            "name": "Stall Schering in Petershagen (Nr.1841-000)",
            "street": "Mitteldorf 17",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1842-000",
            "name": "Privatstall Heil in Lindlar (Nr.1842-000)",
            "street": "Müllersommer 2",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1843-000",
            "name": "Privatstall Hanisch in Engden (Nr.1843-000)",
            "street": "Emsfort 8a",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Engden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1844-000",
            "name": "Wentholt in Südlohn (Nr.1844-000)",
            "street": "Tünte 3",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1845-000",
            "name": "Hof Efker in Lippetal (Nr.1845-000)",
            "street": "Heintroper Str 23",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1846-000",
            "name": "Fam. Assen in Vreden  (Nr.1846-000)",
            "street": "Nork 113",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1847-000",
            "name": "Hof Hesse in Binnen (Nr.1847-000)",
            "street": " Am Rohrbach 12",
            "house_number": "1",
            "zipcode": "31619",
            "city": "Binnen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1848-000",
            "name": "Stall Büter in Surwold (Nr.1848-000)",
            "street": "Hauptstraße  14",
            "house_number": "1",
            "zipcode": "26903",
            "city": "Surwold",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1849-000",
            "name": "Brinkerhook in  Ahaus- Alstätte (Nr.1849-000)",
            "street": "Brinkerhook  12",
            "house_number": "1",
            "zipcode": "48683",
            "city": " Ahaus- Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1850-000",
            "name": "De Paddloepers - Bewegungsstall Schnelle in Martfeld (Nr.1850-000)",
            "street": "Kiwitt  13",
            "house_number": "1",
            "zipcode": "27327",
            "city": "Martfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1851-000",
            "name": "Hof Geitmann in Iserlohn (Nr.1851-000)",
            "street": "Leckerhorstweg  22",
            "house_number": "1",
            "zipcode": "58642",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1852-000",
            "name": "Hof Liedke in Adelheidsdorf  (Nr.1852-000)",
            "street": "Kurfürstendamm 39",
            "house_number": "1",
            "zipcode": "29352",
            "city": "Adelheidsdorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1853-000",
            "name": "Hof Otten in Elsdorf (Nr.1853-000)",
            "street": "Ostestraße  10",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Elsdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1854-000",
            "name": "Hof Auetal in Barsbüttel (Nr.1854-000)",
            "street": "Bahnhofstraße  10",
            "house_number": "1",
            "zipcode": "22885",
            "city": "Barsbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1855-000",
            "name": "Privatstall van Bergerem in Goch (Nr.1855-000)",
            "street": "Boeckelterweg  425",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1856-000",
            "name": "RuFV Diek-Bassum in Bassum (Nr.1856-000)",
            "street": "Wiebusch 4a",
            "house_number": "1",
            "zipcode": "27211",
            "city": "Bassum",
            "state": "Niedersachsen ",
            "collect_point": "nein"
        },
        {
            "ID": "1857-000",
            "name": "Lindenhof in Düsseldorf (Nr.1857-000)",
            "street": "Pfaffenmühlenweg  8",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1858-000",
            "name": "Reitanlage am Brunnenhof in Schwelm (Nr.1858-000)",
            "street": "Am Brunnenhof 28",
            "house_number": "1",
            "zipcode": "58332",
            "city": "Schwelm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1859-000",
            "name": "Sander Westerkappeln/Seeste in Westerkappeln (Nr.1859-000)",
            "street": "Im Himmelreich 6",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1860-000",
            "name": "Reitstall Prigge in Beckdorf (Nr.1860-000)",
            "street": "Estetalstraße 10",
            "house_number": "1",
            "zipcode": "21643",
            "city": "Beckdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1861-000",
            "name": "Pferdehof Iried Weth in Lehrte (Nr.1861-000)",
            "street": "Hauptstraße  3",
            "house_number": "1",
            "zipcode": "31275",
            "city": "Lehrte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1862-000",
            "name": "Hof Schulze-Bisping in Werne (Nr.1862-000)",
            "street": "Im Nierfeld 5",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1863-000",
            "name": "Privat Küpper in Bedburg (Nr.1863-000)",
            "street": "Am Fließ 1",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1864-000",
            "name": "Linnhof in Osterrönfeld (Nr.1864-000)",
            "street": "Linnhof  1",
            "house_number": "1",
            "zipcode": "24783",
            "city": "Osterrönfeld",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1865-000",
            "name": "Hof Leisner in Seedorf (Nr.1865-000)",
            "street": "Seekathen 3a",
            "house_number": "1",
            "zipcode": "23823",
            "city": "Seedorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1866-000",
            "name": "Ketteltasche in Hattingen-Niederwenigern  (Nr.1866-000)",
            "street": "Ketteltasche 8",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen-Niederwenigern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1867-000",
            "name": "Pferdeinhalation-MK  in Iserlohn (Nr.1867-000)",
            "street": "Rombrockerstraße 10",
            "house_number": "1",
            "zipcode": "58640",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1868-000",
            "name": "Stall Ulmenhof in Krumstedt  (Nr.1868-000)",
            "street": "Dorfstraße 27",
            "house_number": "1",
            "zipcode": "25727",
            "city": "Krumstedt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1869-000",
            "name": "Reitstall Dassau in Dassendorf (Nr.1869-000)",
            "street": "Hauskoppel  3",
            "house_number": "1",
            "zipcode": "21521",
            "city": "Dassendorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1870-000",
            "name": "Hof Hoffmeister in Bockenem (Nr.1870-000)",
            "street": "Lange Straße  3",
            "house_number": "1",
            "zipcode": "31167",
            "city": "Bockenem",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1871-000",
            "name": "Pferdeparadies Bortfeld in Bortfeld (Nr.1871-000)",
            "street": "Lange Straße  33",
            "house_number": "1",
            "zipcode": "38176",
            "city": "Bortfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1872-000",
            "name": "Reitanlage Stapelskotten  in Münster (Nr.1872-000)",
            "street": "Am Mooresch  34",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1873-000",
            "name": "Reit- und Fahrverein Laer e.V. in Laer (Nr.1873-000)",
            "street": "Borgweg  1",
            "house_number": "1",
            "zipcode": "48366",
            "city": "Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1874-000",
            "name": "Hof Geiger in Aventoft  (Nr.1874-000)",
            "street": "Aventofter Landstraße 26",
            "house_number": "1",
            "zipcode": "25927",
            "city": "Aventoft ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1875-000",
            "name": "Hof Curth in Langerwehe  (Nr.1875-000)",
            "street": "B264  6",
            "house_number": "1",
            "zipcode": "52379",
            "city": "Langerwehe ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1876-000",
            "name": "Pferdeschutzhof Iserlohn in Iserlohn (Nr.1876-000)",
            "street": "Hegenscheider Str. 6",
            "house_number": "1",
            "zipcode": "58644",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1877-000",
            "name": "Hof Springhorn in Soltau (Nr.1877-000)",
            "street": "Frielingen  9",
            "house_number": "1",
            "zipcode": "29614",
            "city": "Soltau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1878-000",
            "name": "Hof Winter in Bohmte (Nr.1878-000)",
            "street": "Scheelenkamp 5",
            "house_number": "1",
            "zipcode": "49161",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1879-000",
            "name": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See in Haltern am See (Nr.1879-000)",
            "street": "Münsterstraße 163",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1880-000",
            "name": "Hof Bettler in Ladbergen (Nr.1880-000)",
            "street": "Münsterweg 39",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1881-000",
            "name": "Hof Mühlenbein in Soest (Nr.1881-000)",
            "street": "Lindenweg 41",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1882-000",
            "name": "Lautenhof in Willich (Nr.1882-000)",
            "street": "Wilhelm-Hörmes-Straße  33",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1883-000",
            "name": "Hof Tangen in Dörpen (Nr.1883-000)",
            "street": "Müll 265",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Dörpen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1884-000",
            "name": "Privathof Griese in Hamm  (Nr.1884-000)",
            "street": "Klostermühlenweg  38",
            "house_number": "1",
            "zipcode": "59075",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1885-000",
            "name": "Pohlmanns Hof  in Hanstedt (Nr.1885-000)",
            "street": "Rüstweg 3",
            "house_number": "1",
            "zipcode": "21271",
            "city": "Hanstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1886-000",
            "name": "Ponyhof Berksen in Welver  (Nr.1886-000)",
            "street": "Berksen  3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1887-000",
            "name": "Tackenhof in Dinslaken in Dinslaken (Nr.1887-000)",
            "street": "Holtener Straße 246",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1888-000",
            "name": "Parkpferde Höllinghofen  in Arnsberg (Nr.1888-000)",
            "street": "Höllinghofen  1",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1889-000",
            "name": "Stall Vlothoböumer in Herford (Nr.1889-000)",
            "street": "Vlothoer Straße 134",
            "house_number": "1",
            "zipcode": "32049",
            "city": "Herford",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1890-000",
            "name": "Reitstall Krüppel in Schwalmtal  (Nr.1890-000)",
            "street": "Hehler ",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1891-000",
            "name": "Eichenhof Werth  in Isselburg - Werth  (Nr.1891-000)",
            "street": "Zehntweg  2a",
            "house_number": "1",
            "zipcode": "46419",
            "city": "Isselburg - Werth ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1892-000",
            "name": "Privat Schäfer in Schloß Holte-Stukenbrock (Nr.1892-000)",
            "street": "Lindenstraße  29a",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1893-000",
            "name": "Privathof Ruhnau in Dortmund (Nr.1893-000)",
            "street": "Schiffhorst  130",
            "house_number": "1",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1894-000",
            "name": "Pferdeparadies Rötzinghofen in Burscheid (Nr.1894-000)",
            "street": "Rötzinghofen 24",
            "house_number": "1",
            "zipcode": "51399",
            "city": "Burscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1895-000",
            "name": "Hof Seidentopp in Salzgitter (Nr.1895-000)",
            "street": "Hohle Straße  18",
            "house_number": "1",
            "zipcode": "38239",
            "city": "Salzgitter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1896-000",
            "name": "Hof Hohenbrink in Warmsen (Nr.1896-000)",
            "street": "Heideweg 4",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1897-000",
            "name": "Hof Baum in Porta Westfalica (Nr.1897-000)",
            "street": "Schaumburger Straße 122",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1898-000",
            "name": "Hof Palatzky in Maasen (Nr.1898-000)",
            "street": "Huckestedt",
            "house_number": "10",
            "zipcode": "27249",
            "city": "Maasen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1899-000",
            "name": "Päpsen in Siedenburg (Nr.1899-000)",
            "street": "Päpsen",
            "zipcode": "27254",
            "city": "Siedenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1900-000",
            "name": "Firma Dallmeier in Bekmünde (Nr.1900-000)",
            "street": "Kaempeweg",
            "house_number": "10",
            "zipcode": "25524",
            "city": "Bekmünde",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1901-000",
            "name": "Waldorfkindergarten Glücksburg e.V. in Glücksburg (Nr.1901-000)",
            "street": "Uferstraße",
            "house_number": "2",
            "zipcode": "24960",
            "city": "Glücksburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1902-000",
            "name": "Hof Beckmann in Bülkau in Bülkau (Nr.1902-000)",
            "street": "Norderende ",
            "house_number": "19",
            "zipcode": "21782",
            "city": "Bülkau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-GI",
            "name": "Raiffeisen-Markt Gildehaus in Bad Bentheim-Gildehaus (Nr.RM-GI)",
            "street": "Ladestraße",
            "house_number": "3",
            "zipcode": "48455",
            "city": "Bad Bentheim-Gildehaus",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "RM-SCH",
            "name": "Raiffeisen-Markt Schüttorf in Schüttorf (Nr.RM-SCH)",
            "street": "Ohner Straße",
            "house_number": "24",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "1903-000",
            "name": "Islandpferdehof Das Vertherland in Münster (Nr.1903-000)",
            "street": "Lützowstraße ",
            "house_number": "243",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1904-000",
            "name": "Hof Henrichmann in Greven (Nr.1904-000)",
            "street": "Bockholter Ring",
            "house_number": "17",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1905-000",
            "name": "Pferdepension Hüdepohl in Bissendorf (Nr.1905-000)",
            "street": "Auf der Heide",
            "house_number": "8a",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1906-000",
            "name": "Stall Andrea Grundei in Böhmte (Nr.1906-000)",
            "street": "Zum Elzsteg ",
            "house_number": "10",
            "zipcode": "49163",
            "city": "Böhmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1907-000",
            "name": "Hof Kroes  in Emmerich  (Nr.1907-000)",
            "street": "Tichelkamp ",
            "zipcode": "46446",
            "city": "Emmerich ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1908-000",
            "name": "Hof Rudde in Gronau-Epe (Nr.1908-000)",
            "street": "Füchte",
            "house_number": "12",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1909-000",
            "name": "Hof Richter in Lastrup (Nr.1909-000)",
            "street": "Zur Heide",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1910-000",
            "name": "Hof Mißfeldt  in Tensbüttel-Röst (Nr.1910-000)",
            "street": "Redder ",
            "house_number": "3",
            "zipcode": "25767",
            "city": "Tensbüttel-Röst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1911-000",
            "name": "Hof Leifeld in Melle  (Nr.1911-000)",
            "street": "Zum Sportplatz",
            "house_number": "10",
            "zipcode": "49324",
            "city": "Melle ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1912-000",
            "name": "Hof Heiducoff in Steinhagen (Nr.1912-000)",
            "street": "Wallbrink",
            "house_number": "9",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1913-000",
            "name": "Hof Peolman in Ovelgönne (Nr.1913-000)",
            "street": "Winterbahn",
            "house_number": "84",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1914-000",
            "name": "Gestüt Lütt Beek in Tremsbüttel (Nr.1914-000)",
            "street": "Grünengrase",
            "house_number": "2",
            "zipcode": "22967",
            "city": "Tremsbüttel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1915-000",
            "name": "Privatstall Erdmenger in Niederlangen (Nr.1915-000)",
            "street": "Haferkampstraße",
            "house_number": "8",
            "zipcode": "49779",
            "city": "Niederlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1916-000",
            "name": "Hof Ueffing in Neuenkirchen (Nr.1916-000)",
            "street": "Sutrum Harum",
            "house_number": "9",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1917-000",
            "name": "Privatstall Quappen in Sögel (Nr.1917-000)",
            "street": "Industriestr.",
            "house_number": "6",
            "zipcode": "49751",
            "city": "Sögel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1918-000",
            "name": "Hof Tenne in Dülmen (Nr.1918-000)",
            "street": "Bauernschaft",
            "house_number": "42",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1919-000",
            "name": "Hof Lüke in Welver Blumroth (Nr.1919-000)",
            "street": "Blumrother Straße",
            "house_number": "2",
            "zipcode": "59514",
            "city": "Welver Blumroth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1920-000",
            "name": "Privatstall Weber Langen in Langen (Nr.1920-000)",
            "street": "Am Esch",
            "house_number": "4",
            "zipcode": "49838",
            "city": "Langen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1921-000",
            "name": "Hof Wulfsdorf in Probsteierhagen  (Nr.1921-000)",
            "street": "Hof Wulfsdorf",
            "house_number": "11",
            "zipcode": "24253",
            "city": "Probsteierhagen ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1922-000",
            "name": "Hof Meyer in Hamburg (Nr.1922-000)",
            "street": "Moorfleeter Deich",
            "house_number": "383",
            "zipcode": "22113",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1923-000",
            "name": "Hof Tobaben in Ahlerstedt (Nr.1923-000)",
            "street": "Mühlendamm",
            "house_number": "14",
            "zipcode": "21702",
            "city": "Ahlerstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1924-000",
            "name": "Hof Niederquell in Ehndorf (Nr.1924-000)",
            "street": "Hochmoor",
            "house_number": "2",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1925-000",
            "name": "Privathof Horlamus in Hasbergen (Nr.1925-000)",
            "street": "Osnabrücker Straße",
            "house_number": "25",
            "zipcode": "49205",
            "city": "Hasbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-EL",
            "name": "Raiffeisen-Markt Emsbüren-Leschede in Emsbüren (Nr.RM-EL)",
            "street": "Bahnhofstraße ",
            "house_number": "73",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "1926-000",
            "name": "Privathof Wiltfang in Ganderkesee  (Nr.1926-000)",
            "street": "Kehnmoorweg ",
            "house_number": "30",
            "zipcode": "27777",
            "city": "Ganderkesee ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1927-000",
            "name": "Privathof Moldenhauer in Steinfurt (Nr.1927-000)",
            "street": "Hollich",
            "house_number": "78",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1928-000",
            "name": "Reiterhof kleine Mücke in Aurich (Nr.1928-000)",
            "street": "Stiekelriegweg",
            "house_number": "23",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1929-000",
            "name": "Privathof Koch in Spelle (Nr.1929-000)",
            "street": "Wällkenstraße",
            "house_number": "59",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1930-000",
            "name": "Privathof Hornbostel in Hambühren (Nr.1930-000)",
            "street": "Oheweg",
            "house_number": "3",
            "zipcode": "29313",
            "city": "Hambühren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1931-000",
            "name": "Privathof Bushe in Vaale (Nr.1931-000)",
            "street": "Mühlenweg",
            "house_number": "7B",
            "zipcode": "25594",
            "city": "Vaale",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1932-000",
            "name": "Privathof Weies in Krefeld (Nr.1932-000)",
            "street": "Hauptstraße",
            "house_number": "356",
            "zipcode": "47809",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1933-000",
            "name": "Privathof Baé in Neuenkirchen (Nr.1933-000)",
            "street": "Herteler Straße",
            "house_number": "24",
            "zipcode": "29643",
            "city": "Neuenkirchen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1934-000",
            "name": "Pferdepension Lück in Schwarme (Nr.1934-000)",
            "street": "Beppener Straße",
            "house_number": "14",
            "zipcode": "27327",
            "city": "Schwarme",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1935-000",
            "name": "Privathof Feddersen in Simonsberg (Nr.1935-000)",
            "street": "Hauptstraße",
            "house_number": "9",
            "zipcode": "25813",
            "city": "Simonsberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1936-000",
            "name": "Hof Marth in Spangenberg (Nr.1936-000)",
            "street": "Schulstraße",
            "house_number": "8",
            "zipcode": "34286",
            "city": "Spangenberg",
            "state": "Hessen",
            "collect_point": "nein"
        },
        {
            "ID": "1937-000",
            "name": "Privathof Ammerland in Wiefelstede (Nr.1937-000)",
            "street": "Wiefelsteder Straße",
            "house_number": "41",
            "zipcode": "26215",
            "city": "Wiefelstede",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1938-000",
            "name": "Pferdepension Giebel in Lamstedt (Nr.1938-000)",
            "street": "Ehlanddamm",
            "house_number": "3",
            "zipcode": "21769",
            "city": "Lamstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1939-000",
            "name": "Privathof Slotala in Reichshof (Nr.1939-000)",
            "street": "Am Nussbaum",
            "house_number": "7",
            "zipcode": "51580",
            "city": "Reichshof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1940-000",
            "name": "Privathof Freytag in Gehrde (Nr.1940-000)",
            "street": "Neuenkirchener Straße ",
            "house_number": "15",
            "zipcode": "49596",
            "city": "Gehrde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1941-000",
            "name": "Privathof Quandt in Otter (Nr.1941-000)",
            "street": "Weller Straße",
            "house_number": "40",
            "zipcode": "21259",
            "city": "Otter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1942-000",
            "name": "Privathof Kahlert in Schalksmühle (Nr.1942-000)",
            "street": "Muhle ",
            "house_number": "13",
            "zipcode": "58579",
            "city": "Schalksmühle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1943-000",
            "name": "Privat Freiburg in Verl (Nr.1943-000)",
            "street": "Teutoburger Straße",
            "house_number": "53",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1944-000",
            "name": "TuS Gahlen / Hildebrandt  in Schermbeck (Nr.1944-000)",
            "street": "Im Aap",
            "house_number": "53",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1945-000",
            "name": "Privathof Pattberg in Jagel (Nr.1945-000)",
            "street": "Eichenweg",
            "house_number": "2",
            "zipcode": "24878",
            "city": "Jagel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1946-000",
            "name": "Schleinershof in Havixbeck (Nr.1946-000)",
            "street": "Herkentrup",
            "house_number": "6",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1947-000",
            "name": "Privatstall Jiske in Groß Rheide (Nr.1947-000)",
            "street": "Wieder Weg",
            "house_number": "7c",
            "zipcode": "24872",
            "city": "Groß Rheide",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1948-000",
            "name": "Power of Iceland in Neuenkirchen (Nr.1948-000)",
            "street": "Herteler Straße",
            "house_number": "24",
            "zipcode": "29643",
            "city": "Neuenkirchen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1949-000",
            "name": "Thomashof in Schneverdingen/Wessloh (Nr.1949-000)",
            "street": "Maatheide",
            "house_number": "10",
            "zipcode": "29640",
            "city": "Schneverdingen/Wessloh",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1950-000",
            "name": "Privathof Froese in Ostercappeln (Nr.1950-000)",
            "street": "Mönkehöfener Straße",
            "house_number": "15",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1951-000",
            "name": "Privathof Wiechert in Holste (Nr.1951-000)",
            "street": "Stedener Str.",
            "house_number": "12",
            "zipcode": "27729",
            "city": "Holste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1952-000",
            "name": "Privathof Reineke in Steinfeld (Nr.1952-000)",
            "street": "Holdorfer Str.",
            "house_number": "4",
            "zipcode": "49439",
            "city": "Steinfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1953-000",
            "name": "Reit- und Ponyhof Liesen in Dinslaken (Nr.1953-000)",
            "street": "Lingelmannstr.",
            "house_number": "171",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1954-000",
            "name": "Privathof Warneke in Varrel (Nr.1954-000)",
            "street": "Dörrieloh ",
            "house_number": "12",
            "zipcode": "27259",
            "city": "Varrel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1955-000",
            "name": "Tierheilpraxis Behrens in Sassenburg (Nr.1955-000)",
            "street": "Dorfstr.",
            "house_number": "159",
            "zipcode": "38524",
            "city": "Sassenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1956-000",
            "name": "Privatstall Pfennig in Voerde (Nr.1956-000)",
            "street": "Mehrumer Str.",
            "house_number": "86",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1957-000",
            "name": "Privatstall Winterhoff in Faßberg (Nr.1957-000)",
            "street": "Im Mittelstendorf",
            "house_number": "56",
            "zipcode": "29328",
            "city": "Faßberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1958-000",
            "name": "Privatstall Henck in Seedorf (Nr.1958-000)",
            "street": "Kukuk ",
            "house_number": "8",
            "zipcode": "23823",
            "city": "Seedorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1959-000",
            "name": "Gestüt Papenhorst in Edemissen (Nr.1959-000)",
            "street": "Papenhorst",
            "house_number": "2",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1960-000",
            "name": "Reitstall Grimm in Hamburg (Nr.1960-000)",
            "street": "Bremer Str.",
            "house_number": "391",
            "zipcode": "21077",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1961-000",
            "name": "Privathof Böttcher in Billerbeck  (Nr.1961-000)",
            "street": "Gantweg",
            "house_number": "27",
            "zipcode": "483727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1962-000",
            "name": "Gut Großeforst in Düsseldorf (Nr.1962-000)",
            "street": "Forster Weg",
            "house_number": "46",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1963-000",
            "name": "Privathof Plett in Vollstedt (Nr.1963-000)",
            "street": "Ole Landstraat",
            "house_number": "3",
            "zipcode": "25821",
            "city": "Vollstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1964-000",
            "name": "Privathof Schaffer in Handewitt  (Nr.1964-000)",
            "street": "Lecker Chaussee ",
            "house_number": "46",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1965-000",
            "name": "Wittes Reitanlage in Riede (Nr.1965-000)",
            "street": "Thedinghauser Str.",
            "house_number": "49",
            "zipcode": "27339",
            "city": "Riede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1966-000",
            "name": "Hof Niekamp in Berne (Nr.1966-000)",
            "street": "Lechterstr.",
            "house_number": "178",
            "zipcode": "27804",
            "city": "Berne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1967-000",
            "name": "VRZ Schöppingen  in Schöppingen (Nr.1967-000)",
            "street": "Heven",
            "house_number": "74",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1968-000",
            "name": "Mindener Pferdezucht Reit und Fahrverein e.V. in Minden (Nr.1968-000)",
            "street": "Mitteldamm",
            "house_number": "80",
            "zipcode": "32427",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1969-000",
            "name": "Privatstall Kruth in Lähden (Nr.1969-000)",
            "street": "Berßener Straße",
            "house_number": "48",
            "zipcode": "49774",
            "city": "Lähden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1970-000",
            "name": "Privatstall Pottmeyer in Saerbeck (Nr.1970-000)",
            "street": "Westladbergen ",
            "house_number": "112",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1971-000",
            "name": "Privatstall Kruse in Warder (Nr.1971-000)",
            "street": "Hauptstr.",
            "house_number": "1",
            "zipcode": "24646",
            "city": "Warder",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1972-000",
            "name": "Reitanlage Stoerblick in Arpsdorf (Nr.1972-000)",
            "street": "Dorfstraße",
            "house_number": "38",
            "zipcode": "24634",
            "city": "Arpsdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1973-000",
            "name": "Privathof Lorenz in Jesteburg (Nr.1973-000)",
            "street": "Pferdeweg",
            "house_number": "41",
            "zipcode": "21266",
            "city": "Jesteburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1974-000",
            "name": "Privathof Driehorst in Büren (Nr.1974-000)",
            "street": "Sehrweg",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1975-000",
            "name": "Therapiehof Immenstedt in Immenstedt (Nr.1975-000)",
            "street": "Hauptstraße",
            "house_number": "5",
            "zipcode": "25767",
            "city": "Immenstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1976-000",
            "name": "Hof Hobbeling in Everswinkel (Nr.1976-000)",
            "street": "Schulter ",
            "house_number": "20",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1977-000",
            "name": "Hof Kamps in Cuxhaven (Nr.1977-000)",
            "street": "Abschnede",
            "house_number": "179",
            "zipcode": "27472",
            "city": "Cuxhaven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1978-000",
            "name": "Hof Rentrop in Werdohl (Nr.1978-000)",
            "street": "Rentrop",
            "house_number": "3",
            "zipcode": "58791",
            "city": "Werdohl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1979-000",
            "name": "Privathof Hansen in Mittelangeln (Nr.1979-000)",
            "street": "Kirchenholz",
            "house_number": "6",
            "zipcode": "24986",
            "city": "Mittelangeln",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1980-000",
            "name": "Privathof Golz in Meerbusch (Nr.1980-000)",
            "street": "Am oberen Feld",
            "house_number": "67",
            "zipcode": "47809",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1981-000",
            "name": "Stall Schnackenberg in Worpswede (Nr.1981-000)",
            "street": "Ostersoder Straße",
            "house_number": "19",
            "zipcode": "27726",
            "city": "Worpswede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1982-000",
            "name": "Privathof Deparade in Issum (Nr.1982-000)",
            "street": "Weseler Straße",
            "house_number": "247",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1983-000",
            "name": "Privathof Rulfs in Winsen (Nr.1983-000)",
            "street": "Hoopter Straße",
            "house_number": "189",
            "zipcode": "21423",
            "city": "Winsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1984-000",
            "name": "Privathof Petra Vogel in Wenzendorf (Nr.1984-000)",
            "street": "Am Schulberg",
            "house_number": "7",
            "zipcode": "21279",
            "city": "Wenzendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1985-000",
            "name": "Privathof Muno in Jüchen (Nr.1985-000)",
            "street": "Hensenhof",
            "house_number": "1",
            "zipcode": "41363",
            "city": "Jüchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1986-000",
            "name": "Hof Arenskötter in Greven (Nr.1986-000)",
            "street": "Fuestruper Straße",
            "house_number": "81",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1987-000",
            "name": "Reitanlage Selter in Dortmund (Nr.1987-000)",
            "street": "Wulfskamp ",
            "house_number": "194",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1988-000",
            "name": "Privathof Hein in Edemissen (Nr.1988-000)",
            "street": "Tiefe Straße",
            "house_number": "11",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1989-000",
            "name": "Privathof Teichmann in Rabenkirchen- Faulück (Nr.1989-000)",
            "street": "Rabenkirchenholz ",
            "house_number": "20",
            "zipcode": "24407",
            "city": "Rabenkirchen- Faulück",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1990-000",
            "name": "Privathof Vogel in Recklinghausen (Nr.1990-000)",
            "street": "Reiffstraße",
            "house_number": "43",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1991-000",
            "name": "Stallgemeinschaft Gut Holthausen in Büren (Nr.1991-000)",
            "street": "Brilonerstraße",
            "house_number": "80",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1992-000",
            "name": "Reiterhof Merreter in Mönchengladbach (Nr.1992-000)",
            "street": "Merreter",
            "house_number": "11",
            "zipcode": "41179",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1993-000",
            "name": "Privathof Feldt in Lingen  (Nr.1993-000)",
            "street": "Unter den Eichen",
            "house_number": "1",
            "zipcode": "49809",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1994-000",
            "name": "AS Trainings und Ausbildungsstall  in Hamm  (Nr.1994-000)",
            "street": "Alte Freisker Str.",
            "house_number": "14",
            "zipcode": "59069",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1995-000",
            "name": "Offenstall Diana in Burgdorf (Nr.1995-000)",
            "street": "Schwarzer Berg",
            "house_number": "6",
            "zipcode": "31303",
            "city": "Burgdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1996-000",
            "name": "Privathof Karlovits in Rötgesbüttel  (Nr.1996-000)",
            "street": "Altes Hohes Feld",
            "house_number": "4",
            "zipcode": "38518",
            "city": "Rötgesbüttel ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1997-000",
            "name": "Reitstall Gut Haus Mahnert in Erkrath (Nr.1997-000)",
            "street": "Mahnert",
            "house_number": "7",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1998-000",
            "name": "Westernplaats  in Norden (Nr.1998-000)",
            "street": "Polderweg ",
            "house_number": "1a",
            "zipcode": "26506",
            "city": "Norden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1999-000",
            "name": "Reitstall Todenmann in Rinteln (Nr.1999-000)",
            "street": "Hauptstraße",
            "house_number": "34",
            "zipcode": "31737",
            "city": "Rinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2000-000",
            "name": "Privathof Vogl in Achtrup (Nr.2000-000)",
            "street": "Tweng",
            "house_number": "22",
            "zipcode": "25917",
            "city": "Achtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2001-000",
            "name": "Privathof Schrader in Ibbenbüren (Nr.2001-000)",
            "street": "Am Berg",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2002-000",
            "name": "Privathof Wiederspahn in Schwarmstedt (Nr.2002-000)",
            "street": "Am Hohen Ufer",
            "house_number": "6",
            "zipcode": "29690",
            "city": "Schwarmstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2003-000",
            "name": "Privathof Hoffmann in Haaßel (Nr.2003-000)",
            "street": "Zur Sandkuhle",
            "house_number": "1",
            "zipcode": "27446",
            "city": "Haaßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2004-000",
            "name": "Rubinhof in Schafstedt (Nr.2004-000)",
            "street": "Nordholz",
            "house_number": "6",
            "zipcode": "25725",
            "city": "Schafstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2005-000",
            "name": "Hof Hagedorn in Glandorf (Nr.2005-000)",
            "street": "Kattenvennerstraße",
            "house_number": "37",
            "zipcode": "49219",
            "city": "Glandorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2006-000",
            "name": "Privathof Haschmann in Lüdinghausen (Nr.2006-000)",
            "street": "Ondrup",
            "house_number": "30",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2007-000",
            "name": "Privathof Heiderhoff in Mettmann (Nr.2007-000)",
            "street": "Außenbürgerschaft",
            "house_number": "7",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2008-000",
            "name": "Privathof Sturm in Otter (Nr.2008-000)",
            "street": "Dorfstraße",
            "house_number": "13",
            "zipcode": "21259",
            "city": "Otter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2009-000",
            "name": "Privathof Köhler in Bötersen (Nr.2009-000)",
            "street": "Höperhöfen",
            "house_number": "7",
            "zipcode": "27367",
            "city": "Bötersen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2010-000",
            "name": "Reitverein Coldewey in Sulingen (Nr.2010-000)",
            "street": "Coldewey",
            "house_number": "1",
            "zipcode": "27232",
            "city": "Sulingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2011-000",
            "name": "Reiterhof Groß Parin in Bad Schwartau (Nr.2011-000)",
            "street": "Groß Parin",
            "house_number": "35",
            "zipcode": "23611",
            "city": "Bad Schwartau",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2012-000",
            "name": "Hermann Gösmeier in Marl (Nr.2012-000)",
            "street": "Obersinsener Straße",
            "house_number": "74",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2013-000",
            "name": "Sternenhof in Wingst (Nr.2013-000)",
            "street": "Bargkampsweg",
            "house_number": "40",
            "zipcode": "21789",
            "city": "Wingst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2014-000",
            "name": "Privathof Bachmann in Salzhausen (Nr.2014-000)",
            "street": "Bruchweg",
            "house_number": "1",
            "zipcode": "21376",
            "city": "Salzhausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2015-000",
            "name": "Ferienhod Steinbruch in Wietzendorf (Nr.2015-000)",
            "street": "Steinbruch",
            "house_number": "81",
            "zipcode": "29649",
            "city": "Wietzendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2016-000",
            "name": "Privathof Sander in Rahden (Nr.2016-000)",
            "street": "Varler Straße",
            "house_number": "43",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2017-000",
            "name": "Hengststation Beckmann in Wettringen (Nr.2017-000)",
            "street": "Aabauerschaft",
            "house_number": "15",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2018-000",
            "name": "Privathof Eilers in Hesel (Nr.2018-000)",
            "street": "Kirchstraße",
            "house_number": "79",
            "zipcode": "26835",
            "city": "Hesel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2019-000",
            "name": "Privathof Hopmann in Handrup (Nr.2019-000)",
            "street": "Am Enekamp",
            "house_number": "2B",
            "zipcode": "49838",
            "city": "Handrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2020-000",
            "name": "Privathof Engbers in Breddenberg (Nr.2020-000)",
            "street": "Am Koopmannsberg",
            "house_number": "19",
            "zipcode": "26897",
            "city": "Breddenberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2021-000",
            "name": "Privathof Helmer in Emsdetten (Nr.2021-000)",
            "street": "Austum",
            "house_number": "43",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2022-000",
            "name": "Pine Alley Ranch in Escheburg (Nr.2022-000)",
            "street": "Kiefernweg",
            "house_number": "58",
            "zipcode": "21039",
            "city": "Escheburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2023-000",
            "name": "Tungerloh-Capellen 101 in Gescher (Nr.2023-000)",
            "street": "Tungerloh-Capellen ",
            "house_number": "101",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2024-000",
            "name": "Hof Raabe in Brekendorf (Nr.2024-000)",
            "street": "Dorfstraße",
            "house_number": "97",
            "zipcode": "24811",
            "city": "Brekendorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2025-000",
            "name": "Shagyas and Friends  in Langenhagen (Nr.2025-000)",
            "street": "Walsroder Str",
            "house_number": "228",
            "zipcode": "30853",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2026-000",
            "name": "Reitstall Neben Heinrichshof (liegt in der Kurve) in Krefeld (Nr.2026-000)",
            "street": "Hökendyk",
            "house_number": "2",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2027-000",
            "name": "Bewegungsstall Sandbochum  in Hamm (Nr.2027-000)",
            "street": "Eckernkamp",
            "house_number": "10",
            "zipcode": "59077",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2028-000",
            "name": "Privathof Weith in Dörpum (Nr.2028-000)",
            "street": "Osterende",
            "house_number": "15",
            "zipcode": "25821",
            "city": "Dörpum",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2029-000",
            "name": "Privathof Kleine in Eydelstedt (Nr.2029-000)",
            "street": "Dörpel",
            "house_number": "11F",
            "zipcode": "49406",
            "city": "Eydelstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2030-000",
            "name": "Pferdehof Eichenhain in Bottrop (Nr.2030-000)",
            "street": "Im Loh ",
            "house_number": "24",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2031-000",
            "name": "Privathof Schilling in Hatten (Nr.2031-000)",
            "street": "Im Häsen",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2032-000",
            "name": "Privathof Wilms in Heinsberg  (Nr.2032-000)",
            "street": "Zedernstraße",
            "house_number": "13",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2033-000",
            "name": "Lindenallee in Coesfeld (Nr.2033-000)",
            "street": "Lindenallee",
            "house_number": "67",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2034-000",
            "name": "Hof Mecklenburg in Norderstedt (Nr.2034-000)",
            "street": "Rantzauer Forstweg",
            "house_number": "21",
            "zipcode": "22850",
            "city": "Norderstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2035-000",
            "name": "Burglager Mühle in Rhauderfehn (Nr.2035-000)",
            "street": "Landesstraße",
            "house_number": "60",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2036-000",
            "name": " in  (Nr.2036-000)",
            "collect_point": "nein"
        },
        {
            "ID": "2037-000",
            "name": "Privathof van Acken in Hohenhameln (Nr.2037-000)",
            "street": "Osterstraße",
            "house_number": "6",
            "zipcode": "31249",
            "city": "Hohenhameln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2038-000",
            "name": "Süderhof Nordstrand - Elisabeth Sophien Koog in Elisabeth-Sophien-Koog (Nr.2038-000)",
            "street": "Elisabeth-sophien-koog",
            "house_number": "14",
            "zipcode": "25845",
            "city": "Elisabeth-Sophien-Koog",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2039-000",
            "name": "Double D Ranch in Olfen (Nr.2039-000)",
            "street": "Schaafhausen",
            "house_number": "2",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2040-000",
            "name": "Reitstall Hucklenbroich in Düsseldorf (Nr.2040-000)",
            "street": "Dorper Weg ",
            "house_number": "22",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2041-000",
            "name": "Abtsküche in Heiligenhaus (Nr.2041-000)",
            "street": "Abtskücher Straße",
            "house_number": "40",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2042-000",
            "name": "Hof Hartger in Nordhorn (Nr.2042-000)",
            "street": "Petkuser Straße",
            "house_number": "30",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2043-000",
            "name": "TIERischgutdrauf in Rehburg-Loccum  (Nr.2043-000)",
            "street": "Preußische Straße",
            "house_number": "25",
            "zipcode": "31547",
            "city": "Rehburg-Loccum ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2044-000",
            "name": "Privathof Robben-Zickerick in Niederlangen (Nr.2044-000)",
            "street": "Haferkampstraße",
            "house_number": "3",
            "zipcode": "49779",
            "city": "Niederlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2045-000",
            "name": "Privathof Krüger in Pinneberg (Nr.2045-000)",
            "street": "Voßhörn",
            "house_number": "31",
            "zipcode": "25421",
            "city": "Pinneberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2046-000",
            "name": "Gestüt Hohenschmark in Grebin (Nr.2046-000)",
            "street": "Hohenschmark",
            "house_number": "1",
            "zipcode": "24329",
            "city": "Grebin",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2047-000",
            "name": "Schoenges Hof Pesch in Korschenbroich (Nr.2047-000)",
            "street": "Liedberger Straße ",
            "house_number": "29",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2048-000",
            "name": "Reitstall Siemes in Viersen (Nr.2048-000)",
            "street": "Omperterweg",
            "house_number": "107",
            "zipcode": "41748",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2049-000",
            "name": "Privathof Hopf in Altenberge (Nr.2049-000)",
            "street": "Westenfeld",
            "house_number": "163",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2050-000",
            "name": "Privathof Grüner in Rosendahl (Nr.2050-000)",
            "street": "Hegerort ",
            "house_number": "16",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2051-000",
            "name": "Privathof Kanschat in Papenburg (Nr.2051-000)",
            "street": "Lüchtenburg Links",
            "house_number": "19",
            "zipcode": "26810",
            "city": "Papenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2052-000",
            "name": "Im Sundern in Fröndenberg (Nr.2052-000)",
            "street": "Im Sundern",
            "house_number": "7",
            "zipcode": "58730",
            "city": "Fröndenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2053-000",
            "name": "Hof Westermann in Hörstel (Nr.2053-000)",
            "street": "Jacksonweg",
            "house_number": "215",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2054-000",
            "name": "Hof Edler in Seelze (Nr.2054-000)",
            "street": "Kirchbuschweg",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2055-000",
            "name": "Privathof Ahrens-Urbanek in Warendorf  (Nr.2055-000)",
            "street": "Neuwarendorf ",
            "house_number": "2",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2056-000",
            "name": "Privathof Leußink in Heek (Nr.2056-000)",
            "street": "Wext",
            "house_number": "20",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2057-000",
            "name": "Privathof Dettmer in Ahlden (Nr.2057-000)",
            "street": "Eilter Dorfstraße",
            "house_number": "36a",
            "zipcode": "29693",
            "city": "Ahlden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2058-000",
            "name": "Privathof Grajczyk in Apen (Nr.2058-000)",
            "street": "Aperstraße",
            "house_number": "55",
            "zipcode": "26689",
            "city": "Apen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2059-000",
            "name": "Gut Osterberge Gödde in Dortmund (Nr.2059-000)",
            "street": "Osterberger Straße",
            "house_number": "19",
            "zipcode": "44289",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2060-000",
            "name": "Stall Niehues in Gescher (Nr.2060-000)",
            "street": "Tungerloh-Capellen",
            "house_number": "47",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2061-000",
            "name": "Privathof Dieler in Rinteln (Nr.2061-000)",
            "street": "Immensiek",
            "house_number": "20",
            "zipcode": "31737",
            "city": "Rinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2062-000",
            "name": "Reitstall Hans Lugge - Brautkutschenverleih in Mülheim an der Ruhr (Nr.2062-000)",
            "street": "Gänseweg ",
            "house_number": "80",
            "zipcode": "45475",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2063-000",
            "name": "Reithof Schlichte in Blomberg (Nr.2063-000)",
            "street": "Hiddensen ",
            "house_number": "22",
            "zipcode": "32825",
            "city": "Blomberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2064-000",
            "name": "Privathof Gebauer in Wülfrath (Nr.2064-000)",
            "street": "Bergstraße",
            "house_number": "62",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2065-000",
            "name": "Pferdehof Jansen in Wegberg (Nr.2065-000)",
            "street": "Marienstraße ",
            "house_number": "62",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2066-000",
            "name": "Privathof Horst in Kempen (Nr.2066-000)",
            "street": "Lötschenweg ",
            "house_number": "34",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2067-000",
            "name": "Privathof Werner  in Billerbeck  (Nr.2067-000)",
            "street": "Aulendorf ",
            "house_number": "5",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2068-000",
            "name": "Zuchthof Harder-Brune in Bramsche (Nr.2068-000)",
            "street": "Am Stroher Feld",
            "house_number": "3",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2069-000",
            "name": "Twietenhof Privatstall in Basedow (Nr.2069-000)",
            "street": "Twieten",
            "house_number": "14",
            "zipcode": "21483",
            "city": "Basedow",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2070-000",
            "name": "Privathof Rüdel in Bottrop (Nr.2070-000)",
            "street": "Forststraße ",
            "house_number": "2",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2071-000",
            "name": "Privathof Müller in Stelle (Nr.2071-000)",
            "street": "Büllhorner Weg",
            "house_number": "64",
            "zipcode": "21435",
            "city": "Stelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2072-000",
            "name": "Privathof Fabek in Essen (Nr.2072-000)",
            "street": "Eststraße",
            "house_number": "150",
            "zipcode": "45149",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2073-000",
            "name": "Privathof Klute in Medelby (Nr.2073-000)",
            "street": "Maiholm",
            "house_number": "1",
            "zipcode": "24994",
            "city": "Medelby",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2074-000",
            "name": "Reit- und Pensionsstall Missfeldt  in Tensbüttel-Röst (Nr.2074-000)",
            "street": "Redder ",
            "house_number": "3",
            "zipcode": "25767",
            "city": "Tensbüttel-Röst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2075-000",
            "name": "Privathof Kienbaum in Lengerich (Nr.2075-000)",
            "street": "Kellerskamp",
            "house_number": "27",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2076-000",
            "name": "Reitverein Sieversen in Rosengarten (Nr.2076-000)",
            "street": "Schwarzer Weg",
            "house_number": "1",
            "zipcode": "21224",
            "city": "Rosengarten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2077-000",
            "name": "Privathof Lichtenthäler in Heiligenhaus (Nr.2077-000)",
            "street": "Rolland",
            "house_number": "25",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2078-000",
            "name": "Privathof Bonna in Bottrop (Nr.2078-000)",
            "street": "Hiesfelderstraße",
            "house_number": "25",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2079-000",
            "name": "Hof Auberg in Mülheim an der Ruhr (Nr.2079-000)",
            "street": "Voßbeckstraße",
            "house_number": "169",
            "zipcode": "45481",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2080-000",
            "name": "Privathod Bulitta in Dorsten (Nr.2080-000)",
            "street": "Speckinger Weg",
            "house_number": "91",
            "zipcode": "46286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2081-000",
            "name": "Kinderhof Wehde in Zetel (Nr.2081-000)",
            "street": "Spolsener Moorstraße",
            "house_number": "23",
            "zipcode": "36340",
            "city": "Zetel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2082-000",
            "name": "Hof Broeker in Schloß Holte-Stukenbrock  (Nr.2082-000)",
            "street": "Lange Straße ",
            "house_number": "2",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2083-000",
            "name": "Reitanlage Johannsen in Tornesch (Nr.2083-000)",
            "street": "Ahrenloher Str.",
            "house_number": "127",
            "zipcode": "25435",
            "city": "Tornesch",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2084-000",
            "name": "Privathof Strothenke in Gütersloh (Nr.2084-000)",
            "street": "Paulusweg",
            "house_number": "13",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2085-000",
            "name": "Reitstall Petersen in Henstedt Ulzburg (Nr.2085-000)",
            "street": "Buschkoppel",
            "house_number": "2",
            "zipcode": "24558",
            "city": "Henstedt Ulzburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2086-000",
            "name": "Privathof Schwarze in Lohne (Oldenburg) (Nr.2086-000)",
            "street": "Feldweg ",
            "house_number": "4",
            "zipcode": "49393",
            "city": "Lohne (Oldenburg)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2087-000",
            "name": "Reiterhof Geyer in Tostedt (Nr.2087-000)",
            "street": "Riepshof",
            "house_number": "9",
            "zipcode": "21255",
            "city": "Tostedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2088-000",
            "name": "Privathof Leibrich-Brünings in Stuhr (Nr.2088-000)",
            "street": "Bürsteler Straße",
            "house_number": "75",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2089-000",
            "name": "Privathof Kranemann in Unna (Nr.2089-000)",
            "street": "Iserlohnerstraße ",
            "house_number": "123",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2090-000",
            "name": "Privathof Bischoff in Schwanewede (Nr.2090-000)",
            "street": "Mühlenweg",
            "house_number": "28",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2091-000",
            "name": "Hof Mißfeldt in Nindorf (Nr. 2091-000)",
            "street": "Möhlenkamp",
            "house_number": "4",
            "zipcode": "24594",
            "city": "Nindorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2092-000",
            "name": "Hof Wieschues in Ahlen-Dolberg (Nr.2092-000)",
            "street": "Auf dem Sichter ",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen-Dolberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2093-000",
            "name": "Hof Greiling in Emsdetten (Nr.2093-000)",
            "street": "Up'm Mersk ",
            "house_number": "2",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2094-000",
            "name": "Privathof Eichberger in Hagenburg (Nr.2094-000)",
            "street": "Im Wiesengrund",
            "house_number": "6",
            "zipcode": "31558",
            "city": "Hagenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2095-000",
            "name": "Reit- und Fahrverein Bottrop in Bottrop (Nr.2095-000)",
            "street": "Beisenstraße",
            "house_number": "18",
            "zipcode": "46242",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2096-000",
            "name": "Stall Hoff in Ladbergen (Nr.2096-000)",
            "street": "Kuhweg",
            "house_number": "9",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2097-000",
            "name": "Privathof Wüstefeld in Thedinghausen (Nr.2097-000)",
            "street": "Dibberser Dorfstraße",
            "house_number": "3",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2098-000",
            "name": "Reitanlage Gut Vogelbusch in Heiligenhausen (Nr.2098-000)",
            "street": "Gut Vogelbusch",
            "house_number": "26",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2099-000",
            "name": "HorseAirium Rieste in Rieste (Nr.2099-000)",
            "street": "Hasekamps-Boll ",
            "house_number": "9",
            "zipcode": "49597",
            "city": "Rieste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-BB",
            "name": "Raiffeisen-Markt Bückeburg in Bückeburg (Nr.RM-BB)",
            "street": "Kreuzbreite",
            "house_number": "6",
            "zipcode": "31675",
            "city": "Bückeburg",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "2100-000",
            "name": "Bredenbeck Stall",
            "street": "Steinkrügerweg ",
            "house_number": "50",
            "zipcode": "30974",
            "city": "Wennigsen (Deister)",
            "state": "Niedersachsen"
        },
        {
            "ID": "2101-000",
            "name": "Privathof Beuck",
            "street": "Klint",
            "house_number": "44a",
            "zipcode": "24800",
            "city": "Elsdorf-westermühlen",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2102-000",
            "name": "Gestüt Lohhof",
            "street": "Lohhof",
            "house_number": "14",
            "zipcode": "31600",
            "city": "Uchte",
            "state": "Niedersachsen"
        },
        {
            "ID": "2103-000",
            "name": "Privathof Grosse-Berkhoff",
            "street": "Soester Straße",
            "house_number": "405",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2104-000",
            "name": "Privathof Wetzel",
            "street": "Uelzener Straße",
            "house_number": "24",
            "zipcode": "29386",
            "city": "Hankensbüttel",
            "state": "Niedersachsen"
        },
        {
            "ID": "2105-000",
            "name": "Johannshof",
            "street": "Zur Glessener Höhe",
            "house_number": "45",
            "zipcode": "50129",
            "city": "Bergheim",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2106-000",
            "name": "Privathof Verhülsdonk",
            "street": "Heideweg",
            "house_number": "3a",
            "zipcode": "46519",
            "city": "Alpen",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2107-000",
            "name": "Privathof Köß",
            "street": "Sarusch",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke",
            "state": "Niedersachsen"
        },
        {
            "ID": "2108-000",
            "name": "In den Meyerhöfen - Islandpferde",
            "street": "In den Meyerhöfen",
            "house_number": "31",
            "zipcode": "31535",
            "city": "Neustadt am Rübenberge",
            "state": "Niedersachsen"
        },
        {
            "ID": "2109-000",
            "name": "Quitthoevelshof Tennagels",
            "street": "Am Mühlenwasser",
            "house_number": "56",
            "zipcode": "47625",
            "city": "Kevelaer",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2110-000",
            "name": "Hof Heinz Flothmann",
            "street": "Kirchbauerschaft",
            "house_number": "35",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2111-000",
            "name": "Hof Sonja Mootz",
            "street": "Oermter Kirchweg",
            "house_number": "47",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2112-000",
            "name": "Privathof Flommersfeld",
            "street": "Nordlünerner Straße",
            "house_number": "78",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2113-000",
            "name": "Privathof Steincke",
            "street": "Stieneichhofen",
            "house_number": "2",
            "zipcode": "58553",
            "city": "Halver",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2114-000",
            "name": "Friesenhof",
            "street": "Lehmberg",
            "house_number": "7",
            "zipcode": "23795",
            "city": "Negernbötel",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2115-000",
            "name": "Reithof Lökes",
            "street": "Brünener Straße",
            "house_number": "2",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2116-000",
            "name": "Privathof Ellekotten",
            "street": "Up de Wälle",
            "house_number": "4",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2117-000",
            "name": "Böhnen Hoff Landwirtschaft",
            "street": "Petershägerweg",
            "house_number": "220",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2118-000",
            "name": "Stall Wüller",
            "street": "Mahlenburger Weg",
            "house_number": "12",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2119-000",
            "name": "Westernreitstall Erlenbusch",
            "street": "Erlenbusch",
            "house_number": "1",
            "zipcode": "51515",
            "city": "Kürten",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2120-000",
            "name": "Hof Blomberg",
            "street": "Nordwalder Straße",
            "house_number": "180",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2121-000",
            "name": "Hof Jankord",
            "street": "Am Gievenbach ",
            "house_number": "60",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2122-000",
            "name": "Privathof Schmid",
            "street": "Eichtelger Weg",
            "house_number": "29",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2123-000",
            "name": "Ponyhof Hausberg",
            "street": "Krusinge",
            "house_number": "28",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen"
        },
        {
            "ID": "2124-000",
            "name": "Privathof Heuser",
            "street": "Hansellerstraße ",
            "house_number": "55",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2125-000",
            "name": "Singerhof",
            "street": "Singerhof",
            "house_number": "67",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2126-000",
            "name": "Tierphysiotherapie Anke Hayk",
            "street": "Fresenhorst",
            "house_number": "3",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2127-000",
            "name": "Pferdepension Lübbert ",
            "street": "Im Mackenbruch",
            "house_number": "10",
            "zipcode": "33813",
            "city": "Oerlinghausen ",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2128-000",
            "name": "Privathof Kröger",
            "street": "Wiesenweg",
            "house_number": "10",
            "zipcode": "21266",
            "city": "Jesteburg",
            "state": "Niedersachsen"
        },
        {
            "ID": "2129-000",
            "name": "Tierarztpraxis Clemens Heider",
            "street": "Ahlen ",
            "house_number": "15",
            "zipcode": "51515",
            "city": "Kürten",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2130-000",
            "name": "Hof Radza",
            "street": "Dorfstraße",
            "house_number": "6",
            "zipcode": "23816",
            "city": "Neversdorf",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2131-000",
            "name": "Kranzhof",
            "street": "Allermarsch",
            "house_number": "7",
            "zipcode": "27336",
            "city": "Rethem",
            "state": "Niedersachsen"
        },
        {
            "ID": "2132-000",
            "name": "Krawinkel",
            "street": "Währentruper Straße ",
            "house_number": "88",
            "zipcode": "32791",
            "city": "Lage",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "10-000",
            "name": "Brockhausen in Münster (Nr.10-000)",
            "street": "Böddingheideweg 48a",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "11-000",
            "name": "Hinske/Dunkelmann in Münster (Nr.11-000)",
            "street": "Angelsachsenweg 111",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "12-000",
            "name": "RV Sendenhorst in Sendenhorst (Nr.12-000)",
            "street": "Alter Postweg 3",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "13-000",
            "name": "RV Amelsbüren in Münster (Nr.13-000)",
            "street": "Thierstraße 291",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "14-000",
            "name": "Schulze Hobeling in Telgte (Nr.14-000)",
            "street": "Grevener Straße 161",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "15-000",
            "name": "Averkamp in Münster (Nr.15-000)",
            "street": "Gremmendorfer Weg 210",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "16-000",
            "name": "Gestüt Förster in Lüdinghausen (Nr.16-000)",
            "street": "Ermen 55",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "17-000",
            "name": "Rusticus in Münster (Nr.17-000)",
            "street": "Münsterstraße 128b",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "18-000",
            "name": "Ponyhof Georgenbruch in Everswinkel (Nr.18-000)",
            "street": "Müssingen 25",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "19-000",
            "name": "Holtkötter in Münster (Nr.19-000)",
            "street": "Kötterstr. 120",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "20-000",
            "name": "Niehoff in Münster (Nr.20-000)",
            "street": "Westfalenstr. 90",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "21-000",
            "name": "AR Trainingstable in Sendenhorst (Nr.21-000)",
            "street": "Rummler 32",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "22-000",
            "name": "Jostmeier  in Dülmen (Nr.22-000)",
            "street": "Feldmark 18",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "23-000",
            "name": "Reitstall Haves in Sendenhorst (Nr.23-000)",
            "street": "Sunger 7",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "24-000",
            "name": "Pferdehof Ludwig in Drensteinfurt (Nr.24-000)",
            "street": "Eickendorf 36",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "25-000",
            "name": "Pferdehof Schabhüser in Warendorf (Nr.25-000)",
            "street": "Neuwarendorf 3",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "26-000",
            "name": "Weidenhof in Drensteinfurt (Nr.26-000)",
            "street": "Göttendorfer Weg 94",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "27-000",
            "name": "Hengststation Holkenbrink in Münster (Nr.27-000)",
            "street": "Oberort 20",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "28-000",
            "name": "West I 12 (Privat)  in Sendenhorst (Nr.28-000)",
            "street": "West I 12",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "29-000",
            "name": "Stegemann-Wibbelt in Münster (Nr.29-000)",
            "street": "Kanalstraße 258",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "30-000",
            "name": "RV Albachten in Münster (Nr.30-000)",
            "street": "Oberort 105",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "31-000",
            "name": "Sekic in Sendenhorst (Nr.31-000)",
            "street": "Sudfeld 9",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "32-000",
            "name": "RV Ascheberg in Ascheberg (Nr.32-000)",
            "street": "Windmühlenweg 10",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "33-000",
            "name": "RuF Greven in Greven (Nr.33-000)",
            "street": "Saerbeckerstrasse 190",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "34-000",
            "name": "Westphalia Stables in Hörstel (Nr.34-000)",
            "street": "Ludwigswald 101",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "35-000",
            "name": "Kammler in Emsdetten (Nr.35-000)",
            "street": "Saerbecker Weg 32",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "36-000",
            "name": "RV Enigger Vorhelm in Ennigerloh (Nr.36-000)",
            "street": "Balhorn 1",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "37-000",
            "name": "Berkenheide in Greven (Nr.37-000)",
            "street": "Am Mühlenbach 46",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "38-000",
            "name": "Reitanlage Hase  in Welver (Nr.38-000)",
            "street": "Postweg 1-3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "39-000",
            "name": "Weringhof  in Hamm (Nr.39-000)",
            "street": "Am Weringhof 1",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "40-000",
            "name": "Reitanlage Hidding in Greven (Nr.40-000)",
            "street": "Wentruper Mark 45",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "41-000",
            "name": "Möllenbeck  in Münster (Nr.41-000)",
            "street": "Kreuzbach 326",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "43-000",
            "name": "Herrenstein (Kruckenbaum) in Drensteinfurt (Nr.43-000)",
            "street": "Kerkpatt 24",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "44-000",
            "name": "Reitstall Twent  in Nottuln (Nr.44-000)",
            "street": "Gladbeck 10",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "45-000",
            "name": "Landhof Große-Hellmann in münster (Nr.45-000)",
            "street": "Niederort 131",
            "house_number": "1",
            "zipcode": "48308",
            "city": "münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "46-000",
            "name": "Stall Beckmann  in Münster (Nr.46-000)",
            "street": "Hofkamp 132",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "47-000",
            "name": "Korte  in Telgte (Nr.47-000)",
            "street": "Lauheide 26",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "48-000",
            "name": "RuV Hiltrup  in Münster (Nr.48-000)",
            "street": "Hünenburg 22",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "49-000",
            "name": "RV Albersloh in Sendenhorst (Nr.49-000)",
            "street": "Hohe Ward 5",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "50-000",
            "name": "Frankenhof in Rehau (Nr.50-000)",
            "street": "Degenreuth 2",
            "house_number": "1",
            "zipcode": "95111",
            "city": "Rehau",
            "state": "Bayern",
            "collect_point": "nein"
        },
        {
            "ID": "51-000",
            "name": "Triebus Fallenberg  in Ennigerloh (Nr.51-000)",
            "street": "Wessenhorst 20",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "52-000",
            "name": "Grumbach  in Harsewinkel (Nr.52-000)",
            "street": "Hallerstrasse 37",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "53-000",
            "name": "RV Rhynern  in Hamm (Nr.53-000)",
            "street": "Holthöfener Weg 1A",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "54-000",
            "name": "Feddermann  in Greven (Nr.54-000)",
            "street": "Saerbeckerstr. 150",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "55-000",
            "name": "RV Roxel  in Münster (Nr.55-000)",
            "street": "Bösenseller Straße 6",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "56-000",
            "name": "Zur Rossheide  in Münster (Nr.56-000)",
            "street": "Zur Rossheide 2",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "57-000",
            "name": "Don A Rima Ranch in Warendorf (Nr.57-000)",
            "street": "Neuwarendorf 56A",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "58-000",
            "name": "RuFWadelheim-Rheine  in Rheine (Nr.58-000)",
            "street": "Ohner Damm 9",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "59-000",
            "name": "Kögel in Porta Westfalica (Nr.59-000)",
            "street": "Am Rehm 10",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "60-000",
            "name": "Heimann in Sendenhorst (Nr.60-000)",
            "street": "Rummler 1",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "61-000",
            "name": "Pferdepension Kellenberg in Hemsloh (Nr.61-000)",
            "street": "Wagenfelderstraße 28",
            "house_number": "1",
            "zipcode": "49453",
            "city": "Hemsloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "62-000",
            "name": "Laumann in Greven (Nr.62-000)",
            "street": "Laumanns Damm 22",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "63-000",
            "name": "RuF Recklinghausen  in Recklinghausen (Nr.63-000)",
            "street": "Lindenstr. 82",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "64-000",
            "name": "Gut Holtmann  in Billerbeck (Nr.64-000)",
            "street": "Dörholt 14",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "65-000",
            "name": "Jana Preissing  in Senden (Nr.65-000)",
            "street": "Gettrup 13",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "66-000",
            "name": "Meckmann-Dorsel in Münster (Nr.66-000)",
            "street": "Markweg 100",
            "house_number": "1",
            "zipcode": "48147",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "67-000",
            "name": "Pfedehof Rohmann  in Hörstel (Nr.67-000)",
            "street": "Brachtesendeweg 215",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "68-000",
            "name": "RV Ennigerloh-Neubeckum in Ennigerloh (Nr.68-000)",
            "street": "In der Hoest  22",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "69-000",
            "name": "Reitanlage Ansgar Westrup  in Havixbeck (Nr.69-000)",
            "street": "Schonebeck 21",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "70-000",
            "name": "Mölllers  in Münster (Nr.70-000)",
            "street": "Lauheide 31",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "72-000",
            "name": "Privater Offenstall in Bottrop (Nr.72-000)",
            "street": "Im Spring 87",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "73-000",
            "name": "RV Wadelheim Rheine in Rheine (Nr.73-000)",
            "street": "Ohner Damm 13",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "74-000",
            "name": "Reiterhof Rohmann  in Nordwalde (Nr.74-000)",
            "street": "Westerode 41",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "75-000",
            "name": "Hof Hinterberg  in Westernkappeln (Nr.75-000)",
            "street": "Hoppenliet 21",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westernkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "76-000",
            "name": "Hengsthaltung Becks in Senden (Nr.76-000)",
            "street": "Dorfbauerschaft 39",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "77-000",
            "name": "Wernsmann  in Hörstel (Nr.77-000)",
            "street": "Münsterdamm 16a",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "78-000",
            "name": "Pferdehof  Hillebrandt in Coesfeld (Nr.78-000)",
            "street": "Letter Berg 16",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "79-000",
            "name": "Kinnebrock in Münster (Nr.79-000)",
            "street": "Erbdrostenweg 285",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "81-000",
            "name": "Hof Leusmann in Rheine (Nr.81-000)",
            "street": "Riesenbeckerstr. 180",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "82-000",
            "name": "Stall Schmitz in Ibbenbüren-Dickenberg (Nr.82-000)",
            "street": "Am Mariannenschacht  85",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren-Dickenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "83-000",
            "name": "Pferdehof Hackenesch in Münster (Nr.83-000)",
            "street": "Im Dahl 13a",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "84-000",
            "name": "Kammann in Senden (Nr.84-000)",
            "street": "Wierling 33",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "85-000",
            "name": "Pferdehof Lohmann in Münster (Nr.85-000)",
            "street": "Westfalen Strasse 48",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "86-000",
            "name": " in Billerbeck (Nr.86-000)",
            "street": "Bockelsdorf 22",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "87-000",
            "name": "Reitanlage Kost in Bochum (Nr.87-000)",
            "street": "Havkenscheider Straße 243",
            "house_number": "1",
            "zipcode": "44803",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "88-000",
            "name": "Privatstall in Viernheim (Nr.88-000)",
            "street": "Am Alten Weinheimer Weg 13",
            "house_number": "1",
            "zipcode": "68589",
            "city": "Viernheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "89-000",
            "name": "Burfeind in Sittensen (Nr.89-000)",
            "street": "Alte Dorfstraße ",
            "house_number": "1",
            "zipcode": "27419",
            "city": "Sittensen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "90-000",
            "name": "Fam. Aupers in Münster (Nr.90-000)",
            "street": "Havixbecker Straße 101",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "91-000",
            "name": "RV Ahlen in Ahlen (Nr.91-000)",
            "street": "Walstedderstr. 176",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "92-000",
            "name": "Hof Beckmann in Recklinghausen (Nr.92-000)",
            "street": "Bockholterstraße 445",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "93-000",
            "name": "Hildesheim marienburg in Hildesheim (Nr.93-000)",
            "street": "Beusterstrasse 22",
            "house_number": "1",
            "zipcode": "31141",
            "city": "Hildesheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "94-000",
            "name": "Reitstall Engelke in Hülsede (Nr.94-000)",
            "street": "Zur Bauernstelle 7",
            "house_number": "1",
            "zipcode": "31867",
            "city": "Hülsede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "95-000",
            "name": "RV Loikum in Hamminkeln (Nr.95-000)",
            "street": "Mehrbruch 1",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "96-000",
            "name": "Niehues in Ledgen (Nr.96-000)",
            "street": "Isingort 63",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Ledgen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "97-000",
            "name": "Pferdepension Peter Horstmann in Sendenhorst (Nr.97-000)",
            "street": "Alter Postweg 38",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "98-000",
            "name": "Hof Freisfeld in Ascheberg (Nr.98-000)",
            "street": "Ostereckern 11",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "99-000",
            "name": "Vechtehof Pröbsting in Wettringen (Nr.99-000)",
            "street": "Vollenbrok 1",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "100-000",
            "name": "Reit- und Fahrverein Lüdinghausen in Lüdinghausen (Nr.100-000)",
            "street": "Elvert 26",
            "house_number": "1",
            "zipcode": "53948",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "101-000",
            "name": "Engemann in Rheda Wiedenbrück (Nr.101-000)",
            "street": "Auf der Horst 29",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "102-000",
            "name": "Hof Schütte in Spelle (Nr.102-000)",
            "street": "An der Koppel 1",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "103-000",
            "name": "ZRFV Neuenkirchen in Neuenkirchen (Nr.103-000)",
            "street": "Haarweg 42",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "104-000",
            "name": "Schulte Mesum in Rheine (Nr.104-000)",
            "street": "Feuerstiege 31",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "106-000",
            "name": "Gestüt Borgert in Coesfeld (Nr.106-000)",
            "street": "Harle 51",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "107-000",
            "name": "Hollenhorst Stables in Thuine (Nr.107-000)",
            "street": "Hollenhorst 1",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "108-000",
            "name": "Steinschulte in Hamm (Nr.108-000)",
            "street": "Frielick 6",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "109-000",
            "name": "Hof Schulze Everding in Münster (Nr.109-000)",
            "street": "Brock 200",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "110-000",
            "name": "Birkenhof Birgte / Riesenbeck in Hörstel (Nr.110-000)",
            "street": "Saerbecker Damm 261",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "111-000",
            "name": "Reitverein Reken in Reken (Nr.111-000)",
            "street": "Berge 12",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "112-000",
            "name": "Reitverein Billerbeck in Billerbeck (Nr.112-000)",
            "street": "Hamern 13",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "113-000",
            "name": "Reitanlage Kettlerholz in Welver (Nr.113-000)",
            "street": "Kettlerholz 39",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "115-000",
            "name": "Selbstabholer in Rheine (Nr.115-000)",
            "street": "Max-Born-Straße 4",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "116-000",
            "name": "Grothues-Homann in Senden (Nr.116-000)",
            "street": "Schölling 17",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "117-000",
            "name": "Reitanlage Hilbring in Recklinghausen (Nr.117-000)",
            "street": "Rittbörden 48",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "118-000",
            "name": "Hof Westerfeld in Datteln (Nr.118-000)",
            "street": "Hagemer Kirchweg 104",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "119-000",
            "name": "Falkhof in Lienen (Nr.119-000)",
            "street": "Im Siensfeld 1",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "120-000",
            "name": "Teigeler Datteln in Datteln (Nr.120-000)",
            "street": "Hagemer Kirchweg 82",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "121-000",
            "name": "Pferdehof Stöppelmann in Hamm (Nr.121-000)",
            "street": "Wambelner Straße 9",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "122-000",
            "name": "Reit- und Fahrverein Bawinkel in Bawinkel (Nr.122-000)",
            "street": "Am Sportplatz ",
            "house_number": "1",
            "zipcode": "49844",
            "city": "Bawinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "123-000",
            "name": "Reitverein St.Georg Heek-Nienborg e.V. in Heek (Nr.123-000)",
            "street": "Averbeck 105",
            "house_number": "1",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "124-000",
            "name": "Reitanlage Harde in Welver (Nr.124-000)",
            "street": "Hillingsen 1",
            "house_number": "1",
            "zipcode": "59515",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "125-000",
            "name": "Reitanlage Lippetal in Lippetal (Nr.125-000)",
            "street": "Dolberger Str. 76",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "126-000",
            "name": "Privatstall Fenner in Greven (Nr.126-000)",
            "street": "Kroner Heide 33",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "127-000",
            "name": "Alte Vogtei Schloss Vornholz in Ennigerloh (Nr.127-000)",
            "street": "Zum Hohen Kreuz 16",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "128-000",
            "name": "Small Hill Stable in Hamm (Nr.128-000)",
            "street": "Hölter 21",
            "house_number": "1",
            "zipcode": "59065",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "129-000",
            "name": "Linda Blänker in Nordwalde (Nr.129-000)",
            "street": "Suttorf 11",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "130-000",
            "name": "Gisa de Angelis in Münster (Nr.130-000)",
            "street": "Bredeheide 152",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "131-000",
            "name": "Hülskötter in Greven (Nr.131-000)",
            "street": "Hüttruper Str. 86",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "132-000",
            "name": "Hoogenhof in Kamp-Lintfort (Nr.132-000)",
            "street": "Xantener Str. 80",
            "house_number": "1",
            "zipcode": "47475",
            "city": "Kamp-Lintfort",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "133-000",
            "name": "RuF Spelle in Spelle (Nr.133-000)",
            "street": "In den Gärten 20",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "134-000",
            "name": "Hövelmann in Sendenhorst (Nr.134-000)",
            "street": "West II",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "137-000",
            "name": "Thurau in Haselünne (Nr.137-000)",
            "street": "Kreuzweg 14",
            "house_number": "1",
            "zipcode": "49740",
            "city": "Haselünne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "138-000",
            "name": "Raming-Freesen in Oberlangen (Nr.138-000)",
            "street": "Zur Marsch 15",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "139-000",
            "name": "Therapiehof Welp in Wettringen (Nr.139-000)",
            "street": "Bilk 57",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "140-000",
            "name": "Burlage in Telgte-Westbevern (Nr.140-000)",
            "street": "Lütken Heide 32",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte-Westbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "141-000",
            "name": "Vinzenzwerk handorf e.V. in Münster (Nr.141-000)",
            "street": "Flugplatz 53",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "142-000",
            "name": "Overbeck in Herten (Nr.142-000)",
            "street": "Weiherstraße ",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "143-000",
            "name": "Schulte  in Spelle (Nr.143-000)",
            "street": "Bönnestr. 8",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "144-000",
            "name": "Weymanns Pony Ranch in Neuenkirchen (Nr.144-000)",
            "street": "Mühlendamm 97",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "146-000",
            "name": "Reitanlage am Rehrbach in Schermbeck (Nr.146-000)",
            "street": "Am Rehrbach 98",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "147-000",
            "name": "Hof Zumkley in Senden (Nr.147-000)",
            "street": "Kley 14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "148-000",
            "name": "Horses in Flames Bleckum in Beckum (Nr.148-000)",
            "street": "Elker 16",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "149-000",
            "name": "Felix Ponyhof in Rietberg (Nr.149-000)",
            "street": "Schulstr. 130",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "150-000",
            "name": "Reiterhof Hunsche in Lienen (Nr.150-000)",
            "street": "Reiterweg 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "152-000",
            "name": "Hof Stimberg in Datteln (Nr.152-000)",
            "street": "Recklinghäuserstr. 140",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "153-000",
            "name": "Schmidt in Everswinkel (Nr.153-000)",
            "street": "Müssingen 38",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "155-000",
            "name": "Privatstall Wiermann in Mettingen (Nr.155-000)",
            "street": "Hagebröcker Weg 22",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "156-000",
            "name": "Lieningshof in Neuenhaus (Nr.156-000)",
            "street": "Lager Str. 110",
            "house_number": "1",
            "zipcode": "49828",
            "city": "Neuenhaus",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "157-000",
            "name": "Ostkotte in Ochtrup (Nr.157-000)",
            "street": "Winkelstraße 31",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "158-000",
            "name": "Reitanlage Wilhelm Mönnich in Datteln (Nr.158-000)",
            "street": "Klosterner Weg 2",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "159-000",
            "name": "Pach in Nordhorn (Nr.159-000)",
            "street": "Am Nolland 18",
            "house_number": "1",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "160-000",
            "name": "Veltmaat in Wietmarschen (Nr.160-000)",
            "street": "Pferdebahn 5",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "161-000",
            "name": "Berning in Rheine (Nr.161-000)",
            "street": "Bredeweg 161",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "162-000",
            "name": "Vischedyk in Gronau (Nr.162-000)",
            "street": "Metelner Damm ",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "163-000",
            "name": "Gripshöver in Werne (Nr.163-000)",
            "street": "Martinsweg 4",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "164-000",
            "name": "Schlüter in Werne (Nr.164-000)",
            "street": "Martinsweg 19",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "165-000",
            "name": "St. Georg Werne in Werne (Nr.165-000)",
            "street": "Kähte-Kollwitz Str. 103",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "166-000",
            "name": "Thünemann in Andervenne (Nr.166-000)",
            "street": "Toschlag 6",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Andervenne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "167-000",
            "name": "Ross in Rheine (Nr.167-000)",
            "street": "Kämpe 75",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "168-000",
            "name": "Die Freigänger in Borken (Nr.168-000)",
            "street": "Coesfelder Straße 69",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "169-000",
            "name": "Werpers in Emsdetten (Nr.169-000)",
            "street": "Ahlintel 45",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "170-000",
            "name": "Pensionsstall Brinker in Fürstenau (Nr.170-000)",
            "street": "Kellinghausen 27",
            "house_number": "1",
            "zipcode": "49584",
            "city": "Fürstenau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "171-000",
            "name": "Frie in Greven (Nr.171-000)",
            "street": "Aldruper Oberesch 26",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "172-000",
            "name": "Privatstall Neumann in Gütersloh (Nr.172-000)",
            "street": "Luise-Henselstraße 129",
            "house_number": "1",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "173-000",
            "name": "Reitanlage Münstermann in Werl-Holtum (Nr.173-000)",
            "street": "Am Jahenbrink 10",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl-Holtum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "174-000",
            "name": "Privatstall Muke in Geeste (Nr.174-000)",
            "street": "Zur Schleuse 25",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "175-000",
            "name": "Reitanlage Kohlmann in Dortmund (Nr.175-000)",
            "street": "Eichwaldstr. 103",
            "house_number": "1",
            "zipcode": "44419",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "176-000",
            "name": "Offenstall Nordwalde Reckenfeld in Nordwalde (Nr.176-000)",
            "street": "Suttorf 99",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "177-000",
            "name": "Tankstelle Holtwick Öffentlich in Rosendahl (Nr.177-000)",
            "street": "Coesfelder Straße 6",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "178-000",
            "name": "Berghoff in Albersloh (Nr.178-000)",
            "street": "Sunger 15",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Albersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "179-000",
            "name": "Blömker in Lienen (Nr.179-000)",
            "street": "Kattenvenner Str. 60",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "180-000",
            "name": "Reitanlage Nordhoff in Emsdetten (Nr.180-000)",
            "street": "Reckenfelderstr. 92",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "181-000",
            "name": "Rawert in Coesfeld-Lette (Nr.181-000)",
            "street": "Herteler 74",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld-Lette",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "182-000",
            "name": "Hof Schulte-Kellinghaus in Gladbeck (Nr.182-000)",
            "street": "Feldhauserstraße 416",
            "house_number": "1",
            "zipcode": "45966",
            "city": "Gladbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "183-000",
            "name": "Einfach Pferdisch in Dorsten (Nr.183-000)",
            "street": "Kippheide 60",
            "house_number": "1",
            "zipcode": "46286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "184-000",
            "name": "Ruhmann in Beckum (Nr.184-000)",
            "street": "Holtmar 4",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "185-000",
            "name": "Hof Balzer in Herten  (Nr.185-000)",
            "street": "Elper Straße 217",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "186-000",
            "name": "RfV Rheine/Catenhorn in Rheine (Nr.186-000)",
            "street": "Bauernschaftsstrasse 153",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "187-000",
            "name": "Rv St. Georg Münster in Münster (Nr.187-000)",
            "street": "Reiner-Klimke-Weg 1",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "188-000",
            "name": "JP - Reiten mit Verstand und Gefühl in Geeste (Nr.188-000)",
            "street": "Süd-Nord-Straße 20",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "189-000",
            "name": "RuF Nordhorn e.V. in Nordhorn (Nr.189-000)",
            "street": "Neuenhauser Str. 257",
            "house_number": "1",
            "zipcode": "48527",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "190-000",
            "name": "Schulze Everding Amelsbüren in Münster (Nr.190-000)",
            "street": "Daverstr. 7",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "191-000",
            "name": "Gerd Niederschabbehard in Steinhagen (Nr.191-000)",
            "street": "In der Howe 1",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "192-000",
            "name": "Busmann in Schüttorf (Nr.192-000)",
            "street": "Alter Emsbürener Weg 21",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "193-000",
            "name": "Hof Wilhelmer in Telgte (Nr.193-000)",
            "street": "Verth 13",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "194-000",
            "name": "Reitverein Marl Hof Ostgathe in Marl (Nr.194-000)",
            "street": "Rottmanskamp 23a",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "195-000",
            "name": "Pferdehof Osterholt in Südlohn (Nr.195-000)",
            "street": "Hessinghook 14",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "196-000",
            "name": "Pferdehof Wiegard in Ennigerloh (Nr.196-000)",
            "street": "Hoest 19",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "197-000",
            "name": "Private Stallgemeinschaft Banker in Rosendahl (Nr.197-000)",
            "street": "Rockel 60",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "198-000",
            "name": "Privatstall Mennemann in Lienen (Nr.198-000)",
            "street": "Am Hagen 3",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "199-000",
            "name": "Reiterhof Jungkamp in Rhede (Nr.199-000)",
            "street": "Zum Venn 34",
            "house_number": "1",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "200-000",
            "name": "Equiva Münster in Münster (öffentlich) (Nr.200-000)",
            "street": "Dieckstraße 71-75",
            "house_number": "1",
            "zipcode": "48145",
            "city": "Münster (öffentlich)",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "201-000",
            "name": "Fohlenhof Steins  in Waltrop (Nr.201-000)",
            "street": "Unterlippe 26",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "202-000",
            "name": "Reitverein St. Martin Stadtlohn in Stadtlohn (Nr.202-000)",
            "street": "Losberg 1",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "203-000",
            "name": "Reitstall Engelernerhof in Merzen  (Nr.203-000)",
            "street": "Fürstenauer Damm 22",
            "house_number": "1",
            "zipcode": "49586",
            "city": "Merzen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "204-000",
            "name": "Rennstall Pavel  in Halle  (Nr.204-000)",
            "street": "Gewerbestr. 4",
            "house_number": "1",
            "zipcode": "33790",
            "city": "Halle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "205-000",
            "name": "Hof Quante  in Münster  (Nr.205-000)",
            "street": "Am Mooresch 35",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "206-000",
            "name": "Haverkamp  in Ostbevern  (Nr.206-000)",
            "street": "Loburg 39",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "207-000",
            "name": "Harenburg  in Hollage (Nr.207-000)",
            "street": "Dörnter Weg 2",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Hollage",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "208-000",
            "name": "Bussmann  in Haltern am See  (Nr.208-000)",
            "street": "Flaesheimerstraße 276",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "209-000",
            "name": "Wienken  in Südlohn (Nr.209-000)",
            "street": "Sickinghook 5",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "210-000",
            "name": "Strosi  in Salzbergen  (Nr.210-000)",
            "street": "Brandeweg 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "211-000",
            "name": "Pferdehof Helmert  in Marienfeld/Harsewinkel  (Nr.211-000)",
            "street": "Lutterstrang 16",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Marienfeld/Harsewinkel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "212-000",
            "name": "Grossmann/Brockmann  in Rheine (Nr.212-000)",
            "street": "Kloddenhook 23",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "213-000",
            "name": "Privatstall Laurenz  in Gronau  (Nr.213-000)",
            "street": "Bergstraße 67",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "214-000",
            "name": "Pferdepension Bauer  in Greven  (Nr.214-000)",
            "street": "Herberner Mersch 70",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "215-000",
            "name": "Kleinblei  in Nordkirchen  (Nr.215-000)",
            "street": "Funneweg 2",
            "house_number": "1",
            "zipcode": "59394",
            "city": "Nordkirchen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "216-000",
            "name": "Colrado-Ranch  in Recklinghausen (Nr.216-000)",
            "street": "Hestermannweg Ecke Heinrichstraße ",
            "house_number": "1",
            "zipcode": "45663",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "217-000",
            "name": "Osthoff  in Welver  (Nr.217-000)",
            "street": "Recklingser Straße  1",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "218-000",
            "name": "Pferdehof Gerling  in Greven  (Nr.218-000)",
            "street": "Maestruper Brook 19",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "219-000",
            "name": "Reit-und Pferdepension Bartling  in Meppen  (Nr.219-000)",
            "street": "Dorfstraße 1",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "220-000",
            "name": "Wilde  in Rosendahl  (Nr.220-000)",
            "street": "Schlee 4",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "221-000",
            "name": "Reitstall FN Elberich  in Münster  (Nr.221-000)",
            "street": "Alter Mühlenweg 41",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "222-000",
            "name": "Privatstall Ripperda  in Lingen  (Nr.222-000)",
            "street": "Altenlingener Weg 85",
            "house_number": "1",
            "zipcode": "49808",
            "city": "Lingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "223-000",
            "name": "Privatstall Suttrup  in Senden  (Nr.223-000)",
            "street": "Dorfbauerschaft 122",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "224-000",
            "name": "Privatstall Bad Iburg  in Bad Iburg  (Nr.224-000)",
            "street": "Alter Postdamm 2",
            "house_number": "1",
            "zipcode": "49186",
            "city": "Bad Iburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "225-000",
            "name": "Sportpferde Hüsken  in Wietmarschen  (Nr.225-000)",
            "street": "Auf der Haare 2",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "226-000",
            "name": "Privatstall Christaller  in Rosendahl  (Nr.226-000)",
            "street": "Rockel 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "227-000",
            "name": "Rieskamp  in Recke  (Nr.227-000)",
            "street": "Haarkamp 15",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "228-000",
            "name": "Reiterhof Thier  in Marl  (Nr.228-000)",
            "street": "Johannesstraße 52",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "229-000",
            "name": "ZRFV St. Hubertus in Dreierwalde (Nr.229-000)",
            "street": "Venhäuser Weg  7",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Dreierwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "230-000",
            "name": "Stall Decker  in Vreden  (Nr.230-000)",
            "street": "Lünten Sand ",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "231-000",
            "name": "Aschhoff  in Ennigerloh  (Nr.231-000)",
            "street": "Pilatusberg 18",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "232-000",
            "name": "Temminghoff  in Heiden  (Nr.232-000)",
            "street": "Stegge 4",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "233-000",
            "name": "RUF Nordbögge-Lerch  in Bönen (Nr.233-000)",
            "street": "Schmerhöfeler Weg 5",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "234-000",
            "name": "Paddocktrail  in Melle  (Nr.234-000)",
            "street": "Haseweg 11",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "235-000",
            "name": "Repeler Hof  in Bottrop  (Nr.235-000)",
            "street": "Repeler Weg 25",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "236-000",
            "name": "DraBo Ranch  in Nottuln  (Nr.236-000)",
            "street": "Kley 66",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "238-000",
            "name": "Privatstall Bindernagel  in Rheine  (Nr.238-000)",
            "street": "Russenweg 16",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "239-000",
            "name": "RC. St. Mauritz  in Münster (Nr.239-000)",
            "street": "Pleistermühlenweg 144",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "240-000",
            "name": "Hof Brengenberg  in Haltern am See (Nr.240-000)",
            "street": "Dorstener Straße 950",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "241-000",
            "name": "Reiterhof Wilmsberg  in Steinfurt (Nr.241-000)",
            "street": "Wilmsberg 35a",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "242-000",
            "name": "Stall Hesseler  in Bottrop  (Nr.242-000)",
            "street": "Brabecker Feld  29A",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "243-000",
            "name": "Hof Mersmann  in Laer (Nr.243-000)",
            "street": "Altenbergerstrasse 3",
            "house_number": "1",
            "zipcode": "48366",
            "city": "Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "244-000",
            "name": "Mein Offenstall in Nordhorn (Nr.244-000)",
            "street": "Harmsenweg 6",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "245-000",
            "name": "Privatstall Surmann in Lingen (Nr.245-000)",
            "street": "Bawinkler Straße 5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "246-000",
            "name": "RuFV von Nagel Herbern in Ascheberg (Nr.246-000)",
            "street": "Am Haselbüschken 5",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "247-000",
            "name": "Reitanlage Tögemann in Marl (Nr.247-000)",
            "street": "Obersinsener Str 172",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "248-000",
            "name": "Sennekamp in Hamm (Nr.248-000)",
            "street": "Baumstraße 47",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "249-000",
            "name": "Stall Schulze Zumkley in Olfen (Nr.249-000)",
            "street": "Im Hagen 1",
            "house_number": "1",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "250-000",
            "name": "Can Equi in Halle Westfalen (Nr.250-000)",
            "street": "Haller Strasse 8",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Halle Westfalen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "251-000",
            "name": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See e.V. in Haltern am See (Nr.251-000)",
            "street": "Münsterstraße 163",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "252-000",
            "name": "Vor dem Brocke in Lingen (Nr.252-000)",
            "street": "Hohlweg 2",
            "house_number": "1",
            "zipcode": "49808",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "253-000",
            "name": "Reitverein Vorhelm Schäringer Feld in Ahlen (Nr.253-000)",
            "street": "Enniger Str. 70",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "254-000",
            "name": "Gut Hohenkamp in Dorsten (Nr.254-000)",
            "street": "Hohenkamp 75",
            "house_number": "1",
            "zipcode": "46284",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "255-000",
            "name": "Pferdepension Mühlenbeck in Münster  (Nr.255-000)",
            "street": "Roxeler Straße 447",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "256-000",
            "name": "Lackmanns Hof in Recklinghausen (Nr.256-000)",
            "street": "Nonnenbuschweg 24",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "257-000",
            "name": "Weeke in Lienen (Nr.257-000)",
            "street": "Glandorfer Damm 48",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "258-000",
            "name": "Privatstall Dijital Santalar in Thuine (Nr.258-000)",
            "street": "Messinger Straße 4",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "259-000",
            "name": "Privater Bauernhof Albersloh in Sendenhorst (Nr.259-000)",
            "street": "Sunger 6a",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "260-000",
            "name": "Gut Behringhausen in Castrop-Rauxel (Nr.260-000)",
            "street": "Westring 135",
            "house_number": "1",
            "zipcode": "44575",
            "city": "Castrop-Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "261-000",
            "name": "Kinderreitschule Gießler in Münster (Nr.261-000)",
            "street": "Buddenbrink 70",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "262-000",
            "name": "Schräder in Ladbergen (Nr.262-000)",
            "street": "Am Venn 26",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "263-000",
            "name": "Mindrup in Münster (Nr.263-000)",
            "street": "Kreuzbach 40",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "264-000",
            "name": "Otte in Gronau-Epe (Nr.264-000)",
            "street": "Gerdingseite 13",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "265-000",
            "name": "Pensionsstall Perm in Ibbenbbüren (Nr.265-000)",
            "street": "Permer Straße 120",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "266-000",
            "name": "Reitanlage Schloss Wilbringen  in Waltrop (Nr.266-000)",
            "street": "Wilbringen 1",
            "house_number": "1",
            "zipcode": "45371",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "267-000",
            "name": "Familie Winzen  in Reken (Nr.267-000)",
            "street": "Vossplacke 4a",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "268-000",
            "name": "Am Dewesberg in Hopsten (Nr.268-000)",
            "street": "Am Dewesberg 1",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "269-000",
            "name": "Pferdehof Bohlmann in Bippen (Nr.269-000)",
            "street": "Schockländer Straße 5",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Bippen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "270-000",
            "name": "Diekmanns Freigänger in Borken  (Nr.270-000)",
            "street": "Boesweg 38",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "271-000",
            "name": "Hof Dahlkamp in Selm - Cappenberg (Nr.271-000)",
            "street": "Zum Birkenbaum 60",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm - Cappenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "272-000",
            "name": "Privatstall Boedeker in Vreden  (Nr.272-000)",
            "street": "Theodor Heuss Str. 4",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "273-000",
            "name": "Kurk in Greven  (Nr.273-000)",
            "street": "Hüttruper Str. 193",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "274-000",
            "name": "Ponyrosa Ranch in Wadersloh (Nr.274-000)",
            "street": "Herzebrockweg 3",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "275-000",
            "name": "Privatstall Deupmann in Rheine  (Nr.275-000)",
            "street": "Salzbergener Str. ",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "276-000",
            "name": "Münch in Recklinghausen (Nr.276-000)",
            "street": "Hoher Steinweg 33",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "277-000",
            "name": "Schwenken in Münster (Nr.277-000)",
            "street": "Davertstrasse 137",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "278-000",
            "name": "Pferdepension Middelhoff in Steinfurt (Nr.278-000)",
            "street": "Hollicher Straße 99",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "279-000",
            "name": "Pferdepension Northoff  in Ahlen  (Nr.279-000)",
            "street": "Borbeiner Straße 28",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "280-000",
            "name": "Privatstall Ehring in Hörstel (Nr.280-000)",
            "street": "Emsdettener Str. 205",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "281-000",
            "name": "Privatstall Schaffrinna in Lünen (Nr.281-000)",
            "street": "An der Wethmarheide 120",
            "house_number": "1",
            "zipcode": "44536",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "282-000",
            "name": "Keßler's Landhaus in Münster (Nr.282-000)",
            "street": "Raringheide 226",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "283-000",
            "name": "Reiterhof Beermann in Senden (Nr.283-000)",
            "street": "Leversum 13",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "284-000",
            "name": "Privatstall Dove in Schüttorf (Nr.284-000)",
            "street": "Narzissenstraße 18",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "285-000",
            "name": "Stall Gruber in Vreden  (Nr.285-000)",
            "street": "Doemern ",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "286-000",
            "name": "Privatstall Riering in Havixbeck (Nr.286-000)",
            "street": "Sentrupskamp 14",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "287-000",
            "name": "Hof Koch in Marl (Nr.287-000)",
            "street": "Forststr. 78",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "288-000",
            "name": "Privatstall Burgmann in Rheine  (Nr.288-000)",
            "street": "Wadelheimer Chaussee 84",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "289-000",
            "name": "Privatstall Bütergerds in Neuenkirchen (Nr.289-000)",
            "street": "Pfarrer-Bette-Str. 5",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "290-000",
            "name": "Pferdezucht Brömmelland in Dorsten (Nr.290-000)",
            "street": "Endelner Weg 201",
            "house_number": "1",
            "zipcode": "48286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "291-000",
            "name": "Ütrecht in Samern (Nr.291-000)",
            "street": "Ohnerstr. 129 129",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Samern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "292-000",
            "name": "Föcking in Südlohn (Nr.292-000)",
            "street": "Amselstrasse 29",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "293-000",
            "name": "Islandpferde Ems-Land in Geeste (Nr.293-000)",
            "street": "Erikastrasse 5",
            "house_number": "1",
            "zipcode": "49744",
            "city": "Geeste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "294-000",
            "name": "Winterhalder in Gronau (Nr.294-000)",
            "street": "Röntgenstr. 11",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "295-000",
            "name": "Hof Stukenborg in Haltern am See (Nr.295-000)",
            "street": "Rekenerstraße 221",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "296-000",
            "name": "Equiva Rheine in Rheine  (Nr.296-000)",
            "street": "Hansaallee 49-51",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "297-000",
            "name": "Hof Heemann - Pensionsstallbetrieb in Lienen (Nr.297-000)",
            "street": "Nigge Weg ",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "298-000",
            "name": "Privatstall Kempkes in Hörstel (Nr.298-000)",
            "street": "Waldstr 17",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "299-000",
            "name": "Privatstall Janson in Coesfeld (Nr.299-000)",
            "street": "Herteler 32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "300-000",
            "name": "Lüttecke in Telgte (Nr.300-000)",
            "street": "Sickerhook 9",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "301-000",
            "name": "Gestüt Wechter Mark in Lengerich (Nr.301-000)",
            "street": "Wechter Str. 108",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "305-000",
            "name": "Equiva Osnabrück in Osnabrück (öffentlich) (Nr.305-000)",
            "street": "Pagenstecherstraße 28",
            "house_number": "1",
            "zipcode": "49090",
            "city": "Osnabrück (öffentlich)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "306-000",
            "name": "Bönen Hacheney in Bönen (Nr.306-000)",
            "street": "Heidestrasse 2",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "307-000",
            "name": "Pferdehof Brinkrolf in Rheda-Wiedenbrück (Nr.307-000)",
            "street": "Moorweg 112",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "308-000",
            "name": "Schulze Brüning in Münster (Nr.308-000)",
            "street": "Kanalstraße 340",
            "house_number": "1",
            "zipcode": "48143",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "309-000",
            "name": "Privatstall Jäschke in Coesfeld (Nr.309-000)",
            "street": "Südring 10",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "310-000",
            "name": "Funke in Hamm (Nr.310-000)",
            "street": "Ahlenerstrasse 240",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "311-000",
            "name": "Ludger Zumvenne in Senden (Nr.311-000)",
            "street": "Gettrup 44",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "312-000",
            "name": "Spreckelmeyer in Lienen (Nr.312-000)",
            "street": "Am Hagen 2",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "313-000",
            "name": "Lennarz in Münster (Nr.313-000)",
            "street": "Am Knapp ",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "314-000",
            "name": "Reitanlage Niehoff in Havixbeck (Nr.314-000)",
            "street": "Schonebeck 24",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "315-000",
            "name": "Privatstall Annuß in Recklinghausen (Nr.315-000)",
            "street": "Marienstr. 36",
            "house_number": "1",
            "zipcode": "45663",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "316-000",
            "name": "Köpper in Schermbeck (Nr.316-000)",
            "street": "Janbrucksfeld 92",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "317-000",
            "name": "Brinkel in Spelle (Nr.317-000)",
            "street": "Englandstraße 11",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "318-000",
            "name": "Holz Ahmann in Emsdetten (Nr.318-000)",
            "street": "Dettener Straße 10a",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "319-000",
            "name": "Privater Offenstall Scholten in Velen-Ramsdorf (Nr.319-000)",
            "street": "Südlohner Diek ",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Velen-Ramsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "320-000",
            "name": "Hölscher Pferde in Emsdetten (Nr.320-000)",
            "street": "Grünring  74",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "321-000",
            "name": "Doetkotte in Gronau (Nr.321-000)",
            "street": "Doetkottenweg  66",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "322-000",
            "name": "Hof Hidding Schulte-Bockum in Bottrop  (Nr.322-000)",
            "street": "Kreienkampsweg  9",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "323-000",
            "name": "Reitstall Neumann in Haltern am See (Nr.323-000)",
            "street": "Hellweg 230",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "324-000",
            "name": "Privatstall Meusel in Werne (Nr.324-000)",
            "street": "Münsterstraße 42",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "325-000",
            "name": "Gestüt Forellenhof in Borken  (Nr.325-000)",
            "street": "Zum Homborn 9",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "326-000",
            "name": "Reitsportanlage Melanie Menzefricke in Versmold (Nr.326-000)",
            "street": "Friedrich-Menzefrickestr. 51",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "327-000",
            "name": "Hemme in Emsbüren (Nr.327-000)",
            "street": "Zum Schultenhook 8",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "328-000",
            "name": "Pferdehof Moorheide in Senden (Nr.328-000)",
            "street": "Kley 32",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "329-000",
            "name": "Hollmann in Senden (Nr.329-000)",
            "street": "Kley  14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "330-000",
            "name": "Pferdeparadies Lögering in Lingen-Bramsche (Nr.330-000)",
            "street": "Wesel  4",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen-Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "331-000",
            "name": "Privatstall Storp in Münster (Nr.331-000)",
            "street": "Hartmannsbrook 92",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "332-000",
            "name": "Hof Wimschulte in Drensteinfurt (Nr.332-000)",
            "street": "Nordholt 3",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "333-000",
            "name": "Privatstall Dasmann in Tecklenburg (Nr.333-000)",
            "street": "Dast 1",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "335-000",
            "name": "Selbstversorger Niemand in Welver (Nr.335-000)",
            "street": "Im Loh 7a",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "336-000",
            "name": "Ausbildungsstall Koeppel in Glandorf (Nr.336-000)",
            "street": "Laersche Straße  28",
            "house_number": "1",
            "zipcode": "49219",
            "city": "Glandorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "337-000",
            "name": "Menke in Thuine (Nr.337-000)",
            "street": "Mühlenstraße 4a",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Thuine",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "338-000",
            "name": "Schulze Topphoff in Telgte (Nr.338-000)",
            "street": "Lütken Heide 45",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "339-000",
            "name": "Privatstall Helms in Bergkamen (Nr.339-000)",
            "street": "Kamer Heide  34",
            "house_number": "1",
            "zipcode": "59192",
            "city": "Bergkamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "340-000",
            "name": "Zeirabenhof in Sendenhorst (Nr.340-000)",
            "street": "Jönsthövel  6",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "341-000",
            "name": "Beckmann in Coesfeld (Nr.341-000)",
            "street": "Flamschen 8",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "342-000",
            "name": "Reitsportanlage Kuhlmann in Marl (Nr.342-000)",
            "street": "Dahlbrede 5",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "343-000",
            "name": "Privatstall Jansen in Rheine  (Nr.343-000)",
            "street": "Steinstr.  13b",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "344-000",
            "name": "SG Schröder Hardinghausen in Bottrop-Kirchhellen (Nr.344-000)",
            "street": "An der Harre  2",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop-Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "345-000",
            "name": "Privatstall Greven / Schmedehausen in Greven  (Nr.345-000)",
            "street": "Ostbevener Straße 26",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "346-000",
            "name": "FuRV Wettringen in Wettringen (Nr.346-000)",
            "street": "Burgsteinfurter Straße  28",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "347-000",
            "name": "Bennie Kleijn in Havixbeck (Nr.347-000)",
            "street": "Natrup  35",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "348-000",
            "name": "Jährlingsstation Deitermann in Horstmar, Leer (Nr.348-000)",
            "street": "Haltern 30",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar, Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "349-000",
            "name": "Privatstall Grave in Lienen (Nr.349-000)",
            "street": "Wulversump 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "350-000",
            "name": "Pensionsstall in Warendorf (Nr.350-000)",
            "street": "Neuwarendorf 64",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "351-000",
            "name": "Familie Beckersjürgen in Nottuln  (Nr.351-000)",
            "street": "Leopoldshöhe 6",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "352-000",
            "name": "Privatstall Wenzel in Greven  (Nr.352-000)",
            "street": "Anna-Badouin-Straße  55",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "353-000",
            "name": "Reitgemeinschaft Bönen Hacheney in Bönen (Nr.353-000)",
            "street": "Heidestraße 45",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "354-000",
            "name": "Hof Rottmann in Münster (Nr.354-000)",
            "street": "Gasselstiege 235",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "355-000",
            "name": "Fahrsportzentrum Ennigerloh in Ennigerloh  (Nr.355-000)",
            "street": "Vossmar 10",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "356-000",
            "name": "Hofstelle Dennemann in Ohne (Nr.356-000)",
            "street": "Möllenweg ",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Ohne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "357-000",
            "name": "Gestüt Heidhügel in Emsdetten (Nr.357-000)",
            "street": "Isendorfer Weg 34",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "358-000",
            "name": "Offenstall Vandreuke in Herten (Nr.358-000)",
            "street": "Backumerstr. 416",
            "house_number": "1",
            "zipcode": "45699",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "359-000",
            "name": "Klostermann in Rheine  (Nr.359-000)",
            "street": "Maiglöckchenweg  45",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "360-000",
            "name": "Kuper in Spelle (Nr.360-000)",
            "street": "Schlanestraße  17",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "361-000",
            "name": "Schürkamp in Ahlen (Nr.361-000)",
            "street": "Hagenbrede 70",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "362-000",
            "name": "Beutnagel in Spelle (Nr.362-000)",
            "street": "Stubbendorfstraße 11",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "363-000",
            "name": "Privatstall Viefhues in Riesenbeck (Nr.363-000)",
            "street": "Kanalstraße 179",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "364-000",
            "name": "Franke in Lüdinghausen (Nr.364-000)",
            "street": "Westrup  59",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "365-000",
            "name": "Ulmker in Neuenkirchen (Nr.365-000)",
            "street": "Mesumer Str.  75",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "366-000",
            "name": "Mersmann in Münster (Nr.366-000)",
            "street": "Böckenhorst 18",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "367-000",
            "name": "FS Paradise in Nordhorn (Nr.367-000)",
            "street": "Emsbürener Str. 50",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "368-000",
            "name": "Haus Küchen in Ahlen (Nr.368-000)",
            "street": "Mallinckrodtweg 25",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "369-000",
            "name": "Hof Gerlemann in Meppen (Nr.369-000)",
            "street": "Dorfstraße 14",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "371-000",
            "name": "Schnarre in Lotte (Nr.371-000)",
            "street": "Düter Str. 8",
            "house_number": "1",
            "zipcode": "49504",
            "city": "Lotte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "372-000",
            "name": "Gestüt Landhaus Schweckendieck in Wietmarschen  (Nr.372-000)",
            "street": "Am Moersfeld 33",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "373-000",
            "name": "Große Wittler in Münster (Nr.373-000)",
            "street": "Davertstraße 198",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "374-000",
            "name": "Hof Diesen in Emsdetten (Nr.374-000)",
            "street": "Aechterhoek 16",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "375-000",
            "name": "Trainingszentrum Hoffrogge in Dorsten (Nr.375-000)",
            "street": "Bestener Straße 145",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "376-000",
            "name": "Reitanlage Stapelskotten in Münster (Nr.376-000)",
            "street": "Am Mooresch  34",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "377-000",
            "name": "ZRFV Borken e.V in Borken Weseken (Nr.377-000)",
            "street": "Pröbstinger Allee 10",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken Weseken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "378-000",
            "name": "Von Kleinsorgen in Coesfeld (Nr.378-000)",
            "street": "Kalte 4",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "379-000",
            "name": "Zucht,-Reit und Fahrverein Rheine e.V. in Rheine  (Nr.379-000)",
            "street": "In der Lake 12",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "380-000",
            "name": "Strotjohann in Ostbevern (Nr.380-000)",
            "street": "Reichard-Str.  9",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "381-000",
            "name": "Schulze Temberge in Gronau (Nr.381-000)",
            "street": "Gerdingseite 3",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "382-000",
            "name": "Privatstall Rehbaum in Sendenhorst (Nr.382-000)",
            "street": "Sunger 18",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "383-000",
            "name": "Schulze Elfringhof in Ochtrup (Nr.383-000)",
            "street": "Weiner 133",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "384-000",
            "name": "Averhaus in Emsdetten (Nr.384-000)",
            "street": "Saerbecker Weg 31",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "385-000",
            "name": "Ahlbrand Pferdefutter in Münster (Nr.385-000)",
            "street": "Dalkamp  14",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "386-000",
            "name": "Peterka in Legden (Nr.386-000)",
            "street": "Wehr 159",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "387-000",
            "name": "Reitstall Stein in Wietmarschen  (Nr.387-000)",
            "street": "Wietmarschener Straße 9",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "388-000",
            "name": "Reitstall Hille in Ladbergen (Nr.388-000)",
            "street": "Brockwiesen 32",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "389-000",
            "name": "Reitstall Otten in Lingen (Nr.389-000)",
            "street": "Hüsinger Hook 2",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "390-000",
            "name": "Strodt in Lingen (Nr.390-000)",
            "street": "Schulstraße  5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "391-000",
            "name": "Eichenhof in Havixbeck (Nr.391-000)",
            "street": "Masbeck 2",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "392-000",
            "name": "Privatstall Gottschald in Stavern (Nr.392-000)",
            "street": "Sögeler Straße 19",
            "house_number": "1",
            "zipcode": "49777",
            "city": "Stavern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "393-000",
            "name": "Privatstall Beckmann in Lienen (Nr.393-000)",
            "street": "Glandorfer Damm 5",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "394-000",
            "name": "Eichenhof Beppen in Thedinghausen (Nr.394-000)",
            "street": "Neu-Morsumer-Weg  8",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "395-000",
            "name": "Siedehof in Steyerberg (Nr.395-000)",
            "street": "Voigtei 111",
            "house_number": "1",
            "zipcode": "31595",
            "city": "Steyerberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "396-000",
            "name": "Pferdepension Wilke in Diepholz (Nr.396-000)",
            "street": "Moorhäuser Str.  25",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "397-000",
            "name": "Stall Daubert in Sögel (Nr.397-000)",
            "street": "Stavernerstrasse  1",
            "house_number": "1",
            "zipcode": "49751",
            "city": "Sögel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "398-000",
            "name": "Schnier in Bad Oeynhausen/ Werste (Nr.398-000)",
            "street": "Ringstraße 77",
            "house_number": "1",
            "zipcode": "32549",
            "city": "Bad Oeynhausen/ Werste",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "399-000",
            "name": "Sasse in Recklinghausen (Nr.399-000)",
            "street": "Franziskanerstr. 60",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "400-000",
            "name": "Hof Suntrup in Warendorf (Nr.400-000)",
            "street": "Gronhorst 14",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "401-000",
            "name": "Hugerlandshof in Münster-Handorf (Nr.401-000)",
            "street": "Hugerlandshofweg 70",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster-Handorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "402-000",
            "name": "Privatstall von Abel in Elsfleth (Nr.402-000)",
            "street": "Oberrege  49",
            "house_number": "1",
            "zipcode": "26931",
            "city": "Elsfleth",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "403-000",
            "name": "Reiterhof Redder in Bad Driburg (Nr.403-000)",
            "street": "An der Steinbrücke ",
            "house_number": "1",
            "zipcode": "33014",
            "city": "Bad Driburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "404-000",
            "name": "Pensionsstall Heuermann in Vlotho (Nr.404-000)",
            "street": "Hettenholter Weg  37",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "405-000",
            "name": "Gerusel in Dörentrup Wendlinghausen (Nr.405-000)",
            "street": "Friedrichsfeld 2",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup Wendlinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "406-000",
            "name": "Campingplatz Schöne Ausdicht in Vlotho (Nr.406-000)",
            "street": "Lehmhöhlenweg 5",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "407-000",
            "name": "Pferdepension Wibbelmann in Bissendorf (Nr.407-000)",
            "street": "Niederberger Mark  31",
            "house_number": "1",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "408-000",
            "name": "Stall Holtkamp in Kirchlegern (Nr.408-000)",
            "street": "Brannecker Str. 56",
            "house_number": "1",
            "zipcode": "32278",
            "city": "Kirchlegern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "409-000",
            "name": "Igelmann in Bissendorf (Nr.409-000)",
            "street": "Bergstrasse  98a",
            "house_number": "1",
            "zipcode": "49153",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "410-000",
            "name": "Hof Gockel in Paderborn (Nr.410-000)",
            "street": "Dörener Holzweg 65",
            "house_number": "1",
            "zipcode": "33100",
            "city": "Paderborn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "411-000",
            "name": "Meiners in Lorup (Nr.411-000)",
            "street": "Kirchkamp 37",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Lorup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "412-000",
            "name": "Stall Aldag in Minden (Nr.412-000)",
            "street": "Mitteldamm 60",
            "house_number": "1",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "413-000",
            "name": "Privatstall Ewen in Hude (Nr.413-000)",
            "street": "Erlenweg 1",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "414-000",
            "name": "Blub in Colnrade (Nr.414-000)",
            "street": "Holtesche 5",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Colnrade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "415-000",
            "name": "Reitsport-Waldweg in Emtinghausen (Nr.415-000)",
            "street": "Waldweg 8",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Emtinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "416-000",
            "name": "Reit-und Fahrverein Wagenfeld in Wagenfeld (Nr.416-000)",
            "street": "Fritz-Cording-Str. 1",
            "house_number": "1",
            "zipcode": "49419",
            "city": "Wagenfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "417-000",
            "name": "Privatstall Kröger in Löhne (Nr.417-000)",
            "street": "Kirschenweg 5",
            "house_number": "1",
            "zipcode": "32584",
            "city": "Löhne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "418-000",
            "name": "Privatstall Goßling in Westoverledingen (Nr.418-000)",
            "street": "Heerweg 6",
            "house_number": "1",
            "zipcode": "26810",
            "city": "Westoverledingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "419-000",
            "name": "Sonntag Bielefeld in Bielefeld (Nr.419-000)",
            "street": "Hillegosser Str. 135",
            "house_number": "1",
            "zipcode": "33719",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "420-000",
            "name": "Lieschen's Ranch in Kirchlengern (Nr.420-000)",
            "street": "Horstfeld 37",
            "house_number": "1",
            "zipcode": "32278",
            "city": "Kirchlengern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "421-000",
            "name": "Gut Vinnen in Bad Salzuflen (Nr.421-000)",
            "street": "Vinnen 2",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "422-000",
            "name": "Radtke in Bremen (Nr.422-000)",
            "street": "Am Grenzknick 17a",
            "house_number": "1",
            "zipcode": "28755",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "423-000",
            "name": "Islandpferdehof Lukka in Lemgo (Nr.423-000)",
            "street": "Am Tiefen Siek 65",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "424-000",
            "name": "Ratering in Walchum (Nr.424-000)",
            "street": "Westweg  61",
            "house_number": "1",
            "zipcode": "26907",
            "city": "Walchum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "425-000",
            "name": "Kronenkamp Ranch in Bad Zwischenahn (Nr.425-000)",
            "street": "Kronenkamp 2",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "426-000",
            "name": "Petvitalshop in Bünde (Nr.426-000)",
            "street": "Elsemühlenweg 85",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "427-000",
            "name": "Overhagener Pferdehof in Bottrop (Nr.427-000)",
            "street": "Hoheheideweg 4",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "428-000",
            "name": "Claaßen in Bramsche (Nr.428-000)",
            "street": "Schleptruper Strang 64",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "429-000",
            "name": "Privatstall Junga in Bramsche (Nr.429-000)",
            "street": "Rote Riede  8",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "430-000",
            "name": "Halhof in Bielefeld (Nr.430-000)",
            "street": "Talbrückenstr. 142",
            "house_number": "1",
            "zipcode": "33609",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "431-000",
            "name": "Privatstall Rippelbeck in Bramsche (Nr.431-000)",
            "street": "Wiechmanns Ecke 3",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "432-000",
            "name": "Privatstall Semmler in Bramsche (Nr.432-000)",
            "street": "Haferkamp 21",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "433-000",
            "name": "Landgut Papenhausen in Bad Salzuflen (Nr.433-000)",
            "street": "Papenhausen 2",
            "house_number": "1",
            "zipcode": "32108",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "434-000",
            "name": "Stall Wessels in Rastede (Nr.434-000)",
            "street": "Am Eichenwall 100",
            "house_number": "1",
            "zipcode": "26180",
            "city": "Rastede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "435-000",
            "name": "Von Essen in Rastede (Nr.435-000)",
            "street": "Heiddornweg  14",
            "house_number": "1",
            "zipcode": "26180",
            "city": "Rastede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "436-000",
            "name": "Privatstall Börger in Delbrück (Nr.436-000)",
            "street": "Ehlersweg 5",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "437-000",
            "name": "Hof Eicheneck in Menslage (Nr.437-000)",
            "street": "Antener Str. 5",
            "house_number": "1",
            "zipcode": "49637",
            "city": "Menslage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "438-000",
            "name": "Knemeyer in Borgholzhausen (Nr.438-000)",
            "street": "Illenbruch 3",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Borgholzhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "439-000",
            "name": "Gnadenhof die Geretteten e.V. in Rahden (Nr.439-000)",
            "street": "Örlingerhausen 4",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "440-000",
            "name": "Stallgemeinschaft in Esterwegen (Nr.440-000)",
            "street": "Mühlenberg 9",
            "house_number": "1",
            "zipcode": "26897",
            "city": "Esterwegen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "441-000",
            "name": "Reitsportanlage Berg in Hiddenhausen (Nr.441-000)",
            "street": "Lipinghauserstr. 101",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "442-000",
            "name": "Kinder Wald und Wiese Bremen e.V. in Bremen (Nr.442-000)",
            "street": "Papenkampsweg  12",
            "house_number": "1",
            "zipcode": "28213",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "443-000",
            "name": "Harms in Wardenburg (Nr.443-000)",
            "street": "Saarländer Weg 335",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "444-000",
            "name": "Brunklaus in Benstrup (Nr.444-000)",
            "street": "Zuschläge 2",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Benstrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "445-000",
            "name": "Stall Mehrhoff in Hille (Nr.445-000)",
            "street": "Burkampweg 21",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "446-000",
            "name": "Freiberger Zucht Solenzki in Bremen (Nr.446-000)",
            "street": "Hospitalstr ",
            "house_number": "1",
            "zipcode": "28777",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "447-000",
            "name": "Reitstall Niederbäumer in Hiddenhausen (Nr.447-000)",
            "street": "Lippinghauser Str. 59",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "448-000",
            "name": "Privatstall Scharringhausen in Harpstedt (Nr.448-000)",
            "street": "Nordstr. 72",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Harpstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "449-000",
            "name": "Struckmann in Lähden (Nr.449-000)",
            "street": "An der Riehe 15",
            "house_number": "1",
            "zipcode": "49774",
            "city": "Lähden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "450-000",
            "name": "Reit- und Fahrverein Cappeln e.V. in Cappeln (Nr.450-000)",
            "street": "Kösters Weg 3",
            "house_number": "1",
            "zipcode": "49692",
            "city": "Cappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "451-000",
            "name": "R.V Welver in Welver (Nr.451-000)",
            "street": "Werlerstr 32",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "452-000",
            "name": "Privatstall Leymann in Diepholz (Nr.452-000)",
            "street": "An der Bahn 39",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "453-000",
            "name": "Molenberg in Rhede/Neurhede (Nr.453-000)",
            "street": "Hauptstraße  49",
            "house_number": "1",
            "zipcode": "26899",
            "city": "Rhede/Neurhede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "454-000",
            "name": "Reitverein Espelkamp in Vehlage (Nr.454-000)",
            "street": "Levenerstraße 4",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Vehlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "455-000",
            "name": "Islandpferdehof Frank Kasperczyk in Stuhr (Nr.455-000)",
            "street": "Kronsbruch 9",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "456-000",
            "name": "Reitstall Rath in Borchen (Nr.456-000)",
            "street": "Schmalzgrube  1",
            "house_number": "1",
            "zipcode": "33178",
            "city": "Borchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "457-000",
            "name": "Rosenberg in Freren (Nr.457-000)",
            "street": "Oststrasse 11",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Freren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "458-000",
            "name": "Privatstall Lübbe in Höltinghausen (Nr.458-000)",
            "street": "Eschstraße 18",
            "house_number": "1",
            "zipcode": "49685",
            "city": "Höltinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "459-000",
            "name": "Privatstall Dehlwisch in Bremen (Nr.459-000)",
            "street": "Waller Heerstr. 61",
            "house_number": "1",
            "zipcode": "28217",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "460-000",
            "name": "Eike Holfeld in Wiefelstede (Nr.460-000)",
            "street": "Hoher Kamp 5",
            "house_number": "1",
            "zipcode": "26215",
            "city": "Wiefelstede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "461-000",
            "name": "Meyer zu Lösebeck in Melle (Nr.461-000)",
            "street": "Gerdenerstr. 20",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "462-000",
            "name": "Privatstall Damrow in Hatten (Nr.462-000)",
            "street": "Hatter Straße 8",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "463-000",
            "name": "Hof Franzen in Marl (Nr.463-000)",
            "street": "Linder Weg 1",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "464-000",
            "name": "Beyer in Melle (Nr.464-000)",
            "street": "Hünenburgweg 52",
            "house_number": "1",
            "zipcode": "49328",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "465-000",
            "name": "Nehring/Maßmann in Rhauderfehn (Nr.465-000)",
            "street": "Buurnweg  5",
            "house_number": "1",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "466-000",
            "name": "Offenstall Köhler Dingstede in Hatten (Nr.466-000)",
            "street": "Nutteler Str. 1a",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "467-000",
            "name": "Hof Wöschenland in Hude (Nr.467-000)",
            "street": "Holler Landstr. 74",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "468-000",
            "name": "Lensmann in Oer-Erkenschwick (Nr.468-000)",
            "street": "Sinsenerstr. 315",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "469-000",
            "name": "Pensionsstall Heidehof in Wardenburg (Nr.469-000)",
            "street": "Saarländer Weg 400",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "470-000",
            "name": "Reiterhof Keuper in Salzkotten (Nr.470-000)",
            "street": "Hederbornstraße 11",
            "house_number": "1",
            "zipcode": "33154",
            "city": "Salzkotten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "471-000",
            "name": "Privatstall Müller-Klein in Bruchhausen-Vilsen (Nr.471-000)",
            "street": "Wöpser Berg 1",
            "house_number": "1",
            "zipcode": "27305",
            "city": "Bruchhausen-Vilsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "472-000",
            "name": "Ostholz in Hamm (Nr.472-000)",
            "street": "Alter Uentroper Weg 263",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "473-000",
            "name": "Privatstall Dauth in Ganderkesee (Nr.473-000)",
            "street": "Müllerweg 11",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "474-000",
            "name": "Privatstall Hrudzik in Mellinghausen (Nr.474-000)",
            "street": "Hoyanerstrasse 21",
            "house_number": "1",
            "zipcode": "27349",
            "city": "Mellinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "475-000",
            "name": "Stall Sahlenbeck in Haren (Nr.475-000)",
            "street": "Am Donnerberg 19",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "476-000",
            "name": "Privatstall Kral in Groß Ippener (Nr.476-000)",
            "street": "Dorfstr. 13",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Groß Ippener",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "477-000",
            "name": "Hüting in Paderborn (Nr.477-000)",
            "street": "Fürstenallee 124",
            "house_number": "1",
            "zipcode": "33102",
            "city": "Paderborn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "478-000",
            "name": "Reiterhof Holsterbrink in Dülmen (Nr.478-000)",
            "street": "Holsterbrink 38",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "479-000",
            "name": "Helming Drees in Engden (Nr.479-000)",
            "street": "Emsbürener Straße 9",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Engden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "480-000",
            "name": "Alte Heide in Vrees (Nr.480-000)",
            "street": "Alte Heide 2",
            "house_number": "1",
            "zipcode": "49757",
            "city": "Vrees",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "481-000",
            "name": "Stall Obermowe in Vlotho (Nr.481-000)",
            "street": "Zum Mergelbruch 1",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "482-000",
            "name": "Kampeter in Bielefeld (Nr.482-000)",
            "street": "Buschkampstraße 1",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "483-000",
            "name": "Reitstall Howe in Lengerich (Nr.483-000)",
            "street": "Strohdamm 10",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "484-000",
            "name": "Ponyhof Deipenbrock in Hamm (Nr.484-000)",
            "street": "Holsen 9",
            "house_number": "1",
            "zipcode": "59075",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "485-000",
            "name": "Dengler in Werne (Nr.485-000)",
            "street": "Hagenrain 1",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "486-000",
            "name": "Kappel in Rheda-Wiedenbrück (Nr.486-000)",
            "street": "Emser Landstr 13",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "487-000",
            "name": "Wacker in Nordkirchen (Nr.487-000)",
            "street": "Zum Brotacker 13",
            "house_number": "1",
            "zipcode": "59394",
            "city": "Nordkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "488-000",
            "name": "H.S. Reitsport in Hude (Nr.488-000)",
            "street": "Knutzenweg 1",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "489-000",
            "name": "Josephshof in Warendorf (Nr.489-000)",
            "street": "Sassenberger Strasse  43",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "490-000",
            "name": "Privatstall Hermann in Gütersloh (Nr.490-000)",
            "street": "Münsterlandstr. 110",
            "house_number": "1",
            "zipcode": "33334",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "491-000",
            "name": "Privatstall Meyer in Rastdorf (Nr.491-000)",
            "street": "Wiesenweg 1",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Rastdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "492-000",
            "name": "Weetkorn in Bad Zwischenahn (Nr.492-000)",
            "street": "Mastenweg 67",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "493-000",
            "name": "Reitsportanlage Sonntag in Jöllenbeck (Nr.493-000)",
            "street": "Eckumer Straße 168",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Jöllenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "494-000",
            "name": "Reitstall Brinkmann in Lüdinghausen (Nr.494-000)",
            "street": "Westrup  37",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "495-000",
            "name": "Huster-Klatte in Lastrup (Nr.495-000)",
            "street": "Molbergstr. 37",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "496-000",
            "name": "Huder Pferdehof in Hude (Nr.496-000)",
            "street": "Am Postweg 4",
            "house_number": "1",
            "zipcode": "27798",
            "city": "Hude",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "497-000",
            "name": "Privatstall Bünde Holsen in Enger (Nr.497-000)",
            "street": "Rödinghauserstrasse 190",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Enger",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "498-000",
            "name": "Trippel Trappel Hof in Goldenstedt (Nr.498-000)",
            "street": "Brombeerhagen 11",
            "house_number": "1",
            "zipcode": "49424",
            "city": "Goldenstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "499-000",
            "name": "Reitsportzentrum Brundiers in Löningen Ehren (Nr.499-000)",
            "street": "Ehrener Kirchweg 3",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Löningen Ehren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "500-000",
            "name": "Hof Plate  in Syke  (Nr.500-000)",
            "street": "Bremer Str.  45",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "501-000",
            "name": "Vaske-Menke in Halen  (Nr.501-000)",
            "street": "Am Dorfplatz 16",
            "house_number": "1",
            "zipcode": "49685",
            "city": "Halen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "502-000",
            "name": "Aktivstall Steinloge in Großkneten  (Nr.502-000)",
            "street": "Im Glaner 10",
            "house_number": "1",
            "zipcode": "26197",
            "city": "Großkneten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "503-000",
            "name": "Hof Uhlmann  in Bad Essen  (Nr.503-000)",
            "street": "Eichkamp 14",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "504-000",
            "name": "Hof Wilmer in Coesfeld  in Coesfeld  (Nr.504-000)",
            "street": "Goxel  38",
            "house_number": "1",
            "zipcode": "48654",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "505-000",
            "name": "Hof Lossau in Rheine  in Rheine  (Nr.505-000)",
            "street": "Gottkenweg  57",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "506-000",
            "name": "Hof Schwert in Werne (Nr.506-000)",
            "street": "Südkirchener Straße 61",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "507-000",
            "name": "Hof Schlüter in Haltern am See (Nr.507-000)",
            "street": "Hülstener Weg  26",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "508-000",
            "name": "Dörhoff in Delbrück (Nr.508-000)",
            "street": "Haselhorster Straße 57",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "510-000",
            "name": "Kloppenburg in Edewecht (Nr.510-000)",
            "street": "Parkstraße 18e",
            "house_number": "1",
            "zipcode": "26188",
            "city": "Edewecht",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "511-000",
            "name": "Hilgen in Bad Zwischenahn (Nr.511-000)",
            "street": "Mittellinie 149",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "580-000",
            "name": "Kochjohann in Rietberg-Bokel (Nr.580-000)",
            "street": "An der Mühle 11",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg-Bokel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "513-000",
            "name": "Hof Landleben in Wettringen (Nr.513-000)",
            "street": "Rothenberge  12",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "514-000",
            "name": "Jostwerner in Delbrück (Nr.514-000)",
            "street": "Heierweg 73",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "515-000",
            "name": "Reitstall Heinrich Buschmann in Stuhr (Nr.515-000)",
            "street": "Siekstraße  150",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "516-000",
            "name": "Privatstall Wienöbst in Essen Oldenburg (Nr.516-000)",
            "street": "Postdamm 1",
            "house_number": "1",
            "zipcode": "49632",
            "city": "Essen Oldenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "517-000",
            "name": "Gut Berghausen in Recklinghausen (Nr.517-000)",
            "street": "Hoher Steinweg 40",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "518-000",
            "name": "Privatstall Tapken in Bad Zwischenahn (Nr.518-000)",
            "street": "Ekenermoorstraße 4",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "519-000",
            "name": "Privatstall Ramnitz in Rheine  (Nr.519-000)",
            "street": "Emscherstraße  7",
            "house_number": "1",
            "zipcode": "48431",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "520-000",
            "name": "Sudowe in Wallenhorst (Nr.520-000)",
            "street": "Haster Berg 2",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Wallenhorst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "521-000",
            "name": "Reiterhof Ahlemeyer in Melle (Nr.521-000)",
            "street": "Brinker Str. 36",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "522-000",
            "name": "Privatstall Keimeier in Ennigerloh  (Nr.522-000)",
            "street": "Zur Bunten Brücke 80",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Ennigerloh ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "523-000",
            "name": "Vehlager Zucht-, Reit- und Fahrverein in Vehlage (Nr.523-000)",
            "street": "Siebenweg ",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Vehlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "525-000",
            "name": "Schäfer in Delbrück (Nr.525-000)",
            "street": "Im Brinkort  15",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "526-000",
            "name": "Reitstall Wüllner in Bünde (Nr.526-000)",
            "street": "Lübbecker Str. 306",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "527-000",
            "name": "RG Eichengrund Welver in Welver (Nr.527-000)",
            "street": "Werler Strasse 34",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "528-000",
            "name": "Spiegeler in Gehrde (Nr.528-000)",
            "street": "Holdorferstrasse 4",
            "house_number": "1",
            "zipcode": "49596",
            "city": "Gehrde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "529-000",
            "name": "Bruchwiesen in Espelkamp (Nr.529-000)",
            "street": "Bruchwiesen  10",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "530-000",
            "name": "Zucht- und Pensionsstall Dirks in Isterberg (Nr.530-000)",
            "street": "Bentheimer Straße  8",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Isterberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "531-000",
            "name": "Wilken in Bockhorn (Nr.531-000)",
            "street": "Grabhorner Weg ",
            "house_number": "1",
            "zipcode": "26345",
            "city": "Bockhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "532-000",
            "name": "Schön in Barßel (Nr.532-000)",
            "street": "Carolinenhofstr.  2",
            "house_number": "1",
            "zipcode": "26676",
            "city": "Barßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "533-000",
            "name": "Hengstebeck in Heiden (Nr.533-000)",
            "street": "Neuer Weg 6",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "534-000",
            "name": "Reiterverein St Georg Saerbeck in Saerbeck (Nr.534-000)",
            "street": "Ibbenbürener Straße  47",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "535-000",
            "name": "Privatstall Börgel in Mettingen (Nr.535-000)",
            "street": "Nieheweg 66",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "536-000",
            "name": "Pferdehof Nolte in Vlotho (Nr.536-000)",
            "street": "Dornberger Heide 39",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vlotho",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "537-000",
            "name": "Ferienhof Junkern-Beel in Lathen (Nr.537-000)",
            "street": "Junkern-Beel 1",
            "house_number": "1",
            "zipcode": "49762",
            "city": "Lathen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "538-000",
            "name": "Reitanlage Wehmeyer in Bielefed (Nr.538-000)",
            "street": "Detmolder Str. 820",
            "house_number": "1",
            "zipcode": "33699",
            "city": "Bielefed",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "539-000",
            "name": "539000 in Herten (Nr.539-000)",
            "street": "Zufahrt Heukamp Backumer Straße 459",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "540-000",
            "name": "Hof Gerdes in Bad Zwischenahn (Nr.540-000)",
            "street": "Bloher Landstraße ",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "541-000",
            "name": "Reit- und Fahrverein Bottrop in Bottrop (Nr.541-000)",
            "street": "Beisenstrasse 18",
            "house_number": "1",
            "zipcode": "46242",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "542-000",
            "name": "Arens in Meppen (Nr.542-000)",
            "street": "Fullenerstr. 45",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "543-000",
            "name": "Poggemann in Greven  (Nr.543-000)",
            "street": "Emsdettener Damm 15",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "544-000",
            "name": "Katharina Jürgens in Hamm (Nr.544-000)",
            "street": "Lange Reihe 214",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "545-000",
            "name": "Privatstall May-Rosen in Marl (Nr.545-000)",
            "street": "Buerer Str.  65",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "546-000",
            "name": "Stall Haverkamp in Haltern am See (Nr.546-000)",
            "street": "Kuhlenweg 64",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "547-000",
            "name": "Hötkemeier in Porta Westfalica (Nr.547-000)",
            "street": "Möllbergerstr.  176",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "548-000",
            "name": "Schimmelhof Bremen in Bremen (Nr.548-000)",
            "street": "Osterholzer Dorfstraße 95",
            "house_number": "1",
            "zipcode": "28307",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "549-000",
            "name": "Reitstall Katenkamp in Stuhr Groß Mackenstedt (Nr.549-000)",
            "street": "Bremer Weg  52",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr Groß Mackenstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "550-000",
            "name": "FreeSpiritNaturalHorses in Rahden (Nr.550-000)",
            "street": "Wagenfelder Straße  66",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "551-000",
            "name": "Sentker in Lemgo (Nr.551-000)",
            "street": "Meinertsberg 11",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "552-000",
            "name": "Ziegenmichel in Gelsenkirchen (Nr.552-000)",
            "street": "Eggemannstr.  51",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "553-000",
            "name": "Reck in Jade (Nr.553-000)",
            "street": "Lisztweg  15",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "554-000",
            "name": "Nau  in Hopsten  (Nr.554-000)",
            "street": " Napoleondamm  13",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "555-000",
            "name": "Farwick  in Glandorf  (Nr.555-000)",
            "street": "Auf der Wichelten  2",
            "house_number": "1",
            "zipcode": "49219",
            "city": "Glandorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "556-000",
            "name": "Islandpferde Witthushof in Schwanenwede (Nr.556-000)",
            "street": "Hinnebecker Furth  31",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanenwede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "557-000",
            "name": "Pferdehof Pool  in Lingen  (Nr.557-000)",
            "street": "Kleekamp  1",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "558-000",
            "name": "Held in Ovelgönne (Nr.558-000)",
            "street": "Kirchstraße  ",
            "house_number": "1",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "559-000",
            "name": "Ollen River Ranch in Ganderkesee (Nr.559-000)",
            "street": "Zur Ollen 2",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "560-000",
            "name": "Hermann in Enger (Nr.560-000)",
            "street": "Enger ",
            "house_number": "1",
            "zipcode": "32130",
            "city": "Enger",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "561-000",
            "name": "Reitstall Fitje in Bad Zwischenahn (Nr.561-000)",
            "street": "Goldene Linie 23a",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "562-000",
            "name": "An der Engelbrücke in Borken (Nr.562-000)",
            "street": "An der Eggelbrücke 25",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "563-000",
            "name": "Raht in Büren (Nr.563-000)",
            "street": "Sehrweg 1",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "564-000",
            "name": "Privatstall Beermann in Harsewinkel (Nr.564-000)",
            "street": "Kortenhegge 10a",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "565-000",
            "name": "Reit- und Fahrverein St.Hülfe/Heede e.V. in Diepholz (Nr.565-000)",
            "street": "Am Turnierplatz 1",
            "house_number": "1",
            "zipcode": "49356",
            "city": "Diepholz",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "566-000",
            "name": "Private Stallgemeinschaft Brinkmann in Soest (Nr.566-000)",
            "street": "Landwehr 12",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "567-000",
            "name": "Boemer  in Ohne  (Nr.567-000)",
            "street": "Feldhoek  6",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Ohne ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "568-000",
            "name": "Privatstall Arndt  in Landesbergen  (Nr.568-000)",
            "street": "Birkenweg  7",
            "house_number": "1",
            "zipcode": "31628",
            "city": "Landesbergen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "569-000",
            "name": "Vor dem Brocke Lingen  in Lingen  (Nr.569-000)",
            "street": "Hohlweg  2",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "570-000",
            "name": "Hof Eiling in Heiden (Nr.570-000)",
            "street": "Drögen Bokelt 8",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "571-000",
            "name": "Stall Scheffler in Westoverledingen (Nr.571-000)",
            "street": "Birkenstraße 200",
            "house_number": "1",
            "zipcode": "26810",
            "city": "Westoverledingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "572-000",
            "name": "Hellmers Hof in Brake (Nr.572-000)",
            "street": "Sinaburger Straße 83",
            "house_number": "1",
            "zipcode": "26919",
            "city": "Brake",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "573-000",
            "name": "Hof Nordendorf in Reken  (Nr.573-000)",
            "street": "Alter Landweg  2",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "574-000",
            "name": "Geers  in Goldenstedt  (Nr.574-000)",
            "street": "Erikaweg  6",
            "house_number": "1",
            "zipcode": "49424",
            "city": "Goldenstedt ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "575-000",
            "name": "Wilkens in Bremen (Nr.575-000)",
            "street": "Waller Straße 300",
            "house_number": "1",
            "zipcode": "28719",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "576-000",
            "name": "Reitverein Velen in Velen (Nr.576-000)",
            "street": "Borkener Damm 12",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Velen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "577-000",
            "name": "Weetkornhof Klostermann in Bad Zwischenahn (Nr.577-000)",
            "street": "Weetkornstrasse  12",
            "house_number": "1",
            "zipcode": "46160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "578-000",
            "name": "Pferdepension Völker in Spelle (Nr.578-000)",
            "street": "Osterwiesenweg  6",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "579-000",
            "name": "Stall Cohausz in Telgte (Nr.579-000)",
            "street": "Voßhaar 15",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "512-000",
            "name": "Konert in Wadersloh (Nr.512-000)",
            "street": "Bredenweg 9",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "581-000",
            "name": "RC St. Georg zu Bremen e.V. in Bremen (Nr.581-000)",
            "street": "Wetterungsweg 1",
            "house_number": "1",
            "zipcode": "28359",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "582-000",
            "name": "Reitschule Isadora Siekmann in Detmold (Nr.582-000)",
            "street": "Unternienhagen 21",
            "house_number": "1",
            "zipcode": "32758",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "583-000",
            "name": "Raiffeisen Ochtrup in Ochtrup (öffentlich) (Nr.583-000)",
            "street": "Gronauer Str. 52",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup (öffentlich)",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "584-000",
            "name": "Privatstall Gausepohl in Versmold (Nr.584-000)",
            "street": "Stränger Str. 11",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "585-000",
            "name": "Jana Dreckmann in Ostbevern (Nr.585-000)",
            "street": "Ravel-Weg 6",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "586-000",
            "name": "Privatstall Woestmann in Steinfurt (Nr.586-000)",
            "street": "Hollich 46",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "587-000",
            "name": "Horseman Ranch in Bad Oeynhausen (Nr.587-000)",
            "street": "Holzmark 35",
            "house_number": "1",
            "zipcode": "32549",
            "city": "Bad Oeynhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "588-000",
            "name": "Privater Offenstall Jenderzi in Friesoythe (Nr.588-000)",
            "street": "Röpkendamm 4",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "589-000",
            "name": "Hof Schulze Schleithoff in Havixbeck (Nr.589-000)",
            "street": "Herkentrup 4",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "590-000",
            "name": "Averbeck in Ochtrup (Nr.590-000)",
            "street": "Schweringhook 3",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "591-000",
            "name": "Privatstall Braun in Schwanewede (Nr.591-000)",
            "street": "Am Wald  1a",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "592-000",
            "name": "Zurhove in Senden (Nr.592-000)",
            "street": "Dorfbauerschaft 27",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "594-000",
            "name": "Sandhaus in Menslage (Nr.594-000)",
            "street": "Hahlener Straße 7",
            "house_number": "1",
            "zipcode": "49637",
            "city": "Menslage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "597-000",
            "name": "Corina Carius in Lippetal (Nr.597-000)",
            "street": "Breite Str. 24",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "598-000",
            "name": "Camping Simon in Uelsen (Nr.598-000)",
            "street": "Hesinger Str.  13",
            "house_number": "1",
            "zipcode": "49843",
            "city": "Uelsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "599-000",
            "name": "Vethacke in Herne (Nr.599-000)",
            "street": "Holsterhauser Straße  323",
            "house_number": "1",
            "zipcode": "44625",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "600-000",
            "name": "Offenstall Heiner Kerkhof in Selm-Bork (Nr.600-000)",
            "street": "Zum Wegebild 5",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm-Bork",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "601-000",
            "name": "Privatstall Katrin Böker in Willebadessen (Nr.601-000)",
            "street": "Von- Ike- Str. 13",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "602-000",
            "name": "Privatstall Bockschatz in Bielefeld (Nr.602-000)",
            "street": "Lübbecker Str. 361",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "603-000",
            "name": "Reit- und Fahrverein Ochtrup e.V. in Ochtrup (Nr.603-000)",
            "street": "Kreuzweg  77",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "604-000",
            "name": "Reiterverein Bayer Leverkusen in Köln (Nr.604-000)",
            "street": "Otto-Bayer-Str 1",
            "house_number": "1",
            "zipcode": "51061",
            "city": "Köln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "605-000",
            "name": "Beelmann Stavern in Stavern (Nr.605-000)",
            "street": "Hinterstr 7",
            "house_number": "1",
            "zipcode": "49777",
            "city": "Stavern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "606-000",
            "name": "Reitschule Füchtmann in Gronau (Nr.606-000)",
            "street": "Gerdingseite 9",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "607-000",
            "name": "Reitstall Bianca in Büren (Nr.607-000)",
            "street": "Niederburgstraße 1",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "608-000",
            "name": "Reitstall Welslau in Bad Salzuflen (Nr.608-000)",
            "street": "Im Wölkental /",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "609-000",
            "name": "Reitanlage Gräve in Hamm (Nr.609-000)",
            "street": "Ostwennemarstraße 125",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "610-000",
            "name": "Gut Wewel in Senden (Nr.610-000)",
            "street": "Gettrup ",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "611-000",
            "name": "Böckenholt in Telgte (Nr.611-000)",
            "street": "Kiebitzpohl 18",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "612-000",
            "name": "Bücker in Emsdetten (Nr.612-000)",
            "street": "Austum 36",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "613-000",
            "name": "Geisthoff in Ahlen (Nr.613-000)",
            "street": "Westhusener Weg  5",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "614-000",
            "name": "Fam. Göcke, Eichenhof in Recke (Nr.614-000)",
            "street": "Twenhusen 33",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "615-000",
            "name": "Hof Bavendamm in Bremen (Nr.615-000)",
            "street": "Wallerstraße  300",
            "house_number": "1",
            "zipcode": "28719",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "616-000",
            "name": "Burghof in Recklinghausen (Nr.616-000)",
            "street": "Burgstr. 21",
            "house_number": "1",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "617-000",
            "name": "Reitanlage Berg in Hiddenhausen (Nr.617-000)",
            "street": "Lippinghauser Straße 101",
            "house_number": "1",
            "zipcode": "32120",
            "city": "Hiddenhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "618-000",
            "name": "Privatstall Vorsthove in Ibbenbüren (Nr.618-000)",
            "street": "Fahlbachtal 12",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "619-000",
            "name": "Stall Temmen in Rheine  (Nr.619-000)",
            "street": "Hohe Alle 101",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "620-000",
            "name": "CTH Sporthorses in Emsbüren (Nr.620-000)",
            "street": "Moorlage 9",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "621-000",
            "name": "Privatstall Assel in Bissendorf (Nr.621-000)",
            "street": "Werscher Straße 2",
            "house_number": "1",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "622-000",
            "name": "Privatstall Jäger in Dülmen (Nr.622-000)",
            "street": "Dernekamp 24a",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "623-000",
            "name": "Kollmer in Lastrup (Nr.623-000)",
            "street": "Blaubusch 5",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "624-000",
            "name": "Immer in Bremen (Nr.624-000)",
            "street": "Stromer Landstraße 38L",
            "house_number": "1",
            "zipcode": "28197",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "625-000",
            "name": "Reitanlage an der Stever in Senden (Nr.625-000)",
            "street": "Wierling 3b",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "626-000",
            "name": "Ulmenhof Albers in Meppen (Nr.626-000)",
            "street": "Ulmenhof 1",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "627-000",
            "name": "Weilichmann in Havixbeck (Nr.627-000)",
            "street": "Herkentrup 7",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "628-000",
            "name": "Reitanlage Döring in Espelkamp (Nr.628-000)",
            "street": "Siebenweg 1",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "629-000",
            "name": "Achterhörner Reitstall in Friesoythe (Nr.629-000)",
            "street": "Feddenbergsweg 2",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "630-000",
            "name": "Sportpferde Piotrowski in Senden (Nr.630-000)",
            "street": "Brock  8",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "631-000",
            "name": "Privatstall Höfener in Sendenhorst (Nr.631-000)",
            "street": "Ahrenhorst 33",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "632-000",
            "name": "Privatstall Denker in Wettringen (Nr.632-000)",
            "street": "Vollenbrok 22",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "633-000",
            "name": "Privatstall Ostermann in Voltlage (Nr.633-000)",
            "street": "Knappstr. 8",
            "house_number": "1",
            "zipcode": "49599",
            "city": "Voltlage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "634-000",
            "name": "Schmiemann in Ibbenbüren (Nr.634-000)",
            "street": "Brochterbecker Str. 8",
            "house_number": "1",
            "zipcode": "49477",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "635-000",
            "name": "Reit- und Fahrverein Steinfurt-Dumte e.V. in Steinfurt (Nr.635-000)",
            "street": "Dumte 20",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "636-000",
            "name": "Reitstall Molkembur in Münster (Nr.636-000)",
            "street": "Kasewinkel 94",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "637-000",
            "name": "Stall Fischer in Vechta (Nr.637-000)",
            "street": "Holtruper Straße 36",
            "house_number": "1",
            "zipcode": "49377",
            "city": "Vechta",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "638-000",
            "name": "Privathof Blank in Achim (Nr.638-000)",
            "street": "Roedenbeckstraße 141d",
            "house_number": "1",
            "zipcode": "28832",
            "city": "Achim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "639-000",
            "name": "Robert in Vreden (Nr.639-000)",
            "street": "Köckelwick 57",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "640-000",
            "name": "Borggreve Dressage in Ahaus (Nr.640-000)",
            "street": "Ammeln 99a",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "641-000",
            "name": "Spieker in Greven  (Nr.641-000)",
            "street": "Ostbevenerstr. 64",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "642-000",
            "name": "Privatstall Schlüter in Stadtlohn (Nr.642-000)",
            "street": "Boschstraße 30",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "643-000",
            "name": "Hof Tenberge in Lüdinghausen (Nr.643-000)",
            "street": "Tetekum 9",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "644-000",
            "name": "Reitanlage Hof Ebel in Arnsberg (Nr.644-000)",
            "street": "Neheimer Str. 108",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "645-000",
            "name": "Privatstall Voß in Rinkerode (Nr.645-000)",
            "street": "Eickenbeck 25",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Rinkerode",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "646-000",
            "name": "Zrg St.Sebastian Amelsbüren in Münster (Nr.646-000)",
            "street": "Von Renesseweg 20",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "650-000",
            "name": "Pferdestall Haarmann in Ahaus (Nr.650-000)",
            "street": "Oberortwick  27a",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "651-000",
            "name": "Reitstall Hartz in Nottuln (Nr.651-000)",
            "street": "Stevern 52",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "652-000",
            "name": "Hellenkamp in Ahaus (Nr.652-000)",
            "street": "Ammeln  91",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "653-000",
            "name": "Stammkötter in Steinhagen (Nr.653-000)",
            "street": "Sandforther Straße 64",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "654-000",
            "name": "Meine kleine Farm in Ostercappeln (Nr.654-000)",
            "street": "Bremer Str.  42a",
            "house_number": "1",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "656-000",
            "name": "Mau in Sendenhorst (Nr.656-000)",
            "street": "Sunger 27",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "657-000",
            "name": "RV Geisterholz in Oelde (Nr.657-000)",
            "street": "Robert-Schumann-Ring  25",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "658-000",
            "name": "Rosenhof in Horn Bad-Meinberg (Nr.658-000)",
            "street": "Zum Rosenbusch 102",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn Bad-Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "659-000",
            "name": "Hof Knickenberg in Hamm (Nr.659-000)",
            "street": "Im Nachtigallental 6",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "661-000",
            "name": "Hof Schuckenberg in Milte (Nr.661-000)",
            "street": "Beverstrang 31a",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Milte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "662-000",
            "name": "Privatstall Haak in Borken (Nr.662-000)",
            "street": "Neumühlenallee 114",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "663-000",
            "name": "Kohlmannhof in Westerkappeln (Nr.663-000)",
            "street": "Kuhlmannstraße 5",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "664-000",
            "name": "Privatstall Wischermann in Rosendahl (Nr.664-000)",
            "street": "Brockbauerschaft 30",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "665-000",
            "name": "Albers Hof in Oberlangen (Nr.665-000)",
            "street": "Sandstraße 1",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "666-000",
            "name": "Verstegge in Gronau (Nr.666-000)",
            "street": "Windmühlenweg 1",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "667-000",
            "name": "Privatstall Döme in Münster (Nr.667-000)",
            "street": "Einigweg 11",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "668-000",
            "name": "Hof Gövert in Havixbeck (Nr.668-000)",
            "street": "Poppenbeck 17",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "669-000",
            "name": "Lödding in Senden (Nr.669-000)",
            "street": "Kreuzbauerschaft 6",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "670-000",
            "name": "Göcking in Rheine  (Nr.670-000)",
            "street": "Osnabrücker Straße ",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "671-000",
            "name": "Telljohann in Lienen (Nr.671-000)",
            "street": "Ellerhooksweg 6",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "672-000",
            "name": "Margaretenhof in Neuenkirchen (Nr.672-000)",
            "street": "Rote Erde 12",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "674-000",
            "name": "Reiterhof Engeler in Saerbeck (Nr.674-000)",
            "street": "Middendorf 31",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "675-000",
            "name": "Lackenberg in Drensteinfurt (Nr.675-000)",
            "street": "Eickenbeck 33",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "676-000",
            "name": "Familie Espelkott in Rosendahl (Nr.676-000)",
            "street": "Helenenweg 4",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "677-000",
            "name": "Reitstall Schierbaum in Osnabrück (Nr.677-000)",
            "street": "Schierbaumsfeld ",
            "house_number": "1",
            "zipcode": "49086",
            "city": "Osnabrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "678-000",
            "name": "Privatstall Strotmeier in Ibbenbüren (Nr.678-000)",
            "street": "Teutohang 83",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "679-000",
            "name": "Ponyhof Benning in Emsdetten (Nr.679-000)",
            "street": "Up'mMersk 1",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "680-000",
            "name": "Privatstall Bringemeier in Steinfurt (Nr.680-000)",
            "street": "Emsdettener Straße 73",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "681-000",
            "name": "Pagliarini in Havixbeck (Nr.681-000)",
            "street": "Walingen 11",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "682-000",
            "name": "Dr. Ute Vaske in Lastrup (Nr.682-000)",
            "street": "Bei der Groberei 4",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "683-000",
            "name": "Jörns bei Zimmerei Stärke in Riede (Nr.683-000)",
            "street": "Wegstätte 25",
            "house_number": "1",
            "zipcode": "27339",
            "city": "Riede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "684-000",
            "name": "Pferdepension zu Stoltenberg in Lüdinghausen-Seppenrade (Nr.684-000)",
            "street": "Leversum 38",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen-Seppenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "685-000",
            "name": "Böckmann in Ibbenbüren (Nr.685-000)",
            "street": "Riesenbeckerstr. 45",
            "house_number": "1",
            "zipcode": "49477",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "686-000",
            "name": "Reitanlage Sylvia Werft in Bad Laer (Nr.686-000)",
            "street": "Hagestrasse 5",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "687-000",
            "name": "Gilhaus in Schermbeck (Nr.687-000)",
            "street": "Vor der Burg 1",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "688-000",
            "name": "Privatstall Müller in Werl (Nr.688-000)",
            "street": "Am krummen Rücken 24",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "689-000",
            "name": "Mareike Sanders in Westbevern (Nr.689-000)",
            "street": "Voßhaar 13",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Westbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "690-000",
            "name": "Privatstall Schulz in Westerkappeln (Nr.690-000)",
            "street": "Telgte 12",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "691-000",
            "name": "Rusinek in Lengerich (Nr.691-000)",
            "street": "Am Steinernen Kreuz 38",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "692-000",
            "name": "Starwood Stables (Hof Brumley) in Emsdetten (Nr.692-000)",
            "street": "Nordwalderstr. 197",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "693-000",
            "name": "Stall Leichhauer in Oer-Erkenschwick (Nr.693-000)",
            "street": "Johannesstr. 248",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "694-000",
            "name": "Matthaiwe in Xanten (Nr.694-000)",
            "street": "Heesweg 25",
            "house_number": "1",
            "zipcode": "46509",
            "city": "Xanten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "695-000",
            "name": "Reitverein Südlohn in Südlohn (Nr.695-000)",
            "street": "Pingelerhook 26",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "696-000",
            "name": "Wessling in Ochtrup (Nr.696-000)",
            "street": "Kreuzweg 77",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "697-000",
            "name": "Stall Marx in Belm (Nr.697-000)",
            "street": "An der Haarener Grenze 1",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "698-000",
            "name": "RV Helleforth in Schloß Holte-Stukenbrock (Nr.698-000)",
            "street": "Kaunitzer Str. 174",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "699-000",
            "name": "Privatstall Pothmann in Metelen (Nr.699-000)",
            "street": "Samberg 56",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "700-000",
            "name": "Privatstall Köttermann in Ahlen (Nr.700-000)",
            "street": "Walstedderstraße 251",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "701-000",
            "name": "RV Riesenbeck in Hörstel-Riesenbeck (Nr.701-000)",
            "street": "Surenburg 20",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "702-000",
            "name": "Privatstall Ernsting in Coesfeld  (Nr.702-000)",
            "street": "Gaupel 32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "703-000",
            "name": "Schulte-Schedding in Herten (Nr.703-000)",
            "street": "Kampstr. 9",
            "house_number": "1",
            "zipcode": "45701",
            "city": "Herten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "704-000",
            "name": "Reitstall Binder in Greven  (Nr.704-000)",
            "street": "Saerbeckerstr. 144",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "705-000",
            "name": "RV Wehdem-Oppendorf in Stemwede (Nr.705-000)",
            "street": "Am Birkenhain 4",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "706-000",
            "name": "Privatstall Rekers in Emsbüren (Nr.706-000)",
            "street": "Zur Venhauser Schleuse  2",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "707-000",
            "name": "ebe Pferdegesundheitszentrum Münster GmbH in Münster (Nr.707-000)",
            "street": "Tweehues 17",
            "house_number": "1",
            "zipcode": "48163",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "708-000",
            "name": "Privatstall Beuker in Steinfurt (Nr.708-000)",
            "street": "Hollich 120",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "709-000",
            "name": "Privatstall Keeve-Gerling in Recke (Nr.709-000)",
            "street": "Venneweg 13",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "710-000",
            "name": "Privatstall Rabe in Bohmte (Nr.710-000)",
            "street": "Meyerhöfener Straße 5",
            "house_number": "1",
            "zipcode": "49163",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "711-000",
            "name": "Islandpferde Oberkarthausen in Radevormwald (Nr.711-000)",
            "street": "Oberkarthausen 1",
            "house_number": "1",
            "zipcode": "42499",
            "city": "Radevormwald",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "712-000",
            "name": "Boltrayhof in Voerde (Nr.712-000)",
            "street": "Rheinstraße 183",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "713-000",
            "name": "Zumloh in Ahlen (Nr.713-000)",
            "street": "In der Groeft 33",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "714-000",
            "name": "Hufbeschlag Hötte in Ahlen (Nr.714-000)",
            "street": "Westhusenerweg 1",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "715-000",
            "name": "Reitstall Pegasus in Wülfrath (Nr.715-000)",
            "street": "Nord-Erbach 25",
            "house_number": "1",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "716-000",
            "name": "Korth in Gummersbach (Nr.716-000)",
            "street": "Kerbelweg  15",
            "house_number": "1",
            "zipcode": "51647",
            "city": "Gummersbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "717-000",
            "name": "Reitanlage Gessmann in Münster (Nr.717-000)",
            "street": "Hunnebeckweg 97",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "718-000",
            "name": "Stall Pölling  in Coesfeld  (Nr.718-000)",
            "street": "Stevede  60",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "719-000",
            "name": "Haltergemeinschaft Dölling  in Rheine  (Nr.719-000)",
            "street": "Zur Vogelstange  5",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "720-000",
            "name": "Gut Henscheshof  in Erkrath  (Nr.720-000)",
            "street": "Hubbelrather Weg 19",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "721-000",
            "name": "Benger Hof  in Duisburg  (Nr.721-000)",
            "street": "An der Bastei 118",
            "house_number": "1",
            "zipcode": "47529",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "722-000",
            "name": "Hüsing  in Emsbüren  (Nr.722-000)",
            "street": "Emsstraße  ",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "723-000",
            "name": "Te Heesen  in Voerde (Nr.723-000)",
            "street": "Hindenburgstraße  160",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "724-000",
            "name": "Centura Reitakademie  in Schwanenwede (Nr.724-000)",
            "street": "Hamfährer Weg  19",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanenwede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "725-000",
            "name": "Reitverein Nienberge in Münster (Nr.725-000)",
            "street": "Beerwiede 160A",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "726-000",
            "name": "DIPO - Hof Thier zum Berge in Dülmen (Nr.726-000)",
            "street": "Mitwick 32",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "727-000",
            "name": "Wessendorf in Dülmen (Nr.727-000)",
            "street": "Börnste  36",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "729-000",
            "name": "Kamps in Bönen (Nr.729-000)",
            "street": "Dorfstraße 11",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "730-000",
            "name": "Tenbrok in Bocholt (Nr.730-000)",
            "street": "Franzstr 76",
            "house_number": "1",
            "zipcode": "46395",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "731-000",
            "name": "Hof Schettler in Haltern am See (Nr.731-000)",
            "street": "Dorstener Str. 880",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "732-000",
            "name": "Stall Nordhues in Saerbeck (Nr.732-000)",
            "street": "Südhoek 15",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "733-000",
            "name": "Stall Deipenwisch in Everswinkel (Nr.733-000)",
            "street": "Holling 17",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "737-000",
            "name": "Reitstall Elling in Salzbergen (Nr.737-000)",
            "street": "Devestr. 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "738-000",
            "name": "Reiterhof Kottig in Gronau-Epe (Nr.738-000)",
            "street": "Gerdingseite 4",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "740-000",
            "name": "Meyer  in Saterland  (Nr.740-000)",
            "street": "An der Wieke  7",
            "house_number": "1",
            "zipcode": "26683",
            "city": "Saterland ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "741-000",
            "name": "Raude Sudhoff  in Osnabrück (Nr.741-000)",
            "street": "DarumerStr.  ",
            "house_number": "1",
            "zipcode": "49090",
            "city": "Osnabrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "742-000",
            "name": "Meier  in Vloth  (Nr.742-000)",
            "street": "Im Nienhagen  3",
            "house_number": "1",
            "zipcode": "32602",
            "city": "Vloth ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "743-000",
            "name": "Erlemeyer  in Warendorf  (Nr.743-000)",
            "street": "Westbezirk  82",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "744-000",
            "name": "Minnerup  in Ibbenbüren (Nr.744-000)",
            "street": "Brumleyweg  8",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "745-000",
            "name": "Figge  in Welver  (Nr.745-000)",
            "street": "Zur Binnekoh  13",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "746-000",
            "name": "Privatstall Brinkbäumer in Soest (Nr.746-000)",
            "street": "Eichenweg 8b",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "747-000",
            "name": "Döring Quarter Horses  in Marl  (Nr.747-000)",
            "street": "Herner Weg  46",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "748-000",
            "name": "Weitkamp in Billerbeck  (Nr.748-000)",
            "street": "Hamern  36",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "749-000",
            "name": "Hovestadt  in Warendorf  (Nr.749-000)",
            "street": "Dr.-Rau-Allee 82",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "750-000",
            "name": "Red Blaze Ranch in Ascheberg (Nr.750-000)",
            "street": "Davensbergerstraße 15",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "751-000",
            "name": "Reitstall Laurenz in Gronau-Epe (Nr.751-000)",
            "street": "Am Fürstenbusch 20",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "752-000",
            "name": "RSC Norden Nordsee in Norden (Nr.752-000)",
            "street": "Schwarzer Weg 32",
            "house_number": "1",
            "zipcode": "26506",
            "city": "Norden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "753-000",
            "name": "Reit- und Fahrverein Dornberg in Bielefeld (Nr.753-000)",
            "street": "Am Krebsbach 19",
            "house_number": "1",
            "zipcode": "33619",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "754-000",
            "name": "Hof Janning in Rheine  (Nr.754-000)",
            "street": "Brookstr. 45",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "755-000",
            "name": "Privatstall Hackländer in Rüthen (Nr.755-000)",
            "street": "Königstraße 17",
            "house_number": "1",
            "zipcode": "59602",
            "city": "Rüthen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "756-000",
            "name": "Privatstall Ratz in Beelen  (Nr.756-000)",
            "street": "Pohlstadt 10",
            "house_number": "1",
            "zipcode": "48361",
            "city": "Beelen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "757-000",
            "name": "Münsterland Stables & Curly Horses in Rosendahl (Nr.757-000)",
            "street": "Midlicher Straße 7",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "758-000",
            "name": "Pferdepension Drei Eichen  in Welver  (Nr.758-000)",
            "street": "Bergstrasser Weg  3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "759-000",
            "name": "Holling  in Greven  (Nr.759-000)",
            "street": "Gronenweg  1a ",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "760-000",
            "name": "Schulze Feldmann  in Hörstel-Riesenbeck (Nr.760-000)",
            "street": "Pastorenkamp 20",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "761-000",
            "name": "RV Heessen  in Hamm  (Nr.761-000)",
            "street": "Dasbeck  6",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "762-000",
            "name": "Wickensack  in Ostbevern  (Nr.762-000)",
            "street": "Brock  29",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "763-000",
            "name": "Wesling  in Ostbevern  (Nr.763-000)",
            "street": "Deppengau  30",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "764-000",
            "name": "Hof Becker in Hamm (Nr.764-000)",
            "street": "Lippestr 130",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "765-000",
            "name": "Hof Grünwald  in Tecklenburg  (Nr.765-000)",
            "street": "Holthausen  25",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "766-000",
            "name": "Hof Stratmann in Senden (Nr.766-000)",
            "street": "Dorfbauerschaft 26",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "767-000",
            "name": "Offenstall Schulte-Walter in Münster (Nr.767-000)",
            "street": "Wittoverstiege 68",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "768-000",
            "name": "Nadine Nölle in Hamm (Nr.768-000)",
            "street": "Wambelner Berg 3",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "769-000",
            "name": "Privatstall Wirth in Gütersloh (Nr.769-000)",
            "street": "Erikenstraße ",
            "house_number": "1",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "770-000",
            "name": "EquiFit in Hüven (Nr.770-000)",
            "street": "Berßener Str. 99",
            "house_number": "1",
            "zipcode": "49751",
            "city": "Hüven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "771-000",
            "name": "Privatstall Lüken in Rastdorf (Nr.771-000)",
            "street": "Hauptstr.  19",
            "house_number": "1",
            "zipcode": "26901",
            "city": "Rastdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "772-000",
            "name": "Wiesenhof in Duisburg  (Nr.772-000)",
            "street": "Straußplatz 3",
            "house_number": "1",
            "zipcode": "47057",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "773-000",
            "name": "Hof Harkotten in Emsdetten (Nr.773-000)",
            "street": "Hollingen 19",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "774-000",
            "name": "Terheiden in Hopsten (Nr.774-000)",
            "street": "Breischenerstr. 4",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "775-000",
            "name": "Reitstall Rieping in Ahlen (Nr.775-000)",
            "street": "Dorffeld 25",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "776-000",
            "name": "Constanze Möller in Ennigerloh (Nr.776-000)",
            "street": "Im Sportpark 1",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "777-000",
            "name": "Majewski in Horstmar (Nr.777-000)",
            "street": "Ostendorf 17",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "778-000",
            "name": "Neuß in Bochum (Nr.778-000)",
            "street": "Auf dem Kalwes 239",
            "house_number": "1",
            "zipcode": "44801",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "779-000",
            "name": "RV Ostönnen in Werl (Nr.779-000)",
            "street": "Breite Straße 7",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "780-000",
            "name": "Busch in Melle (Nr.780-000)",
            "street": "Westerheide 28",
            "house_number": "1",
            "zipcode": "49324",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "781-000",
            "name": "Tierpension Groll in Hagen (Nr.781-000)",
            "street": "Düinghauser Weg  33",
            "house_number": "1",
            "zipcode": "58091",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "782-000",
            "name": "Ziegler in Menden (Nr.782-000)",
            "street": "Neue Straße 26",
            "house_number": "1",
            "zipcode": "58708",
            "city": "Menden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "783-000",
            "name": "Privatstall Farwick in Wadersloh (Nr.783-000)",
            "street": "Liesborner Str. 28",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "784-000",
            "name": "Reitstall Hoffmann in Düsseldorf (Nr.784-000)",
            "street": "Edmund-Bertram-Straße  54",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "785-000",
            "name": "Schulze Zur Verth in Borken (Nr.785-000)",
            "street": "Pröbstinger Allee 1",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "786-000",
            "name": "Niemeyer in Westerkappeln (Nr.786-000)",
            "street": "Bathmener Str. 28",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "787-000",
            "name": "J&A Ranch in Olsberg (Nr.787-000)",
            "street": "Ibergstraße ",
            "house_number": "1",
            "zipcode": "59939",
            "city": "Olsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "788-000",
            "name": "Ramrath in Sendenhorst (Nr.788-000)",
            "street": "Hohe Ward 4",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "789-000",
            "name": "Pensionsstall Lukat in Nordhorn (Nr.789-000)",
            "street": "Karl-Braun-Straße  18",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "790-000",
            "name": "Ponyschule Sauerland in Meschede (Nr.790-000)",
            "street": "Erflinghausen 13",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "791-000",
            "name": "Anne Lauderbach in Lastrup (Nr.791-000)",
            "street": "Blaubusch 1",
            "house_number": "1",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "792-000",
            "name": "Klaas in Meppen (Nr.792-000)",
            "street": "In den Höften 11",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "793-000",
            "name": "Privatstall Frers in Oelde (Nr.793-000)",
            "street": "Katthagenstr. 25",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "794-000",
            "name": "Rönnebäumer in Havixbeck (Nr.794-000)",
            "street": "Brock 18",
            "house_number": "1",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "795-000",
            "name": "PferdeAktivStall in Stadthagen (Nr.795-000)",
            "street": "Hauptstraße 23",
            "house_number": "1",
            "zipcode": "31655",
            "city": "Stadthagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "796-000",
            "name": "Vogel/Haar in Nordhorn (Nr.796-000)",
            "street": "Bentheimer Straße 405",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "797-000",
            "name": "Tünte Cappenberg in Telgte (Nr.797-000)",
            "street": "Bockhorner Heide 27",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "798-000",
            "name": "Reit- und Fahrverein Emsdetten in Emsdetten (Nr.798-000)",
            "street": "Am Teekotten 1",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "799-000",
            "name": "Sportpferde Premiumhorses in Emsdetten (Nr.799-000)",
            "street": "Westumer Landstr.  68b",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "800-000",
            "name": "Holzbau Fieke in Altenberge (Nr.800-000)",
            "street": "Kümper 110b",
            "house_number": "1",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "801-000",
            "name": "Reckers in Hörstel (Nr.801-000)",
            "street": "Altenrheiner Weg 60",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "802-000",
            "name": "Werning  in Lage  (Nr.802-000)",
            "street": "Eggeweg  21",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "803-000",
            "name": "Kamphorst  in Nordhorn-Hestrup (Nr.803-000)",
            "street": "Katthorstweg  15",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn-Hestrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "804-000",
            "name": "Reitanlage Vedder in Waltrop (Nr.804-000)",
            "street": "Im Abdinghof ",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "805-000",
            "name": "Privatstall Schönberg in Dreierwalde (Nr.805-000)",
            "street": "Hopstener Straße 46",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Dreierwalde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "806-000",
            "name": "Privatstall Dingwerth in Versmold (Nr.806-000)",
            "street": "Hollmortstr 3",
            "house_number": "1",
            "zipcode": "33775",
            "city": "Versmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "807-000",
            "name": "Reitstall Pulte in Attendorn-Mecklinghausen (Nr.807-000)",
            "street": "Talstrasse ",
            "house_number": "1",
            "zipcode": "57439",
            "city": "Attendorn-Mecklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "808-000",
            "name": "Sonnenhol in Lüdenscheid (Nr.808-000)",
            "street": "Hottenbruch 24",
            "house_number": "1",
            "zipcode": "58515",
            "city": "Lüdenscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "809-000",
            "name": "Hof Pöppelmann in Münster (Nr.809-000)",
            "street": "Ramertsweg 104",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "810-000",
            "name": "Zuchtgemeinschaft Espelkott in Rosendahl (Nr.810-000)",
            "street": "Geitendorf 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "811-000",
            "name": "Privatstall Lütke-Stratkötter in Wadersloh (Nr.811-000)",
            "street": "Herzebrockweg 8",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "812-000",
            "name": "Privatstall Rose in Büren (Nr.812-000)",
            "street": "Burgwall 4",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "813-000",
            "name": "Schmitz in Wadersloh (Nr.813-000)",
            "street": "Soester Str. 14",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "814-000",
            "name": "Hill of the Moon in Arnsberg (Nr.814-000)",
            "street": "Echthauserstr. 55",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "815-000",
            "name": "Wittkemper in Wadersloh (Nr.815-000)",
            "street": "Buchenweg 5",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "816-000",
            "name": "Osenberg in Radevormwald (Nr.816-000)",
            "street": "Ispingrade 13",
            "house_number": "1",
            "zipcode": "42477",
            "city": "Radevormwald",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "817-000",
            "name": "Hovestadt  in Gronau (Nr.817-000)",
            "street": "Am Berge 53",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "818-000",
            "name": "Ferienbauernhof Voß in Schmallenberg (Nr.818-000)",
            "street": "Uentropstr. 12",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "819-000",
            "name": "Meierhof in Detmold (Nr.819-000)",
            "street": "Barntruper Straße 44",
            "house_number": "1",
            "zipcode": "32758",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "820-000",
            "name": "Fellnasen in Dreierwalde (Nr.820-000)",
            "street": "Uthuiserstraße 33",
            "house_number": "1",
            "zipcode": "48486",
            "city": "Dreierwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "821-000",
            "name": "Privatstall Keller in Ibbenbüren (Nr.821-000)",
            "street": "Adlerstiege  80",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "822-000",
            "name": "Gestüt Schultenhof in Bochum (Nr.822-000)",
            "street": "Zum Schultenhof 34",
            "house_number": "1",
            "zipcode": "44807",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "823-000",
            "name": "Buse in Holzwickede (Nr.823-000)",
            "street": "Talstr. 12",
            "house_number": "1",
            "zipcode": "59439",
            "city": "Holzwickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "824-000",
            "name": "Privatstall Wewers in Belm (Nr.824-000)",
            "street": "Nelkenweg 4",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "825-000",
            "name": "Privatstall Gelking in Nordwalde (Nr.825-000)",
            "street": "Suttorf 5",
            "house_number": "1",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "826-000",
            "name": "Privatstall Hüntemann in Wettringen (Nr.826-000)",
            "street": "Wilhelm-Busch-Str.  17",
            "house_number": "1",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "827-000",
            "name": "Privatstall Bracht in Kluse (Nr.827-000)",
            "street": "Wippinger Str  7",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Kluse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "828-000",
            "name": "Große Hühnfeld in Münster (Nr.828-000)",
            "street": "Lindberghweg 131",
            "house_number": "1",
            "zipcode": "48155",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "829-000",
            "name": "Nienhaus in Bocholt (Nr.829-000)",
            "street": "Degelingsesch 5",
            "house_number": "1",
            "zipcode": "46395",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "830-000",
            "name": "Reitanlage Fockenberg in Bottrop (Nr.830-000)",
            "street": "In der Koppel 82",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "831-000",
            "name": "Schaafhausen in Mettmann (Nr.831-000)",
            "street": "Diepensiepen 53",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "832-000",
            "name": "Forsthof Haschert in Witten (Nr.832-000)",
            "street": "Krünerstr. 52",
            "house_number": "1",
            "zipcode": "58456",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "833-000",
            "name": "Brockmann in Bergen (Nr.833-000)",
            "street": "Peerborm 6",
            "house_number": "1",
            "zipcode": "29303",
            "city": "Bergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "834-000",
            "name": "Dortmund Kirchlinde in Dortmund (Nr.834-000)",
            "street": "Mosselde 150",
            "house_number": "1",
            "zipcode": "44357",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "835-000",
            "name": "Pferdehof Schütte in Schortens (Nr.835-000)",
            "street": "Stummeldorf 1",
            "house_number": "1",
            "zipcode": "26419",
            "city": "Schortens",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "836-000",
            "name": "Reitsportanlage Könemann in Petershagen (Nr.836-000)",
            "street": "Stehbrink 37",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "837-000",
            "name": "Gut Beringhof in Wickede (Nr.837-000)",
            "street": "Zum Beringhof 2",
            "house_number": "1",
            "zipcode": "58739",
            "city": "Wickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "838-000",
            "name": "Artmanns Hof in  Horstmar (Nr.838-000)",
            "street": "Ostendorf 38",
            "house_number": "1",
            "zipcode": "48565",
            "city": " Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "839-000",
            "name": "Neitemeier in Meschede (Nr.839-000)",
            "street": "Stesse ",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "840-000",
            "name": "Backhaus in Wetter (Nr.840-000)",
            "street": "Limbeckerweg ",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "841-000",
            "name": "Reitverein Werl in Werl (Nr.841-000)",
            "street": "Neheimer Str. 49",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "842-000",
            "name": "Hasenhorst in Münster (Nr.842-000)",
            "street": "Bremerfeld 4",
            "house_number": "1",
            "zipcode": "48147",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "843-000",
            "name": "Pension Tiemann in Löhne (Nr.843-000)",
            "street": "Börstelstraße 109",
            "house_number": "1",
            "zipcode": "32584",
            "city": "Löhne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "844-000",
            "name": "Jasper in Hopsten (Nr.844-000)",
            "street": "Stadener Straße  14",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "845-000",
            "name": "Holtumer Landhof in Duisburg  (Nr.845-000)",
            "street": "Holtumer Mühlenweg  1",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "846-000",
            "name": "Steinbrückhof in Müden (Aller) (Nr.846-000)",
            "street": "Gilde 1a",
            "house_number": "1",
            "zipcode": "38539",
            "city": "Müden (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "847-000",
            "name": "Güldner in Hopsten (Nr.847-000)",
            "street": "Zum Wurftaubenstand 1",
            "house_number": "1",
            "zipcode": "48496",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "848-000",
            "name": "Wilde in Nottuln (Nr.848-000)",
            "street": "Mühlenweg  2",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "849-000",
            "name": "Kaspar in Korschenbroich (Nr.849-000)",
            "street": "Glehner Str. 14a",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "850-000",
            "name": "Privatstall Nienhuis in Heede (Nr.850-000)",
            "street": "Schuckenbrock 14",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Heede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "851-000",
            "name": "Reiterverein Iserlohn in Iserlohn (Nr.851-000)",
            "street": "Reiterweg 16",
            "house_number": "1",
            "zipcode": "58636",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "852-000",
            "name": "Privatstall Niggemann Hunteburg in Bohmte (Nr.852-000)",
            "street": "Am Strohtkanal 3",
            "house_number": "1",
            "zipcode": "49163",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "853-000",
            "name": "Gut Hellerhof in Düsseldorf (Nr.853-000)",
            "street": "Rudolf-Breitscheid-Strasse ",
            "house_number": "1",
            "zipcode": "40721",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "854-000",
            "name": "Reitanlage am Thabrauck in Frödenberg (Nr.854-000)",
            "street": "Thabrauck 22",
            "house_number": "1",
            "zipcode": "58730",
            "city": "Frödenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "855-000",
            "name": "Privatstall Weller in Goch (Nr.855-000)",
            "street": "Kapellenhofstr. 13",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "856-000",
            "name": "Sonntagsfarm in Kaarst (Nr.856-000)",
            "street": "Neersener Straße 38",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "857-000",
            "name": "Stall Deimann/Sprankel in Schmallenberg-Oberkirchen (Nr.857-000)",
            "street": "Hammerweg ",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Oberkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "858-000",
            "name": "Reitanlage Hubertus in Gladbeck-Brauck (Nr.858-000)",
            "street": "Brauckstr 10",
            "house_number": "1",
            "zipcode": "45968",
            "city": "Gladbeck-Brauck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "859-000",
            "name": "Carranza Sport Horses in Nordhorn (Nr.859-000)",
            "street": "Buchenstraße 84",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "861-000",
            "name": "Privatstall Brautmeier in Delbrück (Nr.861-000)",
            "street": "Lippstädter Str. 104",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "862-000",
            "name": "Pferdehof Behle in Ense-Lüttringen (Nr.862-000)",
            "street": "Auf den Weiden  6",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense-Lüttringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "863-000",
            "name": "Privatstall Götten in Ibbenbüren (Nr.863-000)",
            "street": "Iltisweg  15e",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "864-000",
            "name": "Harberg in Beckum (Nr.864-000)",
            "street": "Harberg 1",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "865-000",
            "name": "Petershagen in Petershagen (Nr.865-000)",
            "street": "Riehe Höfe 6",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "866-000",
            "name": "Frickenstein in Ibbenbüren (Nr.866-000)",
            "street": "An der Umfluth 19a",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "867-000",
            "name": "Privatstall Steinberg in Schwerte (Nr.867-000)",
            "street": "Steinberg  31",
            "house_number": "1",
            "zipcode": "58239",
            "city": "Schwerte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "868-000",
            "name": "Privatstall Deuper in Bad Laer (Nr.868-000)",
            "street": "Wechel  7",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "869-000",
            "name": "Privatstall Engemann in Willebadessen (Nr.869-000)",
            "street": "Klosterstr 5",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "870-000",
            "name": "Islandpferdepension Haasenbau in Dorsten (Nr.870-000)",
            "street": "Nierleistr. 64",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "871-000",
            "name": "Hertenhof in Meerbusch (Nr.871-000)",
            "street": "Bovert  33",
            "house_number": "1",
            "zipcode": "40670",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "872-000",
            "name": "Reitanl. am Kressenberg in Hattingen (Nr.872-000)",
            "street": "Langes Feld 17",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "873-000",
            "name": "Hof der Pferde in Adelheidsdorf (Nr.873-000)",
            "street": "Dasselsbrucher Str.  82",
            "house_number": "1",
            "zipcode": "29352",
            "city": "Adelheidsdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "874-000",
            "name": "Zur Kummerwie in Bad Sassendorf (Nr.874-000)",
            "street": "Weslarner Weg 2",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "875-000",
            "name": "RV Lengerich in Lengerich (Nr.875-000)",
            "street": "Erlenweg  3",
            "house_number": "1",
            "zipcode": "49838",
            "city": "Lengerich",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "876-000",
            "name": "Privatstall Vogt  (kleiner Offenstall) in Marl  (Nr.876-000)",
            "street": "Haßlinger Bogen 22",
            "house_number": "1",
            "zipcode": "49448",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "877-000",
            "name": "Privatstall Adams in Rheinberg (Nr.877-000)",
            "street": "Rheinkamper Str.  71",
            "house_number": "1",
            "zipcode": "47495",
            "city": "Rheinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "878-000",
            "name": "Privatstall Stappers in Spelle (Nr.878-000)",
            "street": "Englandstr.  30",
            "house_number": "1",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "879-000",
            "name": "Privatstall Krasenbrink in Nordhorn (Nr.879-000)",
            "street": "Feldflurweg  86",
            "house_number": "1",
            "zipcode": "48531",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "880-000",
            "name": "Pensionsstall Johst in Grevenbroich (Nr.880-000)",
            "street": "Am Blauen Stein 3",
            "house_number": "1",
            "zipcode": "41516",
            "city": "Grevenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "881-000",
            "name": "Privatstall Lügan in Löningen (Nr.881-000)",
            "street": "Weißer Damm 5",
            "house_number": "1",
            "zipcode": "49624",
            "city": "Löningen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "882-000",
            "name": "Kleine Auszeit in Würselen (Nr.882-000)",
            "street": "Broicher Str 130",
            "house_number": "1",
            "zipcode": "52146",
            "city": "Würselen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "883-000",
            "name": "Hunder in Warmsen (Nr.883-000)",
            "street": "Hauskämper Str.  6",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "884-000",
            "name": "Privatstsall Wiethoff in Neukirchen-Vluyn (Nr.884-000)",
            "street": "Geldernsche Str.  405",
            "house_number": "1",
            "zipcode": "47506",
            "city": "Neukirchen-Vluyn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "885-000",
            "name": "Stall Volkmer Meinhard in Ochtrup (Nr.885-000)",
            "street": "Weiner  231",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "886-000",
            "name": "Pabsthof in Düsseldorf (Nr.886-000)",
            "street": "Pabsthofweg  2",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "887-000",
            "name": "Birtes Ranch in Ense Vollbringen (Nr.887-000)",
            "street": "Lanner 9",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense Vollbringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "888-000",
            "name": "Privatstall Stegemann in Neuenrade (Nr.888-000)",
            "street": "Hofstr  5b",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "889-000",
            "name": "Privatstall Bacchiocchi in Ratingen (Nr.889-000)",
            "street": "Lintorfer Weg 16",
            "house_number": "1",
            "zipcode": "40885",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "890-000",
            "name": "Privatstall Göppinger in Grefrath (Nr.890-000)",
            "street": "Auffeld  26",
            "house_number": "1",
            "zipcode": "47929",
            "city": "Grefrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "891-000",
            "name": "Joeressen in Mönchengladbach (Nr.891-000)",
            "street": "Günhovener Str  49",
            "house_number": "1",
            "zipcode": "41179",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "892-000",
            "name": "Jürgensmeyerhof in Lage  (Nr.892-000)",
            "street": "Billinghauser 167",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "893-000",
            "name": "Gut Klein Düssel in Düsseldorf (Nr.893-000)",
            "street": "Gödinghover Weg 80",
            "house_number": "1",
            "zipcode": "40627",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "894-000",
            "name": "Stall Bahr in Schwanewede (Nr.894-000)",
            "street": "Hamfährer Weg  34",
            "house_number": "1",
            "zipcode": "27890",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "895-000",
            "name": "Privatstall Entrup in Rheda-Wiedenbrück (Nr.895-000)",
            "street": "Kleestr 44",
            "house_number": "1",
            "zipcode": "33378",
            "city": "Rheda-Wiedenbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "896-000",
            "name": "Friedrich Dehmann in Nordstemmen (Nr.896-000)",
            "street": "Hallerstr 9",
            "house_number": "1",
            "zipcode": "31171",
            "city": "Nordstemmen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "897-000",
            "name": "Privatstall Göbel in Schmallenberg-Felbecke (Nr.897-000)",
            "street": "Hawerlandstr 7",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Felbecke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "898-000",
            "name": "Dyckers in Neuss Grefrath (Nr.898-000)",
            "street": "Lüttenglehnerstrasse 116",
            "house_number": "1",
            "zipcode": "41472",
            "city": "Neuss Grefrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "899-000",
            "name": "Reiterhof Ressing in Hünxe (Nr.899-000)",
            "street": "Hoher Wardweg 12a",
            "house_number": "1",
            "zipcode": "46569",
            "city": "Hünxe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "900-000",
            "name": "Watermann in Witten (Nr.900-000)",
            "street": "Am Katterloh  12",
            "house_number": "1",
            "zipcode": "58454",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "901-000",
            "name": "Privatstall Lampe in Friesoythe (Nr.901-000)",
            "street": "Altenoyther Str. 66",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "902-000",
            "name": "Hof Eckey in Bönen (Nr.902-000)",
            "street": "Auf dem hachenei 6",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "903-000",
            "name": "Privatstall Fricke in Algermissen (Nr.903-000)",
            "street": "Pfingstanger 5",
            "house_number": "1",
            "zipcode": "31191",
            "city": "Algermissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "904-000",
            "name": "Jennifer Wulf und Thorben Schulte in Witten (Nr.904-000)",
            "street": "Oberkrone 76",
            "house_number": "1",
            "zipcode": "58455",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "905-000",
            "name": "Fahrstall in Rheine  (Nr.905-000)",
            "street": "Im Uhlenhook 11",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "906-000",
            "name": "Privatstall Aumann in Hespe (Nr.906-000)",
            "street": "Hauptstr 33",
            "house_number": "1",
            "zipcode": "31693",
            "city": "Hespe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "907-000",
            "name": "Friedrich Döpke in Langenhagen (Nr.907-000)",
            "street": "Dorfstraße 60",
            "house_number": "1",
            "zipcode": "30855",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "908-000",
            "name": "Zuchtstall Schäfers in Ense (Nr.908-000)",
            "street": "Soester Straße  6",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "909-000",
            "name": "Herbsthof in Garbsen (Nr.909-000)",
            "street": "Burgstraße 42",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "910-000",
            "name": "Gut Wolfsaap / Prange in Düsseldorf (Nr.910-000)",
            "street": "Bauernhäuser Weg  100",
            "house_number": "1",
            "zipcode": "40472",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "911-000",
            "name": "Reinstall Stuhr in Stuhr (Nr.911-000)",
            "street": "Klardinger Straße 8",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "912-000",
            "name": "Piepel in Rheine (Nr.912-000)",
            "street": "Devesburg 30",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "913-000",
            "name": "Noeke in Meschede (Nr.913-000)",
            "street": "In der Giesmecke 3",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "914-000",
            "name": "Resser RV in Gelsenkirchen (Nr.914-000)",
            "street": "Brauckstraße  21",
            "house_number": "1",
            "zipcode": "45892",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "915-000",
            "name": "Gestüt Ziegelhof in Rommerskirchen (Nr.915-000)",
            "street": "Am Ziegelhof  2",
            "house_number": "1",
            "zipcode": "41569",
            "city": "Rommerskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "916-000",
            "name": "Meyers Pferdehof in Stuhr (Nr.916-000)",
            "street": "Zur Malsch 2",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "917-000",
            "name": "RTG Gut Hellerhof in Düsseldorf (Nr.917-000)",
            "street": "Rudolf-Breitscheidstr.  71",
            "house_number": "1",
            "zipcode": "40595",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "918-000",
            "name": "Hof Holtmann/Schulze Isfort in Ascheberg (Nr.918-000)",
            "street": "Davensbergerstraße 18",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "919-000",
            "name": "Reit- und Fahrverein Altlünen e.V. in Lünen (Nr.919-000)",
            "street": "Im Geistwinkel  62",
            "house_number": "1",
            "zipcode": "44534",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "920-000",
            "name": "Dieckmann in Melle (Nr.920-000)",
            "street": "Borgloher Str 65",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "921-000",
            "name": "Privatstall Meißner in Nottuln (Nr.921-000)",
            "street": "Appelhülsener Strasse 74",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "922-000",
            "name": "Privatstall Otte-Krone in Stemwede (Nr.922-000)",
            "street": "Oppenweher Str. 15",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "923-000",
            "name": "Ulli Schröder in Warstein (Nr.923-000)",
            "street": "St Barbara str 42",
            "house_number": "1",
            "zipcode": "59581",
            "city": "Warstein",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "924-000",
            "name": "Wilms in Schwalmtal (Nr.924-000)",
            "street": "Berg 36",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "925-000",
            "name": "Heidehof in Horstmar (Nr.925-000)",
            "street": "Haltern 73",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "926-000",
            "name": "Vereinigter Reit und Fahrverein Remscheid in Remscheid (Nr.926-000)",
            "street": "Buscherhof  3",
            "house_number": "1",
            "zipcode": "42899",
            "city": "Remscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "927-000",
            "name": "Shamrock Stables in Kierspe (Nr.927-000)",
            "street": "Berkenbaum 1",
            "house_number": "1",
            "zipcode": "58566",
            "city": "Kierspe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "928-000",
            "name": "R.V. Stuhr in Stuhr (Nr.928-000)",
            "street": "Stuhrer Landstraße 144",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "929-000",
            "name": "Landgut Steeg in Issum (Nr.929-000)",
            "street": "Hamsfeld 24a",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "930-000",
            "name": "Privatstall Dzialdowski in Gescher (Nr.930-000)",
            "street": "Estern  4",
            "house_number": "1",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "931-000",
            "name": "Privatstall Beerens in Selm (Nr.931-000)",
            "street": "Lüdinghausener Str 69",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "932-000",
            "name": "Privatstall Deppe in Heiden (Nr.932-000)",
            "street": "Deel 18",
            "house_number": "1",
            "zipcode": "46359",
            "city": "Heiden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "933-000",
            "name": "Leimkühler KG in Moers (Nr.933-000)",
            "street": "Wefortstraße 99",
            "house_number": "1",
            "zipcode": "47445",
            "city": "Moers",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "934-000",
            "name": "Roter stall in Bedburg (Nr.934-000)",
            "street": "Hohenholzer Straße 32",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "935-000",
            "name": "Reit- und Fahrverein Rinkerode e.V. in Drensteinfurt (Nr.935-000)",
            "street": "Im Breul 35",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "936-000",
            "name": "Reitstall Lübbehusen in Visbeck (Nr.936-000)",
            "street": "Norddöllen 1",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "937-000",
            "name": "Hubert in Haltern am See (Nr.937-000)",
            "street": "Hennewigerweg 203",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "938-000",
            "name": "Hof Schuze Vels in Kamen (Nr.938-000)",
            "street": "Im Haferfeld 5",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "939-000",
            "name": "Pferdepension Rolf in Herzebrock-Clarholz (Nr.939-000)",
            "street": "Groppeler Straße 29",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "940-000",
            "name": "Privatstall Schulze Balhorn in Sendenhorst (Nr.940-000)",
            "street": "Blankenweg 2",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "941-000",
            "name": "Privatstall Lindenbrink in Ronnenberg (Nr.941-000)",
            "street": "Reitverein Lindert 15",
            "house_number": "1",
            "zipcode": "30952",
            "city": "Ronnenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "942-000",
            "name": "Stall Bockumsfeld in Dorsten (Nr.942-000)",
            "street": "Bockumsfeld 21",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "943-000",
            "name": "Gut Nienhausen in Gelsenkirchen (Nr.943-000)",
            "street": "Laurentiusstr 38",
            "house_number": "1",
            "zipcode": "45899",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "944-000",
            "name": "Luela in Petershagen (Nr.944-000)",
            "street": "Galgenheider Str ",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "945-000",
            "name": "Reitverein vilsendorf in Bielefeld (Nr.945-000)",
            "street": "Vilsendorfer Straße 210 210",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "946-000",
            "name": "Hof Gehrendes in Willebadessen (Nr.946-000)",
            "street": "Eissener Straße  5",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "947-000",
            "name": "Süssmann in Sibbesse (Nr.947-000)",
            "street": "Mittelweg  7",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "948-000",
            "name": "Junker in Bad Sassendorf (Nr.948-000)",
            "street": "Alter Soestweg 1",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassendorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "950-000",
            "name": "Börgel in Mettingen (Nr.950-000)",
            "street": "Alte Bockradener Straße 13",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "951-000",
            "name": "Kappmeyer in Achim (Nr.951-000)",
            "street": "Am Feldrain  16",
            "house_number": "1",
            "zipcode": "28832",
            "city": "Achim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "952-000",
            "name": "Hansen in Duisburg (Nr.952-000)",
            "street": "Holtumer Mühlenweg 25",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "953-000",
            "name": "Reitverein Lengerich in Lengerich (Nr.953-000)",
            "street": "An der Reithalle 2",
            "house_number": "1",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "954-000",
            "name": "Gut Breitenhaupt in Steinheim (Nr.954-000)",
            "street": "Breitenhaupter Weg 1",
            "house_number": "1",
            "zipcode": "32839",
            "city": "Steinheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "955-000",
            "name": "Stall Stecklenberg in Fröndenberg (Nr.955-000)",
            "street": "Hauptstr 95",
            "house_number": "1",
            "zipcode": "58730",
            "city": "Fröndenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "956-000",
            "name": "Hof Averbeck in Greven (Nr.956-000)",
            "street": "Guntruper Str 44",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "957-000",
            "name": "Caballos de la Luz in Mülheim (Nr.957-000)",
            "street": "Stooter Strasse 100",
            "house_number": "1",
            "zipcode": "45481",
            "city": "Mülheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "959-000",
            "name": "Privatstall Nährmann in Salzbergen (Nr.959-000)",
            "street": "Wittenweg 2",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "960-000",
            "name": "Privat Stall Storat in Reichshof (Nr.960-000)",
            "street": "Im alten Garten 3",
            "house_number": "1",
            "zipcode": "51580",
            "city": "Reichshof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "961-000",
            "name": "Stenmans in Kerken (Nr.961-000)",
            "street": "Dorfstraße 1",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "962-000",
            "name": "Stall Schuh in Mönchengladbach (Nr.962-000)",
            "street": "Seidenweberstr 9",
            "house_number": "1",
            "zipcode": "41189",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "963-000",
            "name": "Hof Voltmer in Isernhagen (Nr.963-000)",
            "street": "Höfestraße 22",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "964-000",
            "name": "Westernranch Isterberg in Isterberg (Nr.964-000)",
            "street": "Am Wald 4",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Isterberg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "965-000",
            "name": "Privater Offenstall in Hörstel (Nr.965-000)",
            "street": "Horstesch 11",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "966-000",
            "name": "Schulze-Oeing in Schöppingen (Nr.966-000)",
            "street": "Heven 4",
            "house_number": "1",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "967-000",
            "name": "Gut Volkardey in Ratingen (Nr.967-000)",
            "street": "Volkardeyer Str 51",
            "house_number": "1",
            "zipcode": "40880",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "968-000",
            "name": "Pielerhof in Rheurdt (Nr.968-000)",
            "street": "Moerserstraße 53",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "969-000",
            "name": "Kotten Leifeld in Oelde (Nr.969-000)",
            "street": "Stromberger Schweiz 5",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "971-000",
            "name": "Privat Averes in Wilsum (Nr.971-000)",
            "street": "Zur Hopfenbachquelle 2",
            "house_number": "1",
            "zipcode": "49849",
            "city": "Wilsum",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "972-000",
            "name": "Privatstall Funke in Ramsdorf (Nr.972-000)",
            "street": "Borkener Strasse 93",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Ramsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "973-000",
            "name": "Reitstall am Bückeberg in Stadthagen (Nr.973-000)",
            "street": "An der Bornau 9",
            "house_number": "1",
            "zipcode": "31655",
            "city": "Stadthagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "974-000",
            "name": "Conradshof in Ratingen (Nr.974-000)",
            "street": "Zu den Höfen 48",
            "house_number": "1",
            "zipcode": "40882",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "975-000",
            "name": "Liethen in Erkrath (Nr.975-000)",
            "street": "Steinkaule  1",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "976-000",
            "name": "Götting in Bad Salzuflen (Nr.976-000)",
            "street": "Am lockhauserbaum 19",
            "house_number": "1",
            "zipcode": "32107",
            "city": "Bad Salzuflen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "977-000",
            "name": "RV Hellefeld in Sundern-Hellefeld (Nr.977-000)",
            "street": "Hellefelderstr. 1a",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern-Hellefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "978-000",
            "name": "Löw Reitsport in Bocholt (Nr.978-000)",
            "street": "Westend 31-39",
            "house_number": "1",
            "zipcode": "46399 ",
            "city": "Bocholt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "979-000",
            "name": "Familie Flunkert in Iserlohn (Nr.979-000)",
            "street": "Gerkendahler Weg 3",
            "house_number": "1",
            "zipcode": "58640",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "980-000",
            "name": "Reitsport Bippen e.V. in Bippen (Nr.980-000)",
            "street": "Sunderhausstraße 1",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Bippen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "981-000",
            "name": "Privatstall Bottländer in Issum (Nr.981-000)",
            "street": "Mühlenstr. 41",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "982-000",
            "name": "Reitanlage Langenhof in Plettenberg (Nr.982-000)",
            "street": "Bremcke 7",
            "house_number": "1",
            "zipcode": "58840",
            "city": "Plettenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "983-000",
            "name": "Haus Giesking in Nottuln (Nr.983-000)",
            "street": "Hangenau 25",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "984-000",
            "name": "Privatstall Warnders in Weener (Nr.984-000)",
            "street": "Alt Möhlenwarf 27",
            "house_number": "1",
            "zipcode": "26826",
            "city": "Weener",
            "state": "NIedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "985-000",
            "name": "Privatstall Oelschner in Raesfeld (Nr.985-000)",
            "street": "Hamborg  19",
            "house_number": "1",
            "zipcode": "46348",
            "city": "Raesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "986-000",
            "name": "Rennstall Jatzke in Düsseldorf (Nr.986-000)",
            "street": "Rennbahnstr 20",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "987-000",
            "name": "RV Münster Sprakel in Münster (Nr.987-000)",
            "street": "Heidegrund 233",
            "house_number": "1",
            "zipcode": "48159",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "988-000",
            "name": "Dudler Hof in Dinslaken (Nr.988-000)",
            "street": "Dickerstraße  464",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "989-000",
            "name": "Schetters Busch in Essen (Nr.989-000)",
            "street": "Schetters Busch 1",
            "house_number": "1",
            "zipcode": "45309",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "990-000",
            "name": "Küppers in Solingen (Nr.990-000)",
            "street": "Haumannst 22",
            "house_number": "1",
            "zipcode": "42651",
            "city": "Solingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "991-000",
            "name": "Reithof Remberg in Dinslaken (Nr.991-000)",
            "street": "Buschst 80",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "992-000",
            "name": "Privatstall Baldus in Ennepetal (Nr.992-000)",
            "street": "Mönninghof 33",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "993-000",
            "name": "Privatstall Wilke in Neustadt Am Rübenberge (Nr.993-000)",
            "street": "An Der Waldbühn 7",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt Am Rübenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "994-000",
            "name": "Kreutzerhof in Krefeld (Nr.994-000)",
            "street": "Vennikelstraße 44",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "995-000",
            "name": "Privatstall Leon in Fürstenau (Nr.995-000)",
            "street": "Große Haar 20",
            "house_number": "1",
            "zipcode": "49584",
            "city": "Fürstenau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "996-000",
            "name": "Reitstall Höfkes in Kempen (Nr.996-000)",
            "street": "Unterweidener Str 2",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "997-000",
            "name": "Hof Begemann in Dörentrup (Nr.997-000)",
            "street": "Untere Dorfstrasse 17",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "998-000",
            "name": "Pferdepension Ulrich Schulte in Bad Sassenberg (Nr.998-000)",
            "street": "Mühlenweg  33",
            "house_number": "1",
            "zipcode": "59505",
            "city": "Bad Sassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "999-000",
            "name": "Privatstall Heinz in Geldern (Nr.999-000)",
            "street": "Montessoristr 13",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1000-000",
            "name": "Reitanlage Baumann in Bielefeld (Nr.1000-000)",
            "street": "Heidsieker Heide 116",
            "house_number": "1",
            "zipcode": "33739",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1001-000",
            "name": "Privatstall Ottensmeyer in Hille (Nr.1001-000)",
            "street": "Friedensweg 41",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1002-000",
            "name": "Kliedter Hof in Krefeld (Nr.1002-000)",
            "street": "Papendyk 138",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1003-000",
            "name": "Fritzenhof in Neumünster (Nr.1003-000)",
            "street": "Kieler Straße 648a",
            "house_number": "1",
            "zipcode": "24536",
            "city": "Neumünster",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1004-000",
            "name": "Stall Seemann in Nienborstel (Nr.1004-000)",
            "street": "Kluhs 4",
            "house_number": "1",
            "zipcode": "24819",
            "city": "Nienborstel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1005-000",
            "name": "Hof Rützenhagen in Negernbötel (Nr.1005-000)",
            "street": "Rützenhagen 1",
            "house_number": "1",
            "zipcode": "23795",
            "city": "Negernbötel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1012-000",
            "name": "Gesenhues in Ahaus-Alstätte (Nr.1012-000)",
            "street": "Öddingstraße 5",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus-Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1006-000",
            "name": "Hof Frölich in Beckum (Nr.1006-000)",
            "street": "Unterberg II nr 19",
            "house_number": "1",
            "zipcode": "59269",
            "city": "Beckum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1007-000",
            "name": "Lieningshof in Neuenhaus (Nr.1007-000)",
            "street": "Lagerstr. 110",
            "house_number": "1",
            "zipcode": "49828",
            "city": "Neuenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1008-000",
            "name": " in Bassum (Nr.1008-000)",
            "street": "Fuhrenkamp 25 25",
            "house_number": "1",
            "zipcode": "27211",
            "city": "Bassum",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1009-000",
            "name": "Reitanlage Tellez in Fintel (Nr.1009-000)",
            "street": "Himberg  80",
            "house_number": "1",
            "zipcode": "27389",
            "city": "Fintel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1010-000",
            "name": "Klüsener in Herzebrock-Clarholz (Nr.1010-000)",
            "street": "Udenbrink  15",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1013-000",
            "name": "Vogtes Erbe Reitanlage Thier in Lüdinghausen (Nr.1013-000)",
            "street": "Ondrup 34",
            "house_number": "1",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1014-000",
            "name": "Hof Riedemann in Bramsche (Nr.1014-000)",
            "street": "Schleptruper Strang 82",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1015-000",
            "name": "Privatstall Seibel in Bockhorst (Nr.1015-000)",
            "street": "Melmstraße 15",
            "house_number": "1",
            "zipcode": "26897",
            "city": "Bockhorst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1016-000",
            "name": "Am Ravenschlag in Ennepetal (Nr.1016-000)",
            "street": "Ravenschlag  82",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1017-000",
            "name": "Niki's Ponystall in Hannover (Nr.1017-000)",
            "street": "Varrelheide  25",
            "house_number": "1",
            "zipcode": "30657",
            "city": "Hannover",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1018-000",
            "name": "Ruland in Emsdetten (Nr.1018-000)",
            "street": "Lange water  10",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1019-000",
            "name": "Lambardt in Bergkamen (Nr.1019-000)",
            "street": "Heinrichstrasse 41",
            "house_number": "1",
            "zipcode": "59192",
            "city": "Bergkamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1020-000",
            "name": "Mewissen in Schwalmtal (Nr.1020-000)",
            "street": "Eschenrath  55-57",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1021-000",
            "name": "Homann Niehoff in Münster (Nr.1021-000)",
            "street": "Homannstrasse 37",
            "house_number": "1",
            "zipcode": "48167",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1022-000",
            "name": "Pappelhof in Rheurdt (Nr.1022-000)",
            "street": "Moerser Str 51",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1023-000",
            "name": "Scheidtmann in Hattingen (Nr.1023-000)",
            "street": "Kohlenstrasse 183",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1024-000",
            "name": "Grönings Hof in Marl (Nr.1024-000)",
            "street": "Wellerfeldweg 13",
            "house_number": "1",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1025-000",
            "name": "Bussmann in  (Nr.1025-000)",
            "street": " ",
            "house_number": "1",
            "collect_point": "nein"
        },
        {
            "ID": "1026-000",
            "name": "Hof Reipen in Rhede (Nr.1026-000)",
            "street": "Büngerner Allee 17",
            "house_number": "1",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1027-000",
            "name": "Privatstall Arndt in Neuenkirchen (Nr.1027-000)",
            "street": "Friedenstr. 57",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1028-000",
            "name": "Offenstall Vor den Moore - Privat in Neustadt (Nr.1028-000)",
            "street": "Ahnser Weg 8",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1057-000",
            "name": "Lützow Schuckenbaum in Leopoldshöhe (Nr.1057-000)",
            "street": "Eckendorferstr 74",
            "house_number": "1",
            "zipcode": "33818",
            "city": "Leopoldshöhe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1029-000",
            "name": "Leas Reitschule in Straelen (Nr.1029-000)",
            "street": "Broekhuysener Str. 1",
            "house_number": "1",
            "zipcode": "47638",
            "city": "Straelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1030-000",
            "name": "Luisenhof in Krefeld (Nr.1030-000)",
            "street": "Flünnertzdyk 161",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1031-000",
            "name": "sportpferde Lohhof in Wedemark (Nr.1031-000)",
            "street": "lange loh  15",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1032-000",
            "name": "Stall Rohleder in Dortmund (Nr.1032-000)",
            "street": "Am Hausacker 5",
            "house_number": "1",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1033-000",
            "name": "Scheibe in Söhlde (Nr.1033-000)",
            "street": "Lindenallee 10",
            "house_number": "1",
            "zipcode": "31185",
            "city": "Söhlde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1034-000",
            "name": "Reitstall Boerger in Lennestadt (Nr.1034-000)",
            "street": "Seilmecke 17a",
            "house_number": "1",
            "zipcode": "57368",
            "city": "Lennestadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1035-000",
            "name": "Offenstall Warneke in Alveslohe (Nr.1035-000)",
            "street": "Dieckskamp 23",
            "house_number": "1",
            "zipcode": "25486",
            "city": "Alveslohe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1036-000",
            "name": "Topp in Lippetal (Nr.1036-000)",
            "street": "Hüttinghauserweg 3",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1037-000",
            "name": "Offenstall Kopp in Dorsten (Nr.1037-000)",
            "street": "Nelkenstr. 15",
            "house_number": "1",
            "zipcode": "46284",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1038-000",
            "name": "Kersebohm in Lünen (Nr.1038-000)",
            "street": "Im Siepen 3",
            "house_number": "1",
            "zipcode": "44536",
            "city": "Lünen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1039-000",
            "name": "Zucht-&Pensionsstall Becker-lütke-Bexten in Ostbevern (Nr.1039-000)",
            "street": "Schirl  68",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1040-000",
            "name": "Uesbeck in Gronau (Nr.1040-000)",
            "street": "Schlamannweg 62a",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1041-000",
            "name": "Kriest in Recklinghausen (Nr.1041-000)",
            "street": "Christine-Englerth-Str.  24",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1042-000",
            "name": "Reit und Fahrverein e.V. in Dörentrup (Nr.1042-000)",
            "street": "Untere Dorfstraße 36",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1043-000",
            "name": "Grabe in Lippetal (Nr.1043-000)",
            "street": "Schachtruper weg  1",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1044-000",
            "name": "Quitthoevelshof Tennagels in Geldern (Nr.1044-000)",
            "street": "Am Mühlenwasser  56",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1045-000",
            "name": "Wiebke Felderhoff in Bremen (Nr.1045-000)",
            "street": "Oberneulander Landstraße 145c",
            "house_number": "1",
            "zipcode": "28355",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "1046-000",
            "name": "Spiekermann in Bönen (Nr.1046-000)",
            "street": "Sinnerstraße 4",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1047-000",
            "name": "Gütges in Geldern (Nr.1047-000)",
            "street": "Poststr. 6",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1048-000",
            "name": "Malorny in Viersen (Nr.1048-000)",
            "street": "Am Buschfeld 87",
            "house_number": "1",
            "zipcode": "41747",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1049-000",
            "name": "Gilbers in Rheurdt (Nr.1049-000)",
            "street": "Kengen 66",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1050-000",
            "name": "Ruf Lohne in Lohne (Nr.1050-000)",
            "street": "Reiterweg  10",
            "house_number": "1",
            "zipcode": "49393",
            "city": "Lohne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1051-000",
            "name": "Hilling in Lathen (Nr.1051-000)",
            "street": "Emsweg 29b",
            "house_number": "1",
            "zipcode": "49762",
            "city": "Lathen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1052-000",
            "name": "Ponyfarm in Rheine (Nr.1052-000)",
            "street": "Bauerschaftsstraße 196",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1053-000",
            "name": "Hof Eulenkrug in Ahrensburg (Nr.1053-000)",
            "street": "Hamburger Straße 248",
            "house_number": "1",
            "zipcode": "22926",
            "city": "Ahrensburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1054-000",
            "name": "Schröder in Hille-Hartum (Nr.1054-000)",
            "street": "Holzhauser Straße 119",
            "house_number": "1",
            "zipcode": "32479",
            "city": "Hille-Hartum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1055-000",
            "name": "Reit- und Fahverein Wilhelminenhof e.V. in Ladelund (Nr.1055-000)",
            "street": "Wilhelmine Straße 3",
            "house_number": "1",
            "zipcode": "25926",
            "city": "Ladelund",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1056-000",
            "name": "Privatstall Schumacher in Kappeln (Nr.1056-000)",
            "street": "Heidesiedlung 50",
            "house_number": "1",
            "zipcode": "24376",
            "city": "Kappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1059-000",
            "name": "Pferdestall Pool in Lingen (Nr.1059-000)",
            "street": "Kleekamp 1",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1060-000",
            "name": "Sportpferdezucht Hof Charlottenlind in Gudow (Nr.1060-000)",
            "street": "Hauptstrasse 45",
            "house_number": "1",
            "zipcode": "23899",
            "city": "Gudow",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1061-000",
            "name": "Mühlenhof in Hürth (Nr.1061-000)",
            "street": "Mühlenweg 11",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1062-000",
            "name": "Hof Büsse in Sibbesse (Nr.1062-000)",
            "street": "Kirchstraße 28",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1064-000",
            "name": "Reit und Fahrverein Uetze und Umgebung e.V. in Uetze (Nr.1064-000)",
            "street": "Am Wolfsbusch 2",
            "house_number": "1",
            "zipcode": "31311",
            "city": "Uetze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1065-000",
            "name": "Privat/Kirschbaum/Borgs in Rosendahl-Holtwick (Nr.1065-000)",
            "street": "Bleck 8",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Holtwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1066-000",
            "name": "Bökhaus in Lage (Nr.1066-000)",
            "street": "Lemgoer Str 154",
            "house_number": "1",
            "zipcode": "32791",
            "city": "Lage",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1067-000",
            "name": "Stonehouse Ranch in Herne (Nr.1067-000)",
            "street": "Wiedehopfstrasse  200",
            "house_number": "1",
            "zipcode": "44653",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1068-000",
            "name": "Selker in Horstmar-Leer (Nr.1068-000)",
            "street": "Haltern  59",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar-Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1069-000",
            "name": "Ohana in Bargtheide (Nr.1069-000)",
            "street": "Alte Landstraße 111",
            "house_number": "1",
            "zipcode": "22941",
            "city": "Bargtheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1070-000",
            "name": "Privatstall Hindersmann in Mettingen (Nr.1070-000)",
            "street": "Neuenkirchener Straße  128",
            "house_number": "1",
            "zipcode": "49497",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1071-000",
            "name": "Reitstall Janneby in Janneby (Nr.1071-000)",
            "street": "Ringstraße 8",
            "house_number": "1",
            "zipcode": "24992",
            "city": "Janneby",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1072-000",
            "name": "Hof Ohlemeyer in Minden (Nr.1072-000)",
            "street": "Barrlinge 4",
            "house_number": "1",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1073-000",
            "name": "Privater Stall in Nöpke in Neustadt (Nr.1073-000)",
            "street": "Kleieweg 3a",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1074-000",
            "name": "Stentenbach in Nordhorn (Nr.1074-000)",
            "street": "Isterberger Weg 56",
            "house_number": "1",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1075-000",
            "name": "Pferdehof Kruse in Neuenrade (Nr.1075-000)",
            "street": "Oberer Beuler Weg 25",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1076-000",
            "name": "Gut Holtau in Winsen (Aller) (Nr.1076-000)",
            "street": "Gut Holtau 1",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1077-000",
            "name": "Reitgemeinschaft Schlagbaum in Ennepetal (Nr.1077-000)",
            "street": "Schlagbaum  17",
            "house_number": "1",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1078-000",
            "name": "Marie‘s Pony Paradies in Kaarst (Nr.1078-000)",
            "street": "Rottes 155",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1079-000",
            "name": "Haus Steprath in Geldern (Nr.1079-000)",
            "street": "Am Böckelken 35",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1080-000",
            "name": "Reiterhof Tramm in Damp (Nr.1080-000)",
            "street": "Dorotheental  1",
            "house_number": "1",
            "zipcode": "24351",
            "city": "Damp",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1081-000",
            "name": "Kaltenborner Offenstall in Overath (Nr.1081-000)",
            "street": "Kaltenborn 15a",
            "house_number": "1",
            "zipcode": "51491",
            "city": "Overath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1082-000",
            "name": "Reitstall Pasternhof in Krefeld (Nr.1082-000)",
            "street": "Vorderorbroich 63",
            "house_number": "1",
            "zipcode": "47839 ",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1083-000",
            "name": "Reitstall Embsen in Embsen (Nr.1083-000)",
            "street": "Ringstr 1",
            "house_number": "1",
            "zipcode": "21409",
            "city": "Embsen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1084-000",
            "name": "Seibel Ranch in Brekendorf (Nr.1084-000)",
            "street": "Hammer 2",
            "house_number": "1",
            "zipcode": "24811",
            "city": "Brekendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1085-000",
            "name": "Mühlenhof in Westerkappeln (Nr.1085-000)",
            "street": "Mühlenweg 13",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1086-000",
            "name": "Privatstall Helfgerdt in Delbrück (Nr.1086-000)",
            "street": "Baumweg 21",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1087-000",
            "name": "Sport- und Freizeitstall Grefen in Meerbusch (Nr.1087-000)",
            "street": "Am oberen Feld 94",
            "house_number": "1",
            "zipcode": "40668",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1088-000",
            "name": "PSV Meeresreiter in Seelze (Nr.1088-000)",
            "street": "Am Wall 4",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1089-000",
            "name": "Am Mühlenbach in Bliestorf (Nr.1089-000)",
            "street": "Am Mühlenbach  2",
            "house_number": "1",
            "zipcode": "23847",
            "city": "Bliestorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1090-000",
            "name": "Niemann in Visbek (Nr.1090-000)",
            "street": "Lohe 7",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1092-000",
            "name": "Platen in Kempen (Nr.1092-000)",
            "street": "Neuenweg 4",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1093-000",
            "name": "Annika Mielke (privat) in Ganderkesee (Nr.1093-000)",
            "street": "Wildeshauser Landstraße ",
            "house_number": "1",
            "zipcode": "27777",
            "city": "Ganderkesee",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1094-000",
            "name": "Stallgemeinschaft Metelen in Metelen (Nr.1094-000)",
            "street": "Schreiber Esch 8",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1095-000",
            "name": "Gestüt Forstwald in Castrop Rauxel (Nr.1095-000)",
            "street": "Westring 347",
            "house_number": "1",
            "zipcode": "44575",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1096-000",
            "name": "Reitanlage Franzen in Korschenbroich (Nr.1096-000)",
            "street": "Krünsend 64",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1097-000",
            "name": "Geisthoff in Ahlen (Nr.1097-000)",
            "street": "Westhusener weg 5",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1098-000",
            "name": "Gestüt Störtal  in Ehndorf (Nr.1098-000)",
            "street": "Heischredde 3",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1099-000",
            "name": "Gut Bimberg in Unna (Nr.1099-000)",
            "street": "Gut Bimberg ",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1101-000",
            "name": "RFG Auetal e.V. in Schwanewede (Nr.1101-000)",
            "street": "Wiesenstraße 43",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1100-000",
            "name": "Privatstall in Berge (Nr.1100-000)",
            "street": "Hekeser Str. 42",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Berge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1102-000",
            "name": "Schlungshof in Willich (Nr.1102-000)",
            "street": "Stock 110",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1103-000",
            "name": "Hof Eckhorst in Güby (Nr.1103-000)",
            "street": "Eckhorst 6",
            "house_number": "1",
            "zipcode": "24357",
            "city": "Güby",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1104-000",
            "name": "Privatstall Utta in Greven (Nr.1104-000)",
            "street": "Herberner Mersch 22",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1105-000",
            "name": "Steinburg Shires Fam. Hauschildt in Winseldorf (Nr.1105-000)",
            "street": "Oberstr. 22",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Winseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1106-000",
            "name": "Privatstall Rinas-Tenberg in Mettingen (Nr.1106-000)",
            "street": "Woorteweg  9",
            "house_number": "1",
            "zipcode": "49497 ",
            "city": "Mettingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1107-000",
            "name": "Katrin Kreihe in Braunschweig (Nr.1107-000)",
            "street": "Eutschenwinkel  1",
            "house_number": "1",
            "zipcode": "38124 ",
            "city": "Braunschweig",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1108-000",
            "name": "Hof Schierenbeck in Weyhe (Nr.1108-000)",
            "street": "Weyher Bruch 30",
            "house_number": "1",
            "zipcode": "28844",
            "city": "Weyhe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1109-000",
            "name": "Gestüt Kobbensen in Heuerßen (Nr.1109-000)",
            "street": "Im Krümmel 8",
            "house_number": "1",
            "zipcode": "31700",
            "city": "Heuerßen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1110-000",
            "name": "Privatstall Göfert in Coesfeld (Nr.1110-000)",
            "street": "Coesfelder Berg  17",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1111-000",
            "name": "Tiemann in Hamm (Nr.1111-000)",
            "street": "Dasbeck  10",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1117-000",
            "name": "Perlenhof in Winsen (Nr.1117-000)",
            "street": "Ostenholzer Str 51",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1118-000",
            "name": "Hof Wichmann in Coesfeld (Nr.1118-000)",
            "street": "Herteler  32",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1119-000",
            "name": "Gartz in Nettetal (Nr.1119-000)",
            "street": "An Schönkes Krüz 2",
            "house_number": "1",
            "zipcode": "41334",
            "city": "Nettetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1120-000",
            "name": "RuFV Eiderstedt in Garding (Nr.1120-000)",
            "street": "Graureiherweg ",
            "house_number": "1",
            "zipcode": "25836",
            "city": "Garding",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1121-000",
            "name": "Gerding in Nottuln-Darup (Nr.1121-000)",
            "street": "Hastehausen 9",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln-Darup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1122-000",
            "name": "Privatstall Mahmens in Stapel (Nr.1122-000)",
            "street": "Breite Str. 7",
            "house_number": "1",
            "zipcode": "25879",
            "city": "Stapel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1123-000",
            "name": "Gut Reuschenberg in Leverkusen (Nr.1123-000)",
            "street": "Gut Reuschenberg 1",
            "house_number": "1",
            "zipcode": "51373",
            "city": "Leverkusen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1124-000",
            "name": "Rennstall Kleinbrahm in Bottrop (Nr.1124-000)",
            "street": "Brabecker Feld 27",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1125-000",
            "name": "Postkunden in  (Nr.1125-000)",
            "street": "Postkunden ",
            "house_number": "1",
            "zipcode": "Postkunden",
            "collect_point": "nein"
        },
        {
            "ID": "1126-000",
            "name": "Privatstall Ingwersen in Ostenfeld (Nr.1126-000)",
            "street": "Heidweg  13",
            "house_number": "1",
            "zipcode": "25872",
            "city": "Ostenfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1127-000",
            "name": "Engelking in Raddestorf (Nr.1127-000)",
            "street": "Harrienstedt 60",
            "house_number": "1",
            "zipcode": "31604",
            "city": "Raddestorf",
            "collect_point": "nein"
        },
        {
            "ID": "1128-000",
            "name": "Hof Segbert in Dülmen (Nr.1128-000)",
            "street": "Bauerschaft  20",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1129-000",
            "name": "Kretschmann in Heidgraben (Nr.1129-000)",
            "street": "Pipenblink 27",
            "house_number": "1",
            "zipcode": "25436",
            "city": "Heidgraben",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1130-000",
            "name": "Finkenbrink in Recklinghausen (Nr.1130-000)",
            "street": "Dortmunderstr. 163",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1131-000",
            "name": "Raedgeshof Kempen in Kempen (Nr.1131-000)",
            "street": "An Haus Steinfunder 9",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1132-000",
            "name": "Reitanlage auf dem Ströhen in Steinhagen (Nr.1132-000)",
            "street": "Ströher Str. 46",
            "house_number": "1",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1133-000",
            "name": "Pferdepension Blome in Arnsberg (Nr.1133-000)",
            "street": "Westerholtstr. 2",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1134-000",
            "name": "Pferdehof Nottuln (Wedding) in Nottuln (Nr.1134-000)",
            "street": "Horst 15",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1135-000",
            "name": "Pugge in Greven (Nr.1135-000)",
            "street": "Pentruper Mersch 45",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1136-000",
            "name": "Kaiser in Soest (Nr.1136-000)",
            "street": "Eichenweg  4",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1137-000",
            "name": "Holthäuser Hof in Waltrop (Nr.1137-000)",
            "street": "Im Eickel 42",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1138-000",
            "name": "Stallgemeinschaft Happy Hippos in Castrop Rauxel (Nr.1138-000)",
            "street": "Im Finkenbrink 34",
            "house_number": "1",
            "zipcode": "44581",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1140-000",
            "name": "Bültel in Emsbüren (Nr.1140-000)",
            "street": "Lingenerstraße 31",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1141-000",
            "name": "Kenzler in Nideggen (Nr.1141-000)",
            "street": "Neffeltalstrasse 24",
            "house_number": "1",
            "zipcode": "52385",
            "city": "Nideggen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1142-000",
            "name": "Wonderland Ranch in Wiehl (Nr.1142-000)",
            "street": "Scheidter Straße ",
            "house_number": "1",
            "zipcode": "51674",
            "city": "Wiehl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1143-000",
            "name": "Iron Horse Ranch in Hamminkeln (Nr.1143-000)",
            "street": "Ißhorst 6",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1144-000",
            "name": "Privat Kaiser in Ibbenbüren (Nr.1144-000)",
            "street": "An der Blankenburg 99",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1145-000",
            "name": "Krude in Schwalmtal (Nr.1145-000)",
            "street": "Renneperstr 32a",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1146-000",
            "name": "Privatstall Schönke in Peine/Vöhrum (Nr.1146-000)",
            "street": "Kirchvordenerstr 13A",
            "house_number": "1",
            "zipcode": "31228",
            "city": "Peine/Vöhrum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1147-000",
            "name": "Pferdepension und Landwirtschaft Muckhof in Bochum (Nr.1147-000)",
            "street": "Deimketal 44",
            "house_number": "1",
            "zipcode": "44879",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1148-000",
            "name": "Privatstall Weltring in Lingen (Nr.1148-000)",
            "street": "Hohlweg 7",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1149-000",
            "name": "Privatstall Möller in Dötlingen (Nr.1149-000)",
            "street": "Zur Loh 23",
            "house_number": "1",
            "zipcode": "27801",
            "city": "Dötlingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1150-000",
            "name": "Reitschule und Reiterhof Steinmeier-Beese in Everswinkel (Nr.1150-000)",
            "street": "Evener  16",
            "house_number": "1",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1151-000",
            "name": "Privatstall Bessmann in Harsewinkel (Nr.1151-000)",
            "street": "Tüllheide 6",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1152-000",
            "name": "Thunhof in Schloß Neuhaus (Nr.1152-000)",
            "street": "Am Thunhof ",
            "house_number": "1",
            "zipcode": "33104",
            "city": "Schloß Neuhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1153-000",
            "name": "Heumann in Stuhr (Nr.1153-000)",
            "street": "Kladdingerstr. 3",
            "house_number": "1",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1154-000",
            "name": "Privatstall Wittenburg in Hohenlockstedt (Nr.1154-000)",
            "street": "Ridders 31",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Hohenlockstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1155-000",
            "name": "Privatstall Beiermann in Hörstel (Nr.1155-000)",
            "street": "Nagels Damm 67",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1156-000",
            "name": "Eigener Offenstall in Witten (Nr.1156-000)",
            "street": "Oberkrone 36",
            "house_number": "1",
            "zipcode": "58455",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1157-000",
            "name": "Rohloff in Freienwill (Nr.1157-000)",
            "street": "Alte Dorfstr. 13",
            "house_number": "1",
            "zipcode": "24991",
            "city": "Freienwill",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1158-000",
            "name": "Mahner Berg in Salzgitter Bad (Nr.1158-000)",
            "street": "Mahner Berg 12",
            "house_number": "1",
            "zipcode": "38259",
            "city": "Salzgitter Bad",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1159-000",
            "name": "Privatstall Krallmann in Meppen (Nr.1159-000)",
            "street": "Flutmulde 8",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1160-000",
            "name": "RFV Bötenberg - Wietzen in  Balge  (Nr.1160-000)",
            "street": "Bötenberger Str. 82",
            "house_number": "1",
            "zipcode": "31609",
            "city": " Balge ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1161-000",
            "name": "Gut Höbek in Haßmoor (Nr.1161-000)",
            "street": "Gut Höbek 1",
            "house_number": "1",
            "zipcode": "24790",
            "city": "Haßmoor",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1162-000",
            "name": "Gut Waldhof Home of healthy horses in  Kisdorf (Nr.1162-000)",
            "street": "Am Waldhof 6",
            "house_number": "1",
            "zipcode": "24629",
            "city": " Kisdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1163-000",
            "name": "Lassen in Waabs (Nr.1163-000)",
            "street": "Flintholm 1",
            "house_number": "1",
            "zipcode": "24369",
            "city": "Waabs",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1164-000",
            "name": "Privatstall Straube in Stadtlohn  (Nr.1164-000)",
            "street": "Estern 78",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1165-000",
            "name": "Wenne Valley Ranch  in Schmallenberg (Nr.1165-000)",
            "street": "Grimminghausen 2",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1166-000",
            "name": "Mangelsen  in Wees (Nr.1166-000)",
            "street": "Blixberg 1",
            "house_number": "1",
            "zipcode": "24999",
            "city": "Wees",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1167-000",
            "name": "Privatstall Droste in Lingen (Nr.1167-000)",
            "street": "Duisenburgerstraße 9",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1168-000",
            "name": "Lengelshof in Ratingen  (Nr.1168-000)",
            "street": "Lengelshof 1",
            "house_number": "1",
            "zipcode": "40883",
            "city": "Ratingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1169-000",
            "name": "Reitstall Stegen in Jersbek  (Nr.1169-000)",
            "street": "Alte Landstraße 1H",
            "house_number": "1",
            "zipcode": "22941",
            "city": "Jersbek ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1170-000",
            "name": "Sandra in Velbert  (Nr.1170-000)",
            "street": "Nierenhofer Straße 10",
            "house_number": "1",
            "zipcode": "45509",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1171-000",
            "name": "Privatstall Schmidt in Seelze  (Nr.1171-000)",
            "street": "Im Busche 8",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1172-000",
            "name": "Stall Lüerdissen in Lemgo (Nr.1172-000)",
            "street": "Zur Behrensburg 19",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1173-000",
            "name": "Privatstall Neumann in Niederkassel (Nr.1173-000)",
            "street": "Sülzstr. 7",
            "house_number": "1",
            "zipcode": "53859",
            "city": "Niederkassel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1174-000",
            "name": "Privatstall Wenzel in Niederkrüchten (Nr.1174-000)",
            "street": "Dilborner Str. 5",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1175-000",
            "name": "Ekkehard Heuser  in Ahnatal  (Nr.1175-000)",
            "street": "Schulstr 17",
            "house_number": "1",
            "zipcode": "34292",
            "city": "Ahnatal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1176-000",
            "name": "Reitstall Hans Lugge in Mülheim  (Nr.1176-000)",
            "street": "Gänseweg 80",
            "house_number": "1",
            "zipcode": "45475",
            "city": "Mülheim ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1177-000",
            "name": "Hechmann in Lennestadt (Nr.1177-000)",
            "street": "Fredeburger Str 104",
            "house_number": "1",
            "zipcode": "57368",
            "city": "Lennestadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1178-000",
            "name": "Vogt in Drensteinfurt  (Nr.1178-000)",
            "street": "Herrenstein 26",
            "house_number": "1",
            "zipcode": "48317",
            "city": "Drensteinfurt ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1179-000",
            "name": "Wilde Banausen  in Tostedt  (Nr.1179-000)",
            "street": "Poststraße 34",
            "house_number": "1",
            "zipcode": "21255",
            "city": "Tostedt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1180-000",
            "name": "Rayker Hof Matuszak in Lehe (Nr.1180-000)",
            "street": "Bundesstraße 12",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Lehe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1181-000",
            "name": "Equus Dynamics Daria Böker / Gut Lödding in Hamm (Nr.1181-000)",
            "street": "Holunderweg 11",
            "house_number": "1",
            "zipcode": "59063",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1182-000",
            "name": "RSG Busche in Hückeswagen  (Nr.1182-000)",
            "street": "Busche  3",
            "house_number": "1",
            "zipcode": "42499",
            "city": "Hückeswagen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1183-000",
            "name": "Wurth in Lindlar (Nr.1183-000)",
            "street": "Stellberg 1",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1184-000",
            "name": "Eichstädt in Münster (Nr.1184-000)",
            "street": "Westfalenstr. 88",
            "house_number": "1",
            "zipcode": "48165",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1185-000",
            "name": "Hof Berning in Emsdetten (Nr.1185-000)",
            "street": "Isendorf 64",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1186-000",
            "name": "Göbel in Bochum (Nr.1186-000)",
            "street": "Bertastraße 8",
            "house_number": "1",
            "zipcode": "44793",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1187-000",
            "name": "Reitsportanlage kisters in Oberhausen (Nr.1187-000)",
            "street": "Waldhuckstraße 187",
            "house_number": "1",
            "zipcode": "46147",
            "city": "Oberhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1188-000",
            "name": "Islandpferde vom Torhaus in Warnau (Nr.1188-000)",
            "street": "Dorfstraße  24",
            "house_number": "1",
            "zipcode": "24250",
            "city": "Warnau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1189-000",
            "name": "Reitstall Seehausen in Wunstorf (Nr.1189-000)",
            "street": "Heidorner Str. 63",
            "house_number": "1",
            "zipcode": "31515",
            "city": "Wunstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1190-000",
            "name": "Hepp in Schönbek (Nr.1190-000)",
            "street": "Dorfstraße 21",
            "house_number": "1",
            "zipcode": "24582",
            "city": "Schönbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1191-000",
            "name": "Stegerhof in Voerde (Nr.1191-000)",
            "street": "Stegerweg 19",
            "house_number": "1",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1192-000",
            "name": "Ristau in Fitzbek  (Nr.1192-000)",
            "street": "Mühlenstraße 4",
            "house_number": "1",
            "zipcode": "25579",
            "city": "Fitzbek ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1193-000",
            "name": "Pferderesort Wesling in Warmsen (Nr.1193-000)",
            "street": "Brüninghorstedt 5",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1194-000",
            "name": "Privatstall Ma in Eschede (Nr.1194-000)",
            "street": "Eichenstrasse 2",
            "house_number": "1",
            "zipcode": "29348",
            "city": "Eschede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1195-000",
            "name": "Offenstall Denkfein  in Mettmann (Nr.1195-000)",
            "street": "Laubach 26a",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1196-000",
            "name": "Wesche in Burgdorf  (Nr.1196-000)",
            "street": "Am Vorwerk 18",
            "house_number": "1",
            "zipcode": "31303",
            "city": "Burgdorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1197-000",
            "name": "Hof nedderby in Husby  (Nr.1197-000)",
            "street": "Nedderbyer str 11",
            "house_number": "1",
            "zipcode": "24975",
            "city": "Husby ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1198-000",
            "name": "Psv Coldinne  in Großheide (Nr.1198-000)",
            "street": "Heerweg  11",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1199-000",
            "name": "Wiesendahl in Hamm (Nr.1199-000)",
            "street": "Auf dem Südfelde 5",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1200-000",
            "name": "Kulturhof Neuner in Wingst (Nr.1200-000)",
            "street": "Altkehdinger Weg 50",
            "house_number": "1",
            "zipcode": "21789",
            "city": "Wingst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1201-000",
            "name": "Heineke in Syke  (Nr.1201-000)",
            "street": "Specken 1",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1202-000",
            "name": "Reitanlage Hassel in Bergen (Nr.1202-000)",
            "street": "Hassel 1a",
            "house_number": "1",
            "zipcode": "29303",
            "city": "Bergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1204-000",
            "name": "Erburt in Friesoythe (Nr.1204-000)",
            "street": "Bundesstraße 87",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1205-000",
            "name": "Loagshof in Warstein (Nr.1205-000)",
            "street": "Sauerlandstr 14",
            "house_number": "1",
            "zipcode": "59581",
            "city": "Warstein",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1206-000",
            "name": "RFZV St. Hubertus Herne  in Herne (Nr.1206-000)",
            "street": "Holthauser Str. 91",
            "house_number": "1",
            "zipcode": "44627",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1207-000",
            "name": "Eichkamp in Ehndorf (Nr.1207-000)",
            "street": "Heischredder 2",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1208-000",
            "name": "Privatstall Busch in Bad Laasphe  (Nr.1208-000)",
            "street": "Mittelstraße 21",
            "house_number": "1",
            "zipcode": "57334",
            "city": "Bad Laasphe ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1209-000",
            "name": "Büttger Buscherhöfe in Kaarst (Nr.1209-000)",
            "street": "Büttger Buscherhöfe 8a",
            "house_number": "1",
            "zipcode": "41564",
            "city": "Kaarst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1210-000",
            "name": "Ebkens in Barßel (Nr.1210-000)",
            "street": "Carolinenhofstraße 1",
            "house_number": "1",
            "zipcode": "26676",
            "city": "Barßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1211-000",
            "name": "Reitstall Peters in Heinsberg- Randerath  (Nr.1211-000)",
            "street": "Am Hellenkamp 38",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg- Randerath ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1212-000",
            "name": "Privatstall Eifler in Hürth (Nr.1212-000)",
            "street": "Burgstraße  66",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1213-000",
            "name": "Antje Kötters in Rosendahl (Nr.1213-000)",
            "street": "Rockel  31",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1214-000",
            "name": "Hesping in Hörstel (Nr.1214-000)",
            "street": "Brandhakenweg 12",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1215-000",
            "name": "Pferdehof Mohme  in Porta Westfalica (Nr.1215-000)",
            "street": "Albert-Schweitzer-Str. 21",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1216-000",
            "name": "Privatstall Fenner in Buseck in Buseck (Nr.1216-000)",
            "street": "Grossen-Busecker Str.  41",
            "house_number": "1",
            "zipcode": "35418",
            "city": "Buseck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1217-000",
            "name": "Eichkamp Ehndorf in Ehndorf (Nr.1217-000)",
            "street": "Heischredder 2",
            "house_number": "1",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1218-000",
            "name": "Privatstall Lingens in Bramsche (Nr.1218-000)",
            "street": "Balkumer Str.  33",
            "house_number": "1",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1219-000",
            "name": "Privatstall Grose in Verden (Aller) (Nr.1219-000)",
            "street": "Osterortstr. 20",
            "house_number": "1",
            "zipcode": "27283",
            "city": "Verden (Aller)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1220-000",
            "name": "Leikop in Brilon (Nr.1220-000)",
            "street": "Remstoß 7",
            "house_number": "1",
            "zipcode": "59929",
            "city": "Brilon",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1221-000",
            "name": "Helmuth Schröder in Dänischenhagen (Nr.1221-000)",
            "street": "Kaltenhofer Allee 35",
            "house_number": "1",
            "zipcode": "24229",
            "city": "Dänischenhagen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1222-000",
            "name": "Reitstall Tempel in Kempen (Nr.1222-000)",
            "street": "Pielmey 6",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1223-000",
            "name": "Pferdefreunde Filsum in Filsum (Nr.1223-000)",
            "street": "Burgweg 9",
            "house_number": "1",
            "zipcode": "26849",
            "city": "Filsum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1224-000",
            "name": "Privatstall Weigand in Ilsede (Nr.1224-000)",
            "street": "Dorfstraße 23",
            "house_number": "1",
            "zipcode": "31241",
            "city": "Ilsede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1225-000",
            "name": "Hof Everding in Harsewinkel (Nr.1225-000)",
            "street": "Berkort 5",
            "house_number": "1",
            "zipcode": "33428",
            "city": "Harsewinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1226-000",
            "name": "Privatstall Dunkel in Schalksmühle (Nr.1226-000)",
            "street": "Resswinkeler Weg 49",
            "house_number": "1",
            "zipcode": "58579",
            "city": "Schalksmühle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1227-000",
            "name": "Privatstall Breforth in Hamm (Nr.1227-000)",
            "street": "Dennehauptweg 3a",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1228-000",
            "name": "Privatstall Ganser in Pulheim (Nr.1228-000)",
            "street": "Johann-Hermanns-Weg  16",
            "house_number": "1",
            "zipcode": "50259",
            "city": "Pulheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1229-000",
            "name": "Hof Düren in Witten (Nr.1229-000)",
            "street": "Dürener Str. 32",
            "house_number": "1",
            "zipcode": "58454",
            "city": "Witten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1230-000",
            "name": "Martin Düsterhöft in Melle (Nr.1230-000)",
            "street": "Bruchmühlener Straße 61",
            "house_number": "1",
            "zipcode": "49328",
            "city": "Melle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1231-000",
            "name": "Reitschule Sandkrug in Hatten (Nr.1231-000)",
            "street": "Bümmersteder Straße 57",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1232-000",
            "name": "Privatstall Mannott in Hohn (Nr.1232-000)",
            "street": "Königsbach 10",
            "house_number": "1",
            "zipcode": "24806",
            "city": "Hohn",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1233-000",
            "name": "Hengststation Müller in Badbergen (Nr.1233-000)",
            "street": "Burlagerweg 10a",
            "house_number": "1",
            "zipcode": "49635",
            "city": "Badbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1234-000",
            "name": "Reit- und Fahrstall Lindenhof in Lindlar (Nr.1234-000)",
            "street": "Unterkotten 2",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1235-000",
            "name": "Sperath in Nordenham (Nr.1235-000)",
            "street": "Hansingstraße 62",
            "house_number": "1",
            "zipcode": "26954",
            "city": "Nordenham",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1236-000",
            "name": "Privatstall Kampe in Hürth (Nr.1236-000)",
            "street": "Marktweg 31",
            "house_number": "1",
            "zipcode": "50354",
            "city": "Hürth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1237-000",
            "name": "von Winterfell in Wedemark (Nr.1237-000)",
            "street": "Auf Dem Kiel 10",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1238-000",
            "name": "Luner Hof der Pferde in Beverstedt (Nr.1238-000)",
            "street": "Reithornsweg 32",
            "house_number": "1",
            "zipcode": "27616",
            "city": "Beverstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1239-000",
            "name": "Privatstall Hemsing in Steinfurt (Nr.1239-000)",
            "street": "Hollich 119",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1240-000",
            "name": "Lagemann in Tecklenburg (Nr.1240-000)",
            "street": "Horstmersch 41",
            "house_number": "1",
            "zipcode": "49545",
            "city": "Tecklenburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1242-000",
            "name": "Privatstall Brandt in Varel (Nr.1242-000)",
            "street": "Im Winkel 7",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1243-000",
            "name": "Privatstall Cleve in Hessisch Oldendorf (Nr.1243-000)",
            "street": "Rittergutstraße 47",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1244-000",
            "name": "Reit-Fahr-u. Zuchtverein Bochum-Nord in Bochum (Nr.1244-000)",
            "street": "Zillertalstraße 89",
            "house_number": "1",
            "zipcode": "44807",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1245-000",
            "name": "Reiterhof Stubbe in Hamburg (Nr.1245-000)",
            "street": "Billwerder Billdeich  272",
            "house_number": "1",
            "zipcode": "21033",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1246-000",
            "name": "Privatstall Beewen in Döhlen (Nr.1246-000)",
            "street": "Krumlander Straße 9",
            "house_number": "1",
            "zipcode": "26197",
            "city": "Döhlen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1247-000",
            "name": "Jill Flocke in Wuppertal (Nr.1247-000)",
            "street": "Teschensudberger Straße 24a",
            "house_number": "1",
            "zipcode": "42349",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1248-000",
            "name": "Privatstall Kowalski in Rheine (Nr.1248-000)",
            "street": "Auf dem Brink 13",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1249-000",
            "name": "Reitstall Burchard in Ronnenberg (Nr.1249-000)",
            "street": "Holtenser Straße 4",
            "house_number": "1",
            "zipcode": "30952",
            "city": "Ronnenberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1250-000",
            "name": "Reitverein Milte-Sassenberg in Warendorf-Milte (Nr.1250-000)",
            "street": "Velsen 20",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf-Milte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1251-000",
            "name": "Ponyhof Doose in Altenholz (Nr.1251-000)",
            "street": "Achtstückenberg 6",
            "house_number": "1",
            "zipcode": "24161",
            "city": "Altenholz",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1252-000",
            "name": "Hof Köhler in Mechtersen (Nr.1252-000)",
            "street": "In der Marsch 1",
            "house_number": "1",
            "zipcode": "21358",
            "city": "Mechtersen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1253-000",
            "name": "Privatstall Jacobowsky in Bochum (Nr.1253-000)",
            "street": "Steinring 30",
            "house_number": "1",
            "zipcode": "44789",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1254-000",
            "name": "Privatstall Wessels in Olfen (Nr.1254-000)",
            "street": "Hahnenberg 15",
            "house_number": "1",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1255-000",
            "name": "Hof Brahmkamp in Kosel (Nr.1255-000)",
            "street": "Lundshof 9",
            "house_number": "1",
            "zipcode": "24354",
            "city": "Kosel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1256-000",
            "name": "Privatstall Rochel in Rahden (Nr.1256-000)",
            "street": "Große Masch 12",
            "house_number": "1",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1257-000",
            "name": "Hof Hundemühle in Gronenberg (Nr.1257-000)",
            "street": "Hundemühle 1",
            "house_number": "1",
            "zipcode": "23684",
            "city": "Gronenberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1258-000",
            "name": "Rainbowranch in Hannover (Nr.1258-000)",
            "street": "Im Heidkampe 166",
            "house_number": "1",
            "zipcode": "30659",
            "city": "Hannover",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1259-000",
            "name": "RFV Hermannsburg-Berge in Südheide / Hermannsburg (Nr.1259-000)",
            "street": "Georgsstraße  19A",
            "house_number": "1",
            "zipcode": "29320",
            "city": "Südheide / Hermannsburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1260-000",
            "name": "Heuer in Springe (Nr.1260-000)",
            "street": "Steinhauserstraße 6",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1261-000",
            "name": "Hancken in Loxstedt (Nr.1261-000)",
            "street": "Eichenallee 72",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1262-000",
            "name": "Nussbaum in Mettmann (Nr.1262-000)",
            "street": "Wülfrather Str. 262",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1263-000",
            "name": "Pferdesport Brand in Steinfurt (Nr.1263-000)",
            "street": "Hollich 132",
            "house_number": "1",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1264-000",
            "name": "Reitstall Peters in Marl (Nr.1264-000)",
            "street": "Dämmerweg 101A",
            "house_number": "1",
            "zipcode": "45768",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1265-000",
            "name": "Privatstall Schmitz in Erftstadt (Nr.1265-000)",
            "street": "Genner Str 30",
            "house_number": "1",
            "zipcode": "50374",
            "city": "Erftstadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1266-000",
            "name": "Frerking in Walsrode (Nr.1266-000)",
            "street": "Ebbingen  2",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1267-000",
            "name": "Voltigier und Reitzentrum im Sunderholze in Gevelsberg (Nr.1267-000)",
            "street": "Sunderholzer Weg  24",
            "house_number": "1",
            "zipcode": "58285",
            "city": "Gevelsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1268-000",
            "name": "Privatstall Engstfeld in Detmold (Nr.1268-000)",
            "street": "Hornoldendorfer Str. 6",
            "house_number": "1",
            "zipcode": "32760",
            "city": "Detmold",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1269-000",
            "name": "Rolf Thiede in Lehe (Nr.1269-000)",
            "street": "Schulstrasse 43",
            "house_number": "1",
            "zipcode": "25774",
            "city": "Lehe",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1270-000",
            "name": "Privatstall Dapper in Mucheln (Nr.1270-000)",
            "street": "Dweerredder 10",
            "house_number": "1",
            "zipcode": "24238",
            "city": "Mucheln",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1271-000",
            "name": "Privatstall Riedel in Essen (Nr.1271-000)",
            "street": "Eststraße 33",
            "house_number": "1",
            "zipcode": "45149",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1272-000",
            "name": "Privatstall Kull-Bor in Brockel (Nr.1272-000)",
            "street": "Bussardweg 15",
            "house_number": "1",
            "zipcode": "27386",
            "city": "Brockel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1273-000",
            "name": "Pferdezucht Steffens in Vorwerk (Nr.1273-000)",
            "street": "Mühlenhof 1",
            "house_number": "1",
            "zipcode": "27412",
            "city": "Vorwerk",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1274-000",
            "name": "Pferdehof Oltmanns in Bad Zwischenahn (Nr.1274-000)",
            "street": "Wildenlohslinie 22",
            "house_number": "1",
            "zipcode": "26160",
            "city": "Bad Zwischenahn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1275-000",
            "name": "Remus-Petersen in Lindewitt OT Linnau (Nr.1275-000)",
            "street": "Neue Str. 1",
            "house_number": "1",
            "zipcode": "24969",
            "city": "Lindewitt OT Linnau",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1276-000",
            "name": "Hof Groten Köß in Walsrode (Nr.1276-000)",
            "street": "Altenboitzen 13",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1277-000",
            "name": "Paganetty in Gronau (Nr.1277-000)",
            "street": "Am Berge 47b",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1278-000",
            "name": "Reitverein Schmallenberg-Lennestadt e. V. in Schmallenberg (Nr.1278-000)",
            "street": "Berndorfer Straße 2",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1279-000",
            "name": "Raetgeshof  in Kempen (Nr.1279-000)",
            "street": "An Haus Steinfunder 9",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1280-000",
            "name": "Privatstall Müller in Soltau (Nr.1280-000)",
            "street": "Reimerdingerstr  1",
            "house_number": "1",
            "zipcode": "29614",
            "city": "Soltau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1281-000",
            "name": "Kamphausen in Mönchengladbach (Nr.1281-000)",
            "street": "Am Chur  4",
            "house_number": "1",
            "zipcode": "41189",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1282-000",
            "name": "Privatstall Nowald in Jade (Nr.1282-000)",
            "street": "Harms Weg  6",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1283-000",
            "name": "Reistall in Beelen in Beelen (Nr.1283-000)",
            "street": "Greffener Str 19",
            "house_number": "1",
            "zipcode": "48361",
            "city": "Beelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1284-000",
            "name": "Bauer Krüsmann in Wuppertal (Nr.1284-000)",
            "street": "Unterdüssler Weg 25",
            "house_number": "1",
            "zipcode": "42113",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1285-000",
            "name": "Privatstall Loots in Wachum (Nr.1285-000)",
            "street": "Nordweg  97",
            "house_number": "1",
            "zipcode": "26907",
            "city": "Wachum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1286-000",
            "name": "Privatstall Hövel in Hamminkeln (Nr.1286-000)",
            "street": "Bahnhofstraße 78",
            "house_number": "1",
            "zipcode": "46499",
            "city": "Hamminkeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1287-000",
            "name": "Rosenhof in Wesel (Nr.1287-000)",
            "street": "Bislicher Str.  68",
            "house_number": "1",
            "zipcode": "46487",
            "city": "Wesel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1288-000",
            "name": "Privatstall Hartig in Grasberg (Nr.1288-000)",
            "street": "Rautendorfer Straße  24",
            "house_number": "1",
            "zipcode": "28879",
            "city": "Grasberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1289-000",
            "name": "Stallgemeinschaft Kröger in Haren (Ems) (Nr.1289-000)",
            "street": "Emen  6",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren (Ems)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1290-000",
            "name": "Privatstall Hähner in Berne (Nr.1290-000)",
            "street": "An den Sielen 24",
            "house_number": "1",
            "zipcode": "27804",
            "city": "Berne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1291-000",
            "name": "Privatstall Musall in Struvenhütten (Nr.1291-000)",
            "street": "Mühlenstraße  33a",
            "house_number": "1",
            "zipcode": "24643",
            "city": "Struvenhütten",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1292-000",
            "name": "Reitanlage Schönbuchen in Dierkshausen (Nr.1292-000)",
            "street": "Zum Moor  46",
            "house_number": "1",
            "zipcode": "21271",
            "city": "Dierkshausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1293-000",
            "name": "Privatstall Onrust in Rhauderfehn (Nr.1293-000)",
            "street": "Schwarzmoorstraße 34",
            "house_number": "1",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1294-000",
            "name": "Reitstall Klintworth in Ohrensen (Nr.1294-000)",
            "street": "Hauptstraße 16",
            "house_number": "1",
            "zipcode": "21698",
            "city": "Ohrensen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1295-000",
            "name": "Reitstall Boms in Korschenbroich (Nr.1295-000)",
            "street": "Willicher Straße 26 A",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1296-000",
            "name": "RV Bodenwerder in Bodenwerder (Nr.1296-000)",
            "street": "Ziegeleiweg  20",
            "house_number": "1",
            "zipcode": "37619",
            "city": "Bodenwerder",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1297-000",
            "name": "Neuwiesenhof  in Burbach (Nr.1297-000)",
            "street": "Höhgarten  5",
            "house_number": "1",
            "zipcode": "57299",
            "city": "Burbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1298-000",
            "name": "Reitstall Verhasselt in Uedem (Nr.1298-000)",
            "street": "Steinbergen 37",
            "house_number": "1",
            "zipcode": "47589",
            "city": "Uedem",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1299-000",
            "name": "Reitstall Schulz in Brakel (Nr.1299-000)",
            "street": "Zum Tiefental  9",
            "house_number": "1",
            "zipcode": "33034",
            "city": "Brakel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1300-000",
            "name": "Reitstall Schoemann in Warpe (Nr.1300-000)",
            "street": "Windhorst 14",
            "house_number": "1",
            "zipcode": "27333",
            "city": "Warpe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1301-000",
            "name": "Privatstall Bies in Kleve (Nr.1301-000)",
            "street": "Südendörp  21",
            "house_number": "1",
            "zipcode": "25779",
            "city": "Kleve",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1302-000",
            "name": "Privatstall Johannsen in Borstel (Nr.1302-000)",
            "street": "Sether Straße 14",
            "house_number": "1",
            "zipcode": "23845",
            "city": "Borstel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1303-000",
            "name": "Ginsterhof in Wulfstorf (Nr.1303-000)",
            "street": "Ginsterweg 6",
            "house_number": "1",
            "zipcode": "29553",
            "city": "Wulfstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1304-000",
            "name": "Pferdepension Kambergs in Viersen (Nr.1304-000)",
            "street": "Hochfeld 1",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1305-000",
            "name": "Stall Flemming in Walsrode (Nr.1305-000)",
            "street": "Hamwiede 4",
            "house_number": "1",
            "zipcode": "29664",
            "city": "Walsrode",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1306-000",
            "name": "Pensionspferdehaltung Thelen in Geilenkirchen (Nr.1306-000)",
            "street": "Hatterather Weg 11",
            "house_number": "1",
            "zipcode": "52511",
            "city": "Geilenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1307-000",
            "name": "Reitstall Welter in Dormagen (Nr.1307-000)",
            "street": "Marienhof 1",
            "house_number": "1",
            "zipcode": "41542",
            "city": "Dormagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1308-000",
            "name": "Privatstall Krebs in Wiedensahl (Nr.1308-000)",
            "street": "In der Hespe  19",
            "house_number": "1",
            "zipcode": "31719",
            "city": "Wiedensahl",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1309-000",
            "name": "Privatstall Fürst in Bülkau (Nr.1309-000)",
            "street": "Süderende ",
            "house_number": "1",
            "zipcode": "21782",
            "city": "Bülkau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1310-000",
            "name": "B&B Reitstall Hesel in Hesel (Nr.1310-000)",
            "street": "Vorwerker str 11",
            "house_number": "1",
            "zipcode": "26835",
            "city": "Hesel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1311-000",
            "name": "Reitstall Gödde in Dortmund (Nr.1311-000)",
            "street": "Ostberger Str.  19",
            "house_number": "1",
            "zipcode": "44289",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1312-000",
            "name": "Privatstall Steiner in Nahe (Nr.1312-000)",
            "street": "Hauen 40",
            "house_number": "1",
            "zipcode": "23866",
            "city": "Nahe",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1313-000",
            "name": "Hof Schulzentrum  in Schneverdingen  (Nr.1313-000)",
            "street": "Goosekamp  10",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1314-000",
            "name": "Privatstall Schildt in Westerkappeln (Nr.1314-000)",
            "street": "Hollenbergs Hügel  62",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1315-000",
            "name": "Privatstall Stern in  Eystrup (Nr.1315-000)",
            "street": "Am Geestrand  6",
            "house_number": "1",
            "zipcode": "27324",
            "city": " Eystrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1316-000",
            "name": "Hof Hammerich in Osdorf (Nr.1316-000)",
            "street": "Haferrögen 100",
            "house_number": "1",
            "zipcode": "24251",
            "city": "Osdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1317-000",
            "name": "Privatstall Laumann in Hörstel-Bevergern (Nr.1317-000)",
            "street": "Kleiner Send  10",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Bevergern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1318-000",
            "name": "RSG Herne Börnig in Herne (Nr.1318-000)",
            "street": "Sodingerstraße 563",
            "house_number": "1",
            "zipcode": "44623",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1319-000",
            "name": "Reitstall Kücker  in Bielefeld (Nr.1319-000)",
            "street": "Hobusch 28",
            "house_number": "1",
            "zipcode": "33619",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1320-000",
            "name": "Privatstall Riegels  in Velbert  (Nr.1320-000)",
            "street": "Ewald-Jochemstr. 17",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1321-000",
            "name": "Privatstall Tietz in Emmerich (Nr.1321-000)",
            "street": "Zum Waldkreuz 160",
            "house_number": "1",
            "zipcode": "46446",
            "city": "Emmerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1322-000",
            "name": "Privatstall Otte in Holte in Ostercappeln (Nr.1322-000)",
            "street": "Dreskenkamp  7",
            "house_number": "1",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1323-000",
            "name": "Reitstall Springer in Großheide (Nr.1323-000)",
            "street": "Schulweg  10a",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1324-000",
            "name": "Reitstall Bannierink in Neuenkirchen (Nr.1324-000)",
            "street": "Haarweg 75",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1325-000",
            "name": "Privatstall Pleßner  in Telgte  (Nr.1325-000)",
            "street": "Harkampsheide  4",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1326-000",
            "name": "Brackmann  in Gehrde  (Nr.1326-000)",
            "street": "Forststraße  12",
            "house_number": "1",
            "zipcode": "49596",
            "city": "Gehrde ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1327-000",
            "name": "Pakheiser  in Burweg  (Nr.1327-000)",
            "street": "Im Ring  7",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Burweg ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1328-000",
            "name": "Privatstall Klug  in Eydelstedt  (Nr.1328-000)",
            "street": "Holzort  2",
            "house_number": "1",
            "zipcode": "49406",
            "city": "Eydelstedt ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1329-000",
            "name": "Privatstall Wilke  in Drentwede  (Nr.1329-000)",
            "street": "Große Heide  1",
            "house_number": "1",
            "zipcode": "49406",
            "city": "Drentwede ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1330-000",
            "name": "Reitstall Rensch  in Handewitt  (Nr.1330-000)",
            "street": "Lecker Chaussee  18A ",
            "house_number": "1",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1331-000",
            "name": "Eichenhof in Ebstorf (Nr.1331-000)",
            "street": "Im Winkel 2",
            "house_number": "1",
            "zipcode": "29574",
            "city": "Ebstorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1332-000",
            "name": "Katharina Bostenmann in Neetze/Neu-Neetze (Nr.1332-000)",
            "street": "Fraaschweg 3",
            "house_number": "1",
            "zipcode": "21398",
            "city": "Neetze/Neu-Neetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1333-000",
            "name": "Reitgemeinschaft 77 in Essen Dellwig (Nr.1333-000)",
            "street": "Klaumerbruch 40a",
            "house_number": "1",
            "zipcode": "45357",
            "city": "Essen Dellwig",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1334-000",
            "name": "Privatstall Gründker in Rheine (Nr.1334-000)",
            "street": "Dahlkampstraße  15",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1335-000",
            "name": "Privatstall Auringer in Hemslingen (Nr.1335-000)",
            "street": "Bockshorst  22",
            "house_number": "1",
            "zipcode": "27386",
            "city": "Hemslingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1336-000",
            "name": "Reitstall Meißner in Wetter (Nr.1336-000)",
            "street": "Auf Schölling  1",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1337-000",
            "name": "Privatstall Koss in Stolzenau (Nr.1337-000)",
            "street": "Krumme Straße ",
            "house_number": "1",
            "zipcode": "31592",
            "city": "Stolzenau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1338-000",
            "name": "Privatadresse Hollje in Wardenburg (Nr.1338-000)",
            "street": "Garreler Straße  128",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "LD-RG",
            "name": "Loesdau Filiale in Rosengarten (Nr.LD-RG)",
            "street": "Am Hatzberg  5",
            "house_number": "1",
            "zipcode": "21224",
            "city": "Rosengarten",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-LEH",
            "name": "Loesdau Filiale in Lehrte-Aligse (Nr.LD-LEH)",
            "street": "Rudolf-Petzold-Ring  7",
            "house_number": "1",
            "zipcode": "31275",
            "city": "Lehrte-Aligse",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-MUE",
            "name": "Loesdau Filiale in Mülheim an der Ruhr (Nr.LD-MUE)",
            "street": "Duisburger Straße  399",
            "house_number": "1",
            "zipcode": "45478",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-REK",
            "name": "Loesdau Filiale in Recklinghausen (Nr.LD-REK)",
            "street": "Schmalkalder Straße  8",
            "house_number": "1",
            "zipcode": "45665",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-ERF",
            "name": "Loesdau Filiale in Erftstadt (Nr.LD-ERF)",
            "street": "Albert-Einstein-Ring  8",
            "house_number": "1",
            "zipcode": "50374",
            "city": "Erftstadt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-RUE",
            "name": "Loesdau Filiale in Rüsselsheim-Königstädten (Nr.LD-RUE)",
            "street": "Alexander-Fleming-Ring  39",
            "house_number": "1",
            "zipcode": "65428",
            "city": "Rüsselsheim-Königstädten",
            "state": "Hessen",
            "collect_point": "ja"
        },
        {
            "ID": "LD-MOE",
            "name": "Loesdau Filiale in Möglingen (Nr.LD-MOE)",
            "street": "Raiffeisenstraße  7",
            "house_number": "1",
            "zipcode": "71696",
            "city": "Möglingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-BIS",
            "name": "Loesdau Filiale in Bisingen / Hohenzollern (Nr.LD-BIS)",
            "street": "Hechinger Straße  58",
            "house_number": "1",
            "zipcode": "72406",
            "city": "Bisingen / Hohenzollern",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-RT",
            "name": "Loesdau Filiale in Reutlingen (Nr.LD-RT)",
            "street": "Tübinger Straße  75",
            "house_number": "1",
            "zipcode": "72762",
            "city": "Reutlingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-VS",
            "name": "Loesdau Filiale in VS-Villingen (Nr.LD-VS)",
            "street": "Vockenhauser Straße  26",
            "house_number": "1",
            "zipcode": "78048",
            "city": "VS-Villingen",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-FI",
            "name": "Loesdau Filiale in Forstinning-Moos (Nr.LD-FI)",
            "street": "Römerstraße  16",
            "house_number": "1",
            "zipcode": "85661",
            "city": "Forstinning-Moos",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-FRI",
            "name": "Loesdau Filiale in Friedberg (Nr.LD-FRI)",
            "street": "Winterbruckenweg  56",
            "house_number": "1",
            "zipcode": "86316",
            "city": "Friedberg",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-WG",
            "name": "Loesdau Filiale in Weingarten (Nr.LD-WG)",
            "street": "Friedrich-Seifriz-Str.  2",
            "house_number": "1",
            "zipcode": "88250",
            "city": "Weingarten",
            "state": "Baden-Württemberg",
            "collect_point": "ja"
        },
        {
            "ID": "LD-HES",
            "name": "Loesdau Filiale in Heßdorf (Nr.LD-HES)",
            "street": "Im Gewerbepark  37",
            "house_number": "1",
            "zipcode": "91093",
            "city": "Heßdorf",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "LD-WOE",
            "name": "Loesdau Filiale in Wörnitz (Nr.LD-WOE)",
            "street": "Am Kreisel  3",
            "house_number": "1",
            "zipcode": "91637",
            "city": "Wörnitz",
            "state": "Bayern",
            "collect_point": "ja"
        },
        {
            "ID": "1339-000",
            "name": "Markwitz  in Heersum  (Nr.1339-000)",
            "street": "Neuer Weg  10",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Heersum ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1340-000",
            "name": "Gestüt Halnerg  in Hennef  (Nr.1340-000)",
            "street": "Halberg  2",
            "house_number": "1",
            "zipcode": "53773",
            "city": "Hennef ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1341-000",
            "name": "Schade  in Hohenlockstedt (Nr.1341-000)",
            "street": "Ridders  58",
            "house_number": "1",
            "zipcode": "25551",
            "city": "Hohenlockstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1342-000",
            "name": "Landreitschule  in Velbert  (Nr.1342-000)",
            "street": "Donnenberger Str.  145",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1343-000",
            "name": "Mentzenhof in Ense (Nr.1343-000)",
            "street": "Mawickerstr. 3",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1344-000",
            "name": "Jäger  in Petershagen (Nr.1344-000)",
            "street": "Heidberg  7",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1345-000",
            "name": "Hof Pintado in Lindau (Nr.1345-000)",
            "street": "Sander Weg 19",
            "house_number": "1",
            "zipcode": "24214",
            "city": "Lindau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1346-000",
            "name": "SL Sporthorses  in Gladbeck  (Nr.1346-000)",
            "street": "Voßbrinkstraße  67",
            "house_number": "1",
            "zipcode": "45966",
            "city": "Gladbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1347-000",
            "name": "Hegemeister  in Espelkamp (Nr.1347-000)",
            "street": "Fabbenstedter Straße  32",
            "house_number": "1",
            "zipcode": "32339",
            "city": "Espelkamp",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1348-000",
            "name": "Reit Club Oberhausen in Oberhausen (Nr.1348-000)",
            "street": "Bauerfeld 159",
            "house_number": "1",
            "zipcode": "46045",
            "city": "Oberhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1349-000",
            "name": "Hof Heitmann in Werne (Nr.1349-000)",
            "street": "Am Reiterhof 5",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1350-000",
            "name": "Germann in Lütetsburg  (Nr.1350-000)",
            "street": "Lütetsburgerlandstraße 68",
            "house_number": "1",
            "zipcode": "26524",
            "city": "Lütetsburg ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1351-000",
            "name": "Silies  in Emsbüren  (Nr.1351-000)",
            "street": "Im Dunkern  1",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1352-000",
            "name": "Horse Competence  in Beverstedt (Nr.1352-000)",
            "street": "Am Blumenkamp  1",
            "house_number": "1",
            "zipcode": "27616",
            "city": "Beverstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1353-000",
            "name": "Schröder-Meyer Hof  in Wienhausen-Bockelskamp  (Nr.1353-000)",
            "street": "Ortfeld  1",
            "house_number": "1",
            "zipcode": "29342",
            "city": "Wienhausen-Bockelskamp ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1354-000",
            "name": "Heidlooger Hof  in Varel (Nr.1354-000)",
            "street": "Heidlooger Weg 2",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1355-000",
            "name": "Ausbildungs- und Therapiezentrum Handorf in Handorf (Nr.1355-000)",
            "street": "Kiefernweg 29",
            "house_number": "1",
            "zipcode": "21447",
            "city": "Handorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1356-000",
            "name": "Anika Siltmann in Grafeld (Nr.1356-000)",
            "street": "Herzlaker Straße 44",
            "house_number": "1",
            "zipcode": "49626",
            "city": "Grafeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1357-000",
            "name": "Schulte Hobein in Sundern (Nr.1357-000)",
            "street": "Am Krausen Baum 11",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1358-000",
            "name": "Hof Ernst in Marxen  (Nr.1358-000)",
            "street": "Hauptstraße  5",
            "house_number": "1",
            "zipcode": "21439",
            "city": "Marxen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1359-000",
            "name": "Tierische Begleiter in Bielefeld (Nr.1359-000)",
            "street": "Veerhoffstraße 20",
            "house_number": "1",
            "zipcode": "33649",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1360-000",
            "name": "Eichenhof in Geestland (Nr.1360-000)",
            "street": "Reiterweg 7",
            "house_number": "1",
            "zipcode": "27607",
            "city": "Geestland",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1361-000",
            "name": "Reitstall Meggers in Schwedeneck (Nr.1361-000)",
            "street": "Gettorfer Landstr. 2",
            "house_number": "1",
            "zipcode": "24229",
            "city": "Schwedeneck",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1362-000",
            "name": "Privatstall Wischemann in Ochtrup (Nr.1362-000)",
            "street": "Wester 261",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1363-000",
            "name": "Privatstall Depembrock in Telgte  (Nr.1363-000)",
            "street": "Kortenkamp 18",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1364-000",
            "name": "Reitstall Breer in Werne (Nr.1364-000)",
            "street": "Am Sunderbach 3",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1365-000",
            "name": "Privatstall Huismann in Ihlow (Nr.1365-000)",
            "street": "Fennenstraße  17",
            "house_number": "1",
            "zipcode": "26632",
            "city": "Ihlow",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1366-000",
            "name": "Privatstall Eiken in Ahlen (Nr.1366-000)",
            "street": "Hauptstraße 11",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1367-000",
            "name": "Reitstall Krusenhoff in Kirchlinteln (Nr.1367-000)",
            "street": "Verdenermoorstraße 1",
            "house_number": "1",
            "zipcode": "27308",
            "city": "Kirchlinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1368-000",
            "name": "Reitstall Jordan in Gifhorn (Nr.1368-000)",
            "street": "Wendenerstraße 18",
            "house_number": "1",
            "zipcode": "38527",
            "city": "Gifhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1369-000",
            "name": "Hof Tönns  in Marxen  (Nr.1369-000)",
            "street": "Lindenallee 30",
            "house_number": "1",
            "zipcode": "21439",
            "city": "Marxen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1370-000",
            "name": "Aktivlaufstall Wessing in Borken (Nr.1370-000)",
            "street": "Sonnenbrink 60",
            "house_number": "1",
            "zipcode": "46325",
            "city": "Borken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1371-000",
            "name": "Privatstall Doepke in Zetel (Nr.1371-000)",
            "street": "An der Eiche 11",
            "house_number": "1",
            "zipcode": "26340",
            "city": "Zetel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1372-000",
            "name": "Hof Wettersberg in Haale (Nr.1372-000)",
            "street": "Wettersberg 20",
            "house_number": "1",
            "zipcode": "24819",
            "city": "Haale",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1373-000",
            "name": "Privatstall Storb  in Mühlheim an der Ruhr (Nr.1373-000)",
            "street": "Hansbergstraße 1",
            "house_number": "1",
            "zipcode": "45472",
            "city": "Mühlheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1374-000",
            "name": "Praxis für Physiotherapie in Hambühren (Nr.1374-000)",
            "street": "Mittelstraße 25",
            "house_number": "1",
            "zipcode": "29313",
            "city": "Hambühren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1375-000",
            "name": "Privatstall Rickert in Winsen-Luhe (Nr.1375-000)",
            "street": "Pattenser Hauptstraße 30",
            "house_number": "1",
            "zipcode": "21423",
            "city": "Winsen-Luhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1376-000",
            "name": "Reitstall Waterboer in Bielefeld (Nr.1376-000)",
            "street": "Waterboerstraße  77b",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1377-000",
            "name": "Privatstall Nohn in Sankt Augustin (Nr.1377-000)",
            "street": "Langstraße  5",
            "house_number": "1",
            "zipcode": "53757",
            "city": "Sankt Augustin",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1378-000",
            "name": "Reitanlage Wocklum in Balve (Nr.1378-000)",
            "street": "Wocklumer Allee  7",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1379-000",
            "name": "Privatstall Gast in Burgwedel (Nr.1379-000)",
            "street": "Alter Postweg  5b",
            "house_number": "1",
            "zipcode": "30938",
            "city": "Burgwedel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1380-000",
            "name": "Privathaus Andreas/Recke in Hannover (Nr.1380-000)",
            "street": "Kleifeld 5",
            "house_number": "1",
            "zipcode": "30539",
            "city": "Hannover",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1381-000",
            "name": "Reitstall Apfelhof in Marschacht (Nr.1381-000)",
            "street": "Elbuferstraße  29a",
            "house_number": "1",
            "zipcode": "21436",
            "city": "Marschacht",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1382-000",
            "name": "Reitstall Eckay in Hamm (Nr.1382-000)",
            "street": "Dasbeck  16",
            "house_number": "1",
            "zipcode": "59073",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1383-000",
            "name": "Reistall Erkes in Viersen (Nr.1383-000)",
            "street": "Heyerhöfe  1",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1384-000",
            "name": "Privatstall Thiel in Diemelsee (Nr.1384-000)",
            "street": "Steinweg 3",
            "house_number": "1",
            "zipcode": "34519",
            "city": "Diemelsee",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1385-000",
            "name": "Privatstall Silberberg  in Oer-Erkenschwick (Nr.1385-000)",
            "street": "Mühlenweg  234",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1386-000",
            "name": "Privatstall Matischewitz in Brunsbüttel (Nr.1386-000)",
            "street": "Gerhart-Hauptmann-Straße 18",
            "house_number": "1",
            "zipcode": "25541",
            "city": "Brunsbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1387-000",
            "name": "Privatstall Genuneit in Varel (Nr.1387-000)",
            "street": "Zum Jadebusen  180a",
            "house_number": "1",
            "zipcode": "26316",
            "city": "Varel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1388-000",
            "name": "Reitstall Szillat in Clauen (Nr.1388-000)",
            "street": "Schlütenstraße  19",
            "house_number": "1",
            "zipcode": "31249",
            "city": "Clauen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1389-000",
            "name": "Kellerhof Fam. Keller in Coesfeld (Nr.1389-000)",
            "street": "Harle  35",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1390-000",
            "name": "Stall Schumacher in Friesoythe (Nr.1390-000)",
            "street": "An der Berme 2",
            "house_number": "1",
            "zipcode": "26169",
            "city": "Friesoythe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1391-000",
            "name": "Stall Schnäbele in Adendorf (Nr.1391-000)",
            "street": "Grüner-Jäger-Weg ",
            "house_number": "1",
            "zipcode": "21365",
            "city": "Adendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1392-000",
            "name": "Hof Höge in Oeyten (Nr.1392-000)",
            "street": "Klein Hollen 33",
            "house_number": "1",
            "zipcode": "28876",
            "city": "Oeyten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1393-000",
            "name": "Mühlenhof in Greven - Gimbte (Nr.1393-000)",
            "street": "Mühlenweg  33",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven - Gimbte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1394-000",
            "name": "Reitstall Palmberg in Soest (Nr.1394-000)",
            "street": "Gartenkamp 15",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1395-000",
            "name": "ZRFV Legden e.V. in Legden (Nr.1395-000)",
            "street": "Bleikenkamp 20",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1396-000",
            "name": "Helgihof in Twistringen (Nr.1396-000)",
            "street": "Nienburger Straße  123",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1397-000",
            "name": "Privatstall Ehlers in Lemwerder (Nr.1397-000)",
            "street": "Ollenstraße  2",
            "house_number": "1",
            "zipcode": "27809",
            "city": "Lemwerder",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1398-000",
            "name": "Horsewellfarm Niederrhein in Issum (Nr.1398-000)",
            "street": "Nordring  155",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1399-000",
            "name": "Privatstall Kersting  in Dorsten (Nr.1399-000)",
            "street": "Philosophenweg 10",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1400-000",
            "name": "Privatstall Minzera in Halle (Nr.1400-000)",
            "street": "Eichenweg 21a",
            "house_number": "1",
            "zipcode": "33790",
            "city": "Halle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1401-000",
            "name": "Stall Stegmann in Twistringen (Nr.1401-000)",
            "street": "Steinstraße  12",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1402-000",
            "name": "Privatstall Schlieske in Petershagen (Nr.1402-000)",
            "street": "Bockmühlenweg 3",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1403-000",
            "name": "Privatstall Kullmann in Celle (Nr.1403-000)",
            "street": "Hannoversche Herrstr. 160",
            "house_number": "1",
            "zipcode": "29227",
            "city": "Celle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1404-000",
            "name": "Hof Reineke in Hemmingen (Nr.1404-000)",
            "street": "Heifeld 4",
            "house_number": "1",
            "zipcode": "30966",
            "city": "Hemmingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1405-000",
            "name": "Hof Hoster  in Issum (Nr.1405-000)",
            "street": "Großholthuysen  31",
            "house_number": "1",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1406-000",
            "name": "Reitstall Jostes in Mühlheim an der Ruhr (Nr.1406-000)",
            "street": "Mintarder Straße  101",
            "house_number": "1",
            "zipcode": "45481",
            "city": "Mühlheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1407-000",
            "name": "Paddock Trail Müller in Wegberg (Nr.1407-000)",
            "street": "Marktstraße  21",
            "house_number": "1",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1408-000",
            "name": "Privatstall Möllmann in Selm (Nr.1408-000)",
            "street": "Strandweg 2",
            "house_number": "1",
            "zipcode": "59379",
            "city": "Selm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1409-000",
            "name": "Reitstall Litjes in Weeze (Nr.1409-000)",
            "street": "Niederhelsum 23a",
            "house_number": "1",
            "zipcode": "47652",
            "city": "Weeze",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1410-000",
            "name": "Reitstall Semmelhack  in Engelbrechtsche Wildnis (Nr.1410-000)",
            "street": "Obendeich 2",
            "house_number": "1",
            "zipcode": "25379",
            "city": "Engelbrechtsche Wildnis",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1412-000",
            "name": "Reitanlage Franzen in Korschenbroich (Nr.1412-000)",
            "street": "Krünsend 1",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1413-000",
            "name": "Privatstall Urbaniak in Beesten (Nr.1413-000)",
            "street": "Waldstraße 1",
            "house_number": "1",
            "zipcode": "49832",
            "city": "Beesten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1414-000",
            "name": "Pensionsstall Hof Heling in Ahaus  (Nr.1414-000)",
            "street": "Averesch 18",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1415-000",
            "name": "Hulingshof Kempen in Kempen (Nr.1415-000)",
            "street": "Klixdorfer Straße  16",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1416-000",
            "name": "RV Balve in Balve (Nr.1416-000)",
            "street": "Wocklum  14",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1417-000",
            "name": "Reitstall Schlß Söder in Holle (Nr.1417-000)",
            "street": "Hainbergstraße 13",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Holle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1418-000",
            "name": "RuFV Samern in Samern (Nr.1418-000)",
            "street": "Salzbergener Str.  93",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Samern",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1419-000",
            "name": "Stall Ruthemeier in Osterholz-Scharmbeck (Nr.1419-000)",
            "street": "Röntgenstraße 14",
            "house_number": "1",
            "zipcode": "27711",
            "city": "Osterholz-Scharmbeck",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1420-000",
            "name": "Privatstall Holz in Mittelangeln (Nr.1420-000)",
            "street": "Norderholz Weg  1a",
            "house_number": "1",
            "zipcode": "24986",
            "city": "Mittelangeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1421-000",
            "name": "Privatstall Otte in Wuppertal (Nr.1421-000)",
            "street": "Untenrohleder  4",
            "house_number": "1",
            "zipcode": "42111",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1422-000",
            "name": "Stall Kaiser  in Seevetal  (Nr.1422-000)",
            "street": "Am Heestern  28",
            "house_number": "1",
            "zipcode": "21218",
            "city": "Seevetal ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1423-000",
            "name": "Star Light Ranch in Essen (Nr.1423-000)",
            "street": "Langestraße  144",
            "house_number": "1",
            "zipcode": "45307",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1424-000",
            "name": "Privatstall Heinze in Lemgo (Nr.1424-000)",
            "street": "Strüher Straße 94",
            "house_number": "1",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1425-000",
            "name": "Niehoff  in Gronau (Nr.1425-000)",
            "street": "Saarstraße  6",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1426-000",
            "name": "Privatstall Steinhoff  in Wickede (Nr.1426-000)",
            "street": "Hopfenkamp 15",
            "house_number": "1",
            "zipcode": "58739",
            "city": "Wickede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1427-000",
            "name": "Reitponyzucht Urienne in Sprockhövel  (Nr.1427-000)",
            "street": "Hedtbleck 4",
            "house_number": "1",
            "zipcode": "45549",
            "city": "Sprockhövel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1428-000",
            "name": "Ponyclub Ohlendorf Jugendfarm e.V. in Seevetal  (Nr.1428-000)",
            "street": "Alter Postweg  160",
            "house_number": "1",
            "zipcode": "21220",
            "city": "Seevetal ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1429-000",
            "name": "Hof Lobbel  in Horstmar-Leer (Nr.1429-000)",
            "street": "Ostendorf  72",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar-Leer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1430-000",
            "name": "Hof Schweer in Wiedensahl (Nr.1430-000)",
            "street": "Bahnhofstraße ",
            "house_number": "1",
            "zipcode": "31719",
            "city": "Wiedensahl",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1431-000",
            "name": "Vierthof in Albersdorf (Nr.1431-000)",
            "street": "Vierthof 2",
            "house_number": "1",
            "zipcode": "25767",
            "city": "Albersdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1432-000",
            "name": "Reiterhof Benien in Bottrop Kirchhellen (Nr.1432-000)",
            "street": "Hofwiese 26",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1433-000",
            "name": "Reitstall Elisenhof  in Hörstel (Nr.1433-000)",
            "street": "Elisenhofstraße 5",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1434-000",
            "name": "Reitschule Peters in Heinsberg  (Nr.1434-000)",
            "street": "Wurmaue  11",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1435-000",
            "name": "Privatstall Höwer in Schmallenberg- Grafschaft (Nr.1435-000)",
            "street": "Hauptstraße  17",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg- Grafschaft",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1436-000",
            "name": "Ponystall  in Stöckse (Nr.1436-000)",
            "street": "In der Twacht  9",
            "house_number": "1",
            "zipcode": "31638",
            "city": "Stöckse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1437-000",
            "name": "Reitanlage Gut Abtshof in Mönchengladbach (Nr.1437-000)",
            "street": "Krefelder Straße  726",
            "house_number": "1",
            "zipcode": "41066",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1438-000",
            "name": "Fohlenhof Felsen in Herzlake in Herzlake (Nr.1438-000)",
            "street": "An der Högede 3",
            "house_number": "1",
            "zipcode": "49770",
            "city": "Herzlake",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1439-000",
            "name": "Hof Drakenburg  in Drakenburg (Nr.1439-000)",
            "street": "Liethenkämpen 3",
            "house_number": "1",
            "zipcode": "31623",
            "city": "Drakenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1440-000",
            "name": "Reiterhof Pulheim Frechen in Pulheim (Nr.1440-000)",
            "street": "Bonnstraße ",
            "house_number": "1",
            "zipcode": "50259",
            "city": "Pulheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1441-000",
            "name": "Lanner Marschhof  in Hetlingen (Nr.1441-000)",
            "street": "Grüner Damm  14",
            "house_number": "1",
            "zipcode": "25491",
            "city": "Hetlingen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1442-000",
            "name": "Reitstall Sophia Schröder  in Isernhagen (Nr.1442-000)",
            "street": "Dorfstraße  83",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1443-000",
            "name": "Reitgemeinschaft Stall Prost  in Gelsenkirchen (Nr.1443-000)",
            "street": "Koesfeld  ",
            "house_number": "1",
            "zipcode": "45896",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1444-000",
            "name": "Reitstall Hehler  in Schwalmtal  (Nr.1444-000)",
            "street": "Hehler 52",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1445-000",
            "name": "Landwirtschaftlicher Betrieb Manuela Pirdzuhn in Borstel (Nr.1445-000)",
            "street": "Holmer Weg 6",
            "house_number": "1",
            "zipcode": "23845",
            "city": "Borstel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1446-000",
            "name": "Privatstall Wellmann in Metelen (Nr.1446-000)",
            "street": "Naendorf 95",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1447-000",
            "name": "Privatstall Berning in Ochtrup (Nr.1447-000)",
            "street": "Oster 331",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1448-000",
            "name": "Reitanlage Wittenbergshof  in Sonsbeck (Nr.1448-000)",
            "street": "Gossendeich 32",
            "house_number": "1",
            "zipcode": "47665",
            "city": "Sonsbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1449-000",
            "name": "Reistall Twietenhof in Winsen-Luhe (Nr.1449-000)",
            "street": "Brückenfeld 21",
            "house_number": "1",
            "zipcode": "21423",
            "city": "Winsen-Luhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1450-000",
            "name": "Werner Mahlstedt Pferdezucht in Schwanewede (Nr.1450-000)",
            "street": "Großer Kamp 28",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1451-000",
            "name": "Reiterhof Kolb in Sophienhamm (Nr.1451-000)",
            "street": "Dorfstraße 5",
            "house_number": "1",
            "zipcode": "24806",
            "city": "Sophienhamm",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1452-000",
            "name": "Unsere kleine Ranch  in Edemissen (Nr.1452-000)",
            "street": "An der Brandwiese 1",
            "house_number": "1",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1453-000",
            "name": "Privatstall Wendel  in Welle (Nr.1453-000)",
            "street": "Cordshagen  4",
            "house_number": "1",
            "zipcode": "21216",
            "city": "Welle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1454-000",
            "name": "Privatstall Spliethoff in Salzbergen  (Nr.1454-000)",
            "street": "Neuenkirchener Straße  34",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1455-000",
            "name": "Reiterhof Nieberg  in Hagen a.T.W. (Nr.1455-000)",
            "street": "Am Silbersee 18",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen a.T.W.",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1456-000",
            "name": "Britta´s Ponyhof in Duisburg (Nr.1456-000)",
            "street": "Obermeidericher Straße  181A",
            "house_number": "1",
            "zipcode": "47138",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1457-000",
            "name": "Pferdeparadies Asche  in Petershagen (Nr.1457-000)",
            "street": "Im Grünen  3",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1458-000",
            "name": "Reitstall Kornmasch in Bückeburg (Nr.1458-000)",
            "street": "An der Kornmasch 5",
            "house_number": "1",
            "zipcode": "31675",
            "city": "Bückeburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1459-000",
            "name": "Hof Krützkemper in Münster (Nr.1459-000)",
            "street": "Roxeler Str 466",
            "house_number": "1",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1460-000",
            "name": "Pferdepension Wübbels in Wietmarschen (Nr.1460-000)",
            "street": "Lohnerbrucher Str. 14",
            "house_number": "1",
            "zipcode": "49835",
            "city": "Wietmarschen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1461-000",
            "name": "Hof Frenz in Gütersloh (Nr.1461-000)",
            "street": "Rothaarweg 15",
            "house_number": "1",
            "zipcode": "33332",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1462-000",
            "name": "Reitverein Lilienthal in Lilienthal (Nr.1462-000)",
            "street": "Im Orth 11",
            "house_number": "1",
            "zipcode": "28865",
            "city": "Lilienthal",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1463-000",
            "name": "Privatstall Müller  in Ippensen (Nr.1463-000)",
            "street": "Zum Feldblick 5",
            "house_number": "1",
            "zipcode": "27419",
            "city": "Ippensen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1464-000",
            "name": "Kikes Pferdebox in Horn- Bad Meinberg (Nr.1464-000)",
            "street": "Hoher Weg 10",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn- Bad Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1465-000",
            "name": "Long Mountain Ranch in Schwanewede (Nr.1465-000)",
            "street": "Langenberger Weg 3",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1466-000",
            "name": "Ederveen in Ederveen (Nr.1466-000)",
            "street": "Poelweg ",
            "house_number": "1",
            "zipcode": "6744 PJ",
            "city": "Ederveen",
            "state": "Niederlande",
            "collect_point": "nein"
        },
        {
            "ID": "1467-000",
            "name": "Privatstall Blömer in Dinklage (Nr.1467-000)",
            "street": "Lager Straße  7",
            "house_number": "1",
            "zipcode": "49413",
            "city": "Dinklage",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1468-000",
            "name": "Sport & Zucht Stall Temmen in Rheine (Nr.1468-000)",
            "street": "Hohe Allee 101",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1469-000",
            "name": "Reiterhof Müscher in Bad Laer (Nr.1469-000)",
            "street": "Aschendorfer Weg 14",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1470-000",
            "name": "Privathof Göcking in Rheine (Nr.1470-000)",
            "street": "Osnabrücker Straße 359",
            "house_number": "1",
            "zipcode": "48429",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1471-000",
            "name": "Privatstall Plugge in Meschede (Nr.1471-000)",
            "street": "Hoppegarten 35",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1472-000",
            "name": "Hof Hannen in Wesel (Nr.1472-000)",
            "street": "Am Spyker 15",
            "house_number": "1",
            "zipcode": "46485",
            "city": "Wesel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1473-000",
            "name": "Privathof Kleine in Wetter (Nr.1473-000)",
            "street": "Albringhauser Straße 278",
            "house_number": "1",
            "zipcode": "58300",
            "city": "Wetter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1474-000",
            "name": "Brings in Korschenbroich (Nr.1474-000)",
            "street": "Jahnstraße 18",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1476-000",
            "name": "Reitsportzentrum Bremervörde  in Bremervörde (Nr.1476-000)",
            "street": "Stader Str. 98a",
            "house_number": "1",
            "zipcode": "27432",
            "city": "Bremervörde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1477-000",
            "name": "Reit- und Pensionsstall Ramcke in Hamburg (Nr.1477-000)",
            "street": "Schlankweg 30",
            "house_number": "1",
            "zipcode": "22587",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1478-000",
            "name": "Stall Klaus Reinacher in Rosendahl-Osterwick (Nr.1478-000)",
            "street": "Holtwicker Straße 56",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Osterwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1479-000",
            "name": "DBT GmbH in Korschenbroich (Nr.1479-000)",
            "street": "Glehner Heide 3",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1480-000",
            "name": "Reitschule Gut Spascher Sand in Wildeshausen (Nr.1480-000)",
            "street": "Spasche 1",
            "house_number": "1",
            "zipcode": "27793",
            "city": "Wildeshausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1481-000",
            "name": "Reitstall Strassburg / WICHTIG Anfahrtshilfe Lesen WICHTIG !!! 0174 1891243 anrufen in Goch (Nr.1481-000)",
            "street": "Gaesdoncker Str. 215",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1482-000",
            "name": "Ptivatstall Frank in Süsel (Nr.1482-000)",
            "street": "Neustädter Str. 33c",
            "house_number": "1",
            "zipcode": "23701",
            "city": "Süsel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1483-000",
            "name": "Privatstall Heinrich in Wardenburg (Nr.1483-000)",
            "street": "Moorweg 49",
            "house_number": "1",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1484-000",
            "name": "Ribbers in Neuenkirchen (Nr.1484-000)",
            "street": "Emsdettener Str 263",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1485-000",
            "name": "Privatstall Lippa in Nordenham (Nr.1485-000)",
            "street": "Abbehauser Wischweg 1a",
            "house_number": "1",
            "zipcode": "26954",
            "city": "Nordenham",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1486-000",
            "name": "Reiterhof Schulze Tenberge in Gronau (Nr.1486-000)",
            "street": "Gerdingseite 3",
            "house_number": "1",
            "zipcode": "48599",
            "city": "Gronau",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1487-000",
            "name": "Privatstall Uekötter in Nottuln (Nr.1487-000)",
            "street": "Am Vogelbusch 17",
            "house_number": "1",
            "zipcode": "48301",
            "city": "Nottuln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1488-000",
            "name": "Reitverein Niebüll in Niebüll (Nr.1488-000)",
            "street": "Gotteskoogstraße 62",
            "house_number": "1",
            "zipcode": "25899",
            "city": "Niebüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1489-000",
            "name": "Eichen-Hof Abbensen (Privat) in Wedemark (Nr.1489-000)",
            "street": "Alte Zollstraße 3",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1490-000",
            "name": "Aktivstall Brüning in Coesfeld (Nr.1490-000)",
            "street": "Stevede  72",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1491-000",
            "name": "Hof Fröhlich in Ladelund (Nr.1491-000)",
            "street": "Königsacker  9",
            "house_number": "1",
            "zipcode": "25926",
            "city": "Ladelund",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1492-000",
            "name": "Privatstall Meier in Bad Münder (Nr.1492-000)",
            "street": "Zum Wittkopfstein 1",
            "house_number": "1",
            "zipcode": "31848",
            "city": "Bad Münder",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1493-000",
            "name": "Stall Berndsmann in Dortmund (Nr.1493-000)",
            "street": "Persebeckerstrasse 1",
            "house_number": "1",
            "zipcode": "44227",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-SOE",
            "name": "Raiffeisen-Markt Soest in Soest (Nr.RM-SOE)",
            "street": "Nottebohmweg 17",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "1495-000",
            "name": "Stall Heimbach in Beringstedt (Nr.1495-000)",
            "street": "Aukamp 1",
            "house_number": "1",
            "zipcode": "25575",
            "city": "Beringstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1496-000",
            "name": "Stall Bentstreek  in Friedeburg (Nr.1496-000)",
            "street": "Flakstellungsweg  4",
            "house_number": "1",
            "zipcode": "26446",
            "city": "Friedeburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1497-000",
            "name": "Privatstall Schimmelpfennig in Telgte (Nr.1497-000)",
            "street": "Brink 28",
            "house_number": "1",
            "zipcode": "48291",
            "city": "Telgte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1498-000",
            "name": "Reitverein Tostedt in Tostedt (Nr.1498-000)",
            "street": "Alter Moorweg 10",
            "house_number": "1",
            "zipcode": "21255",
            "city": "Tostedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1499-000",
            "name": "Privatstall Peters in Lingen (Nr.1499-000)",
            "street": "Bruchstraße 15",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1500-000",
            "name": "Stall König in Ladbergen (Nr.1500-000)",
            "street": "Westerweg 130",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1501-000",
            "name": "Privatstall Brands in Leverkusen (Nr.1501-000)",
            "street": "Grunder Wiesen 18",
            "house_number": "1",
            "zipcode": "51381",
            "city": "Leverkusen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1502-000",
            "name": "Privatstall Harmeyer in Quendorf (Nr.1502-000)",
            "street": "Am Kapellenplatz 1",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Quendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1503-000",
            "name": "Wedig in Harsum (Nr.1503-000)",
            "street": "Am Thie 7",
            "house_number": "1",
            "zipcode": "31177",
            "city": "Harsum",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1504-000",
            "name": "JoKa Farm in Schwanewede (Nr.1504-000)",
            "street": "Lehmhorst 226a",
            "house_number": "1",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1505-000",
            "name": "Pferdezahnbehandlung Martin Hüpen  in Straelen (Nr.1505-000)",
            "street": "Op den tupp 6",
            "house_number": "1",
            "zipcode": "47638",
            "city": "Straelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1506-000",
            "name": "Privatstall Lammers in Rheine (Nr.1506-000)",
            "street": "Möllerhookstraße 11",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1507-000",
            "name": "Reitverein Visbek in Visbek (Nr.1507-000)",
            "street": "Schützenstraße 5",
            "house_number": "1",
            "zipcode": "49429",
            "city": "Visbek",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1508-000",
            "name": "Reitstall Max Weber in Werne (Nr.1508-000)",
            "street": "Am Reiterhof 4",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1509-000",
            "name": "Reitstall Willy Vogel in Bielefeld (Nr.1509-000)",
            "street": "Senner Hellweg 138",
            "house_number": "1",
            "zipcode": "33659",
            "city": "Bielefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1510-000",
            "name": "Rockers Peerstall in Aurich (Nr.1510-000)",
            "street": "Holzweg 111",
            "house_number": "1",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1511-000",
            "name": "Islandpferde Gestüt Borgarstadur in Dülmen (Nr.1511-000)",
            "street": "Bauernschaft 190",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1512-000",
            "name": "Hof Wullenweber in Meschede (Nr.1512-000)",
            "street": "Enste 2",
            "house_number": "1",
            "zipcode": "49872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1513-000",
            "name": "Pferdepension am Abbabach in Menden (Nr.1513-000)",
            "street": "Am Abbabach 2",
            "house_number": "1",
            "zipcode": "58708",
            "city": "Menden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1514-000",
            "name": "Privatstall Kostka in Wermelskirchen (Nr.1514-000)",
            "street": "Eipringhausen  60",
            "house_number": "1",
            "zipcode": "42929",
            "city": "Wermelskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1515-000",
            "name": "Reitanlage zum Batz in Hanerau-Hademarschen (Nr.1515-000)",
            "street": "Batzer Weg 3",
            "house_number": "1",
            "zipcode": "25557",
            "city": "Hanerau-Hademarschen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1516-000",
            "name": "Privatstall Brüggemeier in Ibbenbüren (Nr.1516-000)",
            "street": "Haarweg 99",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1517-000",
            "name": "Doppe in Rietberg (Nr.1517-000)",
            "street": "Doppstaße 23",
            "house_number": "1",
            "zipcode": "33397",
            "city": "Rietberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1518-000",
            "name": "Hof Baden in Schneverdingen (Nr.1518-000)",
            "street": "Dorfstraße 61",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1519-000",
            "name": "Apfelhof Hördinghausen Fam. Borgmann in Bad Essen  (Nr.1519-000)",
            "street": "Hördinghauser Str. 22",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1520-000",
            "name": "Reitstall Wettmershagen in Calberlah (Nr.1520-000)",
            "street": "Höpenweg 6",
            "house_number": "1",
            "zipcode": "38547",
            "city": "Calberlah",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1521-000",
            "name": "Hof Grotwinkel in Kamp-Lintfort (Nr.1521-000)",
            "street": "Niephauser Str. 18",
            "house_number": "1",
            "zipcode": "47475",
            "city": "Kamp-Lintfort",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1522-000",
            "name": "Reitsportanlage Wietrehm in Wedemark (Nr.1522-000)",
            "street": "Fuhrberger Weg 14",
            "house_number": "1",
            "zipcode": "30900",
            "city": "Wedemark",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "RV-GL",
            "name": "Raiffeisen Vital Gleidorf in Schmallenberg-Gleidorf (Nr.RV-GL)",
            "street": "Kornhausstraße  11",
            "house_number": "1",
            "zipcode": "57392",
            "city": "Schmallenberg-Gleidorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-EB",
            "name": "Raiffeisen Vital Ense-Bremen in Ense-Bremen (Nr.RV-EB)",
            "street": "Werler Straße 57",
            "house_number": "1",
            "zipcode": "59469",
            "city": "Ense-Bremen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-HE",
            "name": "Raiffeisen Vital Herzfeld in Lippetal-Herzfeld (Nr.RV-HE)",
            "street": "Lippborger Straße 21",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal-Herzfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-RH",
            "name": "Raiffeisen Vital Rhynern in Hamm-Osttünnen (Nr.RV-RH)",
            "street": "Twärsweg 2",
            "house_number": "1",
            "zipcode": "59069",
            "city": "Hamm-Osttünnen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-UN",
            "name": "Raiffeisen Vital Unna in Unna (Nr.RV-UN)",
            "street": "Alfred-Nobel-Straße 19",
            "house_number": "1",
            "zipcode": "59423",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-WE",
            "name": "Raiffeisen Vital Werl in Werl (Nr.RV-WE)",
            "street": "Zur Mersch 14",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "RV-BA",
            "name": "Raiffeisen Vital Balve in Balve (Nr.RV-BA)",
            "street": "An der Kormke 20-24",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "ja"
        },
        {
            "ID": "1523-000",
            "name": "Privatstall Burmann in Lippetal (Nr.1523-000)",
            "street": "Am Heitkamp 8",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1524-000",
            "name": "Reitverein Calle-Meschede in Meschede (Nr.1524-000)",
            "street": "An der Reithalle 1",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1525-000",
            "name": "RuVV am Hallohberg in Wiemersdorf (Nr.1525-000)",
            "street": "Grünplan 3",
            "house_number": "1",
            "zipcode": "24623",
            "city": "Wiemersdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1526-000",
            "name": "Privatstall Fröbel in Morsbach (Nr.1526-000)",
            "street": "Herbertshagen 2",
            "house_number": "1",
            "zipcode": "51597",
            "city": "Morsbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1527-000",
            "name": "Reit und Fahrverein Wickede-Asseln-Sölde in Dortmund (Nr.1527-000)",
            "street": "Eschenwaldstraß 45",
            "house_number": "1",
            "zipcode": "44319",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1528-000",
            "name": "Thomas Voss Reitanlage Höllnhof in Schülp bei Nortorf (Nr.1528-000)",
            "street": "Looper Weg 2",
            "house_number": "1",
            "zipcode": "24589",
            "city": "Schülp bei Nortorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1529-000",
            "name": "Privatstall Keuter in Papenburg (Nr.1529-000)",
            "street": "Zum Wehr 41",
            "house_number": "1",
            "zipcode": "26871",
            "city": "Papenburg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1530-000",
            "name": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1530-000)",
            "street": "Feldmarkstraße 180",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1531-000",
            "name": "Hof Große Hellmann in Senden (Nr.1531-000)",
            "street": "Brock 7",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1532-000",
            "name": "Privatstall Geuking in Coesfeld (Nr.1532-000)",
            "street": "Letter Berg 102",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1533-000",
            "name": "Hof Stoffers in Gelsenkirchen (Nr.1533-000)",
            "street": "Bußmannstrase 62a",
            "house_number": "1",
            "zipcode": "45896",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1534-000",
            "name": "Reitanlage M. Langer in Kamen (Nr.1534-000)",
            "street": "Zum Lüchting 1",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1535-000",
            "name": "Privatstall Schütte in Düsseldorf (Nr.1535-000)",
            "street": "Duisburger Landstraße 203",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1536-000",
            "name": "Privatstall Kirchner in Neustadt (Nr.1536-000)",
            "street": "Mandelsloher Str. 6",
            "house_number": "1",
            "zipcode": "31535",
            "city": "Neustadt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1537-000",
            "name": "Privathof Pape in Delbrück (Nr.1537-000)",
            "street": "Neubrückstraße 10",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Delbrück",
            "collect_point": "nein"
        },
        {
            "ID": "1538-000",
            "name": "Outback Corona in Willich (Nr.1538-000)",
            "street": "Fonger 30",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1539-000",
            "name": "Gut Eulental Reitstall in Erkrath (Nr.1539-000)",
            "street": "Eulental 32",
            "house_number": "1",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1540-000",
            "name": "Privatstall Wade in Emmerthal (Nr.1540-000)",
            "street": "In der Meinte 9",
            "house_number": "1",
            "zipcode": "31860",
            "city": "Emmerthal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1541-000",
            "name": "Flüsterpferde in Stade (Nr.1541-000)",
            "street": "Götzdorfer Str 214",
            "house_number": "1",
            "zipcode": "21683",
            "city": "Stade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1542-000",
            "name": "Reitanlage Vibrans in Langelsheim (Nr.1542-000)",
            "street": "Unterdorf 5a",
            "house_number": "1",
            "zipcode": "38685",
            "city": "Langelsheim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1543-000",
            "name": "Reiterhof Jobmann in Hamburg (Nr.1543-000)",
            "street": "Neuländer Elbdeich 234",
            "house_number": "1",
            "zipcode": "21079",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1544-000",
            "name": "Islandpferdehof Vierhohen in Weddelbrook (Nr.1544-000)",
            "street": "Krücken 5",
            "house_number": "1",
            "zipcode": "24576",
            "city": "Weddelbrook",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1545-000",
            "name": "Privatstall Noack in Ennigerloh (Nr.1545-000)",
            "street": "Wessenhorst 32",
            "house_number": "1",
            "zipcode": "59320",
            "city": "Ennigerloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1546-000",
            "name": "Privatstall Petersen in Wohlde (Nr.1546-000)",
            "street": "Mittelstraße 14",
            "house_number": "1",
            "zipcode": "24899",
            "city": "Wohlde",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1547-000",
            "name": "Privatstall Blume in Wülfrath (Nr.1547-000)",
            "street": "Velberter Straße 36",
            "house_number": "1",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1548-000",
            "name": "Reitstall Lange in Rehburg-Loccum (Nr.1548-000)",
            "street": "Düsselburger Str. 70",
            "house_number": "1",
            "zipcode": "31547",
            "city": "Rehburg-Loccum",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1549-000",
            "name": "Hof Röring in Ahaus (Nr.1549-000)",
            "street": "Barle 8",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1550-000",
            "name": "Privatstall Rorup Holsterbrink in Dülmen (Nr.1550-000)",
            "street": "Holsterbrink 22",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1551-000",
            "name": "Privatstall Rosenberger in Senden (Nr.1551-000)",
            "street": "Gettrup 14",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1552-000",
            "name": "Steinhoff in Kerken (Nr.1552-000)",
            "street": "Dorfstr. 105",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1553-000",
            "name": "Reitanlage Braß - Gut Kückshausen in Dortmund (Nr.1553-000)",
            "street": "Syburgstr. 9",
            "house_number": "1",
            "zipcode": "44265",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1554-000",
            "name": "Reitstall Wilkens in Thedinghausen (Nr.1554-000)",
            "street": "Rieder Straße 81a",
            "house_number": "1",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1555-000",
            "name": "Privatstall Wendt in Willebadessen (Nr.1555-000)",
            "street": "Schönthal 3",
            "house_number": "1",
            "zipcode": "34439",
            "city": "Willebadessen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1556-000",
            "name": "Elsermann kamen Methler in Kamen (Nr.1556-000)",
            "street": "Hilsingstraße  22",
            "house_number": "1",
            "zipcode": "59174",
            "city": "Kamen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1557-000",
            "name": "Hof Bendel in Balve (Nr.1557-000)",
            "street": "Wocklum 3a",
            "house_number": "1",
            "zipcode": "48802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1558-000",
            "name": "Wellin in Herscheid (Nr.1558-000)",
            "street": "Wellin 6",
            "house_number": "1",
            "zipcode": "58859",
            "city": "Herscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1559-000",
            "name": "RC Senne e.V. Stukenbrock in Schloß-Holte Stuckenbrock (Nr.1559-000)",
            "street": "Flugplatzstr. 80",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß-Holte Stuckenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1560-000",
            "name": "Reitverein Oelde e.V. in Oelde (Nr.1560-000)",
            "street": "Am Ruthenfeld 40",
            "house_number": "1",
            "zipcode": "59302",
            "city": "Oelde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1561-000",
            "name": "Freizeitpferdehof Meier in Extertal (Nr.1561-000)",
            "street": "Schneppel  1",
            "house_number": "1",
            "zipcode": "32699",
            "city": "Extertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1562-000",
            "name": "Hof Wiesmann in Castrop Rauxel (Nr.1562-000)",
            "street": "Im Finkenbrink 33",
            "house_number": "1",
            "zipcode": "44581",
            "city": "Castrop Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1563-000",
            "name": "Privatstall Appel in Leezdorf  (Nr.1563-000)",
            "street": "Heideweg 16",
            "house_number": "1",
            "zipcode": "26529",
            "city": "Leezdorf ",
            "state": "Niedersachesen",
            "collect_point": "nein"
        },
        {
            "ID": "1564-000",
            "name": "Niehues in Legden (Nr.1564-000)",
            "street": "Isingoort 63",
            "house_number": "1",
            "zipcode": "48739",
            "city": "Legden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1565-000",
            "name": "Hof Lorenz in Loxstedt (Nr.1565-000)",
            "street": "Am Schafdamm 10",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1566-000",
            "name": "Freizeithof Mesterscheidt in Hemer (Nr.1566-000)",
            "street": "Mesterscheid 2",
            "house_number": "1",
            "zipcode": "58675",
            "city": "Hemer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1567-000",
            "name": "Hof Glüsing in Osterbruch  (Nr.1567-000)",
            "street": "Süderende  16",
            "house_number": "1",
            "zipcode": "21762",
            "city": "Osterbruch ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1568-000",
            "name": "Hof Krohn in Flintbek (Nr.1568-000)",
            "street": "Sörenberg  23",
            "house_number": "1",
            "zipcode": "24220",
            "city": "Flintbek",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1569-000",
            "name": "Gut Römerhof in Düsseldorf (Nr.1569-000)",
            "street": "am Schmidtberg 15",
            "house_number": "1",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1570-000",
            "name": "Stall Lohe in Ascheberg (Nr.1570-000)",
            "street": "Ostereckern 9",
            "house_number": "1",
            "zipcode": "59387",
            "city": "Ascheberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1571-000",
            "name": "Stall Sältz in Bohmstedt (Nr.1571-000)",
            "street": "Sick 2",
            "house_number": "1",
            "zipcode": "25853",
            "city": "Bohmstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1572-000",
            "name": "Reitstall Fragen in Korschenbroich (Nr.1572-000)",
            "street": "Fragenhütte ",
            "house_number": "1",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1573-000",
            "name": "Gut Wylack in Wassenberg (Nr.1573-000)",
            "street": "Gut Wylack ",
            "house_number": "1",
            "zipcode": "41849",
            "city": "Wassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1574-000",
            "name": "Reiterhof Rüter in Wetzen (Nr.1574-000)",
            "street": "Dorfstraße 6",
            "house_number": "1",
            "zipcode": "21385",
            "city": "Wetzen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1575-000",
            "name": "Dammackerhof  in Sarstedt (Nr.1575-000)",
            "street": "Wenderter Str. 14",
            "house_number": "1",
            "zipcode": "31157",
            "city": "Sarstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1576-000",
            "name": "Reiterverein Sintfeld St. Martin Fürstenberg e.V. in Bad Wünnenberg (Nr.1576-000)",
            "street": "Grasweg 3",
            "house_number": "1",
            "zipcode": "33181",
            "city": "Bad Wünnenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1577-000",
            "name": "Privater Offenstall Luckhaus in Hamm (Nr.1577-000)",
            "street": "Soester Str. 407",
            "house_number": "1",
            "zipcode": "49199",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1578-000",
            "name": "Hof Heine in Drebber (Nr.1578-000)",
            "street": "Marienstraße  5",
            "house_number": "1",
            "zipcode": "49457",
            "city": "Drebber",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1579-000",
            "name": "Offenstall Grzesiek in Stelle (Nr.1579-000)",
            "street": "Fohrsfeld 7",
            "house_number": "1",
            "zipcode": "21435",
            "city": "Stelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1580-000",
            "name": "Hof Hünnekes in Niederkrüchten (Nr.1580-000)",
            "street": "Am Hügelhof 1",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1581-000",
            "name": "Reitstall Mateos in Bochum (Nr.1581-000)",
            "street": "An der Holtbrügge 25",
            "house_number": "1",
            "zipcode": "44795",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1582-000",
            "name": "Pferdepension Langenfeld in Hessisch Oldendorf (Nr.1582-000)",
            "street": "Pensionsstraße 2",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1583-000",
            "name": "Hof Heinrichs in Wegberg (Nr.1583-000)",
            "street": "In Ellinghoven 10",
            "house_number": "1",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1584-000",
            "name": "Einstellerhof Jessen in Oeversee  (Nr.1584-000)",
            "street": "Munkwolstruper Weg 35",
            "house_number": "1",
            "zipcode": "24988",
            "city": "Oeversee ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1585-000",
            "name": "Hof Geenen in Sprockhövel  (Nr.1585-000)",
            "street": "Heidestraße 26",
            "house_number": "1",
            "zipcode": "45549",
            "city": "Sprockhövel ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1586-000",
            "name": "Reitstall am Himmelmoor GbR in Quickborn (Nr.1586-000)",
            "street": "Heinrich-Hertz-Str. 18",
            "house_number": "1",
            "zipcode": "25451",
            "city": "Quickborn",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1587-000",
            "name": "Carolin Thomsen Pferdestärken in Stoltebüll (Nr.1587-000)",
            "street": "Levshöh 1",
            "house_number": "1",
            "zipcode": "24409",
            "city": "Stoltebüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1588-000",
            "name": "Privatstall Kathmann  in Haren (Ems) (Nr.1588-000)",
            "street": "Ostereschweg 65",
            "house_number": "1",
            "zipcode": "49733",
            "city": "Haren (Ems)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1589-000",
            "name": "Hof Reeger in Hagen (Nr.1589-000)",
            "street": "Niggenbölling  ",
            "house_number": "1",
            "zipcode": "58091",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1590-000",
            "name": "Hof Helbig-Baldt in Hamm (Nr.1590-000)",
            "street": "Im Nachtigallental 4",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1591-000",
            "name": "Reitanlage-Behrens in Soest (Nr.1591-000)",
            "street": "Wasserweg 17",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1592-000",
            "name": "Hörsters Farmer in Arnsberg (Nr.1592-000)",
            "street": "Im Schmiemketal 1",
            "house_number": "1",
            "zipcode": "59821",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1593-000",
            "name": "Stall Witte in Ovelgönne (Nr.1593-000)",
            "street": "Anton-Hullmann-Weg 2",
            "house_number": "1",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1594-000",
            "name": "Hof Laves in Einbeck (Nr.1594-000)",
            "street": "Clusweg 2",
            "house_number": "1",
            "zipcode": "37574",
            "city": "Einbeck",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1595-000",
            "name": "Ponyhof Rottmann in Hagen (Nr.1595-000)",
            "street": "Bergstr 12",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1596-000",
            "name": "Gestüt Brauershof in Geldern (Nr.1596-000)",
            "street": "An den Niersauen  42",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1597-000",
            "name": "Danielles Pferdehof in Kluse (Nr.1597-000)",
            "street": "Hauptstrasse 8",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Kluse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1598-000",
            "name": "Wuppertaler Ponyfreunde e.V. in Wuppertal (Nr.1598-000)",
            "street": "Sonnenblume 22",
            "house_number": "1",
            "zipcode": "42281",
            "city": "Wuppertal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1599-000",
            "name": "Hof Schnellenberg in Hörstel-Riesenbeck (Nr.1599-000)",
            "street": "Surenburg 4",
            "house_number": "1",
            "zipcode": "48477",
            "city": "Hörstel-Riesenbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1600-000",
            "name": "Hof Müther in Rosendahl (Nr.1600-000)",
            "street": "Hermann-Löns-Weg 48",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1601-000",
            "name": "Reitstall Berenyi in Garbsen (Nr.1601-000)",
            "street": "Mühlenstraße  37",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1602-000",
            "name": "Hof Knop in Edemissen (Nr.1602-000)",
            "street": "Klein Blumenhagen 3",
            "house_number": "1",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1603-000",
            "name": "Pferdepension Jürgens in Dinslaken (Nr.1603-000)",
            "street": "Sterkraderstr  111",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1604-000",
            "name": "Reitstall Andree in Marsberg (Nr.1604-000)",
            "street": "Markeweg 9",
            "house_number": "1",
            "zipcode": "34431",
            "city": "Marsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1605-000",
            "name": "Hof Reismann in Ibbenbüren (Nr.1605-000)",
            "street": "Püsselbürener Damm 251",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1606-000",
            "name": "Vom Körfkens Hof  in Stadtlohn  (Nr.1606-000)",
            "street": "Schützenweg 144",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1607-000",
            "name": "Hof Tillmann in Geseke (Nr.1607-000)",
            "street": "Ziegelweg 2",
            "house_number": "1",
            "zipcode": "59590",
            "city": "Geseke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1608-000",
            "name": "Hof Weber in Bad Essen  (Nr.1608-000)",
            "street": "Am Bülten 1",
            "house_number": "1",
            "zipcode": "49152",
            "city": "Bad Essen ",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1609-000",
            "name": "Hof Thiel in Oer-Erkenschwick (Nr.1609-000)",
            "street": "Westfeldweg ",
            "house_number": "1",
            "zipcode": "45739",
            "city": "Oer-Erkenschwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1610-000",
            "name": "Privatstall Haus Alaquint in Mettmann (Nr.1610-000)",
            "street": "Hoppenhofweg 1",
            "house_number": "1",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1611-000",
            "name": "RV Langenhagen in Langenhagen (Nr.1611-000)",
            "street": "Walsroder Str 179",
            "house_number": "1",
            "zipcode": "30855",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1612-000",
            "name": "Feines Reiten in Varrel (Nr.1612-000)",
            "street": "Schäkeln 2",
            "house_number": "1",
            "zipcode": "27259",
            "city": "Varrel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1613-000",
            "name": "RV Winterberg in Winterberg (Nr.1613-000)",
            "street": "Am Postteich 7",
            "house_number": "1",
            "zipcode": "59955",
            "city": "Winterberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1614-000",
            "name": "Privatstall Benning in Coesfeld (Nr.1614-000)",
            "street": "Gaupel  36",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1615-000",
            "name": "RG Landgraben  in Schönkirchen  (Nr.1615-000)",
            "street": "Landgraben  73",
            "house_number": "1",
            "zipcode": "24232",
            "city": "Schönkirchen ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1616-000",
            "name": "Reitstall Riedel (Postversand) in Heiligengrabe OT Liebenthal (Nr.1616-000)",
            "street": "Liebenthaler Dorfstraße  16",
            "house_number": "1",
            "zipcode": "16909",
            "city": "Heiligengrabe OT Liebenthal",
            "state": "Brandenburg",
            "collect_point": "nein"
        },
        {
            "ID": "1617-000",
            "name": "Reiterverein Altes Amt Dielingen e.V  in Stemwede  (Nr.1617-000)",
            "street": "Zur Toppheide 9",
            "house_number": "1",
            "zipcode": "32351",
            "city": "Stemwede ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1618-000",
            "name": "Privat Köster in Veelen (Nr.1618-000)",
            "street": "Bischof-Averkamp-Straße 6",
            "house_number": "1",
            "zipcode": "46342",
            "city": "Veelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1619-000",
            "name": "Hof Wallhorn in Duisburg (Nr.1619-000)",
            "street": "Stalbergstraße 29",
            "house_number": "1",
            "zipcode": "47167",
            "city": "Duisburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1620-000",
            "name": "Reitanlage Hofstedde in Datteln (Nr.1620-000)",
            "street": "Am Alten Busch 8 8",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1621-000",
            "name": "Hof Erich Robert in Altenberge (Nr.1621-000)",
            "street": "Hohenhorst  60",
            "house_number": "1",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1622-000",
            "name": "Hof Scheepker in Aurich (Nr.1622-000)",
            "street": "Heuweg 94",
            "house_number": "1",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1623-000",
            "name": "Pferdeland in Leichlingen (Nr.1623-000)",
            "street": "Zum Buschtor 3",
            "house_number": "1",
            "zipcode": "42799",
            "city": "Leichlingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1624-000",
            "name": "Hof Schlattmann in Neuenkirchen (Nr.1624-000)",
            "street": "Sutrum Harum 16",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1625-000",
            "name": "Reitanlage Wierling in Senden (Nr.1625-000)",
            "street": "Dorfbauernschaft 115",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1626-000",
            "name": "Reiterhof Nonte in Münster (Nr.1626-000)",
            "street": "Verth 66",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1627-000",
            "name": "Pferdepension Blomberg in Meinerzhagen Blomberg (Nr.1627-000)",
            "street": "Blomberg 1",
            "house_number": "1",
            "zipcode": "58540",
            "city": "Meinerzhagen Blomberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1628-000",
            "name": "Hof Kempken in Alpen (Nr.1628-000)",
            "street": "Mühlenweg 30",
            "house_number": "1",
            "zipcode": "46519",
            "city": "Alpen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1629-000",
            "name": "Hof van Bevern in Saerbeck (Nr.1629-000)",
            "street": "Sinningen  17",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1630-000",
            "name": "Hof Wentzlaff (Privat) in Schneverdingen (Nr.1630-000)",
            "street": "Lindenstraße  42",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1631-000",
            "name": "Stall Dieckmann in Bottrop Kirchhellen (Nr.1631-000)",
            "street": "Lohbraucksweg  6",
            "house_number": "1",
            "zipcode": "46244",
            "city": "Bottrop Kirchhellen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1632-000",
            "name": "Hohmannshof Spanier / Dols in Kerken (Nr.1632-000)",
            "street": "Kappelenweg 12",
            "house_number": "1",
            "zipcode": "47647",
            "city": "Kerken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1633-000",
            "name": "Privatstall Leeling in Mönchengladbach (Nr.1633-000)",
            "street": "Baueshütte 41",
            "house_number": "1",
            "zipcode": "41238",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1634-000",
            "name": "Hof Steinmetz in Zeven-Badenstedt (Nr.1634-000)",
            "street": "Ziegeleistr 14",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Zeven-Badenstedt",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1635-000",
            "name": "Privat Junge in Belm (Nr.1635-000)",
            "street": "Bröckerskamp 5",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1636-000",
            "name": "Hof Reul in Holle (Nr.1636-000)",
            "street": "Hainbergstraße 13a",
            "house_number": "1",
            "zipcode": "31188",
            "city": "Holle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1637-000",
            "name": "Reitstall Gäher in Sassenberg (Nr.1637-000)",
            "street": "Steinkamps Heide 1",
            "house_number": "1",
            "zipcode": "48336",
            "city": "Sassenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1638-000",
            "name": "Hof Zeletzki in Greven (Nr.1638-000)",
            "street": "Pentruper Str. 73",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1639-000",
            "name": "Bucks Stall  in Lehe (Nr.1639-000)",
            "street": "Flüte 7",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Lehe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1640-000",
            "name": "Equestrian Sports Wamers / Wamers Wamers GbR in Niederkrüchten (Nr.1640-000)",
            "street": "Erkelenzer Straße 71",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1641-000",
            "name": "Hof Predovic in Bünde (Nr.1641-000)",
            "street": "Südlengerstr. 157",
            "house_number": "1",
            "zipcode": "32257",
            "city": "Bünde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1642-000",
            "name": "Linßenhof in Rheurdt in Rheurdt (Nr.1642-000)",
            "street": "Hochend 138",
            "house_number": "1",
            "zipcode": "47509",
            "city": "Rheurdt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1643-000",
            "name": "Eumeshof Halle in Krefeld (Nr.1643-000)",
            "street": "Vorderorbroich 93",
            "house_number": "1",
            "zipcode": "47839 ",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1644-000",
            "name": "Stall Schütte in Meppen (Nr.1644-000)",
            "street": "Backemühle 2",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1645-000",
            "name": "Reiterhof Kreickmann in Ahlen (Nr.1645-000)",
            "street": "Im Oestricher Holt 100",
            "house_number": "1",
            "zipcode": "59227",
            "city": "Ahlen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1646-000",
            "name": "Privatstall Elkar in Dorsten (Nr.1646-000)",
            "street": "Reiherstraße 33",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1647-000",
            "name": "Hof Veldmann in Laar (Nr.1647-000)",
            "street": "Veldgoorstr 2",
            "house_number": "1",
            "zipcode": "49824",
            "city": "Laar",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1648-000",
            "name": "Hof Gabriel in Schenefeld (Nr.1648-000)",
            "street": "Seggerweg 12",
            "house_number": "1",
            "zipcode": "25469",
            "city": "Schenefeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1649-000",
            "name": "Reitstall König in Herdecke (Nr.1649-000)",
            "street": "Im Bruch 11",
            "house_number": "1",
            "zipcode": "58313",
            "city": "Herdecke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1650-000",
            "name": "Hof Strunk in Bochum (Nr.1650-000)",
            "street": "Haarstr. 59",
            "house_number": "1",
            "zipcode": "44797",
            "city": "Bochum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1651-000",
            "name": "Hof Schmiemann  in Recke (Nr.1651-000)",
            "street": "Twenhusen 29",
            "house_number": "1",
            "zipcode": "49509",
            "city": "Recke",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1652-000",
            "name": "Hof Steffens in Schloß Holte-Stukenbrock (Nr.1652-000)",
            "street": "Römerstraße  3",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1653-000",
            "name": "Osterheidehof  in Borstel (Nr.1653-000)",
            "street": "An der Osterheide 34",
            "house_number": "1",
            "zipcode": "27246",
            "city": "Borstel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1654-000",
            "name": "Hof Becker in Hamm (Nr.1654-000)",
            "street": "Lippestraße 130",
            "house_number": "1",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1655-000",
            "name": "Hof Stein in Himmelpforten  (Nr.1655-000)",
            "street": "Ramels 2",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Himmelpforten ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1656-000",
            "name": "Hof Rinklake in Bad Laer (Nr.1656-000)",
            "street": "Glaner Weg  8",
            "house_number": "1",
            "zipcode": "49196",
            "city": "Bad Laer",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1657-000",
            "name": "Stall Güldner in Hopsten (Nr.1657-000)",
            "street": "Zum Wurftaubenstand  1",
            "house_number": "1",
            "zipcode": "48596",
            "city": "Hopsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1658-000",
            "name": "Hof Beckmeier in Horn-Bad Meinberg (Nr.1658-000)",
            "street": "Lakeweg 10",
            "house_number": "1",
            "zipcode": "32805",
            "city": "Horn-Bad Meinberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1659-000",
            "name": "Felix Kassen Westerntraining in Herne (Nr.1659-000)",
            "street": "Hofstr 42",
            "house_number": "1",
            "zipcode": "44651",
            "city": "Herne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1660-000",
            "name": "Love and Trust Ranch in Datteln (Nr.1660-000)",
            "street": "Ahsener Allee  4",
            "house_number": "1",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1661-000",
            "name": "Paul Vocke Mesum in Rheine (Nr.1661-000)",
            "street": "Feuerstiege 33",
            "house_number": "1",
            "zipcode": "48432",
            "city": "Rheine",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1662-000",
            "name": "Reit und Fahrverein Ostönnen in Soest (Nr.1662-000)",
            "street": "Werler Landstraße 301",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1663-000",
            "name": "Reit- u. Fahrverein in Neuenkirchen-Vörden (Nr.1663-000)",
            "street": "Brakenstraße 3",
            "house_number": "1",
            "zipcode": "49434",
            "city": "Neuenkirchen-Vörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1664-000",
            "name": "Privater Offenstall Freckmann in Lingen (Nr.1664-000)",
            "street": "Antoniusstraße/Ecke Deeringhook ",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1665-000",
            "name": "Theo Wulhorst in Waltrop (Nr.1665-000)",
            "street": "Unterlippe  3",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1666-000",
            "name": "Hof Rathjens in Horneburg (Nr.1666-000)",
            "street": "Moorstr. 18",
            "house_number": "1",
            "zipcode": "21640",
            "city": "Horneburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1667-000",
            "name": "Hof Vollenbroich in Erkelenz (Nr.1667-000)",
            "street": "Klosterstr. 19",
            "house_number": "1",
            "zipcode": "41812",
            "city": "Erkelenz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1668-000",
            "name": "Pferdehofliebe in Bad Bentheim (Nr.1668-000)",
            "street": "Isterberger Weg 5",
            "house_number": "1",
            "zipcode": "48455",
            "city": "Bad Bentheim",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1669-000",
            "name": "Privatstall Metzger in Dülmen (Nr.1669-000)",
            "street": "Bauerschaft  122",
            "house_number": "1",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1670-000",
            "name": "Hof Thomsen in Poppenbüll (Nr.1670-000)",
            "street": "Achter de Kark 3",
            "house_number": "1",
            "zipcode": "25836",
            "city": "Poppenbüll",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1671-000",
            "name": "Aktiv- und Bewegungsstall Sievers in Syke  (Nr.1671-000)",
            "street": "Okeler Heide 8",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1672-000",
            "name": "Hof Oertker in Holdorf (Nr.1672-000)",
            "street": "Ihorst 3",
            "house_number": "1",
            "zipcode": "49451",
            "city": "Holdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1673-000",
            "name": "Privatstall Brosche in Münster (Nr.1673-000)",
            "street": "Hölkenbusch 200",
            "house_number": "1",
            "zipcode": "48161 ",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1674-000",
            "name": "Hof Kövener  in Ostbevern (Nr.1674-000)",
            "street": "Überwasser 7",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1675-000",
            "name": "Rehazentrum Eichenhof in Debstedterbüttel (Nr.1675-000)",
            "street": "Reiterweg  7",
            "house_number": "1",
            "zipcode": "27607",
            "city": "Debstedterbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1676-000",
            "name": "Privatstall Wöbken in Oldenburg (Nr.1676-000)",
            "street": "Geestkamp 29",
            "house_number": "1",
            "zipcode": "26125",
            "city": "Oldenburg",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1677-000",
            "name": "Reitpark Gut Nienhausen in Gelsenkirchen (Nr.1677-000)",
            "street": "Feldmarkstraße 180",
            "house_number": "1",
            "zipcode": "45883",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1678-000",
            "name": "Reiterhof Wekenborg in Meppen (Nr.1678-000)",
            "street": "Landwehr 80",
            "house_number": "1",
            "zipcode": "49716",
            "city": "Meppen",
            "state": "Niedersachen",
            "collect_point": "nein"
        },
        {
            "ID": "1679-000",
            "name": "RV Clarholz-Lette in Herzebrock-Clarholz (Nr.1679-000)",
            "street": "Langemersch 1",
            "house_number": "1",
            "zipcode": "33442",
            "city": "Herzebrock-Clarholz",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1680-000",
            "name": "Hof Nagel in Hövelhof (Nr.1680-000)",
            "street": "Balkenweg 15",
            "house_number": "1",
            "zipcode": "33161",
            "city": "Hövelhof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1681-000",
            "name": "Eskingerhof  in Billerbeck  (Nr.1681-000)",
            "street": "Esking  41",
            "house_number": "1",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1682-000",
            "name": "Ostseeferien Evershof Halske in Lübeck (Nr.1682-000)",
            "street": "Kowitzberg 3",
            "house_number": "1",
            "zipcode": "23570",
            "city": "Lübeck",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1683-000",
            "name": "Reit- unf Fahrverein Emsbüren e.V. in Emsbüren (Nr.1683-000)",
            "street": "Hügeleschweg 5",
            "house_number": "1",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1684-000",
            "name": "Privatstall Schröder in Isernhagen (Nr.1684-000)",
            "street": "Dorfstr. 41",
            "house_number": "1",
            "zipcode": "30916",
            "city": "Isernhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1685-000",
            "name": "Privathof Biermeier  in Schloß Holte-Stukenbrock (Nr.1685-000)",
            "street": "Auf den Holen 1",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1686-000",
            "name": "Privatstall Wöbcke in Elskop (Nr.1686-000)",
            "street": "Dorfstraße 27",
            "house_number": "1",
            "zipcode": "25361",
            "city": "Elskop",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1687-000",
            "name": "Privatstall Gruhnert in Sundern (Nr.1687-000)",
            "street": "Illingheimer Str 3",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1688-000",
            "name": "Reitstall von Öhsen in Hagen im Bremischen (Nr.1688-000)",
            "street": "Wiesenstraße 4",
            "house_number": "1",
            "zipcode": "27628",
            "city": "Hagen im Bremischen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1689-000",
            "name": "Hof Teismann in Senden (Nr.1689-000)",
            "street": "Gettrup 30",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1690-000",
            "name": "Privatstall Haase in Twistringen (Nr.1690-000)",
            "street": "Am Brink 17",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1691-000",
            "name": "Privatstall Ehlting in Prinzhöfte (Nr.1691-000)",
            "street": "Hauptstraße 5",
            "house_number": "1",
            "zipcode": "27243",
            "city": "Prinzhöfte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1692-000",
            "name": "Privatstall Stadler in Oerel (Nr.1692-000)",
            "street": "Sünderbeeksweg 9",
            "house_number": "1",
            "zipcode": "27432",
            "city": "Oerel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1693-000",
            "name": "Privatstall Geiger in Labenz (Nr.1693-000)",
            "street": "Steinhorster Straße 4",
            "house_number": "1",
            "zipcode": "23898",
            "city": "Labenz",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1694-000",
            "name": "Schulze Balhorn  in Sendenhorst (Nr.1694-000)",
            "street": "Bracht 18",
            "house_number": "1",
            "zipcode": "48324",
            "city": "Sendenhorst",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1695-000",
            "name": "Pivatstall Sevenich in Welver (Nr.1695-000)",
            "street": "Illinger Str. 38a",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1696-000",
            "name": "Büsgeshof in Ratingen  (Nr.1696-000)",
            "street": "Götschenbeck  1",
            "house_number": "1",
            "zipcode": "40883",
            "city": "Ratingen ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1697-000",
            "name": "Eggers in Kaiser-Wilhelm-Kroog (Nr.1697-000)",
            "street": "Norderstraße 2",
            "house_number": "1",
            "zipcode": "25709",
            "city": "Kaiser-Wilhelm-Kroog",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1698-000",
            "name": "Reitsportanlage Eichholz in Steinheim (Nr.1698-000)",
            "street": "Heinrich-Spier-Straße 32",
            "house_number": "1",
            "zipcode": "32839",
            "city": "Steinheim",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1699-000",
            "name": "Privatstall Wojewski in Rosendahl-Holtwick (Nr.1699-000)",
            "street": "Riege 9",
            "house_number": "1",
            "zipcode": "48720",
            "city": "Rosendahl-Holtwick",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1700-000",
            "name": "Reitverein Balve in Balve (Nr.1700-000)",
            "street": "Wocklum  9",
            "house_number": "1",
            "zipcode": "58802",
            "city": "Balve",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1701-000",
            "name": "Privatstall Schowwe in Osnabrück (Nr.1701-000)",
            "street": "Bauerschaft Hickingen 40",
            "house_number": "1",
            "zipcode": "49086",
            "city": "Osnabrück",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1702-000",
            "name": "Privatstall Weilinghoff in Heek (Nr.1702-000)",
            "street": "Ahle  117",
            "house_number": "1",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1703-000",
            "name": "Gut Ruhrfeld in Schwerte (Nr.1703-000)",
            "street": "Gut Ruhrfeld ",
            "house_number": "1",
            "zipcode": "58239",
            "city": "Schwerte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1704-000",
            "name": "RTG Berge Halver in Halver (Nr.1704-000)",
            "street": "Berge 3",
            "house_number": "1",
            "zipcode": "58553",
            "city": "Halver",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1705-000",
            "name": "Pensionsstall Hüttmann in Essen (Nr.1705-000)",
            "street": "Donnerberg 92a",
            "house_number": "1",
            "zipcode": "45357",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1706-000",
            "name": "Hof Quast in Olpe (Nr.1706-000)",
            "street": "Fahlenscheid  3",
            "house_number": "1",
            "zipcode": "57462",
            "city": "Olpe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1707-000",
            "name": "Reit- und Fahrrverein Attendorn – Askay e.V. in Attendorn (Nr.1707-000)",
            "street": "Lamfertweg ",
            "house_number": "1",
            "zipcode": "57439",
            "city": "Attendorn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1708-000",
            "name": "Hof Wulf in Werl (Nr.1708-000)",
            "street": "Soester Str. 41",
            "house_number": "1",
            "zipcode": "59457",
            "city": "Werl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1709-000",
            "name": "Zenshof in Bedburg (Nr.1709-000)",
            "street": "Friedensstraße  39",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1710-000",
            "name": "Hof Anumee Bendestorf  in Bendestorf  (Nr.1710-000)",
            "street": "Kleckerwaldstraße  39",
            "house_number": "1",
            "zipcode": "21227",
            "city": "Bendestorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1711-000",
            "name": "Privatstall Kooymans in Höxter (Nr.1711-000)",
            "street": "Wiesenstraße  30",
            "house_number": "1",
            "zipcode": "37671",
            "city": "Höxter",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1712-000",
            "name": "Privatstall Schulz in Düdenbüttel (Nr.1712-000)",
            "street": "Weißenmoor 15",
            "house_number": "1",
            "zipcode": "21709",
            "city": "Düdenbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1713-000",
            "name": "Privatstall Simon in Tating (Nr.1713-000)",
            "street": "Dorfstraße  1",
            "house_number": "1",
            "zipcode": "25881",
            "city": "Tating",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1714-000",
            "name": "Privatstall Dreger in Südheide / Hermannsburg (Nr.1714-000)",
            "street": "Hemmetworth  6",
            "house_number": "1",
            "zipcode": "29320",
            "city": "Südheide / Hermannsburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1715-000",
            "name": "Stall Stefan Heling in Ahaus (Nr.1715-000)",
            "street": "Averesch 18",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1716-000",
            "name": "Privatstall Schermbeck in Schermbeck (Nr.1716-000)",
            "street": "Zur Alten Lippe 22",
            "house_number": "1",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1717-000",
            "name": "Privatstall Stegemann in Coesfeld (Nr.1717-000)",
            "street": "Stripperhook 26",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1718-000",
            "name": "Hof Riedemann in Oerlinghausen (Nr.1718-000)",
            "street": "Oetenhauser Str. 43",
            "house_number": "1",
            "zipcode": "33813",
            "city": "Oerlinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1719-000",
            "name": "Laurienshof Christian Uelschen in Garbsen (Nr.1719-000)",
            "street": "Stöckener Str. 1",
            "house_number": "1",
            "zipcode": "30826",
            "city": "Garbsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1720-000",
            "name": "Privatadresse Basylec in Hohenwestedt (Nr.1720-000)",
            "street": "An der Kleinbahn 28",
            "house_number": "1",
            "zipcode": "24594",
            "city": "Hohenwestedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1721-000",
            "name": "Privatstall Büttner in Rees (Nr.1721-000)",
            "street": "Schledenhorst 1",
            "house_number": "1",
            "zipcode": "46459",
            "city": "Rees",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1722-000",
            "name": "Winkel in Blender (Nr.1722-000)",
            "street": "Winkel 5",
            "house_number": "1",
            "zipcode": "27337",
            "city": "Blender",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1723-000",
            "name": "Hof Funke in Wadersloh (Nr.1723-000)",
            "street": "Vahlhauser Weg 4",
            "house_number": "1",
            "zipcode": "49329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1724-000",
            "name": "Reitstall Wöllersberg in Wermelskirchen (Nr.1724-000)",
            "street": "Wöllersberg  2",
            "house_number": "1",
            "zipcode": "42929",
            "city": "Wermelskirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1725-000",
            "name": "ZRFV Dorsten in Dorsten (Nr.1725-000)",
            "street": "Im Ovelgünne 16",
            "house_number": "1",
            "zipcode": "46282",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1726-000",
            "name": "Förderverein für Hippopädagogik & Reitsport e.V. Zeven in Zeven (Nr.1726-000)",
            "street": "Kirchhofsallee ",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Zeven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1727-000",
            "name": "Pferdestall Haskenau in Münster (Nr.1727-000)",
            "street": "Zur Haskenau 71",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1728-000",
            "name": "Christinenhof in Frechen (Nr.1728-000)",
            "street": "Freimersdorfer Weg 9",
            "house_number": "1",
            "zipcode": "50226",
            "city": "Frechen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1729-000",
            "name": "Reitclub Walle e.V. in Bremen (Nr.1729-000)",
            "street": "Mittelwischweg  1",
            "house_number": "1",
            "zipcode": "28237",
            "city": "Bremen",
            "state": "Bremen",
            "collect_point": "nein"
        },
        {
            "ID": "1730-000",
            "name": "Hof Wente in Unna (Nr.1730-000)",
            "street": "Hinterstraße  1",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1731-000",
            "name": "TJ Quarter Horses in Emmerthal (Nr.1731-000)",
            "street": "Völkerhausen 5",
            "house_number": "1",
            "zipcode": "31860",
            "city": "Emmerthal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1732-000",
            "name": "Kruthoff  in Ahaus-Alstätte (Nr.1732-000)",
            "street": "Buurser Straße 85",
            "house_number": "1",
            "zipcode": "48683",
            "city": "Ahaus-Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1733-000",
            "name": "Ritzenhof in Elsdorf (Nr.1733-000)",
            "street": "Hahnenstr. 65",
            "house_number": "1",
            "zipcode": "50189",
            "city": "Elsdorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1734-000",
            "name": "Privathof Frieling in Emsdetten (Nr.1734-000)",
            "street": "Westumer Landstr.  69",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1735-000",
            "name": "Privathof Voss in Heinsberg  (Nr.1735-000)",
            "street": "Rurstraße 7",
            "house_number": "1",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1736-000",
            "name": "Pferdepension Ellernhof in Springe (Nr.1736-000)",
            "street": "In der Ellern 2",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1737-000",
            "name": "Privatstall Heiduk in Hagen im Bremischen (Nr.1737-000)",
            "street": "Dorfhagener Allee 1",
            "house_number": "1",
            "zipcode": "27628",
            "city": "Hagen im Bremischen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1738-000",
            "name": "Privathof Ksinski in Verl (Nr.1738-000)",
            "street": "Binnerweg 55",
            "house_number": "1",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1739-000",
            "name": "Privathof Dercks in Geldern (Nr.1739-000)",
            "street": "Loerheideweg  21a",
            "house_number": "1",
            "zipcode": "47608",
            "city": "Geldern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1740-000",
            "name": "Sonnenhof Hofolpe in Kirchhundem (Nr.1740-000)",
            "street": "Saalweg  53",
            "house_number": "1",
            "zipcode": "57399",
            "city": "Kirchhundem",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1741-000",
            "name": "Privathof Wilk in Langenfeld (Nr.1741-000)",
            "street": "Rothenberger Str. 6",
            "house_number": "1",
            "zipcode": "40764",
            "city": "Langenfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1742-000",
            "name": "Hölzle in Jüchen (Nr.1742-000)",
            "street": "Dürselen 176",
            "house_number": "1",
            "zipcode": "41363",
            "city": "Jüchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1743-000",
            "name": "Privathof Schaper in Didderse (Nr.1743-000)",
            "street": "Celler Straße 1",
            "house_number": "1",
            "zipcode": "38530",
            "city": "Didderse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1744-000",
            "name": "RFV Steele-Horst in Essen (Nr.1744-000)",
            "street": "Schultenweg  98",
            "house_number": "1",
            "zipcode": "45279",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1745-000",
            "name": "Privatstall Werth in Soest (Nr.1745-000)",
            "street": "Bördenstraße 22",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1746-000",
            "name": "Global Dressage Horses in Wallenhorst (Nr.1746-000)",
            "street": "Im alten Dorf 13a",
            "house_number": "1",
            "zipcode": "49134",
            "city": "Wallenhorst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1747-000",
            "name": "Privathof Haak in Westerkappeln (Nr.1747-000)",
            "street": "Wulverliet  2",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1748-000",
            "name": "Privatstall Rittmeyer in Jade (Nr.1748-000)",
            "street": "Oldenbroker Str. 5",
            "house_number": "1",
            "zipcode": "26349",
            "city": "Jade",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1749-000",
            "name": "Privatstall Victoria in Loxstedt (Nr.1749-000)",
            "street": "Frankensteiner Str. 4a",
            "house_number": "1",
            "zipcode": "27612",
            "city": "Loxstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1750-000",
            "name": "Reitstall Tidow  in Springe (Nr.1750-000)",
            "street": "Am Thie 25",
            "house_number": "1",
            "zipcode": "31832",
            "city": "Springe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1751-000",
            "name": "Privatstall Funke in Sundern (Nr.1751-000)",
            "street": "Altenhellefelder Str. 1",
            "house_number": "1",
            "zipcode": "59846",
            "city": "Sundern",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1752-000",
            "name": "Privatstall Knigge in Belm (Nr.1752-000)",
            "street": "Bergstraße 121",
            "house_number": "1",
            "zipcode": "49191",
            "city": "Belm",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1753-000",
            "name": "Reitstall Bröckmann in Bönen (Nr.1753-000)",
            "street": "Sinnerstraße  7",
            "house_number": "1",
            "zipcode": "59199",
            "city": "Bönen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1754-000",
            "name": "Hackmann's Biohof in Westerkappeln (Nr.1754-000)",
            "street": "Heerstr. 71",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1755-000",
            "name": "Hof Rolle in Meinerzhagen (Nr.1755-000)",
            "street": "Neuhohlinden 1",
            "house_number": "1",
            "zipcode": "58540",
            "city": "Meinerzhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1756-000",
            "name": "Privatstall Große Kleimann in Metelen (Nr.1756-000)",
            "street": "Samberg 35",
            "house_number": "1",
            "zipcode": "48629",
            "city": "Metelen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1757-000",
            "name": "Privatstall Steinberg in Meschede (Nr.1757-000)",
            "street": "Enste 5",
            "house_number": "1",
            "zipcode": "59872",
            "city": "Meschede",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1758-000",
            "name": "Stall David in Heilshoop  in Zarpen (Nr.1758-000)",
            "street": "Hauptstraße 26",
            "house_number": "1",
            "zipcode": "23619",
            "city": "Zarpen",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1759-000",
            "name": "Strohbücker in Coesfeld (Nr.1759-000)",
            "street": "Harle  48a",
            "house_number": "1",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1760-000",
            "name": "Reitstall Piel in Sibbesse (Nr.1760-000)",
            "street": "Westfelder Hauptstraße 35",
            "house_number": "1",
            "zipcode": "31079",
            "city": "Sibbesse",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1761-000",
            "name": "Gestüt Ebbing in Kempen (Nr.1761-000)",
            "street": "Krefelder Weg 68",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1762-000",
            "name": "ZRFV Salzbergen in Salzbergen (Nr.1762-000)",
            "street": "Emsstraße 15",
            "house_number": "1",
            "zipcode": "48499",
            "city": "Salzbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1763-000",
            "name": "Pferdepension und Zuchtstall Lauer in Handewitt  (Nr.1763-000)",
            "street": "Ahnebylund 15",
            "house_number": "1",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1764-000",
            "name": "Reitstall Zimmermann in Uetze (Nr.1764-000)",
            "street": "Schwüblingserstr. 13",
            "house_number": "1",
            "zipcode": "31311",
            "city": "Uetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1765-000",
            "name": "Pferdehof Nobiskrug in Jever (Nr.1765-000)",
            "street": "Sandeler Mühlenweg  1-3",
            "house_number": "1",
            "zipcode": "26441",
            "city": "Jever",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1766-000",
            "name": "Krampitz in Pohle (Nr.1766-000)",
            "street": "Apelerner Straße 11",
            "house_number": "1",
            "zipcode": "31867",
            "city": "Pohle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1768-000",
            "name": "Ponyparadies Waltrop in Waltrop (Nr.1768-000)",
            "street": "Auf dem Heiken 28",
            "house_number": "1",
            "zipcode": "45731",
            "city": "Waltrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1769-000",
            "name": "Landgut Diepeschrath in Bergisch Gladbach (Nr.1769-000)",
            "street": "Diepeschrath  1",
            "house_number": "1",
            "zipcode": "51469",
            "city": "Bergisch Gladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1770-000",
            "name": "Bei Dornuf in Krefeld (Nr.1770-000)",
            "street": "Hökendyk 2",
            "house_number": "1",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1771-000",
            "name": "Privatstall Breuer in Schiphorst (Nr.1771-000)",
            "street": "Steinhorster Weg 5",
            "house_number": "1",
            "zipcode": "23847",
            "city": "Schiphorst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1772-000",
            "name": "Reitstall Erlenhagen  in Gummersbach (Nr.1772-000)",
            "street": "Wasserwerkstraße  5",
            "house_number": "1",
            "zipcode": "51647",
            "city": "Gummersbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1773-000",
            "name": "Privatstall Fiege in Velbert  (Nr.1773-000)",
            "street": "Asbachtal 6",
            "house_number": "1",
            "zipcode": "42553",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1774-000",
            "name": "Privathof Neumann in Reken  (Nr.1774-000)",
            "street": "Heltweg 18",
            "house_number": "1",
            "zipcode": "48734",
            "city": "Reken ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1775-000",
            "name": "Reitstall Dahlhoff  in Kempen (Nr.1775-000)",
            "street": "An der Gastendonk 25a",
            "house_number": "1",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1776-000",
            "name": "Privatstall Becker in Neuenkirchen-Vörden (Nr.1776-000)",
            "street": "Astrup  19",
            "house_number": "1",
            "zipcode": "49434",
            "city": "Neuenkirchen-Vörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1777-000",
            "name": "Voss in Lingen  (Nr.1777-000)",
            "street": "Bramharstr 5",
            "house_number": "1",
            "zipcode": "49811",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1778-000",
            "name": "Hof Hansen in Duisburg  (Nr.1778-000)",
            "street": "Holtumer Mühlenweg  25",
            "house_number": "1",
            "zipcode": "47259",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1779-000",
            "name": "Pferdehof Sophie in Henstedt Ulzburg (Nr.1779-000)",
            "street": "Weedentwiete  ",
            "house_number": "1",
            "zipcode": "24558",
            "city": "Henstedt Ulzburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1780-000",
            "name": "Hofer Hof in Viersen (Nr.1780-000)",
            "street": "Amrather Weg 13",
            "house_number": "1",
            "zipcode": "41751",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1781-000",
            "name": "Eagle Free Ranch in Steyerberg (Nr.1781-000)",
            "street": "Deblinghausen  19",
            "house_number": "1",
            "zipcode": "31595",
            "city": "Steyerberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1782-000",
            "name": "Bockholtshoff  in Schneverdingen  (Nr.1782-000)",
            "street": "Pappelallee  5",
            "house_number": "1",
            "zipcode": "29640",
            "city": "Schneverdingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1783-000",
            "name": "HofLeben eV in Dahlenburg (Nr.1783-000)",
            "street": "Hauptstraße 1",
            "house_number": "1",
            "zipcode": "21368",
            "city": "Dahlenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1784-000",
            "name": "Privathof Böke in Porta Westfalica (Nr.1784-000)",
            "street": "Weserblick 17",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1785-000",
            "name": "Privatstall Büsing in Burgwedel (Nr.1785-000)",
            "street": "Dorfstraße 29",
            "house_number": "1",
            "zipcode": "30938",
            "city": "Burgwedel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1786-000",
            "name": "Privatstall Humpert in Hessisch Oldendorf (Nr.1786-000)",
            "street": "Teichstrasse  4",
            "house_number": "1",
            "zipcode": "31840",
            "city": "Hessisch Oldendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1787-000",
            "name": "Privatstall Fey in Ochtrup (Nr.1787-000)",
            "street": "Spinnereistraße  5",
            "house_number": "1",
            "zipcode": "48607",
            "city": "Ochtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1788-000",
            "name": "Privatstall Rosenstengel in Neuenrade (Nr.1788-000)",
            "street": "Vorm Schorfe 1",
            "house_number": "1",
            "zipcode": "58809",
            "city": "Neuenrade",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1789-000",
            "name": "Hof Klingeberg Burgstemmen  in Nordstemmen (Nr.1789-000)",
            "street": "Berkel 3",
            "house_number": "1",
            "zipcode": "31171",
            "city": "Nordstemmen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1790-000",
            "name": "Privathof Fleck in Lienen (Nr.1790-000)",
            "street": "Mühlenweg 2",
            "house_number": "1",
            "zipcode": "49536",
            "city": "Lienen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1791-000",
            "name": "RV Senden in Senden (Nr.1791-000)",
            "street": "Dorfbauernschaft 102b",
            "house_number": "1",
            "zipcode": "48308",
            "city": "Senden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1792-000",
            "name": "Stall Hauptmeier in Wadersloh (Nr.1792-000)",
            "street": "Stromberger Str 62",
            "house_number": "1",
            "zipcode": "59329",
            "city": "Wadersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1793-000",
            "name": "Privathof Heinz in Hagen a.T.W. (Nr.1793-000)",
            "street": "Achter De Welt 2",
            "house_number": "1",
            "zipcode": "49170",
            "city": "Hagen a.T.W.",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1794-000",
            "name": "Privatstall Pleines in Delbrück (Nr.1794-000)",
            "street": "Lippstädter Str. 109",
            "house_number": "1",
            "zipcode": "33129",
            "city": "Delbrück",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1795-000",
            "name": "Privatstall Uphoff in Großheide (Nr.1795-000)",
            "street": "Südarlerlandstr. 24",
            "house_number": "1",
            "zipcode": "26532",
            "city": "Großheide",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1796-000",
            "name": "Privathof Haerskötter in Emsdetten (Nr.1796-000)",
            "street": "Austum 26",
            "house_number": "1",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1797-000",
            "name": "Hof Große-Hartmann in Warendorf  (Nr.1797-000)",
            "street": "Vohren 7",
            "house_number": "1",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1798-000",
            "name": "RV Saerbeck in Saerbeck (Nr.1798-000)",
            "street": "Riesenbecker Straße 44",
            "house_number": "1",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1799-000",
            "name": "Pferdepension Ameln in Oberlangen (Nr.1799-000)",
            "street": "Marienstraße  13",
            "house_number": "1",
            "zipcode": "49779",
            "city": "Oberlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1800-000",
            "name": "Albers Rosenhof in Bispingen (Nr.1800-000)",
            "street": "Rosenhof 2",
            "house_number": "1",
            "zipcode": "29646",
            "city": "Bispingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1801-000",
            "name": "Freyer in Neetze/Neu-Neetze (Nr.1801-000)",
            "street": "Neu Süttorf 16",
            "house_number": "1",
            "zipcode": "21398",
            "city": "Neetze/Neu-Neetze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1802-000",
            "name": "Privathof Renz in Weyhe (Nr.1802-000)",
            "street": "Heidstraße 53",
            "house_number": "1",
            "zipcode": "28844",
            "city": "Weyhe",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1803-000",
            "name": "Privathof Nimmert in Großenwörden (Nr.1803-000)",
            "street": "Seestraße  13",
            "house_number": "1",
            "zipcode": "21712",
            "city": "Großenwörden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1804-000",
            "name": "Privatstall Trauzettel in Marl  (Nr.1804-000)",
            "street": "Herner Weg 20",
            "house_number": "1",
            "zipcode": "45772",
            "city": "Marl ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1805-000",
            "name": "Privathof Püschel in Verl (Nr.1805-000)",
            "street": "Holter Landstraße  81",
            "house_number": "1",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1806-000",
            "name": "Privatstall Lüthje in Hemmingen (Nr.1806-000)",
            "street": "Ostertorstraße  25a",
            "house_number": "1",
            "zipcode": "30966",
            "city": "Hemmingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1807-000",
            "name": "Privatstall Breiderhoff in Duisburg  (Nr.1807-000)",
            "street": "Orsoyer Str.  1",
            "house_number": "1",
            "zipcode": "47199",
            "city": "Duisburg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1808-000",
            "name": "Silver Diamond Ranch in Velbert  (Nr.1808-000)",
            "street": "Wallmichrather Straße  26a",
            "house_number": "1",
            "zipcode": "42555",
            "city": "Velbert ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1809-000",
            "name": "Kuhlmann in Gelsenkirchen (Nr.1809-000)",
            "street": "Böningstr. 153a",
            "house_number": "1",
            "zipcode": "45892",
            "city": "Gelsenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1810-000",
            "name": "Privatstall Post in Twistringen (Nr.1810-000)",
            "street": "Zur Mühle 64",
            "house_number": "1",
            "zipcode": "27239",
            "city": "Twistringen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1811-000",
            "name": "Privatstall Lutter in Vahlbruch (Nr.1811-000)",
            "street": "An der Kirche 8",
            "house_number": "1",
            "zipcode": "37647",
            "city": "Vahlbruch",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1812-000",
            "name": "Privatstsall Scheepers in Niederkrüchten (Nr.1812-000)",
            "street": "Erkelenzer Straße 69",
            "house_number": "1",
            "zipcode": "41372",
            "city": "Niederkrüchten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1813-000",
            "name": "Stall Nordmann in Saterland  (Nr.1813-000)",
            "street": "Vorm Moor 34",
            "house_number": "1",
            "zipcode": "26683",
            "city": "Saterland ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1814-000",
            "name": "Hof Isaak in Soest (Nr.1814-000)",
            "street": "Erzväterring  5",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1815-000",
            "name": "Hof Messing in Schöppingen (Nr.1815-000)",
            "street": "Heven 40",
            "house_number": "1",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1816-000",
            "name": "Reitstall Bega in Dörentrup (Nr.1816-000)",
            "street": "Sibbentruper Str. 12",
            "house_number": "1",
            "zipcode": "32694",
            "city": "Dörentrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1817-000",
            "name": " Reitstall Claßen - Brachelen in Hückelhoven (Nr.1817-000)",
            "street": "Kahrweghof  1",
            "house_number": "1",
            "zipcode": "41836",
            "city": "Hückelhoven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1818-000",
            "name": "Stall Wollesen in Twedt (Nr.1818-000)",
            "street": "Kappelner Straße 6",
            "house_number": "1",
            "zipcode": "24894",
            "city": "Twedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1819-000",
            "name": "Privathof Wiefel in Greven  (Nr.1819-000)",
            "street": "Postdamm 30",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1820-000",
            "name": "Reiterhof Laubner in Gütersloh (Nr.1820-000)",
            "street": "Blankenhagener Weg 139",
            "house_number": "1",
            "zipcode": "22224",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1821-000",
            "name": "Privatstall Thomsen in Lindewitt (Nr.1821-000)",
            "street": "Süderreihe 3",
            "house_number": "1",
            "zipcode": "24969",
            "city": "Lindewitt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1822-000",
            "name": "Privatstall Schlecht in Unna (Nr.1822-000)",
            "street": "Zum Bröhl 1",
            "house_number": "1",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1823-000",
            "name": "Privatstall Meinhardt in Mönchengladbach (Nr.1823-000)",
            "street": "Großheide 248",
            "house_number": "1",
            "zipcode": "41063",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1824-000",
            "name": "Spiekerhof in Borgholzhausen (Nr.1824-000)",
            "street": "Wichlinghausen 11",
            "house_number": "1",
            "zipcode": "33829",
            "city": "Borgholzhausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1825-000",
            "name": "Birkenhof in Stapelfeld (Nr.1825-000)",
            "street": "Hauptstraße 5",
            "house_number": "1",
            "zipcode": "22145",
            "city": "Stapelfeld",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1826-000",
            "name": "Hof Löcke in Neuenkirchen (Nr.1826-000)",
            "street": "Landersum 13",
            "house_number": "1",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1827-000",
            "name": "Privathof Andersen in Silberstedt (Nr.1827-000)",
            "street": "Stapelholmer Weg 8",
            "house_number": "1",
            "zipcode": "24887",
            "city": "Silberstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1828-000",
            "name": "Bat Oak Ranch in Winsen OT Stedden (Nr.1828-000)",
            "street": "Zum Hahnenberg ",
            "house_number": "1",
            "zipcode": "29308",
            "city": "Winsen OT Stedden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1829-000",
            "name": "Sattelberatung & Mehr in Ratingen (Nr.1829-000)",
            "street": "August-Prell-Strasse 34",
            "house_number": "1",
            "zipcode": "40885",
            "city": "Ratingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1830-000",
            "name": "Privathof Eilers in Ostbevern  (Nr.1830-000)",
            "street": "Kattmannskamp  8",
            "house_number": "1",
            "zipcode": "48346",
            "city": "Ostbevern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1831-000",
            "name": "Privathof Tenhumberg in Horstmar (Nr.1831-000)",
            "street": "Haltern 60",
            "house_number": "1",
            "zipcode": "48612",
            "city": "Horstmar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1832-000",
            "name": "Stall Schubert in Melle  (Nr.1832-000)",
            "street": "Brockmannsweg  8",
            "house_number": "1",
            "zipcode": "49326",
            "city": "Melle ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1833-000",
            "name": "Flothhof in Greven  (Nr.1833-000)",
            "street": "Flothdamm 6",
            "house_number": "1",
            "zipcode": "48268",
            "city": "Greven ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1834-000",
            "name": "Privathof Adrian in Welver  (Nr.1834-000)",
            "street": "Hammer Landstraße 4",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1835-000",
            "name": "Hof Wemmel in Leiferde (Nr.1835-000)",
            "street": "Glider Weg 78",
            "house_number": "1",
            "zipcode": "38542",
            "city": "Leiferde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1836-000",
            "name": "Privatstall Hesse in Kalkar (Nr.1836-000)",
            "street": "Hochstrasse  6a",
            "house_number": "1",
            "zipcode": "47546",
            "city": "Kalkar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1837-000",
            "name": "Peveling in Castrop-Rauxel (Nr.1837-000)",
            "street": "Kanalstraße 58",
            "house_number": "1",
            "zipcode": "44579",
            "city": "Castrop-Rauxel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1838-000",
            "name": "OS Sporthorses in Stadtlohn  (Nr.1838-000)",
            "street": "Am Esch 9",
            "house_number": "1",
            "zipcode": "48703",
            "city": "Stadtlohn ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1839-000",
            "name": "Privathof Wallrabenstein in Grube (Nr.1839-000)",
            "street": "Fährkamp 4",
            "house_number": "1",
            "zipcode": "23749",
            "city": "Grube",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1840-000",
            "name": "Planwagenfahrten Wendel  in Hamm  (Nr.1840-000)",
            "street": "Dortmunder Straße 269",
            "house_number": "1",
            "zipcode": "59077",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1841-000",
            "name": "Stall Schering in Petershagen (Nr.1841-000)",
            "street": "Mitteldorf 17",
            "house_number": "1",
            "zipcode": "32469",
            "city": "Petershagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1842-000",
            "name": "Privatstall Heil in Lindlar (Nr.1842-000)",
            "street": "Müllersommer 2",
            "house_number": "1",
            "zipcode": "51789",
            "city": "Lindlar",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1843-000",
            "name": "Privatstall Hanisch in Engden (Nr.1843-000)",
            "street": "Emsfort 8a",
            "house_number": "1",
            "zipcode": "48465",
            "city": "Engden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1844-000",
            "name": "Wentholt in Südlohn (Nr.1844-000)",
            "street": "Tünte 3",
            "house_number": "1",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1845-000",
            "name": "Hof Efker in Lippetal (Nr.1845-000)",
            "street": "Heintroper Str 23",
            "house_number": "1",
            "zipcode": "59510",
            "city": "Lippetal",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1846-000",
            "name": "Fam. Assen in Vreden  (Nr.1846-000)",
            "street": "Nork 113",
            "house_number": "1",
            "zipcode": "48691",
            "city": "Vreden ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1847-000",
            "name": "Hof Hesse in Binnen (Nr.1847-000)",
            "street": " Am Rohrbach 12",
            "house_number": "1",
            "zipcode": "31619",
            "city": "Binnen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1848-000",
            "name": "Stall Büter in Surwold (Nr.1848-000)",
            "street": "Hauptstraße  14",
            "house_number": "1",
            "zipcode": "26903",
            "city": "Surwold",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1849-000",
            "name": "Brinkerhook in  Ahaus- Alstätte (Nr.1849-000)",
            "street": "Brinkerhook  12",
            "house_number": "1",
            "zipcode": "48683",
            "city": " Ahaus- Alstätte",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1850-000",
            "name": "De Paddloepers - Bewegungsstall Schnelle in Martfeld (Nr.1850-000)",
            "street": "Kiwitt  13",
            "house_number": "1",
            "zipcode": "27327",
            "city": "Martfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1851-000",
            "name": "Hof Geitmann in Iserlohn (Nr.1851-000)",
            "street": "Leckerhorstweg  22",
            "house_number": "1",
            "zipcode": "58642",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1852-000",
            "name": "Hof Liedke in Adelheidsdorf  (Nr.1852-000)",
            "street": "Kurfürstendamm 39",
            "house_number": "1",
            "zipcode": "29352",
            "city": "Adelheidsdorf ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1853-000",
            "name": "Hof Otten in Elsdorf (Nr.1853-000)",
            "street": "Ostestraße  10",
            "house_number": "1",
            "zipcode": "27404",
            "city": "Elsdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1854-000",
            "name": "Hof Auetal in Barsbüttel (Nr.1854-000)",
            "street": "Bahnhofstraße  10",
            "house_number": "1",
            "zipcode": "22885",
            "city": "Barsbüttel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1855-000",
            "name": "Privatstall van Bergerem in Goch (Nr.1855-000)",
            "street": "Boeckelterweg  425",
            "house_number": "1",
            "zipcode": "47574",
            "city": "Goch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1856-000",
            "name": "RuFV Diek-Bassum in Bassum (Nr.1856-000)",
            "street": "Wiebusch 4a",
            "house_number": "1",
            "zipcode": "27211",
            "city": "Bassum",
            "state": "Niedersachsen ",
            "collect_point": "nein"
        },
        {
            "ID": "1857-000",
            "name": "Lindenhof in Düsseldorf (Nr.1857-000)",
            "street": "Pfaffenmühlenweg  8",
            "house_number": "1",
            "zipcode": "40489",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1858-000",
            "name": "Reitanlage am Brunnenhof in Schwelm (Nr.1858-000)",
            "street": "Am Brunnenhof 28",
            "house_number": "1",
            "zipcode": "58332",
            "city": "Schwelm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1859-000",
            "name": "Sander Westerkappeln/Seeste in Westerkappeln (Nr.1859-000)",
            "street": "Im Himmelreich 6",
            "house_number": "1",
            "zipcode": "49492",
            "city": "Westerkappeln",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1860-000",
            "name": "Reitstall Prigge in Beckdorf (Nr.1860-000)",
            "street": "Estetalstraße 10",
            "house_number": "1",
            "zipcode": "21643",
            "city": "Beckdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1861-000",
            "name": "Pferdehof Iried Weth in Lehrte (Nr.1861-000)",
            "street": "Hauptstraße  3",
            "house_number": "1",
            "zipcode": "31275",
            "city": "Lehrte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1862-000",
            "name": "Hof Schulze-Bisping in Werne (Nr.1862-000)",
            "street": "Im Nierfeld 5",
            "house_number": "1",
            "zipcode": "59368",
            "city": "Werne",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1863-000",
            "name": "Privat Küpper in Bedburg (Nr.1863-000)",
            "street": "Am Fließ 1",
            "house_number": "1",
            "zipcode": "50181",
            "city": "Bedburg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1864-000",
            "name": "Linnhof in Osterrönfeld (Nr.1864-000)",
            "street": "Linnhof  1",
            "house_number": "1",
            "zipcode": "24783",
            "city": "Osterrönfeld",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1865-000",
            "name": "Hof Leisner in Seedorf (Nr.1865-000)",
            "street": "Seekathen 3a",
            "house_number": "1",
            "zipcode": "23823",
            "city": "Seedorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1866-000",
            "name": "Ketteltasche in Hattingen-Niederwenigern  (Nr.1866-000)",
            "street": "Ketteltasche 8",
            "house_number": "1",
            "zipcode": "45529",
            "city": "Hattingen-Niederwenigern ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1867-000",
            "name": "Pferdeinhalation-MK  in Iserlohn (Nr.1867-000)",
            "street": "Rombrockerstraße 10",
            "house_number": "1",
            "zipcode": "58640",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1868-000",
            "name": "Stall Ulmenhof in Krumstedt  (Nr.1868-000)",
            "street": "Dorfstraße 27",
            "house_number": "1",
            "zipcode": "25727",
            "city": "Krumstedt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1869-000",
            "name": "Reitstall Dassau in Dassendorf (Nr.1869-000)",
            "street": "Hauskoppel  3",
            "house_number": "1",
            "zipcode": "21521",
            "city": "Dassendorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1870-000",
            "name": "Hof Hoffmeister in Bockenem (Nr.1870-000)",
            "street": "Lange Straße  3",
            "house_number": "1",
            "zipcode": "31167",
            "city": "Bockenem",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1871-000",
            "name": "Pferdeparadies Bortfeld in Bortfeld (Nr.1871-000)",
            "street": "Lange Straße  33",
            "house_number": "1",
            "zipcode": "38176",
            "city": "Bortfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1872-000",
            "name": "Reitanlage Stapelskotten  in Münster (Nr.1872-000)",
            "street": "Am Mooresch  34",
            "house_number": "1",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1873-000",
            "name": "Reit- und Fahrverein Laer e.V. in Laer (Nr.1873-000)",
            "street": "Borgweg  1",
            "house_number": "1",
            "zipcode": "48366",
            "city": "Laer",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1874-000",
            "name": "Hof Geiger in Aventoft  (Nr.1874-000)",
            "street": "Aventofter Landstraße 26",
            "house_number": "1",
            "zipcode": "25927",
            "city": "Aventoft ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1875-000",
            "name": "Hof Curth in Langerwehe  (Nr.1875-000)",
            "street": "B264  6",
            "house_number": "1",
            "zipcode": "52379",
            "city": "Langerwehe ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1876-000",
            "name": "Pferdeschutzhof Iserlohn in Iserlohn (Nr.1876-000)",
            "street": "Hegenscheider Str. 6",
            "house_number": "1",
            "zipcode": "58644",
            "city": "Iserlohn",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1877-000",
            "name": "Hof Springhorn in Soltau (Nr.1877-000)",
            "street": "Frielingen  9",
            "house_number": "1",
            "zipcode": "29614",
            "city": "Soltau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1878-000",
            "name": "Hof Winter in Bohmte (Nr.1878-000)",
            "street": "Scheelenkamp 5",
            "house_number": "1",
            "zipcode": "49161",
            "city": "Bohmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1879-000",
            "name": "Ländlicher Zucht-, Reit- und Fahrverein Haltern am See in Haltern am See (Nr.1879-000)",
            "street": "Münsterstraße 163",
            "house_number": "1",
            "zipcode": "45721",
            "city": "Haltern am See",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1880-000",
            "name": "Hof Bettler in Ladbergen (Nr.1880-000)",
            "street": "Münsterweg 39",
            "house_number": "1",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1881-000",
            "name": "Hof Mühlenbein in Soest (Nr.1881-000)",
            "street": "Lindenweg 41",
            "house_number": "1",
            "zipcode": "59494",
            "city": "Soest",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1882-000",
            "name": "Lautenhof in Willich (Nr.1882-000)",
            "street": "Wilhelm-Hörmes-Straße  33",
            "house_number": "1",
            "zipcode": "47877",
            "city": "Willich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1883-000",
            "name": "Hof Tangen in Dörpen (Nr.1883-000)",
            "street": "Müll 265",
            "house_number": "1",
            "zipcode": "26892",
            "city": "Dörpen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1884-000",
            "name": "Privathof Griese in Hamm  (Nr.1884-000)",
            "street": "Klostermühlenweg  38",
            "house_number": "1",
            "zipcode": "59075",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1885-000",
            "name": "Pohlmanns Hof  in Hanstedt (Nr.1885-000)",
            "street": "Rüstweg 3",
            "house_number": "1",
            "zipcode": "21271",
            "city": "Hanstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1886-000",
            "name": "Ponyhof Berksen in Welver  (Nr.1886-000)",
            "street": "Berksen  3",
            "house_number": "1",
            "zipcode": "59514",
            "city": "Welver ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1887-000",
            "name": "Tackenhof in Dinslaken in Dinslaken (Nr.1887-000)",
            "street": "Holtener Straße 246",
            "house_number": "1",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1888-000",
            "name": "Parkpferde Höllinghofen  in Arnsberg (Nr.1888-000)",
            "street": "Höllinghofen  1",
            "house_number": "1",
            "zipcode": "59757",
            "city": "Arnsberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1889-000",
            "name": "Stall Vlothoböumer in Herford (Nr.1889-000)",
            "street": "Vlothoer Straße 134",
            "house_number": "1",
            "zipcode": "32049",
            "city": "Herford",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1890-000",
            "name": "Reitstall Krüppel in Schwalmtal  (Nr.1890-000)",
            "street": "Hehler ",
            "house_number": "1",
            "zipcode": "41366",
            "city": "Schwalmtal ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1891-000",
            "name": "Eichenhof Werth  in Isselburg - Werth  (Nr.1891-000)",
            "street": "Zehntweg  2a",
            "house_number": "1",
            "zipcode": "46419",
            "city": "Isselburg - Werth ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1892-000",
            "name": "Privat Schäfer in Schloß Holte-Stukenbrock (Nr.1892-000)",
            "street": "Lindenstraße  29a",
            "house_number": "1",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1893-000",
            "name": "Privathof Ruhnau in Dortmund (Nr.1893-000)",
            "street": "Schiffhorst  130",
            "house_number": "1",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1894-000",
            "name": "Pferdeparadies Rötzinghofen in Burscheid (Nr.1894-000)",
            "street": "Rötzinghofen 24",
            "house_number": "1",
            "zipcode": "51399",
            "city": "Burscheid",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1895-000",
            "name": "Hof Seidentopp in Salzgitter (Nr.1895-000)",
            "street": "Hohle Straße  18",
            "house_number": "1",
            "zipcode": "38239",
            "city": "Salzgitter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1896-000",
            "name": "Hof Hohenbrink in Warmsen (Nr.1896-000)",
            "street": "Heideweg 4",
            "house_number": "1",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1897-000",
            "name": "Hof Baum in Porta Westfalica (Nr.1897-000)",
            "street": "Schaumburger Straße 122",
            "house_number": "1",
            "zipcode": "32457",
            "city": "Porta Westfalica",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1898-000",
            "name": "Hof Palatzky in Maasen (Nr.1898-000)",
            "street": "Huckestedt",
            "house_number": "10",
            "zipcode": "27249",
            "city": "Maasen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1899-000",
            "name": "Päpsen in Siedenburg (Nr.1899-000)",
            "street": "Päpsen",
            "zipcode": "27254",
            "city": "Siedenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1900-000",
            "name": "Firma Dallmeier in Bekmünde (Nr.1900-000)",
            "street": "Kaempeweg",
            "house_number": "10",
            "zipcode": "25524",
            "city": "Bekmünde",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1901-000",
            "name": "Waldorfkindergarten Glücksburg e.V. in Glücksburg (Nr.1901-000)",
            "street": "Uferstraße",
            "house_number": "2",
            "zipcode": "24960",
            "city": "Glücksburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1902-000",
            "name": "Hof Beckmann in Bülkau in Bülkau (Nr.1902-000)",
            "street": "Norderende ",
            "house_number": "19",
            "zipcode": "21782",
            "city": "Bülkau",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-GI",
            "name": "Raiffeisen-Markt Gildehaus in Bad Bentheim-Gildehaus (Nr.RM-GI)",
            "street": "Ladestraße",
            "house_number": "3",
            "zipcode": "48455",
            "city": "Bad Bentheim-Gildehaus",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "RM-SCH",
            "name": "Raiffeisen-Markt Schüttorf in Schüttorf (Nr.RM-SCH)",
            "street": "Ohner Straße",
            "house_number": "24",
            "zipcode": "48465",
            "city": "Schüttorf",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "1903-000",
            "name": "Islandpferdehof Das Vertherland in Münster (Nr.1903-000)",
            "street": "Lützowstraße ",
            "house_number": "243",
            "zipcode": "48157",
            "city": "Münster",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1904-000",
            "name": "Hof Henrichmann in Greven (Nr.1904-000)",
            "street": "Bockholter Ring",
            "house_number": "17",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1905-000",
            "name": "Pferdepension Hüdepohl in Bissendorf (Nr.1905-000)",
            "street": "Auf der Heide",
            "house_number": "8a",
            "zipcode": "49143",
            "city": "Bissendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1906-000",
            "name": "Stall Andrea Grundei in Böhmte (Nr.1906-000)",
            "street": "Zum Elzsteg ",
            "house_number": "10",
            "zipcode": "49163",
            "city": "Böhmte",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1907-000",
            "name": "Hof Kroes  in Emmerich  (Nr.1907-000)",
            "street": "Tichelkamp ",
            "zipcode": "46446",
            "city": "Emmerich ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1908-000",
            "name": "Hof Rudde in Gronau-Epe (Nr.1908-000)",
            "street": "Füchte",
            "house_number": "12",
            "zipcode": "48599",
            "city": "Gronau-Epe",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1909-000",
            "name": "Hof Richter in Lastrup (Nr.1909-000)",
            "street": "Zur Heide",
            "zipcode": "49688",
            "city": "Lastrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1910-000",
            "name": "Hof Mißfeldt  in Tensbüttel-Röst (Nr.1910-000)",
            "street": "Redder ",
            "house_number": "3",
            "zipcode": "25767",
            "city": "Tensbüttel-Röst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1911-000",
            "name": "Hof Leifeld in Melle  (Nr.1911-000)",
            "street": "Zum Sportplatz",
            "house_number": "10",
            "zipcode": "49324",
            "city": "Melle ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1912-000",
            "name": "Hof Heiducoff in Steinhagen (Nr.1912-000)",
            "street": "Wallbrink",
            "house_number": "9",
            "zipcode": "33803",
            "city": "Steinhagen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1913-000",
            "name": "Hof Peolman in Ovelgönne (Nr.1913-000)",
            "street": "Winterbahn",
            "house_number": "84",
            "zipcode": "26939",
            "city": "Ovelgönne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1914-000",
            "name": "Gestüt Lütt Beek in Tremsbüttel (Nr.1914-000)",
            "street": "Grünengrase",
            "house_number": "2",
            "zipcode": "22967",
            "city": "Tremsbüttel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1915-000",
            "name": "Privatstall Erdmenger in Niederlangen (Nr.1915-000)",
            "street": "Haferkampstraße",
            "house_number": "8",
            "zipcode": "49779",
            "city": "Niederlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1916-000",
            "name": "Hof Ueffing in Neuenkirchen (Nr.1916-000)",
            "street": "Sutrum Harum",
            "house_number": "9",
            "zipcode": "48485",
            "city": "Neuenkirchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1917-000",
            "name": "Privatstall Quappen in Sögel (Nr.1917-000)",
            "street": "Industriestr.",
            "house_number": "6",
            "zipcode": "49751",
            "city": "Sögel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1918-000",
            "name": "Hof Tenne in Dülmen (Nr.1918-000)",
            "street": "Bauernschaft",
            "house_number": "42",
            "zipcode": "48249",
            "city": "Dülmen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1919-000",
            "name": "Hof Lüke in Welver Blumroth (Nr.1919-000)",
            "street": "Blumrother Straße",
            "house_number": "2",
            "zipcode": "59514",
            "city": "Welver Blumroth",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1920-000",
            "name": "Privatstall Weber Langen in Langen (Nr.1920-000)",
            "street": "Am Esch",
            "house_number": "4",
            "zipcode": "49838",
            "city": "Langen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1921-000",
            "name": "Hof Wulfsdorf in Probsteierhagen  (Nr.1921-000)",
            "street": "Hof Wulfsdorf",
            "house_number": "11",
            "zipcode": "24253",
            "city": "Probsteierhagen ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1922-000",
            "name": "Hof Meyer in Hamburg (Nr.1922-000)",
            "street": "Moorfleeter Deich",
            "house_number": "383",
            "zipcode": "22113",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1923-000",
            "name": "Hof Tobaben in Ahlerstedt (Nr.1923-000)",
            "street": "Mühlendamm",
            "house_number": "14",
            "zipcode": "21702",
            "city": "Ahlerstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1924-000",
            "name": "Hof Niederquell in Ehndorf (Nr.1924-000)",
            "street": "Hochmoor",
            "house_number": "2",
            "zipcode": "24647",
            "city": "Ehndorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1925-000",
            "name": "Privathof Horlamus in Hasbergen (Nr.1925-000)",
            "street": "Osnabrücker Straße",
            "house_number": "25",
            "zipcode": "49205",
            "city": "Hasbergen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-EL",
            "name": "Raiffeisen-Markt Emsbüren-Leschede in Emsbüren (Nr.RM-EL)",
            "street": "Bahnhofstraße ",
            "house_number": "73",
            "zipcode": "48488",
            "city": "Emsbüren",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "1926-000",
            "name": "Privathof Wiltfang in Ganderkesee  (Nr.1926-000)",
            "street": "Kehnmoorweg ",
            "house_number": "30",
            "zipcode": "27777",
            "city": "Ganderkesee ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1927-000",
            "name": "Privathof Moldenhauer in Steinfurt (Nr.1927-000)",
            "street": "Hollich",
            "house_number": "78",
            "zipcode": "48565",
            "city": "Steinfurt",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1928-000",
            "name": "Reiterhof kleine Mücke in Aurich (Nr.1928-000)",
            "street": "Stiekelriegweg",
            "house_number": "23",
            "zipcode": "26607",
            "city": "Aurich",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1929-000",
            "name": "Privathof Koch in Spelle (Nr.1929-000)",
            "street": "Wällkenstraße",
            "house_number": "59",
            "zipcode": "48480",
            "city": "Spelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1930-000",
            "name": "Privathof Hornbostel in Hambühren (Nr.1930-000)",
            "street": "Oheweg",
            "house_number": "3",
            "zipcode": "29313",
            "city": "Hambühren",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1931-000",
            "name": "Privathof Bushe in Vaale (Nr.1931-000)",
            "street": "Mühlenweg",
            "house_number": "7B",
            "zipcode": "25594",
            "city": "Vaale",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1932-000",
            "name": "Privathof Weies in Krefeld (Nr.1932-000)",
            "street": "Hauptstraße",
            "house_number": "356",
            "zipcode": "47809",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1933-000",
            "name": "Privathof Baé in Neuenkirchen (Nr.1933-000)",
            "street": "Herteler Straße",
            "house_number": "24",
            "zipcode": "29643",
            "city": "Neuenkirchen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1934-000",
            "name": "Pferdepension Lück in Schwarme (Nr.1934-000)",
            "street": "Beppener Straße",
            "house_number": "14",
            "zipcode": "27327",
            "city": "Schwarme",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1935-000",
            "name": "Privathof Feddersen in Simonsberg (Nr.1935-000)",
            "street": "Hauptstraße",
            "house_number": "9",
            "zipcode": "25813",
            "city": "Simonsberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1936-000",
            "name": "Hof Marth in Spangenberg (Nr.1936-000)",
            "street": "Schulstraße",
            "house_number": "8",
            "zipcode": "34286",
            "city": "Spangenberg",
            "state": "Hessen",
            "collect_point": "nein"
        },
        {
            "ID": "1937-000",
            "name": "Privathof Ammerland in Wiefelstede (Nr.1937-000)",
            "street": "Wiefelsteder Straße",
            "house_number": "41",
            "zipcode": "26215",
            "city": "Wiefelstede",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1938-000",
            "name": "Pferdepension Giebel in Lamstedt (Nr.1938-000)",
            "street": "Ehlanddamm",
            "house_number": "3",
            "zipcode": "21769",
            "city": "Lamstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1939-000",
            "name": "Privathof Slotala in Reichshof (Nr.1939-000)",
            "street": "Am Nussbaum",
            "house_number": "7",
            "zipcode": "51580",
            "city": "Reichshof",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1940-000",
            "name": "Privathof Freytag in Gehrde (Nr.1940-000)",
            "street": "Neuenkirchener Straße ",
            "house_number": "15",
            "zipcode": "49596",
            "city": "Gehrde",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1941-000",
            "name": "Privathof Quandt in Otter (Nr.1941-000)",
            "street": "Weller Straße",
            "house_number": "40",
            "zipcode": "21259",
            "city": "Otter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1942-000",
            "name": "Privathof Kahlert in Schalksmühle (Nr.1942-000)",
            "street": "Muhle ",
            "house_number": "13",
            "zipcode": "58579",
            "city": "Schalksmühle",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1943-000",
            "name": "Privat Freiburg in Verl (Nr.1943-000)",
            "street": "Teutoburger Straße",
            "house_number": "53",
            "zipcode": "33415",
            "city": "Verl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1944-000",
            "name": "TuS Gahlen / Hildebrandt  in Schermbeck (Nr.1944-000)",
            "street": "Im Aap",
            "house_number": "53",
            "zipcode": "46514",
            "city": "Schermbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1945-000",
            "name": "Privathof Pattberg in Jagel (Nr.1945-000)",
            "street": "Eichenweg",
            "house_number": "2",
            "zipcode": "24878",
            "city": "Jagel",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1946-000",
            "name": "Schleinershof in Havixbeck (Nr.1946-000)",
            "street": "Herkentrup",
            "house_number": "6",
            "zipcode": "48329",
            "city": "Havixbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1947-000",
            "name": "Privatstall Jiske in Groß Rheide (Nr.1947-000)",
            "street": "Wieder Weg",
            "house_number": "7c",
            "zipcode": "24872",
            "city": "Groß Rheide",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1948-000",
            "name": "Power of Iceland in Neuenkirchen (Nr.1948-000)",
            "street": "Herteler Straße",
            "house_number": "24",
            "zipcode": "29643",
            "city": "Neuenkirchen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1949-000",
            "name": "Thomashof in Schneverdingen/Wessloh (Nr.1949-000)",
            "street": "Maatheide",
            "house_number": "10",
            "zipcode": "29640",
            "city": "Schneverdingen/Wessloh",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1950-000",
            "name": "Privathof Froese in Ostercappeln (Nr.1950-000)",
            "street": "Mönkehöfener Straße",
            "house_number": "15",
            "zipcode": "49179",
            "city": "Ostercappeln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1951-000",
            "name": "Privathof Wiechert in Holste (Nr.1951-000)",
            "street": "Stedener Str.",
            "house_number": "12",
            "zipcode": "27729",
            "city": "Holste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1952-000",
            "name": "Privathof Reineke in Steinfeld (Nr.1952-000)",
            "street": "Holdorfer Str.",
            "house_number": "4",
            "zipcode": "49439",
            "city": "Steinfeld",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1953-000",
            "name": "Reit- und Ponyhof Liesen in Dinslaken (Nr.1953-000)",
            "street": "Lingelmannstr.",
            "house_number": "171",
            "zipcode": "46539",
            "city": "Dinslaken",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1954-000",
            "name": "Privathof Warneke in Varrel (Nr.1954-000)",
            "street": "Dörrieloh ",
            "house_number": "12",
            "zipcode": "27259",
            "city": "Varrel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1955-000",
            "name": "Tierheilpraxis Behrens in Sassenburg (Nr.1955-000)",
            "street": "Dorfstr.",
            "house_number": "159",
            "zipcode": "38524",
            "city": "Sassenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1956-000",
            "name": "Privatstall Pfennig in Voerde (Nr.1956-000)",
            "street": "Mehrumer Str.",
            "house_number": "86",
            "zipcode": "46562",
            "city": "Voerde",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1957-000",
            "name": "Privatstall Winterhoff in Faßberg (Nr.1957-000)",
            "street": "Im Mittelstendorf",
            "house_number": "56",
            "zipcode": "29328",
            "city": "Faßberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1958-000",
            "name": "Privatstall Henck in Seedorf (Nr.1958-000)",
            "street": "Kukuk ",
            "house_number": "8",
            "zipcode": "23823",
            "city": "Seedorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1959-000",
            "name": "Gestüt Papenhorst in Edemissen (Nr.1959-000)",
            "street": "Papenhorst",
            "house_number": "2",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1960-000",
            "name": "Reitstall Grimm in Hamburg (Nr.1960-000)",
            "street": "Bremer Str.",
            "house_number": "391",
            "zipcode": "21077",
            "city": "Hamburg",
            "state": "Hamburg",
            "collect_point": "nein"
        },
        {
            "ID": "1961-000",
            "name": "Privathof Böttcher in Billerbeck  (Nr.1961-000)",
            "street": "Gantweg",
            "house_number": "27",
            "zipcode": "483727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1962-000",
            "name": "Gut Großeforst in Düsseldorf (Nr.1962-000)",
            "street": "Forster Weg",
            "house_number": "46",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1963-000",
            "name": "Privathof Plett in Vollstedt (Nr.1963-000)",
            "street": "Ole Landstraat",
            "house_number": "3",
            "zipcode": "25821",
            "city": "Vollstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1964-000",
            "name": "Privathof Schaffer in Handewitt  (Nr.1964-000)",
            "street": "Lecker Chaussee ",
            "house_number": "46",
            "zipcode": "24983",
            "city": "Handewitt ",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1965-000",
            "name": "Wittes Reitanlage in Riede (Nr.1965-000)",
            "street": "Thedinghauser Str.",
            "house_number": "49",
            "zipcode": "27339",
            "city": "Riede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1966-000",
            "name": "Hof Niekamp in Berne (Nr.1966-000)",
            "street": "Lechterstr.",
            "house_number": "178",
            "zipcode": "27804",
            "city": "Berne",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1967-000",
            "name": "VRZ Schöppingen  in Schöppingen (Nr.1967-000)",
            "street": "Heven",
            "house_number": "74",
            "zipcode": "48624",
            "city": "Schöppingen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1968-000",
            "name": "Mindener Pferdezucht Reit und Fahrverein e.V. in Minden (Nr.1968-000)",
            "street": "Mitteldamm",
            "house_number": "80",
            "zipcode": "32427",
            "city": "Minden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1969-000",
            "name": "Privatstall Kruth in Lähden (Nr.1969-000)",
            "street": "Berßener Straße",
            "house_number": "48",
            "zipcode": "49774",
            "city": "Lähden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1970-000",
            "name": "Privatstall Pottmeyer in Saerbeck (Nr.1970-000)",
            "street": "Westladbergen ",
            "house_number": "112",
            "zipcode": "48369",
            "city": "Saerbeck",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1971-000",
            "name": "Privatstall Kruse in Warder (Nr.1971-000)",
            "street": "Hauptstr.",
            "house_number": "1",
            "zipcode": "24646",
            "city": "Warder",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1972-000",
            "name": "Reitanlage Stoerblick in Arpsdorf (Nr.1972-000)",
            "street": "Dorfstraße",
            "house_number": "38",
            "zipcode": "24634",
            "city": "Arpsdorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1973-000",
            "name": "Privathof Lorenz in Jesteburg (Nr.1973-000)",
            "street": "Pferdeweg",
            "house_number": "41",
            "zipcode": "21266",
            "city": "Jesteburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1974-000",
            "name": "Privathof Driehorst in Büren (Nr.1974-000)",
            "street": "Sehrweg",
            "house_number": "1",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1975-000",
            "name": "Therapiehof Immenstedt in Immenstedt (Nr.1975-000)",
            "street": "Hauptstraße",
            "house_number": "5",
            "zipcode": "25767",
            "city": "Immenstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1976-000",
            "name": "Hof Hobbeling in Everswinkel (Nr.1976-000)",
            "street": "Schulter ",
            "house_number": "20",
            "zipcode": "48351",
            "city": "Everswinkel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1977-000",
            "name": "Hof Kamps in Cuxhaven (Nr.1977-000)",
            "street": "Abschnede",
            "house_number": "179",
            "zipcode": "27472",
            "city": "Cuxhaven",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1978-000",
            "name": "Hof Rentrop in Werdohl (Nr.1978-000)",
            "street": "Rentrop",
            "house_number": "3",
            "zipcode": "58791",
            "city": "Werdohl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1979-000",
            "name": "Privathof Hansen in Mittelangeln (Nr.1979-000)",
            "street": "Kirchenholz",
            "house_number": "6",
            "zipcode": "24986",
            "city": "Mittelangeln",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1980-000",
            "name": "Privathof Golz in Meerbusch (Nr.1980-000)",
            "street": "Am oberen Feld",
            "house_number": "67",
            "zipcode": "47809",
            "city": "Meerbusch",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1981-000",
            "name": "Stall Schnackenberg in Worpswede (Nr.1981-000)",
            "street": "Ostersoder Straße",
            "house_number": "19",
            "zipcode": "27726",
            "city": "Worpswede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1982-000",
            "name": "Privathof Deparade in Issum (Nr.1982-000)",
            "street": "Weseler Straße",
            "house_number": "247",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1983-000",
            "name": "Privathof Rulfs in Winsen (Nr.1983-000)",
            "street": "Hoopter Straße",
            "house_number": "189",
            "zipcode": "21423",
            "city": "Winsen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1984-000",
            "name": "Privathof Petra Vogel in Wenzendorf (Nr.1984-000)",
            "street": "Am Schulberg",
            "house_number": "7",
            "zipcode": "21279",
            "city": "Wenzendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1985-000",
            "name": "Privathof Muno in Jüchen (Nr.1985-000)",
            "street": "Hensenhof",
            "house_number": "1",
            "zipcode": "41363",
            "city": "Jüchen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1986-000",
            "name": "Hof Arenskötter in Greven (Nr.1986-000)",
            "street": "Fuestruper Straße",
            "house_number": "81",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1987-000",
            "name": "Reitanlage Selter in Dortmund (Nr.1987-000)",
            "street": "Wulfskamp ",
            "house_number": "194",
            "zipcode": "44339",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1988-000",
            "name": "Privathof Hein in Edemissen (Nr.1988-000)",
            "street": "Tiefe Straße",
            "house_number": "11",
            "zipcode": "31234",
            "city": "Edemissen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1989-000",
            "name": "Privathof Teichmann in Rabenkirchen- Faulück (Nr.1989-000)",
            "street": "Rabenkirchenholz ",
            "house_number": "20",
            "zipcode": "24407",
            "city": "Rabenkirchen- Faulück",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "1990-000",
            "name": "Privathof Vogel in Recklinghausen (Nr.1990-000)",
            "street": "Reiffstraße",
            "house_number": "43",
            "zipcode": "45659",
            "city": "Recklinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1991-000",
            "name": "Stallgemeinschaft Gut Holthausen in Büren (Nr.1991-000)",
            "street": "Brilonerstraße",
            "house_number": "80",
            "zipcode": "33142",
            "city": "Büren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1992-000",
            "name": "Reiterhof Merreter in Mönchengladbach (Nr.1992-000)",
            "street": "Merreter",
            "house_number": "11",
            "zipcode": "41179",
            "city": "Mönchengladbach",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1993-000",
            "name": "Privathof Feldt in Lingen  (Nr.1993-000)",
            "street": "Unter den Eichen",
            "house_number": "1",
            "zipcode": "49809",
            "city": "Lingen ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1994-000",
            "name": "AS Trainings und Ausbildungsstall  in Hamm  (Nr.1994-000)",
            "street": "Alte Freisker Str.",
            "house_number": "14",
            "zipcode": "59069",
            "city": "Hamm ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1995-000",
            "name": "Offenstall Diana in Burgdorf (Nr.1995-000)",
            "street": "Schwarzer Berg",
            "house_number": "6",
            "zipcode": "31303",
            "city": "Burgdorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1996-000",
            "name": "Privathof Karlovits in Rötgesbüttel  (Nr.1996-000)",
            "street": "Altes Hohes Feld",
            "house_number": "4",
            "zipcode": "38518",
            "city": "Rötgesbüttel ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1997-000",
            "name": "Reitstall Gut Haus Mahnert in Erkrath (Nr.1997-000)",
            "street": "Mahnert",
            "house_number": "7",
            "zipcode": "40699",
            "city": "Erkrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "1998-000",
            "name": "Westernplaats  in Norden (Nr.1998-000)",
            "street": "Polderweg ",
            "house_number": "1a",
            "zipcode": "26506",
            "city": "Norden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "1999-000",
            "name": "Reitstall Todenmann in Rinteln (Nr.1999-000)",
            "street": "Hauptstraße",
            "house_number": "34",
            "zipcode": "31737",
            "city": "Rinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2000-000",
            "name": "Privathof Vogl in Achtrup (Nr.2000-000)",
            "street": "Tweng",
            "house_number": "22",
            "zipcode": "25917",
            "city": "Achtrup",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2001-000",
            "name": "Privathof Schrader in Ibbenbüren (Nr.2001-000)",
            "street": "Am Berg",
            "house_number": "1",
            "zipcode": "49479",
            "city": "Ibbenbüren",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2002-000",
            "name": "Privathof Wiederspahn in Schwarmstedt (Nr.2002-000)",
            "street": "Am Hohen Ufer",
            "house_number": "6",
            "zipcode": "29690",
            "city": "Schwarmstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2003-000",
            "name": "Privathof Hoffmann in Haaßel (Nr.2003-000)",
            "street": "Zur Sandkuhle",
            "house_number": "1",
            "zipcode": "27446",
            "city": "Haaßel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2004-000",
            "name": "Rubinhof in Schafstedt (Nr.2004-000)",
            "street": "Nordholz",
            "house_number": "6",
            "zipcode": "25725",
            "city": "Schafstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2005-000",
            "name": "Hof Hagedorn in Glandorf (Nr.2005-000)",
            "street": "Kattenvennerstraße",
            "house_number": "37",
            "zipcode": "49219",
            "city": "Glandorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2006-000",
            "name": "Privathof Haschmann in Lüdinghausen (Nr.2006-000)",
            "street": "Ondrup",
            "house_number": "30",
            "zipcode": "59348",
            "city": "Lüdinghausen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2007-000",
            "name": "Privathof Heiderhoff in Mettmann (Nr.2007-000)",
            "street": "Außenbürgerschaft",
            "house_number": "7",
            "zipcode": "40822",
            "city": "Mettmann",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2008-000",
            "name": "Privathof Sturm in Otter (Nr.2008-000)",
            "street": "Dorfstraße",
            "house_number": "13",
            "zipcode": "21259",
            "city": "Otter",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2009-000",
            "name": "Privathof Köhler in Bötersen (Nr.2009-000)",
            "street": "Höperhöfen",
            "house_number": "7",
            "zipcode": "27367",
            "city": "Bötersen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2010-000",
            "name": "Reitverein Coldewey in Sulingen (Nr.2010-000)",
            "street": "Coldewey",
            "house_number": "1",
            "zipcode": "27232",
            "city": "Sulingen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2011-000",
            "name": "Reiterhof Groß Parin in Bad Schwartau (Nr.2011-000)",
            "street": "Groß Parin",
            "house_number": "35",
            "zipcode": "23611",
            "city": "Bad Schwartau",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2012-000",
            "name": "Hermann Gösmeier in Marl (Nr.2012-000)",
            "street": "Obersinsener Straße",
            "house_number": "74",
            "zipcode": "45770",
            "city": "Marl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2013-000",
            "name": "Sternenhof in Wingst (Nr.2013-000)",
            "street": "Bargkampsweg",
            "house_number": "40",
            "zipcode": "21789",
            "city": "Wingst",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2014-000",
            "name": "Privathof Bachmann in Salzhausen (Nr.2014-000)",
            "street": "Bruchweg",
            "house_number": "1",
            "zipcode": "21376",
            "city": "Salzhausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2015-000",
            "name": "Ferienhod Steinbruch in Wietzendorf (Nr.2015-000)",
            "street": "Steinbruch",
            "house_number": "81",
            "zipcode": "29649",
            "city": "Wietzendorf",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2016-000",
            "name": "Privathof Sander in Rahden (Nr.2016-000)",
            "street": "Varler Straße",
            "house_number": "43",
            "zipcode": "32369",
            "city": "Rahden",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2017-000",
            "name": "Hengststation Beckmann in Wettringen (Nr.2017-000)",
            "street": "Aabauerschaft",
            "house_number": "15",
            "zipcode": "48493",
            "city": "Wettringen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2018-000",
            "name": "Privathof Eilers in Hesel (Nr.2018-000)",
            "street": "Kirchstraße",
            "house_number": "79",
            "zipcode": "26835",
            "city": "Hesel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2019-000",
            "name": "Privathof Hopmann in Handrup (Nr.2019-000)",
            "street": "Am Enekamp",
            "house_number": "2B",
            "zipcode": "49838",
            "city": "Handrup",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2020-000",
            "name": "Privathof Engbers in Breddenberg (Nr.2020-000)",
            "street": "Am Koopmannsberg",
            "house_number": "19",
            "zipcode": "26897",
            "city": "Breddenberg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2021-000",
            "name": "Privathof Helmer in Emsdetten (Nr.2021-000)",
            "street": "Austum",
            "house_number": "43",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2022-000",
            "name": "Pine Alley Ranch in Escheburg (Nr.2022-000)",
            "street": "Kiefernweg",
            "house_number": "58",
            "zipcode": "21039",
            "city": "Escheburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2023-000",
            "name": "Tungerloh-Capellen 101 in Gescher (Nr.2023-000)",
            "street": "Tungerloh-Capellen ",
            "house_number": "101",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2024-000",
            "name": "Hof Raabe in Brekendorf (Nr.2024-000)",
            "street": "Dorfstraße",
            "house_number": "97",
            "zipcode": "24811",
            "city": "Brekendorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2025-000",
            "name": "Shagyas and Friends  in Langenhagen (Nr.2025-000)",
            "street": "Walsroder Str",
            "house_number": "228",
            "zipcode": "30853",
            "city": "Langenhagen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2026-000",
            "name": "Reitstall Neben Heinrichshof (liegt in der Kurve) in Krefeld (Nr.2026-000)",
            "street": "Hökendyk",
            "house_number": "2",
            "zipcode": "47802",
            "city": "Krefeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2027-000",
            "name": "Bewegungsstall Sandbochum  in Hamm (Nr.2027-000)",
            "street": "Eckernkamp",
            "house_number": "10",
            "zipcode": "59077",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2028-000",
            "name": "Privathof Weith in Dörpum (Nr.2028-000)",
            "street": "Osterende",
            "house_number": "15",
            "zipcode": "25821",
            "city": "Dörpum",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2029-000",
            "name": "Privathof Kleine in Eydelstedt (Nr.2029-000)",
            "street": "Dörpel",
            "house_number": "11F",
            "zipcode": "49406",
            "city": "Eydelstedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2030-000",
            "name": "Pferdehof Eichenhain in Bottrop (Nr.2030-000)",
            "street": "Im Loh ",
            "house_number": "24",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2031-000",
            "name": "Privathof Schilling in Hatten (Nr.2031-000)",
            "street": "Im Häsen",
            "house_number": "1",
            "zipcode": "26209",
            "city": "Hatten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2032-000",
            "name": "Privathof Wilms in Heinsberg  (Nr.2032-000)",
            "street": "Zedernstraße",
            "house_number": "13",
            "zipcode": "52525",
            "city": "Heinsberg ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2033-000",
            "name": "Lindenallee in Coesfeld (Nr.2033-000)",
            "street": "Lindenallee",
            "house_number": "67",
            "zipcode": "48653",
            "city": "Coesfeld",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2034-000",
            "name": "Hof Mecklenburg in Norderstedt (Nr.2034-000)",
            "street": "Rantzauer Forstweg",
            "house_number": "21",
            "zipcode": "22850",
            "city": "Norderstedt",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2035-000",
            "name": "Burglager Mühle in Rhauderfehn (Nr.2035-000)",
            "street": "Landesstraße",
            "house_number": "60",
            "zipcode": "26817",
            "city": "Rhauderfehn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2036-000",
            "name": " in  (Nr.2036-000)",
            "collect_point": "nein"
        },
        {
            "ID": "2037-000",
            "name": "Privathof van Acken in Hohenhameln (Nr.2037-000)",
            "street": "Osterstraße",
            "house_number": "6",
            "zipcode": "31249",
            "city": "Hohenhameln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2038-000",
            "name": "Süderhof Nordstrand - Elisabeth Sophien Koog in Elisabeth-Sophien-Koog (Nr.2038-000)",
            "street": "Elisabeth-sophien-koog",
            "house_number": "14",
            "zipcode": "25845",
            "city": "Elisabeth-Sophien-Koog",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2039-000",
            "name": "Double D Ranch in Olfen (Nr.2039-000)",
            "street": "Schaafhausen",
            "house_number": "2",
            "zipcode": "59399",
            "city": "Olfen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2040-000",
            "name": "Reitstall Hucklenbroich in Düsseldorf (Nr.2040-000)",
            "street": "Dorper Weg ",
            "house_number": "22",
            "zipcode": "40629",
            "city": "Düsseldorf",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2041-000",
            "name": "Abtsküche in Heiligenhaus (Nr.2041-000)",
            "street": "Abtskücher Straße",
            "house_number": "40",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2042-000",
            "name": "Hof Hartger in Nordhorn (Nr.2042-000)",
            "street": "Petkuser Straße",
            "house_number": "30",
            "zipcode": "48529",
            "city": "Nordhorn",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2043-000",
            "name": "TIERischgutdrauf in Rehburg-Loccum  (Nr.2043-000)",
            "street": "Preußische Straße",
            "house_number": "25",
            "zipcode": "31547",
            "city": "Rehburg-Loccum ",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2044-000",
            "name": "Privathof Robben-Zickerick in Niederlangen (Nr.2044-000)",
            "street": "Haferkampstraße",
            "house_number": "3",
            "zipcode": "49779",
            "city": "Niederlangen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2045-000",
            "name": "Privathof Krüger in Pinneberg (Nr.2045-000)",
            "street": "Voßhörn",
            "house_number": "31",
            "zipcode": "25421",
            "city": "Pinneberg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2046-000",
            "name": "Gestüt Hohenschmark in Grebin (Nr.2046-000)",
            "street": "Hohenschmark",
            "house_number": "1",
            "zipcode": "24329",
            "city": "Grebin",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2047-000",
            "name": "Schoenges Hof Pesch in Korschenbroich (Nr.2047-000)",
            "street": "Liedberger Straße ",
            "house_number": "29",
            "zipcode": "41352",
            "city": "Korschenbroich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2048-000",
            "name": "Reitstall Siemes in Viersen (Nr.2048-000)",
            "street": "Omperterweg",
            "house_number": "107",
            "zipcode": "41748",
            "city": "Viersen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2049-000",
            "name": "Privathof Hopf in Altenberge (Nr.2049-000)",
            "street": "Westenfeld",
            "house_number": "163",
            "zipcode": "48341",
            "city": "Altenberge",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2050-000",
            "name": "Privathof Grüner in Rosendahl (Nr.2050-000)",
            "street": "Hegerort ",
            "house_number": "16",
            "zipcode": "48720",
            "city": "Rosendahl",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2051-000",
            "name": "Privathof Kanschat in Papenburg (Nr.2051-000)",
            "street": "Lüchtenburg Links",
            "house_number": "19",
            "zipcode": "26810",
            "city": "Papenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2052-000",
            "name": "Im Sundern in Fröndenberg (Nr.2052-000)",
            "street": "Im Sundern",
            "house_number": "7",
            "zipcode": "58730",
            "city": "Fröndenberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2053-000",
            "name": "Hof Westermann in Hörstel (Nr.2053-000)",
            "street": "Jacksonweg",
            "house_number": "215",
            "zipcode": "48477",
            "city": "Hörstel",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2054-000",
            "name": "Hof Edler in Seelze (Nr.2054-000)",
            "street": "Kirchbuschweg",
            "house_number": "1",
            "zipcode": "30926",
            "city": "Seelze",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2055-000",
            "name": "Privathof Ahrens-Urbanek in Warendorf  (Nr.2055-000)",
            "street": "Neuwarendorf ",
            "house_number": "2",
            "zipcode": "48231",
            "city": "Warendorf ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2056-000",
            "name": "Privathof Leußink in Heek (Nr.2056-000)",
            "street": "Wext",
            "house_number": "20",
            "zipcode": "48619",
            "city": "Heek",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2057-000",
            "name": "Privathof Dettmer in Ahlden (Nr.2057-000)",
            "street": "Eilter Dorfstraße",
            "house_number": "36a",
            "zipcode": "29693",
            "city": "Ahlden",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2058-000",
            "name": "Privathof Grajczyk in Apen (Nr.2058-000)",
            "street": "Aperstraße",
            "house_number": "55",
            "zipcode": "26689",
            "city": "Apen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2059-000",
            "name": "Gut Osterberge Gödde in Dortmund (Nr.2059-000)",
            "street": "Osterberger Straße",
            "house_number": "19",
            "zipcode": "44289",
            "city": "Dortmund",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2060-000",
            "name": "Stall Niehues in Gescher (Nr.2060-000)",
            "street": "Tungerloh-Capellen",
            "house_number": "47",
            "zipcode": "48712",
            "city": "Gescher",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2061-000",
            "name": "Privathof Dieler in Rinteln (Nr.2061-000)",
            "street": "Immensiek",
            "house_number": "20",
            "zipcode": "31737",
            "city": "Rinteln",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2062-000",
            "name": "Reitstall Hans Lugge - Brautkutschenverleih in Mülheim an der Ruhr (Nr.2062-000)",
            "street": "Gänseweg ",
            "house_number": "80",
            "zipcode": "45475",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2063-000",
            "name": "Reithof Schlichte in Blomberg (Nr.2063-000)",
            "street": "Hiddensen ",
            "house_number": "22",
            "zipcode": "32825",
            "city": "Blomberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2064-000",
            "name": "Privathof Gebauer in Wülfrath (Nr.2064-000)",
            "street": "Bergstraße",
            "house_number": "62",
            "zipcode": "42489",
            "city": "Wülfrath",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2065-000",
            "name": "Pferdehof Jansen in Wegberg (Nr.2065-000)",
            "street": "Marienstraße ",
            "house_number": "62",
            "zipcode": "41844",
            "city": "Wegberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2066-000",
            "name": "Privathof Horst in Kempen (Nr.2066-000)",
            "street": "Lötschenweg ",
            "house_number": "34",
            "zipcode": "47906",
            "city": "Kempen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2067-000",
            "name": "Privathof Werner  in Billerbeck  (Nr.2067-000)",
            "street": "Aulendorf ",
            "house_number": "5",
            "zipcode": "48727",
            "city": "Billerbeck ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2068-000",
            "name": "Zuchthof Harder-Brune in Bramsche (Nr.2068-000)",
            "street": "Am Stroher Feld",
            "house_number": "3",
            "zipcode": "49565",
            "city": "Bramsche",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2069-000",
            "name": "Twietenhof Privatstall in Basedow (Nr.2069-000)",
            "street": "Twieten",
            "house_number": "14",
            "zipcode": "21483",
            "city": "Basedow",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2070-000",
            "name": "Privathof Rüdel in Bottrop (Nr.2070-000)",
            "street": "Forststraße ",
            "house_number": "2",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2071-000",
            "name": "Privathof Müller in Stelle (Nr.2071-000)",
            "street": "Büllhorner Weg",
            "house_number": "64",
            "zipcode": "21435",
            "city": "Stelle",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2072-000",
            "name": "Privathof Fabek in Essen (Nr.2072-000)",
            "street": "Eststraße",
            "house_number": "150",
            "zipcode": "45149",
            "city": "Essen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2073-000",
            "name": "Privathof Klute in Medelby (Nr.2073-000)",
            "street": "Maiholm",
            "house_number": "1",
            "zipcode": "24994",
            "city": "Medelby",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2074-000",
            "name": "Reit- und Pensionsstall Missfeldt  in Tensbüttel-Röst (Nr.2074-000)",
            "street": "Redder ",
            "house_number": "3",
            "zipcode": "25767",
            "city": "Tensbüttel-Röst",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2075-000",
            "name": "Privathof Kienbaum in Lengerich (Nr.2075-000)",
            "street": "Kellerskamp",
            "house_number": "27",
            "zipcode": "49525",
            "city": "Lengerich",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2076-000",
            "name": "Reitverein Sieversen in Rosengarten (Nr.2076-000)",
            "street": "Schwarzer Weg",
            "house_number": "1",
            "zipcode": "21224",
            "city": "Rosengarten",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2077-000",
            "name": "Privathof Lichtenthäler in Heiligenhaus (Nr.2077-000)",
            "street": "Rolland",
            "house_number": "25",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2078-000",
            "name": "Privathof Bonna in Bottrop (Nr.2078-000)",
            "street": "Hiesfelderstraße",
            "house_number": "25",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2079-000",
            "name": "Hof Auberg in Mülheim an der Ruhr (Nr.2079-000)",
            "street": "Voßbeckstraße",
            "house_number": "169",
            "zipcode": "45481",
            "city": "Mülheim an der Ruhr",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2080-000",
            "name": "Privathod Bulitta in Dorsten (Nr.2080-000)",
            "street": "Speckinger Weg",
            "house_number": "91",
            "zipcode": "46286",
            "city": "Dorsten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2081-000",
            "name": "Kinderhof Wehde in Zetel (Nr.2081-000)",
            "street": "Spolsener Moorstraße",
            "house_number": "23",
            "zipcode": "36340",
            "city": "Zetel",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2082-000",
            "name": "Hof Broeker in Schloß Holte-Stukenbrock  (Nr.2082-000)",
            "street": "Lange Straße ",
            "house_number": "2",
            "zipcode": "33758",
            "city": "Schloß Holte-Stukenbrock ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2083-000",
            "name": "Reitanlage Johannsen in Tornesch (Nr.2083-000)",
            "street": "Ahrenloher Str.",
            "house_number": "127",
            "zipcode": "25435",
            "city": "Tornesch",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2084-000",
            "name": "Privathof Strothenke in Gütersloh (Nr.2084-000)",
            "street": "Paulusweg",
            "house_number": "13",
            "zipcode": "33335",
            "city": "Gütersloh",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2085-000",
            "name": "Reitstall Petersen in Henstedt Ulzburg (Nr.2085-000)",
            "street": "Buschkoppel",
            "house_number": "2",
            "zipcode": "24558",
            "city": "Henstedt Ulzburg",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2086-000",
            "name": "Privathof Schwarze in Lohne (Oldenburg) (Nr.2086-000)",
            "street": "Feldweg ",
            "house_number": "4",
            "zipcode": "49393",
            "city": "Lohne (Oldenburg)",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2087-000",
            "name": "Reiterhof Geyer in Tostedt (Nr.2087-000)",
            "street": "Riepshof",
            "house_number": "9",
            "zipcode": "21255",
            "city": "Tostedt",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2088-000",
            "name": "Privathof Leibrich-Brünings in Stuhr (Nr.2088-000)",
            "street": "Bürsteler Straße",
            "house_number": "75",
            "zipcode": "28816",
            "city": "Stuhr",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2089-000",
            "name": "Privathof Kranemann in Unna (Nr.2089-000)",
            "street": "Iserlohnerstraße ",
            "house_number": "123",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2090-000",
            "name": "Privathof Bischoff in Schwanewede (Nr.2090-000)",
            "street": "Mühlenweg",
            "house_number": "28",
            "zipcode": "28790",
            "city": "Schwanewede",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2091-000",
            "name": "Hof Mißfeldt in Nindorf (Nr. 2091-000)",
            "street": "Möhlenkamp",
            "house_number": "4",
            "zipcode": "24594",
            "city": "Nindorf",
            "state": "Schleswig-Holstein",
            "collect_point": "nein"
        },
        {
            "ID": "2092-000",
            "name": "Hof Wieschues in Ahlen-Dolberg (Nr.2092-000)",
            "street": "Auf dem Sichter ",
            "house_number": "1",
            "zipcode": "59229",
            "city": "Ahlen-Dolberg",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2093-000",
            "name": "Hof Greiling in Emsdetten (Nr.2093-000)",
            "street": "Up'm Mersk ",
            "house_number": "2",
            "zipcode": "48282",
            "city": "Emsdetten",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2094-000",
            "name": "Privathof Eichberger in Hagenburg (Nr.2094-000)",
            "street": "Im Wiesengrund",
            "house_number": "6",
            "zipcode": "31558",
            "city": "Hagenburg",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2095-000",
            "name": "Reit- und Fahrverein Bottrop in Bottrop (Nr.2095-000)",
            "street": "Beisenstraße",
            "house_number": "18",
            "zipcode": "46242",
            "city": "Bottrop ",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2096-000",
            "name": "Stall Hoff in Ladbergen (Nr.2096-000)",
            "street": "Kuhweg",
            "house_number": "9",
            "zipcode": "49549",
            "city": "Ladbergen",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2097-000",
            "name": "Privathof Wüstefeld in Thedinghausen (Nr.2097-000)",
            "street": "Dibberser Dorfstraße",
            "house_number": "3",
            "zipcode": "27321",
            "city": "Thedinghausen",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "2098-000",
            "name": "Reitanlage Gut Vogelbusch in Heiligenhausen (Nr.2098-000)",
            "street": "Gut Vogelbusch",
            "house_number": "26",
            "zipcode": "42579",
            "city": "Heiligenhaus",
            "state": "Nordrhein-Westfalen",
            "collect_point": "nein"
        },
        {
            "ID": "2099-000",
            "name": "HorseAirium Rieste in Rieste (Nr.2099-000)",
            "street": "Hasekamps-Boll ",
            "house_number": "9",
            "zipcode": "49597",
            "city": "Rieste",
            "state": "Niedersachsen",
            "collect_point": "nein"
        },
        {
            "ID": "RM-BB",
            "name": "Raiffeisen-Markt Bückeburg in Bückeburg (Nr.RM-BB)",
            "street": "Kreuzbreite",
            "house_number": "6",
            "zipcode": "31675",
            "city": "Bückeburg",
            "state": "Niedersachsen",
            "collect_point": "ja"
        },
        {
            "ID": "2100-000",
            "name": "Bredenbeck Stall",
            "street": "Steinkrügerweg ",
            "house_number": "50",
            "zipcode": "30974",
            "city": "Wennigsen (Deister)",
            "state": "Niedersachsen"
        },
        {
            "ID": "2101-000",
            "name": "Privathof Beuck",
            "street": "Klint",
            "house_number": "44a",
            "zipcode": "24800",
            "city": "Elsdorf-westermühlen",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2102-000",
            "name": "Gestüt Lohhof",
            "street": "Lohhof",
            "house_number": "14",
            "zipcode": "31600",
            "city": "Uchte",
            "state": "Niedersachsen"
        },
        {
            "ID": "2103-000",
            "name": "Privathof Grosse-Berkhoff",
            "street": "Soester Straße",
            "house_number": "405",
            "zipcode": "59071",
            "city": "Hamm",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2104-000",
            "name": "Privathof Wetzel",
            "street": "Uelzener Straße",
            "house_number": "24",
            "zipcode": "29386",
            "city": "Hankensbüttel",
            "state": "Niedersachsen"
        },
        {
            "ID": "2105-000",
            "name": "Johannshof",
            "street": "Zur Glessener Höhe",
            "house_number": "45",
            "zipcode": "50129",
            "city": "Bergheim",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2106-000",
            "name": "Privathof Verhülsdonk",
            "street": "Heideweg",
            "house_number": "3a",
            "zipcode": "46519",
            "city": "Alpen",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2107-000",
            "name": "Privathof Köß",
            "street": "Sarusch",
            "house_number": "1",
            "zipcode": "28857",
            "city": "Syke",
            "state": "Niedersachsen"
        },
        {
            "ID": "2108-000",
            "name": "In den Meyerhöfen - Islandpferde",
            "street": "In den Meyerhöfen",
            "house_number": "31",
            "zipcode": "31535",
            "city": "Neustadt am Rübenberge",
            "state": "Niedersachsen"
        },
        {
            "ID": "2109-000",
            "name": "Quitthoevelshof Tennagels",
            "street": "Am Mühlenwasser",
            "house_number": "56",
            "zipcode": "47625",
            "city": "Kevelaer",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2110-000",
            "name": "Hof Heinz Flothmann",
            "street": "Kirchbauerschaft",
            "house_number": "35",
            "zipcode": "48356",
            "city": "Nordwalde",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2111-000",
            "name": "Hof Sonja Mootz",
            "street": "Oermter Kirchweg",
            "house_number": "47",
            "zipcode": "47661",
            "city": "Issum",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2112-000",
            "name": "Privathof Flommersfeld",
            "street": "Nordlünerner Straße",
            "house_number": "78",
            "zipcode": "59427",
            "city": "Unna",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2113-000",
            "name": "Privathof Steincke",
            "street": "Stieneichhofen",
            "house_number": "2",
            "zipcode": "58553",
            "city": "Halver",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2114-000",
            "name": "Friesenhof",
            "street": "Lehmberg",
            "house_number": "7",
            "zipcode": "23795",
            "city": "Negernbötel",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2115-000",
            "name": "Reithof Lökes",
            "street": "Brünener Straße",
            "house_number": "2",
            "zipcode": "46414",
            "city": "Rhede",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2116-000",
            "name": "Privathof Ellekotten",
            "street": "Up de Wälle",
            "house_number": "4",
            "zipcode": "46244",
            "city": "Bottrop",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2117-000",
            "name": "Böhnen Hoff Landwirtschaft",
            "street": "Petershägerweg",
            "house_number": "220",
            "zipcode": "32425",
            "city": "Minden",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2118-000",
            "name": "Stall Wüller",
            "street": "Mahlenburger Weg",
            "house_number": "12",
            "zipcode": "45711",
            "city": "Datteln",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2119-000",
            "name": "Westernreitstall Erlenbusch",
            "street": "Erlenbusch",
            "house_number": "1",
            "zipcode": "51515",
            "city": "Kürten",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2120-000",
            "name": "Hof Blomberg",
            "street": "Nordwalder Straße",
            "house_number": "180",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2121-000",
            "name": "Hof Jankord",
            "street": "Am Gievenbach ",
            "house_number": "60",
            "zipcode": "48161",
            "city": "Münster",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2122-000",
            "name": "Privathof Schmid",
            "street": "Eichtelger Weg",
            "house_number": "29",
            "zipcode": "32657",
            "city": "Lemgo",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2123-000",
            "name": "Ponyhof Hausberg",
            "street": "Krusinge",
            "house_number": "28",
            "zipcode": "31606",
            "city": "Warmsen",
            "state": "Niedersachsen"
        },
        {
            "ID": "2124-000",
            "name": "Privathof Heuser",
            "street": "Hansellerstraße ",
            "house_number": "55",
            "zipcode": "48268",
            "city": "Greven",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2125-000",
            "name": "Singerhof",
            "street": "Singerhof",
            "house_number": "67",
            "zipcode": "58256",
            "city": "Ennepetal",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2126-000",
            "name": "Tierphysiotherapie Anke Hayk",
            "street": "Fresenhorst",
            "house_number": "3",
            "zipcode": "46354",
            "city": "Südlohn",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2127-000",
            "name": "Pferdepension Lübbert ",
            "street": "Im Mackenbruch",
            "house_number": "10",
            "zipcode": "33813",
            "city": "Oerlinghausen ",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2128-000",
            "name": "Privathof Kröger",
            "street": "Wiesenweg",
            "house_number": "10",
            "zipcode": "21266",
            "city": "Jesteburg",
            "state": "Niedersachsen"
        },
        {
            "ID": "2129-000",
            "name": "Tierarztpraxis Clemens Heider",
            "street": "Ahlen ",
            "house_number": "15",
            "zipcode": "51515",
            "city": "Kürten",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2130-000",
            "name": "Hof Radza",
            "street": "Dorfstraße",
            "house_number": "6",
            "zipcode": "23816",
            "city": "Neversdorf",
            "state": "Schleswig-Holstein"
        },
        {
            "ID": "2131-000",
            "name": "Kranzhof",
            "street": "Allermarsch",
            "house_number": "7",
            "zipcode": "27336",
            "city": "Rethem",
            "state": "Niedersachsen"
        },
        {
            "ID": "2132-000",
            "name": "Krawinkel",
            "street": "Währentruper Straße ",
            "house_number": "88",
            "zipcode": "32791",
            "city": "Lage",
            "state": "Nordrhein-Westfalen"
        },
        {
            "ID": "2610-000",
            "name": "Hof Wiese",
            "street": "Dörrieloh",
            "house_number": "7",
            "zipcode": "27259",
            "city": "Varel",
            "state": "Niedersachsen"
        },
        {
            "ID": "2601-000",
            "name": "Pferdestall Westerburg",
            "street": "Am Schmeel",
            "house_number": "32a",
            "zipcode": "26203",
            "city": "Wardenburg",
            "state": "Niedersachsen"
        }
    
    ];

